webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _app = __webpack_require__(416);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _shared = __webpack_require__(440);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _pages = __webpack_require__(1153);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _api = __webpack_require__(1647);
	
	var _api2 = _interopRequireDefault(_api);
	
	__webpack_require__(1667);
	
	__webpack_require__(1668);
	
	__webpack_require__(1669);
	
	__webpack_require__(1670);
	
	var _localeEn = __webpack_require__(1671);
	
	var _localeDe = __webpack_require__(1672);
	
	var _localeFr = __webpack_require__(1674);
	
	var _localeEs = __webpack_require__(1675);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularjs2.default, _shared2.default, _pages2.default, _api2.default, 'pascalprecht.translate']).config(["$urlRouterProvider", "$locationProvider", "$translateProvider", "$windowProvider", function ($urlRouterProvider, $locationProvider, $translateProvider, $windowProvider) {
	  'ngInject';
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $urlRouterProvider.rule(function ($injector, $location) {
	    if ($location.path().match(/^\/(settings|transactions|profile|support|activation|dashboard|forgot-password|reset)/i)) {
	      return 'redirect-to-mobile' + $location.path();
	    } else if ($location.path() === '' || $location.path() === '/') {
	      return 'redirect-to-mobile/';
	    }
	  });
	
	  $urlRouterProvider.otherwise(function ($injector, $location) {
	    var path = $location.path();
	    var matches = path.match(/^\/(redirect-to-mobile)(.*)/i);
	    if (matches) {
	      $windowProvider.$get().location = _environment2.default.MOBILE_SITE_REDIRECT_URL + matches[2];
	    } else {
	      $location.replace('sign-in');
	    }
	  });
	  $locationProvider.html5Mode(true).hashPrefix('!');
	
	  $translateProvider.translations('en', (0, _localeEn.en)()).translations('de', (0, _localeDe.de)()).translations('fr', (0, _localeFr.fr)()).translations('es', (0, _localeEs.es)()).useSanitizeValueStrategy('sanitizeParameters').preferredLanguage('en').fallbackLanguage('en').useLocalStorage();
	}]).component('app', _app2.default);

/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(417);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _appController = __webpack_require__(418);
	
	var _appController2 = _interopRequireDefault(_appController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  controller: _appController2.default
	};
	
	exports.default = appComponent;

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div id=\"wrapper\">\n  <div ui-view></div>\n  <settings-modal></settings-modal>\n</div>\n"

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppController = function () {
	  AppController.$inject = ["SecurityService"];
	  function AppController(SecurityService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AppController);
	    this.SecurityService = SecurityService;
	  }
	
	  (0, _createClass3.default)(AppController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.SecurityService.initialize();
	    }
	  }]);
	  return AppController;
	}();
	
	exports.default = AppController;

/***/ }),
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _angularCookies = __webpack_require__(441);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _ui = __webpack_require__(443);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	var _security = __webpack_require__(991);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _eventdispatcher = __webpack_require__(1034);
	
	var _eventdispatcher2 = _interopRequireDefault(_eventdispatcher);
	
	var _app = __webpack_require__(1042);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _http = __webpack_require__(1043);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _storage = __webpack_require__(1033);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _chat = __webpack_require__(1048);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	var _http3 = __webpack_require__(1049);
	
	var _http4 = _interopRequireDefault(_http3);
	
	var _standardlayout = __webpack_require__(1082);
	
	var _standardlayout2 = _interopRequireDefault(_standardlayout);
	
	var _forbidden = __webpack_require__(1085);
	
	var _forbidden2 = _interopRequireDefault(_forbidden);
	
	var _customerProductsList = __webpack_require__(1088);
	
	var _customerProductsList2 = _interopRequireDefault(_customerProductsList);
	
	var _customerProductWidget = __webpack_require__(1091);
	
	var _customerProductWidget2 = _interopRequireDefault(_customerProductWidget);
	
	var _requestProductModal = __webpack_require__(1097);
	
	var _requestProductModal2 = _interopRequireDefault(_requestProductModal);
	
	var _successModal = __webpack_require__(1125);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _settingsModal = __webpack_require__(1128);
	
	var _settingsModal2 = _interopRequireDefault(_settingsModal);
	
	var _linkBankWidget = __webpack_require__(1134);
	
	var _linkBankWidget2 = _interopRequireDefault(_linkBankWidget);
	
	var _productPasswordWidget = __webpack_require__(1140);
	
	var _productPasswordWidget2 = _interopRequireDefault(_productPasswordWidget);
	
	var _accountReminderWidget = __webpack_require__(1145);
	
	var _accountReminderWidget2 = _interopRequireDefault(_accountReminderWidget);
	
	var _inputLimitDirective = __webpack_require__(1148);
	
	var _inputLimitDirective2 = _interopRequireDefault(_inputLimitDirective);
	
	var _loadingDirective = __webpack_require__(1149);
	
	var _loadingDirective2 = _interopRequireDefault(_loadingDirective);
	
	var _fileModelDirective = __webpack_require__(1150);
	
	var _fileModelDirective2 = _interopRequireDefault(_fileModelDirective);
	
	var _async = __webpack_require__(1151);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _filesize = __webpack_require__(1152);
	
	var _filesize2 = _interopRequireDefault(_filesize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedModule = _angular2.default.module('app.shared', [_angularCookies2.default, _ui2.default, _security2.default]).service('EventDispatcherService', _eventdispatcher2.default).service('AppService', _app2.default).service('HttpService', _http2.default).service('StorageService', _storage2.default).service('ChatService', _chat2.default).component('customerProductsList', _customerProductsList2.default).component('customerProductWidget', _customerProductWidget2.default).component('accountReminderWidget', _accountReminderWidget2.default).component('linkBankWidget', _linkBankWidget2.default).component('productPasswordWidget', _productPasswordWidget2.default).component('requestProductModal', _requestProductModal2.default).component('requestProductSuccessModal', _successModal2.default).component('settingsModal', _settingsModal2.default).component('standardLayout', _standardlayout2.default).component('forbiddenPage', _forbidden2.default).directive('limit', _inputLimitDirective2.default).directive('loading', _loadingDirective2.default).directive('fileModel', _fileModelDirective2.default).filter('async', _async2.default).filter('filesize', _filesize2.default).config(["$httpProvider", "$stateProvider", function ($httpProvider, $stateProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push(_http4.default);
	
	  $stateProvider.state('standardLayout', {
	    component: 'standardLayout'
	  }).state('forbidden', {
	    url: '/forbidden',
	    component: 'forbiddenPage'
	  });
	}]).name;
	
	exports.default = sharedModule;

/***/ }),
/* 441 */,
/* 442 */,
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _topbar = __webpack_require__(444);
	
	var _topbar2 = _interopRequireDefault(_topbar);
	
	var _navbar = __webpack_require__(501);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _datepicker = __webpack_require__(505);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _select = __webpack_require__(508);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _laddaButton = __webpack_require__(511);
	
	var _laddaButton2 = _interopRequireDefault(_laddaButton);
	
	var _pagination = __webpack_require__(514);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _pagination3 = __webpack_require__(517);
	
	var _pagination4 = _interopRequireDefault(_pagination3);
	
	var _tooltip = __webpack_require__(520);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _modal = __webpack_require__(523);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _switchery = __webpack_require__(526);
	
	var _switchery2 = _interopRequireDefault(_switchery);
	
	var _navbar3 = __webpack_require__(529);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	var _page = __webpack_require__(531);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _form = __webpack_require__(986);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _modal3 = __webpack_require__(987);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	var _appFooter = __webpack_require__(988);
	
	var _appFooter2 = _interopRequireDefault(_appFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiModule = _angular2.default.module('app.ui', []).component('topbar', _topbar2.default).component('navbar', _navbar2.default).component('datePicker', _datepicker2.default).component('select2', _select2.default).component('laddaButton', _laddaButton2.default).component('pagination', _pagination2.default).component('pagination2', _pagination4.default).component('appFooter', _appFooter2.default).component('tooltip', _tooltip2.default).component('modal', _modal2.default).component('switchery', _switchery2.default).service('NavbarService', _navbar4.default).service('PageService', _page2.default).service('FormService', _form2.default).service('ModalService', _modal4.default).name;
	
	exports.default = uiModule;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _topbar = __webpack_require__(445);
	
	var _topbar2 = _interopRequireDefault(_topbar);
	
	var _topbar3 = __webpack_require__(446);
	
	var _topbar4 = _interopRequireDefault(_topbar3);
	
	var _topbar5 = __webpack_require__(497);
	
	var _topbar6 = _interopRequireDefault(_topbar5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var topbarComponent = {
	  bindings: {},
	  template: _topbar2.default,
	  controller: _topbar4.default,
	  css: _topbar6.default
	};
	
	exports.default = topbarComponent;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"topbar\">\n    <div class=\"topbar-left\">\n        <div class=\"text-center\">\n            <!-- Image Logo here -->\n            <a href=\"#\" class=\"logo\">\n                <i class=\"icon-c-logo\"> <img src=\"assets/images/ac_img/ac-white.png\" height=\"25\"/> </i>\n                <span><img src=\"assets/images/ac_img/asianconnect88-white.png\" height=\"20\"/></span>\n            </a>\n        </div>\n    </div>\n    <div class=\"navbar navbar-default top-header\" role=\"navigation\">\n        <div class=\"container\">\n            <div class=\"\">\n                <div class=\"pull-left\">\n                    <a class=\"button-menu-mobile open-left waves-effect waves-light\" id= \"slide_menu\">\n                        <i class=\"md md-menu\"></i>\n                    </a>\n                    <span class=\"clearfix\"></span>\n                </div>\n                <ul class=\"nav navbar-nav navbar-right pull-right\">\n                    <li ng-click=\"$ctrl.readNotifications()\" class=\"dropdown top-menu-item-xs\">\n                        <a href=\"#\" data-target=\"#\" class=\"dropdown-toggle waves-effect waves-light\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n                            <i class=\"fas fa-bell\"></i> <span ng-if=\"$ctrl.model.notifications && $ctrl.model.notificationsCount > 0\" class=\"badge badge-xs badge-danger\">{{ $ctrl.model.notificationsCount }}</span>\n                        </a>\n                        <ul class=\"dropdown-menu dropdown-menu-lg\" style=\"width: 502px; overflow-x: auto; height: 330px !important;\">\n                            <li class=\"notif-title\"><span ng-if=\"$ctrl.model.notifications\" class=\"label label-default pull-right\"></span></li>\n                            <li ng-repeat=\"notification in $ctrl.model.notifications\"  class=\"list-group slimscroll-noti notification-list\">\n                               <a href=\"javascript:void(0);\" class=\"list-group-item\">\n                                  <div class=\"media\">\n                                     <div class=\"media-body\" style=\"margin-left: 0px;\">\n                                        <p>{{ notification.message }}</p>\n                                        <p class=\"m-0\">\n                                            <small>{{ notification.dateTime | date : 'medium' }}</small>\n                                        </p>\n                                     </div>\n                                  </div>\n                               </a>\n                            </li>\n                            <li class=\"list-group slimscroll-noti notification-list\">\n                              <a ui-sref=\"overview\" class=\"list-group-item text-right\">\n                                  <small class=\"font-600\">{{ 'Go To Transaction Overview' | translate }}</small>\n                              </a>\n                          </li>\n                        </ul>\n                    </li>\n                    <!-- Select Language -->\n                    <li class=\"dropdown top-menu-item-xs translation\">\n                        <a href=\"#\" class=\"dropdown-toggle waves-effect waves-light trans hidden-xs\" data-toggle=\"dropdown\" role=\"button\"><img ng-src=\"assets/images/ac_img/flag-{{ $ctrl.model.selectedLanguage.key }}.svg\" height=\"25\"/> {{ $ctrl.model.selectedLanguage.language | translate }} <i class=\"fas fa-angle-down pull-right\"></i></a>\n                        <ul class=\"dropdown-menu trans-list\">\n                            <li class=\"font-md\" ng-click=\"$ctrl.changeLanguage('en')\"><a href=\"#\"><img src=\"assets/images/ac_img/flag-en.svg\" class=\"m-r-5\" height=\"25\"/> {{ 'English' | translate }}</a></li>\n                            <li class=\"font-md\" ng-click=\"$ctrl.changeLanguage('fr')\"><a href=\"#\"><img src=\"assets/images/ac_img/flag-fr.svg\" class=\"m-r-5\" height=\"25\"/> {{ 'French' | translate }}</a></li>\n                            <li class=\"font-md\" ng-click=\"$ctrl.changeLanguage('de')\"><a href=\"#\"><img src=\"assets/images/ac_img/flag-de.svg\" class=\"m-r-5\" height=\"25\"/> {{ 'German' | translate }}</a></li>\n                            <li class=\"font-md\" ng-click=\"$ctrl.changeLanguage('es')\"><a href=\"#\"><img src=\"assets/images/ac_img/flag-es.svg\" class=\"m-r-5\" height=\"25\"/> {{ 'Spanish' | translate }}</a></li>\n                        </ul>\n                    </li>\n                    <!-- End Select Language -->\n                    <li class=\"dropdown top-menu-item-xs profile-menu\">\n                        <a href=\"\" class=\"dropdown-toggle profile waves-effect waves-light hidden-xs\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n                            <img ng-if=\"$ctrl.model.selectedAvatar && $ctrl.model.selectedAvatar != 'custom'\" ng-src=\"/assets/images/users/{{ $ctrl.model.selectedAvatar }}.svg\" alt=\"user\" class=\"rounded-circle\">\n                            <img ng-if=\"($ctrl.model.selectedAvatar == 'custom' && !$ctrl.image) || !$ctrl.model.selectedAvatar\" src=\"/assets/images/users/avatar-default.svg\" alt=\"user\" class=\"rounded-circle\">\n                            <img ng-if=\"$ctrl.model.selectedAvatar == 'custom' && $ctrl.image\" ng-src=\"{{ $ctrl.image }}\" alt=\"user\" class=\"rounded-circle\">\n                        </a>\n                        <ul class=\"dropdown-menu ac-logout\">\n                            <span class=\"arrow\"></span>\n                            <li>\n                                <div class=\"user-footer\">\n                                    <div class=\"bold\">{{ $ctrl.model.customerName }}</div>\n                                      <div class=\"italic\">Member since {{ $ctrl.model.customerSince | date : 'MMM d, yyyy' }}</div>\n                                </div>\n                            </li>\n                            <li>\n                                <a ui-sref=\"profile\" class=\"dropdown-item notify-item\">\n                                    <i class=\"fas fa-user\"></i> <span>Profile</span>\n                                </a>\n                            </li>\n                            <li>\n                                <a ui-sref=\"settings\" class=\"dropdown-item notify-item\">\n                                    <i class=\"fas fa-cog\"></i> <span>{{ 'titles.settings' | translate }}</span>\n                                </a>\n                            </li>\n                            <li>\n                                <a ui-sref=\"log-out\" class=\"dropdown-item notify-item\">\n                                    <i class=\"fas fa-lock\"></i> <span>{{ 'signOut' | translate }}</span>\n                                </a>\n                            </li>\n                        </ul>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(447);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(488);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _topbar = __webpack_require__(493);
	
	var _topbar2 = _interopRequireDefault(_topbar);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _locales = __webpack_require__(495);
	
	var _notificationModel = __webpack_require__(496);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopbarController = function () {
	  TopbarController.$inject = ["HttpService", "SessionService", "PageService", "CustomerApiService", "StorageService", "EventDispatcherService", "$translate", "$rootScope", "$sce"];
	  function TopbarController(HttpService, SessionService, PageService, CustomerApiService, StorageService, EventDispatcherService, $translate, $rootScope, $sce) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TopbarController);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	    this.StorageService = StorageService;
	    this.PageService = PageService;
	    this.CustomerApiService = CustomerApiService;
	    this.EventDispatcherService = EventDispatcherService;
	    this.$translate = $translate;
	    this.$rootScope = $rootScope;
	    this.$sce = $sce;
	    this.image = null;
	  }
	
	  (0, _createClass3.default)(TopbarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.model = new _topbar2.default();
	      this.session = this.SessionService.getSession();
	      this.subscription = this.SessionService.session.subscribe(function (sessionDetails) {
	        if (sessionDetails) {
	          _this.model.customerName = sessionDetails.customerName;
	          _this.model.customerSince = sessionDetails.customerSince;
	          _this.model.selectedAvatar = sessionDetails.selectedAvatar;
	          _this.model.uploadedAvatar = sessionDetails.uploadedAvatar;
	
	          _this.loadAvatar();
	        }
	      });
	
	      var locale = this.StorageService.getItem('locale');
	      this.model.selectedLanguage.key = locale;
	      this.model.selectedLanguage.language = _locales.LANGUAGES[locale];
	
	      this.loadNotifications();
	
	      // Add Listener for Web Socket Event
	      this.eventSubscription = this.EventDispatcherService.addListener(_events2.default.TRANSACTION_PROCESSED, function (event) {
	        return _this.loadNotifications();
	      });
	      this.eventSubscription = this.EventDispatcherService.addListener(_events2.default.GAUTH_RESET, function (event) {
	        return _this.loadNotifications();
	      });
	
	      this.$rootScope.$on('$translateChangeSuccess', function () {
	        _this.loadNotifications();
	      });
	
	      this.EventDispatcherService.addListener(_events2.default.AVATAR_UPDATED, function (event) {
	        _this.model.selectedAvatar = event.payload.selected;
	        _this.model.uploadedAvatar = event.payload.uploaded;
	
	        _this.loadAvatar();
	      });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscription.unsubscribe();
	      this.eventSubscription.remove();
	    }
	  }, {
	    key: 'loadNotifications',
	    value: function loadNotifications() {
	      var _this2 = this;
	
	      this.CustomerApiService.getNotifications().then(function (response) {
	        var notifications = (0, _notificationModel.makeNotifications)(response);
	
	        (0, _entries2.default)(notifications).forEach(function (_ref) {
	          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	              key = _ref2[0],
	              value = _ref2[1];
	
	          value.message = value.message.replace('New referral', _this2.$translate.instant('New referral')).replace('has been linked.', _this2.$translate.instant('has been linked.')).replace('Referral', _this2.$translate.instant('Referral')).replace('has been unlinked.', _this2.$translate.instant('has been unlinked.')).replace('Product/s', _this2.$translate.instant('Product/s')).replace('has been added.', _this2.$translate.instant('has been added.')).replace('Transaction', _this2.$translate.instant('Transaction')).replace('has been', _this2.$translate.instant('has been')).replace('Deposit', _this2.$translate.instant('Deposit')).replace('Withdraw', _this2.$translate.instant('Withdraw')).replace('Transfer', _this2.$translate.instant('Transfer')).replace('P2P Transfer', _this2.$translate.instant('P2P Transfer')).replace('Approved', _this2.$translate.instant('Approved')).replace('Acknowledged', _this2.$translate.instant('Acknowledged')).replace('Saved', _this2.$translate.instant('Saved'));
	        });
	
	        _this2.model.notifications = notifications;
	      });
	    }
	  }, {
	    key: 'readNotifications',
	    value: function readNotifications() {
	      var _this3 = this;
	
	      this.CustomerApiService.readNotifications().then(function () {
	        _this3.model.markNotificationsAsRead();
	      });
	    }
	  }, {
	    key: 'showSettingsModal',
	    value: function showSettingsModal() {
	      this.PageService.showModal('settingsModal');
	    }
	  }, {
	    key: 'changeLanguage',
	    value: function changeLanguage(languageKey) {
	      var _this4 = this;
	
	      this.$translate.use(languageKey);
	      this.model.selectedLanguage.key = languageKey;
	      this.model.selectedLanguage.language = _locales.LANGUAGES[languageKey];
	
	      this.CustomerApiService.updateLanguage(languageKey).then(function (response) {
	        _this4.StorageService.setItem('locale', response.member.locale);
	      });
	    }
	  }, {
	    key: 'loadAvatar',
	    value: function loadAvatar() {
	      var _this5 = this;
	
	      if (this.model.uploadedAvatar) {
	        this.CustomerApiService.getAvatar(this.model.uploadedAvatar).then(function (fileUri) {
	          _this5.HttpService.$http.get(fileUri, { responseType: 'arraybuffer' }).then(function (s3data) {
	            var fileObj = new Blob([s3data], { type: 'application/binary' });
	            _this5.image = _this5.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
	          });
	        });
	      }
	    }
	  }]);
	  return TopbarController;
	}();
	
	exports.default = TopbarController;

/***/ }),
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopbarModel = function () {
	  function TopbarModel() {
	    (0, _classCallCheck3.default)(this, TopbarModel);
	
	    this.customerName = '';
	    this.customerSince = '';
	    this.selectedLanguage = {
	      'key': '',
	      'language': ''
	    };
	    this.notifications = [];
	  }
	
	  (0, _createClass3.default)(TopbarModel, [{
	    key: 'markNotificationsAsRead',
	    value: function markNotificationsAsRead() {
	      angular.forEach(this.notifications, function (value, key) {
	        value.isRead = true;
	      });
	    }
	  }, {
	    key: 'notificationsCount',
	    get: function get() {
	      var count = 0;
	
	      angular.forEach(this.notifications, function (value, key) {
	        if (!value.isRead) {
	          count++;
	        }
	      });
	
	      return count;
	    }
	  }]);
	  return TopbarModel;
	}();
	
	exports.default = TopbarModel;

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * These Events are supposed to be dispatched within the system
	 * and should be listened by different parts of the app.
	 */
	var EVENTS = exports.EVENTS = {
	    UNAUTHORIZED_ACCESS: 'unauthorized_access',
	    TRANSACTION_PROCESSED: 'transaction_processed',
	    TRANSACTION_DECLINED: 'transaction_declined',
	    BET_PROCESSED: 'bet_processed',
	    BTC_EXCHANGE_RATE: 'btc.exchange_rate',
	    PRODUCT_REQUESTED: 'product_requested',
	    BITCOIN_RATE_TRANSACTION_EXPIRED: 'bitcoin_rate_transaction_expired',
	    KYC_FILE_UPLOADED: 'kyc_file_uploaded',
	    KYC_FILE_DELETED: 'kyc_file_deleted',
	    LANGUAGE_UPDATED: 'language_updated',
	    AVATAR_UPDATED: 'avatar_updated',
	    GAUTH_RESET: 'gauth_reset'
	};
	
	exports.default = EVENTS;

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var LANGUAGES = exports.LANGUAGES = {
		'fr': 'French',
		'en': 'English',
		'de': 'German',
		'es': 'Spanish'
	};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.makeNotifications = makeNotifications;
	exports.makeNotification = makeNotification;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeNotifications(payload) {
		return payload.map(function (notification) {
			return makeNotification(notification);
		});
	}
	
	function makeNotification(payload) {
		return new Notification(payload.read, payload.message, payload.dateTime);
	}
	
	var Notification = function Notification(isRead, message, dateTime) {
		(0, _classCallCheck3.default)(this, Notification);
	
		this.isRead = isRead;
		this.message = message;
		this.dateTime = dateTime;
	};
	
	exports.default = Notification;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(498);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(500)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./topbar.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./topbar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(499)();
	// imports
	
	
	// module
	exports.push([module.id, ".rounded-circle{border-radius:50%}.translation .dropdown-toggle{margin-top:2px}.profile-menu>a{line-height:0!important;padding:0!important;margin:13px;border-radius:50%}.profile-menu.open .profile{border-color:#fff!important}", ""]);
	
	// exports


/***/ }),
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(502);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(503);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	  bindings: {},
	  template: _navbar2.default,
	  controller: _navbar4.default
	};
	
	exports.default = navbarComponent;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"left side-menu\">\n    <div class=\"sidebar-inner slimscrollleft-custom\">\n        <div id=\"sidebar-menu\">\n            <ul class=\"nav-list\">\n              <li class=\"has_sub hidden-sm hidden-md hidden-lg\">\n                <div class=\"user-join-date-xs\">\n                 <h4>{{ $ctrl.model.customerName }}</h4>\n                  <span><small><i>{{ 'memberSince' | translate }} {{ $ctrl.model.customerSince | date: 'MMM d, yyyy' }}</i></small></span>\n                </div>\n              </li>\n              <li class=\"custom-divider-xs hidden-md hidden-lg\"></li>\n              <li>\n                  <a class=\"waves-effect\"  ui-sref=\"dashboard\" data-nav=\"dashboard\"><i class=\"fas fa-tachometer-alt\"></i> <span> {{ 'titles.dashboard' | translate }} </span></a>\n                </li>\n              <li>\n                  <a class=\"waves-effect\" ui-sref=\"profile\"><i class=\"fa fa-user\"></i> <span> {{ 'titles.profile' | translate }} </span> </a>\n              </li>\n              <li class=\"has_sub\">\n                <a class=\"waves-effect menu-parent\"><i class=\"fa fa-credit-card\"></i><span>{{ 'titles.transaction' | translate }}</span> <span class=\"menu-arrow\"></span> </a>\n                <ul class=\"list-unstyled transact-sub\">\n                  <li><a ui-sref=\"overview\"><i class=\"fas fa-dot-circle\"></i>{{ 'titles.overview' | translate }}</a></li>\n                  <li><a ui-sref=\"deposit\"><i class=\"fas fa-dot-circle\"></i>{{ 'titles.deposit' | translate }}</a></li>\n                  <li><a ui-sref=\"withdrawal\"><i class=\"fas fa-dot-circle\"></i>{{ 'titles.withdrawal' | translate }}</a></li>\n                  <li><a ui-sref=\"productwallet\"><i class=\"fas fa-dot-circle\"></i>{{ 'titles.productWallet' | translate }}</a></li>\n                  <li><a ui-sref=\"peertopeer\"><i class=\"fas fa-dot-circle\"></i>{{ 'titles.p2pTransfer' | translate }}</a></li>\n                </ul>\n              </li>\n              <li ng-show=\"$ctrl.hasBrokerage\" class=\"has_sub brokerage-nav\">\n                  <a class=\"waves-effect menu-parent\"><i class=\"fa fa-money\"></i><span> {{ 'titles.skypeBetting' | translate }} </span> <span class=\"menu-arrow\"></span> </a>\n                  <ul class=\"list-unstyled transact-sub\">\n                      <li><a ui-sref=\"outstandingbet\"><i class=\"fas fa-dot-circle\"></i> {{ 'titles.outstandingBets' | translate }}</a></li>\n                      <li><a ui-sref=\"bethistory\"><i class=\"fas fa-dot-circle\"></i> {{ 'titles.betHistory' | translate }}</a></li>\n                      <li><a ui-sref=\"betoverview\"><i class=\"fas fa-dot-circle\"></i> {{ 'titles.betOverview' | translate }}</a></li>\n                  </ul>\n              </li>\n              <li ng-show=\"$ctrl.isAffiliate\" class=\"has_sub affiliate-nav active\">\n                  <a class=\"waves-effect menu-parent\"><i class=\"fa fa-group\"></i> <img src=\"assets/images/ac-logo.png\"><span> {{ 'titles.affiliate' | translate }} <sup class=\"text-red\">{{ 'BETA' | translate }}</sup></span> <span class=\"menu-arrow\"></span> </a>\n                  <ul class=\"list-unstyled transact-sub\">\n                      <li><a ui-sref=\"acrewards\"><i class=\"fas fa-dot-circle\"></i> {{ 'titles.affiliateDashboard' | translate }}</a></li>\n                      <li><a ui-sref=\"marketing\"><i class=\"fas fa-dot-circle\"></i> {{ 'titles.affiliateTools' | translate }}</a></li>\n                  </ul>\n              </li>\n              <li class=\"has_sub\">\n                <a class=\"waves-effect menu-parent\"><i class=\"fas fa-comments\"></i><span>Support</span> <span class=\"menu-arrow\"></span> </a>\n                <ul class=\"list-unstyled transact-sub\">\n                  <li><a ui-sref=\"zendesk\" id=\"tickets\"><i class=\"fas fa-dot-circle\"></i>{{ 'My Tickets' | translate }}</a></li>\n                  <li><a ui-sref=\"requests\"><i class=\"fas fa-dot-circle\"></i>My Requests</a></li>\n                </ul>\n              </li>\n              <li class=\"hidden-sm hidden-md hidden-lg\">\n                <div class=\"col-md-12 mtop2\">\n                  <button type=\"button\" ui-sref=\"settings\"\" class=\"btn btn-block btn-inverse waves-effect waves-light\"><span class=\"\"><i class=\"fa fa-cog fa-fw\"></i> User Settings</span></button>\n                </div>\n              </li>\n              <li class=\"hidden-sm hidden-md hidden-lg\">\n                <div class=\"col-md-12 mtop2\">\n                  <a class=\"nosubdrop\" href=\"{{ $ctrl.mobileSiteRedirectUrl }}\"><button type=\"button\" class=\"btn btn-block btn-inverse waves-effect waves-light\"><span class=\"\"><i class=\"fa fa-mobile\"></i> {{ 'titles.mobileSite' | translate }}</span></button></a>\n                </div>\n              </li>\n              <li class=\"hidden-sm hidden-md hidden-lg\">\n                <div class=\"col-md-12 mtop2\">\n                  <button ui-sref=\"log-out\" type=\"button\" class=\"btn btn-block btn-inverse waves-effect waves-light\"><span class=\"\"><i class=\"fa fa-sign-out\"></i> {{ 'signOut' | translate }}</span></button>\n                </div>\n              </li>\n            </ul>\n            <div class=\"clearfix\"></div>\n        </div>\n        <div class=\"clearfix\"></div>\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n</div>\n"

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function () {
	  NavbarController.$inject = ["NavbarService", "SessionService", "PageService"];
	  function NavbarController(NavbarService, SessionService, PageService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NavbarController);
	    this.NavbarService = NavbarService;
	    this.SessionService = SessionService;
	    this.PageService = PageService;
	
	    this.mobileSiteRedirectUrl = _environment2.default.MOBILE_SITE_REDIRECT_URL;
	  }
	
	  (0, _createClass3.default)(NavbarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.NavbarService.initialize();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.NavbarService.destroy();
	    }
	  }, {
	    key: 'showSettingsModal',
	    value: function showSettingsModal() {
	      this.PageService.showModal('settingsModal');
	    }
	  }, {
	    key: 'model',
	    get: function get() {
	      return this.NavbarService.model;
	    }
	  }, {
	    key: 'hasBrokerage',
	    get: function get() {
	      return +this.model.brokerageSyncId !== 0;
	    }
	  }, {
	    key: 'isAffiliate',
	    get: function get() {
	      return this.model.tags.includes('AFF');
	    }
	  }]);
	  return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Modify this file according to your environment.
	 *
	 * For dev, create environment.dev.js
	 * for prod, create environment.prod.js
	 *
	 * Note: When creating new environmet variables
	 * always make sure to follow the ff: format:
	 * AC66_MY_ENVIRONMENT_VARIABLE_HERE
	 * Don't forget to include the new variable in
	 * deployer's script.
	 */
	
	var environment = {
	  API_URL: '$AC66_AMS_API_URL',
	  MOBILE_SITE_REDIRECT_URL: '$AC66_MOBILE_SITE_REDIRECT_URL',
	  WEBSOCKET_URL: '$AC66_WEBSOCKET_URL',
	  REALM: '$AC66_REALM',
	  ASIANCONNECT_URL: '$AC66_ASIANCONNECT_URL',
	  IDLE_TIMEOUT: '$AC66_IDLE_TIMEOUT',
	  ECOPAYZ_SUCCESS_URL: '$AC66_ECOPAYZ_SUCCESS_URL',
	  ECOPAYZ_FAILURE_URL: '$AC66_ECOPAYZ_FAILURE_URL',
	  ECOPAYZ_CANCELATION_URL: '$AC66_ECOPAYZ_CANCELATION_URL',
	  AES_ENCRYPTION_KEY: '$AC66_AES_ENCRYPTION_KEY',
	  FRESH_CHAT_TOKEN: '$AC66_FRESH_CHAT_TOKEN',
	  FRESH_CHAT_HOST: '$AC66_FRESH_CHAT_HOST',
	  ZENDESK_WIDGET_SCRIPT: '$AC66_ZENDESK_WIDGET_SCRIPT'
	};
	
	exports.default = environment;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datepicker = __webpack_require__(506);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _datepicker3 = __webpack_require__(507);
	
	var _datepicker4 = _interopRequireDefault(_datepicker3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var datePickerComponent = {
	  require: {
	    ngModel: '^ngModel'
	  },
	  bindings: {
	    autoclose: '<',
	    todayHighlight: '<',
	    dateFormat: '<'
	  },
	  template: _datepicker2.default,
	  controller: _datepicker4.default
	};
	
	exports.default = datePickerComponent;

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"input-group date\">\n    <div class=\"input-group-addon\">\n        <i class=\"fa fa-calendar\"></i>\n    </div>\n    <input type=\"text\" class=\"form-control pull-right filter-from-date datepicker_class\" placeholder=\"{{ $ctrl.placeholder }}\">\n</div>"

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerController = function () {
	  DatePickerController.$inject = ["$element"];
	  function DatePickerController($element) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DatePickerController);
	    this.$element = $element;
	  }
	
	  (0, _createClass3.default)(DatePickerController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.input = this.$element.find('input');
	      this.placeholder = this.$element.attr('placeholder') ? this.$element.attr('placeholder') : 'mm/dd/yyyy';
	
	      var options = {};
	      options['autoclose'] = this.autoclose ? true : false;
	      options['todayHighlight'] = this.todayHighlight ? true : false;
	      options['format'] = this.dateFormat ? this.dateFormat : 'mm/dd/yyyy';
	
	      this.input.datepicker(options);
	      this.input.attr('name', this.$element.attr('name'));
	      this.input.change(function (event) {
	        _this.onChange(_this.input.val());
	      });
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      this.input.val(this.ngModel.$viewValue);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(value) {
	      this.ngModel.$setViewValue(value);
	    }
	  }, {
	    key: 'onReset',
	    value: function onReset() {
	      $('.datepicker_class').val('').datepicker('update');
	    }
	  }]);
	  return DatePickerController;
	}();
	
	exports.default = DatePickerController;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _select = __webpack_require__(509);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _select3 = __webpack_require__(510);
	
	var _select4 = _interopRequireDefault(_select3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var select2Component = {
	  require: {
	    ngModel: '^ngModel'
	  },
	  bindings: {
	    options: '<'
	  },
	  template: _select2.default,
	  controller: _select4.default
	};
	
	exports.default = select2Component;

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = "<select></select>"

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO, add Select2 with Ajax functionality.
	var Select2Controller = function () {
	  Select2Controller.$inject = ["$element", "$attrs", "$translate"];
	  function Select2Controller($element, $attrs, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Select2Controller);
	    this.$element = $element;
	    this.$attrs = $attrs;
	    this.$translate = $translate;
	  }
	
	  (0, _createClass3.default)(Select2Controller, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!this.isAjax()) {
	        this.initializedSimple();
	      }
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (this.ngModel.$viewValue === null) {
	        this.select.val('').trigger('change');
	      }
	    }
	  }, {
	    key: 'initializedSimple',
	    value: function initializedSimple() {
	      if (this.isMultiple()) {
	        this.initiliazeMultipleSelect();
	      }
	    }
	  }, {
	    key: 'initiliazeMultipleSelect',
	    value: function initiliazeMultipleSelect() {
	      var _this = this;
	
	      if (this.options) {
	        this.select = this.$element.find('select');
	        this.select.attr('multiple', 'multiple');
	
	        this.appendOptions(this.select);
	
	        $(this.select).select2({
	          placeholder: this.$translate.instant(this.$attrs.placeholder)
	        });
	
	        //handle events
	        this.select.on('change', function () {
	          _this.ngModel.$setViewValue(_this.select.val());
	        });
	      }
	    }
	  }, {
	    key: 'appendOptions',
	    value: function appendOptions(select) {
	      var _this2 = this;
	
	      angular.forEach(this.options, function (option, index) {
	        var optionHTML = '<option value=' + option.value + '>' + _this2.$translate.instant(option.text) + '</option>';
	        select.append(optionHTML);
	      });
	    }
	
	    // Ajaxable, I can't help it :)
	
	  }, {
	    key: 'initializedAjaxable',
	    value: function initializedAjaxable() {}
	
	    // Returns true if the component has
	    // ajax attribute.
	
	  }, {
	    key: 'isAjax',
	    value: function isAjax() {
	      return this.$attrs.hasOwnProperty('ajax');
	    }
	
	    // Returns true if the component has
	    // multiple attribute.
	
	  }, {
	    key: 'isMultiple',
	    value: function isMultiple() {
	      return this.$attrs.hasOwnProperty('multiple');
	    }
	  }]);
	  return Select2Controller;
	}();
	
	exports.default = Select2Controller;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _laddaButton = __webpack_require__(512);
	
	var _laddaButton2 = _interopRequireDefault(_laddaButton);
	
	var _laddaButton3 = __webpack_require__(513);
	
	var _laddaButton4 = _interopRequireDefault(_laddaButton3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Add more classes and effects :3
	var laddaButtonComponent = {
	  bindings: {
	    text: '<',
	    laddaDisable: '<',
	    stopWhen: '<', // Event signaled from Parent Component when to stop loading
	    class: '<',
	    load: '<',
	    onClick: '&'
	  },
	  template: _laddaButton2.default,
	  controller: _laddaButton4.default
	};
	
	exports.default = laddaButtonComponent;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	module.exports = "<button ng-click=\"$ctrl.click()\" type=\"button\" class=\"btn btn-danger ladda-button ac-color\" data-style=\"expand-right\"></button>\n"

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LadaButton = function () {
	  LadaButton.$inject = ["$element", "FormService", "$translate", "$rootScope"];
	  function LadaButton($element, FormService, $translate, $rootScope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LadaButton);
	    this.$element = $element;
	    this.FormService = FormService;
	    this.$translate = $translate;
	    this.$rootScope = $rootScope;
	  }
	
	  (0, _createClass3.default)(LadaButton, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.button = this.$element.find('button')[0];
	      this.button.innerHTML = this.$translate.instant(this.text);
	      this.button.classList.add(this.class);
	      this.laddaInstance = Ladda.create(this.button);
	
	      this.subscription = this.FormService.isSubmitting.subscribe(function (isSubmitting) {
	        if (!isSubmitting) {
	          _this.stop();
	        }
	      });
	
	      this.$rootScope.$on('$translateChangeSuccess', function () {
	        _this.button.innerHTML = _this.$translate.instant(_this.text);
	      });
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges() {
	      if (this.load !== null && this.load === false) {
	        if (this.laddaInstance) {
	          this.stop();
	        }
	      }
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscription.unsubscribe();
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (this.laddaDisable) {
	        this.button.setAttribute('disabled', 'disabled');
	      } else {
	        this.button.removeAttribute('disabled');
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.laddaInstance.stop();
	    }
	  }, {
	    key: 'click',
	    value: function click() {
	      this.laddaInstance.start();
	      this.onClick();
	    }
	  }]);
	  return LadaButton;
	}();
	
	exports.default = LadaButton;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pagination = __webpack_require__(515);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _pagination3 = __webpack_require__(516);
	
	var _pagination4 = _interopRequireDefault(_pagination3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paginationComponent = {
	  bindings: {
	    subject: '<',
	    maxPageCount: '<',
	    onPageClicked: '&'
	  },
	  template: _pagination2.default,
	  controller: _pagination4.default
	};
	
	exports.default = paginationComponent;

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"pagination-b no-p no-m\">\n    <li ng-click=\"$ctrl.click(page)\" ng-repeat=\"page in $ctrl.pages\" ng-class=\"{'active': page.active}\">\n        <a href=\"#\" class=\"link\">{{ page.label }}</a>\n    </li>\n </ul>\n"

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaginationController = function () {
	  PaginationController.$inject = ["$element"];
	  function PaginationController($element) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PaginationController);
	    this.$element = $element;
	  }
	
	  (0, _createClass3.default)(PaginationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.pageCount = 0;
	      this.pages = [];
	
	      this.hasSubscribed = false;
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      // Subscriptions can leak memory, always clean it if not used anymore.
	      this.subscription.unsubscribe();
	    }
	
	    // Note that subscription will be done only once.
	
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      var _this = this;
	
	      if (this.maxPageCount && this.subject && !this.hasSubscribed) {
	        this.hasSubscribed = true;
	        this.subscription = this.subject.subscribe(function (pagination) {
	          if (pagination) {
	            // Note that the pagination object is required to have
	            // the following properties or the pagination wouldn't work.
	            _this.limit = pagination.limit;
	            _this.page = pagination.page;
	            _this.total = pagination.total;
	            _this.totalFiltered = pagination.totalFiltered;
	
	            _this.refresh();
	            _this.draw(_this.limit, _this.totalFiltered);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'draw',
	    value: function draw(limit, totalFiltered) {
	      this.pageCount = this.getPageCount(limit, totalFiltered);
	
	      if (this.pageCount <= 1) {
	        return;
	      }
	
	      this.last = this.pageCount;
	      this.current = this.page;
	
	      var upperLimit = void 0,
	          lowerLimit = void 0;
	      var currentPage = lowerLimit = upperLimit = Math.min(this.current, this.total);
	
	      for (var b = 1; b < this.maxPageCount; b++) {
	        if (lowerLimit > 1) {
	          lowerLimit--;
	        }
	        if (b < this.maxPageCount) {
	          if (upperLimit < this.last) {
	            upperLimit++;
	          }
	        }
	      }
	
	      for (var i = lowerLimit; i <= upperLimit; i++) {
	        var page = {
	          number: i,
	          label: i,
	          active: i === currentPage
	        };
	
	        this.pages.push(page);
	      }
	
	      if (this.hasPrevious()) {
	        var prevPage = {
	          number: this.current - 1,
	          label: '<'
	        };
	
	        this.pages.unshift(prevPage);
	      }
	
	      if (this.hasNext()) {
	        var _prevPage = {
	          number: this.current + 1,
	          label: '>'
	        };
	
	        this.pages.push(_prevPage);
	      }
	    }
	  }, {
	    key: 'hasPrevious',
	    value: function hasPrevious() {
	      return this.current > 1;
	    }
	  }, {
	    key: 'hasNext',
	    value: function hasNext() {
	      return this.current !== this.last;
	    }
	  }, {
	    key: 'getPageCount',
	    value: function getPageCount(limit, totalFiltered) {
	      return Math.ceil(totalFiltered / limit);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.pages.length = 0;
	    }
	  }, {
	    key: 'click',
	    value: function click(page) {
	      this.onPageClicked({ page: page });
	    }
	  }]);
	  return PaginationController;
	}();
	
	exports.default = PaginationController;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pagination = __webpack_require__(518);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _pagination3 = __webpack_require__(519);
	
	var _pagination4 = _interopRequireDefault(_pagination3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A new implementation for pagination without using RxJS
	 * and will be intended to be more generic.
	 */
	var pagination2Component = {
	  bindings: {
	    maxPageCount: '<',
	    limitPerPage: '<',
	    total: '<',
	    onPageClicked: '&'
	  },
	  template: _pagination2.default,
	  controller: _pagination4.default
	};
	
	exports.default = pagination2Component;

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"pagination-b\">\n    <li ng-click=\"$ctrl.click(page)\" ng-repeat=\"page in $ctrl.pages\" ng-class=\"{'active': page.active}\">\n        <a href=\"#\" class=\"link\">{{ page.label }}</a>\n    </li>\n</ul>\n"

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pagination2Controller = function () {
	  Pagination2Controller.$inject = ["$element", "$scope"];
	  function Pagination2Controller($element, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Pagination2Controller);
	    this.$element = $element;
	    this.$scope = $scope;
	  }
	
	  (0, _createClass3.default)(Pagination2Controller, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.pageCount = 0;
	      this.page = 1;
	      this.pages = [];
	      this.rendering = false;
	
	      this.$scope.$on('resetPages', function () {
	        _this.page = 1;
	        _this.render();
	      });
	
	      this.totalItems = null;
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (!angular.isUndefined(this.total)) {
	        if (this.shouldRender()) {
	          this.page = 1;
	          this.totalItems = this.total;
	          this.render();
	        }
	      }
	    }
	
	    // Render only if the total has been changed to avoid
	    // digest cycle bug.
	
	  }, {
	    key: 'shouldRender',
	    value: function shouldRender() {
	      return this.totalItems !== this.total;
	    }
	  }, {
	    key: 'getPageCount',
	    value: function getPageCount() {
	      return Math.ceil(this.totalItems / this.limitPerPage);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.refresh();
	      var pageCount = this.getPageCount();
	      if (pageCount <= 1) {
	        return;
	      }
	
	      var last = pageCount;
	
	      var upperLimit = void 0,
	          lowerLimit = void 0;
	      var currentPage = lowerLimit = upperLimit = Math.min(this.page, this.totalItems);
	
	      for (var b = 1; b < this.maxPageCount; b++) {
	        if (lowerLimit > 1) {
	          lowerLimit--;
	        }
	        if (b < this.maxPageCount) {
	          if (upperLimit < last) {
	            upperLimit++;
	          }
	        }
	      }
	
	      for (var i = lowerLimit; i <= upperLimit; i++) {
	        var page = {
	          number: i,
	          label: i,
	          active: i === currentPage
	        };
	
	        this.pages.push(page);
	      }
	
	      if (this.hasPrevious()) {
	        var prevPage = {
	          number: this.page - 1,
	          label: '<'
	        };
	
	        this.pages.unshift(prevPage);
	      }
	
	      if (this.hasNext(last)) {
	        var _prevPage = {
	          number: this.page + 1,
	          label: '>'
	        };
	
	        this.pages.push(_prevPage);
	      }
	    }
	  }, {
	    key: 'hasPrevious',
	    value: function hasPrevious() {
	      return this.page > 1;
	    }
	  }, {
	    key: 'hasNext',
	    value: function hasNext(lastPage) {
	      return this.page !== lastPage;
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.pages.length = 0;
	    }
	  }, {
	    key: 'click',
	    value: function click(page) {
	      this.page = +page.number;
	      this.render();
	
	      var offset = (this.page - 1) * this.limitPerPage;
	      this.onPageClicked({ page: this.page, offset: offset });
	    }
	  }]);
	  return Pagination2Controller;
	}();
	
	exports.default = Pagination2Controller;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tooltip = __webpack_require__(521);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _tooltip3 = __webpack_require__(522);
	
	var _tooltip4 = _interopRequireDefault(_tooltip3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toolTipComponent = {
	  bindings: {},
	  template: _tooltip2.default,
	  controller: _tooltip4.default
	};
	
	exports.default = toolTipComponent;

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	module.exports = "<a class=\"hidden-sm hidden-xs\" data-toggle=\"tooltip\" data-placement=\"right\"><i class=\"fa {{ $ctrl.icon }}\"></i></a>"

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToolTipController = function () {
	  ToolTipController.$inject = ["$element", "$timeout", "$compile"];
	  function ToolTipController($element, $timeout, $compile) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ToolTipController);
	    this.$element = $element;
	    this.$compile = $compile;
	    this.$timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(ToolTipController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.icon = this.$element.attr('set-icon');
	      if (typeof this.$element.attr('data-content') !== 'undefined') {
	        var $content = $('<div class="hidden">' + this.$element.data('content') + '</div>');
	        this.$element.after($content);
	
	        var scope = angular.element($content).scope();
	        var compiled = this.$compile($content)(scope);
	        this.$timeout(function () {
	          _this.$element.attr('data-original-title', compiled.get(0).innerHTML);
	        }, 500);
	      }
	
	      this.$element.tooltip();
	    }
	  }]);
	  return ToolTipController;
	}();
	
	exports.default = ToolTipController;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modal = __webpack_require__(524);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(525);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalComponent = {
	  bindings: {
	    modalTitle: '<',
	    modalContent: '<',
	    modalId: '<',
	    onOk: '&'
	  },
	  template: _modal2.default,
	  controller: _modal4.default
	
	};
	
	exports.default = modalComponent;

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"{{ $ctrl.modalId }}\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n  <div class=\"icon success animate\">\n      <span class=\"line tip animateSuccessTip\"></span>\n      <span class=\"line long animateSuccessLong\"></span>\n      <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n  </div>\n  <h3>{{ $ctrl.modalTitle }}</h3>\n  <p class=\"lead text-muted\">\n    {{ $ctrl.modalContent }}\n  </p>\n  <p>\n      <button type=\"button\" ng-click=\"$ctrl.onOkClicked()\" class=\"btn btn-success waves-effect waves-light\">{{ 'OK' | translate }}</button>\n  </p>\n</div>\n"

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalController = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalController = exports.ModalController = function () {
	  ModalController.$inject = ["$scope"];
	  function ModalController($scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalController);
	    this.$scope = $scope;
	  }
	
	  (0, _createClass3.default)(ModalController, [{
	    key: '$doCheck',
	    value: function $doCheck() {
	      this.modalTitle = this.$scope.modalTitle;
	      this.modalContent = this.$scope.modalContent;
	    }
	  }, {
	    key: 'onOkClicked',
	    value: function onOkClicked() {
	      this.onOk();
	    }
	  }]);
	  return ModalController;
	}();
	
	exports.default = ModalController;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _switchery = __webpack_require__(527);
	
	var _switchery2 = _interopRequireDefault(_switchery);
	
	var _switchery3 = __webpack_require__(528);
	
	var _switchery4 = _interopRequireDefault(_switchery3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var switcheryComponent = {
	  bindings: {
	    onSwitch: '&',
	    checked: '<'
	  },
	  template: _switchery2.default,
	  controller: _switchery4.default
	};
	
	exports.default = switcheryComponent;

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	module.exports = "<label class=\"ui-switch\">\n    <input type=\"checkbox\" ng-checked=\"$ctrl.checked\" id=\"{{ $ctrl.id }}\" />\n    <span class=\"ui-slider round\"></span>\n</label>"

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwitcheryController = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwitcheryController = exports.SwitcheryController = function () {
	  SwitcheryController.$inject = ["AppService", "$element", "$scope"];
	  function SwitcheryController(AppService, $element, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SwitcheryController);
	    this.AppService = AppService;
	    this.$element = $element;
	    this.$scope = $scope;
	  }
	
	  (0, _createClass3.default)(SwitcheryController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.input = this.$element.find('input');
	      this.id = this.setName;
	      this.input.click(function (event) {
	        _this.onClick(_this.input.prop('checked'));
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(value) {
	      this.onSwitch({ state: value });
	    }
	  }]);
	  return SwitcheryController;
	}();
	
	exports.default = SwitcheryController;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _navbar = __webpack_require__(530);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarService = function () {
	  NavbarService.$inject = ["PageService", "SessionService", "$timeout"];
	  function NavbarService(PageService, SessionService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NavbarService);
	    this.PageService = PageService;
	    this.SessionService = SessionService;
	    this.$timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(NavbarService, [{
	    key: 'initialize',
	    value: function initialize() {
	      var _this = this;
	
	      this._model = new _navbar2.default();
	
	      // Listen to changes on navigations
	      this.transitionsSubscription = this.PageService.transitionEvents.subscribe(function (event) {
	        _this.$timeout(function () {
	          _this.activate(event.url);
	        });
	      });
	
	      // Subscribe on session.
	      this.subscription = this.SessionService.session.subscribe(function (sessionDetails) {
	        if (sessionDetails) {
	          // Set model's property when sessionDetails becomes available.
	          _this._model.customerName = sessionDetails.customerName;
	          _this._model.customerSince = sessionDetails.customerSince;
	          _this._model.brokerageSyncId = sessionDetails.brokerageSyncId;
	          _this._model.tags = sessionDetails.tags;
	        }
	      });
	
	      var ua = navigator.userAgent,
	          event = ua.match(/iP/i) ? 'touchstart' : 'click';
	
	      this.setUpLeftBtn(event);
	      this.setUpSidebarNavigation(event);
	      $.Sidemenu.highLight();
	
	      if ($(window).width() > 768) {
	        if ($('#sidebar-menu ul > li.has_sub a').hasClass('subdrop')) {
	          $('#wrapper.forced').removeClass('enlarged');
	        }
	      }
	
	      if ($(window).width() < 768) {
	        $('#sidebar-menu>ul>li:not(.has_sub)>a, #sidebar-menu ul ul a').click(function () {
	          $('#wrapper').addClass('forced enlarged');
	        });
	      }
	
	      this.setActiveSubMenu();
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.transitionsSubscription.unsubscribe();
	      this.subscription.unsubscribe();
	    }
	  }, {
	    key: 'setUpLeftBtn',
	    value: function setUpLeftBtn(event) {
	      var openLeftBtn = angular.element('.open-left');
	
	      openLeftBtn.on(event, function () {
	        $.Sidemenu.openLeftBar();
	      });
	    }
	  }, {
	    key: 'setUpSidebarNavigation',
	    value: function setUpSidebarNavigation(event) {
	      var menuItems = angular.element('#sidebar-menu a');
	
	      angular.forEach(menuItems, function (menuItem) {
	        angular.element(menuItem).on(event, function () {
	          $.Sidemenu.menuItemClick(menuItem);
	        });
	      });
	    }
	  }, {
	    key: 'setActiveSubMenu',
	    value: function setActiveSubMenu() {
	      $('.nav-list').on('click', 'li', function () {
	        $('.nav-list li.active').removeClass('active');
	        $(this).addClass('active');
	      });
	    }
	
	    /**
	     * Activates and opens menu items that has been clicked.
	     * The navigation to be activated will be inferred from the
	     * state's url path.
	     *
	     * E.g /transactions/deposit will activate transactions > deposit
	     * nav item respectively.
	       * @param {String} path - ui-sref value for the anchor tag navigation.
	      */
	
	  }, {
	    key: 'activate',
	    value: function activate(path) {
	      var navs = path.substring(1).split('/');
	
	      // If the nav item clicked is inside a dropdown.
	      if (navs.length > 1) {
	        var parent = navs[0];
	        var child = navs[1];
	        var mainMenus = angular.element('#sidebar-menu .has_sub');
	        angular.forEach(mainMenus, function (menu) {
	          var menuEl = angular.element(menu);
	          if (menuEl.find('.menu-parent').length === 1) {
	            var menuAnchor = angular.element(menuEl.find('.menu-parent')[0]);
	            var spanLabel = menuAnchor.find('span')[0].innerHTML.trim().toLowerCase();
	            if (spanLabel === parent.trim()) {
	              menuAnchor.addClass('subdrop');
	              var siblings = menuAnchor.parent().children();
	              var ul = angular.element(menuAnchor.siblings('.transact-sub')[0]);
	              ul.css({ display: 'block' });
	
	              var anchorItems = ul.find('a');
	              angular.forEach(anchorItems, function (item) {
	                var anchorItem = angular.element(item);
	                var navLabel = anchorItem.attr('ui-sref');
	
	                if (navLabel === child || navLabel.indexOf(child) > -1) {
	                  anchorItem.addClass('subdrop');
	                } else {
	                  anchorItem.removeClass('subdrop');
	                }
	              });
	            } else {
	              menuAnchor.removeClass('subdrop');
	            }
	          }
	        });
	      } else {
	        var nav = navs[0];
	        var anchors = angular.element('#sidebar-menu li a');
	
	        angular.forEach(anchors, function (a) {
	          var navLabel = angular.element(a).attr('ui-sref');
	
	          if (navLabel === nav.trim()) {
	            angular.element(a).addClass('subdrop');
	          } else {
	            angular.element(a).removeClass('subdrop');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'model',
	    get: function get() {
	      return this._model;
	    }
	  }]);
	  return NavbarService;
	}();
	
	exports.default = NavbarService;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarModel = function () {
	  function NavbarModel() {
	    (0, _classCallCheck3.default)(this, NavbarModel);
	
	    this._customerName = '';
	    this._customerSince = '';
	    this._brokerageSyncId = '';
	    this._tags = '';
	  }
	
	  (0, _createClass3.default)(NavbarModel, [{
	    key: 'customerName',
	    set: function set(customerName) {
	      this._customerName = customerName;
	    },
	    get: function get() {
	      return this._customerName;
	    }
	  }, {
	    key: 'customerSince',
	    set: function set(customerSince) {
	      this._customerSince = customerSince;
	    },
	    get: function get() {
	      return this._customerSince;
	    }
	  }, {
	    key: 'brokerageSyncId',
	    set: function set(brokerageSyncId) {
	      this._brokerageSyncId = brokerageSyncId;
	    },
	    get: function get() {
	      return this._brokerageSyncId;
	    }
	  }, {
	    key: 'tags',
	    set: function set(tags) {
	      this._tags = tags;
	    },
	    get: function get() {
	      return this._tags;
	    }
	  }]);
	  return NavbarModel;
	}();
	
	exports.default = NavbarModel;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageService = function () {
	  PageService.$inject = ["$state", "$transitions", "$stateParams", "SessionService"];
	  function PageService($state, $transitions, $stateParams, SessionService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, PageService);
	    this.$state = $state;
	    this.$transitions = $transitions;
	    this.$stateParams = $stateParams;
	    this.SessionService = SessionService;
	
	    this._subject$ = new _Rx2.default.BehaviorSubject(this._createEventFromState(this.$state.current));
	    this._transitionEvents$ = this._subject$.asObservable();
	
	    $transitions.onSuccess({}, function (event) {
	      _this._subject$.next(_this._createEventFromState(_this.$state.current));
	    });
	  }
	
	  (0, _createClass3.default)(PageService, [{
	    key: '_createEventFromState',
	    value: function _createEventFromState(state) {
	      var event = {};
	
	      event['current'] = state.name;
	      event['parent'] = state.parent;
	      event['url'] = state.url;
	
	      return event;
	    }
	  }, {
	    key: 'goto',
	    value: function goto(state) {
	      this.$state.go(state);
	    }
	  }, {
	    key: 'getQueryParameters',
	    value: function getQueryParameters() {
	      var parameters = {};
	      for (var property in this.$stateParams) {
	        if (this.$stateParams.hasOwnProperty(property)) {
	          if (property !== '#') {
	            parameters[property] = this.$stateParams[property];
	          }
	        }
	      }
	
	      return parameters;
	    }
	
	    // TODO: Remove this and use modal.util.js instead
	
	  }, {
	    key: 'showModal',
	    value: function showModal() {
	      var modalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (modalId === null) {
	        // TODO
	      } else {
	        $('#' + modalId).modal('show');
	      }
	    }
	  }, {
	    key: 'transitionEvents',
	    get: function get() {
	      return this._transitionEvents$;
	    }
	  }]);
	  return PageService;
	}();
	
	exports.default = PageService;

/***/ }),
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormService = function () {
	  function FormService() {
	    (0, _classCallCheck3.default)(this, FormService);
	
	    this.isSubmitting = new _Rx2.default.BehaviorSubject(false);
	  }
	
	  /**
	   * This function would evaluate forms in the current page resulting to
	   * an object in par with the current state of the form
	   * 
	   * It is required that all field have name attribute in
	   * order to  be evaluated.
	   */
	
	
	  (0, _createClass3.default)(FormService, [{
	    key: 'evaluateForms',
	    value: function evaluateForms() {
	      var evaluation = {};
	
	      var forms = document.getElementsByTagName('form');
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(forms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var form = _step.value;
	
	          var formName = form.getAttribute('name');
	          var formEvaluation = {};
	
	          var formElements = form.elements;
	
	          for (var idx = 0; idx < formElements.length; idx++) {
	            var element = formElements[idx];
	            var elementEvaluation = {};
	            var elementName = element.getAttribute('name');
	            if (elementName) {
	              if (element.tagName === 'SELECT') {
	                elementEvaluation['text'] = element.options[element.selectedIndex].text;
	                elementEvaluation['value'] = element.options[element.selectedIndex].value;
	              }
	
	              if (element.tagName === 'INPUT') {
	                elementEvaluation['text'] = element.value;
	                elementEvaluation['value'] = element.value;
	              }
	            }
	
	            formEvaluation[elementName] = elementEvaluation;
	          }
	
	          evaluation[formName] = formEvaluation;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return evaluation;
	    }
	  }]);
	  return FormService;
	}();
	
	exports.default = FormService;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalService = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalService = exports.ModalService = function () {
	  ModalService.$inject = ["$compile", "$rootScope"];
	  function ModalService($compile, $rootScope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ModalService);
	    this.$compile = $compile;
	    this.$rootScope = $rootScope;
	
	    this.modals = {};
	  }
	
	  (0, _createClass3.default)(ModalService, [{
	    key: 'create',
	    value: function create(id, options) {
	      options['modalId'] = id;
	
	      var newScope = this.$rootScope.$new(true);
	
	      var element = $('body');
	
	      var okAction = '$ctrl.' + options['okAction'] + '()';
	
	      var html = '<modal modal-id="\'' + id + '\'" on-ok="' + okAction + '"></modal>';
	
	      element.append(this.$compile(html)(newScope));
	
	      // Its weird the the scope became child
	      newScope = newScope.$$childHead;
	
	      newScope.modalTitle = options.title;
	      newScope.modalContent = options.content;
	
	      this.modals[id] = newScope;
	    }
	  }, {
	    key: 'show',
	    value: function show(id) {
	      $('#' + id).modal('show');
	    }
	  }, {
	    key: 'setTitle',
	    value: function setTitle(id, newTitle) {
	      var scope = this.modals[id];
	      scope.modalTitle = newTitle;
	    }
	  }]);
	  return ModalService;
	}();
	
	exports.default = ModalService;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appFooter = __webpack_require__(989);
	
	var _appFooter2 = _interopRequireDefault(_appFooter);
	
	var _appFooter3 = __webpack_require__(990);
	
	var _appFooter4 = _interopRequireDefault(_appFooter3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appFooterComponent = {
	  bindings: {},
	  template: _appFooter2.default,
	  controller: _appFooter4.default
	};
	
	exports.default = appFooterComponent;

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	module.exports = "<footer class=\"footer\">\n    <div class=\"text-center\">\n        <div class=\"col-md-10\">\n        <ul class=\"footer-links\">\n            <li>\n            <a href=\"https://asianconnect88.com/about/\" target=\"_blank\">{{ 'About Us' | translate }} </a>\n            </li>\n            <li>\n            <a href=\"https://asianconnect88.com/contact/\" target=\"_blank\">{{ 'Contact Us' | translate }}</a>\n            </li>\n            <li>\n            <a href=\"https://www.asianconnect88.com/terms\" target=\"_blank\">{{ 'Terms and Conditions' | translate }}</a>\n            </li>\n            <li>\n            <a href=\"https://www.asianconnect88.com/responsible-gambling/\" target=\"_blank\">{{ 'Legal Disclaimer' | translate }}</a>\n            </li>  \n            <li>\n            <a href=\"https://www.asianconnect88.com/privacy-policy/\" target=\"_blank\">{{ 'Privacy Policy' | translate }}</a>\n            </li>   \n        </ul>\n        </div>\n    </div>\n</footer>"

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterController = function FooterController() {
	  (0, _classCallCheck3.default)(this, FooterController);
	};
	
	exports.default = FooterController;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _security = __webpack_require__(992);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _security3 = __webpack_require__(993);
	
	var _security4 = _interopRequireDefault(_security3);
	
	var _session = __webpack_require__(994);
	
	var _session2 = _interopRequireDefault(_session);
	
	var _timeout = __webpack_require__(1032);
	
	var _timeout2 = _interopRequireDefault(_timeout);
	
	var _storage = __webpack_require__(1033);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storageService = new _storage2.default();
	var siteOrigin = storageService.getItem('site_origin') ? storageService.getItem('site_origin') : _environment2.default.ASIANCONNECT_URL;
	
	var securityModule = _angular2.default.module('app.security', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('log-out', {
	    url: '/logout',
	    template: '',
	    params: {
	      reason: null
	    },
	    onEnter: ["SecurityService", "$stateParams", function onEnter(SecurityService, $stateParams) {
	      // window.location will reload the page thus destroying all subscriptions and initialized services.
	      SecurityService.logout().then(function () {
	        if (!siteOrigin || siteOrigin === 'undefined') {
	          window.location.assign('?status=' + $stateParams.reason);
	        } else {
	          window.location.assign(siteOrigin + '?status=' + $stateParams.reason);
	        }
	      });
	    }]
	  });
	}]).service('SecurityService', _security2.default).service('SecurityApiService', _security4.default).service('SessionService', _session2.default).service('TimeoutService', _timeout2.default).service('StorageService', _storage2.default).name;
	
	exports.default = securityModule;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Aggregates all security functionalities
	var SecurityService = function () {
	  SecurityService.$inject = ["SessionService", "TimeoutService", "$state"];
	  function SecurityService(SessionService, TimeoutService, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SecurityService);
	    this.SessionService = SessionService;
	    this.TimeoutService = TimeoutService;
	
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(SecurityService, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.SessionService.initialize();
	      // this.SessionService.session.subscribe((sessionDetails) => {
	      //   if (sessionDetails) {
	      //     this.TimeoutService.initialize();
	      //   }
	      // });
	    }
	  }, {
	    key: 'authenticate',
	    value: function authenticate() {
	      if (!this.SessionService.getSession()) {
	        // This would cause a transition rejection.
	        // That is normal since we will transition to signin state without
	        // finishing the current transition.
	        this.$state.go('signin');
	      }
	    }
	
	    // TODO: Add actual checking of session on the backend.
	
	  }, {
	    key: 'isSessionActive',
	    value: function isSessionActive() {
	      // We want a distinct value of just true or false.
	      return this.SessionService.getSession() ? true : false;
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      return this.SessionService.logout();
	    }
	  }, {
	    key: 'login',
	    value: function login(payload) {
	      return this.SessionService.login(payload);
	    }
	  }]);
	  return SecurityService;
	}();
	
	exports.default = SecurityService;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecurityApiService = function () {
	  SecurityApiService.$inject = ["HttpService", "StorageService"];
	  function SecurityApiService(HttpService, StorageService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SecurityApiService);
	    this.StorageService = StorageService;
	    this.HttpService = HttpService;
	  }
	
	  (0, _createClass3.default)(SecurityApiService, [{
	    key: 'login',
	    value: function login(payload) {
	      return this.HttpService.post('/login', payload);
	    }
	  }, {
	    key: 'logout',
	    value: function logout(payload) {
	      return this.HttpService.post('/logout', payload);
	    }
	  }, {
	    key: 'saveCredentials',
	    value: function saveCredentials(payload) {
	      return this.HttpService.post('/' + this.StorageService.getItem('locale') + '/update-credentials', payload);
	    }
	  }, {
	    key: 'checkSessionExpiration',
	    value: function checkSessionExpiration() {
	      return this.HttpService.post('/check-session-expiration');
	    }
	  }]);
	  return SecurityApiService;
	}();
	
	exports.default = SecurityApiService;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(995);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	var _cryptoJs = __webpack_require__(997);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	var _security = __webpack_require__(1031);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STORAGE_KEY = 'zimitech';
	
	var SessionService = function () {
	  SessionService.$inject = ["StorageService", "SecurityApiService"];
	  function SessionService(StorageService, SecurityApiService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SessionService);
	    this.StorageService = StorageService;
	    this.SecurityApiService = SecurityApiService;
	
	    this.subject = new _Rx2.default.BehaviorSubject(undefined);
	    this.session = this.subject.asObservable();
	  }
	
	  (0, _createClass3.default)(SessionService, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.loadSession();
	    }
	  }, {
	    key: 'login',
	    value: function login(payload) {
	      var _this = this;
	
	      return this.SecurityApiService.login(payload).then(function (response) {
	        return _this.processResponse(response);
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      return this.SecurityApiService.logout({}).then(function () {
	        return _this2.clearSession();
	      });
	    }
	  }, {
	    key: 'processResponse',
	    value: function processResponse(response) {
	      var sessionDetails = {
	        customerName: response.full_name,
	        customerSince: response.joined_at,
	        email: response.user.email,
	        currency: response.currency.code === 'BTC' ? 'EUR' : response.currency.code,
	        statuses: response.preferences.transaction.statuses,
	        websocketToken: response.jwt_websocket_token,
	        websocket: response.websocket,
	        brokerageSyncId: response.brokerage_sync_id,
	        tags: response.tags,
	        zendeskId: response.zendesk_id,
	        hasTransactionPasswordEnabled: response.has_enable_transaction_password,
	        verifiedAt: response.verified_at,
	        locale: response.locale,
	        selectedAvatar: response.avatar ? response.avatar.selected : null,
	        uploadedAvatar: response.avatar ? response.avatar.uploaded : null
	      };
	
	      if (response.preferences.hasOwnProperty('google_authenticator')) {
	        sessionDetails.hasTwoFactorEnabled = true;
	        sessionDetails.isUsingGoogleTwoFactor = response.preferences.google_authenticator.is_default_2fa;
	      } else {
	        sessionDetails.hasTwoFactorEnabled = false;
	        sessionDetails.isUsingGoogleTwoFactor = false;
	      }
	
	      if (response.preferences.restore_id) {
	        this.StorageService.setItem('restore_id', response.preferences.restore_id);
	      }
	
	      var memberDetails = {
	        'user_id': response.user.id,
	        'full_name': response.full_name,
	        'email': response.user.email,
	        'country': response.country.name,
	        'birth_date': response.birth_date
	      };
	
	      this.StorageService.setItem('locale', sessionDetails.locale);
	      this.StorageService.setItem('member_details', (0, _stringify2.default)(memberDetails));
	      this.StorageService.setItem('activation_code', response.user.activation_code);
	      this.StorageService.setItem('show_activation_modal', true);
	      this.saveSession(sessionDetails);
	
	      return sessionDetails;
	    }
	  }, {
	    key: 'saveSession',
	    value: function saveSession(dataToStore) {
	      var triggerSubscribption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var cipher = this.encrypt((0, _stringify2.default)(dataToStore));
	      this.StorageService.setItem(STORAGE_KEY, cipher);
	
	      if (triggerSubscribption) {
	        this.subject.next(dataToStore);
	      }
	    }
	  }, {
	    key: 'clearSession',
	    value: function clearSession() {
	      window.fcWidget.user.clear();
	      this.StorageService.removeAllCookie();
	      this.StorageService.clear();
	      this.StorageService.removeItem(STORAGE_KEY);
	      this.subject.next(undefined);
	    }
	  }, {
	    key: 'getSession',
	    value: function getSession() {
	      var cipher = this.StorageService.getItem(STORAGE_KEY);
	
	      if (cipher) {
	        var decrypted = this.decrypt(cipher);
	        var session = JSON.parse(decrypted);
	        session.hasSetupTransactionAuthentication = _security.hasSetupTransactionAuthentication;
	        session.hasSetupAllTransactionAuthentication = _security.hasSetupAllTransactionAuthentication;
	        session.isVerified = _security.isVerified;
	
	        return session;
	      }
	
	      return null;
	    }
	
	    // get an item from localstorage
	
	  }, {
	    key: 'get',
	    value: function get(key) {
	      var item = this.getSession()[key];
	
	      return item;
	    }
	  }, {
	    key: 'set',
	    value: function set(key, value) {
	      var triggerSubscription = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      var data = this.getSession();
	      data[key] = value;
	      this.saveSession(data, triggerSubscription);
	    }
	  }, {
	    key: 'getLocale',
	    value: function getLocale() {
	      return this.StorageService.hasItem('locale') ? this.StorageService.getItem('locale') : 'en';
	    }
	
	    /**
	     * Add AES encryption. Note that we do not store
	     * any sensitive details on local storage.
	     * There is no such secured encryption on front end
	     * since private key will always be insecure.
	     * We only do this, so that local storage content won't
	     * be manually adjusted by any user. Though hacker
	     * could try to decrypt it but again, our backend is secure and
	     * we do not store sensitive details on localstorage. Also
	     * note that our compiled source code will be jumbled making
	     * it harder for anyone to decrypt our local storage.
	     */
	
	  }, {
	    key: 'encrypt',
	    value: function encrypt(string) {
	      return _cryptoJs2.default.AES.encrypt(string, _environment2.default.AES_ENCRYPTION_KEY);
	    }
	  }, {
	    key: 'decrypt',
	    value: function decrypt(cipher) {
	      var bytes = _cryptoJs2.default.AES.decrypt(cipher.toString(), _environment2.default.AES_ENCRYPTION_KEY);
	      var encrypted = bytes.toString(_cryptoJs2.default.enc.Utf8);
	
	      return encrypted;
	    }
	  }, {
	    key: 'loadSession',
	    value: function loadSession() {
	      try {
	        this.subject.next(this.getSession());
	      } catch (e) {
	        // Try to reload session or just do the logout to avoid infinite loops.
	      }
	    }
	  }]);
	  return SessionService;
	}();
	
	exports.default = SessionService;

/***/ }),
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasSetupTransactionAuthentication = hasSetupTransactionAuthentication;
	exports.hasSetupAllTransactionAuthentication = hasSetupAllTransactionAuthentication;
	exports.isVerified = isVerified;
	function hasSetupTransactionAuthentication() {
	  return this.isUsingGoogleTwoFactor || this.hasTransactionPasswordEnabled;
	}
	
	function hasSetupAllTransactionAuthentication() {
	  return this.isUsingGoogleTwoFactor && this.hasTransactionPasswordEnabled;
	}
	
	function isVerified() {
	  return this.verifiedAt !== null;
	}

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeoutService = function () {
	  TimeoutService.$inject = ["$state", "$window", "SessionService", "SecurityApiService"];
	  function TimeoutService($state, $window, SessionService, SecurityApiService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TimeoutService);
	    this.$state = $state;
	    this.$window = $window;
	
	    this.SessionService = SessionService;
	    this.SecurityApiService = SecurityApiService;
	  }
	
	  (0, _createClass3.default)(TimeoutService, [{
	    key: 'initialize',
	    value: function initialize() {
	      var _this = this;
	
	      this.idleSeconds = 0;
	      this.sessionSeconds = 0;
	
	      this.$window.addEventListener('click', function (e) {
	        _this.idleSeconds = 0;
	      });
	
	      this.$window.addEventListener('mouseover', function (e) {
	        _this.idleSeconds = 0;
	      });
	
	      this.$window.addEventListener('keypress', function (e) {
	        _this.idleSeconds = 0;
	      });
	
	      this.SessionService.session.subscribe(function (session) {
	        if (session) {
	          _this.startTimer();
	        } else {
	          _this.stopTimer();
	        }
	      });
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this2 = this;
	
	      this.interval = this.$window.setInterval(function () {
	        _this2.sessionSeconds++;
	        _this2.idleSeconds++;
	
	        if (_this2.idleSeconds === _environment2.default.IDLE_TIMEOUT) {
	          _this2.$state.go('log-out', { reason: 'inactive' });
	        }
	
	        if (_this2.sessionSeconds === 10) {
	          if (_this2.checkSessionIsExpired() === true) {
	            _this2.$state.go('log-out', { reason: 'session_expired' });
	          }
	          _this2.sessionSeconds = 0;
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'checkSessionIsExpired',
	    value: function checkSessionIsExpired() {
	      this.SecurityApiService.checkSessionExpiration().then(function (resp) {
	        return resp.session_expired;
	      });
	    }
	  }, {
	    key: 'stopTimer',
	    value: function stopTimer() {
	      if (this.interval) {
	        clearInterval(this.interval);
	      }
	    }
	  }]);
	  return TimeoutService;
	}();
	
	exports.default = TimeoutService;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _events = __webpack_require__(494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StorageService = function () {
	  StorageService.$inject = ["$cookies", "EventDispatcherService"];
	  function StorageService($cookies, EventDispatcherService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, StorageService);
	    this.$cookies = $cookies;
	    this.supportsLocalStorage = false;
	
	    if (EventDispatcherService) {
	      EventDispatcherService.addListener(_events.EVENTS.UNAUTHORIZED_ACCESS, function (event) {
	        return _this.clear();
	      });
	    }
	
	    try {
	      var testKey = 'storage-test';
	      localStorage.setItem(testKey, 'ok');
	      localStorage.removeItem(testKey);
	      this.supportsLocalStorage = true;
	    } catch (e) {
	      this.supportsLocalStorage = false;
	    }
	  }
	
	  (0, _createClass3.default)(StorageService, [{
	    key: 'setItem',
	    value: function setItem(key, value) {
	      if (this.supportsLocalStorage) {
	        return localStorage.setItem(key, value);
	      }
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(key) {
	      if (this.supportsLocalStorage) {
	        return localStorage.getItem(key);
	      }
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(key) {
	      if (this.supportsLocalStorage) {
	        return localStorage.removeItem(key);
	      }
	    }
	  }, {
	    key: 'hasItem',
	    value: function hasItem(key) {
	      if (this.supportsLocalStorage) {
	        if (this.getItem(key) !== null) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      if (this.supportsLocalStorage) {
	        var donotShowGooglePromptModal = this.getItem('do-not-show-google-prompt');
	        localStorage.clear();
	
	        if (donotShowGooglePromptModal) {
	          localStorage.setItem('do-not-show-google-prompt', donotShowGooglePromptModal);
	        }
	      }
	    }
	  }, {
	    key: 'removeZendeskCookie',
	    value: function removeZendeskCookie() {
	      var zendeskCookieIndex = '__zlcmid';
	      this.$cookies.remove(zendeskCookieIndex);
	    }
	  }, {
	    key: 'removeAllCookie',
	    value: function removeAllCookie() {
	      var domain = window.location.hostname;
	      var cookies = document.cookie.split(";");
	
	      for (var i = 0; i < cookies.length; i++) {
	        var cookie = cookies[i];
	        var eqPos = cookie.indexOf("=");
	        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
	        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=" + domain;
	      }
	    }
	  }]);
	  return StorageService;
	}(); // TODO: Handle if the browser doesnt support locale storage. Use $cookies if not.
	
	
	exports.default = StorageService;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventDispatcher = undefined;
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _fbemitter = __webpack_require__(1035);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This class exist to minimize the use of RxJS
	 * for Emitting Events. RxJS is just purely overkill
	 * if we just wanna have a basic event dispatching.
	 */
	var EventDispatcher = exports.EventDispatcher = function () {
	  function EventDispatcher() {
	    (0, _classCallCheck3.default)(this, EventDispatcher);
	
	    this.emitter = new _fbemitter.EventEmitter();
	  }
	
	  (0, _createClass3.default)(EventDispatcher, [{
	    key: "dispatch",
	    value: function dispatch(eventName, event) {
	      event.name = eventName;
	      this.emitter.emit(eventName, event);
	    }
	  }, {
	    key: "addListener",
	    value: function addListener(eventName, callback) {
	      return this.emitter.addListener(eventName, callback);
	    }
	
	    /**
	     * Add Listener to list of events calling same callback 
	     * function
	     * 
	     * @param {*} eventNames list of events
	     * @param {function} callback function that will be called when one of the events occured
	     */
	
	  }, {
	    key: "addListeners",
	    value: function addListeners(callback) {
	      for (var _len = arguments.length, eventNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        eventNames[_key - 1] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(eventNames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var eventName = _step.value;
	
	          this.addListener(eventName, callback);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }]);
	  return EventDispatcher;
	}();
	
	exports.default = EventDispatcher;

/***/ }),
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppService = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This class should only be injected into Controllers extending
	 * BaseController.
	 */
	var AppService = exports.AppService = function () {
	  /**
	   * Do not inject $injector and $rootscope on any service other
	   * than this service.
	   * 
	   * @param {*} $injector 
	   * @param {*} $rootscope
	   */
	  AppService.$inject = ["$injector", "$rootScope"];
	  function AppService($injector, $rootScope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AppService);
	    this.$injector = $injector;
	    this.$rootScope = $rootScope;
	  }
	
	  (0, _createClass3.default)(AppService, [{
	    key: 'broadcast',
	    value: function broadcast(name) {
	      this.$rootScope.$broadcast(name);
	    }
	
	    /**
	     * Adds listener to EventDispatcherService.
	     * 
	     * @param {string} eventName - Name of the event to listen to
	     * @param {function} callback - Function to invoke when the specified event is emitted
	     * 
	     * @returns Subscription
	     */
	
	  }, {
	    key: 'addListener',
	    value: function addListener(eventName, callback) {
	      var EventDispatcherService = this.$injector.get('EventDispatcherService');
	
	      return EventDispatcherService.addListener(eventName, callback);
	    }
	
	    /**
	     * Get the service from the DI container.
	     * 
	     * @param {string} name - Name of service to get
	     */
	
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this.$injector.get(name);
	    }
	  }]);
	  return AppService;
	}();
	
	exports.default = AppService;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1044);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTTPService = function () {
	  HTTPService.$inject = ["$http"];
	  function HTTPService($http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HTTPService);
	    this.$http = $http;
	    this.apiUrl = _environment2.default.API_URL;
	  }
	
	  (0, _createClass3.default)(HTTPService, [{
	    key: 'get',
	    value: function get(url) {
	      var responseType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';
	
	      return this.sendRequest('GET', url, null, responseType);
	    }
	
	    /**
	     * This is a quickfix for bet details loading inside a modal.
	     * It is somehow very weird that it doesn't behave like any
	     * other functions that uses get() with async.
	     * 
	     * TODO: Refactor BetHistoryController to get rid of this method.
	     */
	
	  }, {
	    key: 'getNonAsync',
	    value: function getNonAsync(url) {
	      var responseType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';
	
	      return this.sendRequest('GET', url, null, responseType);
	    }
	  }, {
	    key: 'post',
	    value: function post(url, payload) {
	      var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'json';
	      var additionalHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	      return this.sendRequest('POST', url, payload, responseType, additionalHeaders);
	    }
	  }, {
	    key: 'put',
	    value: function put(url, payload) {
	      return this.sendRequest('PUT', url, payload);
	    }
	  }, {
	    key: 'buildQueryParamsFromPayload',
	    value: function buildQueryParamsFromPayload(payload) {
	      var encode = encodeURIComponent;
	
	      return (0, _keys2.default)(payload).map(function (k) {
	        if (payload[k] !== '' && payload[k] !== null && typeof payload[k] != 'undefined') {
	          return encode(k) + '=' + encode(payload[k]);
	        }
	
	        return '';
	      }).filter(function (part) {
	        return part || part.length > 0;
	      }).join('&');
	    }
	  }, {
	    key: 'sendRequest',
	    value: function sendRequest(method, url) {
	      var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'json';
	      var additionalHeaders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	      var requestUrl = this.apiUrl + url;
	      var headers = {
	        'Accept': 'application/json'
	      };
	
	      if (method !== 'GET') {
	        headers['X-CSRF-Protection'] = '1';
	      }
	
	      return this.$http({
	        method: method,
	        url: requestUrl,
	        data: payload,
	        headers: angular.merge(headers, additionalHeaders),
	        withCredentials: true,
	        responseType: responseType
	      });
	    }
	  }]);
	  return HTTPService;
	}();
	
	exports.default = HTTPService;

/***/ }),
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatService = function () {
	  ChatService.$inject = ["CustomerApiService", "StorageService", "SessionService", "TicketsApiService"];
	  function ChatService(CustomerApiService, StorageService, SessionService, TicketsApiService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ChatService);
	    this.CustomerApiService = CustomerApiService;
	    this.StorageService = StorageService;
	    this.SessionService = SessionService;
	    this.enableChatHistory = false;
	    this.TicketsApiService = TicketsApiService;
	  }
	
	  (0, _createClass3.default)(ChatService, [{
	    key: 'initialize',
	    value: function initialize() {
	      var _this = this;
	
	      this.SessionService.session.subscribe(function (sessionDetails) {
	        if (sessionDetails) {
	          _this.enableZendeskChat();
	        } else {
	          _this.disableZendeskChat();
	        }
	      });
	    }
	  }, {
	    key: 'enableChat',
	    value: function enableChat() {
	      var _this2 = this;
	
	      var memberDetails = JSON.parse(this.StorageService.getItem('member_details'));
	      var userId = memberDetails.user_id;
	      var fullName = memberDetails.full_name;
	      var email = memberDetails.email;
	      var restoreId = '';
	
	      if (this.enableChatHistory) {
	        restoreId = this.StorageService.getItem('restore_id');
	      }
	
	      window.fcWidget.init({
	        token: _environment2.default.FRESH_CHAT_TOKEN,
	        host: _environment2.default.FRESH_CHAT_HOST,
	        externalId: userId,
	        restoreId: restoreId
	      });
	
	      window.fcWidget.user.get(function (resp) {
	        var status = resp && resp.status;
	
	        if (status !== 200) {
	          window.fcWidget.user.setProperties({
	            firstName: fullName,
	            email: email,
	            externalId: userId
	          });
	
	          if (_this2.enableChatHistory) {
	            window.fcWidget.on('user:created', function (resp) {
	              var status = resp && resp.status;
	              var data = resp && resp.data;
	              if (status === 200) {
	                if (data.restoreId) {
	                  _this2.CustomerApiService.saveRestoreId({ 'restoreId': data.restoreId }).then(function () {});
	                }
	              }
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'enableZendeskChat',
	    value: function enableZendeskChat() {
	      var zeScript = document.createElement('script');
	      zeScript.setAttribute('id', 'ze-snippet');
	      zeScript.setAttribute('src', _environment2.default.ZENDESK_WIDGET_SCRIPT);
	
	      this.TicketsApiService.fetchTicketToken().then(function (ticketDetails) {
	        window.zESettings = {
	          webWidget: {
	            authenticate: {
	              chat: {
	                jwtFn: function jwtFn(callback) {
	                  callback(ticketDetails.token);
	                }
	              }
	            }
	          }
	        };
	        document.body.appendChild(zeScript);
	        zeScript.onload = function () {
	          zE('webWidget', 'show');
	        };
	      });
	    }
	  }, {
	    key: 'disableZendeskChat',
	    value: function disableZendeskChat() {
	      if (typeof zE !== 'undefined') {
	        zE(function () {
	          zE.logout();
	          zE.hide();
	        });
	      } else {
	        var zeScript = document.createElement('script');
	        zeScript.setAttribute('id', 'ze-snippet');
	        zeScript.setAttribute('src', _environment2.default.ZENDESK_WIDGET_SCRIPT);
	        document.body.appendChild(zeScript);
	
	        zeScript.onload = function () {
	          zE('webWidget', 'show');
	        };
	      }
	    }
	  }]);
	  return ChatService;
	}();
	
	exports.default = ChatService;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	HTTPInterceptor.$inject = ["$q", "$state", "EventDispatcherService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _unauthorizedAccessEvent = __webpack_require__(1050);
	
	var _events = __webpack_require__(494);
	
	function HTTPInterceptor($q, $state, EventDispatcherService) {
	  'ngInject';
	
	  return {
	    response: function response(_response, status, headers) {
	      switch (_response.status) {
	        case 200:
	          if (_response.headers()['x-redirect-url']) {
	            window.location = _response.headers()['x-redirect-url'];
	          }
	
	          break;
	      }
	
	      return _response.data;
	    },
	
	    responseError: function responseError(response) {
	      var deferred = $q.defer();
	
	      switch (response.status) {
	        case 401:
	          var event = new _unauthorizedAccessEvent.UnauthorizedAccessEvent();
	          EventDispatcherService.dispatch(_events.EVENTS.UNAUTHORIZED_ACCESS, event);
	          if ($state.current.name !== 'signin') {
	            $state.go('log-out');
	          }
	          break;
	        case 403:
	          $state.go('forbidden');
	          break;
	        case 422:
	          // FORM ERRORS
	          deferred.reject(response.data);
	          break;
	        case 400:
	          deferred.reject(response.data.message);
	          break;
	      }
	
	      return deferred.promise;
	    }
	  };
	}
	
	exports.default = HTTPInterceptor;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UnauthorizedAccessEvent = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _default = __webpack_require__(1081);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This event is being dispatched whenever HTTPInterceptor encounters
	// 401 response
	var UnauthorizedAccessEvent = exports.UnauthorizedAccessEvent = function (_DefaultEvent) {
	  (0, _inherits3.default)(UnauthorizedAccessEvent, _DefaultEvent);
	
	  function UnauthorizedAccessEvent() {
	    (0, _classCallCheck3.default)(this, UnauthorizedAccessEvent);
	    return (0, _possibleConstructorReturn3.default)(this, (UnauthorizedAccessEvent.__proto__ || (0, _getPrototypeOf2.default)(UnauthorizedAccessEvent)).call(this, {}));
	  }
	
	  return UnauthorizedAccessEvent;
	}(_default.DefaultEvent);

/***/ }),
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DefaultEvent = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Extend this class for more sophisticated events
	 */
	var DefaultEvent = exports.DefaultEvent = function () {
	  function DefaultEvent(payload) {
	    (0, _classCallCheck3.default)(this, DefaultEvent);
	
	    this._payload = payload;
	
	    this._name = null;
	  }
	
	  (0, _createClass3.default)(DefaultEvent, [{
	    key: "name",
	    set: function set(name) {
	      this._name = name;
	    },
	    get: function get() {
	      return this._name;
	    }
	  }, {
	    key: "payload",
	    set: function set(payload) {
	      this._payload = payload;
	    },
	    get: function get() {
	      return this._payload;
	    }
	  }]);
	  return DefaultEvent;
	}();
	
	exports.default = DefaultEvent;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _standardlayout = __webpack_require__(1083);
	
	var _standardlayout2 = _interopRequireDefault(_standardlayout);
	
	var _standardlayout3 = __webpack_require__(1084);
	
	var _standardlayout4 = _interopRequireDefault(_standardlayout3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var standardLayoutComponent = {
	  bindings: {},
	  template: _standardlayout2.default,
	  controller: _standardlayout4.default
	};
	
	exports.default = standardLayoutComponent;

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	module.exports = "<topbar></topbar>\n<navbar></navbar>\n<div ui-view></div>\n<app-footer></app-footer>\n"

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StandardLayoutController = function StandardLayoutController() {
	  (0, _classCallCheck3.default)(this, StandardLayoutController);
	};
	
	exports.default = StandardLayoutController;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _forbidden = __webpack_require__(1086);
	
	var _forbidden2 = _interopRequireDefault(_forbidden);
	
	var _forbidden3 = __webpack_require__(1087);
	
	var _forbidden4 = _interopRequireDefault(_forbidden3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var forbiddenPageComponent = {
	  bindings: {},
	  template: _forbidden2.default,
	  controller: _forbidden4.default
	};
	
	exports.default = forbiddenPageComponent;

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	module.exports = "<h1>{{ 'Forbidden!' | translate }}</h1>\n"

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForbiddenController = function ForbiddenController() {
	  (0, _classCallCheck3.default)(this, ForbiddenController);
	};
	
	exports.default = ForbiddenController;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _customerProductsList = __webpack_require__(1089);
	
	var _customerProductsList2 = _interopRequireDefault(_customerProductsList);
	
	var _customerProductsList3 = __webpack_require__(1090);
	
	var _customerProductsList4 = _interopRequireDefault(_customerProductsList3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomerProductlistComponent = {
	  bindings: {
	    customerProducts: '<'
	  },
	  template: _customerProductsList2.default,
	  controller: _customerProductsList4.default
	};
	
	exports.default = CustomerProductlistComponent;

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

	module.exports = "<div loading=\"$ctrl.customerProducts\"></div>\n<div ng-show=\"$ctrl.customerProducts\" class=\"filters\">\n  <table id=\"myProductsTable\" class=\"table table-striped toggle-circle m-b-0\">\n    <thead>\n    <tr>\n      <th data-toggle=\"true\">{{ 'tables.product' | translate }}</th>\n      <th>{{ 'tables.username' | translate }}</th>\n      <th data-hide=\"phone\">{{ 'tables.currency' | translate }}</th>\n      <th data-hide=\"phone, tablet\">{{ 'tables.balance' | translate }}</th>\n      <th data-hide=\"phone, tablet\">{{ 'tables.dateLastUpdated' | translate }}</th>\n    </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"customerProduct in $ctrl.customerProducts\">\n        <td>{{ customerProduct.product.name }}</td>\n        <td>{{ customerProduct.username }}</td>\n        <td>{{ customerProduct.currency.code }}</td>\n        <td>{{ customerProduct.balance }}</td>\n        <td>{{ customerProduct.updatedAt }}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>"

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomerProductListController = function () {
	  CustomerProductListController.$inject = ["CustomerApiService", "$timeout", "$scope"];
	  function CustomerProductListController(CustomerApiService, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CustomerProductListController);
	    this.CustomerApiService = CustomerApiService;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	  }
	
	  (0, _createClass3.default)(CustomerProductListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.loadCustomerProducts();
	
	      // Listen for broadcasted event on parent's scope.
	      this.$scope.$on('reload.customer-products', function () {
	        _this.loadCustomerProducts();
	      });
	    }
	  }, {
	    key: 'loadCustomerProducts',
	    value: function loadCustomerProducts() {
	      var _this2 = this;
	
	      this.CustomerApiService.getCustomerProducts().then(function (customerProducts) {
	        _this2.customerProducts = customerProducts;
	        _this2.$timeout(function () {
	          $('#myProductsTable').footable();
	          $('#myProductsTable').trigger('footable_redraw');
	        }, 0);
	      });
	    }
	  }]);
	  return CustomerProductListController;
	}();
	
	exports.default = CustomerProductListController;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _customerProductWidget = __webpack_require__(1092);
	
	var _customerProductWidget2 = _interopRequireDefault(_customerProductWidget);
	
	var _customerProductWidget3 = __webpack_require__(1093);
	
	var _customerProductWidget4 = _interopRequireDefault(_customerProductWidget3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerProductWidgetComponent = {
	    bindings: {
	        onCustomerProductsLoaded: '&'
	    },
	    template: _customerProductWidget2.default,
	    controller: _customerProductWidget4.default
	};
	
	exports.default = customerProductWidgetComponent;

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"portlet widget p-15\">\n    <div class=\"portlet-heading no-p\">\n        <ul class=\"customer-widget\">\n            <li>\n                <h3 class=\"portlet-title text-gray\">\n                    <i class=\"fas fa-box-open\"></i> {{ 'My Products' | translate }}\n                </h3>                \n            </li>\n            <li>\n                <div class=\"right\">\n                    <div class=\"custom_tooltip_mobile\">\n                        <button class=\"btn waves-effect btn-sm request-product\" data-toggle=\"modal\" data-target=\"#requestProductModal\"><i class=\"fas fa-plus\"></i>\n                        </button>\n                        <span class=\"custom_tooltiptext font-sm\">\n                            Add Product\n                        </span>\n                    </div>\n                    <div class=\"custom_tooltip_mobile\">\n                        <button class=\"btn waves-effect btn-sm request-product\" data-toggle=\"modal\" data-target=\"#requestProductPassword\"><i class=\"fas fa-key\"></i></button>\n                        <span class=\"custom_tooltiptext font-sm\">\n                            Reset Product Password\n                        </span>\n                    </div>\n                </div>                \n            </li>\n        </ul>\n        <div class=\"clearfix\"></div>\n    </div>\n    <hr>\n    <div class=\"portlet-body no-p\">\n        <span loading=\"$ctrl.customerProducts\"></span>\n        <div class=\"row\">\n            <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                <ul class=\"product-title\">\n                    <li ng-repeat=\"customerProduct in $ctrl.customerProducts\">\n                        <p>{{ customerProduct.productName }} <span ng-if=\"customerProduct.isRequestedToday\">({{ 'New' | translate }})</span></p>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                <ul class=\"product-content\">\n                    <li ng-repeat=\"customerProduct in $ctrl.customerProducts\">\n                        <p>{{ customerProduct.balance |number : 2 }} {{ customerProduct.currency.code === 'BTC' ? 'EUR' : customerProduct.currency.code }}</p>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CustomerProductWidgetController = exports.CustomerProductsList = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _modal = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomerProductsList = exports.CustomerProductsList = function () {
	    function CustomerProductsList(customerProducts) {
	        (0, _classCallCheck3.default)(this, CustomerProductsList);
	
	        this._customerProducts = customerProducts;
	    }
	
	    (0, _createClass3.default)(CustomerProductsList, [{
	        key: 'customerProducts',
	        get: function get() {
	            return this._customerProducts;
	        }
	    }, {
	        key: 'balance',
	        get: function get() {
	            var balance = (0, _numeral2.default)(0);
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(this.customerProducts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var customerProduct = _step.value;
	
	                    balance = balance.add(customerProduct.balance);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return balance.format('0,0.00');
	        }
	    }]);
	    return CustomerProductsList;
	}();
	
	var CustomerProductWidgetController = exports.CustomerProductWidgetController = function (_BaseController) {
	    CustomerProductWidgetController.$inject = ["CustomerApiService", "AppService", "$scope"];
	    (0, _inherits3.default)(CustomerProductWidgetController, _BaseController);
	
	    function CustomerProductWidgetController(CustomerApiService, AppService, $scope) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, CustomerProductWidgetController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerProductWidgetController.__proto__ || (0, _getPrototypeOf2.default)(CustomerProductWidgetController)).call(this, AppService));
	
	        _this.CustomerApiService = CustomerApiService;
	        _this.$scope = $scope;
	
	        _this.$scope.$on('reload.customer-products', function () {
	            _this.loadCustomerProducts();
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(CustomerProductWidgetController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.loadCustomerProducts();
	
	            this.addListener(_events2.default.PRODUCT_REQUESTED, function (event) {
	                _this2.refreshProducts();
	            });
	
	            this.addListener(_events2.default.TRANSACTION_PROCESSED, function (event) {
	                _this2.refreshProducts();
	            });
	        }
	    }, {
	        key: 'loadCustomerProducts',
	        value: function loadCustomerProducts() {
	            var _this3 = this;
	
	            this.CustomerApiService.getProducts().then(function (customerProducts) {
	                _this3.customerProducts = customerProducts;
	                _this3.onCustomerProductsLoaded({ customerProductsList: new CustomerProductsList(_this3.customerProducts) });
	            });
	        }
	    }, {
	        key: 'refreshProducts',
	        value: function refreshProducts() {
	            this.loadCustomerProducts();
	        }
	    }]);
	    return CustomerProductWidgetController;
	}(_basecontroller.BaseController);
	
	exports.default = CustomerProductWidgetController;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BaseController = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseController = exports.BaseController = function () {
	  /**
	   * We make AppService nullable to make it backwards compatible.
	   * 
	   * @param {AppService} AppService 
	   */
	  function BaseController() {
	    var AppService = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    (0, _classCallCheck3.default)(this, BaseController);
	
	    this.AppService = AppService;
	
	    this.state = {};
	    this._subscriptions = [];
	  }
	
	  /**
	   * Broadcast a scope event to all siblings scope.
	   * 
	   * @param {string} name - The name of the event to be broadcasted to siblings scope.
	   */
	
	
	  (0, _createClass3.default)(BaseController, [{
	    key: 'broadcast',
	    value: function broadcast(name) {
	      this.AppService.broadcast(name);
	    }
	
	    /**
	     * Adds listener to EventDispatcherService.
	     * 
	     * @param {string} eventName - Name of the event to listen to
	     * @param {function} callback - Function to invoke when the specified event is emitted
	     */
	
	  }, {
	    key: 'addListener',
	    value: function addListener(eventName, callback) {
	      var subscription = this.AppService.addListener(eventName, callback);
	
	      this.addSubscription(subscription);
	    }
	  }, {
	    key: 'setState',
	    value: function setState(key, val) {
	      this.state[key] = val;
	    }
	  }, {
	    key: 'getState',
	    value: function getState(key) {
	      return this.state[key];
	    }
	  }, {
	    key: 'addSubscription',
	    value: function addSubscription(subscription) {
	      this._subscriptions.push(subscription);
	    }
	  }, {
	    key: 'removeSubscriptions',
	    value: function removeSubscriptions() {
	      this._subscriptions.forEach(function (subscription) {
	        return subscription.remove();
	      });
	      this._subscriptions.length = 0;
	    }
	  }, {
	    key: 'getSession',
	    value: function getSession() {
	      var sessionService = this.AppService.get('SessionService');
	
	      return sessionService.getSession();
	    }
	  }, {
	    key: 'setSessionItem',
	    value: function setSessionItem(key, value) {
	      var sessionService = this.AppService.get('SessionService');
	
	      sessionService.set(key, value);
	    }
	  }, {
	    key: 'goToState',
	    value: function goToState(state, params) {
	      var $state = this.AppService.get('$state', params);
	
	      $state.go(state, params);
	    }
	
	    // Override this when you need to have
	    // more sophisticated onDestroy() logic.
	    // but do not forget to call super.$onDestroy();
	
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.removeSubscriptions();
	    }
	  }]);
	  return BaseController;
	}();

/***/ }),
/* 1095 */,
/* 1096 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showModal = showModal;
	exports.hideModal = hideModal;
	function showModal(modalId) {
	  $('#' + modalId).modal('show');
	}
	
	function hideModal(modalId) {
	  $('#' + modalId).modal('hide');
	}

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _requestProductModalComponent = __webpack_require__(1098);
	
	var _requestProductModalComponent2 = _interopRequireDefault(_requestProductModalComponent);
	
	var _requestProductModal = __webpack_require__(1099);
	
	var _requestProductModal2 = _interopRequireDefault(_requestProductModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestProductModalComponent = {
	    bindings: {},
	    template: _requestProductModalComponent2.default,
	    controller: _requestProductModal2.default
	};
	
	exports.default = requestProductModalComponent;

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"requestProductModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\" style=\"display: none;\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content add-product-modal\">\n            <!-- header -->\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\">{{ 'Request Product' | translate }}</h5>\n            </div>\n\n            <!-- body -->\n            <div class=\"modal-body\">\n                <div class=\"product-wrapper\">\n                    <div class=\"row\">\n                        <div class=\"col-md-7 col-xs-12 col-sm-12\">\n                            <div ng-if=\"$ctrl.hasUnrequestedProducts === true\" class=\"bookies-notes\">\n                                <small>{{ 'Please select at least one product below' | translate }}:</small>\n                            </div>\n                        </div>\n                        <div class=\"col-md-5 col-xs-12 col-sm-12 cls-product-error\">\n                            <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.form.error.parent\">\n                                <li ng-repeat=\"(key, error) in $ctrl.form.error.parent\" class=\"parsley-required\">{{ error }}</li>\n                            </ul>\n                        </div>                        \n                    </div>\n\n                    <!-- no products to show notice -->\n                    <div ng-if=\"$ctrl.hasUnrequestedProducts === false\" class=\"product-available\">\n                        <p>{{ 'No products available. You already have all the products Asianconnect offers.' | translate }}</p>\n                    </div>\n\n                    <!-- product list item -->\n                    <div class=\"col-product col-md-4 col-sm-4 col-xs-4\" ng-repeat=\"unrequestedProduct in $ctrl.unrequestedProducts\">\n                        <label ng-class=\"{ 'image-checkbox-checked' : $ctrl.form.requestProducts[unrequestedProduct.code].isSelected }\" class=\"image-checkbox\">\n                            <div class=\"checkbox-custom\">\n                                <span class=\"fa fa-check\"></span>\n                                <input class=\"hidden\" ng-click=\"$ctrl.toggleTab(unrequestedProduct.code)\" ng-model=\"$ctrl.form.requestProducts[unrequestedProduct.code].isSelected\" type=\"checkbox\">\n                            </div>\n                            <img class=\"img-responsive\" ng-src=\"/assets/images/product_logo/{{ unrequestedProduct.code }}.png\">\n                        </label>\n                    </div>\n\n                    <!-- product username field -->\n                    <div class=\"product-form col-md-12 col-sm-12 col-xs-12\">\n                        <div class=\"col-md-6 col-sm-6 col-xs-12 liFormGroup\" ng-class=\"{ 'hidden': !$ctrl.form.requestProducts[unrequestedProduct.code].isSelected }\" ng-repeat=\"unrequestedProduct in $ctrl.unrequestedProducts\" ng-if=\"unrequestedProduct !== undefined && unrequestedProduct.has_username\">\n                            <div class=\"form-group customerProduct\">\n                                <label>{{ unrequestedProduct.name }} {{ 'form.username' | translate }} *</label>\n                                <input type=\"text\" required class=\"form-control username\" ng-class=\"{ 'parsley-error': $ctrl.form.error.memberProducts[unrequestedProduct.code].children.username.errors }\" ng-model=\"$ctrl.form.requestProducts[unrequestedProduct.code].username\" ng-keyup=\"$ctrl.toggleSubmitButton()\" placeholder=\"Enter {{ unrequestedProduct.name }} {{ 'username' | translate }}\" required=\"\">\n                                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.form.error.memberProducts[unrequestedProduct.code].children.username.errors\">\n                                    <li ng-repeat=\"(key, error) in $ctrl.form.error.memberProducts[unrequestedProduct.code].children.username.errors\" class=\"parsley-required\">{{ error }}</li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- position taking agreement -->\n                    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n                        <div class=\"panel-group\" id=\"forced-pt\">\n                            <div class=\"\" ng-class=\"{ 'collapse-wrapper': $ctrl.hasAgreement }\">\n                                <div class=\"panel panel-default\" ng-class=\"{ 'hidden': !$ctrl.hasPositionTaking('SIN') }\">\n                                    <div class=\"panel-heading\">\n                                        <h4 class=\"panel-title\">\n                                            <a data-toggle=\"collapse\" ng-click=\"$ctrl.toggleTab('SIN')\" href=\"\" aria-expanded=\"false\" class=\"collapsed\">\n                                                {{ 'SINGBET FORCED POSITION TAKING ON ASIANCONNECT' | translate }}\n                                            </a>\n                                        </h4>\n                                    </div>\n                                    <div id=\"SIN-pt\" class=\"panel-collapse collapse in\" aria-expanded=\"false\">\n                                        <div class=\"panel-body\">\n                                            <h5 class=\"cnt-title\">{{ 'Profit and Loss (PnL)' | translate }}</h3>\n\n                                                <p>{{ 'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.' | translate }}<br>\n                                                    {{ 'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).' | translate }}<br>\n                                                    {{ 'Then if you lose, you only lose 400 EUR/GBP.' | translate }}</p>\n\n                                                <h5 class=\"cnt-label\">{{ 'Deposits' | translate }}</h5>\n\n                                                <p>{{ 'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.' | translate }}</p>\n\n                                                <h5 class=\"cnt-label\">{{ 'Withdrawals' | translate }}</h5>\n\n                                                <p>{{ 'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.' | translate }}</p>\n                                                <p class=\"agreement-note\"><strong>{{ 'Note' | translate }}: </strong>{{ 'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.' | translate }}</p>\n                                                <div class=\"accept-tc\">\n                                                    <div class=\"checkbox checkbox-success\">\n                                                        <input ng-model=\"$ctrl.form.requestProducts['SIN'].isAgree\" ng-click=\"$ctrl.toggleTab('SIN')\" id=\"accept-terms1\" type=\"checkbox\">\n                                                        <label for=\"accept-terms1\">\n                                                            {{ 'I agree to the Terms and Conditions' | translate }}\n                                                        </label>\n                                                    </div>\n                                                </div>  \n                                        </div>                                  \n                                    </div>\n                                </div>\n                                <div class=\"panel panel-default\" ng-class=\"{ 'hidden': !$ctrl.hasPositionTaking('MXB') }\">\n                                    <div class=\"panel-heading\">\n                                        <h4 class=\"panel-title\">\n                                            <a data-toggle=\"collapse\" ng-click=\"$ctrl.toggleTab('MXB')\" href=\"\" class=\"collapsed\" aria-expanded=\"false\">\n                                                {{ 'MAXBET FORCED POSITION TAKING ON ASIANCONNECT' | translate }}\n                                            </a>\n                                        </h4>\n                                    </div>\n                                    <div id=\"MXB-pt\" class=\"panel-collapse collapse in\" aria-expanded=\"false\">\n                                        <div class=\"panel-body\">\n                                            <h5 class=\"cnt-title\">{{ 'Profit and Loss (PnL)' | translate }}</h5>\n\n                                            <p>{{ 'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.' | translate }}<br>\n                                                {{ 'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).' | translate }}<br>\n                                                {{ 'Then if you lose, you only lose 500 EUR/GBP.' | translate }}</p>\n\n                                            <h5 class=\"cnt-label\">{{ 'Deposits' | translate }}</h5>\n\n                                            <p>{{ 'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.' | translate }}</p>\n\n                                            <h5 class=\"cnt-label\">{{ 'Withdrawals' | translate }}</h5>\n\n                                            <p>{{ 'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.' | translate }}</p>\n                                            <p class=\"agreement-note\"><strong>{{ 'Note' | translate }}: </strong>{{ 'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.' | translate }}</p>\n                                            <div class=\"accept-tc\">\n                                                <div class=\"checkbox checkbox-success\">\n                                                    <input ng-model=\"$ctrl.form.requestProducts['MXB'].isAgree\" ng-click=\"$ctrl.toggleTab('MXB')\" id=\"accept-terms2\" type=\"checkbox\">\n                                                    <label for=\"accept-terms2\">\n                                                        {{ 'I agree to the Terms and Conditions' | translate }}\n                                                    </label>\n                                                </div>\n                                            </div>                                          \n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"panel panel-default\" ng-class=\"{ 'hidden': !$ctrl.hasPositionTaking('SBO') }\">\n                                    <div class=\"panel-heading\">\n                                        <h4 class=\"panel-title\">\n                                            <a data-toggle=\"collapse\" ng-click=\"$ctrl.toggleTab('SBO')\" href=\"\" class=\"collapsed\" aria-expanded=\"false\">\n                                                {{ 'SBOBET Forced Position Taking ON ASIANCONNECT' | translate }}\n                                            </a>\n                                        </h4>\n                                    </div>\n                                    <div id=\"SBO-pt\" class=\"panel-collapse collapse in\" aria-expanded=\"false\">\n                                        <div class=\"panel-body\">\n                                            <h5 class=\"cnt-title\">{{ 'Profit and Loss (PnL)' | translate }}</h5>\n\n                                            <p>{{ 'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.' | translate }}</p>\n\n                                            <h5 class=\"cnt-label\">{{ 'Deposits' | translate }}</h5>\n\n                                            <p>{{ 'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.' | translate }}</p>\n\n                                            <h5 class=\"cnt-label\">{{ 'Withdrawals' | translate }}</h5>\n\n                                            <p>{{ 'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.' | translate }}</p>\n                                            <p class=\"agreement-note\"><strong>{{ 'Note' | translate }}: </strong>{{ 'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.' | translate }}</p>\n                                            <div class=\"accept-tc\">\n                                                <div class=\"checkbox checkbox-success\">\n                                                    <input ng-model=\"$ctrl.form.requestProducts['SBO'].isAgree\" ng-click=\"$ctrl.toggleTab('SBO')\" id=\"accept-terms3\" type=\"checkbox\">\n                                                    <label for=\"accept-terms3\">\n                                                        {{ 'I agree to the Terms and Conditions' | translate }}\n                                                    </label>\n                                                </div>\n                                            </div>                                           \n                                        </div>\n                                    </div>\n                                </div>  \n                                <div class=\"panel panel-default\" ng-class=\"{ 'hidden': !$ctrl.hasPositionTaking('WIC') }\">\n                                    <div class=\"panel-heading\">\n                                        <h4 class=\"panel-title\">\n                                            <a data-toggle=\"collapse\" ng-click=\"$ctrl.toggleTab('WIC')\" href=\"\" class=\"collapsed\" aria-expanded=\"false\">\n                                                {{ '9WICKETS FORCED POSITION TAKING ON ASIANCONNECT' | translate }}\n                                            </a>\n                                        </h4>\n                                    </div>\n                                    <div id=\"WIC-pt\" class=\"panel-collapse collapse in\" aria-expanded=\"false\">\n                                        <div class=\"panel-body\">\n\n                                            <p>{{ 'Please note that 9wickets have 3% commission rate applied to your winnings.' | translate }}</p>\n\n                                            <p>{{ 'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.' | translate }}</p>\n\n                                            <div class=\"accept-tc\">\n                                                <div class=\"checkbox checkbox-success\">\n                                                    <input ng-model=\"$ctrl.form.requestProducts['WIC'].isAgree\" ng-click=\"$ctrl.toggleTab('WIC')\" id=\"accept-terms3\" type=\"checkbox\">\n                                                    <label for=\"accept-terms3\">\n                                                        {{ 'I agree to the Terms and Conditions' | translate }}\n                                                    </label>\n                                                </div>\n                                            </div>                                           \n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"panel panel-default\" ng-class=\"{ 'hidden': !$ctrl.hasPositionTaking('ORB') }\">\n                                    <div class=\"panel-heading\">\n                                        <h4 class=\"panel-title\">\n                                            <a data-toggle=\"collapse\" ng-click=\"$ctrl.toggleTab('ORB')\" href=\"\" class=\"collapsed\" aria-expanded=\"false\">\n                                                {{ 'ORBITX FORCED POSITION TAKING ON ASIANCONNECT' | translate }}\n                                            </a>\n                                        </h4>\n                                    </div>\n                                    <div id=\"ORB-pt\" class=\"panel-collapse collapse in\" aria-expanded=\"false\">\n                                        <div class=\"panel-body\">\n\n                                            <p>{{ 'Please note that OrbitX have 3% commission rate applied to your winnings.' | translate }}</p>\n\n                                            <p>{{ 'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.' | translate }}</p>\n                                            <div class=\"accept-tc\">\n                                                <div class=\"checkbox checkbox-success\">\n                                                    <input ng-model=\"$ctrl.form.requestProducts['ORB'].isAgree\" ng-click=\"$ctrl.toggleTab('ORB')\" id=\"accept-terms3\" type=\"checkbox\">\n                                                    <label for=\"accept-terms3\">\n                                                        {{ 'I agree to the Terms and Conditions' | translate }}\n                                                    </label>\n                                                </div>\n                                            </div>                                           \n                                        </div>\n                                    </div>\n                                </div>   \n                                <div class=\"panel panel-default\" ng-class=\"{ 'hidden': !$ctrl.hasPositionTaking('SKY') }\">\n                                    <div class=\"panel-heading\">\n                                        <h4 class=\"panel-title\">\n                                            <a data-toggle=\"collapse\" ng-click=\"$ctrl.toggleTab('SKY')\" href=\"\" class=\"collapsed\" aria-expanded=\"false\">\n                                               {{ 'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT' | translate }}\n                                            </a>\n                                        </h4>\n                                    </div>\n                                    <div id=\"SKY-pt\" class=\"panel-collapse collapse in\" aria-expanded=\"false\">\n                                        <div class=\"panel-body\">\n                                            <p>{{ 'You can contact us via Skype at' | translate }} <a href=\"#\">Asianconnect888</a> {{ 'NV for Skype betting Terms and Conditions.' | translate }}</p>\n                                        </div>\n                                    </div>\n                                </div>                                \n                                <div class=\"panel panel-default\" ng-class=\"{ 'hidden': !$ctrl.hasPositionTaking('MTB') }\">\n                                    <div class=\"panel-heading\">\n                                        <h4 class=\"panel-title\">\n                                            <a data-toggle=\"collapse\" ng-click=\"$ctrl.toggleTab('MTB')\" href=\"\" class=\"collapsed\" aria-expanded=\"false\">\n                                               MATCHBOOK TERMS AND CONDITONS ON ASIANCONNECT\n                                            </a>\n                                        </h4>\n                                    </div>\n                                    <div id=\"MTB-pt\" class=\"panel-collapse collapse in\" aria-expanded=\"false\">\n                                        <div class=\"panel-body\">\n                                            <p>There will be a 1.25% commission for each bet you place.\n                                              This will be applied to the Win amount on winning bets.\n                                              For losing bets, it will be applied to the lesser of the stake or potential in amount.\n                                              There will be no commission charged for voided bets.</p>\n\n                                            <div class=\"accept-tc\">\n                                              <div class=\"checkbox checkbox-success\">\n                                                  <input ng-model=\"$ctrl.form.requestProducts['MTB'].isAgree\" ng-click=\"$ctrl.toggleTab('MTB')\" id=\"accept-terms4\" type=\"checkbox\">\n                                                  <label for=\"accept-terms4\">\n                                                      I agree to the Terms and Conditions\n                                                  </label>\n                                              </div>\n                                          </div>\n                                        </div>\n                                    </div>\n                                </div>                                \n                            </div>\n\n                        </div>\n                    </div>\n                </div>\n                <div class=\"clearfix\"></div>\n            </div>\n\n            <!-- footer -->\n            <div class=\"modal-footer\">\n                <!-- modal button -->\n                <button type=\"button\" class=\"btn btn-success waves-effect waves-light\" id=\"_btnSubmit\" ng-disabled=\"$ctrl.isDisabled\" ng-click=\"$ctrl.submit()\">{{ 'Request' | translate }}</button>\n                <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" ng-click=\"$ctrl.close()\">{{ 'Close' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<request-product-success-modal modal=\"$ctrl.requestProductSuccessModal\"></request-product-success-modal>\n\n<!-- additional js -->\n<script type=\"text/javascript\">\n    $(window).resize(function () {\n        var viewportWidth = $(window).width();\n        if (viewportWidth < 350) {\n            $( \".col-product\" ).removeClass( \"col-xs-4\" ).addClass( \"col-xs-6\" );\n        } else {\n            $( \".col-product\" ).removeClass( \"col-xs-6\" ).addClass( \"col-xs-4\" );\n        }\n    });\n</script>\n\n<!-- custom css -->\n<style>\n    .product-wrapper .ng-scope img {\n        cursor: pointer;\n    }\n    .red-border {\n        border: 1px #c1272d solid;\n    }\n</style>"

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(995);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(1044);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _promise = __webpack_require__(1100);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formModel = __webpack_require__(1120);
	
	var _formModel2 = _interopRequireDefault(_formModel);
	
	var _successModal = __webpack_require__(1124);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _modal = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POSITION_TAKING_PRODUCT_CODES = ['SIN', 'MXB', 'SBO', 'ORB', 'WIC', 'MTB'];
	var MEMBER_PRODUCT_REQUEST_STORAGE_KEY = 'requested_products';
	
	var RequestProductController = function () {
	    RequestProductController.$inject = ["ProductApiService", "CustomerApiService", "StorageService", "MemberProductApiService", "AppService", "$timeout"];
	    function RequestProductController(ProductApiService, CustomerApiService, StorageService, MemberProductApiService, AppService, $timeout) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, RequestProductController);
	        this.unrequestedProducts = {};
	        this.requestedProducts = {};
	        this.products = null;
	        this.memberProducts = null;
	        this.isDisabled = true;
	        this.hasUnrequestedProducts = null;
	        this.hasAgreement = false;
	
	        this.$timeout = $timeout;
	        this.StorageService = StorageService;
	        this.ProductApiService = ProductApiService;
	        this.CustomerApiService = CustomerApiService;
	        this.MemberProductApiService = MemberProductApiService;
	        this.AppService = AppService;
	    }
	
	    (0, _createClass3.default)(RequestProductController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.requestProductSuccessModal = new _successModal2.default();
	            this.form = new _formModel2.default();
	
	            this.getUnrequestedProducts();
	        }
	    }, {
	        key: 'getUnrequestedProducts',
	        value: function getUnrequestedProducts() {
	            var _this = this;
	
	            var productsPromise = this.ProductApiService.getProducts();
	            var memberProductsPromise = this.CustomerApiService.getCustomerProducts();
	
	            _promise2.default.all([productsPromise, memberProductsPromise]).then(function (values) {
	                _this.unrequestedProducts = {};
	                _this.products = values[0];
	                _this.memberProducts = values[1];
	
	                angular.forEach(_this.products, function (product) {
	                    var found = false;
	
	                    angular.forEach(_this.memberProducts, function (memberProduct) {
	                        if (product.code == memberProduct.product.code) {
	                            found = true;
	                        }
	                    });
	
	                    if (!found && product.can_be_requested) {
	                        _this.unrequestedProducts[product.code] = product;
	                    }
	                });
	
	                _this.checkUnrequestedProducts();
	            });
	        }
	    }, {
	        key: 'hasPositionTaking',
	        value: function hasPositionTaking(code) {
	            if (!angular.isUndefined(this.form.getRequestProduct(code))) {
	                return this.form.getRequestProduct(code).isSelected;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'toggleTab',
	        value: function toggleTab(code) {
	            var _this2 = this;
	
	            this.$timeout(function () {
	                if (POSITION_TAKING_PRODUCT_CODES.includes(code)) {
	                    $('#' + code + '-pt').collapse('show');
	
	                    if (!angular.isUndefined(_this2.form.getRequestProduct(code))) {
	                        if (_this2.form.getRequestProduct(code).isAgree) {
	                            $('#' + code + '-pt').collapse('hide');
	                        }
	                    }
	                }
	
	                angular.forEach(POSITION_TAKING_PRODUCT_CODES, function (ptCode) {
	                    if (!angular.isUndefined(_this2.form.getRequestProduct(ptCode))) {
	                        if (!_this2.form.getRequestProduct(ptCode).isAgree) {
	                            $('#' + ptCode + '-pt').collapse('show');
	                        } else {
	                            $('#' + ptCode + '-pt').collapse('hide');
	                        }
	                    }
	                });
	            }, 100);
	
	            this.toggleSubmitButton();
	        }
	    }, {
	        key: 'toggleSubmitButton',
	        value: function toggleSubmitButton() {
	            var _this3 = this;
	
	            this.$timeout(function () {
	                _this3.hasAgreement = false;
	                _this3.isDisabled = true;
	                var productCount = 0;
	                var hasEmptyUsername = false;
	                var hasAgreed = true;
	
	                angular.forEach(POSITION_TAKING_PRODUCT_CODES, function (code) {
	                    if (_this3.hasPositionTaking(code)) {
	                        _this3.hasAgreement = true;
	                    }
	                });
	
	                angular.forEach(_this3.form.getRequestProducts(), function (requestProduct, code) {
	                    if (angular.isDefined(_this3.unrequestedProducts[code])) {
	                        if (requestProduct.isSelected) {
	                            productCount += 1;
	
	                            if (_this3.unrequestedProducts[code].has_username && !hasEmptyUsername && (angular.isUndefined(requestProduct.username) || requestProduct.username.length == 0)) {
	                                hasEmptyUsername = true;
	                            }
	
	                            if (_this3.hasAgreement && POSITION_TAKING_PRODUCT_CODES.includes(code) && !requestProduct.isAgree) {
	                                hasAgreed = false;
	                            }
	                        } else {
	                            if (POSITION_TAKING_PRODUCT_CODES.includes(code)) {
	                                requestProduct.isAgree = false;
	                            }
	                        }
	                    }
	                });
	
	                if (productCount > 0) {
	                    _this3.isDisabled = false;
	
	                    if (hasEmptyUsername) {
	                        _this3.isDisabled = true;
	                    }
	
	                    if (_this3.hasAgreement && !hasAgreed) {
	                        _this3.isDisabled = true;
	                    }
	                }
	            }, 100);
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            this.form.setRequestProducts({});
	            this.form.setFormErrors([]);
	            this.isDisabled = true;
	            this.hasAgreement = false;
	        }
	    }, {
	        key: 'checkUnrequestedProducts',
	        value: function checkUnrequestedProducts() {
	            if ((0, _keys2.default)(this.unrequestedProducts).length > 0) {
	                this.hasUnrequestedProducts = true;
	            } else {
	                this.hasUnrequestedProducts = false;
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var _this4 = this;
	
	            this.MemberProductApiService.request(this.form.toPayload()).then(function (response) {
	                _this4.getRequestedProducts(response);
	                _this4.requestProductSuccessModal.requestedProducts = response;
	                _this4.StorageService.setItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY, (0, _stringify2.default)(_this4.requestedProducts));
	                _this4.removeUnrequestedProducts();
	                _this4.AppService.broadcast('reload.member-product-list');
	                $('#requestProductModal').modal('hide');
	                _this4.reset();
	
	                (0, _modal.showModal)('requestProductSuccessModal');
	            }).catch(function (errors) {
	                _this4.form.setFormErrors(errors);
	
	                if (_this4.StorageService.hasItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY)) {
	                    _this4.requestedProducts = JSON.parse(_this4.StorageService.getItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY));
	                    _this4.removeUnrequestedProducts();
	                }
	
	                _this4.toggleSubmitButton();
	            });
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.reset();
	        }
	    }, {
	        key: 'removeUnrequestedProducts',
	        value: function removeUnrequestedProducts() {
	            var _this5 = this;
	
	            angular.forEach(this.requestedProducts, function (productCode) {
	                if (angular.isDefined(_this5.unrequestedProducts[productCode])) {
	                    delete _this5.unrequestedProducts[productCode];
	
	                    if (angular.isDefined(_this5.form.requestProducts[productCode])) {
	                        delete _this5.form.requestProducts[productCode];
	                    }
	                }
	            });
	
	            this.checkUnrequestedProducts();
	        }
	    }, {
	        key: 'getRequestedProducts',
	        value: function getRequestedProducts(memberProducts) {
	            var _this6 = this;
	
	            if (this.StorageService.hasItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY)) {
	                this.requestedProducts = JSON.parse(this.StorageService.getItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY));
	            }
	
	            angular.forEach(memberProducts, function (memberProduct) {
	                _this6.requestedProducts[memberProduct.id] = memberProduct.product.code;
	            });
	        }
	    }]);
	    return RequestProductController;
	}();
	
	exports.default = RequestProductController;

/***/ }),
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1121);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestProductFormModel = function () {
	    function RequestProductFormModel() {
	        (0, _classCallCheck3.default)(this, RequestProductFormModel);
	
	        this.requestProducts = {};
	
	        this.error = new _formError2.default();
	    }
	
	    (0, _createClass3.default)(RequestProductFormModel, [{
	        key: 'getRequestProducts',
	        value: function getRequestProducts() {
	            return this.requestProducts;
	        }
	    }, {
	        key: 'setRequestProducts',
	        value: function setRequestProducts(requestProducts) {
	            this.requestProducts = requestProducts;
	        }
	    }, {
	        key: 'getRequestProduct',
	        value: function getRequestProduct(code) {
	            return this.requestProducts[code];
	        }
	    }, {
	        key: 'setFormErrors',
	        value: function setFormErrors(errors) {
	            this.error.setFormErrors(errors);
	        }
	    }, {
	        key: 'toPayload',
	        value: function toPayload() {
	            var payload = {
	                memberProductList: {
	                    memberProducts: {}
	                }
	            };
	
	            angular.forEach(this.requestProducts, function (requestProduct, code) {
	                if (requestProduct.isSelected) {
	                    payload.memberProductList.memberProducts[code] = {
	                        product: code,
	                        username: requestProduct.username,
	                        isAgree: requestProduct.isAgree
	                    };
	                }
	            });
	
	            return payload;
	        }
	    }]);
	    return RequestProductFormModel;
	}();
	
	exports.default = RequestProductFormModel;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormErrorModel = function () {
	    function FormErrorModel() {
	        (0, _classCallCheck3.default)(this, FormErrorModel);
	
	        this.flattenedErrors = {
	            memberProducts: {},
	            parent: {}
	        };
	    }
	
	    (0, _createClass3.default)(FormErrorModel, [{
	        key: 'setFormErrors',
	        value: function setFormErrors(errors) {
	            this.flattenErrors(errors);
	        }
	    }, {
	        key: 'flattenErrors',
	        value: function flattenErrors(errors) {
	            this.flattenedErrors.parent = (0, _lodash.get)(errors, 'errors');
	            this.flattenedErrors.memberProducts = (0, _lodash.get)(errors, 'children.memberProducts.children');
	        }
	    }, {
	        key: 'memberProducts',
	        get: function get() {
	            return this.flattenedErrors['memberProducts'];
	        }
	    }, {
	        key: 'parent',
	        get: function get() {
	            return this.flattenedErrors['parent'];
	        }
	    }]);
	    return FormErrorModel;
	}();
	
	exports.default = FormErrorModel;

/***/ }),
/* 1122 */,
/* 1123 */,
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestProductSuccessModalModel = function RequestProductSuccessModalModel() {
	    (0, _classCallCheck3.default)(this, RequestProductSuccessModalModel);
	
	    this.requestedProducts = {};
	};
	
	;
	
	exports.default = RequestProductSuccessModalModel;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _successModal = __webpack_require__(1126);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _successModal3 = __webpack_require__(1127);
	
	var _successModal4 = _interopRequireDefault(_successModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestProductModalComponent = {
	    bindings: {
	        modal: '<'
	    },
	    template: _successModal2.default,
	    controller: _successModal4.default
	};
	
	exports.default = requestProductModalComponent;

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"requestProductSuccessModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n    <div class=\"icon success animate\">\n        <span class=\"line tip animateSuccessTip\"></span>\n        <span class=\"line long animateSuccessLong\"></span>\n        <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n    </div>\n    <h3>{{ 'Successfully added!' | translate }}</h3>\n    <p class=\"lead text-muted\">\n        <ul>\n            <li ng-repeat=\"requestedProduct in $ctrl.modal.requestedProducts\">{{ requestedProduct.product.name }}</li>\n        </ul>\n        <br/>\n        {{ 'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.' | translate }}\n    </p>\n    <p>\n        <button ng-click=\"$ctrl.redirect()\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'Deposit Now' | translate }}</button>\n        <button ng-click=\"$ctrl.close()\" type=\"button\" class=\"btn waves-effect waves-light\">{{ 'Close' | translate }}</button>\n    </p>\n</div>"

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _modal = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestProductSuccessModalController = function () {
	    RequestProductSuccessModalController.$inject = ["$state"];
	    function RequestProductSuccessModalController($state) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, RequestProductSuccessModalController);
	        this.$state = $state;
	    }
	
	    (0, _createClass3.default)(RequestProductSuccessModalController, [{
	        key: 'redirect',
	        value: function redirect() {
	            (0, _modal.hideModal)('requestProductSuccessModal');
	
	            if (this.$state.current.name !== 'deposit') {
	                this.$state.go('deposit');
	            }
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            (0, _modal.hideModal)('requestProductSuccessModal');
	        }
	    }]);
	    return RequestProductSuccessModalController;
	}();
	
	exports.default = RequestProductSuccessModalController;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _settingsModalComponent = __webpack_require__(1129);
	
	var _settingsModalComponent2 = _interopRequireDefault(_settingsModalComponent);
	
	var _settingsModal = __webpack_require__(1130);
	
	var _settingsModal2 = _interopRequireDefault(_settingsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settingsComponent = {
	  bindings: {},
	  template: _settingsModalComponent2.default,
	  controller: _settingsModal2.default
	};
	
	exports.default = settingsComponent;

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"settingsModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\" style=\"display: none;\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n        <h4 class=\"modal-title\">Change Security Setting</h4>\n      </div>\n      <div class=\"modal-body\">\n        <div class=\"select-login form-inline \">\n          <h5 class=\"m-t-0\"><b>Select Log-in credential</b></h5>\n          <div class=\"m-t-20\">\n            <ul class=\"sc-setting p-l-0 text-center\">\n              <li class=\"m-r-30\">\n                <div class=\"radio radio-success radio-inline\">\n                  <input type=\"radio\" ng-model=\"$ctrl.form.type\" value=\"username\" id =\"radio1\">\n                  <label for=\"radio1\"> Username </label>\n                </div>\n              </li>\n              <li class=\"m-0\">\n                <div class=\"radio radio-success radio-inline\">\n                  <input type=\"radio\" ng-model=\"$ctrl.form.type\" value=\"password\" id =\"radio2\"> \n                  <label for=\"radio2\"> Password </label>\n                </div>\n              </li>\n              <li class=\"hidden\"> \n                <div class=\"radio radio-success radio-inline\">\n                    <input type=\"radio\" ng-model=\"$ctrl.form.type\" value=\"transaction\" id =\"radio3\"> \n                    <label for=\"radio3\"> Transaction Password </label>\n                </div>\n              </li>\n            </ul>\n          </div>\n        </div>\n        <div class =\"m-t-20\">\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <div ng-if=\"$ctrl.form.isUsername\" class=\"form-group\">\n                <h4 class=\"m-t-0\"><b>Change Username</b></h4>\n                <div class=\"form-group sc-credentials\">\n                    <div class=\"col-md-12\">\n                      <input ng-model=\"$ctrl.form.currentPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.currentPassword }\" type=\"password\" class=\"form-control\" placeholder=\"Enter current password\">\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.currentPassword\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.currentPassword\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </div>\n                    <div class=\"col-md-12\">\n                      <input ng-model=\"$ctrl.form.newUsername\" ng-class=\"{ 'parsley-error': $ctrl.form.error.currentPassword }\" type=\"text\" class=\"form-control\" placeholder=\"Enter new username\">\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.newUsername\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.newUsername\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </div>\n                    <div class=\"col-md-12\">\n                      <input ng-model=\"$ctrl.form.confirmNewUsername\" type=\"text\" class=\"form-control\" placeholder=\"Confirm new username\">\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.confirmNewUsername\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.confirmNewUsername\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </div>\n                </div>\n              </div>\n              <div ng-if=\"$ctrl.form.isPassword\" class=\"form-group\">\n                <h4 class=\"m-t-0\"><b>Change Password</b></h4>\n                <div class=\"form-group sc-credentials\">\n                  <div class=\"col-md-12\">\n                    <input ng-model=\"$ctrl.form.currentPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.currentPassword }\" type=\"password\" class=\"form-control\" placeholder=\"Enter current password\">\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.currentPassword\">\n                      <li ng-repeat=\"(key, error) in $ctrl.form.error.currentPassword\" class=\"parsley-required\">{{ error }}</li>\n                    </ul>\n                  </div>\n                  <div class=\"col-md-12\">\n                    <input ng-model=\"$ctrl.form.newPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.newPassword }\" type=\"password\" class=\"form-control\" placeholder=\"Enter new password\">\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.newPassword\">\n                      <li ng-repeat=\"(key, error) in $ctrl.form.error.newPassword\" class=\"parsley-required\">{{ error }}</li>\n                    </ul>\n                  </div>\n                  <div class=\"col-md-12\">\n                    <input ng-model=\"$ctrl.form.confirmNewPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.confirmNewPassword }\" type=\"password\" class=\"form-control\" placeholder=\"Confirm new password\">\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.confirmNewPassword\">\n                      <li ng-repeat=\"(key, error) in $ctrl.form.error.confirmNewPassword\" class=\"parsley-required\">{{ error }}</li>\n                    </ul>\n                  </div>\n                </div>\n             </div>\n            <div ng-if=\"$ctrl.form.isTransaction\" class=\"form-group\">\n              <h4 class=\"m-t-0\"><b>Change Transaction password</b></h4>\n              <div class=\"form-group sc-credentials\">\n                <div class=\"col-md-12\">\n                    <input type=\"password\" class=\"form-control\" placeholder=\"Enter current transaction password\">\n                  <!-- <input ng-model=\"$ctrl.form.currentPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.currentPassword }\" type=\"password\" class=\"form-control\" placeholder=\"Enter current password\">\n                  <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.currentPassword\">\n                    <li ng-repeat=\"(key, error) in $ctrl.form.error.currentPassword\" class=\"parsley-required\">{{ error }}</li>\n                  </ul> -->\n                </div>\n                <div class=\"col-md-12\">\n                    <input type=\"password\" class=\"form-control\" placeholder=\"Enter new transaction password\">\n                  <!-- <input ng-model=\"$ctrl.form.newPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.newPassword }\" type=\"password\" class=\"form-control\" placeholder=\"Enter new password\">\n                  <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.newPassword\">\n                    <li ng-repeat=\"(key, error) in $ctrl.form.error.newPassword\" class=\"parsley-required\">{{ error }}</li>\n                  </ul> -->\n                </div>\n                <div class=\"col-md-12\">\n                    <input type=\"password\" class=\"form-control\" placeholder=\"Confirm new transaction password\">\n                  <!-- <input ng-model=\"$ctrl.form.confirmNewPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.confirmNewPassword }\" type=\"password\" class=\"form-control\" placeholder=\"Confirm new password\">\n                  <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.confirmNewPassword\">\n                    <li ng-repeat=\"(key, error) in $ctrl.form.error.confirmNewPassword\" class=\"parsley-required\">{{ error }}</li>\n                  </ul> -->\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button ng-click=\"$ctrl.submit()\" type=\"button\" class=\"btn btn-info waves-effect waves-light\">Save changes</button>\n        <button type=\"button\" class=\"btn btn-default waves-effect\" data-dismiss=\"modal\">Close</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formModel = __webpack_require__(1131);
	
	var _formModel2 = _interopRequireDefault(_formModel);
	
	var _toastr = __webpack_require__(1133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsController = function () {
	  SettingsController.$inject = ["SecurityApiService"];
	  function SettingsController(SecurityApiService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SettingsController);
	    this.SecurityApiService = SecurityApiService;
	  }
	
	  (0, _createClass3.default)(SettingsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _formModel2.default();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      this.SecurityApiService.saveCredentials(this.form.toPayload()).then(function () {
	        $('#settingsModal').modal('hide');
	        (0, _toastr.success)('Credentials has been successfully updated!');
	        _this.form.reset();
	      }).catch(function (errors) {
	        _this.form.setFormErrors(errors);
	      });
	    }
	  }]);
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1132);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsFormModel = function () {
	  function SettingsFormModel() {
	    (0, _classCallCheck3.default)(this, SettingsFormModel);
	
	    // values can be username and password only.
	    this.type = 'username';
	
	    this.newUsername = '';
	    this.confirmNewUsername = '';
	
	    this.newPassword = '';
	    this.confirmNewPassword = '';
	
	    this.currentPassword = '';
	
	    this.error = new _formError2.default();
	  }
	
	  (0, _createClass3.default)(SettingsFormModel, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.error.setFormErrors(errors);
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        security: {
	          currentPassword: this.currentPassword
	        }
	      };
	
	      if (this.isUsername) {
	        payload['security']['hasChangeUsername'] = true;
	        payload['security']['username'] = {};
	        payload['security']['username']['first'] = this.newUsername;
	        payload['security']['username']['second'] = this.confirmNewUsername;
	      } else {
	        payload['security']['hasChangePassword'] = true;
	        payload['security']['password'] = {};
	        payload['security']['password']['first'] = this.newPassword;
	        payload['security']['password']['second'] = this.confirmNewPassword;
	      }
	
	      return payload;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.type = 'username';
	
	      this.newUsername = '';
	      this.confirmNewUsername = '';
	
	      this.newPassword = '';
	      this.confirmNewPassword = '';
	
	      this.currentPassword = '';
	    }
	  }, {
	    key: 'isUsername',
	    get: function get() {
	      return this.type === 'username';
	    }
	  }, {
	    key: 'isPassword',
	    get: function get() {
	      return this.type === 'password';
	    }
	  }, {
	    key: 'isTransaction',
	    get: function get() {
	      return this.type === 'transaction';
	    }
	  }]);
	  return SettingsFormModel;
	}();
	
	exports.default = SettingsFormModel;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormErrorModel = function () {
	  function FormErrorModel() {
	    (0, _classCallCheck3.default)(this, FormErrorModel);
	
	    this.flattenedErrors = {
	      currentPassword: null,
	      newUsername: null,
	      newPassword: null
	    };
	  }
	
	  (0, _createClass3.default)(FormErrorModel, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.flattenErrors(errors);
	    }
	  }, {
	    key: 'flattenErrors',
	    value: function flattenErrors(errors) {
	      this.flattenedErrors.currentPassword = (0, _lodash.get)(errors, 'children.currentPassword.errors');
	      this.flattenedErrors.newUsername = (0, _lodash.get)(errors, 'children.username.children.first.errors');
	      this.flattenedErrors.newPassword = (0, _lodash.get)(errors, 'children.password.children.first.errors');
	    }
	  }, {
	    key: 'currentPassword',
	    get: function get() {
	      return this.flattenedErrors['currentPassword'];
	    }
	  }, {
	    key: 'newUsername',
	    get: function get() {
	      return this.flattenedErrors['newUsername'];
	    }
	  }, {
	    key: 'newPassword',
	    get: function get() {
	      return this.flattenedErrors['newPassword'];
	    }
	  }]);
	  return FormErrorModel;
	}();
	
	exports.default = FormErrorModel;

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.success = success;
	exports.info = info;
	exports.warning = warning;
	exports.error = error;
	function success(title, message) {
	  toastr.success(message, title);
	}
	
	function info(title, message) {
	  toastr.info(message, title);
	}
	
	function warning(title, message) {
	  toastr.warning(message, title);
	}
	
	function error(title, message) {
	  toastr.error(message, title);
	}

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _linkBankWidget = __webpack_require__(1135);
	
	var _linkBankWidget2 = _interopRequireDefault(_linkBankWidget);
	
	var _linkBankWidget3 = __webpack_require__(1136);
	
	var _linkBankWidget4 = _interopRequireDefault(_linkBankWidget3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkBankWidgetComponent = {
	  bindings: {
	    form: '<',
	    onSubmit: '&',
	    formData: '<'
	  },
	  template: _linkBankWidget2.default,
	  controller: _linkBankWidget4.default
	};
	
	exports.default = linkBankWidgetComponent;

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"bankAccountModal\" class=\"modal fade in\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"\n  data-backdrop=\"static\" data-keyboard=\"false\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <form role=\"form\" id=\"bankDetailsForm\">\n        <div class=\"modal-header\">\n          <button type=\"button\" class=\"close\" ng-click=\"$ctrl.onCloseForm()\" aria-hidden=\"true\">×</button>\n          <h4 class=\"modal-title\">{{ 'Link a bank account' | translate }}</h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col col-sm-6\">\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.iban' | translate }} *</label>\n                <input ng-model=\"$ctrl.form.beneficiaryAccount\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'Enter Account Number' | translate }}\">\n                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.accountId\">\n                  <li ng-repeat=\"(key, error) in $ctrl.error.accountId\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.accountName' | translate }} *</label>\n                <input ng-model=\"$ctrl.form.beneficiaryAccountName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'Enter Account Name' | translate }}\">\n                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.accountName\">\n                  <li ng-repeat=\"(key, error) in $ctrl.error.accountName\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.birthDate' | translate }} *</label>\n                <date-picker ng-model=\"$ctrl.form.dateOfBirth\" date-format=\"'yyyy-mm-dd'\"></date-picker>\n                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.birthDate\">\n                  <li ng-repeat=\"(key, error) in $ctrl.error.birthDate\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.citizenship' | translate }} *</label>\n                <input ng-model=\"$ctrl.form.citizenship\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'Enter Citizenship' | translate }}\">\n                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.citizenship\">\n                  <li ng-repeat=\"(key, error) in $ctrl.error.citizenship\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.address' | translate }} *</label>\n                <input ng-model=\"$ctrl.form.beneficiaryAddress\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'Enter Address' | translate }}\">\n                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.accountAddress\">\n                  <li ng-repeat=\"(key, error) in $ctrl.error.accountAddress\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n            </div>\n            <div class=\"col col-sm-6\">\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.swift' | translate }} *</label>\n                <input ng-model=\"$ctrl.form.beneficiaryCode\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'Enter Bank Code' | translate }}\">\n                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.bankCode\">\n                  <li ng-repeat=\"(key, error) in $ctrl.error.bankCode\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.bankName' | translate }} *</label>\n                <input ng-model=\"$ctrl.form.beneficiaryBank\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'Enter Bank Name' | translate }}\">\n                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.bankName\">\n                  <li ng-repeat=\"(key, error) in $ctrl.error.bankName\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.bankAddress' | translate }} *</label>\n                <input ng-model=\"$ctrl.form.bankAddress\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'Enter Bank Address' | translate }}\">\n                <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.bankAddress\">\n                  <li ng-repeat=\"(key, error) in $ctrl.error.bankAddress\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"control-label\">{{ 'form.isDefault' | translate }}</label><br>\n                <switchery ng-model=\"$ctrl.form.isDefault\" set-default-value=\"$ctrl.form.isDefault\" set-name=\"'default'\"></switchery>\n              </div>\n              <div class=\"form-group\" ng-if=\"$ctrl.isWithdrawal()\">\n                <label class=\"control-label\">{{ 'Save bank account' | translate }}</label><br>\n                <switchery ng-model=\"$ctrl.form.saveBankAccount\" set-default-value=\"$ctrl.form.saveBankAccount\"\n                  set-name=\"'save'\"></switchery>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <div class=\"pull-right\">\n            <button ng-hide=\"$ctrl.form.props.isReadOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-gray ladda-button\"\n              data-style=\"expand-right\"><span class=\"ladda-label\">{{ 'Clear All' | translate }}</span><span class=\"ladda-spinner\"></span>\n              <div class=\"ladda-progress\" style=\"width: 0px;\"></div>\n            </button>\n          </div>\n          <div class=\"link-bank-button pull-right\">\n            <ladda-button ng-hide=\"$ctrl.form.props.isReadOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Save'\"></ladda-button>\n          </div>\n          <br>\n          <div ng-if=\"!$ctrl.error.hasError\" class=\"alert alert-success text-center\" style=\"margin-top: 20px;\">\n            <strong>{{ $ctrl.form.successMessage.title | translate }}!</strong> {{ $ctrl.form.successMessage.body | translate }}\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n\n<div ng-if=\"$ctrl.error.formError\" id=\"warningModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\"\n  data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\"\n  data-timer=\"null\" style=\"border: 1px solid #bdbdbd;\">\n  <div class=\"icon info\"></div>\n  <h3>{{ 'Limit Reached!' | translate }}</h3>\n  <p class=\"lead text-muted\">\n    {{ $ctrl.error.formError }}\n  </p>\n  <p>\n    <button ng-if=\"$ctrl.isWithdrawal()\" ng-click=\"$ctrl.goToSettings()\" data-dismiss=\"modal\" class=\"btn btn-warning waves-effect waves-light\">{{ 'Go to Settings' | translate }}</button>\n    <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-danger waves-effect waves-light\">{{ 'Close' | translate }}</button>\n  </p>\n</div>"

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LinkBank = undefined;
	
	var _stringify = __webpack_require__(995);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _form = __webpack_require__(1137);
	
	var _formError = __webpack_require__(1139);
	
	var _payload = __webpack_require__(1138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAGE_WITHDRAWAL = 'withdrawal';
	var ACTION_CREATE = 'CREATE';
	var ACTION_UPDATE = 'UPDATE';
	
	var LinkBank = exports.LinkBank = function () {
	  LinkBank.$inject = ["FormService", "PaymentOptionApiService", "PageService", "AppService", "StorageService", "$state", "$timeout", "$scope"];
	  function LinkBank(FormService, PaymentOptionApiService, PageService, AppService, StorageService, $state, $timeout, $scope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, LinkBank);
	    this.FormService = FormService;
	    this.PaymentOptionApiService = PaymentOptionApiService;
	    this.PageService = PageService;
	    this.AppService = AppService;
	    this.StorageService = StorageService;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	
	    this.$scope.$on('reload.bank-details', function () {
	      _this.editBankAccountDetails(_this.formData);
	    });
	
	    this.$scope.$on('reload.off-default', function () {
	      _this.offDefaultSaving();
	    });
	  }
	
	  (0, _createClass3.default)(LinkBank, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form.RequestLinkBankForm();
	      this.error = new _formError.LinkBankFormErrorModel();
	      this.getMemberDetails();
	    }
	  }, {
	    key: 'getMemberDetails',
	    value: function getMemberDetails() {
	      var memberDetails = JSON.parse(this.StorageService.getItem('member_details'));
	      this.form.dateOfBirth = (0, _payload.toApiAcceptedDateFormat)(memberDetails.birth_date);
	      this.form.citizenship = memberDetails.country;
	    }
	  }, {
	    key: 'editBankAccountDetails',
	    value: function editBankAccountDetails(resp) {
	      var _this2 = this;
	
	      this.form.action = ACTION_UPDATE;
	      this.error.hasError = true;
	      this.form.bankPaymentOption = resp.id;
	      this.form.isDefault = resp.fields.is_default;
	      this.form.beneficiaryAccount = resp.fields.account_id;
	      this.form.beneficiaryAccountName = resp.fields.account_name;
	      this.form.beneficiaryAddress = resp.fields.account_address;
	      this.form.dateOfBirth = resp.fields.birth_date;
	      this.form.citizenship = resp.fields.citizenship;
	      this.form.beneficiaryCode = resp.fields.swift_code;
	      this.form.bankAddress = resp.fields.bank_address;
	      this.form.beneficiaryBank = resp.fields.bank_name;
	      this.$timeout(function () {
	        _this2.AppService.broadcast('reload.switchery');
	        _this2.PageService.showModal('bankAccountModal');
	      }, 200);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      if (this.form.action === ACTION_CREATE) {
	        this.createBank();
	      } else if (this.form.action === ACTION_UPDATE) {
	        this.updateBank();
	      }
	    }
	  }, {
	    key: 'createBank',
	    value: function createBank() {
	      var _this3 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.PaymentOptionApiService.linkBankAccountRequest(this.form.toPayload()).then(function (resp) {
	        _this3.error.hasError = false;
	        _this3.FormService.isSubmitting.next(false);
	        if (resp.fields.is_default) {
	          _this3.AppService.broadcast('reload.member-payment-option');
	        } else {
	          _this3.appendBankAccountToList(resp);
	        }
	        _this3.$timeout(function () {
	          $('#bankAccountModal').modal('hide');
	          _this3.resetForm();
	          _this3.error.hasError = true;
	        }, 2000);
	      }).catch(function (errors) {
	        _this3.error.hasError = true;
	        _this3.FormService.isSubmitting.next(false);
	        if (errors.errors) {
	          _this3.error.formError = errors.errors[0];
	          _this3.$timeout(function () {
	            _this3.PageService.showModal('warningModal');
	          }, 500);
	        }
	        _this3.error.setFormErrors(errors);
	      });
	    }
	  }, {
	    key: 'updateBank',
	    value: function updateBank() {
	      var _this4 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.PaymentOptionApiService.updateBankAccountRequest(this.form.toUpdatePayload()).then(function (resp) {
	        _this4.error.hasError = false;
	        _this4.FormService.isSubmitting.next(false);
	        _this4.form.successMessage.body = 'Bank account successfully updated.';
	        _this4.$timeout(function () {
	          $('#bankAccountModal').modal('hide');
	          _this4.resetForm();
	          _this4.AppService.broadcast('reload.member-payment-option');
	          _this4.error.hasError = true;
	        }, 1000);
	      }).catch(function (errors) {
	        _this4.error.hasError = true;
	        _this4.FormService.isSubmitting.next(false);
	        if (errors.errors) {
	          _this4.error.formError = errors.errors[0];
	          _this4.$timeout(function () {
	            _this4.PageService.showModal('warningModal');
	          }, 500);
	        }
	        _this4.error.setFormErrors(errors);
	      });
	    }
	  }, {
	    key: 'getPageName',
	    value: function getPageName() {
	      var path = window.location.pathname;
	      return path.substring(path.lastIndexOf('/') + 1);
	    }
	  }, {
	    key: 'isWithdrawal',
	    value: function isWithdrawal() {
	      return this.getPageName() === PAGE_WITHDRAWAL;
	    }
	  }, {
	    key: 'offDefaultSaving',
	    value: function offDefaultSaving() {
	      this.form.isDefault = false;
	      this.form.saveBankAccount = false;
	    }
	  }, {
	    key: 'appendBankAccountToList',
	    value: function appendBankAccountToList(resp) {
	      sessionStorage.setItem('temp_bank', (0, _stringify2.default)(resp));
	      this.AppService.broadcast('reload.bank-sidebar');
	    }
	  }, {
	    key: 'goToSettings',
	    value: function goToSettings() {
	      $('#warningModal').modal('hide');
	      $('#bankAccountModal').modal('hide');
	      $('.modal-backdrop').hide();
	      this.$state.go('settings');
	    }
	  }, {
	    key: 'onCloseForm',
	    value: function onCloseForm() {
	      $('#bankAccountModal').modal('hide');
	      this.resetForm();
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	      this.error.clearFormErrors();
	      this.FormService.isSubmitting.next(false);
	      $('#default').prop('checked', true);
	      $('#save').prop('checked', true);
	      this.getMemberDetails();
	    }
	  }]);
	  return LinkBank;
	}();
	
	exports.default = LinkBank;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RequestLinkBankForm = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _payload = __webpack_require__(1138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestLinkBankForm = exports.RequestLinkBankForm = function () {
	  function RequestLinkBankForm() {
	    (0, _classCallCheck3.default)(this, RequestLinkBankForm);
	
	    this.bankDetails = {};
	    this.responseData = {};
	    this.action = 'CREATE';
	    this.isDefault = true;
	    this.isWithdrawal = true;
	    this.saveBankAccount = true;
	    this.bankPaymentOption = null;
	    this.beneficiaryAccount = null;
	    this.beneficiaryAccountName = null;
	    this.beneficiaryAddress = null;
	    this.beneficiaryCode = null;
	    this.beneficiaryBank = null;
	    this.bankAddress = null;
	    this.dateOfBirth = null;
	    this.citizenship = null;
	
	    this.props = {
	      isSubmitting: false,
	      isReady: false,
	      readOnly: false
	    };
	
	    this.successMessage = {
	      title: 'Success',
	      body: 'Bank account successfully created.'
	    };
	  }
	
	  (0, _createClass3.default)(RequestLinkBankForm, [{
	    key: 'reset',
	    value: function reset() {
	      this.action = 'CREATE';
	      this.bankPaymentOption = null;
	      this.isDefault = true;
	      this.isWithdrawal = true;
	      this.saveBankAccount = true;
	      this.beneficiaryAccount = null;
	      this.beneficiaryAccountName = null;
	      this.beneficiaryAddress = null;
	      this.beneficiaryCode = null;
	      this.beneficiaryBank = null;
	      this.bankAddress = null;
	      this.dateOfBirth = null;
	      this.citizenship = null;
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        memberPaymentOption: {
	          is_active: this.saveBankAccount,
	          is_default: this.isDefault,
	          is_withdrawal: this.isWithdrawal,
	          account_id: this.beneficiaryAccount,
	          account_name: this.beneficiaryAccountName,
	          birth_date: (0, _payload.toApiAcceptedDateFormat)(this.dateOfBirth),
	          citizenship: this.citizenship,
	          account_address: this.beneficiaryAddress,
	          swift_code: this.beneficiaryCode,
	          bank_name: this.beneficiaryBank,
	          bank_address: this.bankAddress,
	          notes: ''
	        }
	      };
	
	      return payload;
	    }
	  }, {
	    key: 'toUpdatePayload',
	    value: function toUpdatePayload() {
	      var payload = {
	        memberPaymentOption: {
	          memberPaymentOptionId: this.bankPaymentOption,
	          is_active: this.saveBankAccount,
	          is_default: this.isDefault,
	          is_withdrawal: this.isWithdrawal,
	          account_id: this.beneficiaryAccount,
	          account_name: this.beneficiaryAccountName,
	          birth_date: (0, _payload.toApiAcceptedDateFormat)(this.dateOfBirth),
	          citizenship: this.citizenship,
	          account_address: this.beneficiaryAddress,
	          swift_code: this.beneficiaryCode,
	          bank_name: this.beneficiaryBank,
	          bank_address: this.bankAddress,
	          notes: ''
	        }
	      };
	
	      return payload;
	    }
	  }, {
	    key: 'toDeletePayload',
	    value: function toDeletePayload() {
	      var payload = {
	        memberPaymentOptionDelete: {
	          memberPaymentOptionId: this.bankPaymentOption
	        }
	      };
	
	      return payload;
	    }
	  }, {
	    key: 'isReadOnly',
	    get: function get() {
	      return this.props.readOnly;
	    }
	  }]);
	  return RequestLinkBankForm;
	}();
	
	exports.default = RequestLinkBankForm;

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toApiAcceptedDateFormat = toApiAcceptedDateFormat;
	function toApiAcceptedDateFormat(dateString) {
	  if (dateString === null || dateString.length === 0) {
	    return null;
	  }
	
	  var date = new Date(dateString);
	
	  var y = date.getFullYear();
	  var m = date.getMonth() + 1;
	  var d = date.getDate();
	
	  var padM = m < 10 ? '0' + m : m;
	  var padD = d < 10 ? '0' + d : d;
	
	  return [y, padM, padD].join('-');
	}

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LinkBankFormErrorModel = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkBankFormErrorModel = exports.LinkBankFormErrorModel = function () {
	    function LinkBankFormErrorModel() {
	        (0, _classCallCheck3.default)(this, LinkBankFormErrorModel);
	
	        this.formError = null;
	        this.flattenedErrors = {
	            accountId: {},
	            accountName: {},
	            birthDate: {},
	            accountAddress: {},
	            citizenship: {},
	            bankCode: {},
	            bankName: {},
	            bankAddress: {},
	            parent: {}
	        };
	        this.hasError = true;
	        this.errorMessage = {
	            title: 'Warning',
	            body: 'Something went wrong. Please try again later.'
	        };
	    }
	
	    (0, _createClass3.default)(LinkBankFormErrorModel, [{
	        key: 'setFormErrors',
	        value: function setFormErrors(errors) {
	            this.flattenedErrors.parent = (0, _lodash.get)(errors, 'errors');
	            this.flattenedErrors.accountId = (0, _lodash.get)(errors, 'children.account_id.errors');
	            this.flattenedErrors.accountName = (0, _lodash.get)(errors, 'children.account_name.errors');
	            this.flattenedErrors.birthDate = (0, _lodash.get)(errors, 'children.birth_date.errors');
	            this.flattenedErrors.citizenship = (0, _lodash.get)(errors, 'children.citizenship.errors');
	            this.flattenedErrors.accountAddress = (0, _lodash.get)(errors, 'children.account_address.errors');
	            this.flattenedErrors.bankCode = (0, _lodash.get)(errors, 'children.swift_code.errors');
	            this.flattenedErrors.bankName = (0, _lodash.get)(errors, 'children.bank_name.errors');
	            this.flattenedErrors.bankAddress = (0, _lodash.get)(errors, 'children.bank_address.errors');
	        }
	    }, {
	        key: 'clearFormErrors',
	        value: function clearFormErrors() {
	            this.flattenedErrors = {
	                accountId: {},
	                accountName: {},
	                birthDate: {},
	                accountAddress: {},
	                citizenship: {},
	                bankCode: {},
	                bankName: {},
	                bankAddress: {},
	                parent: {}
	            };
	        }
	    }, {
	        key: 'accountId',
	        get: function get() {
	            return this.flattenedErrors['accountId'];
	        }
	    }, {
	        key: 'accountName',
	        get: function get() {
	            return this.flattenedErrors['accountName'];
	        }
	    }, {
	        key: 'birthDate',
	        get: function get() {
	            return this.flattenedErrors['birthDate'];
	        }
	    }, {
	        key: 'citizenship',
	        get: function get() {
	            return this.flattenedErrors['citizenship'];
	        }
	    }, {
	        key: 'accountAddress',
	        get: function get() {
	            return this.flattenedErrors['accountAddress'];
	        }
	    }, {
	        key: 'bankCode',
	        get: function get() {
	            return this.flattenedErrors['bankCode'];
	        }
	    }, {
	        key: 'bankName',
	        get: function get() {
	            return this.flattenedErrors['bankName'];
	        }
	    }, {
	        key: 'bankAddress',
	        get: function get() {
	            return this.flattenedErrors['bankAddress'];
	        }
	    }, {
	        key: 'parent',
	        get: function get() {
	            return this.flattenedErrors['parent'];
	        }
	    }]);
	    return LinkBankFormErrorModel;
	}();
	
	exports.default = LinkBankFormErrorModel;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _productPasswordWidget = __webpack_require__(1141);
	
	var _productPasswordWidget2 = _interopRequireDefault(_productPasswordWidget);
	
	var _productPasswordWidget3 = __webpack_require__(1142);
	
	var _productPasswordWidget4 = _interopRequireDefault(_productPasswordWidget3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productPasswordWidgetComponent = {
	    bindings: {},
	    template: _productPasswordWidget2.default,
	    controller: _productPasswordWidget4.default
	};
	
	exports.default = productPasswordWidgetComponent;

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"requestProductPassword\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" style=\"display: none;\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content add-product-modal\">\n            <!-- header -->\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" ng-click=\"$ctrl.onCloseModal()\" aria-hidden=\"true\">×</button>\n                <h3 class=\"modal-title text-white\">{{ 'Request Product Password' | translate }}</h3>\n            </div>\n            <!-- body -->\n            <div class=\"modal-body\">\n                <div class=\"product-wrap\">\n                    <form>\n                        <section class=\"section-wrap\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <h4>{{ 'Select one or more products to reset password' | translate }} *</h4>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <ul>\n                                        <li ng-repeat=\"product in $ctrl.form.customerProducts\" class=\"row\">\n                                            <div ng-if=\"product.product.details.is_product_password && product.details.has_first_deposit\">\n                                                <div class=\"col-sm-7\">\n                                                    <div class=\"checkbox checkbox-success\">\n                                                        <input type=\"checkbox\" ng-model=\"$ctrl.form.selectedProducts[product.id].isSelected\">\n                                                        <label class=\"custom-checkbox\">{{ product.product.name }}</label> <span>({{ product.username }})</span>\n                                                    </div>\n                                                </div>\n                                                <div class=\"col-sm-5\">\n                                                    <div ng-if=\"product.details.product_password.is_active && !$ctrl.isExpired(product.details.product_password.created_at.date)\">\n                                                        <button ng-show=\"!product.details.product_password.is_viewed\" id=\"{{ product.id }}\" ng-click=\"$ctrl.viewPassword(product.id)\" class=\"btn btn-sm btn-info btn-w-200 view-password\">{{ 'View Password' | translate }} <i class=\"fa fa-eye\"></i></button>\n                                                        <div ng-show=\"product.details.product_password.is_viewed\" class=\"copy-password\" id=\"ig-{{ product.id }}\">\n                                                            <div class=\"input-group input-group-sm\">\n                                                                <input id=\"cp-{{ product.id }}\" ng-value=\"product.details.product_password.password\" type=\"text\" class=\"form-control input-sm\" placeholder=\"{{ 'form.password' | translate }}\" readonly>\n                                                                <span class=\"input-group-btn\">\n                                                                    <button ng-click=\"$ctrl.copyToClipBoard(product.id)\" type=\"button\" class=\"btn waves-effect waves-light btn-sm btn-info\">\n                                                                      <span class=\"copy-text\" id=\"tp-{{ product.id }}\">{{ 'Copy' | translate }}</span>\n                                                                    </button>\n                                                                </span>\n                                                            </div>\n                                                            <small><i class=\"text-danger\">{{ 'Expires on' | translate }} {{ $ctrl.expiresOn(product.details.product_password.created_at.date) | date: 'medium' }}</i></small>\n                                                        </div>\n\n                                                    </div>\n                                                    <button ng-if=\"!product.details.product_password.is_active\" class=\"btn btn-sm btn-w-200 disabled view-password\">{{ 'No Password' | translate }} <i class=\"fa fa-eye-slash\"></i></button>\n                                                    <button ng-if=\"product.details.product_password.is_active && $ctrl.isExpired(product.details.product_password.created_at.date)\" class=\"btn btn-sm btn-warning btn-w-200 disabled view-password\">{{ 'Expired Password' | translate }} <i class=\"fa fa-eye-slash\"></i></button>\n                                                </div>\n                                            </div>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-7\">\n                                    <div class=\"form-group\">\n                                        <label>{{ 'form.transactionPassword' | translate }} *</label>\n                                        <switch-auth switched=\"$ctrl.form.authenticationSwitched(isUsingGoogleTwoFactor)\" session=\"$ctrl.session\">\n                                            <input ng-model=\"$ctrl.form.transactionPassword\" type=\"password\" class=\"form-control\">\n                                            <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.transactionPassword\">\n                                              <li ng-repeat=\"(key, error) in $ctrl.form.error.transactionPassword\" class=\"parsley-required\">{{ error }}</li>\n                                            </ul>\n                                        </switch-auth>\n                                        \n                                    </div>\n                                    <ul class=\"parsley-errors-list filled error-message\" ng-if=\"$ctrl.error.transactionPassword\">\n                                        <li ng-repeat=\"(key, error) in $ctrl.error.transactionPassword\" class=\"parsley-required\">{{ error }}</li>\n                                    </ul>\n                                </div>\n                                <div class=\"col-md-5\">\n                                    <div class=\"form-group product-password\">\n                                        <ladda-button ng-hide=\"$ctrl.form.props.isReadOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request'\"></ladda-button>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <p><i>* {{ 'Product password will be available once password has been reset.' | translate }}</i></p>\n                                </div>\n                            </div>\n                            <div ng-if=\"$ctrl.error.parent[0] && $ctrl.error.hasError\" class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <div class=\"alert alert-warning\">\n                                        <strong>{{ 'Warning!' | translate }}</strong> {{ $ctrl.error.parent[0] }}\n                                    </div>\n                                </div>\n                            </div>\n                            <div ng-if=\"$ctrl.hasMemberProductError($ctrl.error.memberProducts) && $ctrl.error.hasError\" class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <div class=\"alert alert-warning\">\n                                        <strong>{{ 'Warning! The following product/s has pending request' | translate }}:</strong>\n                                        <ul>\n                                            <li ng-repeat=\"(key, error) in $ctrl.error.memberProducts\">{{ error.children.memberProductId.errors[0] }}</li>\n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>\n                            <div ng-if=\"!$ctrl.error.hasError\" class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <div class=\"alert alert-success\">\n                                        <strong>{{ $ctrl.form.successMessage.title | translate }}!</strong> {{ $ctrl.form.successMessage.body | translate }}\n                                    </div>\n                                </div>\n                            </div>\n                            <div ng-if=\"$ctrl.error.hasViewPasswordError && $ctrl.error.hasError\" class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <div class=\"alert alert-warning\">\n                                        <strong>{{ $ctrl.error.errorMessage.title | translate }}!</strong> {{ $ctrl.error.errorMessage.body | translate }}\n                                    </div>\n                                </div>\n                            </div>\n                        </section>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductPassword = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _form = __webpack_require__(1143);
	
	var _modal = __webpack_require__(1096);
	
	var _formError = __webpack_require__(1144);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPassword = exports.ProductPassword = function () {
	  ProductPassword.$inject = ["FormService", "SessionService", "CustomerApiService", "TransactionApiService", "AppService", "$state", "$timeout", "$scope"];
	  function ProductPassword(FormService, SessionService, CustomerApiService, TransactionApiService, AppService, $state, $timeout, $scope) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ProductPassword);
	    this.SessionService = SessionService;
	    this.FormService = FormService;
	    this.CustomerApiService = CustomerApiService;
	    this.TransactionApiService = TransactionApiService;
	    this.AppService = AppService;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	
	    this.$scope.$on('reload.member-product-list', function () {
	      _this.loadProductList();
	    });
	  }
	
	  (0, _createClass3.default)(ProductPassword, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.session = this.SessionService.getSession();
	      this.form = new _form.RequestProductPasswordForm();
	      this.error = new _formError2.default();
	      this.loadProductList();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.TransactionApiService.createProductPassword(this.form.toPayload()).then(function (resp) {
	        _this2.FormService.isSubmitting.next(false);
	        _this2.error.hasError = false;
	        _this2.error.hasProductError = false;
	        _this2.$timeout(function () {
	          _this2.AppService.broadcast('reload.transaction-overview');
	          _this2.onCloseModal();
	        }, 2000);
	      }).catch(function (errors) {
	        _this2.FormService.isSubmitting.next(false);
	        _this2.error.hasError = true;
	        _this2.error.setFormErrors(errors);
	      });
	    }
	  }, {
	    key: 'viewPassword',
	    value: function viewPassword(element) {
	      var _this3 = this;
	
	      this.form.memberProductId = element;
	      this.TransactionApiService.viewProductPassword(this.form.toViewPayload()).then(function () {
	        _this3.loadProductList();
	      }).catch(function () {
	        return false;
	      });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      $('.copy-password').hide();
	      $('.view-password').show();
	      $('.copy-text').html('Copy');
	      this.form.reset();
	      this.error.clearFormErrors();
	      this.loadProductList();
	    }
	  }, {
	    key: 'loadProductList',
	    value: function loadProductList() {
	      var _this4 = this;
	
	      this.CustomerApiService.getMemberProducts().then(function (resp) {
	        _this4.form.customerProducts = resp;
	      });
	    }
	  }, {
	    key: 'isExpired',
	    value: function isExpired(dateTime) {
	      var dateNow = new Date(Date.now());
	      var expirationDate = new Date(dateTime);
	      var oneDay = 24 * 60 * 60 * 1000;
	
	      if (dateNow - expirationDate > oneDay) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'expiresOn',
	    value: function expiresOn(dateTime) {
	      var expirationDate = new Date(dateTime);
	
	      return expirationDate.setDate(expirationDate.getDate() + 1);
	    }
	  }, {
	    key: 'hasMemberProductError',
	    value: function hasMemberProductError(errors) {
	      var _this5 = this;
	
	      this.error.hasProductError = false;
	      angular.forEach(errors, function (value, key) {
	        if (value.children.memberProductId.errors) {
	          _this5.error.hasProductError = true;
	        } else {
	          if (!_this5.error.hasProductError) {
	            _this5.error.hasProductError = false;
	          }
	        }
	      });
	
	      return this.error.hasProductError;
	    }
	  }, {
	    key: 'copyToClipBoard',
	    value: function copyToClipBoard(element) {
	      var copyText = document.getElementById('cp-' + element);
	      copyText.select();
	      document.execCommand('copy');
	
	      var tooltip = document.getElementById('tp-' + element);
	      tooltip.innerHTML = 'Copied';
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      (0, _modal.hideModal)('requestProductPassword');
	      this.resetForm();
	      this.error.hasError = true;
	      this.error.hasProductError = false;
	    }
	  }]);
	  return ProductPassword;
	}();
	
	exports.default = ProductPassword;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RequestProductPasswordForm = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestProductPasswordForm = exports.RequestProductPasswordForm = function () {
	  function RequestProductPasswordForm() {
	    (0, _classCallCheck3.default)(this, RequestProductPasswordForm);
	
	    this.customerProducts = {};
	    this.selectedProducts = {};
	    this.transactionPassword = null;
	    this.memberProductId = null;
	    this.isViewed = false;
	
	    this.isUsingGoogleTwoFactor = false;
	
	    this.props = {
	      isSubmitting: false,
	      isReady: false,
	      readOnly: false
	    };
	
	    this.successMessage = {
	      title: 'Success',
	      body: 'Product password successfully requested.'
	    };
	  }
	
	  (0, _createClass3.default)(RequestProductPasswordForm, [{
	    key: 'reset',
	    value: function reset() {
	      this.selectedProducts = {};
	      this.transactionPassword = null;
	    }
	  }, {
	    key: 'authenticationSwitched',
	    value: function authenticationSwitched(isUsingGoogleTwoFactor) {
	      this.isUsingGoogleTwoFactor = isUsingGoogleTwoFactor;
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        memberProductRequestPassword: {
	          memberProducts: {},
	          transactionPassword: this.transactionPassword,
	          usingGoogleAuthPassword: this.isUsingGoogleTwoFactor
	        }
	      };
	
	      var index = 0;
	      angular.forEach(this.selectedProducts, function (selectedProduct, id) {
	        if (selectedProduct.isSelected) {
	          payload.memberProductRequestPassword.memberProducts[index] = {
	            memberProductId: parseInt(id)
	          };
	          index++;
	        }
	      });
	
	      return payload;
	    }
	  }, {
	    key: 'toViewPayload',
	    value: function toViewPayload() {
	      var payload = {
	        memberProductField: {
	          memberProductId: this.memberProductId
	        }
	      };
	
	      return payload;
	    }
	  }, {
	    key: 'isReadOnly',
	    get: function get() {
	      return this.props.readOnly;
	    }
	  }]);
	  return RequestProductPasswordForm;
	}();
	
	exports.default = RequestProductPasswordForm;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductPasswordFormErrorModel = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPasswordFormErrorModel = exports.ProductPasswordFormErrorModel = function () {
	  function ProductPasswordFormErrorModel() {
	    (0, _classCallCheck3.default)(this, ProductPasswordFormErrorModel);
	
	    this.formError = null;
	    this.hasProductError = false;
	    this.hasViewPasswordError = false;
	    this.flattenedErrors = {
	      transactionPassword: {},
	      memberProducts: {},
	      parent: {}
	    };
	    this.hasError = true;
	    this.errorMessage = {
	      title: 'Warning',
	      body: 'Something went wrong. Please try again later.'
	    };
	  }
	
	  (0, _createClass3.default)(ProductPasswordFormErrorModel, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.flattenedErrors.parent = (0, _lodash.get)(errors, 'errors');
	      this.flattenedErrors.transactionPassword = (0, _lodash.get)(errors, 'children.transactionPassword.errors');
	      this.flattenedErrors.memberProducts = (0, _lodash.get)(errors, 'children.memberProducts.children');
	    }
	  }, {
	    key: 'clearFormErrors',
	    value: function clearFormErrors() {
	      this.flattenedErrors = {
	        transactionPassword: {},
	        memberProducts: {},
	        parent: {}
	      };
	    }
	  }, {
	    key: 'parent',
	    get: function get() {
	      return this.flattenedErrors['parent'];
	    }
	  }, {
	    key: 'transactionPassword',
	    get: function get() {
	      return this.flattenedErrors['transactionPassword'];
	    }
	  }, {
	    key: 'memberProducts',
	    get: function get() {
	      return this.flattenedErrors['memberProducts'];
	    }
	  }]);
	  return ProductPasswordFormErrorModel;
	}();
	
	exports.default = ProductPasswordFormErrorModel;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accountReminderWidget = __webpack_require__(1146);
	
	var _accountReminderWidget2 = _interopRequireDefault(_accountReminderWidget);
	
	var _accountReminderWidget3 = __webpack_require__(1147);
	
	var _accountReminderWidget4 = _interopRequireDefault(_accountReminderWidget3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountReminderWidget = {
	  bindings: {},
	  template: _accountReminderWidget2.default,
	  controller: _accountReminderWidget4.default
	};
	
	exports.default = accountReminderWidget;

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	module.exports = "<div ng-show=\"$ctrl.hasReminder()\" class=\"alert alert-warning notif-warning no-m\">\n  <strong>Reminder:</strong> A few more steps in order to secure your account:\n  <ul>\n      <li class=\"m-b-10\"><i ng-class=\"{ 'fa-check-circle': !$ctrl.needsToSetupAuthentication(), 'fa-circle': $ctrl.needsToSetupAuthentication() }\" class=\"far m-r-5\"></i> Set your 2FA using <a href=\"settings#google-auth\">Google Authenticator</a> or <a href=\"settings#transaction-pw\">Transaction Password</a></li>\n      <li><i ng-class=\"{ 'fa-check-circle': !$ctrl.needsToBeVerified(), 'fa-circle': $ctrl.needsToBeVerified() }\" class=\"far fa-check-circle m-r-5\"></i> Please verify your account by submitting <a ui-sref=\"profile\">KYC documents</a></li>\n  </ul>\n</div>\n"

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountReminderWidgetController = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountReminderWidgetController = exports.AccountReminderWidgetController = function (_BaseController) {
	  AccountReminderWidgetController.$inject = ["AppService"];
	  (0, _inherits3.default)(AccountReminderWidgetController, _BaseController);
	
	  function AccountReminderWidgetController(AppService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AccountReminderWidgetController);
	    return (0, _possibleConstructorReturn3.default)(this, (AccountReminderWidgetController.__proto__ || (0, _getPrototypeOf2.default)(AccountReminderWidgetController)).call(this, AppService));
	  }
	
	  (0, _createClass3.default)(AccountReminderWidgetController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.session = this.getSession();
	    }
	  }, {
	    key: 'hasReminder',
	    value: function hasReminder() {
	      return !this.session.isVerified() || !this.session.hasSetupTransactionAuthentication();
	    }
	  }, {
	    key: 'needsToBeVerified',
	    value: function needsToBeVerified() {
	      return !this.session.isVerified();
	    }
	  }, {
	    key: 'needsToSetupAuthentication',
	    value: function needsToSetupAuthentication() {
	      return !this.session.hasSetupTransactionAuthentication();
	    }
	  }]);
	  return AccountReminderWidgetController;
	}(_basecontroller.BaseController);
	
	exports.default = AccountReminderWidgetController;

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function countDecimalPlaces(value) {
	  if (isNaN(value)) {
	    return 0;
	  }
	
	  var decimalPos = String(value).indexOf('.');
	  if (decimalPos === -1) {
	    return 0;
	  } else {
	    return String(value).length - decimalPos - 1;
	  }
	}
	
	// TODO: Create a more flexible directive
	function InputLlimitDirective() {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ngModel) {
	      var limit = parseInt(attrs.limit);
	      var precision = parseInt(attrs.precision);
	
	      if (isNaN(precision)) {
	        // defaults to four decimal places 
	        precision = 4;
	      }
	
	      angular.element(elem).on('keypress', function (e) {
	        if (this.value.length === limit) {
	          e.preventDefault();
	        }
	
	        if (e.which < 48 || e.which > 57) {
	          if (e.which !== 46) {
	            e.preventDefault();
	          }
	        }
	      });
	
	      // Validate input decimal places based on precision
	      ngModel.$parsers.push(function (value) {
	        var places = countDecimalPlaces(value);
	
	        if (places > precision) {
	          var prevValue = ngModel.$modelValue;
	          ngModel.$setViewValue(prevValue);
	          ngModel.$render();
	
	          return prevValue;
	        }
	
	        return value;
	      });
	    }
	  };
	}
	
	exports.default = InputLlimitDirective;

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	'use strict';
	
	LoadingDirective.$inject = ["$compile"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function LoadingDirective($compile) {
	  'ngInject';
	
	  var loadingSpinner = '<i class="fas fa-circle-notch fa-spin text-red"></i>';
	
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      var originalContent = element.html();
	      element.html(loadingSpinner);
	      scope.$watch(attrs.loading, function (val) {
	        if (val !== null && typeof val != 'undefined') {
	          element.html(originalContent);
	          $compile(element.contents())(scope);
	        } else {
	          element.html(loadingSpinner);
	        }
	      });
	    }
	  };
	}
	
	exports.default = LoadingDirective;

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

	'use strict';
	
	FileModelDirective.$inject = ["$compile", "$parse"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function FileModelDirective($compile, $parse) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var model = $parse(attrs.fileModel);
	            var modelSetter = model.assign;
	
	            element.bind('change', function () {
	                scope.$apply(function () {
	                    modelSetter(scope, element[0].files);
	                });
	            });
	        }
	    };
	}
	
	exports.default = FileModelDirective;

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function AsyncFilter() {
	  var values = {};
	  var subscriptions = {};
	
	  function async(input, scope) {
	    // Make sure we have an Observable or a Promise
	    if (!input || !(input.subscribe || input.then)) {
	      return input;
	    }
	
	    var inputId = objectId(input);
	    if (!(inputId in subscriptions)) {
	      var subscriptionStrategy = input.subscribe && input.subscribe.bind(input) || input.success && input.success.bind(input) // To make it work with HttpPromise
	      || input.then.bind(input);
	
	      subscriptions[inputId] = subscriptionStrategy(function (value) {
	        values[inputId] = value;
	
	        if (scope && scope.$applyAsync) {
	          scope.$applyAsync(); // Automatic safe apply, if scope provided
	        }
	      });
	
	      if (scope && scope.$on) {
	        // Clean up subscription and its last value when the scope is destroyed.
	        scope.$on('$destroy', function () {
	          var sub = subscriptions[inputId];
	          if (sub) {
	            sub.unsubscribe && sub.unsubscribe();
	            sub.dispose && sub.dispose();
	          }
	          delete subscriptions[inputId];
	          delete values[inputId];
	        });
	      }
	    }
	
	    return values[inputId];
	  };
	
	  // Need a way to tell the input objects apart from each other (so we only subscribe to them once)
	  var nextObjectID = 0;
	  function objectId(obj) {
	    if (!obj.hasOwnProperty('__asyncFilterObjectID__')) {
	      obj.__asyncFilterObjectID__ = ++nextObjectID;
	    }
	
	    return obj.__asyncFilterObjectID__;
	  }
	
	  // So that Angular does not cache the return value
	  async.$stateful = true;
	
	  return async;
	}
	
	exports.default = AsyncFilter;

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/***
	 * https://gist.github.com/yrezgui/5653591
	 */
	
	function filesizeFilter() {
	  var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
	
	  return function (bytes, precision) {
	    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
	      return '?';
	    }
	
	    var unit = 0;
	
	    while (bytes >= 1024) {
	      bytes /= 1024;
	      unit++;
	    }
	
	    return bytes.toFixed(+precision) + ' ' + units[unit];
	  };
	}
	
	exports.default = filesizeFilter;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signin = __webpack_require__(1154);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _profile = __webpack_require__(1164);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _deposit = __webpack_require__(1182);
	
	var _deposit2 = _interopRequireDefault(_deposit);
	
	var _overview = __webpack_require__(1247);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _withdrawal = __webpack_require__(1398);
	
	var _withdrawal2 = _interopRequireDefault(_withdrawal);
	
	var _productwallet = __webpack_require__(1433);
	
	var _productwallet2 = _interopRequireDefault(_productwallet);
	
	var _peertopeer = __webpack_require__(1446);
	
	var _peertopeer2 = _interopRequireDefault(_peertopeer);
	
	var _outstandingbet = __webpack_require__(1463);
	
	var _outstandingbet2 = _interopRequireDefault(_outstandingbet);
	
	var _bethistory = __webpack_require__(1472);
	
	var _bethistory2 = _interopRequireDefault(_bethistory);
	
	var _acrewards = __webpack_require__(1484);
	
	var _acrewards2 = _interopRequireDefault(_acrewards);
	
	var _resetpassword = __webpack_require__(1496);
	
	var _resetpassword2 = _interopRequireDefault(_resetpassword);
	
	var _forgotpassword = __webpack_require__(1504);
	
	var _forgotpassword2 = _interopRequireDefault(_forgotpassword);
	
	var _activation = __webpack_require__(1512);
	
	var _activation2 = _interopRequireDefault(_activation);
	
	var _zendesk = __webpack_require__(1521);
	
	var _zendesk2 = _interopRequireDefault(_zendesk);
	
	var _settings = __webpack_require__(1526);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _requests = __webpack_require__(1571);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _customer = __webpack_require__(1582);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _marketing = __webpack_require__(1630);
	
	var _marketing2 = _interopRequireDefault(_marketing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO remove CustomerModule.
	var pagesModule = _angular2.default.module('pages', [_signin2.default, _profile2.default, _deposit2.default, _overview2.default, _withdrawal2.default, _productwallet2.default, _peertopeer2.default, _outstandingbet2.default, _bethistory2.default, _acrewards2.default, _resetpassword2.default, _forgotpassword2.default, _activation2.default, _customer2.default, _marketing2.default, _zendesk2.default, _settings2.default, _requests2.default]).name;
	
	exports.default = pagesModule;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _signin = __webpack_require__(1155);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _form = __webpack_require__(1159);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _signin3 = __webpack_require__(1163);
	
	var _signin4 = _interopRequireDefault(_signin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signinModule = _angular2.default.module('signin', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('signin', {
	    url: '/sign-in',
	    component: 'signin',
	    resolve: {
	      authenticate: ["SecurityService", "SessionService", "$state", "$location", function authenticate(SecurityService, SessionService, $state, $location) {
	        var fromMobile = $location.search().from;
	        if (SecurityService.isSessionActive() && fromMobile !== 'mob') {
	          // We don't want to display sign-page to user when he is logged in. Automatically
	          // transition to dashboard instead.
	          // This will cause transition rejection, but again, that would be fine.
	          $state.go('dashboard');
	        }
	      }]
	    }
	  });
	}]).component('signin', _signin2.default).component('signinForm', _form2.default).service('SigninService', _signin4.default).name;
	
	exports.default = signinModule;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _signin = __webpack_require__(1156);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _signin3 = __webpack_require__(1157);
	
	var _signin4 = _interopRequireDefault(_signin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signinComponent = {
	  bindings: {},
	  template: _signin2.default,
	  controller: _signin4.default
	};
	
	exports.default = signinComponent;

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main-wrapper\"></div>\n<div class=\"clearfix\"></div>\n<div class=\"wrapper-page\">\n    <div class=\" main-box fadeIn animated\">\n        <div class=\"ac-logo\">\n            <img src=\"assets/images/ac_img/ac-colored.png\" height=\"30\"/>\n        </div>\n        <div ng-if=\"!$ctrl.isAutoLogin()\" class=\"card-box\">\n            <div class=\"text-center\">\n                <span>{{ 'Sign in to start your session' | translate }}</span>\n            </div>\n            <signin-form></signin-form>\n        </div>\n        <div ng-if=\"$ctrl.isAutoLogin()\" class=\"row\">\n            <div class=\"text-center\">\n                <div class=\"autologin-loader\"></div>\n                <br>\n                <span>{{ 'Please wait, Logging in...' | translate }}</span>\n                <div ng-hide=\"$ctrl.isAutoLogin()\">\n                    <signin-form></signin-form>\n                </div>\n            </div>\n        </div>\n        <p><a href=\"/forgot-password\">Forgot password?</a></p>\n    </div>\n</div>\n"

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _string = __webpack_require__(1158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SigninController = function () {
	  SigninController.$inject = ["PageService", "StorageService", "ProfileApiService", "SessionService", "$window", "$state", "$location", "$translate"];
	  function SigninController(PageService, StorageService, ProfileApiService, SessionService, $window, $state, $location, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SigninController);
	    this.PageService = PageService;
	    this.StorageService = StorageService;
	    this.ProfileApiService = ProfileApiService;
	    this.SessionService = SessionService;
	    this.$window = $window;
	    this.$state = $state;
	    this.$location = $location;
	    this.$translate = $translate;
	  }
	
	  (0, _createClass3.default)(SigninController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var locale = this.$location.search().lang;
	
	      if (locale) {
	        this.$translate.use(locale);
	      }
	
	      this.SessionService.clearSession();
	      this.ProfileApiService.profile().then(function (response) {
	        _this.SessionService.processResponse(response);
	      });
	
	      parent.postMessage('disconnected', '*');
	    }
	  }, {
	    key: 'isAutoLogin',
	    value: function isAutoLogin() {
	      return this.$location.search().username && this.$location.search().password;
	    }
	  }]);
	  return SigninController;
	}();
	
	exports.default = SigninController;

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.jsonParse = jsonParse;
	/**
	 * @returns null if string is not parseable
	 */
	function jsonParse(str) {
	  try {
	    return JSON.parse(str);
	  } catch ($ex) {
	    return null;
	  }
	}

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1160);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1161);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    onSuccessfulLogin: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form-horizontal m-t-20\" ng-submit=\"$ctrl.submit()\" autocomplete=\"off\">\n    <div class=\"alert alert-danger\" ng-show=\"$ctrl.form.error\">\n        <p>{{ $ctrl.form.error | translate }}</p>\n\t</div>\n    <div class=\"input-group m-t-10\">\n        <input ng-model=\"$ctrl.form._username\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'form.username' | translate }}\">\n        <span class=\"input-group-addon ac-white\"><i class=\"fa fa-user\"></i></span>\n    </div>\n    <div class=\"input-group m-t-10\">\n        <input ng-model=\"$ctrl.form._password\" type=\"password\" class=\"form-control\" placeholder=\"{{ 'form.password' | translate }}\">\n        <span class=\"input-group-addon ac-white\"><i class=\"fa fa-lock\"></i></span>\n    </div>\n    <div class=\"form-group text-center m-t-10\">\n        <div class=\"col-xs-12\">\n            <button type=\"submit\" class=\"btn btn-danger ladda-button ac-color\" data-style=\"expand-right\">{{ 'Sign In' | translate }} <i id=\"spin\" class=\"fas fa-spinner fa-spin hidden\"></i></button>\n        </div>\n    </div>\n    <div class=\"form-group m-t-10 m-b-0\">\n        <!--div class=\"col-sm-12\">\n            <a ng-click=\"$ctrl.sendPostMessageToForgotPass()\" href=\"/forgot-password\" class=\"text-dark\"><small>I forgot my password.</small></a>\n        </div-->\n    </div>\n</form>\n"

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1162);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPE_MEMBER = 'MBR';
	var TYPE_AFFILIATE = 'AFF';
	
	var FormController = function () {
	  FormController.$inject = ["SigninService", "FormService", "StorageService", "$timeout", "$state", "$window", "$location", "$translate"];
	  function FormController(SigninService, FormService, StorageService, $timeout, $state, $window, $location, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	    this.SigninService = SigninService;
	    this.StorageService = StorageService;
	    this.FormService = FormService;
	
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.$window = $window;
	    this.$translate = $translate;
	    this.$location = $location;
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = _form2.default;
	      this.autoLogin();
	      this.storeOrigin = this.getOrigin.bind(this);
	      this.$window.addEventListener('message', this.storeOrigin);
	    }
	  }, {
	    key: 'getOrigin',
	    value: function getOrigin(e) {
	      var parsedData = e.data;
	      if (parsedData) {
	        this.StorageService.setItem('site_origin', parsedData.origin_from);
	        if (parsedData.username && parsedData.password) {
	          this.form._username = parsedData.username;
	          this.form._password = parsedData.password;
	          this.submit();
	        }
	      }
	    }
	  }, {
	    key: 'autoLogin',
	    value: function autoLogin() {
	      var _this = this;
	
	      if (this.$location.search().username && this.$location.search().password) {
	        this.form._username = this.$location.search().username;
	        this.form._password = this.$location.search().password;
	        this.$timeout(function () {
	          _this.submit();
	        }, 1500);
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      var spinner = document.getElementById('spin');
	      spinner.classList.remove("hidden");
	
	      this.form.error = '';
	      this.FormService.isSubmitting.next(true);
	      this.SigninService.signin(this.form.toPayload()).then(function (sessionDetails) {
	        _this2.$translate.use(sessionDetails.locale);
	
	        if (sessionDetails.tags.includes(TYPE_AFFILIATE)) {
	          parent.postMessage('amsLogin-affiliate', '*');
	          _this2.StorageService.setItem('customer_type', TYPE_AFFILIATE);
	          _this2.$state.go('marketing');
	        } else {
	          parent.postMessage('amsLogin-member', '*');
	          _this2.StorageService.setItem('customer_type', TYPE_MEMBER);
	          _this2.$state.go('dashboard');
	        }
	        _this2.$timeout(function () {
	          _this2.$window.location.reload();
	        }, 500);
	      }).catch(function (error) {
	        // needed to use timeout, probably another issue on $digest.
	        _this2.$timeout(function () {
	          return _this2.form.error = error;
	        }, 100);
	        spinner.classList.add("hidden");
	      }).finally(function () {
	        return _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'sendPostMessageToForgotPass',
	    value: function sendPostMessageToForgotPass() {
	      parent.postMessage('amsForgot-pass', '*');
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SigninForm = {
	  _username: '',
	  _password: '',
	
	  error: '',
	
	  toPayload: function toPayload() {
	    return {
	      _username: this._username,
	      _password: this._password
	    };
	  },
	
	  reset: function reset() {
	    this.error = '';
	    this._username = '';
	    this._password = '';
	  }
	};
	
	exports.default = SigninForm;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SigninService = function () {
	  SigninService.$inject = ["SecurityApiService", "SecurityService"];
	  function SigninService(SecurityApiService, SecurityService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SigninService);
	    this.SecurityApiService = SecurityApiService;
	    this.SecurityService = SecurityService;
	  }
	
	  (0, _createClass3.default)(SigninService, [{
	    key: 'signin',
	    value: function signin(payload) {
	      return this.SecurityService.login(payload);
	    }
	  }]);
	  return SigninService;
	}();
	
	exports.default = SigninService;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _profile = __webpack_require__(1165);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profile3 = __webpack_require__(1171);
	
	var _profile4 = _interopRequireDefault(_profile3);
	
	var _fileList = __webpack_require__(1172);
	
	var _fileList2 = _interopRequireDefault(_fileList);
	
	var _file = __webpack_require__(1179);
	
	var _file2 = _interopRequireDefault(_file);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profileModule = _angular2.default.module('profile', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('profile', {
	    parent: 'standardLayout',
	    url: '/profile',
	    component: 'profile',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('profile', _profile2.default).component('fileList', _fileList2.default).component('file', _file2.default).service('ProfileStore', _profile4.default).name;
	
	exports.default = profileModule;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _profile = __webpack_require__(1166);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profile3 = __webpack_require__(1167);
	
	var _profile4 = _interopRequireDefault(_profile3);
	
	var _profile5 = __webpack_require__(1169);
	
	var _profile6 = _interopRequireDefault(_profile5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profileComponent = {
	  bindings: {
	    profile: '<'
	  },
	  template: _profile2.default,
	  controller: _profile4.default,
	  css: _profile6.default
	};
	
	exports.default = profileComponent;

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-12\">\n          <h1>{{ 'titles.profile' | translate }}</h1>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"fadeIn animated\">\n          <section>\n            <!-- Profile -->\n            <div class=\"col-lg-8\">\n              <div class=\"panel panel-default myprofile-box\">\n                <div class=\"panel-body profile-info\">\n                  <div class=\"row\">\n\n                    <div class=\"col-lg-2 col-md-3 col-sm-12 col-xs-12 text-center\">\n                      <div class=\"profile-header-customer\">\n                        <span ng-if=\"$ctrl.model.status === 'Verified'\">\n                          <img class=\"profile-header-verified\" src=\"/assets/images/users/verified-icon.svg\">\n                        </span>\n                        <span ng-if=\"$ctrl.model.status !== 'Verified'\">\n                          <img class=\"profile-header-verified\" src=\"/assets/images/users/unverified-icon.svg\">\n                        </span>\n\n                        <img ng-if=\"$ctrl.model.avatar.selected && $ctrl.model.avatar.selected != 'custom'\" ng-src=\"/assets/images/users/{{ $ctrl.model.avatar.selected }}.svg\" alt=\"user\" class=\"profile-header-avatar\">\n                        <img ng-if=\"($ctrl.model.avatar.selected == 'custom' && !$ctrl.image) || !$ctrl.model.avatar.selected\" ng-src=\"/assets/images/users/avatar-default.svg\" alt=\"user\" class=\"profile-header-avatar\">\n                        <img ng-if=\"$ctrl.model.avatar.selected == 'custom' && $ctrl.image\" ng-src=\"{{ $ctrl.image }}\" alt=\"user\" class=\"profile-header-avatar\">\n\n                      </div>\n                      \n                      <div class=\"change-avatar\">\n                          <i class=\"fas fa-edit\"></i>\n                          <a ui-sref=\"settings\">Change Avatar</a>\n                      </div>\n                    </div>\n\n                    <div class=\"col-lg-10 col-md-9 col-sm-12 col-xs-12\">\n                      <div class=\"row\">\n                        <div class=\"col-lg-12\">\n                          <h3 loading=\"$ctrl.model.fullName\" class=\"m-b-0\">{{ $ctrl.model.fullName }}</h3>\n                          <p loading=\"$ctrl.model.username\" class=\"m-b-30\">{{ $ctrl.model.username }}</p>\n                        </div>\n                      </div>\n                      <div class=\"row\">\n                        <div class=\"col-lg-6\">\n                          <div class=\"row\">\n                            <div class=\"text-group\">\n                              <div class=\"col-md-5 col-sm-5 col-xs-5\">\n                                <strong>{{ 'Customer ID' | translate }}</strong>\n                              </div>\n                              <div class=\"ccol-md-7 col-sm-7 col-xs-7\">\n                                <span loading=\"$ctrl.model.id\">{{ $ctrl.model.id }}</span>\n                              </div>\n                            </div>\n\n                            <div class=\"text-group\">\n                              <div class=\"col-md-5 col-sm-5 col-xs-5\">\n                                <strong>{{ 'Currency' | translate }}:</strong>\n                              </div>\n                              <div class=\"col-md-7 col-sm-7 col-xs-7\">\n                                <span loading=\"$ctrl.model.currency.code\">{{ $ctrl.model.currency.code }}</span>\n                              </div>\n                            </div>\n\n                            <div class=\"text-group\">\n                              <div class=\"col-md-5 col-sm-5 col-xs-5\">\n                                <strong>{{ 'Country' | translate }}:</strong>\n                              </div>\n                              <div class=\"col-md-7 col-sm-7 col-xs-7\">\n                                <span loading=\"$ctrl.model.country.name\">{{ $ctrl.model.country.name }}</span>\n                              </div>\n                            </div>\n\n                            <div class=\"text-group\">\n                              <div class=\"col-md-5 col-sm-5 col-xs-5\">\n                                <strong>{{ 'Date of birth' | translate }}:</strong>\n                              </div>\n                              <div class=\"col-md-7 col-sm-7 col-xs-7\">\n                                <span loading=\"$ctrl.model.dateOfBirth\">{{ $ctrl.model.dateOfBirth }}</span>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"col-lg-6\">\n                          <div class=\"row\">\n                            <div class=\"text-group\">\n                              <div class=\"col-md-5 col-sm-5 col-xs-5\">\n                                <strong>{{ 'Join date' | translate }}:</strong>\n                              </div>\n                              <div class=\"col-md-7 col-sm-7 col-xs-7\">\n                                <span\n                                  loading=\"$ctrl.model.joinedDate\">{{ $ctrl.model.joinedDate | date: 'MM/dd/yyyy' }}</span>\n                              </div>\n                            </div>\n\n                            <div class=\"text-group\">\n                              <div class=\"col-md-5 col-sm-5 col-xs-5\">\n                                <strong>{{ 'Email Address' | translate }}:</strong>\n                              </div>\n                              <div class=\"col-md-7 col-sm-7 col-xs-7\">\n                                <span loading=\"$ctrl.model.email\">{{ $ctrl.model.email }}</span>\n                              </div>\n                            </div>\n\n                            <div class=\"text-group\">\n                              <div class=\"col-md-5 col-sm-5 col-xs-5\">\n                                <strong>{{ 'Phone number' | translate }}:</strong>\n                              </div>\n                              <div class=\"col-md-7 col-sm-7 col-xs-7 h-30\">\n                                <span loading=\"$ctrl.model.contact\">{{ $ctrl.model.contact }}</span>\n                              </div>\n                            </div>\n                            <div class=\"text-group\">\n                              <div class=\"col-md-5 col-sm-5 col-xs-5\">\n                                <strong>{{ 'Skype' | translate }}:</strong>\n                              </div>\n                              <div class=\"col-md-7 col-sm-7 col-xs-7\">\n                                <span loading=\"$ctrl.model.skype\">{{ $ctrl.model.skype }}</span>\n                              </div>\n                            </div>\n                          </div>\n\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <!-- KYC -->\n            <div class=\"col-lg-4\">\n              <div class=\"panel\">\n                <div class=\"panel-heading\">\n                  <div class=\"row\">\n                    <div class=\"col-md-6 col-sm-6 col-xs-4\">\n                      <div>\n                        <h3><strong>{{ 'K.Y.C documents' | translate }}</strong></h4>\n                      </div>\n                    </div>\n                  </div>\n\n                  <file-list></file-list>\n                </div>\n              </div>\n              <div class=\"clearfix\"></div>\n          </section>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n</div>"

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _profile = __webpack_require__(1168);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileController = function () {
	  ProfileController.$inject = ["EventDispatcherService", "HttpService", "ProfileStore", "CustomerApiService", "NavbarService", "$timeout", "$translate", "$sce", "$scope"];
	  function ProfileController(EventDispatcherService, HttpService, ProfileStore, CustomerApiService, NavbarService, $timeout, $translate, $sce, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProfileController);
	    this.EventDispatcherService = EventDispatcherService;
	    this.HttpService = HttpService;
	    this.NavbarService = NavbarService;
	    this.ProfileStore = ProfileStore;
	    this.$timeout = $timeout;
	    this.$translate = $translate;
	    this.CustomerApiService = CustomerApiService;
	    this.image = null;
	    this.$sce = $sce;
	    this.$scope = $scope;
	    this.$scope.renderingFile = false;
	  }
	
	  (0, _createClass3.default)(ProfileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.model = new _profile2.default();
	
	      this.ProfileStore.getProfile().then(function (profile) {
	        _this.model.id = profile.id;
	        _this.model.firstName = profile.firstName;
	        _this.model.lastName = profile.lastName;
	        _this.model.fullName = profile.full_name;
	        _this.model.currency.name = profile.currency.name;
	        _this.model.currency.code = profile.currency.code;
	        _this.model.country.name = profile.country.name;
	        _this.model.joinedDate = profile.joined_at;
	        _this.model.verifiedAt = profile.verified_at;
	        _this.model.dateOfBirth = profile.birthDate;
	        _this.model.email = profile.user.email;
	        _this.model.username = profile.user.username;
	        _this.model.contact = _this.getPhoneNumber(profile.contacts);
	        _this.model.skype = profile.skype;
	        _this.model.enabled = profile.is_enabled;
	        _this.model.avatar = profile.avatar;
	
	        _this.loadAvatar();
	      });
	
	      this.updateModel();
	
	      this.EventDispatcherService.addListener(_events2.default.AVATAR_UPDATED, function (event) {
	        _this.model.avatar = event.payload;
	
	        _this.loadAvatar();
	      });
	    }
	  }, {
	    key: 'getPhoneNumber',
	    value: function getPhoneNumber(contacts) {
	      var contact = contacts.find(function (x) {
	        return x.type === 'mobile';
	      });
	
	      return contact ? contact.value : "";
	    }
	  }, {
	    key: 'updateModel',
	    value: function updateModel() {
	      var _this2 = this;
	
	      return this.ProfileStore.getDashboardDetails().then(function (details) {
	        _this2.model.verifiedAt = details.others.verifiedAt;
	      });
	    }
	  }, {
	    key: 'loadAvatar',
	    value: function loadAvatar() {
	      var _this3 = this;
	
	      if (this.model.avatar && this.model.avatar.uploaded) {
	        this.CustomerApiService.getAvatar(this.model.avatar.uploaded).then(function (fileUri) {
	          _this3.HttpService.$http.get(fileUri, { responseType: 'arraybuffer' }).then(function (s3data) {
	            var fileObj = new Blob([s3data], { type: 'application/binary' });
	            _this3.image = _this3.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
	          });
	        });
	      }
	    }
	  }]);
	  return ProfileController;
	}();
	
	exports.default = ProfileController;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileModel = function () {
	  function ProfileModel() {
	    (0, _classCallCheck3.default)(this, ProfileModel);
	
	    this.id = null;
	    this.firstName = null;
	    this.lastName = null;
	    this.fullName = null;
	    this.currency = {
	      name: null,
	      code: null
	    };
	    this.country = {
	      name: null
	    };
	    this.enabled = null;
	    this.dateOfBirth = null;
	    this.joinedDate = null;
	    this.verifiedAt = null;
	    this.email = null;
	    this.username = null;
	    this.contacts = [];
	    this.skype = null;
	    this.files = [];
	  }
	
	  (0, _createClass3.default)(ProfileModel, [{
	    key: 'status',
	    get: function get() {
	      return this.verifiedAt ? 'Verified' : 'Not Verified';
	    }
	  }, {
	    key: 'isVerified',
	    get: function get() {
	      return this.verifiedAt ? true : false;
	    }
	  }]);
	  return ProfileModel;
	}();
	
	exports.default = ProfileModel;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1170);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(500)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./profile.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./profile.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(499)();
	// imports
	
	
	// module
	exports.push([module.id, ".profile-header-customer{display:inline-block;position:relative;margin-bottom:10px}.profile-header-customer img{padding:0}.profile-header-verified{height:30px;width:30px!important;border:3px solid #fff;background-color:#fff;border-radius:50%;position:absolute;bottom:5px;right:0}.profile-header-avatar{height:110px;width:110px!important;border:4px solid #fff;background-color:#fff;border-radius:50%;object-fit:cover}.myprofile-box{padding:50px!important;border-left:10px solid #c1282d}.h-30{height:30px}.profile-info .text-group{line-height:30px}.kyc-image img{width:230px;margin-top:30px}.up-button button{margin-top:40px;margin-bottom:5px;width:100%}", ""]);
	
	// exports


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeOtherDetails = makeOtherDetails;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeOtherDetails(details) {
	  return {
	    verifiedAt: details.verified_at
	  };
	}
	
	var ProfileStore = function () {
	  ProfileStore.$inject = ["ProfileApiService", "DashboardApiService"];
	  function ProfileStore(ProfileApiService, DashboardApiService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProfileStore);
	    this.ProfileApiService = ProfileApiService;
	    this.DashboardApiService = DashboardApiService;
	  }
	
	  (0, _createClass3.default)(ProfileStore, [{
	    key: 'getDashboardDetails',
	    value: function getDashboardDetails() {
	      return this.DashboardApiService.dashboard().then(function (details) {
	        return {
	          others: makeOtherDetails(details)
	        };
	      });
	    }
	  }, {
	    key: 'getProfile',
	    value: function getProfile() {
	      return this.ProfileApiService.profile();
	    }
	  }]);
	  return ProfileStore;
	}();
	
	exports.default = ProfileStore;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fileList = __webpack_require__(1173);
	
	var _fileList2 = _interopRequireDefault(_fileList);
	
	var _fileList3 = __webpack_require__(1174);
	
	var _fileList4 = _interopRequireDefault(_fileList3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fileListComponent = {
	  bindings: {
	    files: '<'
	  },
	  template: _fileList2.default,
	  controller: _fileList4.default
	};
	
	exports.default = fileListComponent;

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-heading kyc-upload-heading\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <form class=\"form-horizontal kyc-upload\">\n        <div class=\"form-group\">\n          <div class=\"kyc-up\">\n            <input id=\"upload-input\" ng-disabled=\"!$parent.$ctrl.model.enabled\" type=\"file\" multiple file-model=\"filesToUpload\">\n            <div class=\"kyc-image\">\n              <img src=\"assets/images/kyc-upload-image.svg\">\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-9\">\n                <p class=\"file-count hidden\">\n                  {{ filesToUpload.length }}\n                  {{ 'file(s) selected. Click upload to proceed.' | translate }}\n                </p>\n                <p class=\"reset-div m-b-0 hidden\">\n                  {{ 'Drag and drop files here or' | translate }}\n                  <span class='browse-btn'>{{ 'Select file(s)' | translate }}</span><br>\n                  <small>{{ 'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 20MB is allowed.' | translate }}</small><br>\n                  <small class=\"hidden error-val\">{{ 'The file is too large (MB). Allowed maximum size is 20MB.' | translate }}<br></small>\n                  <small class=\"hidden error-ext\">{{ 'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.' | translate }}<br></small>\n                </p>\n                <p class=\"file-uploading hidden\">{{ 'File(s) still uploading, please wait.' | translate }}</p>\n              </div>\n              <div class=\"col-lg-3\">\n                <ladda-button class=\"up-button\" ladda-disable=\"filesToUpload.length < 1\" text=\"'Upload'\" ng-click=\"$ctrl.uploadFiles()\"></ladda-button>\n              </div>\n            </div>\n            \n            <div ng-show=\"uploadSuccessful\" class=\"alert alert-success custom-notif no-m ng-binding\">\n              {{ 'Successfully uploaded!' | translate }}\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n\n<div class=\"panel-body kyc-upload-body\">\n    <div class=\"kyc-documents\">\n        <h1>{{ 'Documents uploaded' | translate }}:</h1>\n        <ul>\n          <file ng-repeat=\"file in files\" file=\"file\"></file>\n        </ul>\n    </div>\n</div>\n\n<div class=\"modal kyc-modal-preview fade bd-example-modal-lg\" id=\"kycFileModal\" ng-click=\"$ctrl.closeModalsOutside()\">\n    <div class=\"modal-dialog\">\n\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeButton()\">&times;</button>\n            </div>\n            <div class=\"img-loading\" ng-show=\"renderingFile\">\n                <center>\n                    <div class=\"kyc-loader\"></div>\n                </center>\n            </div>\n            <!-- <div ng-show=\"renderingFile\">\n              Loading...\n            </div> -->\n            <div class=\"modal-body\" ng-hide=\"{{ !isImage }}\">\n                <img class=\"img-kyc\" ng-src=\"{{ selectedFile.previewLink }}\">\n            </div>\n            <div class=\"modal-footer\">\n                <div class=\"kyc-file-delete\">\n                    <ul>\n                        <!--<li><button class=\"btn btn-danger\" data-toggle=\"modal\" ng-click=\"$ctrl.showDeleteModal()\"><i class=\"far fa-trash-alt\"></i></button></li>-->\n                        <li>\n                            <p><a ng-click=\"$event.stopPropagation();\" ng-href=\"{{ selectedFile.downloadLink }}\" download=\"{{ selectedFile.filename }}\"><i class=\"fa fa-download\"></i> {{ selectedFile.filename }}</a></p>\n                            <small>{{ 'Uploaded' | translate }} {{ selectedFile.lastModified | date: 'dd MMM yyyy' }}</small>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>\n<!-- Modal -->\n<div class=\"modal kyc-modal-delete fade\" id=\"kycDelete\" role=\"dialog\">\n    <div class=\"modal-dialog modal-dialog-centered \">\n\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <h1>Delete Document</h1>\n            <p>Are you sure you want to delete this document?</p>\n            <button class=\"btn btn-secondary\" data-dismiss=\"modal\">Cancel</button>\n            <button class=\"btn btn-danger\" ng-click=\"$ctrl.deleteFile()\">Delete</button>\n        </div>\n\n    </div>\n</div>\n\n<div style=\"display: none;\" class=\"modal-backdrop fade in\" id=\"kyc-files\"></div>\n"

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(1175);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _modal = __webpack_require__(1096);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileListController = function (_BaseController) {
	  FileListController.$inject = ["ProfileStore", "HttpService", "SessionService", "$scope", "FormService", "AppService", "$timeout", "$sce", "$translate"];
	  (0, _inherits3.default)(FileListController, _BaseController);
	
	  function FileListController(ProfileStore, HttpService, SessionService, $scope, FormService, AppService, $timeout, $sce, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FileListController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FileListController.__proto__ || (0, _getPrototypeOf2.default)(FileListController)).call(this, AppService));
	
	    _this.$scope = $scope;
	    _this.$scope.renderingFile = false;
	    _this.$scope.filesToUpload = [];
	    _this.ProfileStore = ProfileStore;
	    _this.HttpService = HttpService;
	    _this.SessionService = SessionService;
	    _this.FormService = FormService;
	    _this.$timeout = $timeout;
	    _this.$sce = $sce;
	    _this.$translate = $translate;
	    _this.fileCount = 0;
	
	    _this.$scope.$on('fileRendered', function (event, file) {
	      $('.modal-body').removeClass('ng-hide');
	      $('.modal-body img').removeClass("hidden");
	      _this.$scope.renderingFile = false;
	      if (file.ext.toLowerCase() === 'pdf') {
	        file.previewLink = '/assets/images/pdf_icon.svg';
	      } else if (['doc', 'docx'].indexOf(file.ext.toLowerCase()) >= 0) {
	        file.previewLink = '/assets/images/docs_icon.svg';
	      } else {
	        file.previewLink = file.downloadLink;
	      }
	    });
	
	    _this.$scope.$on('fileSelected', function (event, file) {
	      _this.$scope.renderingFile = true;
	      _this.$scope.selectedFile = file;
	      _this.$scope.isImage = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'bmp'].indexOf(file.ext.toLowerCase()) >= 0;
	      if (typeof file.fileUri === 'undefined') {
	        if (file.storage === 'S3') {
	          _this.HttpService.get('/' + _this.SessionService.getLocale() + '/profile/file/uri/' + file.filename).then(function (uri) {
	            _this.$scope.selectedFile.fileUri = uri;
	            _this.$scope.$emit('renderFile');
	          });
	        } else {
	          _this.$scope.selectedFile.fileUri = '/' + _this.SessionService.getLocale() + '/profile/file/' + file.filename;
	          _this.$scope.$emit('renderFile');
	        }
	      } else {
	        _this.$scope.$emit('renderFile');
	      }
	      (0, _modal.showModal)('kycFileModal');
	      $('.modal-backdrop').hide();
	      $('#kyc-files').show();
	    });
	
	    _this.$scope.$on('renderFile', function () {
	      _this.renderFile(_this.$scope.selectedFile);
	    });
	
	    _this.$scope.$on('reloadFiles', function () {
	      _this.reloadFiles();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(FileListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.$scope.$emit('reloadFiles');
	      this.addListener(_events2.default.KYC_FILE_UPLOADED, function (event) {
	        return _this2.reloadFiles();
	      });
	      this.addListener(_events2.default.KYC_FILE_DELETED, function (event) {
	        return _this2.reloadFiles();
	      });
	
	      this.$timeout(function () {
	        var uploadField = document.getElementById("upload-input");
	
	        var self = _this2;
	        uploadField.onchange = function () {
	          var hasError = false;
	          angular.forEach(this.files, function (file, key) {
	            if (hasError) {
	              return;
	            }
	            var ext = file.name.split('.').pop().toLowerCase();
	            if (file.size > 20971520) {
	              $(".kyc-up .error-val").removeClass("hidden");
	              $(".kyc-up .error-ext").addClass("hidden");
	              hasError = true;
	            } else if ($.inArray(ext, ['gif', 'png', 'jpg', 'jpeg', 'docx', 'pdf', 'doc']) == -1) {
	              $(".kyc-up .error-ext").removeClass("hidden");
	              $(".kyc-up .error-val").addClass("hidden");
	              hasError = true;
	            }
	          });
	          if (hasError) {
	            this.value = "";
	            $(".kyc-up .reset-div").removeClass("hidden");
	            $(".kyc-up .file-count, .kyc-up .file-uploading").addClass("hidden");
	            $(".kyc-upload")[0].reset();
	          } else {
	            self.fileCount = this.files.length;
	            $(".kyc-up .file-count").removeClass("hidden");
	            $(".kyc-up .reset-div, .kyc-up .file-uploading").addClass("hidden");
	            $(".kyc-up .error-ext").addClass("hidden");
	            $(".kyc-up .error-val").addClass("hidden");
	          }
	        };
	      });
	    }
	  }, {
	    key: 'reloadFiles',
	    value: function reloadFiles() {
	      var _this3 = this;
	
	      $(".kyc-up .reset-div").removeClass("hidden");
	      $(".kyc-up .file-count, .kyc-up .file-uploading").addClass("hidden");
	      $(".kyc-upload")[0].reset();
	
	      this.$scope.uploadSuccessful = false;
	      this.HttpService.get('/' + this.SessionService.getLocale() + '/profile/files').then(function (files) {
	        _this3.$scope.files = files;
	      });
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile() {
	      var _this4 = this;
	
	      var file = this.$scope.selectedFile;
	      this.HttpService.post('/' + this.SessionService.getLocale() + '/profile/file/' + file.filename + '/delete').then(function (response) {
	        _this4.$scope.selectedFile = null;
	        _this4.$scope.isImage = false;
	
	        _this4.closeModals();
	        // this.broadcast(EVENTS.KYC_FILE_DELETED);
	        _this4.$scope.$emit('reloadFiles');
	      });
	    }
	  }, {
	    key: 'uploadFiles',
	    value: function uploadFiles() {
	      var _this5 = this;
	
	      if (!this.$scope.filesToUpload || this.$scope.filesToUpload.length < 1) {
	        return;
	      }
	
	      this.FormService.isSubmitting.next(true);
	
	      var fd = new FormData();
	      if (this.$scope.filesToUpload.length > 1) {
	        (0, _from2.default)(this.$scope.filesToUpload).forEach(function (elem) {
	          fd.append('file[files][]', elem);
	          $(".kyc-up .file-uploading").removeClass("hidden");
	          $(".kyc-up .reset-div, .kyc-up .file-count").addClass("hidden");
	          $(".kyc-upload")[0].reset();
	        });
	      } else {
	        fd.append('file[files][]', this.$scope.filesToUpload[0]);
	        $(".kyc-up .file-uploading").removeClass("hidden");
	        $(".kyc-up .reset-div, .kyc-up .file-count").addClass("hidden");
	        $(".kyc-upload")[0].reset();
	      }
	
	      this.HttpService.post('/' + this.SessionService.getLocale() + '/profile/files', fd, 'json', {
	        'Content-Type': undefined
	      }).then(function () {
	
	        _this5.FormService.isSubmitting.next(false);
	        _this5.broadcast(_events2.default.KYC_FILE_UPLOADED);
	        _this5.$scope.uploadSuccessful = true;
	        _this5.$scope.filesToUpload = [];
	        setTimeout(function () {
	          _this5.$scope.$emit('reloadFiles');
	        }, 3000);
	      }).catch(function (errors) {
	        //show errors
	        _this5.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'renderFile',
	    value: function renderFile(file) {
	      var _this6 = this;
	
	      if (typeof file.downloadLink === 'undefined') {
	        if (file.storage === 'S3') {
	          this.HttpService.$http.get(file.fileUri, { responseType: 'arraybuffer' }).then(function (s3data) {
	            var fileObj = new Blob([s3data], { type: 'application/binary' });
	            file.downloadLink = _this6.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
	            if (_this6.$scope.isImage) {
	              file.previewLink = file.downloadLink;
	            }
	            _this6.$scope.$emit('fileRendered', _this6.$scope.selectedFile);
	          });
	        } else {
	          this.HttpService.get(file.fileUri, 'arraybuffer').then(function (response) {
	            var fileObj = new Blob([response], { type: 'application/binary' });
	            file.downloadLink = _this6.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
	            if (_this6.$scope.isImage) {
	              file.previewLink = file.downloadLink;
	            }
	            _this6.$scope.$emit('fileRendered', _this6.$scope.selectedFile);
	          });
	        }
	      } else {
	        this.$scope.$emit('fileRendered', this.$scope.selectedFile);
	      }
	    }
	  }, {
	    key: 'showDeleteModal',
	    value: function showDeleteModal() {
	      (0, _modal.showModal)('kycDelete');
	      $('.modal-backdrop').hide();
	      $('#kyc-files').show();
	    }
	  }, {
	    key: 'closeModals',
	    value: function closeModals() {
	      (0, _modal.hideModal)('kycDelete');
	      (0, _modal.hideModal)('kycFileModal');
	      $('#kyc-files').hide();
	    }
	  }, {
	    key: 'closeModalsOutside',
	    value: function closeModalsOutside() {
	      $('#kyc-files').fadeOut(300);
	      (0, _modal.hideModal)('kycFileModal');
	    }
	  }, {
	    key: 'selectFile',
	    value: function selectFile(file) {
	      this.$scope.$emit('fileSelected', file);
	    }
	  }, {
	    key: 'closeButton',
	    value: function closeButton() {
	      $('#kyc-files').hide();
	      $('.modal-body img').addClass("hidden");
	    }
	  }]);
	  return FileListController;
	}(_basecontroller.BaseController);
	
	exports.default = FileListController;

/***/ }),
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _file = __webpack_require__(1180);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _file3 = __webpack_require__(1181);
	
	var _file4 = _interopRequireDefault(_file3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fileComponent = {
	  bindings: {
	    file: '<'
	  },
	  template: _file2.default,
	  controller: _file4.default
	};
	
	exports.default = fileComponent;

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

	module.exports = "<li>\n  <span class=\"fa-li\"><i class=\"far fa-file-alt\"></i></span>\n  {{ $ctrl.file.filename }}\n</li>"

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileController = function FileController(HttpService) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, FileController);
	  this.HttpService = HttpService;
	};
	FileController.$inject = ["HttpService"];
	
	exports.default = FileController;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _angularSanitize = __webpack_require__(1183);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _deposit = __webpack_require__(1185);
	
	var _deposit2 = _interopRequireDefault(_deposit);
	
	var _ecopayzform = __webpack_require__(1196);
	
	var _ecopayzform2 = _interopRequireDefault(_ecopayzform);
	
	var _skrillform = __webpack_require__(1204);
	
	var _skrillform2 = _interopRequireDefault(_skrillform);
	
	var _netellerform = __webpack_require__(1208);
	
	var _netellerform2 = _interopRequireDefault(_netellerform);
	
	var _bankform = __webpack_require__(1212);
	
	var _bankform2 = _interopRequireDefault(_bankform);
	
	var _bitcoinform = __webpack_require__(1216);
	
	var _bitcoinform2 = _interopRequireDefault(_bitcoinform);
	
	var _successModal = __webpack_require__(1222);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _netellerModal = __webpack_require__(1225);
	
	var _netellerModal2 = _interopRequireDefault(_netellerModal);
	
	var _bankModal = __webpack_require__(1228);
	
	var _bankModal2 = _interopRequireDefault(_bankModal);
	
	var _skrillModal = __webpack_require__(1231);
	
	var _skrillModal2 = _interopRequireDefault(_skrillModal);
	
	var _successPage = __webpack_require__(1234);
	
	var _successPage2 = _interopRequireDefault(_successPage);
	
	var _failurePage = __webpack_require__(1237);
	
	var _failurePage2 = _interopRequireDefault(_failurePage);
	
	var _cancellationPage = __webpack_require__(1240);
	
	var _cancellationPage2 = _interopRequireDefault(_cancellationPage);
	
	var _deposit3 = __webpack_require__(1243);
	
	var _deposit4 = _interopRequireDefault(_deposit3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var depositModule = _angular2.default.module('deposit', [_angularjs2.default, _angularSanitize2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('deposit', {
	    parent: 'standardLayout',
	    url: '/transactions/deposit',
	    component: 'deposit',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  }).state('success', {
	    parent: 'standardLayout',
	    url: '/deposit/success',
	    component: 'successPageComponent',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  }).state('failure', {
	    parent: 'standardLayout',
	    url: '/deposit/failure',
	    component: 'failurePageComponent',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  }).state('cancel', {
	    parent: 'standardLayout',
	    url: '/deposit/cancel',
	    component: 'cancellationPageComponent',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('deposit', _deposit2.default).component('ecopayzForm', _ecopayzform2.default).component('skrillForm', _skrillform2.default).component('netellerForm', _netellerform2.default).component('bankForm', _bankform2.default).component('bitcoinForm', _bitcoinform2.default).component('depositSuccessModal', _successModal2.default).component('netellerModal', _netellerModal2.default).component('bankModal', _bankModal2.default).component('skrillModal', _skrillModal2.default).component('successPageComponent', _successPage2.default).component('failurePageComponent', _failurePage2.default).component('cancellationPageComponent', _cancellationPage2.default).service('DepositStore', _deposit4.default).name;
	
	exports.default = depositModule;

/***/ }),
/* 1183 */,
/* 1184 */,
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deposit = __webpack_require__(1186);
	
	var _deposit2 = _interopRequireDefault(_deposit);
	
	var _deposit3 = __webpack_require__(1187);
	
	var _deposit4 = _interopRequireDefault(_deposit3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var depositComponent = {
	  bindings: {
	    details: '<',
	    email: '<'
	  },
	  template: _deposit2.default,
	  controller: _deposit4.default
	};
	
	exports.default = depositComponent;

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray deposit-wrapper\">\n\t<div class=\"content\">\n\t\t<div class=\"container\">\n\t\t\t<div class=\"row mbot3\">\n        <div class=\"col-md-12\">\n          <h2 class=\"no-m\">{{ 'titles.transaction' | translate }}</h2>\n          <h4 class=\"no-m text-dark\">{{ 'titles.deposit' | translate }}</h4>\n        </div>\n      </div>\n      \n      <div class=\"row\">\n        <!-- Deposit Forms -->\n        <div class=\"col-lg-9 col-md-8 col-sm-12 fadeIn animated index-one mbot3\">\n          <div loading=\"$ctrl.PaymentOptionsViewDetails\"></div>\n\n          <!-- Tab List -->\n          <div class=\"row\" ng-if=\"$ctrl.PaymentOptionsViewDetails\">\n            <div class=\"col-md-12\">\n              <ul class=\"nav nav-tabs nav-justified deposit-tabs\">\n                <li ng-click=\"$ctrl.onPaymentOptionsSelected(paymentOption)\" ng-repeat=\"paymentOption in $ctrl.paymentOptions\" ng-class=\"{'active': paymentOption.activeTab}\">\n                  <a data-toggle=\"tab\" aria-expanded=\"false\">\n                  <span>{{ paymentOption.type }}</span>\n                  </a>\n                </li>\n              </ul>\n            </div>\n          </div>\n      \n          <!-- Tab Body -->\n          <div class=\"tab-content\">\n            <ecopayz-form \n              ng-if=\"$ctrl.details && $ctrl.isEcopayz()\" \n              on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\" \n              details=\"$ctrl.details\" \n              selected-payment-option=\"$ctrl.selectedPaymentOption\"></ecopayz-form>\n  \n            <skrill-form \n              ng-if=\"$ctrl.details && $ctrl.isSkrill()\" \n              on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\" \n              details=\"$ctrl.details\" \n              selected-payment-option=\"$ctrl.selectedPaymentOption\"></skrill-form>\n  \n            <neteller-form \n              ng-if=\"$ctrl.details && $ctrl.isNeteller()\" \n              on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\" \n              details=\"$ctrl.details\" \n              selected-payment-option=\"$ctrl.selectedPaymentOption\"></neteller-form>\n              \n            <bitcoin-form \n              ng-if=\"$ctrl.details && $ctrl.isBitcoin()\" \n              on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\" \n              details=\"$ctrl.details\" \n              selected-payment-option=\"$ctrl.selectedPaymentOption\"></bitcoin-form>\n\n            <bank-form\n              ng-if=\"$ctrl.details && $ctrl.isBank()\"\n              on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\"\n              details=\"$ctrl.details\"\n              selected-payment-option=\"$ctrl.selectedPaymentOption\"></bank-form>\n          </div>\n        </div>\n\n        <div class=\"col-lg-3 col-md-4 col-sm-12 fadeIn animated index-zero\">\n          <customer-product-widget on-customer-products-loaded=\"$ctrl.onCustomerProductsLoaded(customerProductsList)\"></customer-product-widget>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<product-password-widget></product-password-widget>\n<request-product-modal></request-product-modal>\n<deposit-success-modal on-closed=\"$ctrl.finishTransaction()\"></deposit-success-modal>\n<skrill-modal modal=\"$ctrl.skrillModal\"></skrill-modal>\n<neteller-modal modal=\"$ctrl.netellerModal\"></neteller-modal>\n<bank-modal modal=\"$ctrl.bankModal\"></bank-modal>\n"

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1188);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _successModal = __webpack_require__(1192);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _netellerModal = __webpack_require__(1193);
	
	var _netellerModal2 = _interopRequireDefault(_netellerModal);
	
	var _skrillModal = __webpack_require__(1194);
	
	var _skrillModal2 = _interopRequireDefault(_skrillModal);
	
	var _bankModal = __webpack_require__(1195);
	
	var _bankModal2 = _interopRequireDefault(_bankModal);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _modal = __webpack_require__(1096);
	
	var _basecontroller = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DepositController = function (_BaseController) {
	  DepositController.$inject = ["AppService", "DepositStore", "$timeout", "$translate"];
	  (0, _inherits3.default)(DepositController, _BaseController);
	
	  function DepositController(AppService, DepositStore, $timeout, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DepositController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DepositController.__proto__ || (0, _getPrototypeOf2.default)(DepositController)).call(this, AppService));
	
	    _this.DepositStore = DepositStore;
	
	    _this.$timeout = $timeout;
	    _this.$translate = $translate;
	    _this.isEnabled = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(DepositController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.modalForm = new _successModal2.default();
	      this.netellerModal = new _netellerModal2.default();
	      this.skrillModal = new _skrillModal2.default();
	      this.bankModal = new _bankModal2.default();
	
	      this.detailsSubscription = this.DepositStore.getDepositDetails().subscribe(function (details) {
	        _this2.details = details;
	        _this2.paymentOptions = _this2.details.paymentOptions;
	        _this2.PaymentOptionsViewDetails = details.paymentOptionsViewDetails;
	        _this2.onPaymentOptionsSelected(_this2.paymentOptions[0]);
	      });
	
	      this.removeSettingsHighlight();
	      this.checkStatus();
	
	      this.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this2.refreshCustomerProducts();
	      });
	      this.addListener(_events2.default.TRANSACTION_PROCESSED, function (event) {
	        return _this2.refreshCustomerProducts();
	      });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      (0, _get3.default)(DepositController.prototype.__proto__ || (0, _getPrototypeOf2.default)(DepositController.prototype), '$onDestroy', this).call(this);
	      this.detailsSubscription.unsubscribe();
	    }
	  }, {
	    key: 'onPaymentOptionsSelected',
	    value: function onPaymentOptionsSelected(paymentOption) {
	      this.selectedPaymentOption = paymentOption;
	
	      // // highlight active tab.
	      angular.forEach(this.paymentOptions, function (value) {
	        return value.activeTab = false;
	      });
	      paymentOption.activeTab = true;
	
	      // // update view details
	      this.PaymentOptionsViewDetails.updateView(paymentOption);
	    }
	  }, {
	    key: 'isEcopayz',
	    value: function isEcopayz() {
	      return this.selectedPaymentOption.type === 'ECOPAYZ';
	    }
	  }, {
	    key: 'isSkrill',
	    value: function isSkrill() {
	      return this.selectedPaymentOption.type === 'SKRILL';
	    }
	  }, {
	    key: 'isNeteller',
	    value: function isNeteller() {
	      return this.selectedPaymentOption.type === 'NETELLER';
	    }
	  }, {
	    key: 'isBitcoin',
	    value: function isBitcoin() {
	      return this.selectedPaymentOption.type === 'BITCOIN';
	    }
	  }, {
	    key: 'isBank',
	    value: function isBank() {
	      return this.selectedPaymentOption.type === 'BANK';
	    }
	  }, {
	    key: 'onSuccessfulSubmission',
	    value: function onSuccessfulSubmission(form, viewDetails) {
	      this.selectedPaymentOption.email = form.email;
	
	      if (form.isSkrill) {
	        var skrillAccount = viewDetails.activeDisplay.fields.email.value;
	        this.skrillModal.content = this.$translate.instant('skrillContent') + skrillAccount;
	
	        (0, _modal.showModal)('skrillModal');
	      }
	
	      if (form.isNeteller) {
	        if (viewDetails.activeDisplay.fields.email) {
	          var netellerEmail = viewDetails.activeDisplay.fields.email.value;
	          this.netellerModal.content = this.$translate.instant('netellerContent') + netellerEmail;
	        } else {
	          var netellerMerchantId = viewDetails.activeDisplay.fields.merchantId.value;
	          var netellerMerchantTransferCode = viewDetails.activeDisplay.fields.merchantTransferCode.value;
	          this.netellerModal.content = this.$translate.instant('netellerTransferNote') + netellerMerchantId + this.$translate.instant('netellerTransferNote2') + netellerMerchantTransferCode;
	        }
	
	        (0, _modal.showModal)('netellerModal');
	      }
	
	      if (form.isBank) {
	        this.bankModal.content = this.$translate.instant('verifyDeposit');
	
	        (0, _modal.showModal)('bankModal');
	      }
	
	      // else wait for Ecopayz redirect.
	    }
	  }, {
	    key: 'refreshCustomerProducts',
	    value: function refreshCustomerProducts() {
	      this.broadcast('reload.customer-products');
	    }
	  }, {
	    key: 'checkStatus',
	    value: function checkStatus() {
	      var _this3 = this;
	
	      this.DepositStore.getStatus().then(function (response) {
	        if (response.is_enabled) {
	          _this3.modalForm.successMessage = 'you will see the additional funds reflected in your account.';
	          _this3.isEnabled = true;
	        }
	
	        $('#on-success-message').text(_this3.$translate.instant(_this3.modalForm.successMessage));
	      });
	    }
	  }, {
	    key: 'removeSettingsHighlight',
	    value: function removeSettingsHighlight() {
	      this.$timeout(function () {
	        $('#settings').removeClass('subdrop');
	      }, 100);
	    }
	  }]);
	  return DepositController;
	}(_basecontroller.BaseController);
	
	exports.default = DepositController;

/***/ }),
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessModalModel = function SuccessModalModel() {
	    (0, _classCallCheck3.default)(this, SuccessModalModel);
	
	    this.successMessage = 'we will send you the username and password of your newly registered account.';
	};
	
	;
	
	exports.default = SuccessModalModel;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetellerModalModel = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetellerModalModel = exports.NetellerModalModel = function () {
	  function NetellerModalModel() {
	    (0, _classCallCheck3.default)(this, NetellerModalModel);
	
	    this._content = null;
	  }
	
	  (0, _createClass3.default)(NetellerModalModel, [{
	    key: "content",
	    set: function set(content) {
	      this._content = content;
	    },
	    get: function get() {
	      return this._content;
	    }
	  }]);
	  return NetellerModalModel;
	}();
	
	exports.default = NetellerModalModel;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SkrillModalModel = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkrillModalModel = exports.SkrillModalModel = function () {
	  function SkrillModalModel() {
	    (0, _classCallCheck3.default)(this, SkrillModalModel);
	
	    this._content = null;
	  }
	
	  (0, _createClass3.default)(SkrillModalModel, [{
	    key: "content",
	    set: function set(content) {
	      this._content = content;
	    },
	    get: function get() {
	      return this._content;
	    }
	  }]);
	  return SkrillModalModel;
	}();
	
	exports.default = SkrillModalModel;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BankModalModel = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankModalModel = exports.BankModalModel = function () {
	  function BankModalModel() {
	    (0, _classCallCheck3.default)(this, BankModalModel);
	
	    this._content = null;
	  }
	
	  (0, _createClass3.default)(BankModalModel, [{
	    key: "content",
	    set: function set(content) {
	      this._content = content;
	    },
	    get: function get() {
	      return this._content;
	    }
	  }]);
	  return BankModalModel;
	}();
	
	exports.default = BankModalModel;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ecopayzform = __webpack_require__(1197);
	
	var _ecopayzform2 = _interopRequireDefault(_ecopayzform);
	
	var _ecopayzform3 = __webpack_require__(1198);
	
	var _ecopayzform4 = _interopRequireDefault(_ecopayzform3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ecopayzFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _ecopayzform2.default,
	  controller: _ecopayzform4.default
	};
	
	exports.default = ecopayzFormComponent;

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white gateway-wrapper\">\n  <div class=\"flex-row mh-80 vh-center\">\n    <div class=\"p-lr-30 mtop2\" ng-show=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">\n      <!-- <p class=\"m-t-10\" ng-bind-html=\"$ctrl.paymentOptionsViewDetails.activeDisplay.details.selected\"></p> -->\n      <ul class=\"depositForm depositForm-btc\">\n        <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.processingTime }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'minimumDeposit' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.minimumDeposit }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'maximumDeposit' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.maximumDeposit }}</li>\n      </ul>\n    </div>\n  </div>\n\n  <hr class=\"m-10\">\n\n  <div class=\"flex-row\">\n    <div class=\"col-lg-8\">\n      <form class=\"form-horizontal p-lr\" action=\"\">\n        <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n          <div class=\"alert alert-success notif-success mbot2\">\n            <p>{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.selectBookie }}</p>\n          </div>\n          <!-- Initial deposit form -->            \n          <div class=\"col-lg-6\">\n            <div ng-show=\"!$ctrl.form.formViews.isEcopayz\" class=\"form-group ecopayz-email\">\n              <label class=\"control-label\">{{ 'Account ID' | translate }}</label>\n              <div class=\"\">\n                <input ng-model=\"$ctrl.form.email\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.email }\" type=\"text\" class=\"form-control\">\n                <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.email\">\n                  <li ng-repeat=\"(key, error) in $ctrl.form.error.email\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-lg-12\">\n            <!-- Product Panel -->\n            <div class=\"product-selection-panel\">\n              <div class=\"row visible-lg visible-md\">\n                <div class=\"col-lg-6 col-md-6\">\n                  <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                </div>\n                <div class=\"col-lg-6 col-md-6\">\n                  <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                </div>\n              </div>\n              <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n                <!-- Product -->\n                <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                  <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-11 col-xs-10 m-b-10\">\n                  <select\n                    ng-model=\"subTransaction.product\"\n                    ng-init=\"oldValue=null\"\n                    ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                    ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                    ng-click=\"oldValue=subTransaction.product\"\n                    ng-disabled=\"$ctrl.form.props.readOnly\"\n                    ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\" class=\"form-control\">\n                    <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                    <!-- <option ng-repeat=\"customerProduct in $ctrl.form.customerProducts\" ng-value=\"{{ customerProduct.id }}\">{{ customerProduct.productName}} ({{ customerProduct.username }})</option> -->\n                  </select>\n                  <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                    <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                  </ul>\n                </div>\n                <!-- Mobile x button -->\n                <div class=\"visible-sm visible-xs col-sm-1 col-xs-2\">\n                  <button ng-hide=\"$ctrl.form.isReadOnly\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\" class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n                </div>\n                <!-- Amount-->\n                <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 product-amount\">\n                  <div class=\"row\">\n                    <!-- Amount Input -->\n                    <div class=\"col-lg-11 col-md-11 col-sm-12 col-xs-12 m-b-10\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ |async }}</span>\n                        <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\" limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control\">\n                      </div>\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </div>  \n                    <div class=\"visible-md visible-lg col-lg-1 col-md-1 close-btn\">\n                      <button ng-show=\"$ctrl.form.props.readOnly === false\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\"\n                        class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!-- Errors -->\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                  <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}</button>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                  <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Deposit'\"></ladda-button>\n                  <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n                </div>\n                <!-- Hiding this for now will implement when Deposit slip feature is already available-->\n                <!--<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 m-b-0\">-->\n                  <!--<input type=\"file\" class=\"filestyle\" data-placeholder=\"No file\" id=\"filestyle-9\" tabindex=\"-1\" style=\"position: absolute; clip: rect(0px 0px 0px 0px);\"><div class=\"bootstrap-filestyle input-group\"><input type=\"text\" class=\"form-control \" placeholder=\"Attach a copy of your deposit slip\" disabled=\"\"> <span class=\"group-span-filestyle input-group-btn\" tabindex=\"0\"><label for=\"filestyle-9\" class=\"btn btn-default \"><span class=\"icon-span-filestyle fa fa-image\"></span> <span class=\"buttonText\">Choose file</span></label></span></div>-->\n                <!--</div>-->\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <!-- Sidebar -->\n    <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap ecopayz-bg active\">\n        <i class=\"fas fa-receipt visible-md visible-xs visible-sm\" type=\"button\"></i>\n        <div class=\"gateway-sidebar\">\n          <img src=\"{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.logo }}\" class=\"payment-option-logo\">\n    \n          <!-- Merchant Details -->\n          <div class=\"merchant-details\">\n            <h4 ng-repeat=\"field in $ctrl.paymentOptionsViewDetails.activeDisplay.fields\" class=\"ac-white-text\">{{ field.label | translate }}: {{ field.value}}</h4>\n          </div>\n\n          <hr class=\"m-10\">\n          \n          <!-- Transaction Summary -->\n          <div class=\"transaction-summary\">\n            <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n            <div class=\"font-lg\">\n              <p>{{ 'Amount to deposit' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmount |number }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n\n              <p>{{ 'Fee' | translate }}:<br>\n                <span ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') === 'FREE'\" class=\"bold\">{{ 'Free' | translate }}</span>\n                <span ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') !== 'FREE'\" class=\"bold\">{{ $ctrl.form.fee |number: 2}} {{ $ctrl.userCurrency$ |async }}</span>\n              </p>\n              \n              <hr class=\"m-10\">\n              <p class=\"uppercase\">{{ 'Total amount to deposit' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmountToSend }} {{ $ctrl.userCurrency$ | async }}</span></p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div> \n"

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _ecopayzform = __webpack_require__(1199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EcopayzFormController = function (_BaseController) {
	  EcopayzFormController.$inject = ["DepositStore", "EventDispatcherService", "FormService", "PaymentOptionApiService", "TransactionApiService", "$timeout"];
	  (0, _inherits3.default)(EcopayzFormController, _BaseController);
	
	  function EcopayzFormController(DepositStore, EventDispatcherService, FormService, PaymentOptionApiService, TransactionApiService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EcopayzFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EcopayzFormController.__proto__ || (0, _getPrototypeOf2.default)(EcopayzFormController)).call(this));
	
	    _this.DepositStore = DepositStore;
	    _this.EventDispatcherService = EventDispatcherService;
	    _this.FormService = FormService;
	    _this.PaymentOptionApiService = PaymentOptionApiService;
	    _this.TransactionApiService = TransactionApiService;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(EcopayzFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.userCurrency$ = this.DepositStore.getCurrency();
	
	      this.form = new _ecopayzform.EcopayzForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('deposit');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('deposit');
	      this.form.email = this.selectedPaymentOption.extras.accountId;
	
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.DepositStore.deposit(this.form.toPayload()).then(function () {
	        return _this2.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        console.log(errors);
	        _this2.form.error.setFormErrors(errors);
	        _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return EcopayzFormController;
	}(_basecontroller.BaseController);
	
	exports.default = EcopayzFormController;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EcopayzForm = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1188);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _transactionform = __webpack_require__(1200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EcopayzForm = exports.EcopayzForm = function (_TransactionForm) {
	  (0, _inherits3.default)(EcopayzForm, _TransactionForm);
	
	  function EcopayzForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, EcopayzForm);
	    return (0, _possibleConstructorReturn3.default)(this, (EcopayzForm.__proto__ || (0, _getPrototypeOf2.default)(EcopayzForm)).call(this, customerProducts, paymentOptions));
	  }
	
	  (0, _createClass3.default)(EcopayzForm, [{
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = (0, _get3.default)(EcopayzForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(EcopayzForm.prototype), 'toPayload', this).call(this);
	
	      payload['returnUrl'] = _environment2.default.ECOPAYZ_SUCCESS_URL;
	      payload['failureUrl'] = _environment2.default.ECOPAYZ_FAILURE_URL;
	      payload['cancelUrl'] = _environment2.default.ECOPAYZ_CANCELATION_URL;
	
	      return payload;
	    }
	  }]);
	  return EcopayzForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TransactionForm = exports.SubTransaction = undefined;
	
	var _slicedToArray2 = __webpack_require__(447);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1201);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	var _number = __webpack_require__(1203);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _number2 = __webpack_require__(1203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO Change this to SubtransactionForm to avoid confusion with api models.
	var SubTransaction = exports.SubTransaction = function () {
	  function SubTransaction(key) {
	    (0, _classCallCheck3.default)(this, SubTransaction);
	
	    this.key = key;
	
	    // NOTE: This is actually customer product.
	    this.product = null;
	    this.amount = 0;
	
	    this.btc = 0;
	    this.receiverAddress = null;
	
	    this.customerProducts = [];
	  }
	
	  (0, _createClass3.default)(SubTransaction, [{
	    key: 'convertBtcToAmount',
	    value: function convertBtcToAmount(btcAdjustedRate) {
	      var converted = (0, _numeral2.default)(btcAdjustedRate * this.btc);
	      this.amount = (0, _number.format)(converted, _number2.DEFAULT_DECIMAL_FORMAT);
	    }
	  }, {
	    key: 'convertAmountToBtc',
	    value: function convertAmountToBtc(btcAdjustedRate) {
	      var converted = (0, _numeral2.default)(this.amount / btcAdjustedRate);
	      this.btc = (0, _number.format)(converted, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }, {
	    key: 'formattedBtc',
	    get: function get() {
	      return (0, _number.format)((0, _numeral2.default)(this.btc), _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }, {
	    key: 'formattedAmount',
	    get: function get() {
	      return (0, _number.format)((0, _numeral2.default)(this.amount), _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }, {
	    key: 'customerProductDisplay',
	    get: function get() {
	      var _this = this;
	
	      var customerProduct = this.customerProducts.filter(function (customerProduct) {
	        return customerProduct.id === _this.product;
	      })[0];
	
	      return customerProduct.product.name + ' (' + customerProduct.username + ')';
	    }
	  }]);
	  return SubTransaction;
	}();
	
	var TransactionForm = exports.TransactionForm = function () {
	  function TransactionForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, TransactionForm);
	
	
	    this.email = null;
	    this.amount = null;
	    this.file = null;
	    this.paymentOption = null;
	    this.subTransactions = [];
	    this.customerProducts = customerProducts;
	    this.paymentOptions = paymentOptions;
	    this.paymentOptionType = null;
	
	    this.selectedCustomerProducts = [];
	
	    this.error = new _formError2.default();
	    this.nextItemKey = 0;
	
	    // This becomes true when the customer comes from France coz we loved France so much.
	    this.feeFree = false;
	    this.feeMultiplier = null;
	
	    this.props = {
	      readOnly: false,
	      isSubmitting: false,
	      isReady: false
	    };
	
	    this.addSubTransaction();
	    // Some extra vars for updating views
	    this.formViews = {
	      isBank: false,
	      isEcopayz: false,
	      isSkrill: false,
	      isNeteller: false
	    };
	  }
	
	  (0, _createClass3.default)(TransactionForm, [{
	    key: 'addSubTransaction',
	    value: function addSubTransaction() {
	      var _this2 = this;
	
	      var subTransaction = new SubTransaction(this.nextItemKey);
	      var shallowCopy = this.customerProducts.slice(0); //copy by value not reference.
	      shallowCopy = shallowCopy.filter(function (item) {
	        return !_this2.selectedCustomerProducts.includes(item.id);
	      });
	      subTransaction.customerProducts = shallowCopy;
	
	      if (this.customerProducts.length === 1) {
	        subTransaction.product = this.customerProducts[0].id;
	      }
	
	      this.subTransactions.push(subTransaction);
	      this.nextItemKey++;
	
	      return subTransaction;
	    }
	  }, {
	    key: 'addPredefinedSubTransaction',
	    value: function addPredefinedSubTransaction(productId) {
	      var _this3 = this;
	
	      var subTransaction = new SubTransaction(this.nextItemKey);
	      var shallowCopy = this.customerProducts.slice(0); //copy by value not reference.
	      shallowCopy = shallowCopy.filter(function (item) {
	        return !_this3.selectedCustomerProducts.includes(item.id);
	      });
	      subTransaction.customerProducts = shallowCopy;
	      subTransaction.product = +productId;
	
	      this.subTransactions.push(subTransaction);
	      this.nextItemKey++;
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.removeFromSelectedProducts(subTransaction.product);
	      this.reloadToAllCustomerProducts(subTransaction.product, index);
	
	      for (var i = 0; i < this.subTransactions.length; i++) {
	        if (this.subTransactions[i].key === subTransaction.key) {
	          this.subTransactions.splice(i, 1);
	          break;
	        }
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.amount = null;
	
	      this.error = new _formError2.default();
	      this.nextItemKey = 0;
	
	      // TODO: Should we reset this also?
	      this.props.readOnly = false;
	      this.props.isSubmitting = false;
	      this.props.isReady = false;
	
	      this.subTransactions = [];
	      this.selectedCustomerProducts = [];
	
	      this.addSubTransaction();
	    }
	  }, {
	    key: 'clearError',
	    value: function clearError() {
	      this.error = new _formError2.default();
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        transaction: {
	          email: this.email,
	          paymentOptionType: this.paymentOptionType,
	          file: this.file instanceof Array || this.file instanceof FileList ? this.file[0] : this.file
	        }
	      };
	
	      payload['transaction']['paymentOption'] = this.paymentOption;
	      payload['transaction']['customerFee'] = this.paymentOptionType === 'BANK' ? this.bankFee : this.fee;
	
	      var subTransactions = {};
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.subTransactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var subTransaction = _step.value;
	
	          subTransactions[subTransaction.key] = {
	            product: subTransaction.product,
	            amount: subTransaction.amount
	          };
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      payload['transaction']['subTransactions'] = subTransactions;
	
	      if (this.file !== null) {
	        payload = this.getBankPayload(payload);
	      }
	
	      return payload;
	    }
	  }, {
	    key: 'getBankPayload',
	    value: function getBankPayload(payload) {
	      var formData = new FormData();
	
	      formData.append('transaction[email]', payload.transaction.email);
	      formData.append('transaction[paymentOptionType]', payload.transaction.paymentOptionType);
	      formData.append('transaction[file]', payload.transaction.file);
	      formData.append('transaction[paymentOption]', payload.transaction.paymentOption);
	      formData.append('transaction[customerFee]', payload.transaction.customerFee);
	
	      angular.forEach(payload.transaction.subTransactions, function (subTransaction, key) {
	        var index = 'transaction[subTransactions][' + key + ']';
	
	        formData.append(index + '[product]', subTransaction.product);
	        formData.append(index + '[amount]', subTransaction.amount);
	      });
	
	      return formData;
	    }
	
	    //============================================================================
	    //  Code Below handles operations when a change in product selection occurs.
	    //============================================================================
	
	  }, {
	    key: 'onChangedCustomerProduct',
	    value: function onChangedCustomerProduct(index, newValue, oldValue) {
	      this.selectedCustomerProducts.push(newValue);
	      this.removeFromSelectedProducts(oldValue);
	      this.removeFromSelection(newValue, index);
	      this.reloadToAllCustomerProducts(oldValue, index);
	    }
	  }, {
	    key: 'removeFromSelection',
	    value: function removeFromSelection(newValue, index) {
	      // Remove CustomerProduct with id matching the newValue within each SubTransactions
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.subTransactions.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
	              sIndex = _step2$value[0],
	              subTransaction = _step2$value[1];
	
	          // This condition will not remove the CustomerProduct from the owning SubTransaction.
	          // The reason is that, when we tried to remove it, the ng-model will be affected does
	          // will unselect the selection. Apparently, this is the same implementation on OLD AMS.
	          if (index !== sIndex) {
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = (0, _getIterator3.default)(this.subTransactions[sIndex].customerProducts.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
	                    cIndex = _step3$value[0],
	                    customerProduct = _step3$value[1];
	
	                if (customerProduct.id === newValue) {
	                  this.subTransactions[sIndex].customerProducts.splice(cIndex, 1);
	                }
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'removeFromSelectedProducts',
	    value: function removeFromSelectedProducts(value) {
	      if (value) {
	        var oldValueIndex = this.selectedCustomerProducts.indexOf(value);
	        this.selectedCustomerProducts.splice(oldValueIndex, 1);
	      }
	    }
	
	    // Push CustomerProduct with id matching the oldValue (if oldValue is not null) within each SubTransactions
	
	  }, {
	    key: 'reloadToAllCustomerProducts',
	    value: function reloadToAllCustomerProducts(oldValue, index) {
	      if (oldValue) {
	        var oldCustomerProduct = this.getCustomerProductById(oldValue);
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(this.subTransactions.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
	                sIndex = _step4$value[0],
	                subTransaction = _step4$value[1];
	
	            if (index !== sIndex) {
	              subTransaction.customerProducts.push(oldCustomerProduct);
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getCustomerProductById',
	    value: function getCustomerProductById(id) {
	      return this.customerProducts.filter(function (customerProduct) {
	        return customerProduct.id === id;
	      })[0];
	    }
	  }, {
	    key: 'totalAmount',
	    get: function get() {
	      var totalAmount = (0, _numeral2.default)(0);
	
	      angular.forEach(this.subTransactions, function (subTransaction) {
	        totalAmount.add(subTransaction.amount);
	      });
	
	      return totalAmount.format('0.00');
	    }
	  }, {
	    key: 'totalAmountToSend',
	    get: function get() {
	      var totalAmount = (0, _numeral2.default)(this.totalAmount);
	      totalAmount = totalAmount.add(this.fee);
	
	      return totalAmount.format('0.00');
	    }
	  }, {
	    key: 'totalAmountToBeDeposited',
	    get: function get() {
	      var actualFee = this.paymentOptionType === 'BANK' ? this.bankFee : this.fee;
	      var totalAmount = Number(this.totalAmount);
	      actualFee = Number(actualFee);
	      totalAmount = totalAmount + actualFee;
	
	      return totalAmount;
	    }
	  }, {
	    key: 'fee',
	    get: function get() {
	      if (this.feeFree) {
	        return 0;
	      }
	
	      var actualFee = (0, _numeral2.default)(this.totalAmount * this.feeMultiplier);
	
	      return actualFee.format('0.00');
	    }
	  }, {
	    key: 'bankFee',
	    get: function get() {
	      if (this.totalAmount >= 2000) {
	        return 0;
	      }
	
	      var bankFee = .01;
	      var actualFee = this.totalAmount * Number(bankFee);
	
	      if (this.totalAmount >= 201) {
	        actualFee = 15;
	      }
	
	      return actualFee;
	    }
	  }, {
	    key: 'isValid',
	    get: function get() {
	      return this.subTransactions.length > 0;
	    }
	  }, {
	    key: 'canAddProduct',
	    get: function get() {
	      return this.customerProducts.length > 1;
	    }
	  }, {
	    key: 'isBitcoin',
	    get: function get() {
	      return this.paymentOptionType === 'BITCOIN';
	    }
	  }, {
	    key: 'isEcopayz',
	    get: function get() {
	      return this.paymentOptionType === 'ECOPAYZ';
	    }
	  }, {
	    key: 'isNeteller',
	    get: function get() {
	      return this.paymentOptionType === 'NETELLER';
	    }
	  }, {
	    key: 'isSkrill',
	    get: function get() {
	      return this.paymentOptionType === 'SKRILL';
	    }
	  }, {
	    key: 'isBank',
	    get: function get() {
	      return this.paymentOptionType === 'BANK';
	    }
	  }, {
	    key: 'isReadOnly',
	    get: function get() {
	      return this.props.readOnly;
	    }
	  }]);
	  return TransactionForm;
	}();

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	var _form = __webpack_require__(1202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormError = function () {
	  function FormError() {
	    (0, _classCallCheck3.default)(this, FormError);
	
	    this.flattenedErrors = {
	      subTransactions: {}
	    };
	  }
	
	  (0, _createClass3.default)(FormError, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.flattenErrors(errors);
	    }
	  }, {
	    key: 'flattenErrors',
	    value: function flattenErrors(errors) {
	      var _this = this;
	
	      var emailErrors = (0, _lodash.get)(errors, 'children.email.errors');
	      this.flattenedErrors['email'] = emailErrors;
	      this.flattenedErrors['file'] = (0, _lodash.get)(errors, 'children.file.errors');
	
	      var subTransactionsErrors = (0, _form.adjustFormError)((0, _lodash.get)(errors, 'children.subTransactions.children'));
	
	      subTransactionsErrors.forEach(function (value, idx) {
	        var errors = value['children'];
	        _this.flattenedErrors.subTransactions[idx] = errors;
	      });
	
	      var rootErrors = (0, _lodash.get)(errors, 'errors');
	      this.flattenedErrors['root'] = rootErrors;
	    }
	  }, {
	    key: 'getError',
	    value: function getError(propertyPath) {
	      return (0, _lodash.get)(this.flattenedErrors, propertyPath);
	    }
	  }, {
	    key: 'subTransaction',
	    value: function subTransaction(path, key) {
	      var propertyPath = 'subTransactions.' + key + '.' + path + '.errors';
	
	      return this.getError(propertyPath);
	    }
	  }, {
	    key: 'bitcoin',
	    value: function bitcoin(key) {
	      if (!(0, _lodash.isEmpty)(this.flattenedErrors['subTransactions'])) {
	        return this.flattenedErrors['subTransactions'][key]['paymentDetails']['children']['bitcoin']['errors'];
	      }
	    }
	  }, {
	    key: 'email',
	    get: function get() {
	      return this.getError('email');
	    }
	  }, {
	    key: 'file',
	    get: function get() {
	      return this.getError('file');
	    }
	  }]);
	  return FormError;
	}();
	
	exports.default = FormError;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1044);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.adjustFormError = adjustFormError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// There are instances form errors return nobject instead of array. Maybe Symfony's bug
	// or the serializer bug. This usually happen on form collections only.
	function adjustFormError(formErrors) {
	  if (formErrors.constructor !== Array) {
	    var arrayErrors = [];
	    (0, _keys2.default)(formErrors).forEach(function (key) {
	      arrayErrors[key] = formErrors[key];
	    });
	
	    return arrayErrors;
	  }
	
	  return formErrors;
	}

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_DECIMAL_FORMAT = exports.BITCOIN_DECIMAL_PLACES_FORMAT = undefined;
	exports.roundOffAmount = roundOffAmount;
	exports.format = format;
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BITCOIN_DECIMAL_PLACES_FORMAT = exports.BITCOIN_DECIMAL_PLACES_FORMAT = '0.00000';
	var DEFAULT_DECIMAL_FORMAT = exports.DEFAULT_DECIMAL_FORMAT = '0.00';
	
	function roundOffAmount(amt) {
	  return parseFloat(Math.abs(amt).toFixed(2));
	}
	
	/**
	 * This function exists coz of a bug on numeraljs
	 * See: https://github.com/adamwdraper/Numeral-js/issues/563
	 * 
	 * Use numbrojs on future instead.
	 * 
	 * @param {Numeral} numeral 
	 * @param {string} format 
	 */
	function format(numeralObject, numberFormat) {
	  return isNaN(numeralObject.format(numberFormat)) ? numeralObject._input : numeralObject.format(numberFormat);
	}

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _skrillform = __webpack_require__(1205);
	
	var _skrillform2 = _interopRequireDefault(_skrillform);
	
	var _skrillform3 = __webpack_require__(1206);
	
	var _skrillform4 = _interopRequireDefault(_skrillform3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var skrillFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _skrillform2.default,
	  controller: _skrillform4.default
	};
	
	exports.default = skrillFormComponent;

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white gateway-wrapper\">\n  <div class=\"flex-row mh-80 vh-center\">\n    <div class=\"p-lr-30 mtop2\" ng-show=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">\n      <!-- <p class=\"m-t-10\" ng-bind-html=\"$ctrl.paymentOptionsViewDetails.activeDisplay.details.selected\"></p> -->\n      <ul class=\"depositForm depositForm-btc\">\n        <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.processingTime }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'minimumDeposit' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.minimumDeposit }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'maximumDeposit' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.maximumDeposit }}</li>\n      </ul>\n    </div>\n  </div>\n\n  <hr class=\"m-10\">\n\n  <div class=\"flex-row\">\n    <div class=\"col-lg-8\">\n      <form class=\"form-horizontal p-lr\" action=\"\">\n        <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n          <div class=\"alert alert-success notif-success mbot2\">\n              <p><strong>{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.note }}</strong></p>\n              <p>{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.selectBookie }}</p>\n          </div>\n          <!-- Initial deposit form -->  \n          <div class=\"col-lg-6\">\n            <div ng-show=\"!$ctrl.form.formViews.isEcopayz\" class=\"form-group skrill-email\">\n              <label class=\"control-label\">Email</label>\n              <div class=\"\">\n                <input ng-model=\"$ctrl.form.email\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.email }\" type=\"text\" class=\"form-control\">\n                <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.email\">\n                  <li ng-repeat=\"(key, error) in $ctrl.form.error.email\" class=\"parsley-required\">{{ error }}</li>\n                </ul>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-lg-12\">\n            <!-- Product Panel -->\n            <div class=\"product-selection-panel\">\n              <div class=\"row visible-lg visible-md\">\n                <div class=\"col-lg-6 col-md-6\">\n                  <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                </div>\n                <div class=\"col-lg-6 col-md-6\">\n                  <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                </div>\n              </div>\n              <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n                <!-- Product -->\n                <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                  <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-11 col-xs-10 m-b-10\">\n                  <select\n                    ng-model=\"subTransaction.product\"\n                    ng-init=\"oldValue=null\"\n                    ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                    ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                    ng-click=\"oldValue=subTransaction.product\"\n                    ng-disabled=\"$ctrl.form.props.readOnly\"\n                    ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\" class=\"form-control\">\n                    <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                    <!-- <option ng-repeat=\"customerProduct in $ctrl.form.customerProducts\" ng-value=\"{{ customerProduct.id }}\">{{ customerProduct.productName}} ({{ customerProduct.username }})</option> -->\n                  </select>\n                  <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                    <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                  </ul>\n                </div>\n                <!-- Mobile x button -->\n                <div class=\"visible-sm visible-xs col-sm-1 col-xs-2\">\n                  <button ng-hide=\"$ctrl.form.isReadOnly\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\" class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n                </div>\n                <!-- Amount-->\n                <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 product-amount\">\n                  <div class=\"row\">\n                    <!-- Amount Input -->\n                    <div class=\"col-lg-11 col-md-11 col-sm-12 col-xs-12 m-b-10\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ |async }}</span>\n                        <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\" limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control\">\n                      </div>\n                        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                          <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                        </ul>\n                    </div>  \n                    <div class=\"visible-md visible-lg col-lg-1 col-md-1 close-btn\">\n                      <button ng-show=\"$ctrl.form.props.readOnly === false\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\"\n                        class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!-- Errors -->\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                  <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}</button>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                  <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Deposit'\"></ladda-button>\n                  <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n                </div>\n                <!-- Hiding this for now will implement when Deposit slip feature is already available-->\n                <!--<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 m-b-0\">-->\n                  <!--<input type=\"file\" class=\"filestyle\" data-placeholder=\"No file\" id=\"filestyle-9\" tabindex=\"-1\" style=\"position: absolute; clip: rect(0px 0px 0px 0px);\"><div class=\"bootstrap-filestyle input-group\"><input type=\"text\" class=\"form-control \" placeholder=\"Attach a copy of your deposit slip\" disabled=\"\"> <span class=\"group-span-filestyle input-group-btn\" tabindex=\"0\"><label for=\"filestyle-9\" class=\"btn btn-default \"><span class=\"icon-span-filestyle fa fa-image\"></span> <span class=\"buttonText\">Choose file</span></label></span></div>-->\n                <!--</div>-->\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap skrill-bg active\">\n          <i class=\"fas fa-receipt visible-md visible-xs visible-sm\" type=\"button\"></i>\n          <div class=\"gateway-sidebar\">\n            <img src=\"{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.logo }}\" class=\"payment-option-logo\">\n    \n            <!-- Merchant Details -->\n            <div class=\"merchant-details\">\n              <h4 ng-repeat=\"field in $ctrl.paymentOptionsViewDetails.activeDisplay.fields\" class=\"ac-white-text\">{{ field.label | translate }}: {{ field.value}}</h4>\n            </div>\n  \n            <hr class=\"m-10\">\n    \n            <!-- Transaction Summary -->\n            <div class=\"transaction-summary\">\n              <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n              <div class=\"font-lg\">\n                <p>{{ 'Amount to deposit' | translate }}:<br>\n                  <span class=\"bold\">{{ $ctrl.form.totalAmount |number }} {{ $ctrl.userCurrency$ | async }}</span>\n                </p>\n  \n                <p>Fee:<br>\n                  <span ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') === 'FREE'\" class=\"bold\">{{ 'Free' | translate }}</span>\n                  <span ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') !== 'FREE'\" class=\"bold\">{{ $ctrl.form.fee |number: 2}} {{ $ctrl.userCurrency$ |async }}</span>\n                </p>\n                \n                <hr class=\"m-10\">\n                <p class=\"uppercase\">{{ 'Total amount to deposit' | translate }}:<br>\n                  <span class=\"bold\">{{ $ctrl.form.totalAmountToSend }} {{ $ctrl.userCurrency$ | async }}</span></p>\n              </div>\n            </div>\n          </div>\n        </div>\n    </div>\n  </div>\n</div> "

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _skrillform = __webpack_require__(1207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkrillFormController = function (_BaseController) {
	  SkrillFormController.$inject = ["DepositStore", "FormService", "$timeout"];
	  (0, _inherits3.default)(SkrillFormController, _BaseController);
	
	  function SkrillFormController(DepositStore, FormService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SkrillFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SkrillFormController.__proto__ || (0, _getPrototypeOf2.default)(SkrillFormController)).call(this));
	
	    _this.DepositStore = DepositStore;
	    _this.FormService = FormService;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(SkrillFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.userCurrency$ = this.DepositStore.getCurrency();
	
	      this.form = new _skrillform.SkrillForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('deposit');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('deposit');
	      this.form.email = this.selectedPaymentOption.email;
	
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.DepositStore.deposit(this.form.toPayload()).then(function () {
	        return _this2.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        _this2.form.error.setFormErrors(errors);
	        _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.updatePaymentOption();
	      this.form.clearError();
	      this.form.props.readOnly = true;
	
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	
	    // Update the current selected payment option.
	    // This is to ensure that when a payment option is newly created it
	    // keeps synced with the ui and the form model.
	
	  }, {
	    key: 'updatePaymentOption',
	    value: function updatePaymentOption() {
	      var _this3 = this;
	
	      this.DepositStore.getPaymentOptions().then(function (updatedPaymentOptions) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(updatedPaymentOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var updatedPaymentOption = _step.value;
	
	            if (updatedPaymentOption.type === _this3.selectedPaymentOption.type) {
	              _this3.selectedPaymentOption.id = updatedPaymentOption.id;
	              _this3.form.paymentOption = updatedPaymentOption.id;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return SkrillFormController;
	}(_basecontroller.BaseController);
	
	exports.default = SkrillFormController;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SkrillForm = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _transactionform = __webpack_require__(1200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkrillForm = exports.SkrillForm = function (_TransactionForm) {
	  (0, _inherits3.default)(SkrillForm, _TransactionForm);
	
	  function SkrillForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, SkrillForm);
	    return (0, _possibleConstructorReturn3.default)(this, (SkrillForm.__proto__ || (0, _getPrototypeOf2.default)(SkrillForm)).call(this, customerProducts, paymentOptions));
	  }
	
	  return SkrillForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _netellerform = __webpack_require__(1209);
	
	var _netellerform2 = _interopRequireDefault(_netellerform);
	
	var _netellerform3 = __webpack_require__(1210);
	
	var _netellerform4 = _interopRequireDefault(_netellerform3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var netellerFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _netellerform2.default,
	  controller: _netellerform4.default
	};
	
	exports.default = netellerFormComponent;

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white gateway-wrapper\">\n  <div class=\"flex-row mh-80 vh-center\">\n    <div class=\"p-lr-30 mtop2\" ng-show=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">    \n      <!-- <p class=\"m-t-10\" ng-bind-html=\"$ctrl.paymentOptionsViewDetails.activeDisplay.details.selected\"></p> -->\n      <ul class=\"depositForm depositForm-btc\">\n        <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.processingTime }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'minimumDeposit' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.minimumDeposit }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'maximumDeposit' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.maximumDeposit }}</li>\n      </ul>\n    </div>\n  </div>\n\n  <hr class=\"m-10\">\n\n  <div class=\"flex-row\">\n    <div class=\"col-lg-8\">\n      <form class=\"form-horizontal p-lr\" action=\"\">\n        <div class=\"alert alert-success notif-success mbot2\">\n          <p>{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.selectBookie }}</p>\n        </div>\n        <!-- Initial deposit form -->             \n        <div class=\"col-lg-6\">\n          <div ng-show=\"!$ctrl.form.formViews.isEcopayz\" class=\"form-group neteller-email\">\n            <label class=\"control-label\">Email</label>\n            <div class=\"\">\n              <input ng-model=\"$ctrl.form.email\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.email }\"\n                type=\"text\" class=\"form-control\">\n              <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.email\">\n                <li ng-repeat=\"(key, error) in $ctrl.form.error.email\" class=\"parsley-required\">{{ error }}</li>\n              </ul>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-lg-12\">\n          <!-- Product Panel -->\n          <div class=\"product-selection-panel\">\n            <div class=\"row visible-lg visible-md\">\n              <div class=\"col-lg-6 col-md-6\">\n                <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n              </div>\n              <div class=\"col-lg-6 col-md-6\">\n                <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n              <!-- Product -->\n              <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-11 col-xs-10 m-b-10\">\n                  <select ng-model=\"subTransaction.product\" ng-init=\"oldValue=null\" ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                  ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                  ng-click=\"oldValue=subTransaction.product\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\"\n                  class=\"form-control\">\n                  <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                  <!-- <option ng-repeat=\"customerProduct in $ctrl.form.customerProducts\" ng-value=\"{{ customerProduct.id }}\">{{ customerProduct.productName}} ({{ customerProduct.username }})</option> -->\n                </select>\n                <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                  <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{\n                    error }}</li>\n                </ul>\n              </div>\n              <!-- Mobile x button -->\n              <div class=\"visible-sm visible-xs col-sm-1 col-xs-2\">\n                <button ng-hide=\"$ctrl.form.isReadOnly\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\" class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n              </div>\n              <!-- Amount-->\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 product-amount\">\n                <div class=\"row\">\n                  <!-- Amount Input -->\n                  <div class=\"col-lg-11 col-md-11 col-sm-12 col-xs-12 m-b-10\">\n                    <div class=\"input-group\">\n                      <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ |async }}</span>\n                        <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\"\n                        limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control\">\n                    </div>\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{\n                          error }}</li>\n                      </ul>\n                  </div>  \n                  <div class=\"visible-md visible-lg col-lg-1 col-md-1 close-btn\">\n                    <button ng-show=\"$ctrl.form.props.readOnly === false\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\"\n                      class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- Errors -->\n            <div class=\"row\">\n              <div class=\"col-md-12\">\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}</button>\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Deposit'\"></ladda-button>\n                <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n              </div>\n              <!-- Hiding this for now will implement when Deposit slip feature is already available-->\n              <!--<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 m-b-0\">-->\n                <!--<input type=\"file\" class=\"filestyle\" data-placeholder=\"No file\" id=\"filestyle-9\" tabindex=\"-1\" style=\"position: absolute; clip: rect(0px 0px 0px 0px);\"><div class=\"bootstrap-filestyle input-group\"><input type=\"text\" class=\"form-control \" placeholder=\"Attach a copy of your deposit slip\" disabled=\"\"> <span class=\"group-span-filestyle input-group-btn\" tabindex=\"0\"><label for=\"filestyle-9\" class=\"btn btn-default \"><span class=\"icon-span-filestyle fa fa-image\"></span> <span class=\"buttonText\">Choose file</span></label></span></div>-->\n              <!--</div>-->\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <!-- Sidebar -->\n    <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap neteller-bg active\">\n        <i class=\"fas fa-receipt visible-md visible-xs visible-sm\" type=\"button\"></i>\n        <div class=\"gateway-sidebar\">\n          <img src=\"{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.logo }}\" class=\"payment-option-logo\">\n    \n          <!-- Merchant Details -->\n          <div class=\"merchant-details\">\n            <h4 ng-repeat=\"field in $ctrl.paymentOptionsViewDetails.activeDisplay.fields\" class=\"ac-white-text\">{{ field.label | translate }}: {{ field.value}}</h4>\n          </div>\n  \n          <hr class=\"m-10\">\n          \n          <!-- Transaction Summary -->\n          <div class=\"transaction-summary\">\n            <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n            <div class=\"font-lg\">\n              <p>{{ 'Amount to deposit' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmount |number }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n  \n              <p>Fee:<br>\n                <span ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') === 'FREE'\" class=\"bold\">{{ 'Free' | translate }}</span>\n                <span ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') !== 'FREE'\" class=\"bold\">{{ $ctrl.form.fee |number: 2}} {{ $ctrl.userCurrency$ |async }}</span>\n              </p>\n              \n              <hr class=\"m-10\">\n              <p class=\"uppercase\">{{ 'Total amount to deposit' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmountToSend }} {{ $ctrl.userCurrency$ | async }}</span></p>\n            </div>\n          </div>\n        </div>\n      </div> \n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _netellerform = __webpack_require__(1211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetellerFormController = function (_BaseController) {
	  NetellerFormController.$inject = ["DepositStore", "FormService", "$timeout"];
	  (0, _inherits3.default)(NetellerFormController, _BaseController);
	
	  function NetellerFormController(DepositStore, FormService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NetellerFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NetellerFormController.__proto__ || (0, _getPrototypeOf2.default)(NetellerFormController)).call(this));
	
	    _this.DepositStore = DepositStore;
	    _this.FormService = FormService;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(NetellerFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.userCurrency$ = this.DepositStore.getCurrency();
	
	      this.form = new _netellerform.NetellerForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('deposit');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('deposit');
	      this.form.email = this.selectedPaymentOption.email;
	
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.DepositStore.deposit(this.form.toPayload()).then(function () {
	        return _this2.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        console.log(errors);
	        _this2.form.error.setFormErrors(errors);
	        _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.updatePaymentOption();
	      this.form.clearError();
	      this.form.props.readOnly = true;
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	
	    // Update the current selected payment option.
	    // This is to ensure that when a payment option is newly created it
	    // keeps synced with the ui and the form model.
	
	  }, {
	    key: 'updatePaymentOption',
	    value: function updatePaymentOption() {
	      var _this3 = this;
	
	      this.DepositStore.getPaymentOptions().then(function (updatedPaymentOptions) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(updatedPaymentOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var updatedPaymentOption = _step.value;
	
	            if (updatedPaymentOption.type === _this3.selectedPaymentOption.type) {
	              _this3.selectedPaymentOption.id = updatedPaymentOption.id;
	              _this3.form.paymentOption = updatedPaymentOption.id;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return NetellerFormController;
	}(_basecontroller.BaseController);
	
	exports.default = NetellerFormController;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetellerForm = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _transactionform = __webpack_require__(1200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetellerForm = exports.NetellerForm = function (_TransactionForm) {
	  (0, _inherits3.default)(NetellerForm, _TransactionForm);
	
	  function NetellerForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, NetellerForm);
	    return (0, _possibleConstructorReturn3.default)(this, (NetellerForm.__proto__ || (0, _getPrototypeOf2.default)(NetellerForm)).call(this, customerProducts, paymentOptions));
	  }
	
	  return NetellerForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bankform = __webpack_require__(1213);
	
	var _bankform2 = _interopRequireDefault(_bankform);
	
	var _bankform3 = __webpack_require__(1214);
	
	var _bankform4 = _interopRequireDefault(_bankform3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bankFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _bankform2.default,
	  controller: _bankform4.default
	};
	
	exports.default = bankFormComponent;

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white bank-wrapper\">\n  <div class=\"row\" ng-if=\"$ctrl.isClosed\">\n    <div class=\"col-lg-12\" style=\"padding: 20px;margin-top: 20px;\">\n      <div class=\"alert alert-danger\">\n        <strong>{{ 'Note:' | translate }}</strong> {{ 'bankNotice' | translate }}\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\" ng-if=\"$ctrl.paymentOptionsViewDetails.isCountryRestricted && $ctrl.paymentOptionsViewDetails.activeDisplay && !$ctrl.isClosed\">\n    <div class=\"col-lg-12\" style=\"padding: 20px;margin-top: 20px;\">\n      <div class=\"alert alert-danger\">\n        <strong>{{ 'Note:' | translate }}</strong> {{ 'bankRestricted' | translate }}\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"!$ctrl.paymentOptionsViewDetails.isCountryRestricted && $ctrl.paymentOptionsViewDetails.activeDisplay && !$ctrl.isClosed\" class=\"flex-row p-b-30\">\n    <div class=\"col-lg-9 m-b-15\">\n      <div class=\"row p-lr m-t-15\" ng-show=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12\">\n          <ul class=\"depositForm depositForm-btc\">\n            <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.processingTime }}</li>\n            <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') }}</li>\n            <li><i class=\"fa fa-check\"></i><b>{{ 'minimumDeposit' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.minimumDeposit }}</li>\n            <li><i class=\"fa fa-check\"></i><b>{{ 'maximumDeposit' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.maximumDeposit }}</li>\n          </ul>\n        </div>\n      </div>\n\n      <hr/>\n      <form class=\"form-horizontal\" action=\"\">\n        <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n          <!-- Initial deposit form -->\n          <div class=\"row\" ng-show=\"!$ctrl.isBitcoinTransactionRequested\">\n            <!-- Notes for bank-->\n            <div id=\"bank-cls\" class=\"panel-collapse collapse in\" aria-expanded=\"true\">\n              <div class=\"panel-body\">\n                <div class=\"alert alert-success notif-success\">\n                    <p><strong>{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.note }}</strong></p>\n                    <p>{{ 'chooseProductDeposit' | translate }}</p>\n                </div>\n              </div>\n              <div class=\"clearfix\"></div>\n            </div>\n            <div class=\"col-lg-12\">\n              <!-- Product Panel -->\n                <!-- Product Panel -->\n                <div class=\"product-selection-panel p-lr\">\n                  <div class=\"row visible-lg visible-md\">\n                    <div class=\"col-lg-6 col-md-6\">\n                      <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                    </div>\n                    <div class=\"col-lg-6 col-md-6\">\n                      <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                    </div>\n                  </div>\n                  <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n                    <!-- Product -->\n                    <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                      <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                    </div>\n                    <div class=\"col-lg-6 col-md-6 col-sm-11 col-xs-10 m-b-10\">\n                      <select ng-model=\"subTransaction.product\" ng-init=\"oldValue=null\" ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                              ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                              ng-click=\"oldValue=subTransaction.product\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\"\n                              class=\"form-control\">\n                        <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                      </select>\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{\n                          error }}</li>\n                      </ul>\n                    </div>\n                    <!-- Mobile x button -->\n                    <div class=\"visible-sm visible-xs col-sm-1 col-xs-2\">\n                      <button ng-hide=\"$ctrl.form.isReadOnly\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\" class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n                    </div>\n                    <!-- Amount-->\n                    <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 product-amount\">\n                      <div class=\"row\">\n                        <!-- Amount Input -->\n                        <div class=\"col-lg-11 col-md-11 col-sm-12 col-xs-12 m-b-10\">\n                          <div class=\"input-group\">\n                            <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ |async }}</span>\n                             <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\"\n                                       limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control ng-pristine ng-untouched ng-valid ng-not-empty\">\n                          </div>\n                          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                            <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{\n                              error }}</li>\n                          </ul>\n                        </div>\n                        <div class=\"visible-md visible-lg col-lg-1 col-md-1 close-btn\">\n                          <button ng-show=\"$ctrl.form.props.readOnly === false\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\"\n                                  class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i>\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <!-- Errors -->\n                  <div class=\"row\">\n                    <div class=\"col-md-12\">\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                      <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}</button>\n                    </div>\n                    <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                      <div class=\"m-b-0\">\n                        <input type=\"file\" file-model=\"$ctrl.form.file\" class=\"filestyle\" data-buttonname=\"btn-primary\" ng-class=\"{ 'parsley-error': $ctrl.form.error.file }\">\n                        <small class=\"img-file-type\">{{ 'fileValidation' | translate }}</small>\n                        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.file\">\n                          <li ng-repeat=\"(key, error) in $ctrl.form.error.file\" class=\"parsley-required\">{{ error }}</li>\n                        </ul>\n                      </div>\n                      <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Deposit'\"></ladda-button>\n                      <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n                    </div>\n                  </div>\n<!--                   <div row>\n                    <div class=\"col-lg-5 col-md-8 col-sm-3 col-xs-3\"></div>\n                    <div class=\"col-lg-2 col-md-4 col-sm-6 col-xs-6  text-right bank-request\">\n                      <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Deposit'\"></ladda-button>\n                      <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">Make\n                        new request</button>\n                    </div>\n                  </div> -->\n                </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n    <!--BANK SIDEBAR-->\n      <div class=\"bank-sidebar-wrap active\">\n           <i class=\"fas fa-receipt visible-md visible-xs visible-sm\" type=\"button\"></i>\n          <div class=\"col-lg-3 bank-sidebar\">\n            <div class=\"text-center\">\n              <img src=\"assets/images/payment/white/bank.png\" class=\"payment-option-logo\">\n\n                <!-- Bank EXchange Rate -->\n                <div class=\"exchange-rate-wrap\">\n                  <p class=\"exchange-rate\">\n                    <div ng-repeat=\"field in $ctrl.paymentOptionsViewDetails.activeDisplay.fields\">\n                      <span><b>{{ field.label }}:</b> {{ field.value}} </span>\n                    </div>\n                  </h3>\n                </div>\n\n              <!-- Transaction Summary -->\n              <div class=\"transaction-summary-wrap\">\n                <hr>\n                <h3 class=\"uppercase\">{{ 'Transaction Summary' | translate }}</h3>\n                <div class=\"text-left\">\n                  <h4>{{ 'Total amount to be deposited in your account' | translate }}:</h4>\n                  <p class=\"btc-totals\">{{ $ctrl.form.totalAmount\n                    |number }} {{ $ctrl.userCurrency$ | async }}</p>\n                  <h4>{{ 'fee' | translate }}:</h4>\n                  <p class=\"btc-totals\">{{ $ctrl.form.bankFee | number: 2}} {{ $ctrl.userCurrency$ |async }}</p>\n                  <h4>{{ 'Total amount to be sent in your account' | translate }}:</h4>\n                  <p class=\"btc-totals\">{{ $ctrl.form.totalAmountToBeDeposited }} {{ $ctrl.userCurrency$ | async }}</p>\n                </div>\n              </div>\n            </div>\n          </div>\n      </div>\n    <!--BANK SIDEBAR-->\n</div>\n"

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _bankform = __webpack_require__(1215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankFormController = function (_BaseController) {
	  BankFormController.$inject = ["DepositStore", "FormService", "$timeout"];
	  (0, _inherits3.default)(BankFormController, _BaseController);
	
	  function BankFormController(DepositStore, FormService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BankFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BankFormController.__proto__ || (0, _getPrototypeOf2.default)(BankFormController)).call(this));
	
	    _this.DepositStore = DepositStore;
	    _this.FormService = FormService;
	    _this.$timeout = $timeout;
	    _this.isClosed = false;
	    return _this;
	  }
	
	  (0, _createClass3.default)(BankFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.isClosed = true;
	
	      this.$timeout(function () {
	        $(':file').filestyle();
	      }, 100);
	
	      this.userCurrency$ = this.DepositStore.getCurrency();
	
	      this.form = new _bankform.BankForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('deposit');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('deposit');
	
	      this.$timeout(function () {
	        $(".bank-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".bank-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	      //this.form.email = this.selectedPaymentOption.email;
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	
	      var additionalHeaders = {};
	      if (this.form.file !== null) {
	        additionalHeaders = { 'Content-Type': undefined };
	      }
	
	      this.DepositStore.deposit(this.form.toPayload(), additionalHeaders).then(function () {
	        return _this2.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        console.log(errors);
	        _this2.form.error.setFormErrors(errors);
	        _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.updatePaymentOption();
	      this.form.clearError();
	      this.form.props.readOnly = true;
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	
	    // Update the current selected payment option.
	    // This is to ensure that when a payment option is newly created it
	    // keeps synced with the ui and the form model.
	
	  }, {
	    key: 'updatePaymentOption',
	    value: function updatePaymentOption() {
	      var _this3 = this;
	
	      this.DepositStore.getPaymentOptions().then(function (updatedPaymentOptions) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(updatedPaymentOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var updatedPaymentOption = _step.value;
	
	            if (updatedPaymentOption.type === _this3.selectedPaymentOption.type) {
	              _this3.selectedPaymentOption.id = updatedPaymentOption.id;
	              _this3.form.paymentOption = updatedPaymentOption.id;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return BankFormController;
	}(_basecontroller.BaseController);
	
	exports.default = BankFormController;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BankForm = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _transactionform = __webpack_require__(1200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankForm = exports.BankForm = function (_TransactionForm) {
	  (0, _inherits3.default)(BankForm, _TransactionForm);
	
	  function BankForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, BankForm);
	    return (0, _possibleConstructorReturn3.default)(this, (BankForm.__proto__ || (0, _getPrototypeOf2.default)(BankForm)).call(this, customerProducts, paymentOptions));
	  }
	
	  return BankForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bitcoinform = __webpack_require__(1217);
	
	var _bitcoinform2 = _interopRequireDefault(_bitcoinform);
	
	var _bitcoinform3 = __webpack_require__(1218);
	
	var _bitcoinform4 = _interopRequireDefault(_bitcoinform3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bitcoinFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _bitcoinform2.default,
	  controller: _bitcoinform4.default
	};
	
	exports.default = bitcoinFormComponent;

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white gateway-wrapper\">\n  <div class=\"flex-row mh-80 vh-center\">\n    <div class=\"p-lr-30 mtop2\" ng-show=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">  \n      <!-- <p class=\"m-t-10\" ng-bind-html=\"$ctrl.paymentOptionsViewDetails.activeDisplay.details.selected\"></p>   -->\n      <ul class=\"depositForm depositForm-btc\">\n        <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.deposit.processingTime }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.feeDisplayFor('deposit') }}</li>\n        <li ng-if=\"$ctrl.bitcoinRate\"><i class=\"fa fa-check\"></i><b>{{ 'minimumDeposit' | translate }}:</b> {{ $ctrl.bitcoinRate.config.formattedMinimumAllowedDeposit }} BTC</li>\n        <li ng-if=\"$ctrl.bitcoinRate\"><i class=\"fa fa-check\"></i><b>{{ 'maximumDeposit' | translate }}:</b> {{ $ctrl.bitcoinRate.config.formattedMaximumAllowedDeposit }} BTC</li>\n      </ul>\n    </div>\n  </div>\n\n  <hr class=\"m-10\">\n\n  <div class=\"flex-row\">\n    <div class=\"col-lg-8\">\n      <div ng-show=\"!$ctrl.form.props.isReady\" class=\"loader\"></div>\n  \n      <form ng-show=\"$ctrl.form.props.isReady\" class=\"form-horizontal\" action=\"\">\n        <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n          <!-- Initial deposit form -->\n          <div class=\"row\" ng-show=\"!$ctrl.isBitcoinTransactionRequested\">           \n            <div class=\"col-lg-12\">\n              <!-- Product Panel -->\n              <div class=\"product-selection-panel p-lr\">\n                <!-- Note -->\n                <div class=\"alert alert-success notif-success mbot3\">\n                  Simply choose your preferred product (bookie), enter the amount then click the Request Deposit.\n                </div>  \n                <div class=\"row visible-lg visible-md\">\n                  <div class=\"col-lg-4 col-md-4\">\n                    <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-8 col-md-8\">\n                    <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                  </div>\n                </div>\n\n                <!-- Product Field, BTC Field -->\n                <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n                  <!-- Product -->\n                  <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                    <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-4 col-md-4 col-sm-11 col-xs-10 m-b-10\">\n                    <select title=\"Please select product(s)\"\n                        ng-model=\"subTransaction.product\"\n                        ng-init=\"oldValue=null\"\n                        ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                        ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                        ng-click=\"oldValue=subTransaction.product\"\n                        ng-disabled=\"$ctrl.form.props.readOnly\"\n                        ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\" class=\"form-control\">\n                        <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                        <!-- <option ng-repeat=\"customerProduct in $ctrl.form.customerProducts\" ng-value=\"{{ customerProduct.id }}\">{{ customerProduct.productName}} ({{ customerProduct.username }})</option> -->\n                    </select>\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                      <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                    </ul>                   \n                  </div>\n                  \n                  <!-- Mobile x button -->\n                  <div class=\"visible-sm visible-xs col-sm-1 col-xs-2\">\n                    <button ng-hide=\"$ctrl.form.isReadOnly\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\" class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n                  </div>\n\n                  <!-- Amount & BTC -->\n                  <div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12 product-amount\">\n                    <div class=\"row\">\n                      \n                      <!-- BTC Input -->\n                      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 m-b-10\">\n                        <div class=\"input-group\">\n                          <span class=\"input-group-addon bg-primary text-white\">BTC</span>\n                          <input ng-blur=\"$ctrl.formatBTC(subTransaction)\" title=\"Please input amount in BTC\" ng-change=\"$ctrl.onBtcInputChanged()\" ng-model=\"subTransaction.btc\" ng-disabled=\"$ctrl.form.isReadOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\" limit=\"22\" precision=\"5\" type=\"text\" class=\"form-control\">\n                        </div>\n                        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.bitcoin(subTransaction.key)\">\n                          <li ng-repeat=\"(key, error) in $ctrl.form.error.bitcoin(subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                        </ul>\n                      </div>                    \n\n                      <!-- Amount Input -->\n                      <div class=\"col-lg-5 col-md-5 col-sm-6 col-xs-12 m-b-10\">\n                        <div class=\"input-group\">\n                          <span class=\"input-group-addon bg-primary text-white\">EUR</span>\n                          <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" title=\"Please input amount in EUR\" ng-change=\"$ctrl.onAmountInputChanged()\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.isReadOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\" limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control\">\n                        </div>\n                        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                          <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                        </ul>\n                      </div>\n\n                      <!-- Cancel/Delete Button ng-if=\"$ctrl.displayDeleteButton\"-->\n                      <div class=\"visible-md visible-lg col-lg-1 col-md-1\">\n                        <button ng-hide=\"$ctrl.form.isReadOnly\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\" class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <!-- Errors -->\n                <div class=\"row\">\n                  <div class=\"col-md-12\">\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.getError('root')\">\n                      <li class=\"parsley-required\"><strong>{{ $ctrl.form.error.getError('root')[0] }}</strong></li>\n                    </ul>\n                  </div>\n                </div>\n\n                <!-- Add Product btn -->\n                <div class=\"row\">\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                    <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" ng-hide=\"$ctrl.form.props.readOnly === true\" type=\"button\" class=\"btn btn-primary btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}</button>\n                  </div>\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                    <ladda-button\n                      ng-hide=\"$ctrl.form.props.readOnly === true\"\n                      on-click=\"$ctrl.submit()\"\n                      text=\"'Request Deposit'\"\n                      load=\"$ctrl.form.props.isSubmitting\"\n                      ladda-disable=\"(!$ctrl.form.isValid) || ($ctrl.form.isSubmitting) === true\"\n                      class=\"request-deposit\"></ladda-button>\n                  </div>\n                </div>              \n              </div>\n            </div>\n          </div>\n\n          <!-- Requested formng-if=\"$ctrl.isBitcoinTransactionRequested\"-->\n          <div ng-if=\"$ctrl.isBitcoinTransactionRequested\" class=\"row requested-status-wrap p-lr\">\n            <!-- Notes for request -->\n              <div id=\"bitcoin\" class=\"panel-collapse collapse in\" aria-expanded=\"true\">\n                <div class=\"panel-body\">\n                  <div class=\"alert alert-success custom-notif\">\n                      {{ 'You have submitted the BTC deposit request form.' | translate }}<br>\n                      {{ 'Please send the BTC amount to the BTC address below. This address is unique to your account.' | translate }}\n                  </div>\n                </div>\n                <div class=\"clearfix\"></div>\n              </div>  \n            <!-- Product List -->\n            <div class=\"col-lg-5\">\n              <h3>{{ 'titles.products' | translate }}</h2>\n              <ul class=\"product-list-requested\">\n                <li ng-repeat=\" subTransaction in $ctrl.form.subTransactions\">\n                    <span>{{ subTransaction.customerProductDisplay }}</span><br>\n                    <span><strong>BTC</strong> {{ subTransaction.formattedBtc }} = <strong>EUR</strong> {{ subTransaction.formattedAmount }}</span>\n                    <hr>\n                </li>\n              </ul>\n            </div>\n\n            <!-- QR and BTC Address -->\n            <div class=\"col-lg-7\">\n              <div class=\"row\">\n\n                <div class=\"col-lg-3 col-md-3 col-sm-3\">\n                  <div class=\"hidden-xs\">\n                    <canvas id=\"qr\" width=\"200\" height=\"200\" class=\"qr-canvas\"></canvas>\n                    <p>{{ 'Tap or Scan to pay' | translate }}</p>\n                  </div>\n                  <div class=\"visible-xs m-b-20\">\n                    <button type=\"button\" class=\"btn btn-icon waves-effect btn-white waves-light\" ng-click=\"$ctrl.showQrModal()\"> {{ 'Show QR' | translate }} <i class=\"fas fa-qrcode\"></i> </button>\n                  </div>\n                </div>\n\n                <div class=\"col-lg-9 col-md-9 col-sm-9\">\n                  <!-- Total BTC to be sent -->\n                  <div class=\"default-wrap\">\n                    <h4><i class=\"fa fa-file-invoice-dollar\"></i> {{ 'Total BTC to be sent' | translate }}</h4>\n                    <p class=\"amount\">{{ $ctrl.form.totalBtc }} BTC</p>\n                  </div>\n\n                  <!-- Recipient BTC Address -->\n                  <div class=\"default-wrap\">\n                    <h4><i class=\"fab fa-bitcoin\"></i>{{ 'Recipient BTC Address' | translate }}</h4>\n                    <p>{{ 'Please send total BTC to the recipient address.' | translate }}</p>\n\n                    <div class=\"input-group\">\n                        <input ng-model=\"$ctrl.bitcoinTransaction.receivingAddress\" type=\"text\" class=\"form-control input-sm\" readonly id=\"recipient-btc-address\">\n                        <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-warning btn-sm waves-effect waves-light btn-primary\" ngclipboard data-clipboard-target=\"#recipient-btc-address\">{{ 'Copy' | translate }}</button>\n                        </span>\n                    </div>\n                  </div>\n\n                  <div class=\"default-wrap\">\n                    <h4><i class=\"fa fa-lock\"></i>{{ 'Rate Used per BTC' | translate }}</h4>\n                    <p class=\"amount\">{{ $ctrl.bitcoinTransaction.formattedAdjustedRate }} EUR</p>\n                    <p>{{ 'Please send bitcoin in' | translate }} <span class=\"btc-timer\"></span> {{ 'minutes.' | translate }}</p>\n                  </div>\n\n                  <p class=\"note-orange text-right m-t-40\">{{ 'This page will automatically refresh when Bitcoin has been sent.' | translate }}</p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!-- Pending Confirmation Modal -->\n        <div class=\"pending-confirmed-btc-wrap\" ng-show=\"$ctrl.isBitcoinTransactionPending\">\n          <div id=\"btc-pending-confirmation-modal\"  tabindex=\"-1\" class=\"sweet-overlay\">\n            <div class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" style=\"display: block; margin-top: -189px;\">\n              <div class=\"icon success animate\">\n                <span class=\"line tip animateSuccessTip\"></span>\n                <span class=\"line long animateSuccessLong\"></span>\n                <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n              </div>\n              <br>\n              <h3><strong>{{ 'Thank you for sending the requested amount!' | translate }}</strong></h3>\n              <p class=\"sub-head\">\n                {{ 'We are now waiting for your Bitcoin confirmations.' | translate }}\n              </p>\n              <div class=\"row text-left\">\n                <div class=\"col-md-6\">\n                  <div class=\"col-md-offset-1\">\n                    <h4><i class=\"fas fa-receipt\"></i> {{ 'Status' | translate }}</h4>\n                    <p class=\"confirmation\">{{ $ctrl.bitcoinTransaction.confirmationCount }}/3 {{ 'confirmation(s) received' | translate }}</p>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!-- Confirmation Modal -->\n        <div class=\"confirmed-btc-wrap\">\n          <div id=\"btc-confirmation-modal\" ng-show=\"$ctrl.isBitcoinTransactionConfirmed\" tabindex=\"-1\" class=\"sweet-overlay\">\n            <div class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" style=\"display: block; margin-top: -189px;\">\n              <div class=\"icon success animate\">\n                <span class=\"line tip animateSuccessTip\"></span>\n                <span class=\"line long animateSuccessLong\"></span>\n                <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n              </div>\n              <br>\n              <h3><strong>{{ 'Thank you for making a deposit!' | translate }}</strong></h3>\n              <p class=\"sub-head\">\n                {{ 'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.' | translate }}\n              </p>\n\n              <div class=\"row text-left\">\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-offset-1\">\n                    <h4><i class=\"fas fa-receipt\"></i> {{ 'Status' | translate }}</h4>\n                    <p class=\"confirmation\">{{ $ctrl.bitcoinTransaction.confirmationCount }}/3 {{ 'confirmation(s) received' | translate }}</p>\n                  </div>\n                </div>\n              </div>\n              <p>\n                <button ng-click=\"$ctrl.acknowledgeTransaction()\" type=\"button\" class=\"btn btn-custom-ok waves-effect waves-light w-lg\" tabindex=\"1\">{{ 'OK' | translate }}</button>\n              </p>\n            </div>\n          </div>\n        </div>\n\n        <!-- Rate Expired Modal -->\n        <div class=\"declined-btc-wrap\">\n          <div id=\"btc-rate-expired-modal\" ng-show=\"$ctrl.isBitcoinRateExpired\" tabindex=\"-1\" class=\"sweet-overlay\">\n            <div class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"display: block; margin-top: -189px;\">\n              <div class=\"loader\"></div>\n              <br>\n              <p class=\"sub-head\">\n                {{ 'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.' | translate }}\n              </p>\n              <div class=\"status\">\n                <h1>{{ 'Status' | translate }}</h1>\n                <p>{{ 'Requested: waiting to receive bitcoin' | translate }}</p>\n                <small>{{ 'Note: Please contact Support if you made a request by mistake and would like to request again' | translate }}</small>\n              </div>            \n            </div>\n          </div>\n        </div>\n\n        <!-- Declined Confirmation Modal -->\n        <div class=\"declined-btc-wrap\">\n          <div id=\"btc-declined-modal\" ng-show=\"$ctrl.isBitcoinTransactionDeclined\" tabindex=\"-1\" class=\"sweet-overlay\">\n            <div class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"display: block; margin-top: -189px;\">\n              <div class=\"icon error animateErrorIcon\" style=\"display: block;\">\n                <span class=\"x-mark animateXMark\">\n                  <span class=\"line left\"></span>\n                  <span class=\"line right\"></span>\n                </span>\n              </div>\n              <br>\n              <p class=\"sub-head\">\n                {{ 'bitcoinDeclined' | translate }}\n              </p>\n              <p>\n                <button type=\"button\" ng-click=\"$ctrl.acknowledgeTransaction()\" class=\"btn btn-custom-decline-ok waves-effect waves-light w-lg\" tabindex=\"1\">{{ 'OK' | translate }}</button>\n              </p>\n            </div>\n          </div>\n        </div>\n\n        <!-- QR Mobile Modal -->\n        <div class=\"qr-btc-wrap\">\n          <div id=\"qr-modal\" tabindex=\"-1\" class=\"sweet-overlay\">\n            <div class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"true\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"true\" data-has-done-function=\"false\" data-timer=\"null\" style=\"display: block; margin-top: -189px;\">\n              <p class=\"sub-head\">\n                <canvas id=\"qr-canvass-modal\" class=\"qr-canvas\"></canvas>\n                {{ 'Tap or Scan to pay' | translate }}\n              </p>\n              <button type=\"button\" ng-click=\"$ctrl.closeModal()\" class=\"btn btn-danger waves-effect waves-light\">{{ 'Close' | translate }}</button>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <!-- Sidebar -->\n    <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap bitcoin-bg active\">\n        <i class=\"fas fa-receipt visible-md visible-xs visible-sm\" type=\"button\"></i>\n        <div class=\"gateway-sidebar\">\n          <img src=\"{{ $ctrl.paymentOptionsViewDetails.activeDisplay.details.logo }}\" class=\"payment-option-logo\">\n          \n          <!-- BTC EXchange Rate -->\n          <h4 class=\"ac-white-text text-center uppercase m-b-0\">{{ 'Exchange Rate' | translate }}</h4>\n          <div class=\"exchange-rate\">\n            <h4 class=\"ac-white-text text-center uppercase bold m-t-0\">\n              1 BTC = <span id=\"btc-adjusted-value\">{{ $ctrl.bitcoinRate.initialRate }}</span>\n            </h4>\n          </div>\n          <p class=\"note\">{{ 'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.' | translate }}</p>\n  \n          <hr class=\"m-10\">\n\n          <!-- Transaction Summary -->\n          <div class=\"transaction-summary\">\n            <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n            <div class=\"font-lg\">\n              <span>{{ 'Total BTC amount to send:' | translate }}\n                <p class=\"bold\">{{ $ctrl.form.totalBtc }} BTC</p>\n              </span>\n  \n              <span>{{ 'Total EUR amount to receive:' | translate }}\n                  <p class=\"bold\">{{ $ctrl.form.totalAmount }} EUR</p>\n              </span>\n            </div>\n          </div>\n\n          <!-- Transaction Status -->\n          <div class=\"transaction-status\" ng-if=\"$ctrl.bitcoinTransaction\">\n            <hr class=\"m-10\">\n            <h4 class=\"uppercase text-center ac-white-text\">\n              {{ 'Transaction Status' | translate }}\n              <p class=\"bold\" ng-if=\"$ctrl.isBitcoinTransactionRequested\">{{ 'Requested' | translate }}</p>\n              <p class=\"bold\" ng-if=\"$ctrl.isBitcoinTransactionPending\">{{ 'Pending Confirmation' | translate }}</p>\n              <p class=\"bold\" ng-if=\"$ctrl.isBitcoinTransactionConfirmed\">{{ 'Confirmed' | translate }}</p>\n              <p class=\"bold\" ng-if=\"$ctrl.isBitcoinTransactionDeclined\">{{ 'Declined' | translate }}</p>\n            </h4>\n          </div>\n          \n          <!-- Timer -->\n          <p ng-show=\"$ctrl.bitcoinTransaction && $ctrl.isBitcoinTransactionRequested\" id=\"btc-timer\" class=\"btc-timer text-center\"></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _promise = __webpack_require__(1100);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1188);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _bitcoinform = __webpack_require__(1219);
	
	var _qrious = __webpack_require__(1221);
	
	var _qrious2 = _interopRequireDefault(_qrious);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BitcoinFormController = function (_BaseController) {
	  BitcoinFormController.$inject = ["AppService", "PaymentOptionApiService", "TransactionApiService", "CustomerApiService", "$timeout", "$document"];
	  (0, _inherits3.default)(BitcoinFormController, _BaseController);
	
	  function BitcoinFormController(AppService, PaymentOptionApiService, TransactionApiService, CustomerApiService, $timeout, $document) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BitcoinFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BitcoinFormController.__proto__ || (0, _getPrototypeOf2.default)(BitcoinFormController)).call(this, AppService));
	
	    _this.PaymentOptionApiService = PaymentOptionApiService;
	    _this.TransactionApiService = TransactionApiService;
	    _this.CustomerApiService = CustomerApiService;
	    _this.$timeout = $timeout;
	    _this.$document = $document;
	
	    _this.bitcoinRate = null;
	    _this.bitcoinTransaction == null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(BitcoinFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.form = new _bitcoinform.BitcoinDepositForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('deposit');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('deposit');
	      this.form.email = this.selectedPaymentOption.email;
	
	      this.addListener(_events2.default.BTC_EXCHANGE_RATE, function (event) {
	        if (event.bitcoinRate.type === 'deposit') {
	          _this2.form.bitcoinRate = event.bitcoinRate;
	          _this2.blinkExchangeRate();
	          _this2.bitcoinRate = event.bitcoinRate;
	          _this2.onBtcInputChanged();
	        }
	      });
	
	      this.addListener(_events2.default.TRANSACTION_DECLINED, function (declinedEvent) {
	        if (declinedEvent.transactionId === _this2.bitcoinTransaction.id) {
	          _this2.bitcoinTransaction.isDeclined = true;
	          _this2.showNecessaryModals();
	        }
	      });
	
	      this.addListener(_events2.default.BITCOIN_RATE_TRANSACTION_EXPIRED, function (event) {
	        if (event.transactionId === _this2.bitcoinTransaction.id) {
	          _this2.bitcoinTransaction.isRateExpired = true;
	          _this2.showNecessaryModals();
	        }
	      });
	
	      // Display the form when all the promises has been completed.
	      _promise2.default.all([this.getBitcoinRate(), this.checkForActiveBitcoinTransaction()]).then(function (values) {
	        _this2.form.props.isReady = true;
	      });
	
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	
	      this.$timeout(function () {
	        $("#qr-modal .close").click(function () {
	          $('#qr-modal').hide();
	        });
	      }, 500);
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      (0, _get3.default)(BitcoinFormController.prototype.__proto__ || (0, _getPrototypeOf2.default)(BitcoinFormController.prototype), '$onDestroy', this).call(this);
	
	      if (this.timerInterval !== null) {
	        clearInterval(this.timerInterval);
	      }
	    }
	
	    // This would handle the initial display when loading the Bitcoin Form.
	
	  }, {
	    key: 'getBitcoinRate',
	    value: function getBitcoinRate() {
	      var _this3 = this;
	
	      return this.PaymentOptionApiService.getBitcoinAdjustment().then(function (bitcoinRate) {
	        _this3.bitcoinRate = bitcoinRate;
	        // TODO: Do not set bitcoinRate on form.
	        _this3.form.bitcoinRate = bitcoinRate;
	      });
	    }
	  }, {
	    key: 'checkForActiveBitcoinTransaction',
	    value: function checkForActiveBitcoinTransaction() {
	      var _this4 = this;
	
	      return this.TransactionApiService.checkForActiveBitcoinTransaction().then(function (bitcoinTransaction) {
	        _this4.bitcoinTransaction = bitcoinTransaction;
	        if (_this4.bitcoinTransaction) {
	          _this4.createQRCode();
	          _this4.form = _bitcoinform.BitcoinDepositForm.fill(_this4.details.customerProducts, _this4.details.paymentOptions, _this4.bitcoinTransaction.bitcoinSubtransactions);
	          _this4.addConfirmationSubscription(_this4.bitcoinTransaction.id);
	
	          if (_this4.bitcoinTransaction.isTimeRemainingExpired) {
	            _this4.declineBitcoinTransaction().then(function () {
	              _this4.bitcoinTransaction.isDeclined = true;
	              _this4.showNecessaryModals();
	            });
	          } else {
	            _this4.startTimer();
	            _this4.showNecessaryModals();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'addConfirmationSubscription',
	    value: function addConfirmationSubscription(transactionId) {}
	  }, {
	    key: 'showNecessaryModals',
	    value: function showNecessaryModals() {
	      if (this.isBitcoinTransactionConfirmed) {
	        this.$timeout(function () {
	          $('#btc-confirmation-modal').show();
	        }, 1000);
	      }
	
	      if (this.isBitcoinTransactionDeclined) {
	        this.$timeout(function () {
	          $('#btc-rate-expired-modal').hide();
	          $('#btc-declined-modal').show();
	        }, 500);
	      }
	
	      if (this.isBitcoinTransactionPending) {
	        this.$timeout(function () {
	          $('#btc-rate-expired-modal').hide();
	          $('#btc-pending-confirmation-modal').show();
	        }, 500);
	      }
	
	      if (this.isBitcoinRateExpired && !this.isBitcoinTransactionDeclined && !this.isBitcoinTransactionPending && !this.isBitcoinTransactionConfirmed) {
	        this.$timeout(function () {
	          $('#btc-rate-expired-modal').show();
	        }, 500);
	      }
	    }
	  }, {
	    key: 'showQrModal',
	    value: function showQrModal() {
	      var _this5 = this;
	
	      this.$timeout(function () {
	        $('#qr-modal').show();
	        _this5.createQRCodeModal();
	      }, 1000);
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$timeout(function () {
	        $('#qr-modal').hide();
	      }, 500);
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this6 = this;
	
	      if (this.bitcoinTransaction === null || this.bitcoinTransaction.isRateExpired) {
	        return;
	      }
	
	      var timerDom = this.$document[0].getElementsByClassName('btc-timer');
	
	      if (this.bitcoinTransaction.isLockDownRateTimeExpired) {
	        timerDom[0].innerHTML = '00:00:00';
	
	        if (!this.bitcoinTransaction.isRateExpired) {
	          this.lockRateBitcoinTransaction();
	        }
	
	        return;
	      }
	
	      var timeRemaining = this.bitcoinTransaction.lockDownRateTimeRemaining;
	      timerDom.innerHTML = timeRemaining.format('HH:mm:ss');
	
	      var isExpired = function isExpired(moment) {
	        return moment.format('HH:mm:ss') === '00:00:00';
	      };
	
	      // Make sure that there is only 1 running instance of interval
	      if (this.timerInterval) {
	        clearInterval(this.timerInterval);
	      }
	
	      this.timerInterval = setInterval(function () {
	        timeRemaining.subtract(1, 'seconds');
	        if (isExpired(timeRemaining)) {
	          clearInterval(_this6.timerInterval);
	          _this6.lockRateBitcoinTransaction();
	        }
	
	        timerDom[0].innerHTML = timeRemaining.format('HH:mm:ss');
	        if (timerDom[1]) {
	          timerDom[1].innerHTML = timeRemaining.format('HH:mm:ss');
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'blinkExchangeRate',
	    value: function blinkExchangeRate() {
	      var _this7 = this;
	
	      var exchangeRate = document.getElementsByClassName('exchange-rate')[0];
	      exchangeRate.classList.add('blinking');
	
	      var seconds = 0;
	
	      this.blinkInterval = setInterval(function () {
	        seconds += 1000;
	
	        if (seconds === 2000) {
	          exchangeRate.classList.remove('blinking');
	          clearInterval(_this7.blinkInterval);
	        }
	      }, 2000);
	    }
	  }, {
	    key: 'declineBitcoinTransaction',
	    value: function declineBitcoinTransaction() {
	      return this.TransactionApiService.declineBitcoinTransaction();
	    }
	  }, {
	    key: 'lockRateBitcoinTransaction',
	    value: function lockRateBitcoinTransaction() {
	      this.TransactionApiService.lockRateBitcoinTransaction();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this8 = this;
	
	      this.form.props.isSubmitting = true;
	      this.TransactionApiService.deposit(this.form.toPayload(this.bitcoinRate)).then(function () {
	        return _this8.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        console.error(errors);
	        _this8.form.props.isSubmitting = false;
	        _this8.form.error.setFormErrors(errors);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      var _this9 = this;
	
	      this.checkForActiveBitcoinTransaction().then(function () {
	        _this9.form.props.isSubmitting = false;
	        _this9.updatePaymentOption();
	      });
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	      this.onBtcInputChanged();
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'formatBTC',
	    value: function formatBTC(subTransaction) {
	      return subTransaction.btc = parseFloat(subTransaction.btc);
	    }
	  }, {
	    key: 'createQRCode',
	    value: function createQRCode() {
	      var _this10 = this;
	
	      this.$timeout(function () {
	        var qr = new _qrious2.default({
	          element: document.getElementById('qr'),
	          size: 200,
	          value: _this10.bitcoinTransaction.receivingAddress
	        });
	      }, 1000);
	    }
	  }, {
	    key: 'createQRCodeModal',
	    value: function createQRCodeModal() {
	      var qrModal = new _qrious2.default({
	        element: document.getElementById('qr-canvass-modal'),
	        size: 100,
	        value: this.bitcoinTransaction.receivingAddress
	      });
	    }
	  }, {
	    key: 'onBtcInputChanged',
	    value: function onBtcInputChanged() {
	      var adjustedRate = this.form.getBtcAdjustedRate(this.bitcoinRate);
	
	      var btcAdjustedDisplay = document.getElementById('btc-adjusted-value');
	      btcAdjustedDisplay.innerHTML = adjustedRate;
	
	      // Do not recompute if there is current transaction
	      if (this.bitcoinTransaction === null) {
	        this.form.computeAmountConversion(adjustedRate);
	      }
	    }
	  }, {
	    key: 'onAmountInputChanged',
	    value: function onAmountInputChanged() {
	      var adjustedRate = this.form.getBtcAdjustedRateFromTotalAmount(this.bitcoinRate);
	
	      var btcAdjustedDisplay = document.getElementById('btc-adjusted-value');
	      btcAdjustedDisplay.innerHTML = adjustedRate;
	
	      // Do not recompute if there is current transaction
	      if (this.bitcoinTransaction === null) {
	        this.form.computeBitcoinConversion(adjustedRate);
	      }
	    }
	  }, {
	    key: 'acknowledgeTransaction',
	    value: function acknowledgeTransaction() {
	      var _this11 = this;
	
	      if (this.bitcoinTransaction !== null) {
	        this.TransactionApiService.acknowledgeBitcoinTransaction().then(function () {
	          _this11.bitcoinTransaction = null;
	          _this11.form.reset();
	          // TODO: Investigate why paymentOptionType becomes null on form reset.
	          _this11.form.paymentOptionType = _this11.selectedPaymentOption.type;
	
	          clearInterval(_this11.timerInterval);
	
	          $('#btc-confirmation-modal').hide();
	          $('#btc-declined-modal').hide();
	
	          _this11.checkForActiveBitcoinTransaction().then(function () {
	            _this11.updatePaymentOption();
	          });
	        });
	      }
	    }
	
	    // Update the current selected payment option.
	    // This is to ensure that when a payment option is newly created it
	    // keeps synced with the ui and the form model.
	
	  }, {
	    key: 'updatePaymentOption',
	    value: function updatePaymentOption() {
	      var _this12 = this;
	
	      this.CustomerApiService.getPaymentOptions().then(function (updatedPaymentOptions) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(updatedPaymentOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var updatedPaymentOption = _step.value;
	
	            if (updatedPaymentOption.type === _this12.selectedPaymentOption.type) {
	              _this12.selectedPaymentOption.id = updatedPaymentOption.id;
	              _this12.form.paymentOption = updatedPaymentOption.id;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'isBitcoinTransactionRequested',
	    get: function get() {
	      if (this.bitcoinTransaction && this.bitcoinTransaction.isRequested) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isBitcoinTransactionPending',
	    get: function get() {
	      if (this.bitcoinTransaction && this.bitcoinTransaction.isPending) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isBitcoinTransactionConfirmed',
	    get: function get() {
	      if (this.bitcoinTransaction && this.bitcoinTransaction.isConfirmed) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isBitcoinTransactionDeclined',
	    get: function get() {
	      if (this.bitcoinTransaction && this.bitcoinTransaction.isDeclined) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isBitcoinRateExpired',
	    get: function get() {
	      if (this.bitcoinTransaction && this.bitcoinTransaction.isRateExpired) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isBitcoinTransactionOnProcess',
	    get: function get() {
	      return this.isBitcoinTransactionConfirmed || this.isBitcoinTransactionDeclined || this.isBitcoinTransactionPending || this.isBitcoinTransactionRequested;
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return BitcoinFormController;
	}(_basecontroller.BaseController);
	
	exports.default = BitcoinFormController;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BitcoinDepositForm = undefined;
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1188);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _number = __webpack_require__(1203);
	
	var _transactionform = __webpack_require__(1200);
	
	var _bitcoinRate = __webpack_require__(1220);
	
	var _number2 = __webpack_require__(1203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BitcoinDepositForm = exports.BitcoinDepositForm = function (_TransactionForm) {
	  (0, _inherits3.default)(BitcoinDepositForm, _TransactionForm);
	
	  function BitcoinDepositForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, BitcoinDepositForm);
	    return (0, _possibleConstructorReturn3.default)(this, (BitcoinDepositForm.__proto__ || (0, _getPrototypeOf2.default)(BitcoinDepositForm)).call(this, customerProducts, paymentOptions));
	  }
	
	  (0, _createClass3.default)(BitcoinDepositForm, [{
	    key: 'getBtcAdjustedRate',
	    value: function getBtcAdjustedRate(bitcoinRate) {
	      return bitcoinRate.computeAdjustedRate(this.totalBtc);
	    }
	  }, {
	    key: 'getBtcAdjustedRateFromTotalAmount',
	    value: function getBtcAdjustedRateFromTotalAmount(bitcoinRate) {
	      return bitcoinRate.computeAdjustedRateFromAmount(this.totalAmount);
	    }
	  }, {
	    key: 'computeAmountConversion',
	    value: function computeAmountConversion(btcAdjustedRate) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.subTransactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var subTransaction = _step.value;
	
	          subTransaction.convertBtcToAmount(btcAdjustedRate);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'computeBitcoinConversion',
	    value: function computeBitcoinConversion(btcAdjustedRate) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.subTransactions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var subTransaction = _step2.value;
	
	          subTransaction.convertAmountToBtc(btcAdjustedRate);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      (0, _get3.default)(BitcoinDepositForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(BitcoinDepositForm.prototype), 'reset', this).call(this);
	
	      this.props.isReady = true;
	      this.props.isSubmitting = false;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: 'toPayload',
	    value: function toPayload(bitcoinRate) {
	      var range = bitcoinRate.getRange(this.totalBtc);
	
	      var payload = {
	        transaction: {
	          paymentOptionType: this.paymentOptionType,
	          paymentDetails: {
	            rateDetails: {
	              rangeStart: _bitcoinRate.Range.formatDecimal(range.start),
	              rangeEnd: _bitcoinRate.Range.formatDecimal(range.end),
	              adjustment: range.getAdjustment(bitcoinRate.latestBaseRate),
	              adjustmentType: range.adjustmentType
	            },
	            rate: this.getBtcAdjustedRate(bitcoinRate),
	            blockchainRate: bitcoinRate.latestBaseRate.value()
	          }
	        }
	      };
	
	      var subTransactions = {};
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.subTransactions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var subTransaction = _step3.value;
	
	          subTransactions[subTransaction.key] = {
	            product: subTransaction.product,
	            amount: subTransaction.amount,
	            paymentDetails: {
	              bitcoin: subTransaction.btc
	            }
	          };
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      payload['transaction']['subTransactions'] = subTransactions;
	      payload['transaction']['paymentOption'] = this.paymentOption;
	      payload['transaction']['customerFee'] = '0';
	
	      return payload;
	    }
	  }, {
	    key: 'totalAmount',
	
	
	    /**
	     * @override
	     */
	    get: function get() {
	      var totalAmount = (0, _numeral2.default)(0);
	
	      angular.forEach(this.subTransactions, function (subTransaction) {
	        totalAmount.add(subTransaction.amount);
	      });
	
	      return totalAmount.format(_number2.DEFAULT_DECIMAL_FORMAT);
	    }
	  }, {
	    key: 'totalBtc',
	    get: function get() {
	      var totalBtc = (0, _numeral2.default)(0);
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(this.subTransactions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var subTransaction = _step4.value;
	
	          totalBtc.add(subTransaction.btc);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      return (0, _number.format)(totalBtc, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }], [{
	    key: 'fill',
	    value: function fill(customerProducts, paymentOptions, subTransactions) {
	      var form = new BitcoinDepositForm(customerProducts, paymentOptions);
	
	      // Empty subtransactions before filling cause there is always one default subtransaction when the form is created.
	      form.subTransactions = [];
	
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = (0, _getIterator3.default)(subTransactions), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var subTransaction = _step5.value;
	
	          var subTransactionForm = form.addSubTransaction();
	
	          subTransactionForm.amount = subTransaction.amount.value();
	          subTransactionForm.btc = subTransaction.btc.value();
	          subTransactionForm.product = subTransaction.customerProduct.id;
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      form.props.readOnly = true;
	      form.props.isReady = true;
	
	      return form;
	    }
	  }]);
	  return BitcoinDepositForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WithdrawalConfig = exports.Config = exports.Range = exports.BitcoinRate = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _number = __webpack_require__(1203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BitcoinRate = exports.BitcoinRate = function () {
	  function BitcoinRate() {
	    (0, _classCallCheck3.default)(this, BitcoinRate);
	
	    this._latestBaseRate = null;
	    this._conversionTable = [];
	    this._config = null;
	    this._type = 'deposit';
	  }
	
	  (0, _createClass3.default)(BitcoinRate, [{
	    key: 'computeAdjustedRate',
	
	
	    /** 
	     * @param {number} totalBtc the total btc's user has inputed
	     * @returns string
	     */
	    value: function computeAdjustedRate(totalBtc) {
	      var range = this.getRange(totalBtc);
	
	      return range.adjustRate(this.latestBaseRate, this.type).format(_number.DEFAULT_DECIMAL_FORMAT);
	    }
	  }, {
	    key: 'computeAdjustedRateFromAmount',
	    value: function computeAdjustedRateFromAmount(totalAmount) {
	      var range = this._getRangeFromAmount(totalAmount);
	
	      return range.adjustRate(this.latestBaseRate, this.type).format(_number.DEFAULT_DECIMAL_FORMAT);
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange(btc) {
	      var inBetween = function inBetween(number, start, end) {
	        return number >= start && number <= end;
	      };
	
	      var range = this.conversionTable.filter(function (range) {
	        return inBetween(btc, range.start.value(), range.end.value());
	      });
	
	      if (range.length < 1) {
	        return this._getDefaultRange();
	      }
	
	      return range[0];
	    }
	  }, {
	    key: '_getRangeFromAmount',
	    value: function _getRangeFromAmount(amount) {
	      var inBetween = function inBetween(number, start, end) {
	        return number >= start && number <= end;
	      };
	
	      var range = this.conversionTable.filter(function (range) {
	        return inBetween(amount, range.startAmount.value(), range.endAmount.value());
	      });
	
	      if (range.length < 1) {
	        return this._getDefaultRange();
	      }
	
	      return range[0];
	    }
	  }, {
	    key: '_getDefaultRange',
	    value: function _getDefaultRange() {
	      return this.conversionTable.filter(function (range) {
	        return range.isDefault;
	      })[0];
	    }
	  }, {
	    key: 'type',
	    set: function set(type) {
	      this._type = type;
	    },
	    get: function get() {
	      return this._type;
	    }
	  }, {
	    key: 'latestBaseRate',
	    set: function set(latestBaseRate) {
	      this._latestBaseRate = latestBaseRate;
	    },
	    get: function get() {
	      return this._latestBaseRate;
	    }
	  }, {
	    key: 'conversionTable',
	    set: function set(conversionTable) {
	      this._conversionTable = conversionTable;
	    },
	    get: function get() {
	      return this._conversionTable;
	    }
	  }, {
	    key: 'config',
	    set: function set(config) {
	      this._config = config;
	    },
	    get: function get() {
	      return this._config;
	    }
	  }, {
	    key: 'initialRate',
	    get: function get() {
	      var range = this._getDefaultRange();
	
	      return range.adjustRate(this.latestBaseRate, this.type).format(_number.DEFAULT_DECIMAL_FORMAT);
	    }
	  }], [{
	    key: 'fromPayload',
	    value: function fromPayload(payload) {
	      var bitcoinRate = new BitcoinRate();
	
	      bitcoinRate.latestBaseRate = (0, _numeral2.default)(payload.latest_base_rate);
	      bitcoinRate.config = Config.fromPayload(payload['bitcoin_config']);
	
	      payload.conversion_table.forEach(function (rangePayload) {
	        bitcoinRate.conversionTable.push(Range.fromPayload(rangePayload, bitcoinRate.latestBaseRate));
	      });
	
	      return bitcoinRate;
	    }
	  }, {
	    key: 'fromWithdrawalAdjustmentPayload',
	    value: function fromWithdrawalAdjustmentPayload(payload) {
	      var bitcoinRate = new BitcoinRate();
	
	      bitcoinRate.latestBaseRate = (0, _numeral2.default)(payload.latest_base_rate);
	      bitcoinRate.config = WithdrawalConfig.fromPayload(payload['bitcoin_config']);
	
	      payload.conversion_table.forEach(function (rangePayload) {
	        bitcoinRate.conversionTable.push(Range.fromPayload(rangePayload, bitcoinRate.latestBaseRate));
	      });
	
	      bitcoinRate.type = 'withdrawal';
	
	      return bitcoinRate;
	    }
	  }]);
	  return BitcoinRate;
	}();
	
	var Range = exports.Range = function () {
	  function Range() {
	    (0, _classCallCheck3.default)(this, Range);
	
	    this._start = null;
	    this._end = null;
	    this._isDefault = false;
	    this._fixedAdjustment = (0, _numeral2.default)(0);
	    this._percentAdjustment = (0, _numeral2.default)(0);
	
	    // Used to convert actual amount into btc value.
	    this._startAmount = null;
	    this._endAmount = null;
	  }
	
	  (0, _createClass3.default)(Range, [{
	    key: 'setEndAmount',
	    value: function setEndAmount(nextRange, baseRate) {
	      var btcSmallestValue = (0, _numeral2.default)('0.0000000001');
	      var smallestValue = (0, _numeral2.default)(baseRate.value() * btcSmallestValue.value());
	      this.endAmount = (0, _numeral2.default)(nextRange.startAmount.value() - smallestValue.value());
	    }
	  }, {
	    key: 'adjustRate',
	
	
	    /**
	     * Computes for Adjusted rate.
	     * 
	     * 
	     * @param numeral bitcoinLatestRate 
	     * @returns numeral
	     * @throws an error probably because the api returns erroneous payload.
	     */
	    value: function adjustRate(bitcoinLatestRate, type) {
	      if (this.fixedAdjustment.value() !== null) {
	        return this._computeByFixedAdjustment(bitcoinLatestRate, type);
	      }
	
	      if (this.percentAdjustment.value() !== null) {
	        return this._computeByPercentageAdjustment(bitcoinLatestRate, type);
	      }
	
	      throw 'Code should not go here.';
	    }
	  }, {
	    key: '_computeByFixedAdjustment',
	    value: function _computeByFixedAdjustment(bitcoinLatestRate, type) {
	      var adjustment = null;
	
	      if (type === 'deposit') {
	        adjustment = bitcoinLatestRate.value() - this.fixedAdjustment.value();
	      } else {
	        adjustment = bitcoinLatestRate.value() + this.fixedAdjustment.value();
	      }
	
	      return (0, _numeral2.default)(adjustment);
	    }
	  }, {
	    key: '_computeByPercentageAdjustment',
	    value: function _computeByPercentageAdjustment(bitcoinLatestRate, type) {
	      var adjustment = bitcoinLatestRate.value() * (this.percentAdjustment.value() / 100);
	
	      if (type === 'deposit') {
	        adjustment = (0, _numeral2.default)(bitcoinLatestRate.value() - adjustment);
	      } else {
	        adjustment = (0, _numeral2.default)(bitcoinLatestRate.value() + adjustment);
	      }
	
	      return (0, _numeral2.default)(adjustment.format(_number.BITCOIN_DECIMAL_PLACES_FORMAT));
	    }
	  }, {
	    key: 'getAdjustment',
	
	
	    // The value to be deducted based on adjustment type
	    value: function getAdjustment(bitcoinLatestRate) {
	      if (this.adjustmentType === 'fixed') {
	        return this.fixedAdjustment.value();
	      }
	
	      if (this.percentAdjustment.value() !== null) {
	        return bitcoinLatestRate.value() * (this.percentAdjustment.value() / 100);;
	      }
	
	      throw 'Code should not go here.';
	    }
	  }, {
	    key: 'start',
	    set: function set(start) {
	      this._start = start;
	    },
	    get: function get() {
	      return this._start;
	    }
	  }, {
	    key: 'end',
	    set: function set(end) {
	      this._end = end;
	    },
	    get: function get() {
	      return this._end;
	    }
	  }, {
	    key: 'startAmount',
	    set: function set(startAmount) {
	      this._startAmount = startAmount;
	    },
	    get: function get() {
	      return this._startAmount;
	    }
	  }, {
	    key: 'endAmount',
	    set: function set(endAmount) {
	      this._endAmount = endAmount;
	    },
	    get: function get() {
	      return this._endAmount;
	    }
	  }, {
	    key: 'isDefault',
	    set: function set(isDefault) {
	      this._isDefault = isDefault;
	    },
	    get: function get() {
	      return this._isDefault;
	    }
	  }, {
	    key: 'fixedAdjustment',
	    set: function set(fixedAdjustment) {
	      this._fixedAdjustment = fixedAdjustment;
	    },
	    get: function get() {
	      return this._fixedAdjustment;
	    }
	  }, {
	    key: 'percentAdjustment',
	    set: function set(percentAdjustment) {
	      this._percentAdjustment = percentAdjustment;
	    },
	    get: function get() {
	      return this._percentAdjustment;
	    }
	  }, {
	    key: 'adjustmentType',
	    get: function get() {
	      if (this.fixedAdjustment.value() !== null) {
	        return 'fixed';
	      }
	
	      if (this.percentAdjustment.value() !== null) {
	        return 'percentage';
	      }
	
	      throw 'Code should not go here.';
	    }
	  }], [{
	    key: 'fromPayload',
	    value: function fromPayload(payload, latestBaseRate) {
	      var range = new Range();
	
	      range.isDefault = payload.is_default;
	      range.start = (0, _numeral2.default)(payload.range_start);
	      range.end = (0, _numeral2.default)(payload.range_end);
	      range.fixedAdjustment = (0, _numeral2.default)(payload.fixed_adjustment);
	      range.percentAdjustment = (0, _numeral2.default)(payload.percent_adjustment);
	
	      var baseRate = range.adjustRate(latestBaseRate);
	      range.startAmount = (0, _numeral2.default)(baseRate.value() * range.start.value());
	      range.endAmount = (0, _numeral2.default)(baseRate.value() * range.end.value());
	
	      return range;
	    }
	  }, {
	    key: 'formatDecimal',
	    value: function formatDecimal(numeral) {
	      return (0, _number.format)(numeral, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }]);
	  return Range;
	}();
	
	var Config = exports.Config = function () {
	  function Config(minimumAllowedDeposit, maximumAllowedDeposit, minutesInterval) {
	    (0, _classCallCheck3.default)(this, Config);
	
	    this._minimumAllowedDeposit = (0, _numeral2.default)(minimumAllowedDeposit);
	    this._maximumAllowedDeposit = (0, _numeral2.default)(maximumAllowedDeposit);
	    this._minutesInterval = minutesInterval;
	  }
	
	  (0, _createClass3.default)(Config, [{
	    key: 'maximumAllowedDeposit',
	    set: function set(maximumAllowedDeposit) {
	      this._maximumAllowedDeposit = maximumAllowedDeposit;
	    },
	    get: function get() {
	      return this._maximumAllowedDeposit;
	    }
	  }, {
	    key: 'formattedMaximumAllowedDeposit',
	    get: function get() {
	      return (0, _number.format)(this.maximumAllowedDeposit, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }, {
	    key: 'minimumAllowedDeposit',
	    set: function set(minimumAllowedDeposit) {
	      this._minimumAllowedDeposit = minimumAllowedDeposit;
	    },
	    get: function get() {
	      return this._minimumAllowedDeposit;
	    }
	  }, {
	    key: 'minutesInterval',
	    get: function get() {
	      return this._minutesInterval;
	    }
	  }, {
	    key: 'formattedMinimumAllowedDeposit',
	    get: function get() {
	      return (0, _number.format)(this.minimumAllowedDeposit, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }], [{
	    key: 'fromPayload',
	    value: function fromPayload(payload) {
	      var config = new Config(payload['minimumAllowedDeposit'], payload['maximumAllowedDeposit'], payload['minutesInterval']);
	
	      return config;
	    }
	  }]);
	  return Config;
	}();
	
	var WithdrawalConfig = exports.WithdrawalConfig = function () {
	  function WithdrawalConfig(minimumAllowedWithdrawal, maximumAllowedWithdrawal, minutesWithdrawalInterval) {
	    (0, _classCallCheck3.default)(this, WithdrawalConfig);
	
	    this._minimumAllowedWithdrawal = (0, _numeral2.default)(minimumAllowedWithdrawal);
	    this._maximumAllowedWithdrawal = (0, _numeral2.default)(maximumAllowedWithdrawal);
	    this._minutesWithdrawalInterval = minutesWithdrawalInterval;
	  }
	
	  (0, _createClass3.default)(WithdrawalConfig, [{
	    key: 'maximumAllowedWithdrawal',
	    set: function set(maximumAllowedWithdrawal) {
	      this._maximumAllowedWithdrawal = maximumAllowedWithdrawal;
	    },
	    get: function get() {
	      return this._maximumAllowedWithdrawal;
	    }
	  }, {
	    key: 'formattedMaximumAllowedWithdrawal',
	    get: function get() {
	      return (0, _number.format)(this.maximumAllowedWithdrawal, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }, {
	    key: 'minimumAllowedWithdrawal',
	    set: function set(minimumAllowedWithdrawal) {
	      this._minimumAllowedWithdrawal = minimumAllowedWithdrawal;
	    },
	    get: function get() {
	      return this._minimumAllowedWithdrawal;
	    }
	  }, {
	    key: 'minutesWithdrawalInterval',
	    get: function get() {
	      return this._minutesWithdrawalInterval;
	    }
	  }, {
	    key: 'formattedMinimumAllowedWithdrawal',
	    get: function get() {
	      return (0, _number.format)(this.minimumAllowedWithdrawal, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }], [{
	    key: 'fromPayload',
	    value: function fromPayload(payload) {
	      var withdrawalConfig = new WithdrawalConfig(payload['minimumAllowedWithdrawal'], payload['maximumAllowedWithdrawal'], payload['minutesWithdrawalInterval']);
	
	      return withdrawalConfig;
	    }
	  }]);
	  return WithdrawalConfig;
	}();
	
	exports.default = BitcoinRate;

/***/ }),
/* 1221 */,
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _successModal = __webpack_require__(1223);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _successModal3 = __webpack_require__(1224);
	
	var _successModal4 = _interopRequireDefault(_successModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalComponent = {
	  bindings: {
	    onClosed: '&'
	  },
	  template: _successModal2.default,
	  controller: _successModal4.default
	};
	
	exports.default = modalComponent;

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"successModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n    <div class=\"icon success animate\">\n        <span class=\"line tip animateSuccessTip\"></span>\n        <span class=\"line long animateSuccessLong\"></span>\n        <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n    </div>\n    <h3>{{ 'Thank you for making a deposit!' | translate }}</h3>\n    <p class=\"lead text-muted\">\n        {{ 'We are now verifying your deposit. Once we have received your deposit,' | translate }} <span id=\"on-success-message\"></span>\n    </p>\n    <p>\n        <button ng-click=\"$ctrl.clickedOk()\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'OK' | translate }}</button>\n    </p>\n</div>\n"

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _modal = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessModalController = function () {
	  SuccessModalController.$inject = ["$state"];
	  function SuccessModalController($state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SuccessModalController);
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(SuccessModalController, [{
	    key: 'clickedOk',
	    value: function clickedOk() {
	      (0, _modal.hideModal)('successModal');
	      this.$state.go('overview');
	    }
	  }]);
	  return SuccessModalController;
	}();
	
	exports.default = SuccessModalController;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _netellerModal = __webpack_require__(1226);
	
	var _netellerModal2 = _interopRequireDefault(_netellerModal);
	
	var _netellerModal3 = __webpack_require__(1227);
	
	var _netellerModal4 = _interopRequireDefault(_netellerModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var netellerModalComponent = {
	  bindings: {
	    modal: '<'
	  },
	  template: _netellerModal2.default,
	  controller: _netellerModal4.default
	};
	
	exports.default = netellerModalComponent;

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"netellerModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n  <div class=\"icon success animate\">\n      <span class=\"line tip animateSuccessTip\"></span>\n      <span class=\"line long animateSuccessLong\"></span>\n      <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n  </div>\n  <h3>{{ 'Thank you for making a deposit!' | translate }}</h3>\n  <p class=\"lead text-muted\">\n      {{ $ctrl.modal.content }}\n  <p>\n      <button ng-click=\"$ctrl.goToNeteller()\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'OK' | translate }}</button>\n  </p>\n</div>\n"

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _modal = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var netellerLogin = 'https://member.neteller.com/';
	
	var SkrillModalController = function () {
	  function SkrillModalController() {
	    (0, _classCallCheck3.default)(this, SkrillModalController);
	  }
	
	  (0, _createClass3.default)(SkrillModalController, [{
	    key: 'goToNeteller',
	    value: function goToNeteller() {
	      (0, _modal.hideModal)('netellerModal');
	
	      window.open(netellerLogin, 'Ratting', 'left=700, top=300, width=600, height=400');
	    }
	  }]);
	  return SkrillModalController;
	}();
	
	exports.default = SkrillModalController;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bankModal = __webpack_require__(1229);
	
	var _bankModal2 = _interopRequireDefault(_bankModal);
	
	var _bankModal3 = __webpack_require__(1230);
	
	var _bankModal4 = _interopRequireDefault(_bankModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bankModalComponent = {
	  bindings: {
	    modal: '<'
	  },
	  template: _bankModal2.default,
	  controller: _bankModal4.default
	};
	
	exports.default = bankModalComponent;

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"bankModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n  <div class=\"icon success animate\">\n      <span class=\"line tip animateSuccessTip\"></span>\n      <span class=\"line long animateSuccessLong\"></span>\n      <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n  </div>\n  <h3>{{ 'Thank you for making a deposit!' | translate }}</h3>\n  <p class=\"lead text-muted\">\n      {{ $ctrl.modal.content }}\n  <p>\n      <a ui-sref=\"overview\" ng-click=\"$ctrl.hideBankModal()\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'OK' | translate }}</a>\n  </p>\n</div>\n"

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _modal = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankModalController = function () {
	  function BankModalController() {
	    (0, _classCallCheck3.default)(this, BankModalController);
	  }
	
	  (0, _createClass3.default)(BankModalController, [{
	    key: 'hideBankModal',
	    value: function hideBankModal() {
	      (0, _modal.hideModal)('bankModal');
	    }
	  }]);
	  return BankModalController;
	}();
	
	exports.default = BankModalController;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _skrillModal = __webpack_require__(1232);
	
	var _skrillModal2 = _interopRequireDefault(_skrillModal);
	
	var _skrillModal3 = __webpack_require__(1233);
	
	var _skrillModal4 = _interopRequireDefault(_skrillModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var skrillModalComponent = {
	  bindings: {
	    modal: '<'
	  },
	  template: _skrillModal2.default,
	  controller: _skrillModal4.default
	};
	
	exports.default = skrillModalComponent;

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"skrillModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n    <div class=\"icon success animate\">\n        <span class=\"line tip animateSuccessTip\"></span>\n        <span class=\"line long animateSuccessLong\"></span>\n        <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n    </div>\n    <h3>{{ 'Thank you for making a deposit!' | translate }}</h3>\n    <p class=\"lead text-muted\">\n        {{ $ctrl.modal.content }}\n    <p>\n        <button ng-click=\"$ctrl.goToSkrill()\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'OK' | translate }}</button>\n    </p>\n</div>\n"

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _modal = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var skrillLogin = 'https://account.skrill.com/login';
	
	var SkrillModalController = function () {
	  function SkrillModalController() {
	    (0, _classCallCheck3.default)(this, SkrillModalController);
	  }
	
	  (0, _createClass3.default)(SkrillModalController, [{
	    key: 'goToSkrill',
	    value: function goToSkrill() {
	      (0, _modal.hideModal)('skrillModal');
	
	      window.open(skrillLogin, 'Ratting', 'left=700, top=300, width=600, height=400');
	    }
	  }]);
	  return SkrillModalController;
	}();
	
	exports.default = SkrillModalController;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _success = __webpack_require__(1235);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _success3 = __webpack_require__(1236);
	
	var _success4 = _interopRequireDefault(_success3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var successPageComponent = {
	  bindings: {},
	  template: _success2.default,
	  controller: _success4.default
	};
	
	exports.default = successPageComponent;

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	module.exports = "<topbar></topbar>\n<navbar></navbar>\n<div class=\"content-page content-wrapper\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"content-left col-sm-10 fadeIn animated\">\n        <div class=\"col-sm-12\">\n          <div class=\"card-box-content\">\n            <div class=\"head-wrapper\">\n              <h1>{{ 'Thank you' | translate }}</h1>\n              <p>{{ 'For making a deposit' | translate }}</p>\n              <i class=\"fa fa-check\"></i>\n            </div>\n            <div class=\"body-wrapper\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2\">\n              </div>\n              <div class=\"col-md-4 col-sm-4 col-xs-4\">\n                <img src=\"assets/images/ams-asianconnect.png\">\n              </div>\n              <div class=\"col-md-4 col-sm-4 col-xs-4\">\n                <img src=\"assets/images/ams-ecopayz.png\">\n              </div>\n              <div class=\"col-md-2 col-sm-2 col-xs-2\">\n              </div>\n              <div class=\"clearfix\"></div>\n              <div class=\"body-wrap-content\">\n                <p>{{ 'We are now verifying your deposit. Once we have received your deposit,' | translate }}<br> {{ 'you will see the additional funds reflected in your account.' | translate }}</p>\n                <button type=\"button\" class=\"btn btn-success\" ui-sref=\"overview\"></button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessController = function SuccessController() {
	  (0, _classCallCheck3.default)(this, SuccessController);
	};
	
	exports.default = SuccessController;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _failure = __webpack_require__(1238);
	
	var _failure2 = _interopRequireDefault(_failure);
	
	var _failure3 = __webpack_require__(1239);
	
	var _failure4 = _interopRequireDefault(_failure3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var failurePageComponent = {
	  bindings: {},
	  template: _failure2.default,
	  controller: _failure4.default
	};
	
	exports.default = failurePageComponent;

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	module.exports = "<topbar></topbar>\n<navbar></navbar>\n<div class=\"content-page content-wrapper\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"content-left col-sm-10 fadeIn animated\">\n        <div class=\"col-sm-12\">\n          <div class=\"card-box-content\">\n            <div class=\"head-wrapper error-wrap\">\n              <h1>{{ 'Sorry' | translate }}</h1>\n              <i class=\"fa fa-close\"></i>\n            </div>\n            <div class=\"body-wrapper\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2\">\n              </div>\n              <div class=\"col-md-4 col-sm-4 col-xs-4\">\n                <img src=\"assets/images/ams-asianconnect.png\">\n              </div>\n              <div class=\"col-md-4 col-sm-4 col-xs-4\">\n                <img src=\"assets/images/ams-ecopayz.png\">\n              </div>\n              <div class=\"col-md-2 col-sm-2 col-xs-2\">\n              </div>\n              <div class=\"clearfix\"></div>\n              <div class=\"body-wrap-content\">\n                <p>{{ 'cantProcessRequest' | translate }}</p>\n                <button type=\"button\" class=\"btn btn-danger\" ui-sref=\"overview\">{{ 'CONTINUE' | translate }}</button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FailureController = function FailureController() {
	  (0, _classCallCheck3.default)(this, FailureController);
	};
	
	exports.default = FailureController;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cancellation = __webpack_require__(1241);
	
	var _cancellation2 = _interopRequireDefault(_cancellation);
	
	var _cancellation3 = __webpack_require__(1242);
	
	var _cancellation4 = _interopRequireDefault(_cancellation3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cancellationPageComponent = {
	  bindings: {},
	  template: _cancellation2.default,
	  controller: _cancellation4.default
	};
	
	exports.default = cancellationPageComponent;

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	module.exports = "<topbar></topbar>\n<navbar></navbar>\n<div class=\"content-page content-wrapper\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"content-left col-sm-10 fadeIn animated\">\n        <div class=\"col-sm-12\">\n          <div class=\"card-box-content\">\n            <div class=\"head-wrapper error-wrap\">\n              <h1>{{ 'Sorry' | translate }}</h1>\n              <i class=\"fa fa-close\"></i>\n            </div>\n            <div class=\"body-wrapper\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2\">\n              </div>\n              <div class=\"col-md-4 col-sm-4 col-xs-4\">\n                <img src=\"assets/images/ams-asianconnect.png\">\n              </div>\n              <div class=\"col-md-4 col-sm-4 col-xs-4\">\n                <img src=\"assets/images/ams-ecopayz.png\">\n              </div>\n              <div class=\"col-md-2 col-sm-2 col-xs-2\">\n              </div>\n              <div class=\"clearfix\"></div>\n              <div class=\"body-wrap-content\">\n                <p>{{ 'cantProcessRequest' | translate }}</p>\n                <button type=\"button\" class=\"btn btn-danger\" ui-sref=\"overview\">{{ 'CONTINUE' | translate }}</button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CancellationController = function CancellationController() {
	  (0, _classCallCheck3.default)(this, CancellationController);
	};
	
	exports.default = CancellationController;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	var _paymentOptionsView = __webpack_require__(1244);
	
	var _customerProduct = __webpack_require__(1245);
	
	var _paymentOption = __webpack_require__(1246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DepositStore = function () {
	  DepositStore.$inject = ["TransactionApiService", "SessionService"];
	  function DepositStore(TransactionApiService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DepositStore);
	    this.TransactionApiService = TransactionApiService;
	    this.SessionService = SessionService;
	  }
	
	  /**
	   * @returns {Observable}
	   */
	
	
	  (0, _createClass3.default)(DepositStore, [{
	    key: 'getDepositDetails',
	    value: function getDepositDetails() {
	      var details$ = _Rx2.default.Observable.fromPromise(this.TransactionApiService.depositDetails());
	
	      return details$.map(function (details) {
	        return {
	          paymentOptionsViewDetails: (0, _paymentOptionsView.makePaymentOptionsViewDetails)(details.paymentOptionsDisplay),
	          customerProducts: details.customerProducts,
	          paymentOptions: (0, _paymentOption.makePaymentOptions)(details.paymentOptions)
	        };
	      });
	    }
	  }, {
	    key: 'getPaymentOptions',
	    value: function getPaymentOptions() {
	      return this.TransactionApiService.depositDetails().then(function (details) {
	        return (0, _paymentOption.makePaymentOptions)(details.paymentOptions);
	      });
	    }
	
	    /**
	     * @returns {Observable}
	     */
	
	  }, {
	    key: 'getCustomerProducts',
	    value: function getCustomerProducts() {
	      return this.getDepositDetails().map(function (details) {
	        return details.customerProducts;
	      });
	    }
	
	    /**
	     * @returns {Observable}
	     */
	
	  }, {
	    key: 'getCurrency',
	    value: function getCurrency() {
	      return this.SessionService.session.map(function (session) {
	        return session ? session.currency : null;
	      });
	    }
	  }, {
	    key: 'deposit',
	    value: function deposit(payload) {
	      var additionalHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.TransactionApiService.deposit(payload, additionalHeaders);
	    }
	  }, {
	    key: 'getStatus',
	    value: function getStatus() {
	      return this.TransactionApiService.condition();
	    }
	  }]);
	  return DepositStore;
	}();
	
	exports.default = DepositStore;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.makePaymentOptionsViewDetails = makePaymentOptionsViewDetails;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @returns {PaymentOptionsViewDetails}
	 */
	function makePaymentOptionsViewDetails(payload) {
	  var paymentOptionsViewDetails = new PaymentOptionsViewDetails();
	
	  paymentOptionsViewDetails.displays = payload.displays.map(function (display) {
	    var paymentOptionsViewDisplay = new PaymentOptionViewDisplay();
	
	    paymentOptionsViewDisplay.details = display.details;
	    paymentOptionsViewDisplay.fields = display.fields;
	    paymentOptionsViewDisplay.label = display.label;
	    paymentOptionsViewDisplay.method = display.method;
	
	    return paymentOptionsViewDisplay;
	  });
	
	  paymentOptionsViewDetails.freeFee = payload.freeFee;
	  paymentOptionsViewDetails.feeDisplay = payload.feeDisplay;
	  paymentOptionsViewDetails.freeCalendar = payload.freeCalendar;
	  paymentOptionsViewDetails.freeCalendarDisplay = payload.freeCalendarDisplay;
	  paymentOptionsViewDetails.isCountryRestricted = payload.isCountryRestricted;
	
	  return paymentOptionsViewDetails;
	}
	
	var PaymentOptionViewDisplay = function PaymentOptionViewDisplay() {
	  (0, _classCallCheck3.default)(this, PaymentOptionViewDisplay);
	
	  this.details = null;
	  this.fields = null;
	  this.label = null;
	  this.method = null;
	};
	
	var PaymentOptionsViewDetails = function () {
	  function PaymentOptionsViewDetails() {
	    (0, _classCallCheck3.default)(this, PaymentOptionsViewDetails);
	
	    // should be array of PaymentOptionsViewDetails.
	    this.displays = null;
	    // this becomes true based on back-end condition e.g
	    // when a user comes from France and some conditions on Ecopayz.
	    this.freeFee = false;
	    this.freeCalendar = false;
	
	    this.feeDisplay = null;
	    this.freeCalendarDisplay = null;
	
	    // this should be an instance of PaymentOptionViewDisplay
	    this.activeDisplay = null;
	  }
	
	  /**
	   * @param {PaymentOption} paymentOption
	   */
	
	
	  (0, _createClass3.default)(PaymentOptionsViewDetails, [{
	    key: 'updateView',
	    value: function updateView(paymentOption) {
	      this.activeDisplay = this.displays.filter(function (display) {
	        // null if paymentOption is Bank.
	        if (display.label) {
	          return display.label.toLowerCase() === paymentOption.type.toLowerCase();
	        }
	      })[0];
	    }
	
	    /**
	     * @param {string} type Transaction Type, either 'withdrawal' or 'deposit' only.
	     * @returns {string|number}
	     */
	
	  }, {
	    key: 'feeFor',
	    value: function feeFor(type) {
	      if (!this.activeDisplay) {
	        return;
	      }
	
	      return this.activeDisplay.method[type].fee;
	    }
	
	    /**
	     * @param {string} type Transaction Type, either 'withdrawal' or 'deposit' only.
	     * @returns {string} returns a formatted fee that can be used for displaying properly.
	     */
	
	  }, {
	    key: 'feeDisplayFor',
	    value: function feeDisplayFor(type) {
	      if (!this.activeDisplay) {
	        return;
	      }
	
	      if (this.isFeeFreeFor(type)) {
	        if (type === 'withdrawal') {
	          if (this.activeDisplay.label === 'Skrill' || this.activeDisplay.label === 'Neteller') {
	            return this.freeCalendarDisplay;
	          } else if (this.activeDisplay.label === 'Bitcoin' || this.activeDisplay.label === 'Bank') {
	            return 'Free';
	          }
	
	          return this.feeDisplay;
	        }
	      }
	
	      var fee = this.feeFor(type);
	
	      return isNaN(fee) ? fee : fee * 100 + '%';
	    }
	
	    /**
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isFeeFreeFor',
	    value: function isFeeFreeFor(type) {
	      if (!this.activeDisplay) {
	        return;
	      }
	
	      if (type === 'withdrawal') {
	        if (this.activeDisplay.label === 'Skrill' || this.activeDisplay.label === 'Neteller') {
	          return this.freeCalendar;
	        } else {
	          if (this.freeFee) {
	            return true;
	          }
	        }
	      }
	
	      var fee = this.feeFor(type);
	
	      if (isNaN(fee) && fee.toLowerCase() === String('FREE').toLowerCase()) {
	        return true;
	      }
	
	      if (!isNaN(fee)) {
	        return false;
	      }
	
	      throw new Exception('Invalid Fee.');
	    }
	  }]);
	  return PaymentOptionsViewDetails;
	}();

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.makeCustomerProducts = makeCustomerProducts;
	exports.makeCustomerProduct = makeCustomerProduct;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeCustomerProducts(payload) {
	  return payload.map(function (product) {
	    return makeCustomerProduct(product);
	  });
	}
	
	function makeCustomerProduct(payload) {
	  var customerProduct = new CustomerProduct(payload.id, payload.username);
	  customerProduct.currency = payload.currency;
	  customerProduct.balance = payload.balance;
	  customerProduct.productName = payload.productName;
	  customerProduct.updatedAt = payload.updatedAt;
	
	  return customerProduct;
	}
	
	var CustomerProduct = function CustomerProduct(id, username) {
	  (0, _classCallCheck3.default)(this, CustomerProduct);
	
	  this.id = +id;
	  this.username = username;
	
	  this.currency = '';
	  this.balance = '';
	  this.productName = '';
	  this.updatedAt = '';
	};
	
	// TODO: Don't export by default
	
	
	exports.default = CustomerProduct;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makePaymentOptions = makePaymentOptions;
	exports.makePaymentOption = makePaymentOption;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ECOPAYZ = 'ECOPAYZ';
	
	function makePaymentOptions(payload) {
	  return payload.map(function (paymentOptionPayload) {
	    return makePaymentOption(paymentOptionPayload);
	  });
	}
	
	function makePaymentOption(payload) {
	  var paymentOption = new PaymentOption(payload.id, payload.type, payload.fields.email);
	  if (payload.type === 'ECOPAYZ' || payload.type === 'BITCOIN') {
	    paymentOption.addExtra('accountId', payload.fields.account_id ? payload.fields.account_id : payload.fields.account);
	  }
	
	  return paymentOption;
	}
	
	var PaymentOption = function () {
	  function PaymentOption(id, type, email) {
	    (0, _classCallCheck3.default)(this, PaymentOption);
	
	    this.id = +id;
	    this.type = type;
	    this.email = email;
	
	    this.activeTab = false;
	
	    this.extras = {};
	  }
	
	  (0, _createClass3.default)(PaymentOption, [{
	    key: 'isEcopayz',
	    value: function isEcopayz() {
	      return this.type === ECOPAYZ;
	    }
	  }, {
	    key: 'addExtra',
	    value: function addExtra(key, value) {
	      this.extras[key] = value;
	    }
	  }]);
	  return PaymentOption;
	}();
	
	// TODO: Don't export by default.
	
	
	exports.default = PaymentOption;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _overview = __webpack_require__(1248);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _form = __webpack_require__(1394);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _overview3 = __webpack_require__(1397);
	
	var _overview4 = _interopRequireDefault(_overview3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var overviewModule = _angular2.default.module('overview', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('overview', {
	    parent: 'standardLayout',
	    url: '/transactions/overview',
	    component: 'overview',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('overview', _overview2.default).component('overviewForm', _form2.default).service('OverviewStore', _overview4.default).name;
	
	exports.default = overviewModule;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _overview = __webpack_require__(1249);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _overview3 = __webpack_require__(1250);
	
	var _overview4 = _interopRequireDefault(_overview3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var overviewComponent = {
	  bindings: {
	    products: '<'
	  },
	  template: _overview2.default,
	  controller: _overview4.default
	};
	
	exports.default = overviewComponent;

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"row mbot3\">\n        <div class=\"col-md-12\">\n          <h2 class=\"no-m\">{{ 'titles.transaction' | translate }}</h2>\n          <h4 class=\"no-m text-dark\">{{ 'titles.overview' | translate }}</h4>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-lg-9 col-md-12 col-sm-12 fadeIn animated\">\n          <div class=\"card-box\">\n            <!-- Filters -->\n            <span loading=\"$ctrl.model.transactionTable.transactions\"></span>\n            <overview-form ng-if=\"$ctrl.model.transactionTable.transactions\" form=\"$ctrl.form\" on-submit=\"$ctrl.submit()\" on-reset=\"$ctrl.reset()\"></overview-form>\n\n            <!-- Table -->\n            <div class=\"row mtop3\">\n              <div class=\"col-lg-12\">\n                <div class=\"table-responsive b-1\">\n                  <table id=\"datatable-responsive\"\n                    class=\"table toggle-circle m-b-0\" cellspacing=\"0\"\n                    date-paging=\"false\"\n                    width=\"100%\">\n                    <thead>\n                      <tr>\n                        <th data-hide=\"phone, tablet\">{{ 'tables.date' | translate }}</th>\n                        <th data-toggle=\"true\">{{ 'tables.transactionNumber' | translate }}</th>\n                        <th data-hide=\"phone\">{{ 'tables.type' | translate }}</th>\n                        <th data-hide=\"phone, tablet\">{{ 'tables.currency' | translate }}</th>\n                        <th data-hide=\"phone, tablet\">{{ 'tables.product' | translate }}</th>\n                        <th data-hide=\"phone, tablet\">{{ 'tables.paymentOption' | translate }}</th>\n                        <th data-hide=\"phone\">{{ 'tables.amount' | translate }}</th>\n                        <th>{{ 'tables.status' | translate }}</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr ng-repeat=\"item in $ctrl.model.transactionTable.transactions\">\n                        <td>{{ item.date | date : 'MM/dd/yyyy' }}</td>\n                        <td>{{ item.transactionNumber }}</td>\n                        <td>{{ item.type | translate }}</td>\n                        <td>\n                          <span ng-if=\"item.type === 'RESET BOOKIE PASSWORD'\">N/A</span>\n                          <span ng-if=\"item.type !== 'RESET BOOKIE PASSWORD'\">{{ item.currency }}</span>\n                        </td>\n                        <td>\n                          <span ng-if=\"item.type === 'BONUS'\">\n                              <div ng-repeat=\"productDetail in item.customerProductTo\" class=\"text-overflow\">\n                                  {{ productDetail.productName }} ({{ productDetail.username }})\n                              </div>\n                          </span>\n                          <span ng-if=\"item.type === 'COMMISSION'\">\n                              <div ng-repeat=\"productDetail in item.customerProductTo\" class=\"text-overflow\">\n                                  {{ productDetail.productName }} ({{ productDetail.username }})\n                              </div>\n                          </span>\n                          <span ng-if=\"item.type === 'REVENUE SHARE'\">\n                              <div ng-repeat=\"productDetail in item.customerProductTo\" class=\"text-overflow\">\n                                  {{ productDetail.productName }} ({{ productDetail.username }})\n                              </div>\n                          </span>\n                          <span ng-if=\"item.type === 'WITHDRAWAL'\">\n                            <div ng-repeat=\"productDetail in item.customerProductFrom\" class=\"text-overflow\">\n                              {{ productDetail.productName }} ({{ productDetail.username }})\n                            </div>\n                          </span>\n                          <span ng-if=\"item.type === 'DEPOSIT' || item.type === 'RESET BOOKIE PASSWORD'\">\n                            <div ng-repeat=\"productDetail in item.customerProductTo\" class=\"text-overflow\">\n                              {{ productDetail.productName }} ({{ productDetail.username }})\n                            </div>\n                          </span>\n                          <span ng-if=\"item.type === 'TRANSFER'\">\n                            From: <div ng-repeat=\"productDetail in item.customerProductFrom\" class=\"text-overflow\">{{ productDetail.productName }} ({{ productDetail.username }})</div>\n                            To: <div ng-repeat=\"productDetail in item.customerProductTo\" class=\"text-overflow\">{{ productDetail.productName }} ({{ productDetail.username }})</div>\n                          </span>\n                          <span ng-if=\"item.type === 'P2P TRANSFER' && item.isReceiver === true\">\n                            <div ng-repeat=\"productDetail in item.customerProductFrom\" class=\"text-overflow\">\n                              {{ productDetail.productName }} ({{ productDetail.username }})\n                            </div>\n                              sent to\n                            <div ng-repeat=\"productDetail in item.customerProductTo\" class=\"text-overflow\">\n                              {{ productDetail.productName }} ({{ productDetail.username }})\n                            </div>\n                          </span>\n                          <span ng-if=\"item.type === 'P2P TRANSFER' && item.isReceiver === false\">\n                            <div ng-repeat=\"productDetail in item.customerProductTo\" class=\"text-overflow\">\n                              {{ productDetail.productName }} ({{ productDetail.username }})\n                            </div>\n                              received from\n                            <div ng-repeat=\"productDetail in item.customerProductFrom\" class=\"text-overflow\">\n                              {{ productDetail.productName }} ({{ productDetail.username }})\n                            </div>\n                          </span>\n                          <span ng-if=\"item.type === 'CREDIT'\">\n                            <div ng-repeat=\"productDetail in item.customerProductTo\">\n                              {{ productDetail.productName }} ({{ productDetail.username }})\n                            </div>\n                          </span>\n                          <span ng-if=\"item.type === 'DEBIT'\">\n                            <div ng-repeat=\"productDetail in item.customerProductFrom\">\n                              {{ productDetail.productName }} ({{ productDetail.username }})\n                            </div>\n                          </span>\n                        </td>\n                        <td>\n                            <span ng-if=\"item.type === 'TRANSFER' \n                                || item.type === 'P2P TRANSFER'\n                                || item.type === 'CREDIT'\n                                || item.type === 'DEBIT'\">\n                                N/A\n                            </span>\n                            <span ng-if=\"item.type === 'COMMISSION' || item.type === 'BONUS' || item.type === 'REVENUE SHARE'\">\n                                SYSTEM GENERATED\n                            </span>\n                            <span ng-if=\"item.type !== 'COMMISSION'\n                                && item.type !== 'BONUS' \n                                && item.type !== 'TRANSFER' \n                                && item.type !== 'P2P TRANSFER'\n                                && item.type !== 'DEBIT'\n                                && item.type !== 'CREDIT'\n                                && item.type !== 'REVENUE SHARE'\">\n                                {{ item.paymentOption | translate }}\n                            </span>\n                        </td>\n                        <td class=\"td-commission-amount\">\n                          {{ item.displayAmount() }}\n                          <div ng-if=\"$ctrl.withBreakdown(item.type, item.customerFee)\" class=\"custom_tooltip_mobile\">\n                            <i class=\"fa fa-money\"></i>\n                            <span class=\"custom_tooltiptext\">\n                              {{ $ctrl.getFirstLabel(item.type, item.customerAmount, item.amount) }}<br>\n                              Fee: {{ item.customerFee }} <br>\n                              {{ $ctrl.getSecondLabel(item.type, item.customerAmount, item.amount) }}\n                            </span>\n                          </div>\n                          <div ng-if=\"$ctrl.isCommission(item.type)\" class=\"custom_tooltip_mobile\">\n                            <i class=\"ti-info-alt\"></i>\n                            <span class=\"custom_tooltiptext\">\n                              <div class=\"text-bold text-left\" style=\"border-bottom: 1px solid #dbddde\">\n                               {{ 'Commission Period' | translate }}: {{ item.commissionPeriod.dateFrom }} {{ 'to' | translate }} {{ item.commissionPeriod.dateTo }}<br/>\n                               {{ 'Original Payout Date' | translate }}: {{ item.commissionPeriod.payoutAt }}\n                              </div>\n                              <div class=\"row m-t-5\" ng-repeat=\"(currencyFrom, convertion) in item.commissionConvertions\">\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-left\">{{ currencyFrom }} {{ 'commission' | translate }}</div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-right m-5\">\n                                  {{ currencyFrom }} {{ $ctrl.fixAmount(convertion.amount) }}\n                                  <span class=\"currency-convert\" ng-if=\"item.currency !== currencyFrom\">({{ convertion.destination }} {{ $ctrl.fixAmount(convertion.convertedAmount) }})</span>\n                                </div>\n                              </div>\n                              <div class=\"text-bold row m-t-5\" style=\"border-top: 1px solid #dbddde\">\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-left\">{{ 'tables.Total Commission' | translate }}</div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-right\">{{ item.currency }} {{ item.amount }}</div>\n                              </div>\n                            </span>\n                          </div>\n                          <div ng-if=\"$ctrl.isRevenueShare(item.type)\" class=\"custom_tooltip_mobile\">\n                            <i class=\"ti-info-alt\"></i>\n                            <span class=\"custom_tooltiptext\">\n                              <div class=\"text-bold text-left\" style=\"border-bottom: 1px solid #dbddde\">\n                               Revenue Share Period: {{ item.revenueSharePeriod.dateFrom }} to {{ item.revenueSharePeriod.dateTo }}<br/>\n                               Original Payout Date: {{ item.revenueSharePeriod.payoutAt }}\n                              </div>\n                              <div class=\"text-bold row m-t-5\">\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-left\">Total Revenue Share</div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-right\">{{ item.currency }} {{ item.amount }}</div>\n                              </div>\n                            </span>\n                          </div>\n                        </td>\n                        <td>{{ item.status | translate }}\n                          <div ng-if=\"item.isVoidedDeclined && item.voidingReason\" class=\"custom_tooltip_mobile\">\n                            <i class=\"fa fa-question-circle\"></i>\n                            <span class=\"custom_tooltiptext\">\n                              {{ 'Reason' | translate }}:  <br> {{ item.voidingReason }}\n                            </span>\n                          </div>\n                          <div ng-if=\"item.isProcessed && item.isAdjustment && !item.isVoidedDeclined\"  class=\"custom_tooltip_mobile\">\n                            <i class=\"fa fa-question-circle\"></i>\n                            <span class=\"custom_tooltiptext\">\n                              {{ 'Note' | translate }}:  <br> {{ item.notes }}\n                            </span>\n                          </div>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n            \n            <!-- Pagination -->\n            <div class=\"row\">\n              <div class=\"col-md-12 m-t-20\">\n                <pagination\n                    on-page-clicked=\"$ctrl.paginate(page)\"\n                    subject=\"$ctrl.subject\"\n                    max-page-count=\"5\">\n                </pagination>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!-- Sidebar -->\n        <div class=\"col-lg-3 col-md-12 col-sm-12\">\n          <!-- My Account -->\n          <div class=\"portlet widget p-20\">\n            <div class=\"portlet-heading no-p\">\n              <h3 class=\"portlet-title text-gray\">\n                <i class=\"far fa-credit-card\"></i> {{ 'titles.account' | translate }}\n              </h3>\n              <div class=\"clearfix\"></div>\n            </div>\n            <hr>\n            <div class=\"portlet-body no-p\">\n              <div class=\"row\">\n                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                  <p>{{ 'Available Balance' | translate }}</p>\n                  <span class=\"text-red italic bold\" loading=\"$ctrl.model.balanceSummary.available\">{{ $ctrl.model.balanceSummary.available |number: 2 }} {{ $ctrl.userCurrency }}</span>\n                </div>\n                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                  <p>{{ 'Account Status' | translate }}</p>\n                  <span class=\"text-green\">\n                    <p ng-if=\"$ctrl.model.status === 'Verified'\" class=\"italic bold\"><i class=\"icon-user-following\"></i> {{ $ctrl.model.status | translate }}</p>\n                    <p ng-if=\"$ctrl.model.status !== 'Verified'\" class=\"italic bold\"><i class=\"icon-user-unfollow\"></i> {{ $ctrl.model.status | translate }}</p>\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-md-12 mtop3\">\n                  <div class=\"alert alert-success custom-notif no-m\">\n                    <strong>{{ 'Note' | translate }}:</strong> {{ 'makeDeposit' | translate }}\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <!-- My Products -->\n          <customer-product-widget on-customer-products-loaded=\"$ctrl.onCustomerProductsLoaded(customerProductsList)\"></customer-product-widget>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<request-product-modal></request-product-modal>\n<product-password-widget></product-password-widget>\n"

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _form = __webpack_require__(1251);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _datepicker = __webpack_require__(507);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _overview = __webpack_require__(1255);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(1256);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _number = __webpack_require__(1203);
	
	var _paymentOption = __webpack_require__(1393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OverviewController = function (_BaseController) {
	  OverviewController.$inject = ["OverviewStore", "EventDispatcherService", "$timeout", "$scope", "$translate"];
	  (0, _inherits3.default)(OverviewController, _BaseController);
	
	  function OverviewController(OverviewStore, EventDispatcherService, $timeout, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OverviewController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OverviewController.__proto__ || (0, _getPrototypeOf2.default)(OverviewController)).call(this));
	
	    _this.OverviewStore = OverviewStore;
	    _this.EventDispatcherService = EventDispatcherService;
	    _this.$timeout = $timeout;
	    _this.$scope = $scope;
	    _this.$translate = $translate;
	
	    _this.$scope.$on('reload.transaction-overview', function () {
	      _this.getTransactionHistory(_this.form.toPayload());
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(OverviewController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.showForm = false;
	      this.model = new _overview2.default();
	      this.form = new _form2.default();
	      this.subject = new _Rx2.default.BehaviorSubject();
	      this.picker = new _datepicker2.default();
	
	      this.removeSettingsHighlight();
	      this.getBalances();
	      this.getTransactionHistory(this.form.toPayload());
	
	      this.addSubscription(this.EventDispatcherService.addListener(_events2.default.TRANSACTION_PROCESSED, function (event) {
	        _this2.getBalances();
	        _this2.getTransactionHistory(_this2.form.toPayload());
	      }));
	
	      this.addSubscription(this.EventDispatcherService.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this2.getBalances();
	      }));
	
	      this.updateModel();
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      this.$timeout(function () {
	        $('#datatable-responsive').footable();
	        $('#datatable-responsive').trigger('footable_redraw');
	      }, 0);
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.removeSubscriptions();
	    }
	  }, {
	    key: 'updateModel',
	    value: function updateModel() {
	      var _this3 = this;
	
	      return this.OverviewStore.getDashboardDetails().then(function (details) {
	        _this3.model.verifiedAt = details.others.verifiedAt;
	        _this3.model.status = details.others.verifiedAt ? _this3.$translate.instant('Verified') : _this3.$translate.instant('Not Verified');
	      });
	    }
	  }, {
	    key: 'getBalances',
	    value: function getBalances() {
	      var _this4 = this;
	
	      this.OverviewStore.getBalance().then(function (response) {
	        _this4.model.balanceSummary = response;
	      });
	      this.OverviewStore.getBalancePerProduct().then(function (response) {
	        return _this4.model.balancePerProduct = response;
	      });
	      this.form.setPaymentOptions(_paymentOption.PAYMENT_OPTION_TYPE);
	      this.subscription = this.OverviewStore.getStatuses().subscribe(function (statuses) {
	        return _this4.form.setStatuses(statuses);
	      });
	      this.currencySubscription = this.OverviewStore.currency$.subscribe(function (currency) {
	        return _this4.userCurrency = currency;
	      });
	    }
	  }, {
	    key: 'getTransactionHistory',
	    value: function getTransactionHistory(payload) {
	      var _this5 = this;
	
	      this.OverviewStore.getHistory(payload).then(function (response) {
	        if (!angular.isDefined(response.items)) {
	          response.items = [];
	        }
	
	        var getStatusLabel = function getStatusLabel(transaction) {
	          var label = transaction.status.label;
	
	          if (transaction.is_bitcoin_status_pending_confirmation) {
	            label = _this5.$translate.instant('Pending Confirmation');
	          } else if (transaction.is_bitcoin_status_confirmed) {
	            label = _this5.$translate.instant('Confirmed');
	          }
	
	          if (transaction.is_voided) {
	            label = _this5.$translate.instant('Voided');
	          }
	
	          return label;
	        };
	
	        var getCommissionPeriod = function getCommissionPeriod(transaction) {
	          var commissionPeriod = null;
	
	          if (typeof transaction.commission_period !== 'undefined') {
	            commissionPeriod = {
	              'payoutAt': (0, _moment2.default)(transaction.commission_period.payoutAt).format('MM/DD/YYYY'),
	              'dateFrom': (0, _moment2.default)(transaction.commission_period.dateFrom).format('MM/DD/YYYY'),
	              'dateTo': (0, _moment2.default)(transaction.commission_period.dateTo).format('MM/DD/YYYY')
	            };
	          }
	
	          return commissionPeriod;
	        };
	
	        var getRevenueSharePeriod = function getRevenueSharePeriod(transaction) {
	          var revenueSharePeriod = null;
	
	          if (typeof transaction.revenue_share_period !== 'undefined') {
	            revenueSharePeriod = {
	              'payoutAt': (0, _moment2.default)(transaction.revenue_share_period.payoutAt).format('MM/DD/YYYY'),
	              'dateFrom': (0, _moment2.default)(transaction.revenue_share_period.dateFrom).format('MM/DD/YYYY'),
	              'dateTo': (0, _moment2.default)(transaction.revenue_share_period.dateTo).format('MM/DD/YYYY')
	            };
	          }
	
	          return revenueSharePeriod;
	        };
	
	        _this5.model.transactionTable.transactions = response.items.map(function (transaction) {
	          var item = {
	            date: transaction.date,
	            transactionNumber: transaction.number,
	            type: _form.TRANSACTION_TYPES[transaction.type],
	            currency: transaction.currency.code === 'BTC' ? 'EUR' : transaction.currency.code,
	            isReceiver: transaction.productDetails.isReceiver,
	            customerProductFrom: transaction.productDetails.from,
	            customerProductTo: transaction.productDetails.to,
	            paymentOption: transaction.payment_option ? transaction.payment_option.type : 'N/A',
	            amount: transaction.amount,
	            customerFee: transaction.customer_fee,
	            customerAmount: transaction.customer_amount,
	            status: getStatusLabel(transaction),
	            voidingReason: transaction.voiding_reason,
	            isVoidedDeclined: transaction.status.id === 3 ? true : transaction.is_voided,
	            commissionConvertions: transaction.commission_convertions,
	            commissionPeriod: getCommissionPeriod(transaction),
	            revenueShareConversions: transaction.revenue_share_conversions,
	            revenueSharePeriod: getRevenueSharePeriod(transaction),
	            notes: transaction.notes_in_details,
	            isAdjustment: transaction.type == 10 || transaction.type == 11 ? true : false,
	            isProcessed: transaction.status.id == 2 ? true : false,
	            isBitcoin: transaction.is_transaction_payment_bitcoin,
	            totalBitcoinAmount: (0, _numeral2.default)(transaction.bitcoin_total_amount).format(_number.BITCOIN_DECIMAL_PLACES_FORMAT)
	          };
	
	          item.displayAmount = function () {
	            if (this.isBitcoin && !((0, _numeral2.default)(0).format(_number.BITCOIN_DECIMAL_PLACES_FORMAT) === this.totalBitcoinAmount)) {
	              return this.amount + ' (' + this.totalBitcoinAmount + ' BTC)';
	            }
	
	            if (this.type === 'WITHDRAWAL') {
	              return this.customerAmount;
	            }
	
	            return this.amount;
	          };
	
	          return item;
	        });
	
	        _this5.model.transactionTable.pagination = {
	          limit: Number(response.limit),
	          page: Number(response.page),
	          total: Number(response.total),
	          totalFiltered: Number(response.total_filtered)
	        };
	
	        _this5.subject.next(_this5.model.transactionTable.pagination);
	
	        _this5.renderTable();
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.form.page = null;
	      this.getTransactionHistory(this.form.toPayload());
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.picker.onReset();
	      this.form.reset();
	      this.submit();
	    }
	  }, {
	    key: 'paginate',
	    value: function paginate(page) {
	      this.form.page = page.number;
	      this.getTransactionHistory(this.form.toPayload());
	    }
	  }, {
	    key: 'refreshBalance',
	    value: function refreshBalance() {
	      var _this6 = this;
	
	      this.OverviewStore.getBalance().then(function (response) {
	        return _this6.model.balanceSummary = response;
	      });
	      this.OverviewStore.getBalancePerProduct().then(function (response) {
	        return _this6.model.balancePerProduct = response;
	      });
	    }
	  }, {
	    key: 'getFirstLabel',
	    value: function getFirstLabel(type, customerAmount, amount) {
	      if (type === 'DEPOSIT') {
	        return this.$translate.instant('Total amount to be deposited on account') + ': ' + customerAmount;
	      } else if (type === 'WITHDRAWAL') {
	        return this.$translate.instant('Total amount to be deducted from account') + ': ' + amount;
	      }
	    }
	  }, {
	    key: 'getSecondLabel',
	    value: function getSecondLabel(type, customerAmount, amount) {
	      if (type === 'DEPOSIT') {
	        return this.$translate.instant('Total amount to be sent') + ': ' + amount;
	      } else if (type === 'WITHDRAWAL') {
	        return this.$translate.instant('Total amount to be received') + ': ' + customerAmount;
	      }
	    }
	  }, {
	    key: 'withBreakdown',
	    value: function withBreakdown(type, fee) {
	      if (!(type === 'DEPOSIT' || type === 'WITHDRAWAL')) {
	        return false;
	      }
	
	      if (fee === 0) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'isCommission',
	    value: function isCommission(type) {
	      return type === 'COMMISSION';
	    }
	  }, {
	    key: 'isRevenueShare',
	    value: function isRevenueShare(type) {
	      return type === 'REVENUE SHARE';
	    }
	  }, {
	    key: 'fixAmount',
	    value: function fixAmount(amount) {
	      return eval(amount);
	    }
	  }, {
	    key: 'onCustomerProductsLoaded',
	    value: function onCustomerProductsLoaded(customerProductsList) {
	      this.model.balance.available = customerProductsList.balance;
	    }
	  }, {
	    key: 'removeSettingsHighlight',
	    value: function removeSettingsHighlight() {
	      this.$timeout(function () {
	        $('#settings').removeClass('subdrop');
	      }, 100);
	    }
	  }]);
	  return OverviewController;
	}(_basecontroller.BaseController);
	
	exports.default = OverviewController;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TRANSACTION_TYPES = undefined;
	
	var _keys = __webpack_require__(1044);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _freeze = __webpack_require__(1252);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _payload = __webpack_require__(1138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRANSACTION_TYPES = exports.TRANSACTION_TYPES = (0, _freeze2.default)({
	  1: 'DEPOSIT',
	  2: 'WITHDRAWAL',
	  3: 'TRANSFER',
	  4: 'BONUS',
	  5: 'P2P TRANSFER',
	  7: 'COMMISSION',
	  10: 'DEBIT',
	  11: 'CREDIT',
	  12: 'REVENUE SHARE',
	  13: 'RESET BOOKIE PASSWORD'
	});
	
	var FilterForm = function () {
	  function FilterForm() {
	    (0, _classCallCheck3.default)(this, FilterForm);
	
	    this.search = null;
	    this.dateFrom = null;
	    this.dateTo = null;
	    this.status = null;
	    this.paymentOption = null;
	    this.page = null;
	    this.selectedTypes = null;
	
	    this.types = [];
	    this.statuses = [];
	    this.paymentOptions = [];
	
	    this.setTypes();
	  }
	
	  (0, _createClass3.default)(FilterForm, [{
	    key: 'setTypes',
	    value: function setTypes() {
	      for (var key in TRANSACTION_TYPES) {
	        this.types.push({
	          value: key,
	          text: TRANSACTION_TYPES[key]
	        });
	      }
	    }
	  }, {
	    key: 'setStatuses',
	    value: function setStatuses(statuses) {
	      this.statuses = (0, _keys2.default)(statuses).map(function (key) {
	        return { value: key, text: statuses[key] };
	      });
	
	      // Add default
	      this.statuses.unshift({
	        value: '',
	        text: 'All Status'
	      });
	
	      this.status = this.statuses[0].value;
	    }
	  }, {
	    key: 'setPaymentOptions',
	    value: function setPaymentOptions(paymentOptions) {
	      this.paymentOptions = (0, _keys2.default)(paymentOptions).map(function (paymentOption) {
	        return {
	          type: paymentOption,
	          text: paymentOption
	        };
	      });
	
	      // Add default
	      this.paymentOptions.unshift({
	        type: '',
	        text: 'All Payment Options'
	      });
	
	      this.paymentOption = this.paymentOptions[0].type;
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      return {
	        search: this.search,
	        from: (0, _payload.toApiAcceptedDateFormat)(this.dateFrom),
	        to: (0, _payload.toApiAcceptedDateFormat)(this.dateTo),
	        types: this.selectedTypes,
	        paymentOption: this.paymentOption,
	        status: this.status,
	        page: this.page
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.search = null;
	      this.dateFrom = null;
	      this.dateTo = null;
	      this.page = null;
	      this.selectedTypes = null;
	      this.paymentOption = '';
	      this.page = null;
	      this.status = '';
	    }
	  }]);
	  return FilterForm;
	}();
	
	;
	
	exports.default = FilterForm;

/***/ }),
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OverviewModel = function OverviewModel() {
	  (0, _classCallCheck3.default)(this, OverviewModel);
	
	  this.balance = {
	    unallocated: null,
	    available: null,
	    acWalletWithdrawable: 0,
	    totalRunningCommission: 0
	  };
	  this.currency = null;
	  this.balanceSummary = null;
	  this.balancePerProduct = null;
	  this.transactionTable = {
	    transactions: null,
	    pagination: null
	  };
	  this.customerProducts = null;
	};
	
	exports.default = OverviewModel;

/***/ }),
/* 1256 */,
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1258,
		"./af.js": 1258,
		"./ar": 1259,
		"./ar-dz": 1260,
		"./ar-dz.js": 1260,
		"./ar-kw": 1261,
		"./ar-kw.js": 1261,
		"./ar-ly": 1262,
		"./ar-ly.js": 1262,
		"./ar-ma": 1263,
		"./ar-ma.js": 1263,
		"./ar-sa": 1264,
		"./ar-sa.js": 1264,
		"./ar-tn": 1265,
		"./ar-tn.js": 1265,
		"./ar.js": 1259,
		"./az": 1266,
		"./az.js": 1266,
		"./be": 1267,
		"./be.js": 1267,
		"./bg": 1268,
		"./bg.js": 1268,
		"./bm": 1269,
		"./bm.js": 1269,
		"./bn": 1270,
		"./bn-bd": 1271,
		"./bn-bd.js": 1271,
		"./bn.js": 1270,
		"./bo": 1272,
		"./bo.js": 1272,
		"./br": 1273,
		"./br.js": 1273,
		"./bs": 1274,
		"./bs.js": 1274,
		"./ca": 1275,
		"./ca.js": 1275,
		"./cs": 1276,
		"./cs.js": 1276,
		"./cv": 1277,
		"./cv.js": 1277,
		"./cy": 1278,
		"./cy.js": 1278,
		"./da": 1279,
		"./da.js": 1279,
		"./de": 1280,
		"./de-at": 1281,
		"./de-at.js": 1281,
		"./de-ch": 1282,
		"./de-ch.js": 1282,
		"./de.js": 1280,
		"./dv": 1283,
		"./dv.js": 1283,
		"./el": 1284,
		"./el.js": 1284,
		"./en-au": 1285,
		"./en-au.js": 1285,
		"./en-ca": 1286,
		"./en-ca.js": 1286,
		"./en-gb": 1287,
		"./en-gb.js": 1287,
		"./en-ie": 1288,
		"./en-ie.js": 1288,
		"./en-il": 1289,
		"./en-il.js": 1289,
		"./en-in": 1290,
		"./en-in.js": 1290,
		"./en-nz": 1291,
		"./en-nz.js": 1291,
		"./en-sg": 1292,
		"./en-sg.js": 1292,
		"./eo": 1293,
		"./eo.js": 1293,
		"./es": 1294,
		"./es-do": 1295,
		"./es-do.js": 1295,
		"./es-mx": 1296,
		"./es-mx.js": 1296,
		"./es-us": 1297,
		"./es-us.js": 1297,
		"./es.js": 1294,
		"./et": 1298,
		"./et.js": 1298,
		"./eu": 1299,
		"./eu.js": 1299,
		"./fa": 1300,
		"./fa.js": 1300,
		"./fi": 1301,
		"./fi.js": 1301,
		"./fil": 1302,
		"./fil.js": 1302,
		"./fo": 1303,
		"./fo.js": 1303,
		"./fr": 1304,
		"./fr-ca": 1305,
		"./fr-ca.js": 1305,
		"./fr-ch": 1306,
		"./fr-ch.js": 1306,
		"./fr.js": 1304,
		"./fy": 1307,
		"./fy.js": 1307,
		"./ga": 1308,
		"./ga.js": 1308,
		"./gd": 1309,
		"./gd.js": 1309,
		"./gl": 1310,
		"./gl.js": 1310,
		"./gom-deva": 1311,
		"./gom-deva.js": 1311,
		"./gom-latn": 1312,
		"./gom-latn.js": 1312,
		"./gu": 1313,
		"./gu.js": 1313,
		"./he": 1314,
		"./he.js": 1314,
		"./hi": 1315,
		"./hi.js": 1315,
		"./hr": 1316,
		"./hr.js": 1316,
		"./hu": 1317,
		"./hu.js": 1317,
		"./hy-am": 1318,
		"./hy-am.js": 1318,
		"./id": 1319,
		"./id.js": 1319,
		"./is": 1320,
		"./is.js": 1320,
		"./it": 1321,
		"./it-ch": 1322,
		"./it-ch.js": 1322,
		"./it.js": 1321,
		"./ja": 1323,
		"./ja.js": 1323,
		"./jv": 1324,
		"./jv.js": 1324,
		"./ka": 1325,
		"./ka.js": 1325,
		"./kk": 1326,
		"./kk.js": 1326,
		"./km": 1327,
		"./km.js": 1327,
		"./kn": 1328,
		"./kn.js": 1328,
		"./ko": 1329,
		"./ko.js": 1329,
		"./ku": 1330,
		"./ku.js": 1330,
		"./ky": 1331,
		"./ky.js": 1331,
		"./lb": 1332,
		"./lb.js": 1332,
		"./lo": 1333,
		"./lo.js": 1333,
		"./lt": 1334,
		"./lt.js": 1334,
		"./lv": 1335,
		"./lv.js": 1335,
		"./me": 1336,
		"./me.js": 1336,
		"./mi": 1337,
		"./mi.js": 1337,
		"./mk": 1338,
		"./mk.js": 1338,
		"./ml": 1339,
		"./ml.js": 1339,
		"./mn": 1340,
		"./mn.js": 1340,
		"./mr": 1341,
		"./mr.js": 1341,
		"./ms": 1342,
		"./ms-my": 1343,
		"./ms-my.js": 1343,
		"./ms.js": 1342,
		"./mt": 1344,
		"./mt.js": 1344,
		"./my": 1345,
		"./my.js": 1345,
		"./nb": 1346,
		"./nb.js": 1346,
		"./ne": 1347,
		"./ne.js": 1347,
		"./nl": 1348,
		"./nl-be": 1349,
		"./nl-be.js": 1349,
		"./nl.js": 1348,
		"./nn": 1350,
		"./nn.js": 1350,
		"./oc-lnc": 1351,
		"./oc-lnc.js": 1351,
		"./pa-in": 1352,
		"./pa-in.js": 1352,
		"./pl": 1353,
		"./pl.js": 1353,
		"./pt": 1354,
		"./pt-br": 1355,
		"./pt-br.js": 1355,
		"./pt.js": 1354,
		"./ro": 1356,
		"./ro.js": 1356,
		"./ru": 1357,
		"./ru.js": 1357,
		"./sd": 1358,
		"./sd.js": 1358,
		"./se": 1359,
		"./se.js": 1359,
		"./si": 1360,
		"./si.js": 1360,
		"./sk": 1361,
		"./sk.js": 1361,
		"./sl": 1362,
		"./sl.js": 1362,
		"./sq": 1363,
		"./sq.js": 1363,
		"./sr": 1364,
		"./sr-cyrl": 1365,
		"./sr-cyrl.js": 1365,
		"./sr.js": 1364,
		"./ss": 1366,
		"./ss.js": 1366,
		"./sv": 1367,
		"./sv.js": 1367,
		"./sw": 1368,
		"./sw.js": 1368,
		"./ta": 1369,
		"./ta.js": 1369,
		"./te": 1370,
		"./te.js": 1370,
		"./tet": 1371,
		"./tet.js": 1371,
		"./tg": 1372,
		"./tg.js": 1372,
		"./th": 1373,
		"./th.js": 1373,
		"./tk": 1374,
		"./tk.js": 1374,
		"./tl-ph": 1375,
		"./tl-ph.js": 1375,
		"./tlh": 1376,
		"./tlh.js": 1376,
		"./tr": 1377,
		"./tr.js": 1377,
		"./tzl": 1378,
		"./tzl.js": 1378,
		"./tzm": 1379,
		"./tzm-latn": 1380,
		"./tzm-latn.js": 1380,
		"./tzm.js": 1379,
		"./ug-cn": 1381,
		"./ug-cn.js": 1381,
		"./uk": 1382,
		"./uk.js": 1382,
		"./ur": 1383,
		"./ur.js": 1383,
		"./uz": 1384,
		"./uz-latn": 1385,
		"./uz-latn.js": 1385,
		"./uz.js": 1384,
		"./vi": 1386,
		"./vi.js": 1386,
		"./x-pseudo": 1387,
		"./x-pseudo.js": 1387,
		"./yo": 1388,
		"./yo.js": 1388,
		"./zh-cn": 1389,
		"./zh-cn.js": 1389,
		"./zh-hk": 1390,
		"./zh-hk.js": 1390,
		"./zh-mo": 1391,
		"./zh-mo.js": 1391,
		"./zh-tw": 1392,
		"./zh-tw.js": 1392
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1257;


/***/ }),
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentOption = exports.PaymentOptionDisplay = exports.PAYMENT_OPTION_TYPE = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makePaymentOption = makePaymentOption;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAYMENT_OPTION_TYPE = exports.PAYMENT_OPTION_TYPE = {
	  'SKRILL': 'SKRILL',
	  'NETELLER': 'NETELLER',
	  'ECOPAYZ': 'ECOPAYZ',
	  'BITCOIN': 'BITCOIN',
	  'BANK': 'BANK'
	};
	
	function makePaymentOption(payload) {
	  return PaymentOption.fromPayload(payload);
	}
	
	var PaymentOptionDisplay = exports.PaymentOptionDisplay = function () {
	  function PaymentOptionDisplay() {
	    (0, _classCallCheck3.default)(this, PaymentOptionDisplay);
	
	    this._fields = [];
	    this._extras = null;
	    this._paymentMethods = {};
	  }
	
	  (0, _createClass3.default)(PaymentOptionDisplay, [{
	    key: 'logo',
	    get: function get() {
	      return this._extras.logo;
	    }
	  }, {
	    key: 'description',
	    set: function set(description) {
	      this._description = this.description;
	    },
	    get: function get() {
	      return this._extras.description;
	    }
	  }, {
	    key: 'fields',
	    set: function set(fields) {
	      this._fields = fields;
	    },
	    get: function get() {
	      return this._fields;
	    }
	  }, {
	    key: 'paymentMethods',
	    set: function set(paymentMethods) {
	      this._paymentMethods = paymentMethods;
	    },
	    get: function get() {
	      return this._paymentMethods;
	    }
	  }, {
	    key: 'extras',
	    set: function set(extras) {
	      this._extras = extras;
	    },
	    get: function get() {
	      return this._extras;
	    }
	  }, {
	    key: 'selected',
	    get: function get() {
	      return this._extras.selected;
	    }
	  }], [{
	    key: 'fromPayload',
	    value: function fromPayload(payload) {
	      var paymentOptionDisplay = new PaymentOptionDisplay();
	
	      paymentOptionDisplay.fields = payload.fields;
	      paymentOptionDisplay.extras = payload.extras;
	      paymentOptionDisplay._paymentMethods = payload.paymentMethods;
	
	      return paymentOptionDisplay;
	    }
	  }]);
	  return PaymentOptionDisplay;
	}();
	
	var PaymentOption = exports.PaymentOption = function () {
	  function PaymentOption() {
	    (0, _classCallCheck3.default)(this, PaymentOption);
	
	    this._id = null;
	    this._isActive = false;
	    this._type = null;
	    this._fields = {};
	    this._display = null;
	  }
	
	  (0, _createClass3.default)(PaymentOption, [{
	    key: 'id',
	    set: function set(id) {
	      this._id = id;
	    },
	    get: function get() {
	      return this._id;
	    }
	  }, {
	    key: 'isActive',
	    set: function set(isActive) {
	      this._isActive = isActive;
	    },
	    get: function get() {
	      return this._isActive;
	    }
	  }, {
	    key: 'type',
	    set: function set(type) {
	      this._type = type;
	    },
	    get: function get() {
	      return this._type;
	    }
	  }, {
	    key: 'fields',
	    set: function set(fields) {
	      this._fields = fields;
	    },
	    get: function get() {
	      return this._fields;
	    }
	  }, {
	    key: 'display',
	    set: function set(display) {
	      this._display = display;
	    },
	    get: function get() {
	      return this._display;
	    }
	  }], [{
	    key: 'fromPayload',
	    value: function fromPayload(payload) {
	      var paymentOption = new PaymentOption();
	
	      paymentOption.id = payload.id;
	      paymentOption.isActive = payload.is_active;
	      paymentOption.type = payload.type;
	      paymentOption.fields = payload.fields;
	
	      if (payload.details) {
	        paymentOption.display = PaymentOptionDisplay.fromPayload(payload.details.display);
	      }
	
	      return paymentOption;
	    }
	  }]);
	  return PaymentOption;
	}();

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1395);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1396);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    form: '<',
	    onSubmit: '&',
	    onReset: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form-horizontal\" action=\"\">\n  <div class=\"row\">\n    <div class=\"col-md-9\">\n      <div class=\"row\">\n        <div class=\"col-md-3 col-sm-6 col-xs-12\">\n          <div class=\"form-group mr-ml-0\">\n            <label>{{ 'form.from' | translate }}</label>\n              <date-picker ng-model=\"$ctrl.form.dateFrom\"></date-picker>\n          </div>\n        </div>\n        <div class=\"col-md-3 col-sm-6 col-xs-12\">\n          <div class=\"form-group mr-ml-0\">\n            <label>{{ 'form.to' | translate }}</label>\n            <date-picker ng-model=\"$ctrl.form.dateTo\"></date-picker>\n          </div>\n        </div>\n        <div class=\"col-md-3 col-sm-6 col-xs-12\">\n          <label>{{ 'form.type' | translate }}</label>\n          <div class=\"tags-default\">\n            <select2 ng-model=\"$ctrl.form.selectedTypes\" options=\"$ctrl.form.types\" placeholder=\"All types\" multiple></select2>\n          </div>\n        </div>\n        <div class=\"col-md-3 col-sm-6 col-xs-12\">\n          <div class=\"form-group\">\n            <label>{{ 'form.status' | translate }}</label>\n            <select ng-model=\"$ctrl.form.status\" class=\"form-control\">\n              <option ng-repeat=\"(key, status) in $ctrl.form.statuses\" ng-value=\"status.value\">{{ status.text | translate }}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-md-3\">\n      <div class=\"form-group mr-ml-0\">\n        <label>{{ 'form.paymentOption' | translate }}</label>\n        <select ng-model=\"$ctrl.form.paymentOption\" class=\"form-control\">\n            <option ng-repeat=\"paymentOption in $ctrl.form.paymentOptions\" ng-value=\"paymentOption.type\">{{ paymentOption.text }}</option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"col-md-12 text-right\">\n        <button ng-click=\"$ctrl.submit()\" type=\"button\" class=\"btn waves-effect waves-light ac-color\">{{ 'Search' | translate }}</button>\n        <button ng-click=\"$ctrl.reset()\" type=\"button\" class=\"btn btn-inverse waves-effect waves-light\">{{ 'Reset Filter' | translate }}</button>\n    </div>\n  </div>\n</form>\n"

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  function FormController() {
	    (0, _classCallCheck3.default)(this, FormController);
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: "submit",
	    value: function submit() {
	      this.onSubmit();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.onReset();
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeBalancePerProduct = makeBalancePerProduct;
	exports.makeOtherDetails = makeOtherDetails;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeBalancePerProduct(response) {
	  return response.map(function (response) {
	    return {
	      productName: response.productName,
	      username: response.username,
	      balance: response.balance,
	      currency: response.currency
	    };
	  });
	}
	
	function makeOtherDetails(details) {
	  return {
	    verifiedAt: details.verified_at
	  };
	}
	
	var OverviewStore = function () {
	  OverviewStore.$inject = ["OverviewApiService", "DashboardApiService", "CustomerApiService", "SessionService"];
	  function OverviewStore(OverviewApiService, DashboardApiService, CustomerApiService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OverviewStore);
	    this.OverviewApiService = OverviewApiService;
	    this.DashboardApiService = DashboardApiService;
	    this.CustomerApiService = CustomerApiService;
	    this.SessionService = SessionService;
	    this.currency$ = SessionService.session.map(function (session) {
	      return session ? session.currency : {};
	    });
	  }
	
	  (0, _createClass3.default)(OverviewStore, [{
	    key: 'getDashboardDetails',
	    value: function getDashboardDetails() {
	      return this.DashboardApiService.dashboard().then(function (details) {
	        return {
	          others: makeOtherDetails(details)
	        };
	      });
	    }
	  }, {
	    key: 'getHistory',
	    value: function getHistory(payload) {
	      return this.OverviewApiService.getHistory(payload);
	    }
	  }, {
	    key: 'getPaymentOptions',
	    value: function getPaymentOptions() {
	      return this.CustomerApiService.getPaymentOptions();
	    }
	  }, {
	    key: 'getBalancePerProduct',
	    value: function getBalancePerProduct() {
	      return this.CustomerApiService.getProducts(function (response) {
	        return makeBalancePerProduct(response);
	      });
	    }
	  }, {
	    key: 'getBalance',
	    value: function getBalance() {
	      return this.CustomerApiService.getBalance();
	    }
	  }, {
	    key: 'getStatuses',
	    value: function getStatuses() {
	      return this.SessionService.session.map(function (sessionDetails) {
	        return sessionDetails ? sessionDetails.statuses : {};
	      });
	    }
	  }, {
	    key: 'getCustomerProducts',
	    value: function getCustomerProducts() {
	      return this.CustomerApiService.getProducts();
	    }
	  }]);
	  return OverviewStore;
	}();
	
	exports.default = OverviewStore;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _withdrawal = __webpack_require__(1399);
	
	var _withdrawal2 = _interopRequireDefault(_withdrawal);
	
	var _successModal = __webpack_require__(1402);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _errorModal = __webpack_require__(1405);
	
	var _errorModal2 = _interopRequireDefault(_errorModal);
	
	var _bankWithdrawalForm = __webpack_require__(1408);
	
	var _bankWithdrawalForm2 = _interopRequireDefault(_bankWithdrawalForm);
	
	var _skrillWithdrawalForm = __webpack_require__(1414);
	
	var _skrillWithdrawalForm2 = _interopRequireDefault(_skrillWithdrawalForm);
	
	var _ecopayzWithdrawalForm = __webpack_require__(1418);
	
	var _ecopayzWithdrawalForm2 = _interopRequireDefault(_ecopayzWithdrawalForm);
	
	var _netellerWithdrawalForm = __webpack_require__(1422);
	
	var _netellerWithdrawalForm2 = _interopRequireDefault(_netellerWithdrawalForm);
	
	var _bitcoinWithdrawalForm = __webpack_require__(1426);
	
	var _bitcoinWithdrawalForm2 = _interopRequireDefault(_bitcoinWithdrawalForm);
	
	var _switchAuth = __webpack_require__(1430);
	
	var _switchAuth2 = _interopRequireDefault(_switchAuth);
	
	var _withdrawal3 = __webpack_require__(1432);
	
	var _withdrawal4 = _interopRequireDefault(_withdrawal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withdrawalModule = _angular2.default.module('withdrawal', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('withdrawal', {
	    parent: 'standardLayout',
	    url: '/transactions/withdrawal',
	    component: 'withdrawal',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('withdrawal', _withdrawal2.default).component('bankwithdrawalForm', _bankWithdrawalForm2.default).component('skrillwithdrawalForm', _skrillWithdrawalForm2.default).component('ecopayzwithdrawalForm', _ecopayzWithdrawalForm2.default).component('netellerwithdrawalForm', _netellerWithdrawalForm2.default).component('bitcoinWithdrawalForm', _bitcoinWithdrawalForm2.default).component('withdrawalSuccessModal', _successModal2.default).component('withdrawalErrorModal', _errorModal2.default).service('WithdrawalStore', _withdrawal4.default).directive('switchAuth', _switchAuth2.default).name;
	
	exports.default = withdrawalModule;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withdrawal = __webpack_require__(1400);
	
	var _withdrawal2 = _interopRequireDefault(_withdrawal);
	
	var _withdrawal3 = __webpack_require__(1401);
	
	var _withdrawal4 = _interopRequireDefault(_withdrawal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withdrawalComponent = {
	  bindings: {
	    details: '<',
	    email: '<'
	  },
	  template: _withdrawal2.default,
	  controller: _withdrawal4.default
	};
	
	exports.default = withdrawalComponent;

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"row mbot3\">\n        <div class=\"col-md-12\">\n          <h2 class=\"no-m\">{{ 'titles.transaction' | translate }}</h2>\n          <h4 class=\"no-m text-dark\">{{ 'titles.withdrawal' | translate }}</h4>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-lg-9 col-md-8 col-sm-12 fadeIn animated index-one mbot3\">\n          <div loading=\"$ctrl.PaymentOptionsViewDetails\"></div>\n\n          <div id=\"modal-withdraw\" tabindex=\"-1\" class=\"modal-unverified\">\n            <div id=\"modal-withdraw-sweet-alert\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"true\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n              <div class=\"icon info\"></div>\n              <h2>Unable to withdraw</h2>\n              <p class=\"lead text-gray-d\">Please contact our customer service team to have your account verified. Thank you.</p>\n              <ol class=\"font-md text-left\">\n                <li ng-show=\"!$ctrl.session.hasSetupTransactionAuthentication()\">Set your 2FA using <a href=\"settings#google-auth\">Google Authenticator</a> or <a href=\"settings#transaction-pw\">Transaction Password</a></li>\n                <li ng-show=\"!$ctrl.session.isVerified()\">Please verify your account by submitting <a ui-sref=\"profile\">KYC documents</a></li>\n              </ol>\n            </div>\n          </div>\n\n          <!-- G Auth Warning Modal -->\n          <!-- Show only if Google Auth hasn't been setup yet -->\n          <div id=\"gAuthSwitchWarning\" class=\"flex-center-center\" style=\"display: none;\">\n            <div class=\"sweet-overlay\" tabindex=\"-1\" style=\"opacity: 1; display: block;\"></div>\n            <div class=\"sweet-alert showSweetAlert visible flex-column\">\n              <button class=\"close\"><i class=\"fas fa-times font-sm pull-right\"></i></button>\n              <div class=\"icon warning pulseWarning\" style=\"display: block;\">\n                <span class=\"body pulseWarningIns\"></span>\n                <span class=\"dot pulseWarningIns\"></span>\n              </div>\n              <h3>Google Authenticator</h3>\n              <span class=\"font-lg p-lr-30\">Your Google Authenticator is not setup yet<br>\n                <a href=\"settings#google-auth\" class=\"ac-txtcolor font-md\">Click here to setup Google Authenticator</a>\n              </span>\n            </div>\n          </div>\n          <!-- Show only if Google Auth hasn't been setup yet -->\n          <!-- End G Auth Warning Modal -->\n\n          <div ng-if=\"$ctrl.hasAvailablePaymentOption\">\n            <!-- Tab List -->\n            <div class=\"row\" ng-if=\"$ctrl.PaymentOptionsViewDetails\">\n              <div class=\"col-md-12\">\n                <ul class=\"nav nav-tabs nav-justified deposit-tabs\">\n                  <li ng-click=\"$ctrl.onPaymentOptionsSelected(paymentOption)\" ng-repeat=\"paymentOption in $ctrl.paymentOptions\" ng-class=\"{'active': paymentOption.activeTab}\">\n                    <a data-toggle=\"tab\" aria-expanded=\"false\">\n                      <span>{{ paymentOption.type }}</span>\n                    </a>\n                  </li>\n                </ul>\n              </div>\n            </div>\n\n            <!-- Tab Body -->\n            <div class=\"tab-content\">\n              <ecopayzwithdrawal-form\n                ng-if=\"$ctrl.details && $ctrl.isEcopayz()\"\n                on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\"\n                details=\"$ctrl.details\"\n                selected-payment-option=\"$ctrl.selectedPaymentOption\"></ecopayzwithdrawal-form>\n\n              <skrillwithdrawal-form\n                ng-if=\"$ctrl.details && $ctrl.isSkrill()\"\n                on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\"\n                details=\"$ctrl.details\"\n                selected-payment-option=\"$ctrl.selectedPaymentOption\"></skrillwithdrawal-form>\n\n              <netellerwithdrawal-form\n                ng-if=\"$ctrl.details && $ctrl.isNeteller()\"\n                on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\"\n                details=\"$ctrl.details\"\n                selected-payment-option=\"$ctrl.selectedPaymentOption\"></netellerwithdrawal-form>\n\n              <bitcoin-withdrawal-form\n                ng-if=\"$ctrl.details && $ctrl.isBitcoin()\"\n                on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\"\n                details=\"$ctrl.details\"\n                selected-payment-option=\"$ctrl.selectedPaymentOption\"></bitcoin-withdrawal-form>\n\n              <bankwithdrawal-form\n                ng-if=\"$ctrl.details && $ctrl.isBank()\"\n                on-successful-submission=\"$ctrl.onSuccessfulSubmission(form, viewDetails)\"\n                details=\"$ctrl.details\"\n                selected-payment-option=\"$ctrl.selectedPaymentOption\"></bankwithdrawal-form>\n\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-lg-3 col-md-4 col-sm-12 fadeIn animated index-zero\">\n          <customer-product-widget on-customer-products-loaded=\"$ctrl.onCustomerProductsLoaded(customerProductsList)\"></customer-product-widget>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div id=\"invalidAction\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n  <div class=\"icon info\"></div>\n  <h3>{{ 'Invalid Action!' | translate }}</h3>\n  <p class=\"lead text-muted\">\n    {{ 'A product where the fee should be charged is required.' | translate }}\n  </p>\n  <p>\n    <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-danger waves-effect waves-light\">{{ 'OK' | translate }}</button>\n  </p>\n</div>\n\n<div id=\"invalidBankDetails\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"z-index: 999999;\">\n  <div class=\"icon info\"></div>\n  <h3 id=\"errorHeader\"></h3>\n  <p class=\"lead text-muted\" id=\"errorMessage\"></p>\n  <p>\n    <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-danger waves-effect waves-light\">{{ 'OK' | translate }}</button>\n  </p>\n</div>\n\n<product-password-widget></product-password-widget>\n<withdrawal-success-modal on-closed=\"$ctrl.finishTransaction()\"></withdrawal-success-modal>\n<withdrawal-error-modal on-closed=\"$ctrl.onCloseModal()\"></withdrawal-error-modal>\n<request-product-modal></request-product-modal>\n<link-bank-widget></link-bank-widget>\n"

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1188);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _basecontroller = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithdrawalController = function (_BaseController) {
	  WithdrawalController.$inject = ["AppService", "CustomerApiService", "PageService", "WithdrawalStore", "$timeout"];
	  (0, _inherits3.default)(WithdrawalController, _BaseController);
	
	  function WithdrawalController(AppService, CustomerApiService, PageService, WithdrawalStore, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WithdrawalController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WithdrawalController.__proto__ || (0, _getPrototypeOf2.default)(WithdrawalController)).call(this, AppService));
	
	    _this.CustomerApiService = CustomerApiService;
	    _this.PageService = PageService;
	    _this.WithdrawalStore = WithdrawalStore;
	    _this.hasAvailablePaymentOption = false;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(WithdrawalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.session = this.getSession();
	      this.removeSettingsHighlight();
	      this.checkStatus();
	      this.detailsSubscription = this.WithdrawalStore.getWithdrawDetails().subscribe(function (details) {
	        _this2.details = details;
	        _this2.paymentOptions = _this2.details.paymentOptions;
	        _this2.PaymentOptionsViewDetails = details.paymentOptionsViewDetails;
	        if (details.paymentOptions.length) {
	          _this2.hasAvailablePaymentOption = true;
	          _this2.onPaymentOptionsSelected(_this2.paymentOptions[0]);
	        }
	      });
	
	      this.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this2.refreshCustomerProducts();
	      });
	      this.addListener(_events2.default.TRANSACTION_PROCESSED, function (event) {
	        return _this2.refreshCustomerProducts();
	      });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      (0, _get3.default)(WithdrawalController.prototype.__proto__ || (0, _getPrototypeOf2.default)(WithdrawalController.prototype), '$onDestroy', this).call(this);
	      this.detailsSubscription.unsubscribe();
	    }
	  }, {
	    key: 'onPaymentOptionsSelected',
	    value: function onPaymentOptionsSelected(paymentOption) {
	
	      this.selectedPaymentOption = paymentOption;
	
	      // // highlight active tab.
	      angular.forEach(this.paymentOptions, function (value) {
	        return value.activeTab = false;
	      });
	      paymentOption.activeTab = true;
	
	      // // update view details
	      this.PaymentOptionsViewDetails.updateView(paymentOption);
	    }
	  }, {
	    key: 'isEcopayz',
	    value: function isEcopayz() {
	      return this.selectedPaymentOption.type === 'ECOPAYZ';
	    }
	  }, {
	    key: 'isSkrill',
	    value: function isSkrill() {
	      return this.selectedPaymentOption.type === 'SKRILL';
	    }
	  }, {
	    key: 'isNeteller',
	    value: function isNeteller() {
	      return this.selectedPaymentOption.type === 'NETELLER';
	    }
	  }, {
	    key: 'isBitcoin',
	    value: function isBitcoin() {
	      return this.selectedPaymentOption.type === 'BITCOIN';
	    }
	  }, {
	    key: 'isBank',
	    value: function isBank() {
	      return this.selectedPaymentOption.type === 'BANK';
	    }
	  }, {
	    key: 'refreshCustomerProducts',
	    value: function refreshCustomerProducts() {
	      this.broadcast('reload.customer-products');
	    }
	  }, {
	    key: 'onSuccessfulSubmission',
	    value: function onSuccessfulSubmission() {
	      this.PageService.showModal('successModal');
	    }
	  }, {
	    key: 'finishTransaction',
	    value: function finishTransaction() {
	      this.PageService.goto('overview');
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      $('#errorModal').modal('hide');
	    }
	  }, {
	    key: 'checkStatus',
	    value: function checkStatus() {
	      var _this3 = this;
	
	      this.WithdrawalStore.getStatus().then(function (response) {
	        _this3.setSessionItem('verifiedAt', response.verified_at);
	
	        _this3.session = _this3.getSession(); // Refresh session if verifiedAt somehow changed.
	        if (!_this3.session.isVerified() || !_this3.session.hasSetupTransactionAuthentication()) {
	          var checkBitcoin = response.details.enabledPaymentOption.filter(function (item) {
	            return item.code === 'BITCOIN';
	          });
	
	          if (response.currency.code !== 'BTC' || checkBitcoin.length <= 0) {
	            $('#modal-withdraw').show();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeSettingsHighlight',
	    value: function removeSettingsHighlight() {
	      this.$timeout(function () {
	        $('#settings').removeClass('subdrop');
	      }, 100);
	    }
	  }]);
	  return WithdrawalController;
	}(_basecontroller.BaseController);
	
	exports.default = WithdrawalController;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _successModal = __webpack_require__(1403);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _successModal3 = __webpack_require__(1404);
	
	var _successModal4 = _interopRequireDefault(_successModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var successModalComponent = {
	  bindings: {
	    onClosed: '&'
	  },
	  template: _successModal2.default,
	  controller: _successModal4.default
	};
	
	exports.default = successModalComponent;

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"successModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n    <div class=\"icon success animate\">\n        <span class=\"line tip animateSuccessTip\"></span>\n        <span class=\"line long animateSuccessLong\"></span>\n        <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n    </div>\n    <h3>{{ 'Request is successfully created!' | translate }}</h3>\n    <p class=\"lead text-muted\">\n        {{ 'Please wait for customer service confirmation. You can view transaction status in Transactions overview.' | translate }}\n    </p>\n    <p>\n        <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'OK' | translate }}</button>\n    </p>\n</div>\n"

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessModalController = function () {
	  function SuccessModalController() {
	    (0, _classCallCheck3.default)(this, SuccessModalController);
	  }
	
	  (0, _createClass3.default)(SuccessModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      $('#successModal').on('hidden.bs.modal', function () {
	        _this.onClosed();
	      });
	    }
	  }]);
	  return SuccessModalController;
	}();
	
	exports.default = SuccessModalController;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _errorModal = __webpack_require__(1406);
	
	var _errorModal2 = _interopRequireDefault(_errorModal);
	
	var _errorModal3 = __webpack_require__(1407);
	
	var _errorModal4 = _interopRequireDefault(_errorModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorModalComponent = {
	  bindings: {
	    onClosed: '&'
	  },
	  template: _errorModal2.default,
	  controller: _errorModal4.default
	};
	
	exports.default = errorModalComponent;

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"errorModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"z-index: 999999;\">\n    <div class=\"icon info\"></div>\n    <h3 id=\"errorHeader\"></h3>\n    <p class=\"lead text-muted\" id=\"errorMessage\"></p>\n    <p>\n        <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-danger waves-effect waves-light\">{{ 'OK' | translate }}</button>\n    </p>\n</div>"

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorModalController = function () {
	  function ErrorModalController() {
	    (0, _classCallCheck3.default)(this, ErrorModalController);
	  }
	
	  (0, _createClass3.default)(ErrorModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      $('#errorModal').on('hidden.bs.modal', function () {
	        _this.onClosed();
	      });
	    }
	  }]);
	  return ErrorModalController;
	}();
	
	exports.default = ErrorModalController;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bankWithdrawalForm = __webpack_require__(1409);
	
	var _bankWithdrawalForm2 = _interopRequireDefault(_bankWithdrawalForm);
	
	var _bankWithdrawalForm3 = __webpack_require__(1410);
	
	var _bankWithdrawalForm4 = _interopRequireDefault(_bankWithdrawalForm3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bankWithdrawalFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _bankWithdrawalForm2.default,
	  controller: _bankWithdrawalForm4.default
	};
	
	exports.default = bankWithdrawalFormComponent;

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white\">\n  <div class=\"row\" ng-if=\"$ctrl.isClosed\">\n    <div class=\"col-lg-12\" style=\"padding: 20px;margin-top: 20px;\">\n      <div class=\"alert alert-danger\">\n        <strong>{{ 'Note' | translate }}:</strong> {{ 'bankNotice' | translate }}\n      </div>\n    </div>\n  </div>\n\n  <div class=\"flex-row p-b-30\" ng-if=\"$ctrl.paymentOptionsViewDetails.isCountryRestricted && $ctrl.paymentOptionsViewDetails.activeDisplay && !$ctrl.isClosed\">\n    <div class=\"col-lg-12\" style=\"padding: 20px;margin-top: 20px;\">\n      <div class=\"alert alert-danger\">\n        <strong>{{ 'Note' | translate }}:</strong> {{ 'bankRestricted' | translate }}\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"!$ctrl.paymentOptionsViewDetails.isCountryRestricted && $ctrl.paymentOptionsViewDetails.activeDisplay && !$ctrl.isClosed\" >\n\n    <div class=\"flex-row p-b-30 bank-with-sidebar\">\n      <div class=\"col-lg-9 col-md-12 col-sm-12 col-xs-12 m-b-15\">\n        <div class=\"row\">\n\n          <div class=\"col-md-12 b-t-1 p-b-30\">\n            <div class=\"row p-lr m-t-15\" ng-show=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">\n              <div class=\"col-lg-10 col-md-10 col-sm-12\">\n                <p>{{ 'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.' | translate }}</p>\n                <ul class=\"depositForm depositForm-btc\">\n                  <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.processingTime }}</li>\n                  <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b>{{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.fee }}</li>\n                  <li><i class=\"fa fa-check\"></i><b>{{ 'Minimum Withdrawal Amount' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.minimumWithdrawal }}</li>\n                  <li><i class=\"fa fa-check\"></i><b>{{ 'Maximum Withdrawal Amount' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.maximumWithdrawal }}</li>\n                </ul>\n              </div>\n            </div>\n          </div>\n\n          <!-- Form -->\n          <div class=\"col-md-12 p-t-30 ac-white b-t-1 p-b-30\">\n            <form class=\"form-horizontal\" action=\"\">\n              <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n                <!--new form-->\n                <div class=\"row\">\n                  <div class=\"col-lg-12\">\n                    <!-- Product Panel -->\n                    <div class=\"product-selection-panel p-lr bank\">\n                      <div class=\"row visible-lg visible-md\">\n                        <div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n                          <label class=\"control-label\">{{ 'Bank Account' | translate }}</label>\n                          <a href=\"#\" data-toggle=\"modal\" data-target=\"#bankAccountModal\" class=\"pull-right link-bank\"><i class=\"fa fa-plus-circle\"></i> {{ 'Link new bank account' | translate }}</a>\n                        </div>\n                        <div class=\"col-lg-7 col-md-7 col-sm-12 col-xs-12\"></div>\n                      </div>\n                      <div class=\"row visible-lg visible-md\">\n                        <div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n                          <select ng-model=\"$ctrl.form.bankPaymentOption\"\n                                  ng-options=\"bank.id as (bank.fields.account_id + ' ( ' + bank.fields.bank_name + ' ) ' ) for bank in $ctrl.form.bankPaymentOptions\"\n                                  ng-change=\"$ctrl.onChangeBankAccount()\"\n                                  class=\"form-control\" id=\"bankAccountList\">\n                          </select>\n                          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.paymentOption\">\n                            <li ng-repeat=\"(key, error) in $ctrl.form.error.paymentOption\" class=\"parsley-required\">{{ error }}</li>\n                          </ul>\n                        </div>\n                        <div class=\"col-lg-7 col-md-7 col-sm-12 col-xs-12\"></div>\n                      </div>\n                      <hr>\n                      <div class=\"row visible-lg visible-md\">\n                        <div class=\"col-lg-5 col-md-5\">\n                          <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                        </div>\n                        <div class=\"col-lg-5 col-md-5\">\n                          <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                        </div>\n                        <div class=\"col-lg-2 col-md-2\">\n                          <label class=\"control-label\">{{ 'fee' | translate }}</label>\n                        </div>\n                      </div>\n                      <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n                        <!-- Product -->\n                        <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                          <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                        </div>\n                        <div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n                          <select ng-model=\"subTransaction.product\" ng-init=\"oldValue=null\" ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                            ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                            ng-click=\"oldValue=subTransaction.product\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\"\n                            class=\"form-control\">\n                            <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                          </select>\n                          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                            <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\"\n                              class=\"parsley-required\">{{\n                              error }}</li>\n                          </ul>\n                        </div>\n\n                        <!-- Amount-->\n                        <div class=\"col-lg-5 col-md-5 col-sm-8 col-xs-8 product-amount\">\n                          <div class=\"row\">\n                            <!-- Amount Input -->\n                            <div class=\"col-lg-12 col-md-12 col-sm-10 col-xs-12 m-b-10\">\n                              <div class=\"input-group\">\n                                <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ | async }}</span>\n                                <input\n                                    ng-blur=\"$ctrl.formatAmount(subTransaction)\"\n                                    ng-model=\"subTransaction.amount\"\n                                    ng-disabled=\"$ctrl.form.props.readOnly\"\n                                    ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\"\n                                    limit=\"22\"\n                                    precision=\"2\"\n                                    type=\"text\"\n                                    class=\"form-control ng-pristine ng-untouched ng-valid ng-not-empty\">\n                              </div>\n                              <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                                <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\"\n                                  class=\"parsley-required\">{{\n                                  error }}</li>\n                              </ul>\n                            </div>\n                          </div>\n                        </div>\n\n                        <!-- Charge Fee Here -->\n                        <div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-3\">\n                          <div class=\"row\">\n                            <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                              <div class=\"checkbox checkbox-success checkbox-circle\">\n                                <input ng-model=\"subTransaction.chargeFee\" ng-click=\"$ctrl.form.chargeFeeSelected(subTransaction)\"\n                                  type=\"checkbox\">\n                                <label></label>\n                              </div>\n                            </div>\n                            <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                              <button ng-click=\"$ctrl.form.removeSubTransaction(subTransaction, $index)\" ng-if=\"$ctrl.displayDeleteButton\"\n                                class=\"btn btn-danger\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n\n                      <!-- Errors -->\n                      <div class=\"row\">\n                        <div class=\"col-md-12\">\n                        </div>\n                      </div>\n\n                      <!-- Add product -->\n                      <div class=\"row\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                          <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\"\n                            class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i>\n                            {{ 'Add product' | translate }}</button>\n                        </div>\n                      </div>\n\n                      <!-- Transaction Password / Request btn -->\n                      <div class=\"row m-t-20\">\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                          <div class=\"row\">\n                            <div class=\"col-md-10\">\n                              <input ng-model=\"$ctrl.form.transactionPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.transactionPassword }\"\n                                type=\"password\" class=\"form-control\" placeholder=\"Transaction Password\">\n                              <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.transactionPassword\">\n                                <li ng-repeat=\"(key, error) in $ctrl.form.error.transactionPassword\" class=\"parsley-required\">{{\n                                  error }}</li>\n                              </ul>\n                            </div>\n                            <div class=\"col-md-2\">\n                              <a class=\"pull-left padding-top-7 custom_tooltip_mobile\" data-toggle=\"tooltip\"\n                                data-placement=\"right\">\n                                <i class=\"fa fa-question-circle\"></i>\n                                <span class=\"custom_tooltiptext\">\n                                  {{ 'transactionPasswordHint' | translate }}\n                                </span>\n                              </a>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 text-right bank-request\">\n                          <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Withdrawal'\"></ladda-button>\n                          <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\"\n                            class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n          <!-- Form -->\n        </div>\n      </div>\n\n      <!--BANK SIDEBAR-->\n      <div class=\"bank-sidebar-wrap active\">\n        <i class=\"fas fa-receipt visible-md visible-sm visible-xs\" type=\"button\"></i>\n        <div class=\"col-lg-3 bank-sidebar bank-sidebar-withdrawal\">\n          <div class=\"text-center\">\n            <img src=\"assets/images/payment/white/bank.png\" class=\"payment-option-logo m-b-10\">\n\n            <div class=\"exchange-rate-wrap\">\n              <ul class=\"list-unstyled text-left\">\n                <li>\n                  <span><b>{{ 'Beneficiary name' | translate }}:</b> {{ $ctrl.form.bankDetails.fields.account_name }}</span>\n                </li>\n                <li>\n                  <span><b>{{ 'Beneficiary address' | translate }}:</b> {{ $ctrl.form.bankDetails.fields.account_address }}</span>\n                </li>\n                <li>\n                  <span><b>{{ 'IBAN' | translate }}:</b> {{ $ctrl.form.bankDetails.fields.account_id }}</span>\n                </li>\n                <li>\n                  <span><b>{{ 'Bank name' | translate }}:</b> {{ $ctrl.form.bankDetails.fields.bank_name }}</span>\n                </li>\n                <li>\n                  <span><b>{{ 'Bank address' | translate }}:</b> {{ $ctrl.form.bankDetails.fields.bank_address }}</span>\n                </li>\n                <li>\n                  <span><b>{{ 'SWIFT' | translate }}:</b> {{ $ctrl.form.bankDetails.fields.swift_code }}</span>\n                </li>\n              </ul>\n            </div>\n            <!-- Transaction Summary -->\n            <div class=\"transaction-summary-wrap\">\n              <hr>\n              <h3 class=\"uppercase text-left\">{{ 'Transaction Summary' | translate }}</h3>\n              <div class=\"text-left\">\n                <h4>{{ 'Total amount to be deducted from your account' | translate }}:</h4>\n                <p class=\"btc-totals\">{{ $ctrl.form.totalAmount\n                  |number }} {{ $ctrl.userCurrency$ | async }}</p>\n                <h4>Fee:</h4>\n                <span class=\"btc-totals\" ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') === 'Free'\">Free</span>\n                <span class=\"btc-totals\" ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') !== 'Free'\">{{\n                  $ctrl.form.fee |number: 2}} {{ $ctrl.userCurrency$ |async }}</span>\n                <h4>{{ 'Total amount to be received in your account' | translate }}:</h4>\n                <p class=\"btc-totals\">{{\n                  $ctrl.form.totalAmountToBeWithdrawn }} {{ $ctrl.userCurrency$ | async }}</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!--BANK SIDEBAR-->\n    </div>\n  </div>\n</div>\n\n<div id=\"bankConfirmationModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" data-backdrop=\"static\" data-keyboard=\"false\">\n  <div class=\"icon info\"></div>\n  <h3>{{ 'Confirmation Message' | translate }}</h3>\n  <p class=\"lead text-muted\" id=\"bankSuccessMessage\"></p>\n  <p>\n    <button ng-click=\"$ctrl.setAsDefaultBank()\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'Yes' | translate }}</button>\n    <button ng-click=\"$ctrl.setAsNotDefaultBank()\" type=\"button\" class=\"btn btn-danger waves-effect waves-light\">{{ 'No' | translate }}</button>\n  </p>\n</div>\n<div id=\"bank-modal-backdrop\" class=\"modal-backdrop in\" style=\"display: none;\"></div>\n"

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _bankWithdrawalForm = __webpack_require__(1411);
	
	var _modal = __webpack_require__(1096);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankWithdrawalFormController = function (_BaseController) {
	  BankWithdrawalFormController.$inject = ["WithdrawalStore", "FormService", "PaymentOptionApiService", "EventDispatcherService", "$timeout", "$scope", "$state", "$translate"];
	  (0, _inherits3.default)(BankWithdrawalFormController, _BaseController);
	
	  function BankWithdrawalFormController(WithdrawalStore, FormService, PaymentOptionApiService, EventDispatcherService, $timeout, $scope, $state, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BankWithdrawalFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BankWithdrawalFormController.__proto__ || (0, _getPrototypeOf2.default)(BankWithdrawalFormController)).call(this));
	
	    _this.WithdrawalStore = WithdrawalStore;
	    _this.FormService = FormService;
	    _this.PaymentOptionApiService = PaymentOptionApiService;
	    _this.EventDispatcherService = EventDispatcherService;
	    _this.$timeout = $timeout;
	    _this.$scope = $scope;
	    _this.$state = $state;
	    _this.$translate = $translate;
	    _this.isClosed = false;
	
	    _this.$scope.$on('reload.member-payment-option', function () {
	      _this.getBankPaymentOptionList();
	    });
	
	    _this.$scope.$on('reload.bank-sidebar', function () {
	      var tempBank = sessionStorage.getItem('temp_bank');
	      tempBank = JSON.parse(tempBank);
	      if (tempBank) {
	        _this.form.bankPaymentOptions.push(tempBank);
	        _this.form.bankPaymentOption = tempBank.id;
	        _this.onChangeBankAccount();
	      }
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(BankWithdrawalFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.isClosed = true;
	      this.addSubscription(this.EventDispatcherService.addListener(_events2.default.MEMBER_PAYMENT_OPTION_CREATED, function (event) {
	        return _this2.getBankPaymentOptionList();
	      }));
	      this.userCurrency$ = this.WithdrawalStore.getCurrency();
	
	      this.form = new _bankWithdrawalForm.BankWithdrawalForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('withdrawal');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('withdrawal');
	      this.enableSidebar();
	      this.getBankPaymentOptionList();
	    }
	  }, {
	    key: 'getBankPaymentOptionList',
	    value: function getBankPaymentOptionList() {
	      var _this3 = this;
	
	      this.PaymentOptionApiService.getBankPaymentOption().then(function (resp) {
	        _this3.form.bankPaymentOptions = resp;
	        angular.forEach(resp, function (item) {
	          if (parseInt(item.fields.is_default) === 1) {
	            _this3.form.bankPaymentOption = item.id;
	            _this3.onChangeBankAccount();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.FormService.isSubmitting.next(true);
	      if (!this.isValidAmount()) {
	        $('#errorHeader').html(this.$translate.instant('Opps, amount is not enough!'));
	        $('#errorMessage').html(this.$translate.instant('Minimum amount that can be withdrawn is 100 EUR/GBP.'));
	        this.FormService.isSubmitting.next(false);
	        (0, _modal.showModal)('invalidBankDetails');
	        return false;
	      }
	
	      var isChecked = this.form.subTransactions.filter(function (obj) {
	        return obj.chargeFee === true;
	      });
	
	      if (!isChecked.length) {
	        (0, _modal.showModal)('invalidAction');
	        this.FormService.isSubmitting.next(false);
	
	        return false;
	      }
	
	      if (this.isNotDefault() && !this.form.confirmed) {
	        this.confirmDefaultBank();
	
	        return false;
	      }
	
	      this.withdraw();
	    }
	  }, {
	    key: 'withdraw',
	    value: function withdraw() {
	      var _this4 = this;
	
	      (0, _modal.hideModal)('bankConfirmationModal');
	      $('#bank-modal-backdrop').hide();
	      this.WithdrawalStore.withdraw(this.form.toPayload()).then(function () {
	        _this4.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        _this4.form.error.setFormErrors(errors);
	        _this4.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'setAsDefaultBank',
	    value: function setAsDefaultBank() {
	      this.form.setAsDefault = true;
	      this.form.confirmed = true;
	      this.withdraw();
	    }
	  }, {
	    key: 'setAsNotDefaultBank',
	    value: function setAsNotDefaultBank() {
	      this.form.setAsDefault = false;
	      this.form.confirmed = true;
	      this.withdraw();
	    }
	  }, {
	    key: 'confirmDefaultBank',
	    value: function confirmDefaultBank() {
	      (0, _modal.showModal)('bankConfirmationModal');
	      this.FormService.isSubmitting.next(false);
	      $('.modal-backdrop').hide();
	      $('#bankSuccessMessage').html(this.$translate.instant('Do you want ') + this.form.bankDetails.fields.bank_name + ' (' + this.form.bankDetails.fields.account_id + ') ' + this.$translate.instant('to be your default bank for withdrawal?'));
	      $('#bank-modal-backdrop').show();
	    }
	  }, {
	    key: 'isNotDefault',
	    value: function isNotDefault() {
	      return !this.form.bankDetails.fields.is_default && this.form.bankDetails.is_active;
	    }
	  }, {
	    key: 'onChangeBankAccount',
	    value: function onChangeBankAccount() {
	      var _this5 = this;
	
	      this.PaymentOptionApiService.getPaymentOptionById(this.form.bankPaymentOption).then(function (resp) {
	        _this5.form.bankDetails = resp;
	        _this5.form.confirmed = false;
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.form.clearError();
	      this.form.props.readOnly = true;
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid() {
	      var count = 0;
	      angular.forEach(this.form.bankDetails, function (value, key) {
	        if (value === null || value === '') {
	          count++;
	        }
	      });
	
	      return count === 0;
	    }
	  }, {
	    key: 'isValidAmount',
	    value: function isValidAmount() {
	      var total = this.form.totalAmountToBeWithdrawn;
	
	      return total >= 100;
	    }
	  }, {
	    key: 'enableSidebar',
	    value: function enableSidebar() {
	      this.$timeout(function () {
	        $(".bank-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".bank-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return BankWithdrawalFormController;
	}(_basecontroller.BaseController);
	
	exports.default = BankWithdrawalFormController;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BankWithdrawalForm = undefined;
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _transactionform = __webpack_require__(1412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankWithdrawalForm = exports.BankWithdrawalForm = function (_TransactionForm) {
	  (0, _inherits3.default)(BankWithdrawalForm, _TransactionForm);
	
	  function BankWithdrawalForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, BankWithdrawalForm);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BankWithdrawalForm.__proto__ || (0, _getPrototypeOf2.default)(BankWithdrawalForm)).call(this, customerProducts, paymentOptions));
	
	    _this.bankPaymentOptions = [];
	    _this.bankPaymentOption = null;
	    _this.bankDetails = {};
	    _this.setAsDefault = false;
	    _this.confirmed = false;
	    return _this;
	  }
	
	  (0, _createClass3.default)(BankWithdrawalForm, [{
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        transaction: {
	          transactionPassword: this.transactionPassword
	        }
	      };
	
	      payload['transaction']['paymentOption'] = this.bankPaymentOption;
	      payload['transaction']['paymentOptionType'] = this.paymentOptionType;
	      payload['transaction']['customerFee'] = this.fee;
	      payload['transaction']['defaultBank'] = this.setAsDefault;
	
	      var subTransactions = {};
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.subTransactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var subTransaction = _step.value;
	
	          subTransactions[subTransaction.key] = {
	            product: subTransaction.product,
	            amount: subTransaction.amount,
	            forFee: subTransaction.forFee
	          };
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      payload['transaction']['subTransactions'] = subTransactions;
	
	      return payload;
	    }
	  }]);
	  return BankWithdrawalForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TransactionForm = exports.SubTransaction = undefined;
	
	var _slicedToArray2 = __webpack_require__(447);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1413);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	var _number = __webpack_require__(1203);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _number2 = __webpack_require__(1203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubTransaction = exports.SubTransaction = function () {
	  function SubTransaction(key) {
	    (0, _classCallCheck3.default)(this, SubTransaction);
	
	    this.key = key;
	
	    this.product = null;
	    this.amount = 0;
	    this.btc = 0;
	    this.chargeFee = true;
	
	    this.customerProducts = [];
	  }
	
	  (0, _createClass3.default)(SubTransaction, [{
	    key: 'convertBtcToAmount',
	    value: function convertBtcToAmount(btcAdjustedRate) {
	      var converted = (0, _numeral2.default)(btcAdjustedRate * this.btc);
	      this.amount = (0, _number.format)(converted, _number2.DEFAULT_DECIMAL_FORMAT);
	    }
	  }, {
	    key: 'convertAmountToBtc',
	    value: function convertAmountToBtc(btcAdjustedRate) {
	      var converted = (0, _numeral2.default)(this.amount / btcAdjustedRate);
	      this.btc = (0, _number.format)(converted, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }, {
	    key: 'formattedBtc',
	    get: function get() {
	      return (0, _number.format)((0, _numeral2.default)(this.btc), _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }, {
	    key: 'formattedAmount',
	    get: function get() {
	      return (0, _number.format)((0, _numeral2.default)(this.amount), _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }, {
	    key: 'forFee',
	    get: function get() {
	      return this.chargeFee ? 1 : 0;
	    }
	  }]);
	  return SubTransaction;
	}();
	
	var TransactionForm = exports.TransactionForm = function () {
	  function TransactionForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, TransactionForm);
	
	    // Form Fields
	    this.email = null;
	    this.amount = null;
	    this.paymentOption = null;
	    this.transactionPassword = null;
	    this.subTransactions = [];
	
	    // Collections needed to create the form
	    this.customerProducts = customerProducts;
	    this.paymentOptions = paymentOptions;
	    this.selectedCustomerProducts = [];
	
	    // Miscellaneous
	    this.error = new _formError2.default();
	    this.nextItemKey = 0;
	    this.freeFee = false; // This becomes true when the customer comes from France coz we loved France so much.
	    this.isUsingGoogleTwoFactor = false;
	
	    this.props = {
	      isSubmitting: false,
	      isReady: false,
	      readOnly: false
	    };
	
	    this.isBank = false;
	    this.bankErrorMessage = '';
	    this.addSubTransaction();
	  }
	
	  (0, _createClass3.default)(TransactionForm, [{
	    key: 'addSubTransaction',
	    value: function addSubTransaction() {
	      var _this = this;
	
	      var subTransaction = new SubTransaction(this.nextItemKey);
	      var shallowCopy = this.customerProducts.slice(0); //copy by value not reference.
	
	      shallowCopy = shallowCopy.filter(function (item) {
	        return !_this.selectedCustomerProducts.includes(item.id);
	      });
	      subTransaction.customerProducts = shallowCopy;
	
	      if (this.nextItemKey !== 0) {
	        subTransaction.chargeFee = false;
	      }
	
	      if (this.customerProducts.length === 1) {
	        subTransaction.product = this.customerProducts[0].id;
	      }
	
	      this.subTransactions.push(subTransaction);
	      this.nextItemKey++;
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.removeFromSelectedProducts(subTransaction.product);
	      this.reloadToAllCustomerProducts(subTransaction.product, index);
	
	      for (var i = 0; i < this.subTransactions.length; i++) {
	        if (this.subTransactions[i].key === subTransaction.key) {
	          this.subTransactions.splice(i, 1);
	          break;
	        }
	      }
	    }
	  }, {
	    key: 'chargeFeeSelected',
	    value: function chargeFeeSelected(subTransaction) {
	      for (var i = 0; i < this.subTransactions.length; i++) {
	        if (this.subTransactions[i].key !== subTransaction.key) {
	          this.subTransactions[i].chargeFee = false;
	        } else {
	          this.subTransactions[i].chargeFee = true;
	        }
	
	        var fees = document.querySelectorAll('input[type=checkbox]');
	        var unchecked = [].filter.call(fees, function (fee) {
	          return !fee.checked;
	        });
	
	        if (fees.length == unchecked.length) {
	          $('#invalidAction').modal('show');
	        }
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.amount = null;
	
	      this.error = new _formError2.default();
	      this.nextItemKey = 0;
	
	      // TODO: Should we reset this also?
	      this.props.readOnly = false;
	      this.props.isSubmitting = false;
	      this.props.isReady = false;
	
	      this.subTransactions = [];
	      this.selectedCustomerProducts = [];
	
	      this.addSubTransaction();
	    }
	  }, {
	    key: 'clearError',
	    value: function clearError() {
	      this.error = new _formError2.default();
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        transaction: {
	          transactionPassword: this.transactionPassword,
	          usingGoogleAuthPassword: this.isUsingGoogleTwoFactor
	        }
	      };
	
	      payload['transaction']['paymentOption'] = this.paymentOption;
	      payload['transaction']['paymentOptionType'] = this.paymentOptionType;
	      payload['transaction']['customerFee'] = this.fee;
	
	      if (this.paymentOptionType == 'BANK') {
	        payload['transaction']['bankDetails'] = this.getBankDetails();
	      }
	
	      var subTransactions = {};
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.subTransactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var subTransaction = _step.value;
	
	          subTransactions[subTransaction.key] = {
	            product: subTransaction.product,
	            amount: subTransaction.amount,
	            forFee: subTransaction.forFee
	          };
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      payload['transaction']['subTransactions'] = subTransactions;
	
	      return payload;
	    }
	  }, {
	    key: 'authenticationSwitched',
	    value: function authenticationSwitched(isUsingGoogleTwoFactor) {
	      this.isUsingGoogleTwoFactor = isUsingGoogleTwoFactor;
	    }
	
	    //============================================================================
	    //  Code Below handles operations when a change in product selection occurs.
	    //============================================================================
	
	  }, {
	    key: 'onChangedCustomerProduct',
	    value: function onChangedCustomerProduct(index, newValue, oldValue) {
	      this.selectedCustomerProducts.push(newValue);
	      this.removeFromSelectedProducts(oldValue);
	      this.removeFromSelection(newValue, index);
	      this.reloadToAllCustomerProducts(oldValue, index);
	    }
	  }, {
	    key: 'removeFromSelection',
	    value: function removeFromSelection(newValue, index) {
	      // Remove CustomerProduct with id matching the newValue within each SubTransactions
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.subTransactions.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
	              sIndex = _step2$value[0],
	              subTransaction = _step2$value[1];
	
	          // This condition will not remove the CustomerProduct from the owning SubTransaction.
	          // The reason is that, when we tried to remove it, the ng-model will be affected does
	          // will unselect the selection. Apparently, this is the same implementation on OLD AMS.
	          if (index !== sIndex) {
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = (0, _getIterator3.default)(this.subTransactions[sIndex].customerProducts.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
	                    cIndex = _step3$value[0],
	                    customerProduct = _step3$value[1];
	
	                if (customerProduct.id === newValue) {
	                  this.subTransactions[sIndex].customerProducts.splice(cIndex, 1);
	                }
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'removeFromSelectedProducts',
	    value: function removeFromSelectedProducts(value) {
	      if (value) {
	        var oldValueIndex = this.selectedCustomerProducts.indexOf(value);
	        this.selectedCustomerProducts.splice(oldValueIndex, 1);
	      }
	    }
	
	    // Push CustomerProduct with id matching the oldValue (if oldValue is not null) within each SubTransactions
	
	  }, {
	    key: 'reloadToAllCustomerProducts',
	    value: function reloadToAllCustomerProducts(oldValue, index) {
	      if (oldValue) {
	        var oldCustomerProduct = this.getCustomerProductById(oldValue);
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(this.subTransactions.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
	                sIndex = _step4$value[0],
	                subTransaction = _step4$value[1];
	
	            if (index !== sIndex) {
	              subTransaction.customerProducts.push(oldCustomerProduct);
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getCustomerProductById',
	    value: function getCustomerProductById(id) {
	      return this.customerProducts.filter(function (customerProduct) {
	        return customerProduct.id === id;
	      })[0];
	    }
	  }, {
	    key: 'totalAmount',
	    get: function get() {
	      var totalAmount = 0;
	
	      angular.forEach(this.subTransactions, function (subTransaction) {
	        totalAmount += Number(subTransaction.amount);
	      });
	
	      return totalAmount;
	    }
	  }, {
	    key: 'totalAmountToBeWithdrawn',
	    get: function get() {
	      return this.totalAmount - this.fee;
	    }
	  }, {
	    key: 'fee',
	    get: function get() {
	      if (this.feeFree) {
	        return 0;
	      }
	
	      var actualFee = this.totalAmount * Number(this.feeMultiplier);
	
	      return actualFee;
	    }
	  }, {
	    key: 'isValid',
	    get: function get() {
	      return this.subTransactions.length > 0;
	    }
	  }, {
	    key: 'canAddProduct',
	    get: function get() {
	      return this.customerProducts.length > 1;
	    }
	  }, {
	    key: 'isReadOnly',
	    get: function get() {
	      return this.props.readOnly;
	    }
	  }]);
	  return TransactionForm;
	}();

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	var _form = __webpack_require__(1202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormError = function () {
	  function FormError() {
	    (0, _classCallCheck3.default)(this, FormError);
	
	    this.flattenedErrors = {
	      subTransactions: {}
	    };
	  }
	
	  (0, _createClass3.default)(FormError, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.flattenErrors(errors);
	    }
	  }, {
	    key: 'flattenErrors',
	    value: function flattenErrors(errors) {
	      var _this = this;
	
	      var transactionPasswordErrors = (0, _lodash.get)(errors, 'children.transactionPassword.errors');
	      this.flattenedErrors['transactionPassword'] = transactionPasswordErrors;
	
	      var accountIdErrors = (0, _lodash.get)(errors, 'children.accountId.errors');
	      this.flattenedErrors['accountId'] = accountIdErrors;
	
	      var paymentOptionErrors = (0, _lodash.get)(errors, 'children.paymentOption.errors');
	      this.flattenedErrors['paymentOption'] = paymentOptionErrors;
	
	      var subTransactionsErrors = (0, _form.adjustFormError)((0, _lodash.get)(errors, 'children.subTransactions.children'));
	
	      subTransactionsErrors.forEach(function (value, idx) {
	        var errors = value['children'];
	        _this.flattenedErrors.subTransactions[idx] = errors;
	      });
	    }
	  }, {
	    key: 'getError',
	    value: function getError(propertyPath) {
	      return (0, _lodash.get)(this.flattenedErrors, propertyPath);
	    }
	  }, {
	    key: 'subTransaction',
	    value: function subTransaction(path, key) {
	      var propertyPath = 'subTransactions.' + key + '.' + path + '.errors';
	
	      return this.getError(propertyPath);
	    }
	  }, {
	    key: 'transactionPassword',
	    get: function get() {
	      return this.getError('transactionPassword');
	    }
	  }, {
	    key: 'accountId',
	    get: function get() {
	      return this.getError('accountId');
	    }
	  }, {
	    key: 'paymentOption',
	    get: function get() {
	      return this.getError('paymentOption');
	    }
	  }]);
	  return FormError;
	}();
	
	exports.default = FormError;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _skrillWithdrawalForm = __webpack_require__(1415);
	
	var _skrillWithdrawalForm2 = _interopRequireDefault(_skrillWithdrawalForm);
	
	var _skrillWithdrawalForm3 = __webpack_require__(1416);
	
	var _skrillWithdrawalForm4 = _interopRequireDefault(_skrillWithdrawalForm3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var skrillWithdrawalFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _skrillWithdrawalForm2.default,
	  controller: _skrillWithdrawalForm4.default
	};
	
	exports.default = skrillWithdrawalFormComponent;

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white gateway-wrapper\">\n  <div class=\"flex-row mh-80 vh-center\">\n    <div class=\"p-lr-30 mtop2\" ng-if=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">\n      <ul class=\"depositForm depositForm-btc\">\n        <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.processingTime }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b>{{ $ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'Minimum Withdrawal Amount' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.minimumWithdrawal }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'Maximum Withdrawal Amount' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.maximumWithdrawal }}</li>\n      </ul>\n    </div>\n  </div>\n\n  <hr class=\"m-10\">\n\n  <div class=\"flex-row\">\n    <div class=\"col-lg-8\">\n      <form class=\"form-horizontal\" action=\"\">\n        <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n          <!--new form-->\n          <div class=\"row\">\n            <div class=\"col-lg-12\">\n              <!-- Product Panel -->\n              <div class=\"product-selection-panel p-lr bank\">\n                <!-- Email -->\n                <div class=\"row\">\n                  <div class=\"col-md-6\">\n                    <div class=\"row\">\n                      <label class=\"col-md-12\">{{ 'form.email' | translate }}</label>\n                      <div class=\"col-md-12\">\n                        <input type=\"email\" disabled value=\"{{ $ctrl.form.email }}\" name=\"From email\" class=\"form-control\" placeholder=\"{{ 'form.email' | translate }}\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"row visible-lg visible-md\">\n                  <div class=\"col-lg-5 col-md-5\">\n                    <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-5 col-md-5\">\n                    <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-2 col-md-2\">\n                    <label class=\"control-label\">{{ 'fee' | translate }}</label>\n                  </div>\n                </div>\n                <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n                  <!-- Product -->\n                  <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                    <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n                    <select ng-model=\"subTransaction.product\" ng-init=\"oldValue=null\" ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                        ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                        ng-click=\"oldValue=subTransaction.product\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\"\n                        class=\"form-control\">\n                      <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                    </select>\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                      <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{\n                        error }}</li>\n                    </ul>\n                  </div>\n\n                  <!-- Amount-->\n                  <div class=\"col-lg-5 col-md-5 col-sm-8 col-xs-8 product-amount\">\n                    <div class=\"row\">\n                      <!-- Amount Input -->\n                      <div class=\"col-lg-12 col-md-12 col-sm-10 col-xs-12 m-b-10\">\n                        <div class=\"input-group\">\n                          <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ | async }}</span>\n                          <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\"\n                                limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control ng-pristine ng-untouched ng-valid ng-not-empty\">\n                        </div>\n                        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                          <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{\n                            error }}</li>\n                        </ul>\n                      </div>\n                    </div>\n                  </div>\n                  \n                  <!-- Charge Fee Here -->\n                  <div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-3\">\n                    <div class=\"row\">\n                      <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                        <div class=\"checkbox checkbox-success checkbox-circle\">\n                          <input ng-model=\"subTransaction.chargeFee\" ng-click=\"$ctrl.form.chargeFeeSelected(subTransaction)\" type=\"checkbox\">\n                          <label></label>\n                        </div>\n                      </div>\n                      <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                        <button ng-click=\"$ctrl.form.removeSubTransaction(subTransaction, $index)\" ng-if=\"$ctrl.displayDeleteButton\" class=\"btn btn-danger\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <!-- Errors -->\n                <div class=\"row\">\n                  <div class=\"col-md-12\">\n                  </div>\n                </div>\n\n                <!-- Add product -->\n                <div class=\"row\">\n                  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}</button>\n                  </div>\n                </div>\n\n                <!-- Transaction Password / Request btn -->\n                <div class=\"row m-t-20\">\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                    <switch-auth switched=\"$ctrl.form.authenticationSwitched(isUsingGoogleTwoFactor)\" session=\"$ctrl.session\">\n                      <input ng-model=\"$ctrl.form.transactionPassword\" type=\"password\" class=\"form-control\">\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.transactionPassword\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.transactionPassword\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </switch-auth>\n                  </div>\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                    <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Withdrawal'\"></ladda-button>\n                    <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <!-- Sidebar -->\n    <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap skrill-bg active\">\n        <i class=\"fas fa-receipt visible-md visible-sm visible-xs\" type=\"button\"></i>\n        <div class=\"gateway-sidebar\">\n          <img src=\"assets/images/payment/white/skrill.png\" class=\"payment-option-logo\">\n          \n          <!-- Transaction Summary -->\n          <div class=\"transaction-summary\">\n            <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n            <div class=\"font-lg\">\n              <p>{{ 'Amount to deduct' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmount |number }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n\n              <p>{{ 'fee' | translate }}:<br>\n                <span class=\"bold\" ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') === 'Free'\">{{ 'Free' | translate }}</span>\n                <span class=\"bold\" ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') !== 'Free'\">{{ $ctrl.form.fee |number: 2}} {{ $ctrl.userCurrency$ |async }}</span>\n              </p>\n\n              <hr class=\"m-10\">\n\n              <p class=\"uppercase\">{{ 'Total amount to receive' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmountToBeWithdrawn }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _skrillWithdrawalForm = __webpack_require__(1417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkrillWithdrawalFormController = function (_BaseController) {
	  SkrillWithdrawalFormController.$inject = ["WithdrawalStore", "FormService", "AppService", "$timeout"];
	  (0, _inherits3.default)(SkrillWithdrawalFormController, _BaseController);
	
	  function SkrillWithdrawalFormController(WithdrawalStore, FormService, AppService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SkrillWithdrawalFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SkrillWithdrawalFormController.__proto__ || (0, _getPrototypeOf2.default)(SkrillWithdrawalFormController)).call(this, AppService));
	
	    _this.WithdrawalStore = WithdrawalStore;
	    _this.FormService = FormService;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(SkrillWithdrawalFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.userCurrency$ = this.WithdrawalStore.getCurrency();
	      this.session = this.getSession();
	
	      this.form = new _skrillWithdrawalForm.SkrillWithdrawalForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.email = this.selectedPaymentOption.email;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('withdrawal');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('withdrawal');
	      this.enableSidebar();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	
	      var isChecked = this.form.subTransactions.filter(function (obj) {
	        return obj.chargeFee === true;
	      });
	
	      if (!isChecked.length) {
	        $('#invalidAction').modal('show');
	        this.FormService.isSubmitting.next(false);
	
	        return false;
	      }
	
	      this.WithdrawalStore.withdraw(this.form.toPayload()).then(function () {
	        return _this2.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        _this2.form.error.setFormErrors(errors);
	        _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.form.clearError();
	      this.form.props.readOnly = true;
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'enableSidebar',
	    value: function enableSidebar() {
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return SkrillWithdrawalFormController;
	}(_basecontroller.BaseController);
	
	exports.default = SkrillWithdrawalFormController;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SkrillWithdrawalForm = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _transactionform = __webpack_require__(1412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkrillWithdrawalForm = exports.SkrillWithdrawalForm = function (_TransactionForm) {
	  (0, _inherits3.default)(SkrillWithdrawalForm, _TransactionForm);
	
	  function SkrillWithdrawalForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, SkrillWithdrawalForm);
	    return (0, _possibleConstructorReturn3.default)(this, (SkrillWithdrawalForm.__proto__ || (0, _getPrototypeOf2.default)(SkrillWithdrawalForm)).call(this, customerProducts, paymentOptions));
	  }
	
	  return SkrillWithdrawalForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ecopayzWithdrawalForm = __webpack_require__(1419);
	
	var _ecopayzWithdrawalForm2 = _interopRequireDefault(_ecopayzWithdrawalForm);
	
	var _ecopayzWithdrawalForm3 = __webpack_require__(1420);
	
	var _ecopayzWithdrawalForm4 = _interopRequireDefault(_ecopayzWithdrawalForm3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ecopayzWithdrawalFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _ecopayzWithdrawalForm2.default,
	  controller: _ecopayzWithdrawalForm4.default
	};
	
	exports.default = ecopayzWithdrawalFormComponent;

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white gateway-wrapper\">\n  <div class=\"flex-row mh-80 vh-center\">\n    <div class=\"p-lr-30 mtop2\" ng-if=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">\n      <ul class=\"depositForm depositForm-btc\">\n        <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.processingTime }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b>{{ $ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'Minimum Withdrawal Amount' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.minimumWithdrawal }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'Maximum Withdrawal Amount' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.maximumWithdrawal }}</li>\n      </ul>\n    </div>\n  </div>\n\n  <hr class=\"m-10\">\n\n  <div class=\"flex-row\">\n    <div class=\"col-lg-8\">\n      <form class=\"form-horizontal\" action=\"\">\n        <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n          <!--new form-->\n          <div class=\"row\">\n            <div class=\"col-lg-12\">\n              <!-- Product Panel -->\n              <div class=\"product-selection-panel p-lr bank\">\n                <!-- Email -->\n                <div class=\"row\">\n                  <div class=\"col-md-5\">\n                    <div class=\"row\">\n                      <label class=\"col-md-12\">{{ 'Account ID' | translate }}</label>\n                      <div class=\"col-md-12\">\n                        <input type=\"text\" disabled value=\"{{ $ctrl.form.email }}\" name=\"From Account ID\" class=\"form-control\" placeholder=\"{{ 'Account ID' | translate }}\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"row visible-lg visible-md\">\n                  <div class=\"col-lg-5 col-md-5\">\n                    <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-5 col-md-5\">\n                    <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-2 col-md-2\">\n                    <label class=\"control-label\">{{ 'fee' | translate }}</label>\n                  </div>\n                </div>\n                <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n                  <!-- Product -->\n                  <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                    <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n                    <select ng-model=\"subTransaction.product\" ng-init=\"oldValue=null\" ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                        ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                        ng-click=\"oldValue=subTransaction.product\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\"\n                        class=\"form-control\">\n                      <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                    </select>\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                      <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{\n                        error }}</li>\n                    </ul>\n                  </div>\n\n                  <!-- Amount-->\n                  <div class=\"col-lg-5 col-md-5 col-sm-8 col-xs-8 product-amount\">\n                    <div class=\"row\">\n                      <!-- Amount Input -->\n                      <div class=\"col-lg-12 col-md-12 col-sm-10 col-xs-12 m-b-10\">\n                        <div class=\"input-group\">\n                          <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ | async }}</span>\n                          <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\"\n                                  limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control ng-pristine ng-untouched ng-valid ng-not-empty\">\n                        </div>\n                        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                          <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{\n                            error }}</li>\n                        </ul>\n                      </div>\n                    </div>\n                  </div>\n                  \n                  <!-- Charge Fee Here -->\n                  <div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-3\">\n                    <div class=\"row\">\n                      <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                        <div class=\"checkbox checkbox-success checkbox-circle\">\n                          <input ng-model=\"subTransaction.chargeFee\" ng-click=\"$ctrl.form.chargeFeeSelected(subTransaction)\" type=\"checkbox\">\n                          <label></label>\n                        </div>\n                      </div>\n                      <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                        <button ng-click=\"$ctrl.form.removeSubTransaction(subTransaction, $index)\" ng-if=\"$ctrl.displayDeleteButton\" class=\"btn btn-danger\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <!-- Errors -->\n                <div class=\"row\">\n                  <div class=\"col-md-12\">\n                  </div>\n                </div>\n\n                <!-- Add product -->\n                <div class=\"row\">\n                  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}</button>\n                  </div>\n                </div>\n\n                <!-- Transaction Password / Request btn -->\n                <div class=\"row m-t-20\">\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                    <switch-auth switched=\"$ctrl.form.authenticationSwitched(isUsingGoogleTwoFactor)\" session=\"$ctrl.session\">\n                      <input ng-model=\"$ctrl.form.transactionPassword\" type=\"password\" class=\"form-control\">\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.transactionPassword\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.transactionPassword\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </switch-auth>\n                  </div>\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                    <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Withdrawal'\"></ladda-button>\n                    <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <!-- Sidebar --> \n    <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap ecopayz-bg active\">\n        <i class=\"fas fa-receipt visible-md visible-sm visible-xs\" type=\"button\"></i>\n        <div class=\"gateway-sidebar\">\n          <img src=\"assets/images/payment/white/ecopayz.png\" class=\"payment-option-logo\">\n          \n          <!-- Transaction Summary -->\n          <div class=\"transaction-summary\">\n            <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n            <div class=\"font-lg\">\n              <p>{{ 'Amount to deduct' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmount |number }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n\n              <p>{{ 'fee' | translate }}:<br>\n                <span class=\"bold\" ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') === 'Free'\">{{ 'Free' | translate }}</span>\n                <span class=\"bold\" ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') !== 'Free'\">{{ $ctrl.form.fee |number: 2}} {{ $ctrl.userCurrency$ |async }}</span>\n              </p>\n\n              <hr class=\"m-10\">\n\n              <p class=\"uppercase\">{{ 'Total amount to receive' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmountToBeWithdrawn }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _ecopayzWithdrawalForm = __webpack_require__(1421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EcopayzWithdrawalFormController = function (_BaseController) {
	  EcopayzWithdrawalFormController.$inject = ["WithdrawalStore", "FormService", "AppService", "$timeout"];
	  (0, _inherits3.default)(EcopayzWithdrawalFormController, _BaseController);
	
	  function EcopayzWithdrawalFormController(WithdrawalStore, FormService, AppService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EcopayzWithdrawalFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EcopayzWithdrawalFormController.__proto__ || (0, _getPrototypeOf2.default)(EcopayzWithdrawalFormController)).call(this, AppService));
	
	    _this.WithdrawalStore = WithdrawalStore;
	    _this.FormService = FormService;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(EcopayzWithdrawalFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.userCurrency$ = this.WithdrawalStore.getCurrency();
	      this.session = this.getSession();
	
	      this.form = new _ecopayzWithdrawalForm.EcopayzWithdrawalForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.email = this.selectedPaymentOption.extras.accountId;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('withdrawal');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('withdrawal');
	      this.enableSidebar();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	      var isChecked = this.form.subTransactions.filter(function (obj) {
	        return obj.chargeFee === true;
	      });
	
	      if (!isChecked.length) {
	        $('#invalidAction').modal('show');
	        this.FormService.isSubmitting.next(false);
	
	        return false;
	      }
	
	      this.WithdrawalStore.withdraw(this.form.toPayload()).then(function () {
	        return _this2.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        _this2.form.error.setFormErrors(errors);
	        _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.form.clearError();
	      this.form.props.readOnly = true;
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'enableSidebar',
	    value: function enableSidebar() {
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return EcopayzWithdrawalFormController;
	}(_basecontroller.BaseController);
	
	exports.default = EcopayzWithdrawalFormController;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EcopayzWithdrawalForm = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _transactionform = __webpack_require__(1412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EcopayzWithdrawalForm = exports.EcopayzWithdrawalForm = function (_TransactionForm) {
	  (0, _inherits3.default)(EcopayzWithdrawalForm, _TransactionForm);
	
	  function EcopayzWithdrawalForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, EcopayzWithdrawalForm);
	    return (0, _possibleConstructorReturn3.default)(this, (EcopayzWithdrawalForm.__proto__ || (0, _getPrototypeOf2.default)(EcopayzWithdrawalForm)).call(this, customerProducts, paymentOptions));
	  }
	
	  return EcopayzWithdrawalForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _netellerWithdrawalForm = __webpack_require__(1423);
	
	var _netellerWithdrawalForm2 = _interopRequireDefault(_netellerWithdrawalForm);
	
	var _netellerWithdrawalForm3 = __webpack_require__(1424);
	
	var _netellerWithdrawalForm4 = _interopRequireDefault(_netellerWithdrawalForm3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var netellerWithdrawalFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _netellerWithdrawalForm2.default,
	  controller: _netellerWithdrawalForm4.default
	};
	
	exports.default = netellerWithdrawalFormComponent;

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white gateway-wrapper\">\n  <div class=\"flex-row mh-80 vh-center\">\n    <div class=\"p-lr-30 mtop2\" ng-if=\"$ctrl.paymentOptionsViewDetails.activeDisplay\">\n      <ul class=\"depositForm depositForm-btc\">\n        <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.processingTime }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b>{{ $ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'Minimum Withdrawal Amount' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.minimumWithdrawal }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'Maximum Withdrawal Amount' | translate }}:</b> {{ $ctrl.paymentOptionsViewDetails.activeDisplay.method.withdrawal.maximumWithdrawal }}</li>\n      </ul>\n    </div>\n  </div>\n\n  <hr class=\"m-10\">\n\n  <div class=\"flex-row\">\n    <div class=\"col-lg-8\">\n      <form class=\"form-horizontal\" action=\"\">\n        <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n          <!--new form-->\n          <div class=\"row\">\n            <div class=\"col-lg-12\">\n              <!-- Product Panel -->\n              <div class=\"product-selection-panel p-lr bank\">\n                <!-- Email -->\n                <div class=\"row\">\n                  <div class=\"col-md-6\">\n                    <div class=\"row\">\n                      <label class=\"col-md-12\">{{ 'form.email' | translate }}</label>\n                      <div class=\"col-md-12\">\n                        <input type=\"email\" disabled value=\"{{ $ctrl.form.email }}\" name=\"From email\" class=\"form-control\" placeholder=\"{{ 'form.email' | translate }}\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"row visible-lg visible-md\">\n                  <div class=\"col-lg-5 col-md-5\">\n                    <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-5 col-md-5\">\n                    <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-2 col-md-2\">\n                    <label class=\"control-label\">{{ 'fee' | translate }}</label>\n                  </div>\n                </div>\n                <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n                  <!-- Product -->\n                  <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                    <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                  </div>\n                  <div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n                    <select ng-model=\"subTransaction.product\" ng-init=\"oldValue=null\" ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                            ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                            ng-click=\"oldValue=subTransaction.product\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\"\n                            class=\"form-control\">\n                      <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                    </select>\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                      <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{\n                        error }}</li>\n                    </ul>\n                  </div>\n\n                  <!-- Amount-->\n                  <div class=\"col-lg-5 col-md-5 col-sm-8 col-xs-8 product-amount\">\n                    <div class=\"row\">\n                      <!-- Amount Input -->\n                      <div class=\"col-lg-12 col-md-12 col-sm-10 col-xs-12 m-b-10\">\n                        <div class=\"input-group\">\n                          <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ | async }}</span>\n                          <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\"\n                                  limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control ng-pristine ng-untouched ng-valid ng-not-empty\">\n                        </div>\n                        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                          <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{\n                            error }}</li>\n                        </ul>\n                      </div>\n                    </div>\n                  </div>\n                  \n                  <!-- Charge Fee Here -->\n                  <div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-3\">\n                    <div class=\"row\">\n                      <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                        <div class=\"checkbox checkbox-success checkbox-circle\">\n                          <input ng-model=\"subTransaction.chargeFee\" ng-click=\"$ctrl.form.chargeFeeSelected(subTransaction)\" type=\"checkbox\">\n                          <label></label>\n                        </div>\n                      </div>\n                      <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                        <button ng-click=\"$ctrl.form.removeSubTransaction(subTransaction, $index)\" ng-if=\"$ctrl.displayDeleteButton\" class=\"btn btn-danger\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <!-- Errors -->\n                <div class=\"row\">\n                  <div class=\"col-md-12\">\n                  </div>\n                </div>\n\n                <!-- Add product -->\n                <div class=\"row\">\n                  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}</button>\n                  </div>\n                </div>\n\n                <!-- Transaction Password / Request btn -->\n                <div class=\"row m-t-20\">\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                    <switch-auth switched=\"$ctrl.form.authenticationSwitched(isUsingGoogleTwoFactor)\" session=\"$ctrl.session\">\n                      <input ng-model=\"$ctrl.form.transactionPassword\" type=\"password\" class=\"form-control\">\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.transactionPassword\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.transactionPassword\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </switch-auth>\n                  </div>\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                    <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Withdrawal'\"></ladda-button>\n                    <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <!-- Sidebar -->\n    <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap neteller-bg active\">\n        <i class=\"fas fa-receipt visible-md visible-sm visible-xs\" type=\"button\"></i>\n        <div class=\"gateway-sidebar\">\n          <img src=\"assets/images/payment/white/neteller.png\" class=\"payment-option-logo\">\n          \n          <!-- Transaction Summary -->\n          <div class=\"transaction-summary\">\n            <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n            <div class=\"font-lg\">\n              <p>{{ 'Amount to deduct' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmount |number }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n\n              <p>{{ 'fee' | translate }}:<br>\n                <span class=\"bold\" ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') === 'Free'\">{{ 'Free' | translate }}</span>\n                <span class=\"bold\" ng-if=\"$ctrl.paymentOptionsViewDetails.feeDisplayFor('withdrawal') !== 'Free'\">{{ $ctrl.form.fee |number: 2}} {{ $ctrl.userCurrency$ |async }}</span>\n              </p>\n\n              <hr class=\"m-10\">\n\n              <p class=\"uppercase\">{{ 'Total amount to receive' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmountToBeWithdrawn }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _netellerWithdrawalForm = __webpack_require__(1425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetellerWithdrawalFormController = function (_BaseController) {
	  NetellerWithdrawalFormController.$inject = ["WithdrawalStore", "FormService", "AppService", "$timeout"];
	  (0, _inherits3.default)(NetellerWithdrawalFormController, _BaseController);
	
	  function NetellerWithdrawalFormController(WithdrawalStore, FormService, AppService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NetellerWithdrawalFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NetellerWithdrawalFormController.__proto__ || (0, _getPrototypeOf2.default)(NetellerWithdrawalFormController)).call(this, AppService));
	
	    _this.WithdrawalStore = WithdrawalStore;
	    _this.FormService = FormService;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(NetellerWithdrawalFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.userCurrency$ = this.WithdrawalStore.getCurrency();
	      this.session = this.getSession();
	
	      this.form = new _netellerWithdrawalForm.NetellerWithdrawalForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.email = this.selectedPaymentOption.email;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('withdrawal');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('withdrawal');
	      this.enableSidebar();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	      var isChecked = this.form.subTransactions.filter(function (obj) {
	        return obj.chargeFee === true;
	      });
	
	      if (!isChecked.length) {
	        $('#invalidAction').modal('show');
	        this.FormService.isSubmitting.next(false);
	
	        return false;
	      }
	
	      this.WithdrawalStore.withdraw(this.form.toPayload()).then(function () {
	        return _this2.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        _this2.form.error.setFormErrors(errors);
	        _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.form.clearError();
	      this.form.props.readOnly = true;
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'enableSidebar',
	    value: function enableSidebar() {
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return NetellerWithdrawalFormController;
	}(_basecontroller.BaseController);
	
	exports.default = NetellerWithdrawalFormController;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetellerWithdrawalForm = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _transactionform = __webpack_require__(1412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetellerWithdrawalForm = exports.NetellerWithdrawalForm = function (_TransactionForm) {
	  (0, _inherits3.default)(NetellerWithdrawalForm, _TransactionForm);
	
	  function NetellerWithdrawalForm(customerProducts, paymentOptions) {
	    (0, _classCallCheck3.default)(this, NetellerWithdrawalForm);
	    return (0, _possibleConstructorReturn3.default)(this, (NetellerWithdrawalForm.__proto__ || (0, _getPrototypeOf2.default)(NetellerWithdrawalForm)).call(this, customerProducts, paymentOptions));
	  }
	
	  return NetellerWithdrawalForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bitcoinWithdrawalForm = __webpack_require__(1427);
	
	var _bitcoinWithdrawalForm2 = _interopRequireDefault(_bitcoinWithdrawalForm);
	
	var _bitcoinWithdrawalForm3 = __webpack_require__(1428);
	
	var _bitcoinWithdrawalForm4 = _interopRequireDefault(_bitcoinWithdrawalForm3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bitcoinWithdrawalFormComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    details: '<',
	    selectedPaymentOption: '<'
	  },
	  template: _bitcoinWithdrawalForm2.default,
	  controller: _bitcoinWithdrawalForm4.default
	};
	
	exports.default = bitcoinWithdrawalFormComponent;

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ac-white gateway-wrapper\">\n  <div class=\"flex-row mh-80 vh-center\">\n    <div class=\"p-lr-30 mtop2\">\n      <ul class=\"depositForm depositForm-btc\">\n        <li><i class=\"fa fa-check\"></i><b>{{ 'processingTime' | translate }}:</b> 3 {{ 'confirmations' | translate }}</li>\n        <li><i class=\"fa fa-check\"></i><b>{{ 'fee' | translate }}:</b> {{ 'Free' | translate }}</li>\n        <li ng-if=\"$ctrl.bitcoinRate\"><i class=\"fa fa-check\"></i><b>{{ 'Minimum Withdrawal Amount' | translate }}:</b> {{ $ctrl.bitcoinRate.config.formattedMinimumAllowedWithdrawal }} BTC</li>\n        <li ng-if=\"$ctrl.bitcoinRate\"><i class=\"fa fa-check\"></i><b>{{ 'Maximum Withdrawal Amount' | translate }}:</b> {{ $ctrl.bitcoinRate.config.formattedMaximumAllowedWithdrawal }} BTC</li>\n      </ul>\n    </div>\n  </div>\n\n  <hr class=\"m-10\">\n  \n  <div class=\"flex-row\">\n    <div class=\"col-lg-8\">\n      <div ng-show=\"!$ctrl.form.props.isReady\" class=\"loader\"></div>\n      <form ng-show=\"$ctrl.form.props.isReady\" class=\"form-horizontal p-lr\" action=\"\">\n        <div ng-hide=\"!$ctrl.paymentOptionsViewDetails.activeDisplay\">\n          <div class=\"alert alert-success custom-notif\">\n            {{ 'Please select product(s) where you want to withdraw, and input the amount in' | translate }} {{ $ctrl.userCurrency$ | async }} {{ 'or BTC' | translate }}.\n          </div>         <!-- Initial Withdrawal form -->\n          <div class=\"col-lg-12\">\n            <!-- Product Panel -->\n            <div class=\"product-selection-panel\">\n              <div class=\"row visible-lg visible-md\">\n                <div class=\"col-lg-4 col-md-4\">\n                  <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n                </div>\n                <div class=\"col-lg-8 col-md-8\">\n                  <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n                </div>\n              </div>\n\n              <!-- Product Field, BTC Field -->\n              <div class=\"row m-b-10-mobile\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n\n                <!-- Product -->\n                <div class=\"visible-sm visible-xs col-sm-12 col-xs-12\">\n                  <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n                </div>\n                <div class=\"col-lg-4 col-md-4 col-sm-11 col-xs-10 m-b-10\">\n                  <select ng-model=\"subTransaction.product\" ng-init=\"oldValue=null\" ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue)\"\n                          ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n                          ng-click=\"oldValue=subTransaction.product\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\"\n                          class=\"form-control\">\n                    <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                  </select>\n                  <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('product', subTransaction.key)\">\n                    <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('product', subTransaction.key)\" class=\"parsley-required\">{{\n                      error }}</li>\n                  </ul>\n                </div>\n\n                <!-- Amount & BTC -->\n                <div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12 product-amount\">\n                  <div class=\"row\">\n\n                    <!-- BTC Input -->\n                    <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 m-b-10\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon bg-primary text-white\">BTC</span>\n                        <input ng-blur=\"$ctrl.formatBTC(subTransaction)\" ng-change=\"$ctrl.onWithdrawalBtcInputChanged()\" ng-model=\"subTransaction.btc\" ng-disabled=\"$ctrl.form.isReadOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\" limit=\"22\" precision=\"5\" type=\"text\" class=\"form-control\">\n                      </div>\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.bitcoin(subTransaction.key)\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.bitcoin(subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </div>\n\n                    <!-- Amount Input -->\n                    <div class=\"col-lg-5 col-md-5 col-sm-6 col-xs-12 m-b-10\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon bg-primary text-white\"> {{ $ctrl.userCurrency$ | async }}</span>\n                        <input ng-blur=\"$ctrl.formatAmount(subTransaction)\" ng-change=\"$ctrl.onWithdawalAmountInputChanged()\" ng-model=\"subTransaction.amount\" ng-disabled=\"$ctrl.form.isReadOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('amount', {{ subTransaction.key }}) }\" limit=\"22\" precision=\"2\" type=\"text\" class=\"form-control\">\n                      </div>\n                      <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.subTransaction('amount', subTransaction.key)\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.error.subTransaction('amount', subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>\n                    </div>\n\n                    <!-- Cancel/Delete Button ng-if=\"$ctrl.displayDeleteButton\"-->\n                    <div class=\"visible-md visible-lg col-lg-1 col-md-1\">\n                      <button ng-hide=\"$ctrl.form.isReadOnly\" ng-click=\"$ctrl.removeSubTransaction(subTransaction, $index)\" class=\"btn btn-danger\" ng-disabled=\"!$ctrl.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <!-- Add Product btn -->\n              <div class=\"row\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                  <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\"><i class=\"fa fa-plus\"></i>{{ ' Add product' | translate }}</button>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right total-withdrawal-btc\">\n                  <p>{{ 'Total BTC' | translate }}: {{ $ctrl.form.totalBtc }}</p>\n                </div>\n              </div>\n\n              <div class=\"row recipient-cls p-t-30 mbot3\">\n                <!-- Recipient -->\n                <div class=\"col-lg-3\">\n                  <p>{{ 'SEND TO' | translate }}:</p>\n                </div>\n                <div class=\"col-lg-9 send-cls m-b-10\">\n                  <input ng-model=\"$ctrl.form.receiverAddress\" placeholder=\"{{ 'Paste an address where you want to receive BTC' | translate }}\" type=\"text\" class=\"form-control\">\n                  <small>{{ 'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.' | translate }}</small>\n                  <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.accountId\">\n                    <li ng-repeat=\"(key, error) in $ctrl.form.error.accountId\" class=\"parsley-required\">{{ error }}</li>\n                  </ul>\n                </div>\n              </div>\n              \n              <!-- Transaction Password / Request btn -->\n              <div class=\"row m-t-20\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                  <switch-auth switched=\"$ctrl.form.authenticationSwitched(isUsingGoogleTwoFactor)\" session=\"$ctrl.session\">\n                    <input ng-model=\"$ctrl.form.transactionPassword\" type=\"password\" class=\"form-control\">\n                    <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.transactionPassword\">\n                      <li ng-repeat=\"(key, error) in $ctrl.form.error.transactionPassword\" class=\"parsley-required\">{{ error }}</li>\n                    </ul>\n                  </switch-auth>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n                  <ladda-button ng-hide=\"$ctrl.form.props.readOnly === true\" on-click=\"$ctrl.submit()\" text=\"'Request Withdrawal'\"></ladda-button>\n                  <button ng-show=\"$ctrl.form.props.readOnly === true\" ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-success waves-effect waves-light ladda-button\">{{ 'Make new request' | translate }}</button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap bitcoin-bg active\">\n        <i class=\"fas fa-receipt visible-md visible-xs visible-sm\" type=\"button\"></i>\n        <div class=\"gateway-sidebar\">\n          <img src=\"assets/images/payment/white/bitcoin.png\" class=\"payment-option-logo\">\n\n          <!-- BTC EXchange Rate -->\n          <h4 class=\"ac-white-text text-center uppercase m-b-0\">{{ 'Exchange Rate' | translate }}</h4>\n          <div class=\"exchange-rate\">\n            <h4 class=\"ac-white-text text-center uppercase bold m-t-0\">\n              1 BTC = <span id=\"btc-adjusted-value\">{{ $ctrl.bitcoinRate.initialRate }}</span>\n            </h4>\n          </div>\n\n          <hr class=\"m-10\">\n\n          <!-- Transaction Summary -->\n          <div class=\"transaction-summary\">\n            <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n            <div class=\"font-lg\">\n              <span>{{ 'Total BTC amount to receive' | translate }}:\n                <p class=\"bold\">{{ $ctrl.form.totalBtc }} BTC</p>\n              </span>\n\n              <span>{{ 'Total' | translate }} {{ $ctrl.userCurrency$ | async }} {{ 'amount to be deducted' | translate }}:\n                <p class=\"bold\">{{ $ctrl.form.totalAmountToBeWithdrawn }} {{ $ctrl.userCurrency$ | async }}</p>\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(1100);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _bitcoinWithdrawalForm = __webpack_require__(1429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BitcoinWithdrawalFormController = function (_BaseController) {
	  BitcoinWithdrawalFormController.$inject = ["AppService", "WithdrawalStore", "FormService", "PaymentOptionApiService", "TransactionApiService", "$timeout", "$document"];
	  (0, _inherits3.default)(BitcoinWithdrawalFormController, _BaseController);
	
	  function BitcoinWithdrawalFormController(AppService, WithdrawalStore, FormService, PaymentOptionApiService, TransactionApiService, $timeout, $document) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BitcoinWithdrawalFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BitcoinWithdrawalFormController.__proto__ || (0, _getPrototypeOf2.default)(BitcoinWithdrawalFormController)).call(this, AppService));
	
	    _this.WithdrawalStore = WithdrawalStore;
	    _this.FormService = FormService;
	    _this.PaymentOptionApiService = PaymentOptionApiService;
	    _this.TransactionApiService = TransactionApiService;
	    _this.$timeout = $timeout;
	    _this.$document = $document;
	
	    _this.bitcoinRate = null;
	    _this.bitcoinTransaction == null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(BitcoinWithdrawalFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.userCurrency$ = this.WithdrawalStore.getCurrency();
	      this.session = this.getSession();
	
	      this.form = new _bitcoinWithdrawalForm.BitcoinWithdrawalForm(this.details.customerProducts, this.details.paymentOptions);
	      this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
	      this.form.receiverAddress = this.selectedPaymentOption.extras.accountId;
	      this.form.paymentOption = this.selectedPaymentOption.id;
	      this.form.paymentOptionType = this.selectedPaymentOption.type;
	      this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('withdrawal');
	      this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('withdrawal');
	      this.enableSidebar();
	
	      this.addListener(_events2.default.BTC_EXCHANGE_RATE, function (event) {
	        if (event.bitcoinRate.type === 'withdrawal') {
	          _this2.form.bitcoinRate = event.bitcoinRate;
	          _this2.bitcoinRate = event.bitcoinRate;
	          _this2.blinkExchangeRate();
	          _this2.onWithdrawalBtcInputChanged();
	        }
	      });
	
	      // Display the form when all the promises has been completed.
	      _promise2.default.all([this.getBitcoinRate()]).then(function (values) {
	        _this2.form.props.isReady = true;
	      });
	    }
	
	    // This would handle the initial display when loading the Bitcoin Form.
	
	  }, {
	    key: 'getBitcoinRate',
	    value: function getBitcoinRate() {
	      var _this3 = this;
	
	      return this.PaymentOptionApiService.getBitcoinWithdrawalAdjustment().then(function (bitcoinRate) {
	        _this3.bitcoinRate = bitcoinRate;
	        // TODO: Do not set bitcoinRate on form.
	        _this3.form.bitcoinRate = bitcoinRate;
	      });
	    }
	  }, {
	    key: 'checkForActiveBitcoinTransaction',
	    value: function checkForActiveBitcoinTransaction() {
	      var _this4 = this;
	
	      return this.TransactionApiService.checkForActiveBitcoinTransaction().then(function (bitcoinTransaction) {
	        _this4.bitcoinTransaction = bitcoinTransaction;
	      });
	    }
	  }, {
	    key: 'enableSidebar',
	    value: function enableSidebar() {
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'onWithdrawalBtcInputChanged',
	    value: function onWithdrawalBtcInputChanged() {
	      var adjustedRate = this.form.getBtcAdjustedRate(this.bitcoinRate);
	      var btcAdjustedDisplay = document.getElementById('btc-adjusted-value');
	      btcAdjustedDisplay.innerHTML = adjustedRate;
	
	      this.form.computeAmountConversion(adjustedRate);
	    }
	  }, {
	    key: 'onWithdawalAmountInputChanged',
	    value: function onWithdawalAmountInputChanged() {
	      var adjustedRate = this.form.getBtcAdjustedRateFromTotalAmount(this.bitcoinRate);
	      var btcAdjustedDisplay = document.getElementById('btc-adjusted-value');
	      btcAdjustedDisplay.innerHTML = adjustedRate;
	
	      this.form.computeBitcoinConversion(adjustedRate);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this5 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.WithdrawalStore.withdraw(this.form.toPayload(this.bitcoinRate)).then(function () {
	        return _this5.handleSuccessfulSubmission();
	      }).catch(function (errors) {
	        _this5.form.error.setFormErrors(errors);
	        _this5.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'handleSuccessfulSubmission',
	    value: function handleSuccessfulSubmission() {
	      this.FormService.isSubmitting.next(false);
	      this.form.clearError();
	      this.form.props.readOnly = true;
	      this.onSuccessfulSubmission({ form: this.form, viewDetails: this.paymentOptionsViewDetails });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.form.removeSubTransaction(subTransaction, index);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(subTransaction) {
	      return subTransaction.amount = parseFloat(subTransaction.amount);
	    }
	  }, {
	    key: 'formatBTC',
	    value: function formatBTC(subTransaction) {
	      return subTransaction.btc = parseFloat(subTransaction.btc);
	    }
	  }, {
	    key: 'blinkExchangeRate',
	    value: function blinkExchangeRate() {
	      var _this6 = this;
	
	      var exchangeRate = document.getElementsByClassName('exchange-rate')[0];
	      exchangeRate.classList.add('blinking');
	
	      var seconds = 0;
	
	      this.blinkInterval = setInterval(function () {
	        seconds += 1000;
	
	        if (seconds === 2000) {
	          exchangeRate.classList.remove('blinking');
	          clearInterval(_this6.blinkInterval);
	        }
	      }, 2000);
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return BitcoinWithdrawalFormController;
	}(_basecontroller.BaseController);
	
	exports.default = BitcoinWithdrawalFormController;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BitcoinWithdrawalForm = undefined;
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1188);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _number = __webpack_require__(1203);
	
	var _transactionform = __webpack_require__(1412);
	
	var _bitcoinRate = __webpack_require__(1220);
	
	var _number2 = __webpack_require__(1203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BitcoinWithdrawalForm = exports.BitcoinWithdrawalForm = function (_TransactionForm) {
	    (0, _inherits3.default)(BitcoinWithdrawalForm, _TransactionForm);
	
	    function BitcoinWithdrawalForm(customerProducts, paymentOptions) {
	        (0, _classCallCheck3.default)(this, BitcoinWithdrawalForm);
	        return (0, _possibleConstructorReturn3.default)(this, (BitcoinWithdrawalForm.__proto__ || (0, _getPrototypeOf2.default)(BitcoinWithdrawalForm)).call(this, customerProducts, paymentOptions));
	    }
	
	    (0, _createClass3.default)(BitcoinWithdrawalForm, [{
	        key: 'getBtcAdjustedRate',
	        value: function getBtcAdjustedRate(bitcoinRate) {
	            return bitcoinRate.computeAdjustedRate(this.totalBtc);
	        }
	    }, {
	        key: 'getBtcAdjustedRateFromTotalAmount',
	        value: function getBtcAdjustedRateFromTotalAmount(bitcoinRate) {
	            return bitcoinRate.computeAdjustedRateFromAmount(this.totalAmount);
	        }
	    }, {
	        key: 'computeAmountConversion',
	        value: function computeAmountConversion(btcAdjustedRate) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(this.subTransactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var subTransaction = _step.value;
	
	                    subTransaction.convertBtcToAmount(btcAdjustedRate);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'computeBitcoinConversion',
	        value: function computeBitcoinConversion(btcAdjustedRate) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = (0, _getIterator3.default)(this.subTransactions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var subTransaction = _step2.value;
	
	                    subTransaction.convertAmountToBtc(btcAdjustedRate);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            (0, _get3.default)(BitcoinWithdrawalForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(BitcoinWithdrawalForm.prototype), 'reset', this).call(this);
	
	            this.props.isReady = true;
	            this.props.isSubmitting = false;
	        }
	
	        /**
	         * @override
	         */
	
	    }, {
	        key: 'toPayload',
	        value: function toPayload(bitcoinRate) {
	            var range = bitcoinRate.getRange(this.totalBtc);
	
	            var payload = {
	                transaction: {
	                    paymentDetails: {
	                        rateDetails: {
	                            rangeStart: _bitcoinRate.Range.formatDecimal(range.start),
	                            rangeEnd: _bitcoinRate.Range.formatDecimal(range.end),
	                            adjustment: range.getAdjustment(bitcoinRate.latestBaseRate),
	                            adjustmentType: range.adjustmentType
	                        },
	                        rate: this.getBtcAdjustedRate(bitcoinRate),
	                        blockchainRate: bitcoinRate.latestBaseRate.value()
	                    },
	                    accountId: this.receiverAddress,
	                    usingGoogleAuthPassword: this.isUsingGoogleTwoFactor,
	                    transactionPassword: this.transactionPassword
	                }
	            };
	
	            var subTransactions = {};
	
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = (0, _getIterator3.default)(this.subTransactions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var subTransaction = _step3.value;
	
	                    subTransactions[subTransaction.key] = {
	                        product: subTransaction.product,
	                        amount: subTransaction.amount,
	                        forFee: subTransaction.forFee,
	                        paymentDetails: {
	                            bitcoin: subTransaction.btc
	                        }
	                    };
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                        _iterator3.return();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	
	            payload['transaction']['subTransactions'] = subTransactions;
	            payload['transaction']['paymentOption'] = this.paymentOption;
	            payload['transaction']['paymentOptionType'] = this.paymentOptionType;
	            payload['transaction']['customerFee'] = '0';
	
	            return payload;
	        }
	    }, {
	        key: 'totalAmount',
	
	
	        /**
	         * @override
	         */
	        get: function get() {
	            var totalAmount = (0, _numeral2.default)(0);
	
	            angular.forEach(this.subTransactions, function (subTransaction) {
	                totalAmount.add(subTransaction.amount);
	            });
	
	            return totalAmount.format(_number2.DEFAULT_DECIMAL_FORMAT);
	        }
	    }, {
	        key: 'totalBtc',
	        get: function get() {
	            var totalBtc = (0, _numeral2.default)(0);
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = (0, _getIterator3.default)(this.subTransactions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var subTransaction = _step4.value;
	
	                    totalBtc.add(subTransaction.btc);
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	
	            return (0, _number.format)(totalBtc, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	        }
	    }], [{
	        key: 'fill',
	        value: function fill(customerProducts, paymentOptions, subTransactions) {
	            var form = new BitcoinDepositForm(customerProducts, paymentOptions);
	
	            // Empty subtransactions before filling cause there is always one default subtransaction when the form is created.
	            form.subTransactions = [];
	
	            var _iteratorNormalCompletion5 = true;
	            var _didIteratorError5 = false;
	            var _iteratorError5 = undefined;
	
	            try {
	                for (var _iterator5 = (0, _getIterator3.default)(subTransactions), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                    var subTransaction = _step5.value;
	
	                    var subTransactionForm = form.addSubTransaction();
	
	                    subTransactionForm.amount = subTransaction.amount.value();
	                    subTransactionForm.btc = subTransaction.btc.value();
	                    subTransactionForm.product = subTransaction.customerProduct.id;
	                }
	            } catch (err) {
	                _didIteratorError5 = true;
	                _iteratorError5 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                        _iterator5.return();
	                    }
	                } finally {
	                    if (_didIteratorError5) {
	                        throw _iteratorError5;
	                    }
	                }
	            }
	
	            form.props.readOnly = true;
	            form.props.isReady = true;
	
	            return form;
	        }
	    }]);
	    return BitcoinWithdrawalForm;
	}(_transactionform.TransactionForm);

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.switchAuth = switchAuth;
	
	var _switchAuth = __webpack_require__(1431);
	
	var _switchAuth2 = _interopRequireDefault(_switchAuth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function switchAuth() {
	  return {
	    restrict: 'E',
	    transclude: true,
	    replace: true,
	    scope: {
	      session: '=',
	      switched: '&'
	    },
	    link: function link(scope, element, attrs) {
	      var session = scope.session;
	      var input = element.find('input')[0];
	
	      if (session.hasTransactionPasswordEnabled) {
	        input.placeholder = scope.placeholder = 'Enter Transaction Password';
	      }
	
	      if (session.isUsingGoogleTwoFactor) {
	        input.placeholder = scope.placeholder = 'Enter G-Auth Code';
	      }
	
	      scope.isUsingGoogleTwoFactor = scope.session.isUsingGoogleTwoFactor;
	      scope.shouldShowSwitch = scope.session.hasSetupAllTransactionAuthentication();
	
	      scope.switched({ isUsingGoogleTwoFactor: scope.isUsingGoogleTwoFactor });
	      scope.switchAuthenticationMode = function () {
	        scope.isUsingGoogleTwoFactor = !scope.isUsingGoogleTwoFactor;
	        input.placeholder = scope.isUsingGoogleTwoFactor ? 'Enter G-Auth Code' : 'Enter Transaction Password';
	        scope.switched({ isUsingGoogleTwoFactor: scope.isUsingGoogleTwoFactor });
	      };
	    },
	    template: _switchAuth2.default
	  };
	};
	
	exports.default = switchAuth;

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <ng-transclude></ng-transclude>\n\n  <a ng-show=\"shouldShowSwitch\" ng-click=\"switchAuthenticationMode()\" class=\"pull-right font-sm\">{{ isUsingGoogleTwoFactor ? 'You are using Google Authenticator. Use Transaction Password instead.' : 'You are using Transaction Password. Use Google Authenticator instead.'}}</a>\n</div>"

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	var _paymentOptionsView = __webpack_require__(1244);
	
	var _paymentOption = __webpack_require__(1246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithdrawalStore = function () {
	  WithdrawalStore.$inject = ["TransactionApiService", "StorageService", "SessionService"];
	  function WithdrawalStore(TransactionApiService, StorageService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, WithdrawalStore);
	    this.TransactionApiService = TransactionApiService;
	    this.StorageService = StorageService;
	    this.SessionService = SessionService;
	  }
	
	  /**
	   * @returns {Observable}
	   */
	
	
	  (0, _createClass3.default)(WithdrawalStore, [{
	    key: 'getWithdrawDetails',
	    value: function getWithdrawDetails() {
	      var details$ = _Rx2.default.Observable.fromPromise(this.TransactionApiService.withdrawDetails());
	
	      return details$.map(function (details) {
	        return {
	          paymentOptionsViewDetails: (0, _paymentOptionsView.makePaymentOptionsViewDetails)(details.paymentOptionsDisplay),
	          customerProducts: details.customerProducts,
	          paymentOptions: (0, _paymentOption.makePaymentOptions)(details.paymentOptions)
	        };
	      });
	    }
	  }, {
	    key: 'getPaymentOptions',
	    value: function getPaymentOptions() {
	      return this.TransactionApiService.withdrawDetails().then(function (details) {
	        return (0, _paymentOption.makePaymentOptions)(details.paymentOptions);
	      });
	    }
	
	    /**
	     * @returns {Observable}
	     */
	
	  }, {
	    key: 'getCustomerProducts',
	    value: function getCustomerProducts() {
	      return this.getWithdrawDetails().map(function (details) {
	        return details.customerProducts;
	      });
	    }
	
	    /**
	     * @returns {Observable}
	     */
	
	  }, {
	    key: 'getCurrency',
	    value: function getCurrency() {
	      return this.SessionService.session.map(function (session) {
	        return session ? session.currency : null;
	      });
	    }
	  }, {
	    key: 'withdraw',
	    value: function withdraw(payload) {
	      return this.TransactionApiService.withdraw(payload);
	    }
	  }, {
	    key: 'getStatus',
	    value: function getStatus() {
	      return this.TransactionApiService.condition();
	    }
	  }]);
	  return WithdrawalStore;
	}();
	
	exports.default = WithdrawalStore;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _productwallet = __webpack_require__(1434);
	
	var _productwallet2 = _interopRequireDefault(_productwallet);
	
	var _form = __webpack_require__(1437);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _successModal = __webpack_require__(1442);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _productWallet = __webpack_require__(1445);
	
	var _productWallet2 = _interopRequireDefault(_productWallet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productwalletModule = _angular2.default.module('productwallet', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('productwallet', {
	    parent: 'standardLayout',
	    url: '/transactions/product-wallet',
	    component: 'productwallet',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('productwallet', _productwallet2.default).component('walletForm', _form2.default).component('transferSuccessModal', _successModal2.default).service('ProductWalletStore', _productWallet2.default).name;
	
	exports.default = productwalletModule;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productwallet = __webpack_require__(1435);
	
	var _productwallet2 = _interopRequireDefault(_productwallet);
	
	var _productwallet3 = __webpack_require__(1436);
	
	var _productwallet4 = _interopRequireDefault(_productwallet3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productwalletComponent = {
	  bindings: {
	    customerProducts: '<'
	  },
	  template: _productwallet2.default,
	  controller: _productwallet4.default
	};
	
	exports.default = productwalletComponent;

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"row mbot3\">\n        <div class=\"col-md-12\">\n          <h2 class=\"no-m\">{{ 'titles.transaction' | translate }}</h2>\n          <h4 class=\"no-m text-dark\">{{ 'titles.productWallet' | translate }}</h4>\n        </div>\n      </div>\n      <div class=\"row\">\n          <div class=\"col-lg-9 col-md-8 col-sm-12 fadeIn animated index-one mbot3\">\n            <div class=\"card-box\">\n              <wallet-form on-successful-submission=\"$ctrl.onSuccessfulSubmission()\"></wallet-form>\n            </div>\n          </div>\n          <div class=\"col-lg-3 col-md-4 col-sm-12 fadeIn animated index-zero\">\n            <customer-product-widget on-customer-products-loaded=\"$ctrl.onCustomerProductsLoaded(customerProductsList)\"></customer-product-widget>\n          </div>\n      </div>\n    </div>\n  </div>\n</div>\n<transfer-success-modal on-closed=\"$ctrl.finishTransaction()\"></transfer-success-modal>\n<request-product-modal></request-product-modal>\n<product-password-widget></product-password-widget>\n"

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _basecontroller = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductwalletController = function (_BaseController) {
	  ProductwalletController.$inject = ["AppService", "ProductWalletStore", "PageService", "$timeout"];
	  (0, _inherits3.default)(ProductwalletController, _BaseController);
	
	  function ProductwalletController(AppService, ProductWalletStore, PageService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProductwalletController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductwalletController.__proto__ || (0, _getPrototypeOf2.default)(ProductwalletController)).call(this, AppService));
	
	    _this.ProductWalletStore = ProductWalletStore;
	    _this.PageService = PageService;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(ProductwalletController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.removeSettingsHighlight();
	      this.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this2.refreshCustomerProducts();
	      });
	      this.addListener(_events2.default.TRANSACTION_PROCESSED, function (event) {
	        return _this2.refreshCustomerProducts();
	      });
	    }
	  }, {
	    key: 'onSuccessfulSubmission',
	    value: function onSuccessfulSubmission() {
	      this.PageService.showModal('successModal');
	    }
	  }, {
	    key: 'finishTransaction',
	    value: function finishTransaction() {
	      this.PageService.goto('overview');
	    }
	  }, {
	    key: 'refreshCustomerProducts',
	    value: function refreshCustomerProducts() {
	      this.broadcast('reload.customer-products');
	    }
	  }, {
	    key: 'removeSettingsHighlight',
	    value: function removeSettingsHighlight() {
	      this.$timeout(function () {
	        $('#settings').removeClass('subdrop');
	      }, 100);
	    }
	  }]);
	  return ProductwalletController;
	}(_basecontroller.BaseController);
	
	exports.default = ProductwalletController;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1438);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1439);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	module.exports = "<div loading=\"$ctrl.form.customerProducts\"></div>\n<div class=\"flex-row\">\n  <div class=\"col-lg-8\">\n    <form ng-if=\"$ctrl.form.customerProducts\" class=\"form-horizontal product-wallet\" action=\"\">\n      <!-- From Product -->\n      <div class=\"row\">\n        <div class=\"col-lg-6 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n          <label class=\"control-label\">{{ 'form.fromProduct' | translate }}: *</label>\n          <select\n            ng-model=\"$ctrl.form.fromProduct\"\n            ng-init=\"oldValue=null\"\n            ng-change=\"$ctrl.form.onChangedFromCustomerProduct($ctrl.form.fromProduct, oldValue); $ctrl.createTransactionSummary()\"\n            ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in $ctrl.form.clonedCustomerProducts\"\n            ng-click=\"oldValue=$ctrl.form.fromProduct\"\n            ng-class=\"{ 'parsley-error': $ctrl.form.error.from }\"\n            class=\"form-control\">\n            <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n          </select>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.from\">\n            <li ng-repeat=\"error in $ctrl.form.error.from\" class=\"parsley-required\">{{ error }}</li>\n          </ul>\n        </div>\n      </div>\n\n      <!-- Desktop label -->\n      <div class=\"row visible-lg visible-md\">\n        <div class=\"col-lg-6 col-md-5\">\n          <label class=\"control-label\">{{ 'Product Name' | translate }}</label>\n        </div>\n        <div class=\"col-lg-5 col-md-5\">\n          <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n        </div>\n      </div>\n\n      <div ng-if=\"$ctrl.form.canAddProduct\" class=\"row \" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n\n        <!-- To Product -->\n        <div class=\"col-lg-6 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n          <!-- Mobile label -->\n          <div class=\"visible-sm visible-xs\">\n            <label class=\"control-label m-b-0\">{{ 'Product Name' | translate }}</label>\n          </div>\n          <select\n            ng-model=\"subTransaction.product\"\n            ng-init=\"oldValue=null\"\n            ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue); $ctrl.createTransactionSummary()\"\n            ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subTransaction.customerProducts\"\n            ng-click=\"oldValue=subTransaction.product\"\n            ng-class=\"{ 'parsley-error': $ctrl.form.error.subTransaction('product', {{ subTransaction.key }}) }\"\n            class=\"form-control\">\n              <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n          </select>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.to('product', subTransaction.key)\">\n              <li ng-repeat=\"error in $ctrl.form.error.to('product', subTransaction.key)\" class=\"parsley-required\">\n                {{ error }}\n              </li>\n            </ul>\n        </div>\n\n        <!-- Amount -->\n        <div class=\"col-lg-5 col-md-5 col-sm-11 col-xs-10 m-b-10\">\n          <div class=\"input-group\">\n            <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ | async }}</span>\n            <input ng-model=\"subTransaction.amount\" ng-class=\"{ 'parsley-error': $ctrl.form.error.to('amount', {{ subTransaction.key }}) }\" limit=\"6\" precision=\"2\" type=\"text\" class=\"form-control\">\n          </div>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.to('amount', subTransaction.key)\">\n            <li ng-repeat=\"error in $ctrl.form.error.to('amount', subTransaction.key)\" class=\"parsley-required\">{{ error }}</li>\n          </ul>\n        </div>\n\n        <!-- Remove product row -->\n        <div class=\"col-lg-1 col-md-2 col-sm-1 col-xs-2\">\n          <button ng-click=\"$ctrl.form.removeSubTransaction(subTransaction);$ctrl.createTransactionSummary();\" class=\"btn btn-danger\" ng-disabled=\"!$ctrl.form.displayDeleteButton\" ng-attr-disabled=\"{{ true ? 'disabled' : '' }}\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n        </div>\n      </div>\n      <div class=\"row total-amount\">\n        <!-- Add another product -->\n        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n          <button ng-if=\"$ctrl.form.canAddProduct\" ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\">\n            <i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}\n          </button>\n        </div>\n\n        <!-- Submit Button -->\n        <div class=\"col-md-6 col-sm-6 col-xs-12 text-right bank-request\">\n          <ladda-button on-click=\"$ctrl.submit()\" text=\"'Request Transfer'\" ladda-disable=\"(!$ctrl.form.isValid) || ($ctrl.FormService.isSubmitting | async) === true\"></ladda-button>\n        </div>\n\n        <!-- Empty product -->\n        <div ng-if=\"!$ctrl.form.canAddProduct\" class=\"row text-center\">\n          <div class=\"col-md-12\">\n            <p>{{ 'No product(s) available for selection.' | translate }}</p>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n\n  <!-- Sidebar -->\n  <div class=\"col-lg-4 no-p\">\n      <div class=\"gateway-sidebar-wrap transfer-bg active\">\n        <i class=\"fas fa-receipt visible-md visible-xs visible-sm\" type=\"button\"></i>\n        <div class=\"gateway-sidebar\">\n          <!-- Transaction Summary -->\n          <div class=\"transaction-summary\">\n            <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n            <div class=\"font-lg\">\n              <p>{{ 'Transfer from' | translate }}:\n                <span class=\"bold\">{{ $ctrl.transactionSummary.fromProduct }}</span>\n              </p>\n  \n              <p>{{ 'Transfer to' | translate }}:\n                <ul class=\"pl15\">\n                  <li ng-repeat=\"product in $ctrl.transactionSummary.toProducts\" class=\"bold overflow\">- {{ product }}</li>\n                </ul>\n              </p>\n  \n              <hr class=\"m-10\">\n              <p class=\"uppercase\">{{ 'Total amount to send' | translate }}:<br>\n                <span class=\"bold\">{{ $ctrl.form.totalAmount | number : 2 }} {{ $ctrl.userCurrency$ | async }}</span>\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n  </div>\n</div>"

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1440);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _customerProduct = __webpack_require__(1245);
	
	var _customerProduct2 = _interopRequireDefault(_customerProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  FormController.$inject = ["ProductWalletStore", "FormService", "$timeout"];
	  function FormController(ProductWalletStore, FormService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	    this.ProductWalletStore = ProductWalletStore;
	    this.FormService = FormService;
	    this.$timeout = $timeout;
	
	    this.transactionSummary = {
	      fromProduct: null,
	      toProducts: []
	    };
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.customerProductsSubscription = this.ProductWalletStore.getCustomerProducts().subscribe(function (customerProducts) {
	        _this.form = new _form2.default(customerProducts);
	      });
	
	      this.userCurrency$ = this.ProductWalletStore.getCurrency();
	
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.customerProductsSubscription.unsubscribe();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.ProductWalletStore.transfer(this.form.toPayload()).then(function () {
	        return _this2.onSuccessfulSubmission();
	      }).catch(function (errors) {
	        return _this2.form.error.setFormErrors(errors);
	      }).finally(function () {
	        return _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'createTransactionSummary',
	    value: function createTransactionSummary() {
	      var _this3 = this;
	
	      var fromProduct = this.form.customerProducts.filter(function (item) {
	        return item.id === _this3.form.fromProduct;
	      })[0];
	
	      if (fromProduct) {
	        this.transactionSummary.fromProduct = fromProduct.product.name + ' (' + fromProduct.username + ')';
	      }
	
	      var productsSelected = this.form.subTransactions.map(function (item) {
	        return item.product;
	      });
	
	      this.transactionSummary.toProducts = this.form.customerProducts.filter(function (item) {
	        return productsSelected.indexOf(item.id) > -1;
	      }).map(function (item) {
	        return item.product.name + ' (' + item.username + ')';
	      });
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(447);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(1122);
	
	var _formError = __webpack_require__(1441);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubTransaction = function SubTransaction(key) {
	  (0, _classCallCheck3.default)(this, SubTransaction);
	
	  this.key = key;
	
	  this.product = null;
	  this.amount = null;
	
	  this.customerProducts = [];
	};
	
	var TransferForm = function () {
	  function TransferForm(customerProducts) {
	    (0, _classCallCheck3.default)(this, TransferForm);
	
	    this.fromProduct = null;
	    this.subTransactions = [];
	
	    this.customerProducts = (0, _lodash.cloneDeep)(customerProducts);
	
	    // Used by fromCustomerProduct selection.
	    this.clonedCustomerProducts = (0, _lodash.cloneDeep)(customerProducts);;
	
	    this.selectedCustomerProducts = [];
	    this.error = new _formError2.default();
	    this.nextItemKey = 0;
	
	    if (this.customerProducts.length === 1) {
	      this.fromProduct = this.customerProducts[0].id;
	    }
	
	    this.addSubTransaction();
	  }
	
	  (0, _createClass3.default)(TransferForm, [{
	    key: 'addSubTransaction',
	    value: function addSubTransaction() {
	      var _this = this;
	
	      var subTransaction = new SubTransaction(this.nextItemKey);
	      var shallowCopy = (0, _lodash.cloneDeep)(this.customerProducts); //copy by value not reference.
	      shallowCopy = shallowCopy.filter(function (item) {
	        return !_this.selectedCustomerProducts.includes(item.id);
	      });
	      subTransaction.customerProducts = shallowCopy;
	
	      if (this.customerProducts.length === 1) {
	        subTransaction.product = this.customerProducts[0].id;
	        subTransaction.currency = this.customerProducts[0].currency;
	      }
	
	      this.subTransactions.push(subTransaction);
	      this.nextItemKey++;
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction, index) {
	      this.removeFromSelectedProducts(subTransaction.product);
	      this.reloadToAllCustomerProducts(subTransaction.product, index);
	
	      for (var i = 0; i < this.subTransactions.length; i++) {
	        if (this.subTransactions[i].key === subTransaction.key) {
	          this.subTransactions.splice(i, 1);
	          break;
	        }
	      }
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        transfer: {}
	      };
	
	      payload['transfer']['from'] = this.fromProduct;
	
	      var subTransactions = {};
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.subTransactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var subTransaction = _step.value;
	
	          subTransactions[subTransaction.key] = {
	            product: subTransaction.product,
	            amount: subTransaction.amount
	          };
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      payload['transfer']['to'] = subTransactions;
	
	      return payload;
	    }
	
	    //============================================================================
	    //  Code Below handles operations when a change in product selection occurs.
	    //============================================================================
	
	  }, {
	    key: 'onChangedFromCustomerProduct',
	    value: function onChangedFromCustomerProduct(newValue, oldValue) {
	      this.onChangedCustomerProduct(-1, newValue, oldValue);
	    }
	  }, {
	    key: 'onChangedCustomerProduct',
	    value: function onChangedCustomerProduct(index, newValue, oldValue) {
	      this.selectedCustomerProducts.push(newValue);
	      this.removeFromSelectedProducts(oldValue);
	      this.removeFromSelection(newValue, index);
	      this.reloadToAllCustomerProducts(oldValue, index);
	    }
	  }, {
	    key: 'removeFromSelection',
	    value: function removeFromSelection(newValue, index) {
	      // Remove CustomerProduct with id matching the newValue within each SubTransactions
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.subTransactions.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
	              sIndex = _step2$value[0],
	              subTransaction = _step2$value[1];
	
	          // This condition will not remove the CustomerProduct from the owning SubTransaction.
	          // The reason is that, when we tried to remove it, the ng-model will be affected does
	          // will unselect the selection. Apparently, this is the same implementation on OLD AMS.
	          if (index !== sIndex) {
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	              for (var _iterator4 = (0, _getIterator3.default)(this.subTransactions[sIndex].customerProducts.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
	                    cIndex = _step4$value[0],
	                    customerProduct = _step4$value[1];
	
	                if (customerProduct.id === newValue) {
	                  this.subTransactions[sIndex].customerProducts.splice(cIndex, 1);
	                }
	              }
	            } catch (err) {
	              _didIteratorError4 = true;
	              _iteratorError4 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                  _iterator4.return();
	                }
	              } finally {
	                if (_didIteratorError4) {
	                  throw _iteratorError4;
	                }
	              }
	            }
	          }
	        }
	
	        // Remove from fromCustomerProduct selection
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      if (index !== -1) {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(this.clonedCustomerProducts.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
	                fIndex = _step3$value[0],
	                customerProduct = _step3$value[1];
	
	            if (customerProduct.id === newValue) {
	              var spliced = this.clonedCustomerProducts.splice(fIndex, 1);
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'removeFromSelectedProducts',
	    value: function removeFromSelectedProducts(value) {
	      if (value) {
	        var oldValueIndex = this.selectedCustomerProducts.indexOf(value);
	        this.selectedCustomerProducts.splice(oldValueIndex, 1);
	      }
	    }
	
	    // Push CustomerProduct with id matching the oldValue (if oldValue is not null) within each SubTransactions
	
	  }, {
	    key: 'reloadToAllCustomerProducts',
	    value: function reloadToAllCustomerProducts(oldValue, index) {
	      if (oldValue) {
	        var oldCustomerProduct = this.getCustomerProductById(oldValue);
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	          for (var _iterator5 = (0, _getIterator3.default)(this.subTransactions.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var _step5$value = (0, _slicedToArray3.default)(_step5.value, 2),
	                sIndex = _step5$value[0],
	                subTransaction = _step5$value[1];
	
	            if (index !== sIndex) {
	              subTransaction.customerProducts.push(oldCustomerProduct);
	            }
	          }
	        } catch (err) {
	          _didIteratorError5 = true;
	          _iteratorError5 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	              _iterator5.return();
	            }
	          } finally {
	            if (_didIteratorError5) {
	              throw _iteratorError5;
	            }
	          }
	        }
	      }
	
	      // Reload to fromCustomerProduct selection
	      if (oldValue && index !== -1) {
	        var _oldCustomerProduct = this.getCustomerProductById(oldValue);
	        this.clonedCustomerProducts.push(_oldCustomerProduct);
	      }
	    }
	  }, {
	    key: 'getCustomerProductById',
	    value: function getCustomerProductById(id) {
	      return this.customerProducts.filter(function (customerProduct) {
	        return customerProduct.id === id;
	      })[0];
	    }
	  }, {
	    key: 'totalAmount',
	    get: function get() {
	      var totalAmount = 0;
	
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = (0, _getIterator3.default)(this.subTransactions), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var subTransaction = _step6.value;
	
	          totalAmount += Number(subTransaction.amount);
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	
	      return totalAmount;
	    }
	  }, {
	    key: 'isValid',
	    get: function get() {
	      return this.subTransactions.length > 0;
	    }
	  }, {
	    key: 'canAddProduct',
	    get: function get() {
	      return this.customerProducts.length > 1;
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.subTransactions.length > 1;
	    }
	  }]);
	  return TransferForm;
	}();
	
	exports.default = TransferForm;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	var _form = __webpack_require__(1202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormError = function () {
	  function FormError() {
	    (0, _classCallCheck3.default)(this, FormError);
	
	    this.flattenedErrors = {
	      from: null,
	      to: {}
	    };
	  }
	
	  (0, _createClass3.default)(FormError, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.flattenErrors(errors);
	    }
	  }, {
	    key: 'flattenErrors',
	    value: function flattenErrors(errors) {
	      var _this = this;
	
	      this.flattenedErrors['from'] = (0, _lodash.get)(errors, 'children.from.errors');
	      var toProductsErrors = (0, _form.adjustFormError)((0, _lodash.get)(errors, 'children.to.children'));
	
	      toProductsErrors.forEach(function (value, idx) {
	        var errors = value['children'];
	        _this.flattenedErrors.to[idx] = errors;
	      });
	    }
	  }, {
	    key: 'getError',
	    value: function getError(propertyPath) {
	      return (0, _lodash.get)(this.flattenedErrors, propertyPath);
	    }
	  }, {
	    key: 'to',
	    value: function to(path, key) {
	      var propertyPath = 'to.' + key + '.' + path + '.errors';
	
	      return this.getError(propertyPath);
	    }
	  }, {
	    key: 'from',
	    get: function get() {
	      return this.getError('from');
	    }
	  }]);
	  return FormError;
	}();
	
	exports.default = FormError;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _successModal = __webpack_require__(1443);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _successModal3 = __webpack_require__(1444);
	
	var _successModal4 = _interopRequireDefault(_successModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalComponent = {
	  bindings: {
	    onClosed: '&'
	  },
	  template: _successModal2.default,
	  controller: _successModal4.default
	};
	
	exports.default = modalComponent;

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"successModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n    <div class=\"icon success animate\">\n        <span class=\"line tip animateSuccessTip\"></span>\n        <span class=\"line long animateSuccessLong\"></span>\n        <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n    </div>\n    <h3>{{ 'Request is successfully created!' | translate }}</h3>\n    <p class=\"lead text-muted\">\n        {{ 'Please wait for customer service confirmation. You can view transaction status in Transactions overview.' | translate }}\n    </p>\n    <p>\n        <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'OK' | translate }}</button>\n    </p>\n</div>\n"

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessModalController = function () {
	  function SuccessModalController() {
	    (0, _classCallCheck3.default)(this, SuccessModalController);
	  }
	
	  (0, _createClass3.default)(SuccessModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      $('#successModal').on('hidden.bs.modal', function () {
	        _this.onClosed();
	      });
	    }
	  }]);
	  return SuccessModalController;
	}();
	
	exports.default = SuccessModalController;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductWalletStore = function () {
	  ProductWalletStore.$inject = ["TransactionApiService", "CustomerApiService", "SessionService"];
	  function ProductWalletStore(TransactionApiService, CustomerApiService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProductWalletStore);
	    this.TransactionApiService = TransactionApiService;
	    this.CustomerApiService = CustomerApiService;
	    this.SessionService = SessionService;
	
	    // $ denotes that the property is an observable.
	    this.currency$ = SessionService.session.map(function (session) {
	      return session.currency;
	    });
	  }
	
	  /**
	   * @returns {Observable}
	   */
	
	
	  (0, _createClass3.default)(ProductWalletStore, [{
	    key: 'getCustomerProducts',
	    value: function getCustomerProducts() {
	      return _Rx2.default.Observable.fromPromise(this.CustomerApiService.getProducts());
	    }
	
	    /**
	     * @returns {Observable}
	     */
	
	  }, {
	    key: 'getCurrency',
	    value: function getCurrency() {
	      return this.SessionService.session.map(function (session) {
	        return session ? session.currency : null;
	      });
	    }
	  }, {
	    key: 'transfer',
	    value: function transfer(payload) {
	      return this.TransactionApiService.transfer(payload);
	    }
	  }]);
	  return ProductWalletStore;
	}();
	
	exports.default = ProductWalletStore;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _peertopeer = __webpack_require__(1447);
	
	var _peertopeer2 = _interopRequireDefault(_peertopeer);
	
	var _form = __webpack_require__(1450);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _successModal = __webpack_require__(1456);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _peertopeerStore = __webpack_require__(1459);
	
	var _peertopeerStore2 = _interopRequireDefault(_peertopeerStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var peertopeerModule = _angular2.default.module('peertopeer', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('peertopeer', {
	    parent: 'standardLayout',
	    url: '/transactions/peer-to-peer',
	    component: 'peertopeer'
	  });
	}]).component('peertopeer', _peertopeer2.default).component('productForm', _form2.default).component('p2pSuccessModal', _successModal2.default).service('PeerToPeerStore', _peertopeerStore2.default).name;
	
	exports.default = peertopeerModule;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _peertopeer = __webpack_require__(1448);
	
	var _peertopeer2 = _interopRequireDefault(_peertopeer);
	
	var _peertopeer3 = __webpack_require__(1449);
	
	var _peertopeer4 = _interopRequireDefault(_peertopeer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var peertopeerComponent = {
	  bindings: {
	    customerProducts: '<',
	    products: '<'
	  },
	  template: _peertopeer2.default,
	  controller: _peertopeer4.default
	};
	
	exports.default = peertopeerComponent;

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"row mbot3\">\n        <div class=\"col-md-12\">\n          <h2 class=\"no-m\">{{ 'titles.transaction' | translate }}</h2>\n          <h4 class=\"no-m text-dark\">{{ 'titles.p2pTransfer' | translate }}</h4>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-lg-9 col-md-8 col-sm-12 fadeIn animated index-one mbot3\">\n          <div class=\"card-box\">\n            <product-form on-successful-submission=\"$ctrl.onSuccessfulSubmission()\" products=\"$ctrl.products\" customer-products=\"$ctrl.customerProducts\"></product-form>\n            <div id=\"modal-p2p\" tabindex=\"-1\" class=\"modal-unverified\">\n              <div id=\"modal-p2p-sweet-alert\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"true\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n                <div class=\"icon info\"></div>\n                <h2>{{ 'Unable to Transfer' | translate }}</h2>\n                <p class=\"lead text-muted\">{{ 'Please contact our customer service team to have your account verified. Thank you.' | translate }}</p>\n              </div>\n            </div> \n          </div>          \n        </div>\n        <div class=\"col-lg-3 col-md-4 col-sm-12 fadeIn animated index-zero\">\n          <customer-product-widget on-customer-products-loaded=\"$ctrl.onCustomerProductsLoaded(customerProductsList)\"></customer-product-widget>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<p2p-success-modal on-closed=\"$ctrl.finishTransaction()\"></p2p-success-modal>\n<request-product-modal></request-product-modal>\n<product-password-widget></product-password-widget>\n"

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _basecontroller = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeertopeerController = function (_BaseController) {
	  PeertopeerController.$inject = ["AppService", "PeerToPeerStore", "TransactionApiService", "PageService", "$timeout"];
	  (0, _inherits3.default)(PeertopeerController, _BaseController);
	
	  function PeertopeerController(AppService, PeerToPeerStore, TransactionApiService, PageService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PeertopeerController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PeertopeerController.__proto__ || (0, _getPrototypeOf2.default)(PeertopeerController)).call(this, AppService));
	
	    _this.PeerToPeerStore = PeerToPeerStore;
	    _this.TransactionApiService = TransactionApiService;
	    _this.PageService = PageService;
	    _this.$timeout = $timeout;
	    return _this;
	  }
	
	  (0, _createClass3.default)(PeertopeerController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.removeSettingsHighlight();
	      this.checkStatus();
	
	      this.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this2.refreshCustomerProducts();
	      });
	      this.addListener(_events2.default.TRANSACTION_PROCESSED, function (event) {
	        return _this2.refreshCustomerProducts();
	      });
	    }
	  }, {
	    key: 'refreshCustomerProducts',
	    value: function refreshCustomerProducts() {
	      this.broadcast('reload.customer-products');
	    }
	  }, {
	    key: 'onSuccessfulSubmission',
	    value: function onSuccessfulSubmission() {
	      this.PageService.showModal('successModal');
	    }
	  }, {
	    key: 'finishTransaction',
	    value: function finishTransaction() {
	      this.PageService.goto('overview');
	    }
	  }, {
	    key: 'checkStatus',
	    value: function checkStatus() {
	      this.TransactionApiService.condition().then(function (response) {
	        if (!response.verified_at) {
	          var checkBitcoin = response.details.enabledPaymentOption.filter(function (item) {
	            return item.code === 'BITCOIN';
	          });
	
	          if (response.currency.code !== 'BTC' || checkBitcoin.length <= 0) {
	            $('#modal-p2p').show();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeSettingsHighlight',
	    value: function removeSettingsHighlight() {
	      this.$timeout(function () {
	        $('#settings').removeClass('subdrop');
	      }, 100);
	    }
	  }]);
	  return PeertopeerController;
	}(_basecontroller.BaseController);
	
	exports.default = PeertopeerController;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1451);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1452);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex-row\">\n  <div class=\"col-lg-8\">\n    <div loading=\"$ctrl.form\"></div>\n    <form ng-if=\"$ctrl.form\" class=\"form-horizontal product-wallet\" action=\"\">\n      <!-- From Product -->\n      <div class=\"row\">\n        <div class=\"col-lg-6 col-md-5 col-sm-12 col-xs-12 m-b-10\">\n          <label class=\"control-label\">{{ 'form.fromProduct' | translate }}:*</label>\n          <select\n            ng-model=\"$ctrl.form.fromProduct\"\n            ng-init=\"oldValue=null\"\n            ng-change=\"$ctrl.form.onChangedFromCustomerProduct($ctrl.form.fromProduct, oldValue); $ctrl.createTransactionSummary()\"\n            ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in $ctrl.form.customerProducts\"\n            ng-click=\"oldValue=$ctrl.form.fromProduct\"\n            ng-class=\"{ 'parsley-error': false }\"\n            class=\"form-control\">\n            <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n          </select>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.fromProduct\">\n            <li ng-repeat=\"(key, error) in $ctrl.form.error.fromProduct\" class=\"parsley-required\">{{ error }}</li>\n          </ul>\n        </div>\n      </div>\n\n      <!-- Desktop label -->\n      <div class=\"row visible-lg\">\n        <div class=\"col-lg-4 col-md-4\">\n          <label class=\"control-label\">{{ 'Product Username' | translate }}</label>\n        </div>\n        <div class=\"col-lg-4 col-md-4\">\n          <label class=\"control-label\">{{ 'Product' | translate }}</label>\n        </div>\n        <div class=\"col-lg-3 col-md-3\">\n          <label class=\"control-label\">{{ 'Amount' | translate }}</label>\n        </div>\n      </div>\n\n      <div class=\"row\" ng-repeat=\"subTransaction in $ctrl.form.subTransactions\">\n\n        <!-- Product Username -->\n        <div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12 m-b-10\">\n          <!-- Mobile label -->\n          <div class=\"visible-md visible-sm visible-xs\">\n            <label class=\"control-label m-b-0\">{{ 'Product Username' | translate }}</label>\n          </div>\n          <input ng-model=\"subTransaction.username\" ng-class=\"{ 'parsley-error': $ctrl.form.error.to('username', {{ subTransaction.key }}) }\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'Enter product username' | translate }}\">\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.to('username', subTransaction.key)\">\n            <li ng-repeat=\"(key, error) in $ctrl.form.error.to('username', subTransaction.key)\" class=\"parsley-required\">{{\n              error }}</li>\n          </ul>\n        </div>\n\n        <!-- Product -->\n        <div class=\"col-lg-4 col-md-5 sm-12 col-xs-12 m-b-10\">\n          <select\n            ng-model=\"subTransaction.code\"\n            ng-change=\"$ctrl.form.onChangedCustomerProduct($index, subTransaction.product, oldValue); $ctrl.createTransactionSummary()\"\n            ng-class=\"{ 'parsley-error': $ctrl.form.error.to('code', {{ subTransaction.key }}) }\"\n            class=\"form-control\">\n            <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n            <option ng-repeat=\"product in $ctrl.form.products\" ng-value=\"product.code\">{{ product.username }}</option>\n          </select>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.to('code', subTransaction.key)\">\n            <li ng-repeat=\"(key, error) in $ctrl.form.error.to('code', subTransaction.key)\" class=\"parsley-required\">{{\n              error }}</li>\n          </ul>\n        </div>\n\n        <!-- Amount to be transferred -->\n        <div class=\"col-lg-3 col-md-5 col-sm-10 col-xs-10 m-b-10\">\n          <div class=\"input-group\">\n            <span class=\"input-group-addon bg-primary text-white\">{{ $ctrl.userCurrency$ | async }}</span>\n            <input ng-model=\"subTransaction.amount\" ng-class=\"{ 'parsley-error': $ctrl.form.error.to('amount', {{ subTransaction.key }}) }\"\n              limit=\"6\" precision=\"2\" type=\"text\" class=\"form-control\">\n          </div>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.to('amount', subTransaction.key)\">\n            <li ng-repeat=\"(key, error) in $ctrl.form.error.to('amount', subTransaction.key)\" class=\"parsley-required\">{{\n              error }}</li>\n          </ul>\n        </div>\n\n        <!-- Remove product row -->\n        <div class=\"col-lg-1 col-md-2 col-sm-2 col-xs-2\">\n          <button ng-click=\"$ctrl.form.removeSubTransaction(subTransaction);$ctrl.createTransactionSummary();\" ng-disabled=\"!$ctrl.displayDeleteButton\"\n            class=\"btn btn-danger\" type=\"button\" disabled=\"disabled\"><i class=\"fa fa-times\"></i></button>\n        </div>\n      </div>\n\n      <!-- General Error -->\n      <div class=\"row\" ng-show=\"$ctrl.form.error.root\">\n        <div class=\"col-md-12\">\n          <p class=\"text-danger\">\n            {{ $ctrl.form.error.root[0] }}\n          </p>\n        </div>\n      </div>\n\n      <!-- Add another procuct -->\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <button ng-click=\"$ctrl.form.addSubTransaction()\" type=\"button\" class=\"btn btn-primary btn-sm btn-custom waves-effect waves-light add-product\">\n            <i class=\"fa fa-plus\"></i> {{ 'Add product' | translate }}\n          </button>\n        </div>\n      </div>\n\n      <div class=\"row m-t-20 m-b-20\">\n        <!-- Transaction Password -->\n        <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n          <switch-auth switched=\"$ctrl.form.authenticationSwitched(isUsingGoogleTwoFactor)\" session=\"$ctrl.session\">\n            <input ng-model=\"$ctrl.form.transactionPassword\" type=\"password\" class=\"form-control\">\n            <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.transactionPassword\">\n              <li ng-repeat=\"(key, error) in $ctrl.form.error.transactionPassword\" class=\"parsley-required\">{{ error }}</li>\n            </ul>\n          </switch-auth>\n        </div>\n\n        <!-- Submit button -->\n        <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 bank-request text-right m-t-25\">\n          <ladda-button on-click=\"$ctrl.submit()\" text=\"'Request Transfer'\" ladda-disable=\"(!$ctrl.form.isValid) || ($ctrl.FormService.isSubmitting | async) === true\"></ladda-button>\n        </div>\n      </div>\n    </form>\n  </div>\n  <!-- Sidebar -->\n  <div class=\"col-lg-4 no-p\">\n    <div class=\"gateway-sidebar-wrap transfer-bg active\">\n      <i class=\"fas fa-receipt visible-md visible-xs visible-sm\" type=\"button\"></i>\n      <div class=\"gateway-sidebar\">\n          <!-- Transaction Summary -->\n        <div class=\"transaction-summary\">\n          <h4 class=\"uppercase text-center ac-white-text\">{{ 'Transaction Summary' | translate }}</h4>\n          <div class=\"font-lg\">\n            <p>{{ 'Transfer from' | translate }}:\n              <span class=\"bold\">{{ $ctrl.transactionSummary.fromProduct }}</span>\n            </p>\n\n            <p>{{ 'Transfer to' | translate }}:\n              <ul class=\"pl15\">\n                <li ng-repeat=\"product in $ctrl.transactionSummary.toProducts\" class=\"bold overflow\">- {{ product.name }} {{ product }}</li>\n              </ul>\n            </p>\n\n            <hr class=\"m-10\">\n            <p class=\"uppercase\">{{ 'Total amount to send' | translate }}:<br>\n              <span class=\"bold\">{{ $ctrl.form.totalAmount | number : 2 }} {{ $ctrl.userCurrency$ | async }}</span>\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _form = __webpack_require__(1453);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _customerProduct = __webpack_require__(1245);
	
	var _customerProduct2 = _interopRequireDefault(_customerProduct);
	
	var _product = __webpack_require__(1455);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _basecontroller = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function (_BaseController) {
	  FormController.$inject = ["PeerToPeerStore", "FormService", "AppService", "$timeout"];
	  (0, _inherits3.default)(FormController, _BaseController);
	
	  function FormController(PeerToPeerStore, FormService, AppService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FormController.__proto__ || (0, _getPrototypeOf2.default)(FormController)).call(this, AppService));
	
	    _this.PeerToPeerStore = PeerToPeerStore;
	    _this.FormService = FormService;
	    _this.$timeout = $timeout;
	
	    _this.transactionSummary = {
	      fromProduct: null,
	      toProducts: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      // Combines two observables
	      this.detailsSubscription = this.PeerToPeerStore.getDetails().subscribe(function (details) {
	        _this2.form = new _form2.default(details.products, details.customerProducts);
	      });
	      this.session = this.getSession();
	
	      this.userCurrency$ = this.PeerToPeerStore.getCurrency();
	
	      this.$timeout(function () {
	        $(".gateway-sidebar-wrap .fa-receipt").click(function (e) {
	          e.preventDefault();
	          $(".gateway-sidebar-wrap").toggleClass('active');
	        });
	      }, 500);
	    }
	  }, {
	    key: '$onDestory',
	    value: function $onDestory() {
	      this.detailsSubscription.unsubscribe();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this3 = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.PeerToPeerStore.p2pTransfer(this.form.toPayload()).then(function () {
	        _this3.form.hasError = false;
	        _this3.onSuccessfulSubmission();
	      }).catch(function (errors) {
	        return _this3.form.error.setFormErrors(errors);
	      }).finally(function () {
	        return _this3.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'createTransactionSummary',
	    value: function createTransactionSummary() {
	      var _this4 = this;
	
	      var fromProduct = this.form.customerProducts.filter(function (item) {
	        return item.id === _this4.form.fromProduct;
	      })[0];
	
	      if (fromProduct) {
	        this.transactionSummary.fromProduct = fromProduct.product.name + ' (' + fromProduct.username + ')';
	      }
	
	      var productsSelected = this.form.subTransactions.map(function (item) {
	        return item.code;
	      });
	
	      this.transactionSummary.toProducts = this.form.products.filter(function (item) {
	        return productsSelected.indexOf(item.code) > -1;
	      }).map(function (item, idx) {
	        return item.username + ' (' + _this4.form.subTransactions[idx].username + ')';
	      });
	    }
	  }, {
	    key: 'displayDeleteButton',
	    get: function get() {
	      return this.form.subTransactions.length > 1;
	    }
	  }]);
	  return FormController;
	}(_basecontroller.BaseController);
	
	exports.default = FormController;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _formError = __webpack_require__(1454);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubTransaction = function SubTransaction(key) {
	  (0, _classCallCheck3.default)(this, SubTransaction);
	
	  this.key = key;
	
	  this.username = '';
	  this.code = '';
	  this.amount = null;
	};
	
	var TransferForm = function () {
	  function TransferForm(products, customerProducts) {
	    (0, _classCallCheck3.default)(this, TransferForm);
	
	    this.subTransactions = [];
	    this.transactionPassword = null;
	
	    this.products = products;
	    this.customerProducts = customerProducts;
	
	    this.hasError = false;
	    this.error = new _formError2.default();
	    this.nextItemKey = 0;
	    this.isUsingGoogleTwoFactor = false;
	
	    if (this.customerProducts.length === 0) {
	      this.fromProduct = this.customerProducts[0].id;
	    }
	
	    this.addSubTransaction();
	  }
	
	  (0, _createClass3.default)(TransferForm, [{
	    key: 'addSubTransaction',
	    value: function addSubTransaction() {
	      var subTransaction = new SubTransaction(this.nextItemKey);
	
	      if (this.products.length === 0) {
	        subTransaction.code = this.products[0].code;
	      }
	
	      this.subTransactions.push(subTransaction);
	      this.nextItemKey++;
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subTransaction) {
	      for (var i = 0; i < this.subTransactions.length; i++) {
	        if (this.subTransactions[i].key === subTransaction.key) {
	          this.subTransactions.splice(i, 1);
	          break;
	        }
	      }
	    }
	  }, {
	    key: 'authenticationSwitched',
	    value: function authenticationSwitched(isUsingGoogleTwoFactor) {
	      this.isUsingGoogleTwoFactor = isUsingGoogleTwoFactor;
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        transfer: {
	          usingGoogleAuthPassword: this.isUsingGoogleTwoFactor
	        }
	      };
	
	      payload['transfer']['from'] = this.fromProduct;
	
	      var subTransactions = {};
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.subTransactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var subTransaction = _step.value;
	
	          subTransactions[subTransaction.key] = {
	            code: subTransaction.code,
	            username: subTransaction.username,
	            amount: subTransaction.amount
	          };
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      payload['transfer']['to'] = subTransactions;
	      payload['transfer']['transactionPassword'] = this.transactionPassword;
	
	      return payload;
	    }
	  }, {
	    key: 'totalAmount',
	    get: function get() {
	      var totalAmount = 0;
	
	      angular.forEach(this.subTransactions, function (subTransaction) {
	        totalAmount += Number(subTransaction.amount);
	      });
	
	      return totalAmount;
	    }
	  }, {
	    key: 'isValid',
	    get: function get() {
	      return this.subTransactions.length > 0;
	    }
	  }]);
	  return TransferForm;
	}();
	
	exports.default = TransferForm;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	var _form = __webpack_require__(1202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormError = function () {
	  function FormError() {
	    (0, _classCallCheck3.default)(this, FormError);
	
	    this.flattenedErrors = {
	      errors: null,
	      to: {}
	    };
	  }
	
	  (0, _createClass3.default)(FormError, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.flattenErrors(errors);
	    }
	  }, {
	    key: 'flattenErrors',
	    value: function flattenErrors(errors) {
	      var _this = this;
	
	      var rootErrors = errors['errors'];
	      var toProductsErrors = (0, _form.adjustFormError)((0, _lodash.get)(errors, 'children.to.children'));
	
	      this.flattenedErrors['errors'] = rootErrors;
	      this.flattenedErrors['fromProduct'] = (0, _lodash.get)(errors, 'children.from.errors');
	      this.flattenedErrors['transactionPassword'] = (0, _lodash.get)(errors, 'children.transactionPassword.errors');
	      toProductsErrors.forEach(function (value, idx) {
	        var errors = value['children'];
	        _this.flattenedErrors.to[idx] = errors;
	      });
	    }
	  }, {
	    key: 'getError',
	    value: function getError(propertyPath) {
	      return (0, _lodash.get)(this.flattenedErrors, propertyPath);
	    }
	  }, {
	    key: 'to',
	    value: function to(path, key) {
	      var propertyPath = 'to.' + key + '.' + path + '.errors';
	
	      return this.getError(propertyPath);
	    }
	  }, {
	    key: 'root',
	    get: function get() {
	      return this.getError('errors');
	    }
	  }, {
	    key: 'fromProduct',
	    get: function get() {
	      return this.getError('fromProduct');
	    }
	  }, {
	    key: 'transactionPassword',
	    get: function get() {
	      return this.getError('transactionPassword');
	    }
	  }]);
	  return FormError;
	}();
	
	exports.default = FormError;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.makeProducts = makeProducts;
	exports.makeProduct = makeProduct;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeProducts(payload) {
	  return payload.map(function (product) {
	    return makeProduct(product);
	  });
	}
	
	function makeProduct(payload) {
	  return new Product(payload.id, payload.name, payload.code);
	}
	
	var Product = function Product(id, name, code) {
	  (0, _classCallCheck3.default)(this, Product);
	
	  this.id = +id;
	  this.username = name;
	  this.code = code;
	};
	
	exports.default = Product;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _successModal = __webpack_require__(1457);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _successModal3 = __webpack_require__(1458);
	
	var _successModal4 = _interopRequireDefault(_successModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCompoent = {
	  bindings: {
	    onClosed: '&'
	  },
	  template: _successModal2.default,
	  controller: _successModal4.default
	};
	
	exports.default = modalCompoent;

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"successModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n    <div class=\"icon success animate\">\n        <span class=\"line tip animateSuccessTip\"></span>\n        <span class=\"line long animateSuccessLong\"></span>\n        <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n    </div>\n    <h3>{{ 'Request is successfully created!' | translate }}</h3>\n    <p class=\"lead text-muted\">\n        {{ 'Please wait for customer service confirmation. You can view transaction status in Transactions overview.' | translate }}\n    </p>\n    <p>\n        <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'OK' | translate }}</button>\n    </p>\n</div>"

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessModalController = function () {
	  function SuccessModalController() {
	    (0, _classCallCheck3.default)(this, SuccessModalController);
	  }
	
	  (0, _createClass3.default)(SuccessModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      $('#successModal').on('hidden.bs.modal', function () {
	        _this.onClosed();
	      });
	    }
	  }]);
	  return SuccessModalController;
	}();
	
	exports.default = SuccessModalController;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	var _customerProduct = __webpack_require__(1245);
	
	var _product = __webpack_require__(1455);
	
	var _customerProduct2 = __webpack_require__(1460);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeerToPeerStore = function () {
	  PeerToPeerStore.$inject = ["TransactionApiService", "SessionService"];
	  function PeerToPeerStore(TransactionApiService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PeerToPeerStore);
	    this.TransactionApiService = TransactionApiService;
	    this.SessionService = SessionService;
	  }
	
	  /**
	   * @returns {Observable}
	   */
	
	
	  (0, _createClass3.default)(PeerToPeerStore, [{
	    key: 'getDetails',
	    value: function getDetails() {
	      return _Rx2.default.Observable.fromPromise(this.TransactionApiService.p2pTransferDetails()).map(function (details) {
	        var customerProducts = details.customerProducts.map(function (payload) {
	          return (0, _customerProduct2.makeCustomerProduct)(payload);
	        });
	
	        return {
	          customerProducts: customerProducts,
	          products: (0, _product.makeProducts)(details.products)
	        };
	      });
	    }
	  }, {
	    key: 'getCustomerProducts',
	    value: function getCustomerProducts() {
	      return _Rx2.default.Observable.fromPromise(this.TransactionApiService.p2pTransferDetails()).map(function (details) {
	        return (0, _customerProduct.makeCustomerProducts)(details.customerProducts);
	      });
	    }
	
	    /**
	     * @returns {Observable}
	     */
	
	  }, {
	    key: 'getCurrency',
	    value: function getCurrency() {
	      return this.SessionService.session.map(function (session) {
	        return session ? session.currency : null;
	      });
	    }
	  }, {
	    key: 'p2pTransfer',
	    value: function p2pTransfer(payload) {
	      return this.TransactionApiService.p2pTransfer(payload);
	    }
	  }]);
	  return PeerToPeerStore;
	}();
	
	exports.default = PeerToPeerStore;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomerProduct = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeCustomerProduct = makeCustomerProduct;
	
	var _currency = __webpack_require__(1461);
	
	var _product = __webpack_require__(1462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeCustomerProduct(payload) {
	  return CustomerProduct.fromPayload(payload);
	}
	
	var CustomerProduct = exports.CustomerProduct = function () {
	  function CustomerProduct() {
	    (0, _classCallCheck3.default)(this, CustomerProduct);
	
	    this._id = null;
	    this._product = null;
	    this._currency = null;
	    this._username = null;
	    this._isActive = true;
	    this._balance = null;
	    this._updatedAt = null;
	  }
	
	  (0, _createClass3.default)(CustomerProduct, [{
	    key: "id",
	    set: function set(id) {
	      this._id = id;
	    },
	    get: function get() {
	      return this._id;
	    }
	  }, {
	    key: "product",
	    set: function set(product) {
	      this._product = product;
	    },
	    get: function get() {
	      return this._product;
	    }
	  }, {
	    key: "currency",
	    set: function set(currency) {
	      this._currency = currency;
	    },
	    get: function get() {
	      return this._currency;
	    }
	  }, {
	    key: "username",
	    set: function set(username) {
	      this._username = username;
	    },
	    get: function get() {
	      return this._username;
	    }
	  }, {
	    key: "balance",
	    set: function set(balance) {
	      this._balance = balance;
	    },
	    get: function get() {
	      return this._balance;
	    }
	  }, {
	    key: "updatedAt",
	    set: function set(updatedAt) {
	      this._updatedAt = updatedAt;
	    },
	    get: function get() {
	      return this._updatedAt;
	    }
	  }, {
	    key: "productName",
	    get: function get() {
	      return this.product.name;
	    }
	  }], [{
	    key: "fromPayload",
	    value: function fromPayload(payload) {
	      var customerProduct = new CustomerProduct();
	
	      customerProduct.id = payload.id;
	      customerProduct.currency = (0, _currency.makeCurrency)(payload.currency);
	      customerProduct.product = (0, _product.makeProduct)(payload.product);
	      customerProduct.username = payload.username;
	      customerProduct.isActive = payload.is_active;
	      customerProduct.balance = payload.balance;
	      customerProduct.updatedAt = payload.updated_at;
	
	      return customerProduct;
	    }
	  }]);
	  return CustomerProduct;
	}();

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Currency = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeCurrency = makeCurrency;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeCurrency(payload) {
	  return Currency.fromPayload(payload);
	}
	
	var Currency = exports.Currency = function () {
	  function Currency() {
	    (0, _classCallCheck3.default)(this, Currency);
	
	    this._id = null;
	    this._name = null;
	    this._code = null;
	  }
	
	  (0, _createClass3.default)(Currency, [{
	    key: "id",
	    set: function set(id) {
	      this._id = id;
	    },
	    get: function get() {
	      return this._id;
	    }
	  }, {
	    key: "name",
	    set: function set(name) {
	      this._name = name;
	    },
	    get: function get() {
	      return this._name;
	    }
	  }], [{
	    key: "fromPayload",
	    value: function fromPayload(payload) {
	      var currency = new Currency();
	
	      currency.id = payload.id;
	      currency.name = payload.name;
	      currency.code = payload.code;
	
	      return currency;
	    }
	  }]);
	  return Currency;
	}();

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Product = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeProduct = makeProduct;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeProduct(payload) {
	  return Product.fromPayload(payload);
	}
	
	var Product = exports.Product = function () {
	  function Product() {
	    (0, _classCallCheck3.default)(this, Product);
	
	    this._id = null;
	    this._code = null;
	    this._name = null;
	  }
	
	  (0, _createClass3.default)(Product, [{
	    key: "id",
	    set: function set(id) {
	      this._id = id;
	    },
	    get: function get() {
	      return this._id;
	    }
	  }, {
	    key: "code",
	    set: function set(code) {
	      this._code = code;
	    },
	    get: function get() {
	      return this._code;
	    }
	  }, {
	    key: "name",
	    set: function set(name) {
	      this._name = name;
	    },
	    get: function get() {
	      return this._name;
	    }
	  }], [{
	    key: "fromPayload",
	    value: function fromPayload(payload) {
	      var product = new Product();
	      product.id = payload.id;
	      product.code = payload.code;
	      product.name = payload.name;
	
	      return product;
	    }
	  }]);
	  return Product;
	}();

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _outstandingbet = __webpack_require__(1464);
	
	var _outstandingbet2 = _interopRequireDefault(_outstandingbet);
	
	var _form = __webpack_require__(1467);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _api = __webpack_require__(1471);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var outstandingbetModule = _angular2.default.module('outstandingbet', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('outstandingbet', {
	    parent: 'standardLayout',
	    url: '/outstanding-bet',
	    component: 'outstandingbet',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('outstandingbet', _outstandingbet2.default).component('outstandingSearchForm', _form2.default).service('OutstandingBetApiService', _api2.default).name;
	
	exports.default = outstandingbetModule;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _outstandingbet = __webpack_require__(1465);
	
	var _outstandingbet2 = _interopRequireDefault(_outstandingbet);
	
	var _outstandingbet3 = __webpack_require__(1466);
	
	var _outstandingbet4 = _interopRequireDefault(_outstandingbet3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var outstandingbetComponent = {
	  bindings: {
	    brokerageSyncId: '<'
	  },
	  template: _outstandingbet2.default,
	  controller: _outstandingbet4.default
	};
	
	exports.default = outstandingbetComponent;

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper\">\n    <div class=\"content\">\n        <div class=\"container\">\n            <div class=\"content-left col-sm-10 fadeIn animated\">\n                <div class=\"col-sm-12\">\n                    <div class=\"card-box\">\n                        <section>\n                            <h4 class=\"m-t-0 page-header\"><strong>Outstanding Bets</strong></h4>\n                            <div class = \"card-box\">\n                                <form action=\"\">\n                                    <div class=\"col-lg-3 col-md-12 col-sm-12\">\n                                    <div class=\"form-group\">\n                                        <div class=\"\">\n                                            <input ng-model=\"$ctrl.OutstadingSearchForm.teamSearch\" id=\"txtSearch\" type=\"text\" class=\"form-control\" value=\"\" placeholder=\"Search Team, League\">\n                                        </div>\n                                    </div>\n                                    </div>\n                                    <div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-6 date-input\">\n                                        <div class=\"form-group\">\n                                            <label class=\"control-label col-lg-4  col-md-4 col-sm-2 mtop2\">From</label>\n                                            <div class=\"col-lg-8 col-md-8 col-sm-10\">\n                                                <div class=\"input-group\" id=\"dateFrom\">\n                                                    <date-picker ng-model=\"$ctrl.OutstadingSearchForm.fromSearch\"></date-picker>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-6 date-input\">\n                                        <div class=\"form-group\">\n                                            <label class=\"control-label col-sm-2 mtop2\">To</label>\n                                            <div class=\"col-sm-10\">\n                                                <div class=\"input-group\" id=\"dateTo\">\n                                                    <date-picker ng-model=\"$ctrl.OutstadingSearchForm.toSearch\"></date-picker>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-lg-3 col-md-4 col-sm-12 sm-search\">\n                                        <button ng-click=\"$ctrl.draw()\" type=\"button\" class=\"btn btn-danger waves-effect waves-light ac-color mtop1\" id=\"btnSearch\">Search</button>\n                                        <button ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-inverse waves-effect waves-light mtop1\">Reset Filter</button>\n                                    </div>\n                                    <div class=\"clearfix\"></div>\n                                </form>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"panel-body tablecustom\">\n                                    <div class=\"col-lg-2 col-md-2 col-sm-4 sel-show\">\n                                      <span class=\"\">Show</span>\n                                      <div class=\"\">\n                                          <select class=\"form-control input-sm sm-limit\" ng-model=\"$ctrl.changelimit\" ng-change=\"$ctrl.changeLimit()\" id=\"outstandingBetLength\">\n                                              <option value=\"10\">10</option>\n                                              <option value=\"25\">25</option>\n                                              <option value=\"50\">50</option>\n                                              <option value=\"100\">100</option>\n                                          </select>\n                                      </div>\n                                      <span class=\"\">entries</span>\n                                    </div>\n                                    <table id=\"datatable-responsive\" class=\"table toggle-circle m-b-0\" cellspacing=\"0\" width=\"100%\">\n                                        <thead>\n                                            <tr>\n                                                <th data-hide=\"tablet, phone\">Event Date</th>\n                                                <th>Bet ID</th>\n                                                <th data-toggle=\"true\">Bet Details</th>\n                                                <th data-hide=\"tablet, phone\">Selection</th>\n                                                <th data-hide=\"tablet, phone\">Odds</th>\n                                                <th data-hide=\"tablet, phone\">Stake</th>\n                                            </tr>\n                                        </thead>\n                                        <tbody>\n                                            <tr ng-repeat=\"bet in $ctrl.betList\">\n                                                <td>{{ $ctrl.formatdate(bet.event_date) }} - {{ bet.event_time }}</td>\n                                                <td>{{ bet.id }}</td>\n                                                <td>{{ bet.home }}</td>\n                                                <td>{{ bet.bet }}<span ng-show=\"{{bet.bet == '' }}\" ng-repeat=\"detail in bet.betOption.lists\">{{ detail }} <br /></span></td>\n                                                <td>{{ bet.odds }}</td>\n                                                <td>{{ bet.stake }}</td>\n                                            </tr>\n                                            <tr ng-hide=\"$ctrl.recordsTotal > 0\">\n                                                <td colspan=\"6\" style=\"text-align: center\">{{ $ctrl.textDisplay }}</td>\n                                            </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                                <div class=\"showed-entry\">\n                                    <div class=\"col-sm-6\">\n                                        <span ng-hide=\"$ctrl.recordsTotal == 0\">Showing {{ $ctrl.recordsTotal > 0 ? $ctrl.offset : 0 }} to {{ $ctrl.endPoint < $ctrl.recordsTotal ? $ctrl.endPoint : $ctrl.recordsTotal }} of {{ $ctrl.recordsTotal }} entries</span>\n                                    </div>\n                                    <div class=\"col-sm-6\">\n                                        <div class=\"pull-right\">\n                                            <ul ng-hide=\"$ctrl.noOfPages < 2\" class=\"pagination-b\">\n                                                <li ng-class=\"{disabled: $ctrl.currentPage == 1}\">\n                                                    <a href ng-click=\"$ctrl.jumpTo($ctrl.currentPage > 1 ? $ctrl.currentPage - 1 : 1, $ctrl.noOfPages)\" ng-if=\"$ctrl.currentPage > 1\">« Prev</a><a ng-if=\"$ctrl.currentPage == 1\">« Prev</a>\n                                                </li>\n                                                <li ng-if=\"$ctrl.currentPage > 4\">\n                                                    <a href ng-click=\"$ctrl.jumpTo(1, $ctrl.noOfPages)\">1</a>\n                                                <li>\n                                                <li ng-if=\"$ctrl.currentPage > 4\">\n                                                    <a>...</a>\n                                                <li>\n                                                <li ng-repeat=\"n in $ctrl.range($ctrl.currentPage, $ctrl.noOfPages)\"\n                                                    ng-class=\"{active: n == $ctrl.currentPage}\">\n                                                    <a ng-bind=\"n\" ng-click=\"$ctrl.jumpTo(n, $ctrl.noOfPages)\">{{ n }}</a>\n                                                </li>\n                                                <li ng-if=\"($ctrl.noOfPages - $ctrl.currentPage) > 3\">\n                                                    <a>...</a>\n                                                <li>\n                                                <li ng-if=\"($ctrl.noOfPages - $ctrl.currentPage) > 3\">\n                                                    <a href ng-click=\"$ctrl.jumpTo($ctrl.noOfPages, $ctrl.noOfPages)\">{{ $ctrl.noOfPages }}</a>\n                                                <li>\n                                                <li ng-class=\"{disabled: $ctrl.currentPage == $ctrl.noOfPages}\">\n                                                    <a href ng-click=\"$ctrl.jumpTo($ctrl.currentPage < $ctrl.noOfPages ? $ctrl.currentPage + 1 : $ctrl.noOfPages, $ctrl.noOfPages)\" ng-if=\"$ctrl.currentPage < $ctrl.noOfPages\">Next »</a><a ng-if=\"$ctrl.currentPage >= $ctrl.noOfPages\">Next »</a>\n                                                </li>\n                                            </ul>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </section>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OutstandingbetController = function () {
	  OutstandingbetController.$inject = ["OutstandingBetApiService", "SessionService", "EventDispatcherService", "$document", "$timeout"];
	  function OutstandingbetController(OutstandingBetApiService, SessionService, EventDispatcherService, $document, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OutstandingbetController);
	    this.OutstandingBetApiService = OutstandingBetApiService;
	    this.SessionService = SessionService;
	    this.EventDispatcherService = EventDispatcherService;
	    this.htmlDocument = $document[0];
	    this.$timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(OutstandingbetController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.endPoint = 10;
	      this.offset = 1;
	      this.currentPage = 1;
	      this.currentDate = '';
	      this.maxSize = 5;
	      this.limit = 10;
	      this.selectlimit = 10;
	      this.changelimit = '10';
	      this.textDisplay = 'Loading...';
	      this.recordsTotal = 0;
	      this.noOfPages = 0;
	      this.brokerageSyncId = this.SessionService.get('brokerageSyncId');
	
	      this.draw();
	      this.renderTable();
	
	      this.subscription = this.EventDispatcherService.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this.draw();
	      });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscription.remove();
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      this.$timeout(function () {
	        $('#datatable-responsive').footable();
	        $('#datatable-responsive').trigger('footable_redraw');
	      }, 0);
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this2 = this;
	
	      this.limit = this.changelimit;
	      var betLinkDetails = '/brokerage/get-bet-list' + this.getLink();
	      this.htmlDocument.getElementById('btnSearch').innerHTML = 'Searching...';
	      this.OutstandingBetApiService.getBetList(betLinkDetails).then(function (response) {
	        var betData = response.data;
	        _this2.recordsTotal = response.recordsTotal;
	        _this2.betList = betData.map(function (value) {
	          var bet = value;
	          bet.home = _this2.betDetails(value);
	          bet.bet = _this2.betSelected(value);
	          bet.stake = _this2.formatAmount(value.stake);
	          bet.odds = _this2.formatAmount(value.odds);
	          bet.betOption = JSON.parse(value.betOption);
	
	          return bet;
	        });
	
	        if (_this2.recordsTotal == 0) {
	          _this2.textDisplay = 'No results to display!';
	        }
	
	        _this2.htmlDocument.getElementById('btnSearch').innerHTML = 'Search';
	        _this2.noOfPages = Math.floor(_this2.recordsTotal / _this2.limit) + 1;
	
	        _this2.renderTable();
	      });
	    }
	  }, {
	    key: 'changeLimit',
	    value: function changeLimit() {
	      this.currentPage = 1;
	      this.changelimit = document.getElementById('outstandingBetLength').value;
	      this.endPoint = this.changelimit;
	      this.offset = 1;
	      this.draw();
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.htmlDocument.getElementById('dateTo').getElementsByClassName('filter-from-date')[0].value = '';
	      this.htmlDocument.getElementById('dateFrom').getElementsByClassName('filter-from-date')[0].value = '';
	      this.htmlDocument.getElementById('outstandingBetLength').value = '10';
	
	      this.draw();
	    }
	  }, {
	    key: 'getLink',
	    value: function getLink() {
	      var dateFrom = this.htmlDocument.getElementById('dateFrom').getElementsByClassName('filter-from-date')[0].value;
	      var dateTo = this.htmlDocument.getElementById('dateTo').getElementsByClassName('filter-from-date')[0].value;
	      var search = this.htmlDocument.getElementById('txtSearch').value;
	      var paramText = '?id=' + this.brokerageSyncId + '&status=1&limit=' + this.limit + '&offset=' + (this.offset - 1) + '&from=' + dateFrom + '&to=' + dateTo + '&search=' + search;
	
	      return paramText;
	    }
	  }, {
	    key: 'formatdate',
	    value: function formatdate(date) {
	      var key = date.split('-');
	
	      return key[1] + '/' + key[2] + '/' + key[0];
	    }
	  }, {
	    key: 'betDetails',
	    value: function betDetails(data) {
	      var betRequestType = parseInt(data.betRequestType);
	
	      switch (betRequestType) {
	        case 0:
	          return this.halfFullTime(data.halftimeBet) + '/' + this.betType(data.betType) + ': ' + data.home + ' VS ' + data.away + ' ' + this.currentScore(data.currentScore);
	        case 1:
	          return data.home + ' VS ' + data.away;
	        default:
	          return data.away;
	      }
	    }
	  }, {
	    key: 'halfFullTime',
	    value: function halfFullTime(value) {
	      return 0 == value ? 'FT' : 'HT';
	    }
	  }, {
	    key: 'betType',
	    value: function betType(value) {
	      value = parseInt(value);
	
	      switch (value) {
	        case 0:
	          return 'AHDP';
	        case 1:
	          return 'OU';
	        default:
	          return '1X2';
	      }
	    }
	  }, {
	    key: 'currentScore',
	    value: function currentScore(value) {
	      return value ? ' (' + value + ')' : '';
	    }
	  }, {
	    key: 'betSelected',
	    value: function betSelected(data) {
	      if (data.betRequestType == 0) {
	        var bet = parseInt(data.bet);
	
	        switch (bet) {
	          case 0:
	            bet = 'DRAW ';
	            break;
	          case 1:
	            bet = 'HOME ';
	            break;
	          case 2:
	            bet = 'AWAY ';
	            break;
	          case 3:
	            bet = 'UNDER ';
	            break;
	          case 4:
	            bet = 'OVER ';
	            break;
	        }
	
	        return bet + this.handicap(data);
	      }
	
	      var betOption = angular.fromJson(data.betOption);
	
	      if (data.betRequestType == 1) {
	        return betOption.special;
	      }
	
	      return '';
	    }
	  }, {
	    key: 'handicap',
	    value: function handicap(data) {
	      return 0 > data.betType ? '' : this.formatAmount(data.handicap);
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(value) {
	      var sign = 0 > value ? '-' : '';
	      value = parseFloat(Math.abs(value).toFixed(4));
	      var count = value.toString().split('.')[1] ? value.toString().split('.')[1].length : 0;
	
	      switch (count) {
	        case 0:
	          value = sign + value + '.00';
	          break;
	        case 1:
	          value = sign + value + '0';
	          break;
	        default:
	          value = sign + value;
	          break;
	      }
	      var components = value.toString().split('.');
	      components[0] = components[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	
	      return components.join('.');
	    }
	  }, {
	    key: 'range',
	    value: function range(current, noOfPages) {
	      this.output = [];
	      var min = 0;
	      var max = 0;
	      if (current < 5 && noOfPages - current > 3) {
	        min = 1;
	        max = 5;
	      } else if (noOfPages < 5 && noOfPages > 1) {
	        min = 1;
	        max = noOfPages;
	      } else if (noOfPages - current > 3) {
	        min = current - 1;
	        max = current + 1;
	      } else if (noOfPages - current <= 3 && noOfPages != 1) {
	        min = noOfPages - 4;
	        max = noOfPages;
	      }
	
	      if (max != 0) {
	        for (this.i = min; this.i <= max; this.i += 1) {
	          this.output.push(this.i);
	        }
	      }
	
	      return this.output;
	    }
	  }, {
	    key: 'jumpTo',
	    value: function jumpTo(current, noOfPages) {
	      this.endPoint = this.limit * current;
	      this.offset = this.limit * current - this.limit;
	      this.offset = this.offset + 1;
	      this.currentPage = current;
	      this.draw();
	    }
	  }]);
	  return OutstandingbetController;
	}();
	
	exports.default = OutstandingbetController;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1468);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1469);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    OutstadingSearchForm: '<',
	    onSubmit: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	module.exports = "<form action=\"\">\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <div class=\"col-md-12\">\n        <input  ng-model=\"$ctrl.OutstadingSearchForm.teamSearch\" type=\"text\" class=\"form-control\" value=\"\" placeholder=\"Search Team, League\">\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <label class=\"control-label col-sm-2 mtop2\">From</label>\n      <div class=\"col-sm-10\">\n       <div class=\"input-group\">\n          <input  ng-model=\"$ctrl.OutstadingSearchForm.fromSearch\" type=\"text\" class=\"form-control datepicker-autoclose\" placeholder=\"mm/dd/yyyy\" id=\"To_datepicker-autoclose\">\n          <span class=\"input-group-addon b-0\"><i class=\"icon-calender\"></i></span>\n        </div>\n      </div>\n    </div>\n  </div>\n   <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <label class=\"control-label col-sm-2 mtop2\">To</label>\n      <div class=\"col-sm-10\">\n        <div class=\"input-group\">\n          <input ng-model=\"$ctrl.OutstadingSearchForm.toSearch\" type=\"text\" class=\"form-control datepicker-autoclose\" placeholder=\"mm/dd/yyyy\" id=\"To_datepicker-autoclose\">\n          <span class=\"input-group-addon b-0\"><i class=\"icon-calender\"></i></span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <button  ng-click=\"$ctrl.submit()\" type=\"button\" class=\"btn btn-danger waves-effect waves-light ac-color\">Search</button>\n    <button type=\"button\" class=\"btn btn-inverse waves-effect waves-light\">Reset Filter</button>\n  </div>\n  <div class=\"clearfix\"></div>\n</form>"

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1470);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  function FormController() {
	    (0, _classCallCheck3.default)(this, FormController);
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.OutstadingSearchForm = _form2.default;
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.onSubmit({ payload: this.OutstadingSearchForm.toPayload() });
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var OutstadingSearchForm = {
	  teamSearch: '',
	  fromSearch: '',
	  toSearch: '',
	
	  toPayload: function toPayload() {
	    return {
	      teamSearch: this.teamSearch,
	      fromSearch: this.fromSearch,
	      toSearch: this.toSearch
	    };
	  }
	};
	
	exports.default = OutstadingSearchForm;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OutstandingBetApiService = function () {
	  OutstandingBetApiService.$inject = ["HttpService"];
	  function OutstandingBetApiService(HttpService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OutstandingBetApiService);
	    this.HttpService = HttpService;
	  }
	
	  (0, _createClass3.default)(OutstandingBetApiService, [{
	    key: 'getBetList',
	    value: function getBetList(url) {
	      return this.HttpService.get(url);
	    }
	  }]);
	  return OutstandingBetApiService;
	}();
	
	exports.default = OutstandingBetApiService;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _bethistory = __webpack_require__(1473);
	
	var _bethistory2 = _interopRequireDefault(_bethistory);
	
	var _form = __webpack_require__(1476);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _detailsModal = __webpack_require__(1480);
	
	var _detailsModal2 = _interopRequireDefault(_detailsModal);
	
	var _api = __webpack_require__(1483);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bethistoryModule = _angular2.default.module('bethistory', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('bethistory', {
	    parent: 'standardLayout',
	    url: '/bet-history',
	    component: 'bethistory',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('bethistory', _bethistory2.default).component('bethistorySearchForm', _form2.default).component('betDetailsModal', _detailsModal2.default).service('BetHistoryApiService', _api2.default).name;
	
	exports.default = bethistoryModule;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bethistory = __webpack_require__(1474);
	
	var _bethistory2 = _interopRequireDefault(_bethistory);
	
	var _bethistory3 = __webpack_require__(1475);
	
	var _bethistory4 = _interopRequireDefault(_bethistory3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bethistoryComponent = {
	  bindings: {
	    brokerageSyncId: '<'
	  },
	  template: _bethistory2.default,
	  controller: _bethistory4.default
	};
	
	exports.default = bethistoryComponent;

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper\">\n    <div class=\"content\">\n        <div class=\"container\">\n            <div class=\"content-left col-sm-10 fadeIn animated\">\n                <div class=\"col-sm-12\">\n                \t<div class=\"card-box\">\n                    \t<section>\n                    \t\t<h4 class=\"m-t-0 page-header\"><strong>Bet History</strong></h4>\n\t                      \t<div class = \"card-box\">\n                                <form action =\"\">\n                                    <div class=\"col-md-4 col-sm-6 col-xs-6 date-input\">\n                                        <div class=\"form-group\">\n                                            <label class=\"control-label col-sm-2 mtop2\">From</label>\n                                            <div class=\"col-sm-10\">\n                                                <div class=\"input-group\" id=\"dateFrom\">\n                                                    <date-picker ng-model=\"$ctrl.BethistorySearchForm.fromSearch\"></date-picker>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-md-4 col-sm-6 col-xs-6 date-input\">\n                                        <div class=\"form-group\">\n                                            <label class=\"control-label col-sm-2 mtop2\">To</label>\n                                            <div class=\"col-sm-10\">\n                                                <div class=\"input-group\" id=\"dateTo\">\n                                                    <date-picker ng-model=\"$ctrl.BethistorySearchForm.toSearch\"></date-picker>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-md-4 col-sm-12\">\n                                        <button ng-click=\"$ctrl.drawSettledBetSummary()\" type=\"button\" class=\"btn btn-danger waves-effect waves-light ac-color\" id=\"btnSearch\">Search</button>\n                                        <button ng-click=\"$ctrl.resetForm()\" type=\"button\" class=\"btn btn-inverse waves-effect waves-light\">Reset Filter</button>\n                                    </div>\n                                    <div class=\"clearfix\"></div>\n                                </form>\n\t                      \t</div>\n\t                    \t<div class=\"row\">\n\t                        \t<div class=\"panel-body\">\n\t                        \t\t<div class=\"col-md-2 sel-show\">\n\t                            \t\t<span>Show</span>\n\t                        \t\t\t<div class=\"sel-entry\">\n\t\t\t                              <select ng-model=\"$ctrl.changelimit\" ng-change=\"$ctrl.changeLimit()\" class=\"form-control input-sm\" id=\"betHistoryLength\">\n\t\t\t                                <option value=\"10\">10</option>\n\t\t\t                                <option value=\"25\">25</option>\n\t\t\t                                <option value=\"50\">50</option>\n\t\t\t                                <option value=\"100\">100</option>\n\t\t\t                              </select>\n\t                        \t\t\t</div>\n\t                        \t\t\t<span>Entries</span>\n\t                          \t\t</div>\n                                    <table id=\"datatable-responsive\" class=\"table toggle-circle m-b-0\" cellspacing=\"0\" width=\"100%\">\n                                        <thead>\n                                            <tr>\n                                                <th data-toggle=\"true\">Event Date</th>\n                                                <th>Number of Bets</th>\n                                                <th data-hide=\"phone\">Total Turnover</th>\n                                                <th data-hide=\"phone\">Total Valid Turnover</th>\n                                                <th data-hide=\"phone\">Win / Loss</th>\n                                            </tr>\n                                        </thead>\n                                        <tbody>\n                                            <tr ng-repeat=\"summaryBet in $ctrl.summaryBets\">\n                                                <td>{{ $ctrl.formatdate(summaryBet.event_date) }}</td>\n                                                <td><input class=\"btn btn-danger\" value=\"Expand ({{ summaryBet.number_of_bets }})\" id=\"btnViewBets{{ summaryBet.id }}\"type=\"button\" ng-click=\"$ctrl.viewBetDetails(summaryBet.event_date, summaryBet.id)\"></td>\n                                                <td>{{ summaryBet.stake }}</td>\n                                                <td>{{ summaryBet.turnover }}</td>\n                                                <td>{{ summaryBet.winLossAmount }}</td>\n                                            </tr>\n                                            <tr ng-hide=\"$ctrl.recordsTotal > 0\">\n                                                <td colspan=\"6\" style=\"text-align: center\">{{ $ctrl.textDisplay }}</td>\n                                            </tr>\n                                        </tbody>\n                                    </table>\n\t                        \t</div>\n\t\t                        <div class=\"showed-entry\">\n                                    <div class=\"col-sm-6\">\n                                        <span ng-hide=\"$ctrl.recordsTotal == 0\">Showing {{ $ctrl.recordsTotal > 0 ? $ctrl.offset : 0 }} to {{ $ctrl.endPoint < $ctrl.recordsTotal ? $ctrl.endPoint : $ctrl.recordsTotal }} of {{ $ctrl.recordsTotal }} entries</span>\n                                    </div>\n                                    <div class=\"col-sm-6\">\n                                        <div class=\"pull-right\">\n                                            <ul ng-hide=\"$ctrl.noOfPages < 2\" class=\"pagination-b\">\n                                                <li ng-class=\"{disabled: $ctrl.currentPage == 1}\">\n                                                    <a href ng-click=\"$ctrl.jumpTo($ctrl.currentPage > 1 ? $ctrl.currentPage - 1 : 1, $ctrl.noOfPages)\" ng-if=\"$ctrl.currentPage > 1\">« Prev</a><a ng-if=\"$ctrl.currentPage == 1\">« Prev</a>\n                                                </li>\n                                                <li ng-if=\"$ctrl.currentPage > 4\">\n                                                    <a href ng-click=\"$ctrl.jumpTo(1, $ctrl.noOfPages)\">1</a>\n                                                <li>\n                                                <li ng-if=\"$ctrl.currentPage > 4\">\n                                                    <a>...</a>\n                                                <li>\n                                                <li ng-repeat=\"n in $ctrl.range($ctrl.currentPage, $ctrl.noOfPages)\"\n                                                    ng-class=\"{active: n == $ctrl.currentPage}\">\n                                                    <a ng-bind=\"n\" ng-click=\"$ctrl.jumpTo(n, $ctrl.noOfPages)\">{{ n }}</a>\n                                                </li>\n                                                <li ng-if=\"($ctrl.noOfPages - $ctrl.currentPage) > 3\">\n                                                    <a>...</a>\n                                                <li>\n                                                <li ng-if=\"($ctrl.noOfPages - $ctrl.currentPage) > 3\">\n                                                    <a href ng-click=\"$ctrl.jumpTo($ctrl.noOfPages, $ctrl.noOfPages)\">{{ $ctrl.noOfPages }}</a>\n                                                <li>\n                                                <li ng-class=\"{disabled: $ctrl.currentPage == $ctrl.noOfPages}\">\n                                                    <a href ng-click=\"$ctrl.jumpTo($ctrl.currentPage < $ctrl.noOfPages ? $ctrl.currentPage + 1 : $ctrl.noOfPages, $ctrl.noOfPages)\" ng-if=\"$ctrl.currentPage < $ctrl.noOfPages\">Next »</a><a ng-if=\"$ctrl.currentPage >= $ctrl.noOfPages\">Next »</a>\n                                                </li>\n                                            </ul>\n                                        </div>\n                                    </div>\n\t\t                        </div>\n\t                      \t</div>\n                    \t</section>\n                  \t</div>\n                </div>\n            </div>\n        </div>\n\t</div>\n</div>\n<div id=\"betDetailsModal\" class=\"modal fade in\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                <h4 class=\"modal-title\">Bet History: {{ $ctrl.currentDate }}</h4>\n            </div>\n            <div class=\"modal-body\">\n                <div class=\"col-sm-12\">\n                    <table id=\"betHistoryDetails\" class=\"table toggle-circle m-b-0\" cellspacing=\"0\" width=\"100%\">\n                        <thead>\n                            <tr>\n                                <th data-hide=\"phone,tablet\">Date</th>\n                                <th data-hide=\"phone,tablet\">Bet ID</th>\n                                <th data-toggle=\"true\">Bet Details</th>\n                                <th data-hide=\"phone,tablet\">Selection</th>\n                                <th data-hide=\"phone,tablet\">Odds</th>\n                                <th>Stake</th>\n                                <th>Valid Turnover</th>\n                                <th data-hide=\"phone,tablet\">Win/Loss Amount</th>\n                                <th data-hide=\"phone,tablet\">Status</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"bet in $ctrl.betList\">\n                                <td>{{ $ctrl.formatdate(bet.event_date) }} - {{ bet.event_time }}</td>\n                                <td>{{ bet.id }}</td>\n                                <td>{{ bet.home }}</td>\n                                <td>{{ bet.bet }}<span ng-show=\"{{ !bet.bet }}\" ng-repeat=\"detail in bet.betOption.lists\">{{ detail }} <br /></span></td>\n                                <td>{{ bet.odds }}</td>\n                                <td>{{ bet.stake }}</td>\n                                <td>{{ bet.turnover }}</td>\n                                <td>{{ bet.winLoss }}</td>\n                                <td>{{ bet.result }} <i ng-if=\"bet.result == 'Voided'\" class=\"fa fa-question-circle\" data-placement=\"right\" data-toggle=\"tooltip\" aria-hidden=\"true\" title=\"{{ bet.reason }}\"></i></td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n                <div class=\"clearfix\"></div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default pull-right\" id=\"bet-history-close-btn\" data-loading-text=\"Close\" data-dismiss=\"modal\">Close</button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div><!-- /.modal-dialog -->\n</div>\n"

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BethistoryController = function () {
	  BethistoryController.$inject = ["BetHistoryApiService", "SessionService", "EventDispatcherService", "$document", "$timeout"];
	  function BethistoryController(BetHistoryApiService, SessionService, EventDispatcherService, $document, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BethistoryController);
	    this.BetHistoryApiService = BetHistoryApiService;
	    this.SessionService = SessionService;
	    this.EventDispatcherService = EventDispatcherService;
	    this.htmlDocument = $document[0];
	    this.$timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(BethistoryController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.endPoint = 10;
	      this.offset = 1;
	      this.currentPage = 1;
	      this.currentDate = '';
	      this.maxSize = 5;
	      this.limit = 10;
	      this.selectlimit = 10;
	      this.textDisplay = 'Loading...';
	      this.changelimit = '10';
	      this.recordsTotal = 0;
	      this.noOfPages = 0;
	      this.brokerageSyncId = this.SessionService.get('brokerageSyncId');
	
	      this.subscription = this.EventDispatcherService.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this.drawSettledBetSummary();
	      });
	
	      this.drawSettledBetSummary();
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      this.$timeout(function () {
	        $('#datatable-responsive').footable();
	        $('#datatable-responsive').trigger('footable_redraw');
	
	        var screen = $(window);
	        if (screen.width() < 768) {
	          $('#betDetailsModal').on('shown.bs.modal', function (e) {
	            $('#betHistoryDetails').footable();
	            $('#betHistoryDetails').trigger('footable_redraw');
	          });
	        } else {
	          $('#betHistoryDetails').footable();
	          $('#betHistoryDetails').trigger('footable_redraw');
	        }
	      }, 0);
	    }
	  }, {
	    key: 'drawSettledBetSummary',
	    value: function drawSettledBetSummary() {
	      var _this2 = this;
	
	      this.limit = this.changelimit ? this.changelimit : this.limit;
	      var betSummaryLink = '/brokerage/get-settled-bet-summary' + this.getLink();
	      this.htmlDocument.getElementById('btnSearch').innerHTML = 'Searching...';
	
	      this.BetHistoryApiService.getSettledBetSummary(betSummaryLink).then(function (response) {
	        var summaryData = response.data;
	        _this2.recordsTotal = response.recordsTotal;
	
	        _this2.summaryBets = summaryData.map(function (value) {
	          var summary = value;
	          summary.stake = _this2.formatAmount(value.stake);
	          summary.turnover = _this2.formatAmount(value.turnover);
	          /*jshint camelcase: false */
	          summary.winLossAmount = _this2.formatAmount(value.win_loss_amount);
	
	          return summary;
	        });
	
	        if (_this2.recordsTotal === 0) {
	          _this2.textDisplay = 'No results to display!';
	        }
	
	        _this2.htmlDocument.getElementById('btnSearch').innerHTML = 'Search';
	        _this2.noOfPages = Math.floor(_this2.recordsTotal / _this2.limit) + 1;
	
	        _this2.renderTable();
	      });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.htmlDocument.getElementById('dateTo').getElementsByClassName('filter-from-date')[0].value = '';
	      this.htmlDocument.getElementById('dateFrom').getElementsByClassName('filter-from-date')[0].value = '';
	
	      this.drawSettledBetSummary();
	    }
	  }, {
	    key: 'getLink',
	    value: function getLink() {
	      var dateFrom = this.htmlDocument.getElementById('dateFrom').getElementsByClassName('filter-from-date')[0].value;
	      var dateTo = this.htmlDocument.getElementById('dateTo').getElementsByClassName('filter-from-date')[0].value;
	      var paramText = '?id=' + this.brokerageSyncId + '&limit=' + this.limit + '&offset=' + (this.offset - 1) + '&from=' + dateFrom + '&to=' + dateTo;
	
	      return paramText;
	    }
	  }, {
	    key: 'changeLimit',
	    value: function changeLimit() {
	      this.currentPage = 1;
	      this.changelimit = this.htmlDocument.getElementById('betHistoryLength').value;
	      this.endPoint = this.changelimit;
	      this.offset = 1;
	      this.drawSettledBetSummary();
	    }
	  }, {
	    key: 'viewBetDetails',
	    value: function viewBetDetails(date, id) {
	      var _this3 = this;
	
	      this.betList = [];
	
	      var previousInnerHtml = this.htmlDocument.getElementById('btnViewBets' + id).value;
	      this.htmlDocument.getElementById('btnViewBets' + id).value = 'Loading...';
	
	      var betLinkDetails = '/brokerage/get-bet-list?id=' + this.brokerageSyncId + '&date=' + date;
	      this.BetHistoryApiService.getBetList(betLinkDetails).then(function (response) {
	        var betData = response.data;
	        _this3.betList = betData.map(function (value) {
	          var bet = value;
	          bet.stake = _this3.formatAmount(value.stake);
	          bet.turnover = _this3.formatAmount(value.turnover);
	          bet.odds = _this3.formatAmount(value.odds);
	          bet.winLoss = _this3.formatAmount(value.winLoss);
	          bet.bet = _this3.betSelected(value);
	          bet.home = _this3.betDetails(value);
	          bet.result = _this3.betStatus(value.result);
	          bet.betOption = JSON.parse(value.betOption);
	
	          return bet;
	        });
	
	        _this3.currentDate = _this3.formatdate(date);
	        _this3.htmlDocument.getElementById('btnViewBets' + id).value = previousInnerHtml;
	        $('#betDetailsModal').modal('show');
	      });
	    }
	  }, {
	    key: 'formatdate',
	    value: function formatdate(date) {
	      var key = date.split('-');
	
	      return key[1] + '/' + key[2] + '/' + key[0];
	    }
	  }, {
	    key: 'betDetails',
	    value: function betDetails(data) {
	      var betRequestType = parseInt(data.betRequestType);
	
	      switch (betRequestType) {
	        case 0:
	          var texta = this.halfFullTime(data.halftimeBet) + '/' + this.betType(data.betType) + ':';
	          var textb = ' ' + data.home + ' VS ' + data.away + ' ' + this.currentScore(data.currentScore);
	
	          return '' + texta + textb;
	        case 1:
	          return data.home + ' VS ' + data.away;
	        default:
	          return data.away;
	      }
	    }
	  }, {
	    key: 'betSelected',
	    value: function betSelected(data) {
	      if (data.betRequestType === 0) {
	        var bet = parseInt(data.bet);
	
	        switch (bet) {
	          case 0:
	            bet = 'DRAW ';
	            break;
	          case 1:
	            bet = 'HOME ';
	            break;
	          case 2:
	            bet = 'AWAY ';
	            break;
	          case 3:
	            bet = 'UNDER ';
	            break;
	          case 4:
	            bet = 'OVER ';
	            break;
	        }
	
	        return bet + this.handicap(data);
	      }
	
	      var betOption = angular.fromJson(data.betOption);
	
	      if (data.betRequestType === 1) {
	        return betOption.special;
	      }
	
	      return '';
	    }
	  }, {
	    key: 'handicap',
	    value: function handicap(data) {
	      return 0 > data.betType ? '' : this.formatAmount(data.handicap);
	    }
	  }, {
	    key: 'halfFullTime',
	    value: function halfFullTime(value) {
	      return !value ? 'FT' : 'HT';
	    }
	  }, {
	    key: 'betType',
	    value: function betType(value) {
	      value = parseInt(value);
	
	      switch (value) {
	        case 0:
	          return 'AHDP';
	        case 1:
	          return 'OU';
	        default:
	          return '1X2';
	      }
	    }
	  }, {
	    key: 'currentScore',
	    value: function currentScore(value) {
	      return value ? ' (' + value + ')' : '';
	    }
	  }, {
	    key: 'formatAmount',
	    value: function formatAmount(value) {
	      var sign = 0 > value ? '-' : '';
	      value = parseFloat(Math.abs(value).toFixed(4));
	      var count = value.toString().split('.')[1] ? value.toString().split('.')[1].length : 0;
	
	      switch (count) {
	        case 0:
	          value = sign + value + '.00';
	          break;
	        case 1:
	          value = sign + value + '0';
	          break;
	        default:
	          value = sign + value;
	          break;
	      }
	      var components = value.toString().split('.');
	      components[0] = components[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	
	      return components.join('.');
	    }
	  }, {
	    key: 'betStatus',
	    value: function betStatus(value) {
	      value = parseInt(value);
	
	      switch (value) {
	        case 0:
	          return 'Voided';
	        case 1:
	          return 'Win';
	        case 2:
	          return 'Half Win';
	        case 3:
	          return 'Lose';
	        case 4:
	          return 'Half Lose';
	        case 5:
	          return 'Stake Returned';
	      }
	    }
	  }, {
	    key: 'range',
	    value: function range(current, noOfPages) {
	      this.output = [];
	      var min = 0;
	      var max = 0;
	      if (current < 5 && noOfPages - current > 3) {
	        min = 1;
	        max = 5;
	      } else if (noOfPages < 5 && noOfPages > 1) {
	        min = 1;
	        max = noOfPages;
	      } else if (noOfPages - current > 3) {
	        min = current - 1;
	        max = current + 1;
	      } else if (noOfPages - current <= 3 && noOfPages !== 1) {
	        min = noOfPages - 4;
	        max = noOfPages;
	      }
	
	      if (max !== 0) {
	        for (this.i = min; this.i <= max; this.i += 1) {
	          this.output.push(this.i);
	        }
	      }
	
	      return this.output;
	    }
	  }, {
	    key: 'jumpTo',
	    value: function jumpTo(current, noOfPages) {
	      this.endPoint = this.limit * current;
	      this.offset = this.limit * current - this.limit;
	      this.offset = this.offset + 1;
	      this.currentPage = current;
	      this.drawSettledBetSummary();
	    }
	  }]);
	  return BethistoryController;
	}();
	
	exports.default = BethistoryController;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1477);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1478);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    BethistorySearchForm: '<',
	    onSubmit: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	module.exports = ""

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1479);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  function FormController() {
	    (0, _classCallCheck3.default)(this, FormController);
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.BethistorySearchForm = _form2.default;
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal() {
	      $('#betDetailsModal').modal('show');
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.onSubmit({ payload: this.BethistorySearchForm.toPayload() });
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BethistorySearchForm = {
	  fromSearch: '',
	  toSearch: '',
	
	  toPayload: function toPayload() {
	    return {
	      fromSearch: this.fromSearch,
	      toSearch: this.toSearch
	    };
	  }
	};
	
	exports.default = BethistorySearchForm;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _details = __webpack_require__(1481);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _detailsModal = __webpack_require__(1482);
	
	var _detailsModal2 = _interopRequireDefault(_detailsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var detailsModalComponent = {
	  bindings: {},
	  template: _details2.default,
	  controller: _detailsModal2.default
	};
	
	exports.default = detailsModalComponent;

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"betDetailsModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myLargeModalLabel\" aria-hidden=\"true\" style=\"display: none;\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                <h4 class=\"modal-title\">Large modal</h4>\n            </div>\n            <div class=\"modal-body\">\n                ...\n            </div>\n        </div><!-- /.modal-content -->\n    </div><!-- /.modal-dialog -->\n</div><!-- /.modal -->"

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailsModalController = function DetailsModalController() {
	    (0, _classCallCheck3.default)(this, DetailsModalController);
	};
	
	exports.default = DetailsModalController;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetHistoryApiService = function () {
	  BetHistoryApiService.$inject = ["HttpService"];
	  function BetHistoryApiService(HttpService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BetHistoryApiService);
	    this.HttpService = HttpService;
	  }
	
	  (0, _createClass3.default)(BetHistoryApiService, [{
	    key: 'getSettledBetSummary',
	    value: function getSettledBetSummary(url) {
	      return this.HttpService.get(url);
	    }
	  }, {
	    key: 'getBetList',
	    value: function getBetList(url) {
	      return this.HttpService.getNonAsync(url);
	    }
	  }]);
	  return BetHistoryApiService;
	}();
	
	exports.default = BetHistoryApiService;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _acrewards = __webpack_require__(1485);
	
	var _acrewards2 = _interopRequireDefault(_acrewards);
	
	var _acrewards3 = __webpack_require__(1491);
	
	var _acrewards4 = _interopRequireDefault(_acrewards3);
	
	var _form = __webpack_require__(1492);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var acrewardsModule = _angular2.default.module('acrewards', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('acrewards', {
	    url: '/acrewards',
	    component: 'acrewards',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('acrewards', _acrewards2.default).service('AcrewardsStore', _acrewards4.default).component('acRewardsForm', _form2.default).name;
	
	exports.default = acrewardsModule;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _acrewards = __webpack_require__(1486);
	
	var _acrewards2 = _interopRequireDefault(_acrewards);
	
	var _acrewards3 = __webpack_require__(1487);
	
	var _acrewards4 = _interopRequireDefault(_acrewards3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var acrewardsComponent = {
	  bindings: {},
	  template: _acrewards2.default,
	  controller: _acrewards4.default
	};
	
	exports.default = acrewardsComponent;

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray affiliate-dashboard\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 fadeIn animated\">\n          <div class=\"card-box\">\n            <!-- Filters -->\n            <ac-rewards-form form=\"$ctrl.form\" on-submit=\"$ctrl.submit(payload)\" periods=\"$ctrl.model.periods\" on-filtered=\"$ctrl.onFiltered(data, total)\"></ac-rewards-form>\n\n            <!-- Tabs -->\n            <div class=\"row mtop3\">\n              <div class=\"col-md-12\">\n                <div class=\"banner-tabs\">\n                  <!-- Tabs -->\n                  <ul class=\"nav nav-tabs nav-justified\" id=\"commissionTab\">\n                    <li class=\"active tab\" data-order=\"productName\">\n                      <a ng-click=\"$ctrl.onOrderBy('productName', $ctrl.model.periods, 0, 'desc')\" data-target=\"#product-tab\" data-toggle=\"tab\">\n                        <span>Commission </span>\n                      </a>\n                    </li>\n                    <li class=\"tab\" data-order=\"memberId\" ng-if=\"$ctrl.model.allowRevenueShare\">\n                      <a ng-click=\"$ctrl.onOrderBy('memberId', $ctrl.model.periods, 1, 'desc')\" data-target=\"#revenue-share-tab\" data-toggle=\"tab\">\n                        <span>Revenue Share</span>\n                      </a>\n                    </li>\n                  </ul>\n\n                  <!-- Content -->\n                  <div class=\"tab-content no-p\">\n                    <!-- Product Tab -->\n                    <div class=\"tab-pane active\" id=\"product-tab\">\n                      <div class=\"row table-loading\">\n                        <div class=\"col-sm-12 text-center\">\n                          <strong><i>{{ 'loadingPageContent' | translate }}</i></strong>\n                        </div>\n                      </div>\n\n                      <div class=\"row\">\n                        <div class=\"col-md-12\">\n                          <!--Product Table-->\n                          <div class=\"commissions-table m-t-20 m-b-20\">\n                            <div class=\"table-responsive\">\n                              <!-- Desktop -->\n                              <table id=\"turnover-table-product\" class=\"table m-0 dt-responsive nowrap turnover-table affilite-table-desktop\" cellspacing=\"0\" width=\"100%\">\n                                <thead>\n                                <tr>\n                                  <th data-hide=\"phone\" ng-click=\"$ctrl.onOrderBy('productName', $ctrl.model.periods, 0, $ctrl.sort)\">{{ 'tables.product' | translate }}</th>\n                                  <th data-toggle=\"true\" ng-click=\"$ctrl.onOrderBy('memberId', $ctrl.model.periods, 0, $ctrl.sort)\">{{ 'tables.memberId' | translate }}</th>\n                                  <th data-sort-ignore=\"true\" data-hide=\"phone\">{{ 'tables.totalTurnover' | translate }}</th>\n                                  <th data-sort-ignore=\"true\" class=\"hidden\">{{ 'tables.totalWinLoss' | translate }}</th>\n                                  <th data-sort-ignore=\"true\">{{ 'tables.totalCommission' | translate }}</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr ng-repeat=\"(key, product) in $ctrl.model.products\">\n                                  <td>{{ product.productName }}</td>\n                                  <td>{{ product.memberId }}</td>\n                                  <td>{{ product.currencyCode }} {{ product.totalTurnover.rounded }}</td>\n                                  <td scope=\"row\" class=\"hidden\">{{ product.currencyCode }} {{ product.totalWinLoss.rounded }}</td>\n                                  <td scope=\"row\">{{ $ctrl.model.currency }} {{ product.totalAffiliateCommission.rounded }}</td>\n                                </tr>\n                                </tbody>\n                              </table>\n\n                              <!-- Mobile -->\n                              <table class=\"table m-0 dt-responsive nowrap turnover-table affilite-table-mobile\" cellspacing=\"0\" width=\"100%\">\n                                <thead>\n                                <tr>\n                                  <th data-hide=\"phone\" ng-click=\"$ctrl.onOrderBy('productName', $ctrl.model.periods, 0, $ctrl.sort)\">{{ 'tables.product' | translate }}</th>\n                                  <th data-toggle=\"true\" ng-click=\"$ctrl.onOrderBy('memberId', $ctrl.model.periods, 0, $ctrl.sort)\">{{ 'tables.memberId' | translate }}</th>\n                                  <th data-sort-ignore=\"true\" data-hide=\"phone\">{{ 'tables.totalTurnover' | translate }}</th>\n                                  <th data-sort-ignore=\"true\" class=\"hidden\">{{ 'tables.totalWinLoss' | translate }}</th>\n                                  <th data-sort-ignore=\"true\">{{ 'tables.totalCommission' | translate }}</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr ng-repeat=\"(key, product) in $ctrl.model.products\">\n                                  <td>{{ product.productName }}</td>\n                                  <td>{{ product.memberId }}</td>\n                                  <td>{{ product.currencyCode }} {{ product.totalTurnover.rounded }}</td>\n                                  <td scope=\"row\" class=\"hidden\">{{ product.currencyCode }} {{ product.totalWinLoss.rounded }}</td>\n                                  <td scope=\"row\">{{ $ctrl.model.currency }} {{ product.totalAffiliateCommission.rounded }}</td>\n                                </tr>\n                                </tbody>\n                              </table>\n                            </div>\n\n                            <div class=\"row\">\n                              <div class=\"col-md-4 col-sm-12 m-t-10 m-b-10\">Date Covered:<br>\n                                <strong class=\"text-red\">{{ $ctrl.model.periods.dwlDateFrom |date : 'MMM d, yyyy' }} - {{ $ctrl.model.periods.dwlDateTo |date : 'MMM d, yyyy' }}</strong>\n                              </div>\n                              <div class=\"col-md-4 col-sm-6 col-xs-6 m-t-10 m-b-10\">{{ 'Total Turnover:' | translate }}\n                                <ul class=\"list-unstyled\">\n                                  <li ng-repeat=\"(key, value) in $ctrl.model.totals\"><strong class=\"text-red\">{{ value.currencyCode }} {{ value.totalTurnover.rounded }}</strong></li>\n                                </ul>\n                              </div>\n                              <div class=\"hidden\">{{ 'Total Customer W/L:' | translate }}\n                                <ul class=\"list-unstyled\">\n                                  <li ng-repeat=\"(key, value) in $ctrl.model.totals\"><strong class=\"text-red\">{{ value.currencyCode }} {{ value.totalWinLoss.rounded }}</strong></li>\n                                </ul>\n                              </div>\n                              <div class=\"col-md-4 col-sm-6 col-xs-6 m-t-10 m-b-10\">{{ 'Total Affiliate Commission:' | translate }}\n                                <ul class=\"list-unstyled\">\n                                  <li ng-repeat=\"(key, value) in $ctrl.model.totals\"><strong class=\"text-red\" ng-if=\"$ctrl.model.currency == value.currencyCode\">{{ value.currencyCode }} {{ value.totalAffiliateCommission.rounded }}</strong></li>\n                                </ul>\n                              </div>\n                            </div>\n                          </div>\n                          <!--Product Table-->\n                        </div>\n                      </div>\n\n                      <div class=\"row\">\n                        <div class=\"col-md-6\">\n                          <div class=\"pull-left\">\n                            <a ng-click=\"$ctrl.exportToCSV()\" class=\"btn btn-csv export-csv\">{{ 'exportCsv' | translate }}</a>\n                          </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                          <div class=\"pull-right\">\n                            <pagination2 on-page-clicked=\"$ctrl.onPageClicked(page, offset, $ctrl.model.orderBy, $ctrl.model.periods, $ctrl.model.filterRevenueShare, $ctrl.model.sort)\" max-page-count=\"5\" limit-per-page=\"$ctrl.model.pageParams.limit\" total=\"$ctrl.model.pageParams.recordsFiltered\"></pagination2>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n\n                    <!-- Revenue Share Tab -->\n                    <div class=\"tab-pane\" id=\"revenue-share-tab\" ng-if=\"$ctrl.model.filterRevenueShare\">\n                      <div class=\"row table-loading\">\n                        <div class=\"col-sm-12 text-center\">\n                          <strong><i>{{ 'loadingPageContent' | translate }}</i></strong>\n                        </div>\n                      </div>\n                      <div class=\"row\">\n                        <div class=\"col-md-12\">\n                          <!--Revshare Table-->\n                          <div class=\"commissions-table\">\n                            <div class=\"table-responsive\">\n                              <!-- Desktop -->\n                              <table id=\"rev-share-table\" class=\"table m-0 dt-responsive nowrap turnover-table affilite-table-desktop\" cellspacing=\"0\" width=\"100%\">\n                                <thead>\n                                <tr>\n                                  <th data-toggle=\"true\" ng-click=\"$ctrl.onOrderBy('memberId', $ctrl.model.periods, 1, $ctrl.sort)\">{{ 'tables.memberId' | translate }}</th>\n                                  <th data-hide=\"phone\" ng-click=\"$ctrl.onOrderBy('productName', $ctrl.model.periods, 1, $ctrl.sort)\">{{ 'tables.product' | translate }}</th>\n                                  <th data-sort-ignore=\"true\">{{ 'W/L' | translate }}</th>\n                                  <th data-sort-ignore=\"true\">{{ 'Bonus' | translate }}</th>\n                                  <th data-sort-ignore=\"true\">{{ 'Revenue Share' | translate }}</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr ng-repeat=\"(key, revProduct) in $ctrl.model.products\">\n                                  <td>{{ revProduct.memberId }}</td>\n                                  <td>{{ revProduct.productName }}</td>\n                                  <td>{{ revProduct.currencyCode }} {{ revProduct.totalWinLoss.rounded }}</td>\n                                  <td scope=\"row\">{{ revProduct.currencyCode }} {{ revProduct.totalBonus.rounded }}</td>\n                                  <td scope=\"row\">{{ $ctrl.model.currency }} {{ revProduct.totalRevenueShare.rounded }}</td>\n                                </tr>\n                                </tbody>\n                              </table>\n\n                              <!-- Mobile -->\n                              <table class=\"table m-0 dt-responsive nowrap turnover-table affilite-table-mobile\" cellspacing=\"0\" width=\"100%\">\n                                <thead>\n                                <tr>\n                                  <th data-toggle=\"true\" ng-click=\"$ctrl.onOrderBy('memberId', $ctrl.model.periods, 1, $ctrl.sort)\">{{ 'tables.memberId' | translate }}</th>\n                                  <th data-hide=\"phone\" ng-click=\"$ctrl.onOrderBy('productName', $ctrl.model.periods, 1, $ctrl.sort)\">{{ 'tables.product' | translate }}</th>\n                                  <th data-sort-ignore=\"true\">{{ 'W/L' | translate }}</th>\n                                  <th data-sort-ignore=\"true\">{{ 'Bonus' | translate }}</th>\n                                  <th data-sort-ignore=\"true\">{{ 'Revenue Share' | translate }}</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr ng-repeat=\"(key, revProduct) in $ctrl.model.products\">\n                                  <td>{{ revProduct.memberId }}</td>\n                                  <td>{{ revProduct.productName }}</td>\n                                  <td>{{ revProduct.currencyCode }} {{ revProduct.totalWinLoss.rounded }}</td>\n                                  <td scope=\"row\">{{ revProduct.currencyCode }} {{ revProduct.totalBonus.rounded }}</td>\n                                  <td scope=\"row\">{{ $ctrl.model.currency }} {{ revProduct.totalRevenueShare.rounded }}</td>\n                                </tr>\n                                </tbody>\n                              </table>\n                            </div>\n\n                            <div class=\"row\">\n                              <div class=\"col-md-3 col-sm-12 m-t-10 m-b-10\">{{ 'Date Covered:' | translate }} <br>\n                                <strong class=\"text-red\">{{ $ctrl.model.periods.dwlDateFrom |date : 'MMM d, yyyy' }} - {{ $ctrl.model.periods.dwlDateTo |date : 'MMM d, yyyy' }}</strong>\n                              </div>\n                              <div class=\"col-md-3 col-sm-6 col-xs-6 m-t-10 m-b-10\">{{ 'Total W/L:' | translate }}\n                                <ul class=\"list-unstyled\">\n                                  <li ng-repeat=\"(key, value) in $ctrl.model.totals\"><strong class=\"text-red\">{{ value.currencyCode }} {{ value.totalWinLoss.rounded }}</strong></li>\n                                </ul>\n                              </div>\n                              <div class=\"col-md-3 col-sm-6 col-xs-6 m-t-10 m-b-10\">{{ 'Total Bonus:' | translate }}\n                                <ul class=\"list-unstyled\">\n                                  <li ng-repeat=\"(key, value) in $ctrl.model.totals\"><strong class=\"text-red\">{{ value.currencyCode }} {{ value.totalAffiliateBonus.rounded }}</strong></li>\n                                </ul>\n                              </div>\n                              <div class=\"col-md-3 col-sm-6 col-xs-6 m-t-10 m-b-10\">{{ 'Total Revenue Share:' | translate }}\n                                <ul class=\"list-unstyled\">\n                                  <li ng-repeat=\"(key, value) in $ctrl.model.totals\"><strong class=\"text-red\" ng-if=\"$ctrl.model.currency == value.currencyCode\">{{ value.currencyCode }} {{ value.totalAffiliateRevenueShare.rounded }}</strong></li>\n                                </ul>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n\n                      <div class=\"row\">\n                        <div class=\"col-md-6\">\n                          <div class=\"pull-left\">\n                            <a ng-click=\"$ctrl.exportToCSV()\" class=\"btn btn-csv\">{{ 'exportCsv' | translate }}</a>\n                          </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                          <div class=\"pull-right affiliate-commission-pagination\">\n                            <pagination2 on-page-clicked=\"$ctrl.onPageClicked(page, offset, $ctrl.model.orderBy, $ctrl.model.periods, $ctrl.model.filterRevenueShare, $ctrl.model.sort)\" max-page-count=\"5\" limit-per-page=\"$ctrl.model.pageParams.limit\" total=\"$ctrl.model.pageParams.recordsFiltered\"></pagination2>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<request-product-modal></request-product-modal>\n<product-password-widget></product-password-widget>"

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	var _lodash = __webpack_require__(1122);
	
	var _export = __webpack_require__(1488);
	
	var _acrewards = __webpack_require__(1489);
	
	var _acrewards2 = _interopRequireDefault(_acrewards);
	
	var _moment = __webpack_require__(1256);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcrewardsController = function () {
	    AcrewardsController.$inject = ["AcrewardsStore", "PageService", "$timeout", "$scope", "$translate"];
	    function AcrewardsController(AcrewardsStore, PageService, $timeout, $scope, $translate) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, AcrewardsController);
	        this.AcrewardsStore = AcrewardsStore;
	        this.PageService = PageService;
	        this.$timeout = $timeout;
	        this.$scope = $scope;
	        this.$translate = $translate;
	    }
	
	    (0, _createClass3.default)(AcrewardsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.model = new _acrewards2.default();
	            this.subject = new _Rx2.default.BehaviorSubject();
	            this.sort = 'asc';
	
	            $('.table-loading').show();
	            $('.turnover-table').hide();
	
	            this.AcrewardsStore.getProfile().then(function (resp) {
	                _this.allowRevenueShare = resp.allow_revenue_share;
	                _this.getTurnOverCommissionDetails();
	                _this.updateModel();
	            });
	        }
	    }, {
	        key: 'tableEventHandler',
	        value: function tableEventHandler() {
	            this.$timeout(function () {
	                $(window).resize(function () {
	                    $('#rev-share-table').footable();
	                    $('#rev-share-table').trigger('footable_redraw');
	                    $('#turnover-table-product').footable();
	                    $('#turnover-table-product').trigger('footable_redraw');
	                });
	                $(window).trigger('resize');
	
	                window.dispatchEvent(new Event('resize'));
	
	                var evt = window.document.createEvent('UIEvents');
	                evt.initUIEvent('resize', true, false, window, 0);
	                window.dispatchEvent(evt);
	            }, 0);
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable(data) {
	            $('.table-loading').hide();
	            this.model.products = data.products;
	            this.model.members = data.members;
	            this.model.totals = data.totals;
	            this.model.turnoverWinLossCommission = data.records;
	            this.model.periods = data.period;
	            this.model.pageParams = data.pageParams;
	            this.model.allowRevenueShare = this.allowRevenueShare;
	            this.model.sort = this.sort;
	            this.$timeout(function () {
	                $('.turnover-table').fadeIn(300);
	            }, 300);
	            this.tableEventHandler();
	        }
	    }, {
	        key: 'updateModel',
	        value: function updateModel() {
	            var _this2 = this;
	
	            this.AcrewardsStore.getDashboardDetails().then(function (details) {
	                _this2.model.currency = details.others.currency;
	                _this2.model.verifiedAt = details.others.verifiedAt;
	                _this2.model.status = details.others.verifiedAt ? _this2.$translate.instant('Verified') : _this2.$translate.instant('Not Verified');
	            });
	        }
	    }, {
	        key: 'getTurnOverCommissionDetails',
	        value: function getTurnOverCommissionDetails() {
	            var _this3 = this;
	
	            var payload = {
	                hideZeroCommission: 1,
	                limit: 10,
	                page: 1,
	                precision: 2,
	                orderBy: 'productName'
	            };
	
	            this.AcrewardsStore.getTurnOverCommissionList(payload).then(function (resp) {
	                _this3.renderTable(resp);
	            });
	        }
	    }, {
	        key: 'exportToCSV',
	        value: function exportToCSV() {
	            var _this4 = this;
	
	            $('.export-csv').html('Generating...');
	            var orderBy = this.model.filterRevenueShare ? 'memberId' : 'productName';
	            var payload = {
	                dwlDateFrom: this.model.periods.dwlDateFrom,
	                dwlDateTo: this.model.periods.dwlDateTo,
	                filterRevenueShare: this.model.filterRevenueShare,
	                limit: this.model.pageParams.recordsFiltered,
	                hideZeroCommission: 1,
	                orderBy: orderBy,
	                page: 1,
	                precision: 2,
	                sort: "asc"
	            };
	
	            this.AcrewardsStore.filterAction(payload).then(function (resp) {
	                var firstColumnText = _this4.model.filterRevenueShare ? 'Member ID,Product' : 'Product,Member ID';
	                var csvFileName = _this4.model.filterRevenueShare ? 'valid-turnovers-revenueshare.csv' : 'valid-turnovers-commission.csv';
	                var csvContent = _this4.model.filterRevenueShare ? firstColumnText + ',W/L,Bonus,Revenue Share,\n' : firstColumnText + ',Total TO,Affiliate Commission,\n';
	                var list = (0, _lodash.cloneDeep)(resp.records);
	                var resultTotalTurnover = '';
	                var resultTotalCommission = '';
	                var resultTotalRevenueShare = '';
	                var resultTotalAffiliateBonus = '';
	                var resultTotalWinLoss = '';
	                var defaultCurrency = _this4.model.currency;
	
	                for (var key in list) {
	                    var row = list[key];
	                    var productName = row.productName;
	                    var currencyCode = row.currencyCode;
	                    var totalTurnover = row.totalTurnover.rounded;
	                    var currencyCodeDefault = defaultCurrency;
	                    var totalCommission = row.totalAffiliateCommission.rounded;
	                    var totalBonus = row.totalBonus.rounded;
	                    var totalWinLoss = row.totalWinLoss.rounded;
	                    var totalRevenueShare = row.totalRevenueShare.rounded;
	
	                    if (!row.productName || row.productName == '') {
	                        productName = 'No Product';
	                        currencyCode = '';
	                        totalTurnover = '';
	                        currencyCodeDefault = '';
	                        totalCommission = '';
	                    }
	
	                    csvContent += _this4.model.filterRevenueShare ? row.memberId + ',' + productName : productName + ',' + row.memberId;
	                    csvContent += _this4.model.filterRevenueShare ? ',' + currencyCode + ' ' + totalWinLoss + ', ' + currencyCode + ' ' + totalBonus + ', ' + currencyCodeDefault + ' ' + totalRevenueShare + ',\n' : ',' + currencyCode + ' ' + totalTurnover + ',' + currencyCodeDefault + ' ' + totalCommission + ',\n';
	                }
	
	                angular.forEach(resp.totals, function (val, key) {
	                    resultTotalTurnover += val.currencyCode + ' ' + val.totalTurnover.rounded + ' ';
	                    resultTotalAffiliateBonus += val.currencyCode + ' ' + val.totalAffiliateBonus.rounded + ' ';
	                    resultTotalWinLoss += val.currencyCode + ' ' + val.totalWinLoss.rounded + ' ';
	                });
	
	                angular.forEach(resp.totals, function (val, key) {
	                    if (defaultCurrency == val.currencyCode) {
	                        resultTotalCommission += val.currencyCode + ' ' + val.totalAffiliateCommission.rounded + ' ';
	                        resultTotalRevenueShare += val.currencyCode + ' ' + val.totalAffiliateRevenueShare.rounded + ' ';
	                    }
	                });
	
	                if (resp.period.dwlDateFrom) {
	                    resp.period.dwlDateFrom = (0, _moment2.default)(resp.period.dwlDateFrom).format('YYYY-MM-DD');
	                }
	
	                if (resp.period.dwlDateTo) {
	                    resp.period.dwlDateTo = (0, _moment2.default)(resp.period.dwlDateTo).format('YYYY-MM-DD');
	                }
	
	                csvContent += _this4.model.filterRevenueShare ? 'Date Covered,,Total WinLoss, Total Bonus, Total Affiliate Revenue Share,\n' : 'Date Covered,,Total Turnover,Total Affiliate Commission,\n';
	                csvContent += _this4.model.filterRevenueShare ? resp.period.dwlDateFrom + ' - ' + resp.period.dwlDateTo + ',,' + resultTotalWinLoss + ',' + resultTotalAffiliateBonus + ',' + resultTotalRevenueShare + ',\n' : resp.period.dwlDateFrom + ' - ' + resp.period.dwlDateTo + ',,' + resultTotalTurnover + ',' + resultTotalCommission + ',\n';
	                (0, _export.exportToCSV)(csvContent, csvFileName);
	                $('.export-csv').html('Export as CSV');
	            });
	        }
	    }, {
	        key: 'onFiltered',
	        value: function onFiltered(data, total) {
	            this.model.turnoverWinLossCommission = data;
	            this.model.totals = total;
	            this.$scope.$broadcast('resetPages');
	            this.renderTable(data);
	        }
	    }, {
	        key: 'onOrderBy',
	        value: function onOrderBy(order, periods, filterRevenueShare) {
	            var _this5 = this;
	
	            var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	            this.model.filterRevenueShare = filterRevenueShare;
	            this.sort = sort == 'asc' ? 'desc' : 'asc';
	            this.model.orderBy = order;
	
	            var payload = {
	                limit: 10,
	                page: 1,
	                precision: 2,
	                orderBy: order,
	                dwlDateFrom: periods.dwlDateFrom,
	                dwlDateTo: periods.dwlDateTo,
	                filterRevenueShare: this.model.filterRevenueShare,
	                sort: this.sort,
	                hideZeroCommission: 1
	            };
	
	            $('.table-loading').show();
	            $('.turnover-table').hide();
	            $('.turnover-table').unbind();
	
	            this.AcrewardsStore.filterAction(payload).then(function (resp) {
	                $('.turnover-table').unbind();
	                _this5.$scope.$broadcast('resetPages');
	                _this5.sort = sort == 'asc' ? 'desc' : 'asc';
	                _this5.renderTable(resp);
	            });
	        }
	    }, {
	        key: 'onPageClicked',
	        value: function onPageClicked(page, offset, orderBy, periods, filterRevenueShare, sort) {
	            this.onPaginate(page, offset, orderBy, periods, filterRevenueShare, sort);
	        }
	    }, {
	        key: 'onPaginate',
	        value: function onPaginate(page, offset, orderBy, periods, filterRevenueShare, sort) {
	            var _this6 = this;
	
	            this.model.pageParams.page = page;
	            this.model.pageParams.offset = offset;
	            this.model.pageParams.orderBy = orderBy;
	            this.model.pageParams.precision = 2;
	            this.model.dateFrom = periods.dwlDateFrom;
	            this.model.dateTo = periods.dwlDateTo;
	            this.model.filterRevenueShare = filterRevenueShare;
	            this.model.pageParams.sort = sort;
	            this.model.pageParams.hideZeroCommission = 1;
	            this.AcrewardsStore.filterAction(this.model.toPayload()).then(function (resp) {
	                _this6.renderTable(resp);
	            });
	        }
	    }, {
	        key: 'onCustomerProductsLoaded',
	        value: function onCustomerProductsLoaded(customerProductsList) {
	            this.model.availableBalance = customerProductsList.balance;
	        }
	    }]);
	    return AcrewardsController;
	}();
	
	exports.default = AcrewardsController;

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.exportToCSV = exportToCSV;
	exports.exportToPDF = exportToPDF;
	function exportToCSV(content, fileName) {
	  var a = document.createElement('a');
	  var mimeType = 'text/csv;encoding:utf-8';
	
	  if (navigator.msSaveBlob) {
	    // IE10
	    navigator.msSaveBlob(new Blob([content], {
	      type: mimeType
	    }), fileName);
	  } else if (URL && 'download' in a) {
	    //html5 A[download]
	    a.href = URL.createObjectURL(new Blob([content], {
	      type: mimeType
	    }));
	    a.setAttribute('download', fileName);
	    document.body.appendChild(a);
	    a.click();
	    document.body.removeChild(a);
	  } else {
	    location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
	  }
	}
	
	function exportToPDF(data, content, fileName, pageSize, pageOrientation) {
	  var pdf = new shield.exp.PDFDocument({
	    author: "Asianconnect88",
	    created: new Date()
	  });
	
	  pdf.addPage(pageSize, pageOrientation);
	  pdf.table(50, 50, data, content, {
	    margins: {
	      top: 50,
	      left: 50
	    }
	  });
	
	  pdf.saveAs({
	    fileName: fileName
	  });
	}

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _date = __webpack_require__(1490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcrewardsModel = function () {
	  function AcrewardsModel() {
	    (0, _classCallCheck3.default)(this, AcrewardsModel);
	
	    this.balanceSummary = null;
	    this.balancePerProduct = null;
	    this.transactionTable = {
	      transactions: null,
	      pagination: null
	    };
	    this.customerProducts = null;
	    this.availableBalance = null;
	    this.currency = null;
	    this.turnOverCommission = null;
	    this.periods = null;
	    this.filterRevenueShare = 0;
	    this.allowRevenueShare = null;
	    this.totalRunningCommission = null;
	    this.totalWithdrawableAmount = null;
	    this.turnoverWinLossCommission = null;
	    this.runningCommissions = null;
	    this.products = null;
	    this.members = null;
	    this.totals = null;
	    this.dateFrom = null;
	    this.dateTo = null;
	    this.orderBy = 'productName';
	    this.pageParams = {
	      recordsTotal: null,
	      recordsFiltered: null,
	      limit: null,
	      page: null,
	      offset: null,
	      orderBy: null,
	      precision: null,
	      filterRevenueShare: null,
	      hideZeroCommission: null,
	      sort: null
	    };
	  }
	
	  (0, _createClass3.default)(AcrewardsModel, [{
	    key: 'toPayload',
	    value: function toPayload() {
	      return {
	        dwlDateFrom: this.dateFrom,
	        dwlDateTo: this.dateTo,
	        limit: this.pageParams.limit,
	        page: this.pageParams.page,
	        offset: this.pageParams.offset,
	        orderBy: this.pageParams.orderBy,
	        precision: this.pageParams.precision,
	        filterRevenueShare: this.filterRevenueShare,
	        hideZeroCommission: this.pageParams.hideZeroCommission,
	        sort: this.pageParams.sort
	      };
	    }
	  }]);
	  return AcrewardsModel;
	}();
	
	exports.default = AcrewardsModel;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentDate = exports.lastDayInMonth = exports.firstDayInMonth = undefined;
	exports.getCurrentDate = getCurrentDate;
	exports.formatDate = formatDate;
	exports.getFirstDayInMonth = getFirstDayInMonth;
	exports.getLastDayInMonth = getLastDayInMonth;
	
	var _moment = __webpack_require__(1256);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCurrentDate() {
	  var today = new Date();
	  var dd = today.getDate();
	  var mm = today.getMonth() + 1; //January is 0!
	  var yyyy = today.getFullYear();
	
	  if (dd < 10) {
	    dd = '0' + dd;
	  }
	
	  if (mm < 10) {
	    mm = '0' + mm;
	  }
	
	  today = mm + '/' + dd + '/' + yyyy;
	
	  return today;
	}
	
	function formatDate(dateString, format) {
	  var date = (0, _moment2.default)(dateString);
	
	  return date.format(format);
	}
	
	function getFirstDayInMonth() {
	  var newDate = (0, _moment2.default)();
	
	  return newDate.format('YYYY-MM') + '-01';
	}
	
	function getLastDayInMonth() {
	  var newDate = (0, _moment2.default)();
	
	  return newDate.format('YYYY-MM') + '-' + (0, _moment2.default)().daysInMonth();
	}
	
	exports.firstDayInMonth = getFirstDayInMonth;
	exports.lastDayInMonth = getLastDayInMonth;
	exports.currentDate = getCurrentDate;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeOtherDetails = makeOtherDetails;
	
	var _Rx = __webpack_require__(532);
	
	var _Rx2 = _interopRequireDefault(_Rx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeOtherDetails(details) {
	  return {
	    currency: details.currency,
	    verifiedAt: details.verified_at
	  };
	}
	
	var AcrewardsStore = function () {
	  AcrewardsStore.$inject = ["AcrewardsApiService", "CustomerApiService", "DashboardApiService", "SessionService", "ProfileApiService"];
	  function AcrewardsStore(AcrewardsApiService, CustomerApiService, DashboardApiService, SessionService, ProfileApiService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AcrewardsStore);
	    this.AcrewardsApiService = AcrewardsApiService;
	    this.CustomerApiService = CustomerApiService;
	    this.DashboardApiService = DashboardApiService;
	    this.SessionService = SessionService;
	    this.ProfileApiService = ProfileApiService;
	    this.currency$ = SessionService.session.map(function (session) {
	      return session ? session.currency : {};
	    });
	  }
	
	  (0, _createClass3.default)(AcrewardsStore, [{
	    key: 'getProfile',
	    value: function getProfile() {
	      return this.ProfileApiService.profile();
	    }
	  }, {
	    key: 'getDashboardDetails',
	    value: function getDashboardDetails() {
	      return this.DashboardApiService.dashboard().then(function (details) {
	        return {
	          others: makeOtherDetails(details)
	        };
	      });
	    }
	  }, {
	    key: 'getCustomerProducts',
	    value: function getCustomerProducts() {
	      return this.CustomerApiService.getProducts();
	    }
	  }, {
	    key: 'getTurnOverCommissionList',
	    value: function getTurnOverCommissionList(payload) {
	      return this.AcrewardsApiService.listTurnOverCommission(payload);
	    }
	  }, {
	    key: 'getCurrentRunningCommissionList',
	    value: function getCurrentRunningCommissionList() {
	      return this.AcrewardsApiService.getCurrentRunningCommission();
	    }
	  }, {
	    key: 'getPreviousRunningCommissionList',
	    value: function getPreviousRunningCommissionList() {
	      return this.AcrewardsApiService.getPreviousRunningCommission();
	    }
	  }, {
	    key: 'filterAction',
	    value: function filterAction(payload) {
	      return this.AcrewardsApiService.filterTurnOverCommission(payload);
	    }
	  }]);
	  return AcrewardsStore;
	}();
	
	exports.default = AcrewardsStore;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1493);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1494);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    form: '<',
	    onFiltered: '&',
	    periods: '<',
	    filterRevenueShare: '<'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	module.exports = "<form id=\"acrewards-form\" class=\"form-inline m-t-10\" role=\"form\" action=\"\" data-parsley-validate novalidate>\n    <div class=\"form-group\">\n        <label>{{ 'form.from' | translate }}  </label>\n        <div class=\"input-group\">\n            <date-picker ng-model=\"$ctrl.form.periods.dwlDateFrom\" date-format=\"'yyyy-mm-dd'\" placeholder=\"yyyy-mm-dd\"></date-picker>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label>{{ 'form.to' | translate }}  </label>\n        <div class=\"input-group\">\n            <date-picker ng-model=\"$ctrl.form.periods.dwlDateTo\" date-format=\"'yyyy-mm-dd'\" placeholder=\"yyyy-mm-dd\"></date-picker>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <ladda-button ng-click=\"$ctrl.submitForm()\" text=\"'Filter'\"></ladda-button>\n    </div>\n</form> "

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1495);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _acrewards = __webpack_require__(1489);
	
	var _acrewards2 = _interopRequireDefault(_acrewards);
	
	var _moment = __webpack_require__(1256);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  FormController.$inject = ["AcrewardsStore", "FormService", "$window", "$timeout"];
	  function FormController(AcrewardsStore, FormService, $window, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.AcrewardsStore = AcrewardsStore;
	    this.FormService = FormService;
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form2.default();
	      this.model = new _acrewards2.default();
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (this.periods && this.periods.dwlDateFrom && this.periods.dwlDateTo) {
	        this.form.periods = this.periods;
	        if (this.periods.dwlDateFrom) {
	          this.periods.dwlDateFrom = (0, _moment2.default)(this.periods.dwlDateFrom).format('YYYY-MM-DD');
	        }
	
	        if (this.periods.dwlDateTo) {
	          this.periods.dwlDateTo = (0, _moment2.default)(this.periods.dwlDateTo).format('YYYY-MM-DD');
	        }
	
	        this.form.dwlDateFrom = this.periods.dwlDateFrom;
	        this.form.dwlDateTo = this.periods.dwlDateTo;
	        this.form.filterRevenueShare = this.filterRevenueShare;
	      }
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var _this = this;
	
	      var order = $('ul#commissionTab').find('li.active').attr('data-order');
	      this.form.limit = 10;
	      this.form.precision = 2;
	      this.form.orderBy = order;
	      $('.commissions-table').hide();
	      $('.table-loading').show();
	
	      this.FormService.isSubmitting.next(true);
	      this.AcrewardsStore.filterAction(this.form.toPayload()).then(function (resp) {
	        $('.commissions-table').show();
	        $('.table-loading').hide();
	        _this.onFiltered({ data: resp, total: resp.totals });
	      }).catch(function (error) {
	        console.log(error);
	      }).finally(function () {
	        return _this.FormService.isSubmitting.next(false);
	      });
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcRewardsForm = function () {
	  function AcRewardsForm() {
	    (0, _classCallCheck3.default)(this, AcRewardsForm);
	
	    this.dwlDateFrom = null;
	    this.dwlDateTo = null;
	    this.limit = null;
	    this.page = null;
	    this.search = null;
	    this.orderBy = null;
	    this.precision = null;
	    this.periods = null;
	    this.currency = null;
	    this.turnoverWinLossCommission = null;
	    this.totals = null;
	    this.filterRevenueShare = null;
	    this.sort = null;
	  }
	
	  (0, _createClass3.default)(AcRewardsForm, [{
	    key: "toPayload",
	    value: function toPayload() {
	      return {
	        dwlDateFrom: this.dwlDateFrom,
	        dwlDateTo: this.dwlDateTo,
	        limit: this.limit,
	        page: this.page,
	        search: this.search,
	        orderBy: this.orderBy,
	        precision: this.precision,
	        filterRevenueShare: this.filterRevenueShare,
	        sort: this.sort
	      };
	    }
	  }]);
	  return AcRewardsForm;
	}();
	
	;
	
	exports.default = AcRewardsForm;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _resetpassword = __webpack_require__(1497);
	
	var _resetpassword2 = _interopRequireDefault(_resetpassword);
	
	var _form = __webpack_require__(1501);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetpasswordModule = _angular2.default.module('resetpassword', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('resetpassword', {
	    url: '/reset-password',
	    component: 'resetpassword'
	  });
	}]).component('resetpassword', _resetpassword2.default).component('resetPasswordForm', _form2.default).name;
	
	exports.default = resetpasswordModule;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _resetpassword = __webpack_require__(1498);
	
	var _resetpassword2 = _interopRequireDefault(_resetpassword);
	
	var _resetpassword3 = __webpack_require__(1499);
	
	var _resetpassword4 = _interopRequireDefault(_resetpassword3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetpasswordComponent = {
	  bindings: {},
	  template: _resetpassword2.default,
	  controller: _resetpassword4.default
	};
	
	exports.default = resetpasswordComponent;

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main-wrapper\"></div>\n<div class=\"clearfix\"></div>\n<div class=\"wrapper-page\">\n    <div class=\" main-box fadeIn animated\">\n        <div class=\"card-box form-reset\">\n            <div class=\"alert alert-danger\" id=\"error-message\">\n                <strong>\n                    {{ $ctrl.form.loadingMessage | translate }}\n                </strong>\n                {{ $ctrl.form.errorMessage }}\n                <p>\n                    <a href=\"/forgot-password\" ng-click=\"$ctrl.sendPostMessageToForgotPass()\"><small>{{ 'Request new reset code?' | translate }}</small></a>\n                </p>\n            </div>\n            <div ng-if=\"$ctrl.form.successMessage\" class=\"animate-if\">\n                <div class=\"text-center\">\n                    <span>{{ 'Enter your new account password below.' | translate }}</span>\n                </div>\n                <reset-password-form form=\"$ctrl.form\" on-submit=\"$ctrl.submit(payload)\"></reset-password-form>\n            </div>\n        </div>\n        <p><a href=\"/sign-in\">Go back to Login.</a></p>\n    </div>                              \n</div>"

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1500);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetpasswordController = function () {
	  ResetpasswordController.$inject = ["AccountApiService", "$window", "$location", "$translate"];
	  function ResetpasswordController(AccountApiService, $window, $location, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ResetpasswordController);
	    this.AccountApiService = AccountApiService;
	    this.$window = $window;
	    this.$location = $location;
	    this.$translate = $translate;
	  }
	
	  (0, _createClass3.default)(ResetpasswordController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form2.default();
	      this.getCodeFromIframe = this.getCodeFromIframe.bind(this);
	      this.$window.addEventListener('message', this.getCodeFromIframe);
	
	      this.form.resetCode = this.$location.search().reset_password_code;
	      this.validateCode();
	    }
	  }, {
	    key: 'getCodeFromIframe',
	    value: function getCodeFromIframe(e) {
	      var parseData = JSON.parse(e.data);
	      this.form.resetCode = parseData.pass_code;
	      this.validateCode();
	    }
	  }, {
	    key: 'validateCode',
	    value: function validateCode() {
	      var _this = this;
	
	      this.form.successMessage = false;
	      var locale = this.$location.search().lang || 'en';
	      this.$translate.use(locale);
	
	      this.AccountApiService.validateResetCode(locale, this.form.resetCode).then(function (resp) {
	        $('#error-message').remove();
	        _this.form.successMessage = true;
	      }).catch(function (errors) {
	        _this.form.errorMessage = errors;
	        if (errors.code) {
	          _this.form.errorMessage = errors.message;
	        }
	        _this.form.loadingMessage = 'Oh snap!';
	        _this.form.successMessage = false;
	      });
	    }
	  }, {
	    key: 'sendPostMessageToForgotPass',
	    value: function sendPostMessageToForgotPass() {
	      parent.postMessage('amsForgot-pass', '*');
	    }
	  }]);
	  return ResetpasswordController;
	}();
	
	exports.default = ResetpasswordController;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetpasswordForm = function () {
	  function ResetpasswordForm() {
	    (0, _classCallCheck3.default)(this, ResetpasswordForm);
	
	    this.newPassword = null;
	    this.confirmPassword = null;
	    this.resetCode = null;
	    this.error = null;
	    this.success = null;
	    this.errorMessage = null;
	    this.loadingMessage = 'Loading, please wait...';
	    this.successMessage = null;
	  }
	
	  (0, _createClass3.default)(ResetpasswordForm, [{
	    key: 'toPayload',
	    value: function toPayload() {
	      return {
	        resetCode: this.resetCode,
	        resetPassword: {
	          password: {
	            first: this.newPassword,
	            second: this.confirmPassword
	          }
	        }
	      };
	    }
	  }]);
	  return ResetpasswordForm;
	}();
	
	;
	
	exports.default = ResetpasswordForm;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1502);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1503);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    ResetpasswordForm: '<',
	    onSubmit: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form-horizontal m-t-20\" action=\"\">\n    <div class=\"input-group m-t-10\">\n        <input ng-model=\"$ctrl.form.newPassword\" type=\"password\" name=\"newPassword\" class=\"form-control\" placeholder=\"{{ 'form.newPassword' | translate }}\">\n        <span class=\"input-group-addon ac-white\"><i class=\"fa fa-lock\"></i></span>\n    </div>\n    <ul class=\"parsley-errors-list filled\"><li class=\"parsley-required\">{{ $ctrl.form.error }}</li></ul>\n    <div class=\"input-group m-t-10\">\n        <input ng-model=\"$ctrl.form.confirmPassword\" type=\"password\" name=\"confirmPassword\" class=\"form-control\" placeholder=\"{{ 'form.confirmPassword' | translate }}\">\n        <span class=\"input-group-addon ac-white\"><i class=\"fa fa-lock\"></i></span>\n    </div>\n    <div ng-if=\"$ctrl.form.success\" class=\"input-group m-t-10\">\n        <div class=\"alert alert-success\">\n            <strong>\n                {{ 'Success!' | translate }}\n            </strong>\n            {{ $ctrl.form.success }}\n        </div>\n    </div>\n    <div class=\"form-group text-center m-t-10\">\n        <div class=\"col-xs-12\">\n            <ladda-button ng-click=\"$ctrl.submitForm()\" text=\"'Reset password'\"></ladda-button>\n        </div>\n    </div>\n    <div class=\"form-group m-t-10 m-b-0\">\n        <div class=\"col-sm-12\">\n            <a href=\"/forgot-password\" ng-click=\"$ctrl.sendPostMessageToForgotPass()\" class=\"text-dark\"><small>{{ 'I want to request a new reset code.' | translate }}</small></a>\n        </div>\n    </div>\n</form> "

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1500);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  FormController.$inject = ["AccountApiService", "FormService", "$timeout", "$translate", "$location"];
	  function FormController(AccountApiService, FormService, $timeout, $translate, $location) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	    this.AccountApiService = AccountApiService;
	    this.FormService = FormService;
	    this.$timeout = $timeout;
	    this.$translate = $translate;
	    this.$location = $location;
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form2.default();
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var _this = this;
	
	      var locale = this.$location.search().lang || 'en';
	      this.$translate.use(locale);
	
	      this.FormService.isSubmitting.next(true);
	      this.AccountApiService.resetPassword(locale, this.form.toPayload()).then(function (resp) {
	        _this.form.error = '';
	        _this.form.success = _this.$translate.instant('Password changed.');
	        _this.$timeout(function () {
	          parent.postMessage('amsReset-success', '*');
	        }, 1500);
	      }).catch(function (error) {
	        _this.form.success = '';
	        _this.form.error = error.children.password.children.first.errors[0];
	      }).finally(function () {
	        return _this.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'sendPostMessageToForgotPass',
	    value: function sendPostMessageToForgotPass() {
	      parent.postMessage('amsForgot-pass', '*');
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _forgotpassword = __webpack_require__(1505);
	
	var _forgotpassword2 = _interopRequireDefault(_forgotpassword);
	
	var _form = __webpack_require__(1509);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var forgotpasswordModule = _angular2.default.module('forgotpassword', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('forgotpassword', {
	    url: '/forgot-password',
	    component: 'forgotpassword'
	  });
	}]).component('forgotpassword', _forgotpassword2.default).component('forgotPasswordForm', _form2.default).name;
	
	exports.default = forgotpasswordModule;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _forgotpassword = __webpack_require__(1506);
	
	var _forgotpassword2 = _interopRequireDefault(_forgotpassword);
	
	var _forgotpassword3 = __webpack_require__(1507);
	
	var _forgotpassword4 = _interopRequireDefault(_forgotpassword3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForgotpasswordComponent = {
	  bindings: {},
	  template: _forgotpassword2.default,
	  controller: _forgotpassword4.default
	};
	
	exports.default = ForgotpasswordComponent;

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main-wrapper\"></div>\n<div class=\"clearfix\"></div>\n<div class=\"wrapper-page\">\n    <div class=\" main-box fadeIn animated\">\n        <div class=\"card-box\">\n            <div class=\"login-box-msg\">\n                <span><small>{{ \"Enter the email you use for Asianconnect88, and we'll help you create a new password.\" | translate }}</small></span>\n            </div>\n            <forgot-password-form form=\"$ctrl.form\" on-submit=\"$ctrl.submit(payload)\"></forgot-password-form>\n        </div>\n        <p><a href=\"/sign-in\">Go back to Login.</a></p>\n    </div>                              \n</div>"

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1508);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForgotpasswordController = function () {
	  ForgotpasswordController.$inject = ["StorageService", "$window"];
	  function ForgotpasswordController(StorageService, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ForgotpasswordController);
	    this.StorageService = StorageService;
	    this.$window = $window;
	  }
	
	  (0, _createClass3.default)(ForgotpasswordController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form2.default();
	      this.getOrigin = this.getOrigin.bind(this);
	      this.$window.addEventListener('message', this.getOrigin);
	    }
	  }, {
	    key: 'getOrigin',
	    value: function getOrigin(e) {
	      var parseData = JSON.parse(e.data);
	      origin = parseData.origin_from;
	      this.$window.localStorage.setItem(origin, parseData.origin_from);
	    }
	  }]);
	  return ForgotpasswordController;
	}();
	
	exports.default = ForgotpasswordController;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForgotpasswordForm = function () {
	  function ForgotpasswordForm() {
	    (0, _classCallCheck3.default)(this, ForgotpasswordForm);
	
	    this.emailAddress = null;
	    this.error = null;
	    this.success = null;
	  }
	
	  (0, _createClass3.default)(ForgotpasswordForm, [{
	    key: "toPayload",
	    value: function toPayload() {
	      return {
	        requestResetPassword: {
	          email: this.emailAddress
	        },
	        origin: origin
	      };
	    }
	  }]);
	  return ForgotpasswordForm;
	}();
	
	;
	
	exports.default = ForgotpasswordForm;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1510);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1511);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    form: '<',
	    onSubmit: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	module.exports = "<form id=\"forgotpassword-form\" class=\"form-horizontal m-t-20\" role=\"form\" action=\"\" data-parsley-validate novalidate>\n    <div class=\"input-group m-t-10\">\n        <input ng-model=\"$ctrl.form.emailAddress\" ng-keypress=\"$ctrl.disableEnter()\" type=\"text\" name=\"emailAddress\" id=\"emailAddress\" class=\"form-control\" placeholder=\"Email\" required>\n        <span class=\"input-group-addon ac-white\"><i class=\"fa fa-envelope\"></i></span>\n    </div>\n    <ul class=\"parsley-errors-list filled\" ng-model=\"$ctrl.form\"><li class=\"parsley-required\" ng-repeat=\"error in $ctrl.form.error\">{{ error }}</li></ul>\n    <div ng-if=\"$ctrl.form.success\" class=\"input-group m-t-10\">\n        <div class=\"alert alert-success\">\n            <strong>\n                {{ 'Success!' | translate }}\n            </strong>\n            {{ $ctrl.form.success }}\n        </div>\n    </div>\n    <div class=\"form-group text-center m-t-10\">\n        <div class=\"col-xs-12\">\n            <ladda-button ng-click=\"$ctrl.submitForm()\" text=\"'Send reset password link'\"></ladda-button>\n        </div>\n    </div>\n    <div class=\"form-group m-t-10 m-b-0\">\n        <!--<div class=\"col-sm-12\">\n            <a ng-click=\"$ctrl.sendPostMessageToLoginForm()\" href=\"/sign-in\" class=\"text-dark\"><small>Go back to sign-in.</small></a>\n        </div-->\n    </div>\n</form> "

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1508);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  FormController.$inject = ["AccountApiService", "FormService", "StorageService", "$window", "$timeout", "$translate", "$location"];
	  function FormController(AccountApiService, FormService, StorageService, $window, $timeout, $translate, $location) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$translate = $translate;
	    this.$location = $location;
	    this.AccountApiService = AccountApiService;
	    this.FormService = FormService;
	    this.StorageService = StorageService;
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form2.default();
	      this.checkOrigin();
	      this.disableEnter();
	    }
	  }, {
	    key: 'checkOrigin',
	    value: function checkOrigin() {
	      var _this = this;
	
	      this.$window.setTimeout(function () {
	        var currentOrigin = _this.$window.location.origin + '/';
	        if (currentOrigin != _this.$window.localStorage.getItem(origin)) {
	          origin = _this.$window.localStorage.getItem(origin);
	        }
	      }, 500);
	    }
	  }, {
	    key: 'disableEnter',
	    value: function disableEnter() {
	      if (this.$window.event.keyCode == 13) {
	        this.$window.event.preventDefault();
	        return false;
	      }
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var _this2 = this;
	
	      var locale = this.$location.search().lang || 'en';
	      this.$translate.use(locale);
	
	      this.FormService.isSubmitting.next(true);
	      this.AccountApiService.sendResetCode(locale, this.form.toPayload()).then(function (resp) {
	        _this2.form.error = '';
	        _this2.form.success = _this2.$translate.instant('Reset link was sent to your email.');
	      }).catch(function (error) {
	        _this2.form.success = '';
	        _this2.form.error = error.children.email.errors;
	      }).finally(function () {
	        return _this2.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'sendPostMessageToLoginForm',
	    value: function sendPostMessageToLoginForm() {
	      parent.postMessage('amsRemember-pass', '*');
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _activation = __webpack_require__(1513);
	
	var _activation2 = _interopRequireDefault(_activation);
	
	var _form = __webpack_require__(1517);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _activation3 = __webpack_require__(1520);
	
	var _activation4 = _interopRequireDefault(_activation3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivationModule = _angular2.default.module('activation', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('activation', {
	    url: '/activation',
	    parent: 'standardLayout',
	    component: 'activation',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('activation', _activation2.default).component('activationForm', _form2.default).service('ActivationApiService', _activation4.default).name;
	
	exports.default = ActivationModule;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _activation = __webpack_require__(1514);
	
	var _activation2 = _interopRequireDefault(_activation);
	
	var _activation3 = __webpack_require__(1515);
	
	var _activation4 = _interopRequireDefault(_activation3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var activationComponent = {
	  bindings: {},
	  template: _activation2.default,
	  controller: _activation4.default
	};
	
	exports.default = activationComponent;

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray settings-page\">\n    <div class=\"content\">\n        <div class=\"container\">\n            <div class=\"row mbot3\">\n                <div class=\"col-md-12\">\n                    <h2 class=\"no-m\">{{ 'titles.settings' | translate }}</h2>\n                </div>\n            </div>\n            <activation-form form=\"$ctrl.form\" on-submit=\"$ctrl.submit(payload)\"></activation-form>\n        </div>\n    </div>\n</div>\n\n<app-footer></app-footer>"

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1516);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivationController = function () {
	  ActivationController.$inject = ["ActivationApiService", "StorageService", "$window", "$timeout", "$state"];
	  function ActivationController(ActivationApiService, StorageService, $window, $timeout, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ActivationController);
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.ActivationApiService = ActivationApiService;
	    this.StorageService = StorageService;
	  }
	
	  (0, _createClass3.default)(ActivationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.checkIfActivated();
	      this.model = new _form2.default();
	    }
	  }, {
	    key: 'checkIfActivated',
	    value: function checkIfActivated() {
	      var activationCode = this.StorageService.getItem('activation_code');
	      var customerType = this.StorageService.getItem('customer_type');
	      if (activationCode == '') {
	        if (customerType == 'AFF') {
	          this.$state.go('marketing');
	        } else {
	          this.$state.go('dashboard');
	        }
	      }
	    }
	  }]);
	  return ActivationController;
	}();
	
	exports.default = ActivationController;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivationForm = function () {
	  function ActivationForm() {
	    (0, _classCallCheck3.default)(this, ActivationForm);
	
	    this.activationCode = '';
	    this.username = '';
	    this.confirmUsername = '';
	    this.password = '';
	    this.confirmPassword = '';
	    this.activationCode = '';
	    this.loadingMessage = 'Loading, please wait...';
	    this.error = '';
	    this.errorUsername = '';
	    this.errorUsernameExist = '';
	    this.errorPassword = '';
	    this.errorTransPass = '';
	    this.errorMessage = '';
	    this.success = '';
	    this.successMessage = '';
	  }
	
	  (0, _createClass3.default)(ActivationForm, [{
	    key: 'toPayload',
	    value: function toPayload() {
	      return {
	        activation: {
	          password: {
	            first: this.password,
	            second: this.confirmPassword
	          },
	          username: {
	            first: this.username,
	            second: this.confirmUsername
	          }
	        },
	        activationCode: this.activationCode
	      };
	    }
	  }]);
	  return ActivationForm;
	}();
	
	;
	
	exports.default = ActivationForm;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1518);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1519);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    form: '<',
	    onSubmit: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row m-b-15\">\n    <div class=\"col-lg-8\">\n        <div class=\"card-box\">\n            <h3 class=\"m-0\">{{ 'Account Activation' | translate }}</h3>\n            <small>{{ 'activateAccountNote' | translate }}</small>\n\n            <form id=\"activation-form\" class=\"form-horizontal\" action=\"\"  role=\"form\"  data-parsley-validate novalidate>\n                <input type=\"hidden\" ng-model=\"$ctrl.form.activationCode\">\n                <div class=\"row\">\n                    <div class=\"col col-lg-6\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label\" for=\"example-input1-group1\">{{ 'form.username' | translate }} *</label><br>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon ac-white\"><i class=\"fa fa-user\"></i></span>\n                                <input type=\"text\" ng-model=\"$ctrl.form.username\" ng-blur=\"$ctrl.checkUsername()\" class=\"form-control\" placeholder=\"Username\" id=\"username\">\n                            </div>\n                            <small class=\"text-custom\">{{ 'usernameValidation' | translate }}</small>\n                            <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error\">\n                                <li class=\"parsley-required\">{{ $ctrl.form.errorUsername.first.errors[0] }}</li>\n                            </ul>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label\" for=\"example-input1-group1\">{{ 'form.password' | translate }} *</label><br>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon ac-white\"><i class=\"fa fa-lock\"></i></span>\n                                <input type=\"password\" ng-model=\"$ctrl.form.password\" class=\"form-control\" placeholder=\"Password\" id=\"password\">\n                            </div>\n                            <small class=\"text-custom\">{{ 'passwordValidation' | translate }}</small>\n                            <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error\">\n                                <li class=\"parsley-required\">{{ $ctrl.form.errorPassword.first.errors[0] }}</li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class=\"col col-lg-6 confirm-account\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label\" for=\"example-input1-group1\">{{ 'form.confirmUsername' | translate }} *</label><br>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon ac-white\"><i class=\"fas fa-check-square\"></i></span>\n                                <input type=\"text\" ng-model=\"$ctrl.form.confirmUsername\" class=\"form-control\" placeholder=\"{{ 'form.confirmUsername' | translate }}\" data-parsley-equalto=\"#username\" id=\"confirm-uname\" required>\n                            </div>\n                            <small class=\"text-custom\">{{ 'Re-enter username' | translate }}</small>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label\" for=\"example-input1-group1\">{{ 'form.confirmPassword' | translate }} *</label><br>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon ac-white\"><i class=\"fas fa-check-square\"></i></span>\n                                <input type=\"password\"  ng-model=\"$ctrl.form.confirmPassword\" class=\"form-control\" placeholder=\"{{ 'form.confirmPassword' | translate }}\" data-parsley-equalto=\"#password\" required>\n                            </div>\n                            <small class=\"text-custom\">{{ 'Re-enter password' | translate }}</small>\n                        </div>\n                    </div>\n                    <div class=\"row form-group m-t-20\">\n                        <div class=\"col-lg-6 pull-right m-t-20\">\n                            <div class=\"invalid-form-error-message\"></div>\n                            <button ng-click=\"$ctrl.submitForm()\" class=\"btn btn-success waves-effect waves-light pull-right\" type=\"button\">{{ 'Activate account' | translate }}</button>\n                            <button ng-click=\"$ctrl.resetForm()\" class=\"btn btn-danger waves-effect waves-light ac-color pull-right m-r-10\" type=\"button\">{{ 'Clear All' | translate }}</button>\n                        </div>\n                        <div class=\"col-lg-6 activation-btn\">\n                            <div ng-if=\"$ctrl.form.error\" class=\"alert alert-danger\">\n                                {{ $ctrl.form.errorMessage }}\n                            </div>\n                            <div ng-if=\"$ctrl.form.success\" class=\"alert alert-success\">\n                                {{ $ctrl.form.successMessage }}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1516);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  FormController.$inject = ["ActivationApiService", "StorageService", "$timeout", "$state", "$translate"];
	  function FormController(ActivationApiService, StorageService, $timeout, $state, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	    this.ActivationApiService = ActivationApiService;
	    this.StorageService = StorageService;
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.$translate = $translate;
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form2.default();
	
	      var activationForm = $('#activation-form');
	      var formValidator = activationForm.parsley();
	
	      activationForm.find('button').click(function () {
	        formValidator.validate();
	      });
	
	      formValidator.on('form:success', function () {});
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var _this = this;
	
	      this.form.success = false;
	      this.form.error = false;
	      $('parsley-required').hide();
	      if (!this.confirmTransactionPassword()) {
	        this.form.error = true;
	        this.form.errorMessage = this.$translate.instant('somethingWentWrong');
	
	        return false;
	      }
	
	      this.form.activationCode = this.StorageService.getItem('activation_code');
	      this.ActivationApiService.activate(this.form.toPayload()).then(function (response) {
	        _this.form.success = true;
	        _this.form.error = false;
	        _this.StorageService.setItem('activation_code', '');
	        _this.form.successMessage = _this.$translate.instant('activated');
	        _this.$timeout(function () {
	          if (_this.StorageService.getItem('customer_type') == 'AFF') {
	            _this.$state.go('marketing');
	          } else {
	            _this.$state.go('dashboard');
	          }
	        }, 3000);
	      }).catch(function (errors) {
	        $('.parsley-required').show();
	        _this.form.error = true;
	        if (errors.message) {
	          _this.form.errorMessage = errors.message;
	        } else {
	          _this.form.errorMessage = _this.$translate.instant('somethingWentWrong');
	          _this.form.errorUsername = errors.children.username.children;
	          _this.form.errorPassword = errors.children.password.children;
	        }
	      });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      $('.parsley-required').hide();
	      this.form.error = false;
	      this.form.username = '';
	      this.form.confirmUsername = '';
	      this.form.password = '';
	      this.form.confirmPassword = '';
	    }
	  }, {
	    key: 'confirmTransactionPassword',
	    value: function confirmTransactionPassword() {
	      if (this.form.transactionPass === this.form.confirmTransPass) {
	        return true;
	      }
	    }
	  }, {
	    key: 'checkUsername',
	    value: function checkUsername() {
	      var _this2 = this;
	
	      this.ActivationApiService.validateUsername({ username: this.form.username }).then(function (response) {
	        $('#username').removeClass('parsley-error');
	        _this2.form.errorUsernameExist = '';
	      }).catch(function (errors) {
	        $('#username').addClass('parsley-error');
	        _this2.form.errorUsernameExist = errors.message;
	      });
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivationApiService = function () {
	  ActivationApiService.$inject = ["HttpService", "SessionService"];
	  function ActivationApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ActivationApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(ActivationApiService, [{
	    key: 'validateCode',
	    value: function validateCode(activationCode) {
	      return this.HttpService.post('/account/check/activation-code', activationCode);
	    }
	  }, {
	    key: 'validateUsername',
	    value: function validateUsername(customerUsername) {
	      return this.HttpService.post('/account/check/username', customerUsername);
	    }
	  }, {
	    key: 'activate',
	    value: function activate(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/activate', payload);
	    }
	  }]);
	  return ActivationApiService;
	}();
	
	exports.default = ActivationApiService;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _zendesk = __webpack_require__(1522);
	
	var _zendesk2 = _interopRequireDefault(_zendesk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zendeskModule = _angular2.default.module('zendesk', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('zendesk', {
	    parent: 'standardLayout',
	    url: '/support/tickets',
	    component: 'zendesk',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('zendesk', _zendesk2.default).name;
	
	exports.default = zendeskModule;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _zendesk = __webpack_require__(1523);
	
	var _zendesk2 = _interopRequireDefault(_zendesk);
	
	var _zendesk3 = __webpack_require__(1524);
	
	var _zendesk4 = _interopRequireDefault(_zendesk3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zendeskComponent = {
	    bindings: {
	        tickets: '<'
	    },
	    template: _zendesk2.default,
	    controller: _zendesk4.default
	};
	
	exports.default = zendeskComponent;

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n    <div class=\"content\">\n        <div class=\"container\">\n            <div class=\"row mbot3\">\n                <div class=\"col-md-12\">\n                    <h2 class=\"no-m\">{{ 'titles.tickets' | translate }}</h2>\n                    <h4 class=\"no-m text-dark\">{{ 'My Tickets' | translate }}</h4>\n                </div>\n            </div>\n                    \n            <div class=\"row fadeIn animated\">\n                <div class=\"col-lg-3 col-md-4\">\n                    <div class=\"card-box p-0\">\n                        <div class=\"customer-info gradient-red\">\n                            <i class=\"fas fa-comments flex-center-center\"></i>\n                            <div class=\"flex-column\">\n                                <p>{{ $ctrl.model.memberDetails.full_name }}</p>\n                                <p>{{ $ctrl.model.memberDetails.user_id }}</p>\n                            </div>\n                        </div>\n                        <div class=\"ticket-status ac-white\">\n                            <ul>\n                                <li ng-repeat=\"(ticketHeader, ticketCount) in $ctrl.model.ticketCount\">\n                                    <div>\n                                        <p class=\"bold\">{{ ticketCount }}</p>\n                                        <p>{{ ticketHeader }}</p>\n                                    </div>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                    \n                    <h3 class=\"panel-title m-t-40\">Status</h3>\n                    <div class=\"list-group b-0 mail-list\">\n                        <a href=\"#\" class=\"list-group-item b-0\"><span class=\"fa fa-circle text-warning m-r-10\"></span>{{ 'Open' | translate }}</a>\n                        <a href=\"#\" class=\"list-group-item b-0\"><span class=\"fa fa-circle text-info m-r-10\"></span>{{ 'Pending' | translate }}</a>\n                        <a href=\"#\" class=\"list-group-item b-0\"><span class=\"fa fa-circle text-success m-r-10\"></span>{{ 'Resolved' | translate }}</a>\n                        <a href=\"#\" class=\"list-group-item b-0\"><span class=\"fa fa-circle text-custom m-r-10\"></span>{{ 'Closed' | translate }}</a>\n                    </div>\n                </div>\n                <div class=\"col-lg-9 col-md-8\">\n                    <div class=\"panel panel-default p-0\">\n                        <div class=\"panel-body p-0\">\n                            <div class=\"table-responsive\" id=\"tickets\">\n                                <table id=\"datatable-responsive\" class=\"table table-hover mails m-0 toggle-circle m-b-0\" cellspacing=\"0\" width=\"100%\">\n                                    <thead>\n                                        <tr class=\"unread\">\n                                            <td class=\"mail-select\"></td>\n                                            <td><a href=\"#\" class=\"email-name\">{{ 'Subject' | translate }}</a></td>\n                                            <td data-hide=\"phone, tablet\" class=\"hidden-xs\"><a href=\"#\" class=\"email-msg\">{{ 'Description' | translate }}</a></td>\n                                            <td data-hide=\"phone, tablet\" style=\"width: 20px;\"></td>\n                                            <td data-hide=\"phone, tablet\" class=\"text-right\"></td>\n                                        </tr>\n                                    </thead>\n                                    <tbody>\n\n                                    <tr ng-repeat=\"item in $ctrl.model.tickets\">\n                                        <td class=\"mail-select\">\n                                            <i ng-if=\"item.status == 'open'\" class=\"fa fa-circle m-l-5 text-warning\"></i>\n                                            <i ng-if=\"item.status == 'pending'\" class=\"fa fa-circle m-l-5 text-info\"></i>\n                                            <i ng-if=\"item.status == 'solved'\" class=\"fa fa-circle m-l-5 text-success\"></i>\n                                            <i ng-if=\"item.status == 'closed'\" class=\"fa fa-circle m-l-5 text-custom\"></i>\n                                        </td>\n                                        <td>\n                                            <a href=\"#\" ng-click=\"$ctrl.openMessage(item.id, item.status, item.subject)\" class=\"email-name\">{{ item.subject | limitTo: 50 }}</a>\n                                        </td>\n                                        <td data-hide=\"phone, tablet\" class=\"hidden-xs\">\n                                            <a href=\"#\" ng-click=\"$ctrl.openMessage(item.id, item.status, item.subject)\" class=\"email-msg\">{{ item.description | limitTo: 120 }}</a>\n                                        </td>\n                                        <td style=\"width: 20px;\"><i class=\"ion-ios7-chatboxes-outline\"></i></td>\n                                        <td data-hide=\"phone, tablet\" class=\"text-right\">{{ item.created_at | date : 'medium' }}</td>\n                                    </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div id=\"conversation\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\" style=\"display: none;\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content p-0 b-0\">\n            <div class=\"panel panel-color panel-ac\">\n                <div class=\"panel-heading\">\n                    <button type=\"button\" class=\"close m-t-5\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                    <h3 class=\"panel-title\"></h3>\n                    <h3 class=\"panel-title\">{{ $ctrl.model.activeSubject }}</h3>\n                    <span class=\"label label-{{ $ctrl.model.statusColor }}\">{{ $ctrl.model.statusText }}</span>\n                </div>\n                <div class=\"panel-body\">\n                    <div class=\"fa-3x text-center spinner fadeIn animated\">\n                      <i class=\"fas fa-spinner fa-spin\"></i>\n                    </div>\n                    <div ng-repeat=\"(key, value) in $ctrl.model.ticketDescription\" class=\"wrap-{{ $ctrl.model.chatStatus }}\">\n                        <p ng-if=\"value.via.channel == 'email'\" id=\"thread\" class=\"convo-{{ ($ctrl.model.id == value.author_id) ? 'client' : 'support' }}\" ng-bind-html=\"value.body\"></p>\n                        <p ng-if=\"value.via.channel != 'email'\" id=\"thread\" class=\"convo-{{ ($ctrl.model.id == value.author_id) ? 'client' : 'support' }}\" ng-bind-html=\"value.html_body\"></p>\n                        <span ng-if=\"value.attachments.length > 0\" class=\"animate-if\">\n                            <ul ng-repeat=\"(key, value) in value.attachments\">\n                                <li>\n                                    <a href=\"{{ value.content_url }}\" type=\"application/pdf\" tabindex=\"-1\" target=\"_blank\">{{ value.file_name }}</a>\n                                </li>\n                            </ul>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _zendesk = __webpack_require__(1525);
	
	var _zendesk2 = _interopRequireDefault(_zendesk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZendeskController = function () {
	  ZendeskController.$inject = ["$window", "TicketsApiService", "StorageService", "$timeout", "$translate", "ProfileApiService"];
	  function ZendeskController($window, TicketsApiService, StorageService, $timeout, $translate, ProfileApiService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ZendeskController);
	    this.$window = $window;
	    this.TicketsApiService = TicketsApiService;
	    this.StorageService = StorageService;
	    this.$timeout = $timeout;
	    this.profileApiService = ProfileApiService;
	    this.$translate = $translate;
	  }
	
	  (0, _createClass3.default)(ZendeskController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.model = new _zendesk2.default();
	      this.loadTickets();
	
	      this.menuHighlight();
	    }
	  }, {
	    key: 'loadTickets',
	    value: function loadTickets() {
	      var _this = this;
	
	      var memberDetails = JSON.parse(this.StorageService.getItem('member_details'));
	
	      this.profileApiService.profile().then(function (userDetails) {
	        _this.model.id = userDetails.zendesk_id;
	      });
	
	      this.TicketsApiService.fetchTickets().then(function (tickets) {
	        _this.model.ticketCount = tickets.summary;
	        _this.model.tickets = tickets.tickets.reverse();
	        _this.model.memberDetails = memberDetails;
	        _this.renderTable();
	      });
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      $('#datatable-responsive').footable();
	      $('#datatable-responsive').trigger('footable_redraw');
	    }
	  }, {
	    key: 'openMessage',
	    value: function openMessage(ticketId, status, subject) {
	      var _this2 = this;
	
	      var payload = {
	        ticketId: ticketId
	      };
	
	      var spin = document.querySelector('#conversation .spinner');
	
	      this.$timeout(function () {
	        spin.classList.remove('hidden');
	        $('#conversation').modal('show');
	      }, 500);
	
	      this.model.activeSubject = subject;
	      this.model.activeMessage = message;
	      this.model.statusText = this.model.getStatusText(this.$translate.instant(status));
	      this.model.statusColor = this.model.getStatusColor(status);
	      this.model.ticketDescription = [];
	
	      this.TicketsApiService.fetchTicketDetails(payload).then(function (ticketDetails) {
	        var channel = ticketDetails.comments[0].via.channel;
	
	        if (channel == 'chat') {
	          _this2.model.ticketDescription = ticketDetails.comments;
	          _this2.model.chatStatus = 'chat';
	        } else {
	          _this2.model.ticketDescription = ticketDetails.comments;
	          _this2.model.chatStatus = 'ticket';
	        }
	
	        _this2.$timeout(function () {
	          spin.classList.add('hidden');
	        }, 100);
	      });
	    }
	  }, {
	    key: 'menuHighlight',
	    value: function menuHighlight() {
	      this.$timeout(function () {
	        $('#tickets').addClass('subdrop');
	      }, 100);
	    }
	  }]);
	  return ZendeskController;
	}();
	
	exports.default = ZendeskController;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZendeskModel = function () {
	  function ZendeskModel() {
	    (0, _classCallCheck3.default)(this, ZendeskModel);
	
	    this.id = null;
	    this.created_at = null;
	    this.description = null;
	    this.priority = null;
	    this.status = null;
	    this.subject = null;
	    this.type = null;
	    this.tickets = [];
	    this.ticketCount = [];
	    this.memberDetails = [];
	    this.total = 0;
	    this.activeSubject = null;
	    this.activeMessage = null;
	    this.statusText = null;
	    this.statusColor = null;
	
	    this.ticketDescriptionCount = 0;
	    this.ticketDescription = [];
	    this.chatStatus = null;
	  }
	
	  (0, _createClass3.default)(ZendeskModel, [{
	    key: 'getStatusColor',
	    value: function getStatusColor(status) {
	      switch (status) {
	        case 'open':
	          return 'warning';
	          break;
	        case 'pending':
	          return 'info';
	          break;
	        case 'solved':
	          return 'success';
	          break;
	        case 'closed':
	          return 'default';
	          break;
	      }
	    }
	  }]);
	  return ZendeskModel;
	}();
	
	exports.default = ZendeskModel;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _settings = __webpack_require__(1527);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _accountPass = __webpack_require__(1532);
	
	var _accountPass2 = _interopRequireDefault(_accountPass);
	
	var _transactionPass = __webpack_require__(1537);
	
	var _transactionPass2 = _interopRequireDefault(_transactionPass);
	
	var _googleAuthentication = __webpack_require__(1542);
	
	var _googleAuthentication2 = _interopRequireDefault(_googleAuthentication);
	
	var _username = __webpack_require__(1547);
	
	var _username2 = _interopRequireDefault(_username);
	
	var _bankAccount = __webpack_require__(1552);
	
	var _bankAccount2 = _interopRequireDefault(_bankAccount);
	
	var _successModal = __webpack_require__(1555);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _errorModal = __webpack_require__(1558);
	
	var _errorModal2 = _interopRequireDefault(_errorModal);
	
	var _transactionAuthentication = __webpack_require__(1561);
	
	var _transactionAuthentication2 = _interopRequireDefault(_transactionAuthentication);
	
	var _avatar = __webpack_require__(1564);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settingsModule = _angular2.default.module('settings', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('settings', {
	    url: '/settings',
	    component: 'settings',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('settings', _settings2.default).component('accountPass', _accountPass2.default).component('transactionPass', _transactionPass2.default).component('googleAuthentication', _googleAuthentication2.default).component('username', _username2.default).component('bankAccount', _bankAccount2.default).component('transactionAuthentication', _transactionAuthentication2.default).component('successModalComponent', _successModal2.default).component('errorModalComponent', _errorModal2.default).component('avatar', _avatar2.default).name;
	
	exports.default = settingsModule;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _settings = __webpack_require__(1528);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _settings3 = __webpack_require__(1529);
	
	var _settings4 = _interopRequireDefault(_settings3);
	
	var _settings5 = __webpack_require__(1530);
	
	var _settings6 = _interopRequireDefault(_settings5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settingsComponent = {
	  bindings: {},
	  template: _settings2.default,
	  controller: _settings4.default,
	  css: _settings6.default
	};
	
	exports.default = settingsComponent;

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	module.exports = "<topbar></topbar>\n<navbar></navbar>\n\n<div class=\"content-page content-wrapper gray settings-page\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"row mbot3\">\n        <div class=\"col-md-12\">\n          <h2 class=\"no-m\">{{ 'titles.settings' | translate }}</h2>\n        </div>\n      </div>\n      <div class=\"clearfix\"></div>\n      <br>\n      <div class=\"row\">\n        <div class=\"col-lg-8\">\n          <div class=\"card-box\">\n            <div class=\"row m-b-15\">\n              <div class=\"col-lg-12\">\n                <h2 class=\"m-0\">Security</h2>\n                <small>{{ 'Update your Username, Account and Transaction Password' | translate }}</small>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-6\">\n                <username></username>\n              </div>\n              <div class=\"col-lg-6\">\n                <account-pass></account-pass>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-lg-4 hidden\"> <!-- Hide bank for now -->\n          <div class=\"overlay-text flex-center-center\">\n            <div class=\"overlay-text-inner\">\n              <p class=\"font-xxl font-bold\">{{ 'Temporarily Unavailable' | translate }}</p><br>\n              <p class=\"font-md\">{{ 'For inquiries, please contact Customer Support.' | translate }}</p>\n            </div>\n            <div class=\"overlay-cover\"></div>\n            <div class=\"custom-card-box w-100\">\n              <h3 class=\"m-0\">{{ 'Payment Option' | translate }}</h3>\n              <small>{{ 'Manage your payment accounts' | translate }}</small>\n              <bank-account></bank-account>\n            </div>\n          </div>\n      </div>\n      <div class=\"col-lg-4\">\n        <div class=\"card-box\">\n          <h2 class=\"m-0\">Avatar</h2>\n          <small class=\"ng-binding\">Select your desired avatar that will be shown on your bio:</small>\n          <avatar></avatar>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-lg-4\"> <!-- Update column size if bank will be shown -->\n        <transaction-authentication></transaction-authentication>\n      </div>\n    </div>\n  </div>\n</div>\n<app-footer></app-footer>\n"

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsController = function () {
	  SettingsController.$inject = ["$timeout"];
	  function SettingsController($timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SettingsController);
	    this.$timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(SettingsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      $('.cancel').click(function () {
	        $('#gAuthSuccess').hide();
	        $('#gAuthWarning').hide();
	      });
	    }
	  }]);
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1531);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(500)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./settings.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./settings.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(499)();
	// imports
	
	
	// module
	exports.push([module.id, ".settings-page .panel{border:1px solid #eee}.settings-page .form-group:last-child{margin-bottom:0}.settings-page .card-box{padding-bottom:0;padding-top:15px}.settings-page h2{line-height:18px;padding-top:5px}.custom-card-box{padding:15px 20px 0;border:1px solid rgba(54,64,74,.05);border-radius:5px;-moz-border-radius:5px;background-clip:padding-box;background-color:#fff}.flex{display:flex}.panel{padding:20px;color:#364049}.panel-body,.panel-heading{padding:0!important}.panel-title{line-height:20px;font-size:22px;text-transform:none;letter-spacing:0}.panel-heading i{font-size:32px;margin-top:5px;margin-right:10px}.panel-title small{font-size:12px}.custom-hr{border-bottom:1px solid #eee;height:1px;margin:10px 0}.bank-list li>i{font-size:24px;margin:7px}.new-account{color:#5e9ae9;margin-top:15px}.bank-list li:hover{background-color:#f8f8f8}.bank-text{padding-top:5px}.bank-text>span{display:block;line-height:15px;height:15px}.bank-button{margin-top:-28px}.bank-text>span.bullet{font-size:35px}.bank-text>span.bullet>span{font-size:14px;vertical-align:bottom}#bankList .default-bank{font-size:14px;text-transform:uppercase}.bank-button a,.new-account a{cursor:pointer}#bankAccountModal .modal-content{padding:0;border:none;border-top-right-radius:5px;border-top-left-radius:5px;border-bottom-right-radius:5px;border-bottom-left-radius:5px;box-shadow:2px 2px 5px #0000001f}#bankAccountModal .modal-header{background-color:#5e9aeb;padding:10px 20px!important;border-top-right-radius:5px;border-top-left-radius:5px}#bankAccountModal .modal-title{color:#fff}#bankAccountModal .modal-body{color:#535353;padding:15px!important}#bankAccountModal .modal-footer{padding:10px 20px!important;border-bottom-right-radius:5px;border-bottom-left-radius:5px}@media only screen and (min-width:768px){.modal-dialog{margin:5% auto!important;width:700px}}li.nav-item{display:table-cell;width:1%}.trxn-settings.nav.nav-tabs>li>a{background-color:#d44e54;box-shadow:inset 0 -10px 10px 0 #c53e44;color:#fff!important;border:0;border-top-right-radius:10px;border-top-left-radius:10px;border-bottom:0;font-weight:400}.trxn-settings.nav.nav-tabs>li.active>a{background-color:#fff;box-shadow:none;border:1px solid #ccc;border-bottom:0;color:#424242!important}#transaction-settings .trxn-settings~.tab-content{border:1px solid #ccc;border-top:0;padding:20px}#transaction-pw .panel{border:none;padding:0;box-shadow:none}.g-auth-footer,.g-auth-header{height:20%}.g-auth-content{height:30%}.g-auth-tabs ul{font-size:14px}.g-auth-tabs .nav.nav-tabs>li.active>a{color:#81c868!important;border:1px solid #cef1c2;background-color:#edffe7}.g-auth-tabs .nav.nav-tabs>li>a{background-color:#fff;border:1px solid #ccc;color:#a9a9a9!important;font-weight:400;line-height:15px;padding:10px;margin:10px 5px;transition:.4s}.g-auth-tabs .nav.nav-tabs>li.done>a{background-color:#80c768;border:1px solid #81c868;color:#fff!important}.g-auth-tabs .nav.nav-tabs>li.active>a:hover{cursor:pointer}.g-auth-tabs .nav.nav-tabs>li>a p{background-color:#b3b3b354;border-radius:50px;width:15px;height:15px;margin:0}.g-auth-tabs .nav.nav-tabs>li.done>a p{background-color:#a6e29294}.g-auth-tabs .nav.nav-tabs>li.active>a p{background-color:#80c76875}.g-auth-tabs .tab-content{padding:10px!important;border-radius:5px}.g-auth-tabs .tab-content>.active{display:flex;flex-direction:column;transition:.4s}.g-auth img{width:120px}.g-auth-footer a{cursor:pointer;color:#d44e54}.g-auth-qr-key{display:flex;justify-content:center}.g-auth-enabled p:first-child{border-radius:5px}.g-auth-bu ul li{list-style:none;display:inline-block;margin:0 10px;color:#d44e54}.g-auth-bu ul{padding-inline-start:0;margin-bottom:0}.g-auth-bu p{font-size:12px;font-weight:400;line-height:12px;margin:0}#g-verify ul{padding-inline-start:0;border-bottom:none!important}#g-verify ul li{color:#c1272d;list-style:none}@media only screen and (max-width:1366px){.g-auth-tabs .nav.nav-tabs>li>a{font-size:12px}.trxn-settings.nav.nav-tabs>li>a{line-height:15px;padding:15px 10px}}.overlay-cover{position:absolute;top:0;bottom:0;left:0;right:0;background-color:#c7c7c7cf;overflow:hidden;z-index:99}.overlay-text{position:relative}.overlay-text-inner{z-index:999}.overlay-text-inner,.overlay-text-inner>p{text-align:center;position:absolute;width:100%}.overlay-text-inner>p{z-index:100;color:#c1272d;text-shadow:1px 1px 5px #bbbbbbb5}.overlay-text-inner>p:last-child{color:#3e3e3e}.input-group .form-control,.input-group .form-control:focus{z-index:0}activation-form .card-box{padding:15px!important}.fa-lock{color:inherit!important;background:transparent;-webkit-text-fill-color:inherit}", ""]);
	
	// exports


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accountPass = __webpack_require__(1533);
	
	var _accountPass2 = _interopRequireDefault(_accountPass);
	
	var _accountPass3 = __webpack_require__(1534);
	
	var _accountPass4 = _interopRequireDefault(_accountPass3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountPassComponent = {
	  bindings: {},
	  template: _accountPass2.default,
	  controller: _accountPass4.default
	};
	
	exports.default = accountPassComponent;

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel\">\n  <div class=\"panel-heading flex\">\n    <i class=\"fas fa-key\"></i>\n    <h3 class=\"panel-title\">{{ 'Update AMS account password' | translate }}<br>\n      <small>{{ 'passwordValidation' | translate }}</small>\n    </h3>\n  </div>\n  <div class=\"custom-hr\"></div>\n  <div class=\"panel-body\">\n    <form role=\"form\">\n      <div class=\"form-group\">\n        <label for=\"current-password\">{{ 'Current AMS password' | translate }}</label>\n        <input ng-model=\"$ctrl.form.currentPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.currentPassword }\" type=\"password\" class=\"form-control\" id=\"current-password\" placeholder=\"{{ 'Enter current password' | translate }}\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.currentPassword\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.currentPassword\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"new-password\">{{ 'New AMS Password' | translate }}</label>\n        <input ng-model=\"$ctrl.form.newPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.newPassword }\" type=\"password\" class=\"form-control m-b-5\" id=\"new-password\" placeholder=\"{{ 'Enter new password' | translate }}\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.newPassword\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.newPassword\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n\n        <input ng-model=\"$ctrl.form.confirmNewPassword\" ng-class=\"{ 'parsley-error': $ctrl.form.error.confirmNewPassword }\" type=\"password\" class=\"form-control\" id=\"confirm-password\" placeholder=\"{{ 'Confirm new password' | translate }}\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.confirmNewPassword\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.confirmNewPassword\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n      </div>\n      <div class=\"form-group text-right\">\n        <button ng-click=\"$ctrl.submit()\" type=\"submit\" class=\"btn btn-success waves-effect waves-light\">{{ 'Update' | translate }}</button>\n      </div>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formModel = __webpack_require__(1535);
	
	var _formModel2 = _interopRequireDefault(_formModel);
	
	var _toastr = __webpack_require__(1133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountPassController = function () {
	    AccountPassController.$inject = ["SecurityApiService", "$translate"];
	    function AccountPassController(SecurityApiService, $translate) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, AccountPassController);
	        this.SecurityApiService = SecurityApiService;
	        this.$translate = $translate;
	    }
	
	    (0, _createClass3.default)(AccountPassController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.form = new _formModel2.default();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var _this = this;
	
	            this.SecurityApiService.saveCredentials(this.form.toPayload()).then(function () {
	                (0, _toastr.success)(_this.$translate.instant('Account password has been successfully updated!'));
	                _this.form.reset();
	            }).catch(function (errors) {
	                _this.form.setFormErrors(errors);
	            });
	        }
	    }]);
	    return AccountPassController;
	}();
	
	exports.default = AccountPassController;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1536);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountPassFormModel = function () {
	    function AccountPassFormModel() {
	        (0, _classCallCheck3.default)(this, AccountPassFormModel);
	
	        this.newPassword = '';
	        this.confirmNewPassword = '';
	        this.currentPassword = '';
	
	        this.error = new _formError2.default();
	    }
	
	    (0, _createClass3.default)(AccountPassFormModel, [{
	        key: 'setFormErrors',
	        value: function setFormErrors(errors) {
	            this.error.setFormErrors(errors);
	        }
	    }, {
	        key: 'toPayload',
	        value: function toPayload() {
	            var payload = {
	                security: {
	                    currentPassword: this.currentPassword,
	                    hasChangePassword: true,
	                    password: {
	                        first: this.newPassword,
	                        second: this.confirmNewPassword
	                    }
	                }
	            };
	
	            return payload;
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            this.newPassword = '';
	            this.confirmNewPassword = '';
	            this.currentPassword = '';
	
	            this.setFormErrors('');
	        }
	    }]);
	    return AccountPassFormModel;
	}();
	
	exports.default = AccountPassFormModel;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountPassFormErrorModel = function () {
	    function AccountPassFormErrorModel() {
	        (0, _classCallCheck3.default)(this, AccountPassFormErrorModel);
	
	        this.flattenedErrors = {
	            currentPassword: null,
	            newPassword: null,
	            confirmNewPassword: null
	        };
	    }
	
	    (0, _createClass3.default)(AccountPassFormErrorModel, [{
	        key: 'setFormErrors',
	        value: function setFormErrors(errors) {
	            this.flattenErrors(errors);
	        }
	    }, {
	        key: 'flattenErrors',
	        value: function flattenErrors(errors) {
	            this.flattenedErrors.currentPassword = (0, _lodash.get)(errors, 'children.currentPassword.errors');
	            this.flattenedErrors.newPassword = (0, _lodash.get)(errors, 'children.password.children.first.errors');
	            this.flattenedErrors.confirmNewPassword = (0, _lodash.get)(errors, 'children.password.children.second.errors');
	        }
	    }, {
	        key: 'currentPassword',
	        get: function get() {
	            return this.flattenedErrors['currentPassword'];
	        }
	    }, {
	        key: 'newPassword',
	        get: function get() {
	            return this.flattenedErrors['newPassword'];
	        }
	    }, {
	        key: 'confirmNewPassword',
	        get: function get() {
	            return this.flattenedErrors['confirmNewPassword'];
	        }
	    }]);
	    return AccountPassFormErrorModel;
	}();
	
	exports.default = AccountPassFormErrorModel;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transactionPass = __webpack_require__(1538);
	
	var _transactionPass2 = _interopRequireDefault(_transactionPass);
	
	var _transactionPass3 = __webpack_require__(1539);
	
	var _transactionPass4 = _interopRequireDefault(_transactionPass3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transactionPassComponent = {
	  bindings: {},
	  template: _transactionPass2.default,
	  controller: _transactionPass4.default
	};
	
	exports.default = transactionPassComponent;

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel no-m m-t-15\">\n  <div class=\"panel-heading flex\">\n    <i class=\"fas fa-key\"></i>\n    <h3 class=\"panel-title\">{{ $ctrl.form.hasTransactionPasswordEnabled ? 'Update AMS transaction password' : 'Setup AMS Transaction Password'}}<br>\n      <small>Must be alphanumeric, min 6 chars and should have at least 1 capital letter.</small>\n    </h3>\n  </div>\n  <div class=\"custom-hr\"></div>\n  <div class=\"panel-body\">\n    <form role=\"form\">\n      <div ng-show=\"$ctrl.form.hasTransactionPasswordEnabled\" class=\"form-group\">\n        <label for=\"current-transaction-password\">Current AMS transaction password</label>\n        <input ng-model=\"$ctrl.form.currentTransactionPassword\" type=\"password\" class=\"form-control\" id=\"current-transaction-password\" placeholder=\"Enter current transaction password\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.currentTransactionPassword\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.currentTransactionPassword\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"new-transaction-password\">{{ 'New AMS transaction password' | translate }}</label>\n        <input ng-model=\"$ctrl.form.newTransactionPassword\" type=\"password\" class=\"form-control m-b-5\" id=\"new-transaction-password\" placeholder=\"{{ 'Enter new transaction password' | translate }}\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.newTransactionPassword\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.newTransactionPassword\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n\n        <input ng-model=\"$ctrl.form.confirmNewTransactionPassword\" type=\"password\" class=\"form-control\" id=\"confirm-transaction-password\" placeholder=\"{{ 'Confirm new transaction password' | translate }}\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.confirmNewTransactionPassword\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.confirmNewTransactionPassword\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n      </div>\n      <div class=\"form-group text-right\">\n        <button ng-click=\"$ctrl.submit()\" type=\"submit\" class=\"btn btn-success waves-effect waves-light\">{{ 'Update' | translate }}</button>\n      </div>\n    </form>\n  </div>\n</div>"

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formModel = __webpack_require__(1540);
	
	var _formModel2 = _interopRequireDefault(_formModel);
	
	var _toastr = __webpack_require__(1133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionPassController = function () {
		TransactionPassController.$inject = ["SecurityApiService", "SessionService"];
		function TransactionPassController(SecurityApiService, SessionService) {
			'ngInject';
	
			(0, _classCallCheck3.default)(this, TransactionPassController);
			this.SecurityApiService = SecurityApiService;
			this.SessionService = SessionService;
		}
	
		(0, _createClass3.default)(TransactionPassController, [{
			key: '$onInit',
			value: function $onInit() {
				this.form = new _formModel2.default();
				this.form.hasTransactionPasswordEnabled = this.SessionService.getSession().hasTransactionPasswordEnabled;
			}
		}, {
			key: 'submit',
			value: function submit() {
				var _this = this;
	
				this.SecurityApiService.saveCredentials(this.form.toPayload()).then(function () {
					(0, _toastr.success)(_this.form.hasTransactionPasswordEnabled ? 'Transaction password has been successfully updated!' : 'Transaction password has been saved!');
					_this.SessionService.set('hasTransactionPasswordEnabled', true);
					_this.session = _this.SessionService.getSession();
					_this.form.hasTransactionPasswordEnabled = true;
					_this.form.reset();
				}).catch(function (errors) {
					_this.form.setFormErrors(errors);
				});
			}
		}]);
		return TransactionPassController;
	}();
	
	exports.default = TransactionPassController;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1541);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionPassFormModel = function () {
		function TransactionPassFormModel() {
			(0, _classCallCheck3.default)(this, TransactionPassFormModel);
	
			this.newTransactionPassword = '';
			this.confirmNewTransactionPassword = '';
			this.currentTransactionPassword = '';
			this.hasTransactionPasswordEnabled = false;
	
			this.error = new _formError2.default();
		}
	
		(0, _createClass3.default)(TransactionPassFormModel, [{
			key: 'setFormErrors',
			value: function setFormErrors(errors) {
				this.error.setFormErrors(errors);
			}
		}, {
			key: 'toPayload',
			value: function toPayload() {
				var payload = {
					security: {
						currentTransactionPassword: this.currentTransactionPassword,
						validateCurrentTransactionPassword: this.hasTransactionPasswordEnabled,
						hasChangeTransactionPassword: true,
						transactionPassword: {
							first: this.newTransactionPassword,
							second: this.confirmNewTransactionPassword
						}
					}
				};
	
				return payload;
			}
		}, {
			key: 'reset',
			value: function reset() {
				this.newTransactionPassword = '';
				this.confirmNewTransactionPassword = '';
				this.currentTransactionPassword = '';
	
				this.setFormErrors('');
			}
		}]);
		return TransactionPassFormModel;
	}();
	
	exports.default = TransactionPassFormModel;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionPassFormErrorModel = function () {
		function TransactionPassFormErrorModel() {
			(0, _classCallCheck3.default)(this, TransactionPassFormErrorModel);
	
			this.flattenedErrors = {
				currentTransactionPassword: null,
				newTransactionPassword: null,
				confirmNewTransactionPassword: null
			};
		}
	
		(0, _createClass3.default)(TransactionPassFormErrorModel, [{
			key: 'setFormErrors',
			value: function setFormErrors(errors) {
				this.flattenErrors(errors);
			}
		}, {
			key: 'flattenErrors',
			value: function flattenErrors(errors) {
				this.flattenedErrors.currentTransactionPassword = (0, _lodash.get)(errors, 'children.currentTransactionPassword.errors');
				this.flattenedErrors.newTransactionPassword = (0, _lodash.get)(errors, 'children.transactionPassword.children.first.errors');
				this.flattenedErrors.confirmNewTransactionPassword = (0, _lodash.get)(errors, 'children.transactionPassword.children.second.errors');
			}
		}, {
			key: 'currentTransactionPassword',
			get: function get() {
				return this.flattenedErrors['currentTransactionPassword'];
			}
		}, {
			key: 'newTransactionPassword',
			get: function get() {
				return this.flattenedErrors['newTransactionPassword'];
			}
		}, {
			key: 'confirmNewTransactionPassword',
			get: function get() {
				return this.flattenedErrors['confirmNewTransactionPassword'];
			}
		}]);
		return TransactionPassFormErrorModel;
	}();
	
	exports.default = TransactionPassFormErrorModel;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _googleAuthentication = __webpack_require__(1543);
	
	var _googleAuthentication2 = _interopRequireDefault(_googleAuthentication);
	
	var _googleAuthentication3 = __webpack_require__(1544);
	
	var _googleAuthentication4 = _interopRequireDefault(_googleAuthentication3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var googleAuthenticationComponent = {
	  bindings: {},
	  template: _googleAuthentication2.default,
	  controller: _googleAuthentication4.default
	};
	
	exports.default = googleAuthenticationComponent;

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"g-auth\">\n    <div class=\"form-group flex no-m\">\n        <label class=\"control-label\">Use in Withdrawal Transactions</label>\n        <switchery checked=\"$ctrl.session.isUsingGoogleTwoFactor\" on-switch=\"$ctrl.onSwitch(state)\" class=\"flex-center m-l-5\"></switchery>\n    </div>\n \n    <!-- Tabs -->\n    <!-- Hide when G Auth has been setup -->\n    <div id=\"g-auth-tab\" class=\"g-auth-tabs hidden\">\n        <ul class=\"nav nav-tabs nav-justified\">\n            <li class=\"active\">\n                <a href=\"#g-download\" data-toggle=\"tab\" class=\"flex-center-h flex-center\" id=\"step-1\">\n                    <p class=\"m-r-10 flex-center-center\">1</p> Download\n                </a>\n            </li>\n            <li class=\"disabled\">\n                <a href=\"#g-scan\" data-toggle=\"tab\" class=\"flex-center-h flex-center\" id=\"step-2\">\n                    <p class=\"m-r-10 flex-center-center\">2</p> Scan\n                </a>\n            </li>\n            <li class=\"disabled\">\n                <a href=\"#g-verify\" data-toggle=\"tab\" class=\"flex-center-h flex-center\" id=\"step-3\">\n                    <p class=\"m-r-10 flex-center-center\">3</p> Verify\n                </a>\n            </li>\n        </ul>\n\n        <!-- Tab Content -->\n        <div class=\"tab-content\">\n            <!-- Download App -->\n            <div class=\"tab-pane fade in active\" id=\"g-download\">\n                <!-- Instruction -->\n                <div class=\"g-auth-header\">\n                    <p>Download and Install Google Authenticator on your mobile phone</p>\n                </div>\n\n                <!-- Content -->\n                <div class=\"g-auth-content text-center m-10-0\">\n                    <img src=\"/assets/images/badge-app-store.svg\" alt=\"\">\n                    <img src=\"/assets/images/badge-play-store.svg\" alt=\"\">\n                </div>\n\n                <!-- Navs -->\n                <div class=\"g-auth-footer\">\n                    <div class=\"custom-hr\"></div>\n                    <p class=\"font-sm flex-end text-gray-d\">I have installed the app</p>\n                    <a class=\"flex pull-right next-step\">Next Step <i class=\"fas fa-chevron-right m-l-5 flex-center\"></i></a>\n                </div>\n            </div>\n\n            <!-- Scan QR -->\n            <div class=\"tab-pane fade\" id=\"g-scan\">\n                <!-- Instruction -->\n                <div class=\"g-auth-header\">\n                    <p>Scan the QR code or enter the secret key on your Google Authenticator app</p>\n                </div>\n\n                <!-- Content -->\n                <div class=\"g-auth-content text-center g-auth-qr-key\">\n                    <div>\n                        <p class=\"font-sm font-strong font-italic\">QR Code:</p>\n                        <canvas id=\"qr\" width=\"200\" height=\"200\" class=\"qr-canvas\"></canvas>\n                    </div>\n                    <div>\n                        <p class=\"font-sm font-strong font-italic\">Secret key:</p>\n                        <span class=\"ac-color-text\">{{ $ctrl.form.secret }}</span>\n                    </div>\n                </div>\n\n                <!-- Navs -->\n                <div class=\"g-auth-footer\">\n                    <div class=\"custom-hr\"></div>\n                    <p class=\"font-sm flex-end text-gray-d\">I have scanned the QR code</p>\n                    <a class=\"flex pull-left prev-step\"><i class=\"fas fa-chevron-left m-r-5 flex-center\"></i> Previous</a>\n                    <a class=\"flex pull-right next-step\">Next Step <i class=\"fas fa-chevron-right m-l-5 flex-center\"></i></a>\n                </div>\n            </div>\n\n            <!-- Verify code -->\n            <div class=\"tab-pane fade\" id=\"g-verify\">\n                <!-- Instruction -->\n                <div class=\"g-auth-header\">\n                    <p>Input the 6-digit code generated on your Google Authenticator app</p>\n                </div>\n\n                <!-- Content -->\n                <div class=\"g-auth-content\">\n                    <div class=\"text-center m-t-10 flex\">\n                        <input ng-model=\"$ctrl.form.code\" type=\"password\" class=\"form-control m-r-5\" id=\"g-auth-code\" placeholder=\"Enter 6-digit code\" autocomplete=\"off\">\n                        <button ng-click=\"$ctrl.verify()\" class=\"flex-center-h btn btn-success waves-effect waves-light verify\">Verify Code</button>\n                    </div>\n                    <ul class=\"filled\" ng-if=\"$ctrl.form.errors.code\">\n                        <li ng-repeat=\"(key, error) in $ctrl.form.errors.code\" class=\"parsley-required\">{{ error }}</li>\n                      </ul>   \n                </div>\n\n                <!-- Navs -->\n                <div class=\"g-auth-footer\">\n                    <div class=\"custom-hr\"></div>\n                    <a class=\"flex pull-left prev-step\"><i class=\"fas fa-chevron-left m-r-5 flex-center\"></i> Previous</a>\n                </div>\n            </div>\n        </div>\n    </div>\n    <!-- Hide when G Auth has been setup -->\n    <!-- End Tabs -->\n\n    <!-- G Auth Enabled -->\n    <div ng-show=\"$ctrl.session.hasTwoFactorEnabled\" class=\"g-auth-enabled\">\n        <p class=\"gradient-green text-white p-10\">\n                <span>\n                  <i class=\"fab fa-google\"></i> Google Authenticator Enabled\n                </span>\n            <span class=\"pull-right\">\n                  <i class=\"fas fa-check\"></i>\n                </span>\n        </p>\n        <p class=\"font-sm m-t-5\"><a id=\"reset-gauth\" data-toggle=\"modal\" data-target=\"#googleAuthReset\" class=\"italic text-gray-d\">Click here to Reset Google Authenticator.</a></p>\n      </div>\n    <!-- Replace Tabs when G Auth has been enabled -->\n    <!-- End G Auth Enabled -->\n</div>\n\n\n<!-- G Auth Succes Modal -->\n<div id=\"gAuthSuccess\" class=\"flex-center-center\" style=\"display: none;\">\n    <div class=\"sweet-overlay\" tabindex=\"-1\" style=\"opacity: 1; display: block;\"></div>\n    <div class=\"sweet-alert showSweetAlert visible flex-column\">\n      <div class=\"icon success animate\" style=\"display: block;\">\n        <span class=\"line tip animateSuccessTip\"></span>\n        <span class=\"line long animateSuccessLong\"></span>\n        <div class=\"placeholder\"></div>\n        <div class=\"fix\"></div>\n      </div>\n      <h3>Success!</h3>\n      <span class=\"font-md\">Google Authenticator has been enabled on your Withdrawal Transactions<br>\n        <div class=\"g-auth-bu font-bold m-10-0\"> Store these back-up keys:<br>\n          <p class=\"font-sm\">Back-up keys can be used in the event you lose access to your device</p>\n          <ul>\n            <li ng-repeat=\"code in $ctrl.backupCodes\">{{ code }}</li>\n          </ul>\n        </div>\n        <a ui-sref=\"withdrawal\" class=\"confirm btn btn-lg btn-success btn-md waves-effect waves-light m-t-10\" tabindex=\"1\" style=\"display: inline-block;\">Start transacting</a>\n        <button class=\"cancel btn btn-lg gray btn-md waves-effect waves-light m-t-10\" tabindex=\"1\" style=\"display: inline-block;\">Cancel</button>\n      </span>\n    </div>\n  </div>\n  \n  <!-- G Auth Warning Modal / Leave page -->\n  <div id=\"gAuthWarning\" class=\"flex-center-center\" style=\"display: none;\">\n    <div class=\"sweet-overlay\" tabindex=\"-1\" style=\"opacity: 1; display: block;\"></div>\n    <div class=\"sweet-alert showSweetAlert visible flex-column\">\n      <div class=\"icon warning pulseWarning\" style=\"display: block;\">\n        <span class=\"body pulseWarningIns\"></span>\n        <span class=\"dot pulseWarningIns\"></span>\n      </div>\n      <h3>Warning!</h3>\n      <span class=\"font-md p-lr-30\">This will cancel your Google Authenticator Setup. Are you sure you want to proceed?<br>\n        <button class=\"confirm btn btn-lg btn-warning btn-md waves-effect waves-light m-t-10\" tabindex=\"1\" style=\"display: inline-block;\">Continue Setup</button>\n        <button class=\"cancel btn btn-lg gray btn-md waves-effect waves-light m-t-10\" tabindex=\"1\" style=\"display: inline-block;\">Leave</button>\n      </span>\n    </div>\n  </div>\n\n<div id=\"googleAuthReset\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n  <div class=\"icon warning pulseWarning\" style=\"display: block;\">\n    <span class=\"body pulseWarningIns\"></span>\n    <span class=\"dot pulseWarningIns\"></span>\n  </div>\n\n  <h3>Are you sure you want to reset Google Authenticator?</h3><br>\n\n  <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-secondary waves-effect waves-light\">Cancel</button>\n  <button data-dismiss=\"modal\" ng-click=\"$ctrl.resetGoogleAuth()\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">Yes</button>\n</div>\n\n<div id=\"successGoogleAuth\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n  <div class=\"icon success animate\">\n    <span class=\"line tip animateSuccessTip\"></span>\n    <span class=\"line long animateSuccessLong\"></span>\n    <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n  </div>\n\n  <h3>Google Authenticator was successfully reset.</h3><br>\n\n  <button type=\"button\" data-dismiss=\"modal\" class=\"btn btn-success waves-effect waves-light\">Done</button>\n</div>\n\n<div id=\"warningGoogleAuth\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n  <div class=\"icon warning pulseWarning\" style=\"display: block;\">\n    <span class=\"body pulseWarningIns\"></span>\n    <span class=\"dot pulseWarningIns\"></span>\n  </div>\n\n  <h3>You still have pending request to reset Google Authenticator.</h3><br>\n\n  <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-secondary waves-effect waves-light\">OK</button>\n</div>"

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _qrious = __webpack_require__(1221);
	
	var _qrious2 = _interopRequireDefault(_qrious);
	
	var _googleAuthentication = __webpack_require__(1545);
	
	var _googleAuthentication2 = _interopRequireDefault(_googleAuthentication);
	
	var _modal = __webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleAuthenticationController = function () {
	  GoogleAuthenticationController.$inject = ["$timeout", "CustomerApiService", "SessionService", "$scope", "$state", "EventDispatcherService"];
	  function GoogleAuthenticationController($timeout, CustomerApiService, SessionService, $scope, $state, EventDispatcherService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, GoogleAuthenticationController);
	    this.$timeout = $timeout;
	    this.CustomerApiService = CustomerApiService;
	    this.SessionService = SessionService;
	
	    this.secret = '';
	    this.form = null;
	    this.session = null;
	    this.isSwitcheryChecked = false;
	    this.backupCodes = [];
	    this.$scope = $scope;
	    this.$state = $state;
	    this.EventDispatcherService = EventDispatcherService;
	
	    this.$scope.$on('checkGoogleAuthStatus', function () {
	      _this.refreshToCheckGauthStatus();
	    });
	  }
	
	  (0, _createClass3.default)(GoogleAuthenticationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.session = this.SessionService.getSession();
	      this.isSwitcheryChecked = this.session.isUsingGoogleTwoFactor;
	      this.setupTabs();
	      this.form = new _googleAuthentication2.default();
	    }
	  }, {
	    key: 'setupTabs',
	    value: function setupTabs() {
	      var _this2 = this;
	
	      this.toggleView();
	      this.$timeout(function () {
	        $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
	          var $target = $(e.target);
	          if ($target.parent().hasClass('disabled')) {
	            return false;
	          }
	        });
	
	        var nextTab = function nextTab(elem) {
	          var next = $(elem).next();
	          next.find('a[data-toggle="tab"]').click();
	          if (next[0].firstElementChild.id === 'step-2') {
	            _this2.loadGoogleAuthenticationQRCode();
	          }
	        };
	
	        function prevTab(elem) {
	          var prev = $(elem).prev();
	          prev.find('a[data-toggle="tab"]').click();
	        }
	
	        $('.next-step').click(function () {
	          var $active = $('.g-auth .nav-tabs li.active');
	          $active.next().removeClass('disabled');
	          nextTab($active);
	
	          $('#step-1, #step-2').parent().not('[class="active"]').addClass('done');
	        });
	
	        $('.prev-step').click(function () {
	          var $active = $('.g-auth .nav-tabs li.active');
	          prevTab($active);
	
	          $('#step-1, #step-2, #step-3').parent().not('[class="done"]').removeClass('done');
	        });
	
	        var url = document.location.href;
	        if (url.search('#transaction-pw') > -1) {
	          var n = $(document).height();
	          $('html, body').animate({ scrollTop: n }, 100);
	          $('#transaction-settings .trxn-settings > li:last-child, #transaction-settings .tab-content > #google-auth').removeClass('active');
	          $('#transaction-settings .trxn-settings > li:first-child, #transaction-settings .tab-content > #transaction-pw').addClass('active');
	        }
	      });
	    }
	  }, {
	    key: 'onSwitch',
	    value: function onSwitch(state) {
	      this.isSwitcheryChecked = state;
	
	      if (this.session.hasTwoFactorEnabled) {
	        this.switchGoogleTwoFactorAuthentication();
	      }
	
	      this.toggleView();
	    }
	  }, {
	    key: 'loadGoogleAuthenticationQRCode',
	    value: function loadGoogleAuthenticationQRCode() {
	      var _this3 = this;
	
	      this.CustomerApiService.getGoogleAuthenticationCode().then(function (response) {
	        _this3.createQRCode(response.qr_code_link);
	        _this3.form.secret = response.secret;
	      });
	    }
	  }, {
	    key: 'switchGoogleTwoFactorAuthentication',
	    value: function switchGoogleTwoFactorAuthentication() {
	      var _this4 = this;
	
	      this.CustomerApiService.switchTwoFactor().then(function () {
	        _this4.SessionService.set('isUsingGoogleTwoFactor', !_this4.session.isUsingGoogleTwoFactor);
	        // Get the new modified session.
	        _this4.session = _this4.SessionService.getSession();
	      });
	    }
	  }, {
	    key: 'createQRCode',
	    value: function createQRCode(content) {
	      var qr = new _qrious2.default({
	        element: document.getElementById('qr'),
	        size: 200,
	        value: content
	      });
	    }
	  }, {
	    key: 'verify',
	    value: function verify() {
	      var _this5 = this;
	
	      this.CustomerApiService.activateGoogleTwoFactor(this.form.toPayload()).then(function (response) {
	        _this5.SessionService.set('isUsingGoogleTwoFactor', true);
	        _this5.SessionService.set('hasTwoFactorEnabled', true);
	        _this5.session = _this5.SessionService.getSession();
	        _this5.backupCodes = response.backup_codes;
	        $('#gAuthSuccess').show();
	        _this5.toggleView();
	      }, function (errors) {
	        _this5.form.setErrors(errors);
	      });
	    }
	
	    /**
	     * Hide / unhide GAuth Tab.
	     */
	
	  }, {
	    key: 'toggleView',
	    value: function toggleView() {
	      var shouldHideTab = this.session.hasTwoFactorEnabled || !this.isSwitcheryChecked;
	      var element = document.getElementById('g-auth-tab');
	      if (shouldHideTab) {
	        element.classList.add('hidden');
	      } else {
	        element.classList.remove('hidden');
	      }
	    }
	  }, {
	    key: 'resetGoogleAuth',
	    value: function resetGoogleAuth() {
	      var _this6 = this;
	
	      this.CustomerApiService.resetGoogleAuthenticationCode().then(function (response) {
	        if (response.status) {
	          _this6.SessionService.set('hasTwoFactorEnabled', false);
	          _this6.SessionService.set('isUsingGoogleTwoFactor', false);
	          _this6.$scope.$emit('checkGoogleAuthStatus');
	          _this6.$timeout(function () {
	            (0, _modal.showModal)('successGoogleAuth');
	          }, 500);
	        }
	      }).catch(function () {
	        (0, _modal.showModal)('warningGoogleAuth');
	      });
	    }
	  }, {
	    key: 'refreshToCheckGauthStatus',
	    value: function refreshToCheckGauthStatus() {
	      this.$state.go(this.$state.current, {}, { reload: true, inherit: true });
	    }
	  }]);
	  return GoogleAuthenticationController;
	}();
	
	exports.default = GoogleAuthenticationController;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(1546);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleAuthenticationForm = function () {
	  function GoogleAuthenticationForm() {
	    (0, _classCallCheck3.default)(this, GoogleAuthenticationForm);
	
	    this.secret = null;
	    this.code = null;
	
	    this.errors = {};
	  }
	
	  (0, _createClass3.default)(GoogleAuthenticationForm, [{
	    key: 'setErrors',
	    value: function setErrors(errors) {
	      this.errors['code'] = errors['errors'];
	      if (this.errors['code'] && Array.isArray(this.errors['code']) && Array.isArray(errors.children.code.errors)) {
	        var _errors$code;
	
	        (_errors$code = this.errors['code']).push.apply(_errors$code, (0, _toConsumableArray3.default)(errors.children.code.errors));
	      }
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      return {
	        memberAuthenticationCode: {
	          secret: this.secret,
	          code: this.code
	        }
	      };
	    }
	  }]);
	  return GoogleAuthenticationForm;
	}();
	
	exports.default = GoogleAuthenticationForm;

/***/ }),
/* 1546 */,
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _username = __webpack_require__(1548);
	
	var _username2 = _interopRequireDefault(_username);
	
	var _username3 = __webpack_require__(1549);
	
	var _username4 = _interopRequireDefault(_username3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usernameComponent = {
	  bindings: {},
	  template: _username2.default,
	  controller: _username4.default
	};
	
	exports.default = usernameComponent;

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel\">\n  <div class=\"panel-heading flex\">\n    <i class=\"fas fa-user\"></i>\n    <h3 class=\"panel-title\">{{ 'Update AMS username' | translate }}<br>\n      <small>{{ 'usernameValidation' | translate }}</small>\n    </h3>\n  </div>\n  <div class=\"custom-hr\"></div>\n  <div class=\"panel-body\">\n    <form role=\"form\">\n      <div class=\"form-group\">\n        <label for=\"current-username\">{{ 'Current AMS username' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"current-username\" ng-value=\"$ctrl.form.currentUsername\" disabled>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"new-username\">{{ 'New AMS username' | translate }}</label>\n        <input ng-model=\"$ctrl.form.newUsername\" type=\"text\" class=\"form-control m-b-5\" id=\"new-username\" placeholder=\"{{ 'Enter new username' | translate }}\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.newUsername\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.newUsername\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n\n        <input ng-model=\"$ctrl.form.confirmNewUsername\" type=\"text\" class=\"form-control\" id=\"confirm-username\" placeholder=\"{{ 'Confirm new username' | translate }}\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.confirmNewUsername\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.confirmNewUsername\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n      </div>\n      <div class=\"form-group flex\">\n        <input ng-model=\"$ctrl.form.currentPassword\" type=\"password\" class=\"form-control m-r-5\" id=\"password\" placeholder=\"{{ 'Enter password' | translate }}\">\n        <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.currentPassword\">\n          <li ng-repeat=\"(key, error) in $ctrl.form.error.currentPassword\" class=\"parsley-required\">{{ error }}</li>\n        </ul>\n        <button ng-click=\"$ctrl.submit()\" type=\"submit\" class=\"btn btn-success waves-effect waves-light flex-center-center\">{{ 'Update' | translate }}</button>\n      </div>      \n    </form>\n  </div>\n</div>"

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formModel = __webpack_require__(1550);
	
	var _formModel2 = _interopRequireDefault(_formModel);
	
	var _toastr = __webpack_require__(1133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsernameController = function () {
		UsernameController.$inject = ["ProfileStore", "SecurityApiService", "$translate"];
		function UsernameController(ProfileStore, SecurityApiService, $translate) {
			'ngInject';
	
			(0, _classCallCheck3.default)(this, UsernameController);
			this.SecurityApiService = SecurityApiService;
			this.ProfileStore = ProfileStore;
			this.$translate = $translate;
		}
	
		(0, _createClass3.default)(UsernameController, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.form = new _formModel2.default();
	
				this.ProfileStore.getProfile().then(function (profile) {
					_this.form.currentUsername = profile.user.username;
				});
			}
		}, {
			key: 'submit',
			value: function submit() {
				var _this2 = this;
	
				this.SecurityApiService.saveCredentials(this.form.toPayload()).then(function () {
					(0, _toastr.success)(_this2.$translate.instant('Account username has been successfully updated!'));
					_this2.form.currentUsername = _this2.form.newUsername;
					_this2.form.reset();
				}).catch(function (errors) {
					_this2.form.setFormErrors(errors);
				});
			}
		}]);
		return UsernameController;
	}();
	
	exports.default = UsernameController;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1551);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsernameFormModel = function () {
		function UsernameFormModel() {
			(0, _classCallCheck3.default)(this, UsernameFormModel);
	
			this.newUsername = '';
			this.confirmNewUsername = '';
			this.currentPassword = '';
			this.currentUsername = '';
	
			this.error = new _formError2.default();
		}
	
		(0, _createClass3.default)(UsernameFormModel, [{
			key: 'setFormErrors',
			value: function setFormErrors(errors) {
				this.error.setFormErrors(errors);
			}
		}, {
			key: 'toPayload',
			value: function toPayload() {
				var payload = {
					security: {
						currentPassword: this.currentPassword,
						hasChangeUsername: true,
						username: {
							first: this.newUsername,
							second: this.confirmNewUsername
						}
					}
				};
	
				return payload;
			}
		}, {
			key: 'reset',
			value: function reset() {
				this.newUsername = '';
				this.confirmNewUsername = '';
				this.currentPassword = '';
	
				this.setFormErrors('');
			}
		}]);
		return UsernameFormModel;
	}();
	
	exports.default = UsernameFormModel;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsernameFormErrorModel = function () {
		function UsernameFormErrorModel() {
			(0, _classCallCheck3.default)(this, UsernameFormErrorModel);
	
			this.flattenedErrors = {
				currentPassword: null,
				newUsername: null,
				confirmNewUsername: null
			};
		}
	
		(0, _createClass3.default)(UsernameFormErrorModel, [{
			key: 'setFormErrors',
			value: function setFormErrors(errors) {
				this.flattenErrors(errors);
			}
		}, {
			key: 'flattenErrors',
			value: function flattenErrors(errors) {
				this.flattenedErrors.currentPassword = (0, _lodash.get)(errors, 'children.currentPassword.errors');
				this.flattenedErrors.newUsername = (0, _lodash.get)(errors, 'children.username.children.first.errors');
				this.flattenedErrors.confirmNewUsername = (0, _lodash.get)(errors, 'children.username.children.second.errors');
			}
		}, {
			key: 'currentPassword',
			get: function get() {
				return this.flattenedErrors['currentPassword'];
			}
		}, {
			key: 'newUsername',
			get: function get() {
				return this.flattenedErrors['newUsername'];
			}
		}, {
			key: 'confirmNewUsername',
			get: function get() {
				return this.flattenedErrors['confirmNewUsername'];
			}
		}]);
		return UsernameFormErrorModel;
	}();
	
	exports.default = UsernameFormErrorModel;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bankAccount = __webpack_require__(1553);
	
	var _bankAccount2 = _interopRequireDefault(_bankAccount);
	
	var _bankAccount3 = __webpack_require__(1554);
	
	var _bankAccount4 = _interopRequireDefault(_bankAccount3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bankAccountComponent = {
	  bindings: {},
	  template: _bankAccount2.default,
	  controller: _bankAccount4.default
	};
	
	exports.default = bankAccountComponent;

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel m-t-15\">\n  <div class=\"panel-heading flex\">\n    <i class=\"fas fa-university\"></i>\n    <h3 class=\"panel-title\">{{ 'titles.bankAccount' | translate }}<br>\n      <small>{{ 'Add bank accounts for faster transaction.' | translate }}</small>\n    </h3>\n  </div>\n  <div class=\"custom-hr\"></div>\n  <div class=\"panel-body\">\n    <ul class=\"list-unstyled bank-list\" id=\"bankList\">\n      <li ng-repeat=\"bank in $ctrl.form.bankDetails\">\n        <i class=\"fas fa-credit-card pull-left\"></i>\n        <div class=\"bank-text\">\n          <span>{{ bank.fields.bank_name }}</span>\n          <span class=\"bullet\">&bullet;&bullet;&bullet;&bullet;&bullet;&bullet;<span>{{ bank.fields.account_id |limitTo: -4 }}</span></span>\n        </div>\n        <div class=\"bank-button pull-right\">\n          <span class=\"m-r-10 default-bank\" ng-if=\"bank.fields.is_default || bank.fields.is_default == '1'\">{{ 'Default' | translate }}</span>\n          <span class=\"m-r-10\">\n            <a class=\"text-primary\" ng-click=\"$ctrl.editBankAccountDetails(bank.id)\"><i class=\"fas fa-edit\"></i></a>\n          </span>\n          <span class=\"m-r-10\">\n            <a class=\"text-danger\" ng-click=\"$ctrl.confirmDelete(bank.id)\"><i class=\"fas fa-trash\"></i></a>\n          </span>\n        </div>\n\n        <span class=\"clearfix\"></span>\n      </li>\n    </ul>\n    <div class=\"custom-hr\"></div>\n    <div class=\"new-account\">\n      <a ng-click=\"$ctrl.openBankAccountModal()\">\n        <i class=\"fas fa-plus-circle\"></i> {{ 'Link a new bank account' | translate }}\n      </a>\n    </div>\n  </div>\n</div>\n\n<div id=\"errorBankAccountModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"z-index: 999999;\">\n  <div class=\"icon info\"></div>\n  <h3>{{ $ctrl.error.errorMessage.title }}</h3>\n  <p class=\"lead text-muted\">{{ $ctrl.error.errorMessage.body }}</p>\n  <p>\n    <button ng-click=\"$ctrl.deleteBankAccount()\" type=\"button\" class=\"btn btn-success waves-effect waves-light\">{{ 'Yes' | translate }}</button>\n    <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-danger waves-effect waves-light\">{{ 'Cancel' | translate }}</button>\n  </p>\n</div>\n<success-modal-component></success-modal-component>\n<error-modal-component></error-modal-component>\n<link-bank-widget form-data=\"$ctrl.form.responseData\"></link-bank-widget>"

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BankAccountController = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _formError = __webpack_require__(1139);
	
	var _form = __webpack_require__(1137);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankAccountController = exports.BankAccountController = function (_BaseController) {
	  BankAccountController.$inject = ["PaymentOptionApiService", "FormService", "PageService", "EventDispatcherService", "AppService", "$timeout", "$scope", "$translate"];
	  (0, _inherits3.default)(BankAccountController, _BaseController);
	
	  function BankAccountController(PaymentOptionApiService, FormService, PageService, EventDispatcherService, AppService, $timeout, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BankAccountController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BankAccountController.__proto__ || (0, _getPrototypeOf2.default)(BankAccountController)).call(this));
	
	    _this.PaymentOptionApiService = PaymentOptionApiService;
	    _this.FormService = FormService;
	    _this.PageService = PageService;
	    _this.EventDispatcherService = EventDispatcherService;
	    _this.AppService = AppService;
	    _this.$timeout = $timeout;
	    _this.$scope = $scope;
	    _this.$translate = $translate;
	
	    _this.$scope.$on('reload.member-payment-option', function () {
	      _this.getBankPaymentOptionList();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(BankAccountController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.error = new _formError.LinkBankFormErrorModel();
	      this.form = new _form.RequestLinkBankForm();
	      this.addSubscription(this.EventDispatcherService.addListener(_events2.default.MEMBER_PAYMENT_OPTION_CREATED, function (event) {
	        return _this2.getBankPaymentOptionList();
	      }));
	      this.getBankPaymentOptionList();
	    }
	  }, {
	    key: 'getBankPaymentOptionList',
	    value: function getBankPaymentOptionList() {
	      var _this3 = this;
	
	      this.PaymentOptionApiService.getBankPaymentOption().then(function (resp) {
	        _this3.form.bankDetails = resp;
	      });
	    }
	  }, {
	    key: 'editBankAccountDetails',
	    value: function editBankAccountDetails(id) {
	      var _this4 = this;
	
	      this.error.hasError = true;
	      this.PaymentOptionApiService.getPaymentOptionById(id).then(function (resp) {
	        _this4.form.bankPaymentOption = id;
	        _this4.form.beneficiaryAccount = resp.fields.account_id;
	        _this4.form.beneficiaryAccountName = resp.fields.account_name;
	        _this4.form.beneficiaryAddress = resp.fields.account_address;
	        _this4.form.dateOfBirth = resp.fields.birth_date;
	        _this4.form.citizenship = resp.fields.citizenship;
	        _this4.form.beneficiaryCode = resp.fields.swift_code;
	        _this4.form.bankAddress = resp.fields.bank_address;
	        _this4.form.beneficiaryBank = resp.fields.bank_name;
	        _this4.form.isDefault = resp.fields.is_default;
	        _this4.form.responseData = resp;
	        _this4.$timeout(function () {
	          _this4.AppService.broadcast('reload.bank-details');
	        }, 200);
	      });
	    }
	  }, {
	    key: 'confirmDelete',
	    value: function confirmDelete(id) {
	      this.error.errorMessage.body = this.$translate.instant('Are you sure you want to delete this Bank Account?');
	      this.form.bankPaymentOption = id;
	      this.PageService.showModal('errorBankAccountModal');
	    }
	  }, {
	    key: 'deleteBankAccount',
	    value: function deleteBankAccount() {
	      var _this5 = this;
	
	      $('#errorBankAccountModal').modal('hide');
	      this.PaymentOptionApiService.deleteBankAccountRequest(this.form.toDeletePayload()).then(function (resp) {
	        _this5.PageService.showModal('successModal');
	        _this5.$timeout(function () {
	          $('#successModal').modal('hide');
	          _this5.getBankPaymentOptionList();
	        }, 2000);
	      }).catch(function (errors) {
	        _this5.error.errorMessage.body = errors[0];
	        _this5.$timeout(function () {
	          _this5.PageService.showModal('errorModal');
	        }, 500);
	      });
	    }
	  }, {
	    key: 'resetForm',
	    value: function resetForm() {
	      this.form.reset();
	      this.error.clearFormErrors();
	      this.FormService.isSubmitting.next(false);
	    }
	  }, {
	    key: 'openBankAccountModal',
	    value: function openBankAccountModal() {
	      this.resetForm();
	      this.PageService.showModal('bankAccountModal');
	    }
	  }]);
	  return BankAccountController;
	}(_basecontroller.BaseController);
	
	exports.default = BankAccountController;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _successModal = __webpack_require__(1556);
	
	var _successModal2 = _interopRequireDefault(_successModal);
	
	var _successModal3 = __webpack_require__(1557);
	
	var _successModal4 = _interopRequireDefault(_successModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var successModalComponent = {
	  bindings: {
	    onClosed: '&'
	  },
	  template: _successModal2.default,
	  controller: _successModal4.default
	};
	
	exports.default = successModalComponent;

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"successModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\">\n    <div class=\"icon success animate\">\n        <span class=\"line tip animateSuccessTip\"></span>\n        <span class=\"line long animateSuccessLong\"></span>\n        <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n    </div>\n    <h3>{{ 'Success' | translate }}</h3>\n    <p class=\"lead text-muted\">\n      {{ 'Bank account successfully deleted.' | translate }}\n    </p>\n</div>\n"

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessModalController = function () {
	  function SuccessModalController() {
	    (0, _classCallCheck3.default)(this, SuccessModalController);
	  }
	
	  (0, _createClass3.default)(SuccessModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      $('#successModal').on('hidden.bs.modal', function () {
	        _this.onClosed();
	      });
	
	      this.form = new _form.RequestLinkBankForm();
	    }
	  }]);
	  return SuccessModalController;
	}();
	
	exports.default = SuccessModalController;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _errorModal = __webpack_require__(1559);
	
	var _errorModal2 = _interopRequireDefault(_errorModal);
	
	var _errorModal3 = __webpack_require__(1560);
	
	var _errorModal4 = _interopRequireDefault(_errorModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorModalComponent = {
	  bindings: {
	    onClosed: '&'
	  },
	  template: _errorModal2.default,
	  controller: _errorModal4.default
	};
	
	exports.default = errorModalComponent;

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"errorModal\" class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"z-index: 999999;\">\n    <div class=\"icon info\"></div>\n    <h3>{{ $ctrl.error.errorMessage.title }}</h3>\n    <p class=\"lead text-muted\">{{ $ctrl.error.errorMessage.body }}</p>\n    <p>\n        <button data-dismiss=\"modal\" type=\"button\" class=\"btn btn-danger waves-effect waves-light\">{{ 'Cancel' | translate }}</button>\n    </p>\n</div>"

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorModalController = function () {
	  function ErrorModalController() {
	    (0, _classCallCheck3.default)(this, ErrorModalController);
	  }
	
	  (0, _createClass3.default)(ErrorModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      $('#errorModal').on('hidden.bs.modal', function () {
	        _this.onClosed();
	      });
	
	      this.error = new _formError.LinkBankFormErrorModel();
	    }
	  }]);
	  return ErrorModalController;
	}();
	
	exports.default = ErrorModalController;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transactionAuthentication = __webpack_require__(1562);
	
	var _transactionAuthentication2 = _interopRequireDefault(_transactionAuthentication);
	
	var _transactionAuthentication3 = __webpack_require__(1563);
	
	var _transactionAuthentication4 = _interopRequireDefault(_transactionAuthentication3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transactionAuthenticationComponent = {
	  bindings: {},
	  template: _transactionAuthentication2.default,
	  controller: _transactionAuthentication4.default
	};
	
	exports.default = transactionAuthenticationComponent;

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card-box\" id=\"transaction-settings\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <h2 class=\"m-0\">Transactions</h2>\n      <small>Manage services related to your transactions</small>\n    </div>\n\n    <div class=\"col-lg-12 m-20-0\">\n      <ul class=\"nav nav-tabs nav-justified trxn-settings\">\n        <li class=\"nav-item\">\n          <a href=\"#transaction-pw\" data-toggle=\"tab\" class=\"nav-link font-sm\">\n            Transaction Password\n          </a>\n        </li>\n        <li class=\"nav-item active\">\n          <a href=\"#google-auth\" data-toggle=\"tab\" class=\"nav-link font-sm\">\n            Google Authenticator\n          </a>\n        </li>\n      </ul>\n\n      <div class=\"tab-content\">\n        <div class=\"tab-pane\" id=\"transaction-pw\">\n          <transaction-pass></transaction-pass>\n        </div>\n        <div class=\"tab-pane active\" id=\"google-auth\">\n          <google-authentication></google-authentication>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionAuthenticationController = function TransactionAuthenticationController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, TransactionAuthenticationController);
	};
	
	exports.default = TransactionAuthenticationController;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _avatar = __webpack_require__(1565);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _avatar3 = __webpack_require__(1566);
	
	var _avatar4 = _interopRequireDefault(_avatar3);
	
	var _avatar5 = __webpack_require__(1569);
	
	var _avatar6 = _interopRequireDefault(_avatar5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avatarComponent = {
	  bindings: {},
	  template: _avatar2.default,
	  controller: _avatar4.default,
	  css: _avatar6.default
	};
	
	exports.default = avatarComponent;

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	module.exports = "<form role=\"form\" class=\"m-t-20 m-b-20\">\n  <div class=\"row\">\n    <div class=\"col-lg-10\">\n      <span class=\"image-checkbox avatar-wrap\" ng-repeat=\"avatar in $ctrl.avatars\" ng-click=\"$ctrl.onAvatarChange(avatar)\" ng-class=\"{ 'image-checkbox-checked' : avatar == $ctrl.currentAvatar.selected }\">\n        <img class=\"img-responsive\" ng-src=\"/assets/images/users/{{ avatar }}.svg\">\n      </span>\n\n      <span class=\"image-checkbox avatar-wrap user\" ng-click=\"$ctrl.onAvatarChange('custom')\" ng-class=\"{ 'image-checkbox-checked' : $ctrl.currentAvatar.selected === 'custom' }\">\n        <img ng-if=\"$ctrl.image\" class=\"img-responsive\" ng-src=\"{{ $ctrl.image }}\"/>\n        <img ng-if=\"!$ctrl.image\" class=\"img-responsive\" src=\"/assets/images/users/avatar-default.svg\"/>\n      </span>\n    </div>\n    <!-- <div class=\"col-lg-2\">\n      <span class=\"avatar-wrap upload center\">\n        <div class=\"upload-btn-wrapper\">\n          <i class=\"fas fa-spinner fa-pulse\" ng-if=\"form.is\"></i>\n          <i class=\"fas fa-upload\"></i>\n          <input class=\"file-input\" type=\"file\" fileInput name=\"file\" id=\"file\" />\n        </div>\n      </span>\n    </div> -->\n  </div>\n</form>"

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _formModel = __webpack_require__(1567);
	
	var _formModel2 = _interopRequireDefault(_formModel);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvatarController = function (_BaseController) {
	  AvatarController.$inject = ["HttpService", "AppService", "SessionService", "CustomerApiService", "$sce", "ProfileStore", "$translate"];
	  (0, _inherits3.default)(AvatarController, _BaseController);
	
	  function AvatarController(HttpService, AppService, SessionService, CustomerApiService, $sce, ProfileStore, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AvatarController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AvatarController.__proto__ || (0, _getPrototypeOf2.default)(AvatarController)).call(this, AppService));
	
	    _this.HttpService = HttpService;
	    _this.SessionService = SessionService;
	    _this.$translate = $translate;
	    _this.ProfileStore = ProfileStore;
	    _this.CustomerApiService = CustomerApiService;
	    _this.$sce = $sce;
	    _this.currentAvatar = null;
	    _this.image = null;
	
	    _this.avatars = ['avatar-man1', 'avatar-man2', 'avatar-man3', 'avatar-woman1', 'avatar-woman2'];
	    return _this;
	  }
	
	  (0, _createClass3.default)(AvatarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.form = new _formModel2.default();
	
	      this.ProfileStore.getProfile().then(function (profile) {
	        _this2.currentAvatar = profile.avatar;
	
	        _this2.loadAvatar();
	      });
	    }
	  }, {
	    key: 'onAvatarChange',
	    value: function onAvatarChange(avatar) {
	      this.form.avatar = avatar;
	
	      this.submit();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this3 = this;
	
	      this.CustomerApiService.updateAvatar(this.form.toPayload()).then(function (response) {
	        _this3.currentAvatar = response;
	        _this3.SessionService.set('selectedAvatar', response.selected);
	        _this3.SessionService.set('uploadedAvatar', response.uploaded);
	
	        _this3.form.reset();
	      }).catch(function (errors) {
	        _this3.form.setFormErrors(errors);
	      });
	    }
	  }, {
	    key: 'loadAvatar',
	    value: function loadAvatar() {
	      var _this4 = this;
	
	      if (this.currentAvatar && this.currentAvatar.uploaded) {
	        this.CustomerApiService.getAvatar(this.currentAvatar.uploaded).then(function (fileUri) {
	          _this4.HttpService.$http.get(fileUri, { responseType: 'arraybuffer' }).then(function (s3data) {
	            var fileObj = new Blob([s3data], { type: 'application/binary' });
	            _this4.image = _this4.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
	          });
	        });
	      }
	    }
	  }]);
	  return AvatarController;
	}(_basecontroller.BaseController);
	
	exports.default = AvatarController;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _formError = __webpack_require__(1568);
	
	var _formError2 = _interopRequireDefault(_formError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvatarFormModel = function () {
	  function AvatarFormModel() {
	    (0, _classCallCheck3.default)(this, AvatarFormModel);
	
	    this.avatar = '';
	    this.file = '';
	
	    this.error = new _formError2.default();
	  }
	
	  (0, _createClass3.default)(AvatarFormModel, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.error.setFormErrors(errors);
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var formData = new FormData();
	
	      formData.append('memberAvatar[avatar]', this.avatar);
	      formData.append('memberAvatar[file]', this.file);
	
	      return formData;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.avatar = '';
	      this.file = '';
	
	      this.setFormErrors('');
	    }
	  }]);
	  return AvatarFormModel;
	}();
	
	exports.default = AvatarFormModel;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvatarFormErrorModel = function () {
	  function AvatarFormErrorModel() {
	    (0, _classCallCheck3.default)(this, AvatarFormErrorModel);
	
	    this.flattenedErrors = {
	      file: null,
	      avatar: null
	    };
	  }
	
	  (0, _createClass3.default)(AvatarFormErrorModel, [{
	    key: 'setFormErrors',
	    value: function setFormErrors(errors) {
	      this.flattenErrors(errors);
	    }
	  }, {
	    key: 'flattenErrors',
	    value: function flattenErrors(errors) {
	      this.flattenedErrors.file = (0, _lodash.get)(errors, 'children.file.errors');
	      this.flattenedErrors.avatar = (0, _lodash.get)(errors, 'children.avatar.errors');
	    }
	  }, {
	    key: 'avatar',
	    get: function get() {
	      return this.flattenedErrors['avatar'];
	    }
	  }, {
	    key: 'file',
	    get: function get() {
	      return this.flattenedErrors['file'];
	    }
	  }]);
	  return AvatarFormErrorModel;
	}();
	
	exports.default = AvatarFormErrorModel;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1570);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(500)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!./avatar.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!./avatar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(499)();
	// imports
	
	
	// module
	exports.push([module.id, ".avatar-wrap{position:relative;display:inline-block}.image-checkbox.avatar-wrap .checkbox-custom{position:absolute}.image-checkbox.avatar-wrap .checkbox-custom input{width:27px;height:27px}.settings-page .image-checkbox{cursor:pointer;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;margin-bottom:10px;outline:0;position:relative;border:2px solid #acacac;filter:grayscale(100%) brightness(100%);border-radius:5px;width:60px;height:60px;margin-right:5px;padding:3px}.image-checkbox:hover{filter:grayscale(0);border-color:#00a65a}.settings-page .image-checkbox img{width:100%;padding:0;object-fit:cover!important;height:100%}.settings-page .image-checkbox-checked{border:2px solid #00a65a;position:relative;filter:grayscale(0)}.avatar-wrap.upload{float:right}.avatar-wrap.upload .fas{font-size:30px;padding:10px 0;vertical-align:baseline!important;margin:0!important;width:50px!important;height:auto;text-align:center}.avatar-wrap.upload{position:relative;border:2px dashed;color:#c9373d;padding:3px;border-radius:5px}.upload-btn-wrapper{position:relative;overflow:hidden;display:flex}.upload-btn-wrapper input[type=file]{position:absolute;left:0;top:0;opacity:0;width:50px;height:50px}.file-input+label{color:transparent!important;background-color:transparent!important;display:block!important;position:absolute!important;top:0;width:100%;height:100%}", ""]);
	
	// exports


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _requests = __webpack_require__(1572);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _form = __webpack_require__(1579);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestsModule = _angular2.default.module('requests', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('requests', {
	    parent: 'standardLayout',
	    url: '/support/requests',
	    component: 'requests',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('requests', _requests2.default).component('requestsForm', _form2.default).name;
	
	exports.default = requestsModule;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requests = __webpack_require__(1573);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _requests3 = __webpack_require__(1574);
	
	var _requests4 = _interopRequireDefault(_requests3);
	
	var _requests5 = __webpack_require__(1577);
	
	var _requests6 = _interopRequireDefault(_requests5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestsComponent = {
	  bindings: {},
	  template: _requests2.default,
	  controller: _requests4.default,
	  css: _requests6.default
	};
	
	exports.default = requestsComponent;

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"row mbot3\">\n        <div class=\"col-md-12\">\n          <h2 class=\"no-m\">Support</h2>\n          <h4 class=\"no-m text-dark\">My Requests</h4>\n        </div>\n      </div>\n      <div class=\"row fadeIn animated\">\n        <!-- Requests Table -->\n        <div class=\"col-md-9\">\n          <div class=\"card-box\">\n            <div class=\"border-box mbot3\">\n              <requests-form form=\"$ctrl.form\" on-submit=\"$ctrl.submit(payload)\" on-filtered=\"$ctrl.onFiltered(data, total, filter)\"></requests-form>\n            </div>\n            <div class=\"border-box no-p\">\n              <div class=\"row\">\n                <div class=\"requests-table col-md-12\">\n                  <div class=\"table-responsive\">\n                    <table id=\"datatable-responsive\" id=\"requests-table\" class=\"table toggle-circle m-b-0\" cellspacing=\"0\" date-paging=\"false\"width=\"100%\">\n                      <thead>\n                        <tr>\n                          <th data-hide=\"phone, tablet\">{{'Date' | translate }}</th>\n                          <th data-toggle=\"true\">{{'Transaction Number' | translate }}</th>\n                          <th data-hide=\"phone, tablet\">{{'Type' | translate }}</th>\n                          <th data-hide=\"phone\">{{'Status' | translate }}</th>\n                        </tr>\n                      </thead>\n\n                      <tbody>\n                        <tr ng-repeat=\"(key, request) in $ctrl.model.requests\">\n                          <td>{{ request.date | date : 'MM/dd/yyyy' }}</td>\n                          <td>{{ request.number }}</td>\n                          <td>{{ $ctrl.removeUnderscore(request.type_text) | translate }}</td>\n                          <td>{{ request.status_text | translate }}\n                            <div ng-if=\"request.type_text !== 'google_auth' && request.type_text !== 'product_password'\" class=\"custom_tooltip_mobile\">\n                              <i class=\"ti-info-alt\"></i>\n                              <span class=\"custom_tooltiptext\">\n                                <div ng-repeat=\"(key, subRequest) in request.details.sub_requests\" class=\"text-left flex\">\n                                  <div class=\"details_tooltiptext\">{{ subRequest.filename }}</div>\n                                  <div ng-if=\"subRequest.status == 0 || subRequest.status == 1\">\n                                    | {{ subRequest.status == 0 ? 'Invalid Doc' : 'Valid Doc' }}\n                                  </div>\n                                  <div ng-if=\"subRequest.remark !== ''\">\n                                    | {{ subRequest.remark }}\n                                  </div>\n                                </div>\n                              </span>\n                            </div>\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <!-- Pagination -->\n            <div class=\"row\">\n              <div class=\"col-md-12 m-t-20\">\n                <pagination2 on-page-clicked=\"$ctrl.onPaginate(page, offset, $ctrl.model.pageParams.limit, $ctrl.model.dateFrom, $ctrl.model.dateTo, $ctrl.model.filterType, $ctrl.model.filterStatus)\" max-page-count=\"5\" limit-per-page=\"$ctrl.model.pageParams.limit\" total=\"$ctrl.model.recordsFiltered\" on-reset=\"$ctrl.reset()\"></pagination2>\n              </div>\n            </div>\n\n          </div>\n        </div>\n\n        <!-- Sidebar -->\n        <div class=\"col-md-3 col-md-12 col-sm-12\">\n          <!-- My Account -->\n          <div class=\"portlet widget p-20\">\n            <div class=\"portlet-heading no-p\">\n              <h3 class=\"portlet-title text-gray\">\n                <i class=\"far fa-credit-card\"></i> {{'My Account' | translate }}\n              </h3>\n              <div class=\"clearfix\"></div>\n            </div>\n            <hr>\n            <div class=\"portlet-body no-p\">\n              <div class=\"row\">\n                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                  <p>{{ 'Available Balance' | translate }}</p>\n                  <span class=\"text-red italic bold\">{{ $ctrl.model.availableBalance }} {{ $ctrl.model.currency }}</span>\n                </div>\n                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                  <p>Account Status</p>\n                  <span class=\"text-green\">\n                    <p ng-if=\"$ctrl.model.accountStatus === 'Verified'\" class=\"italic bold\"><i class=\"icon-user-following\"></i> {{ $ctrl.model.accountStatus }}</p>\n                    <p ng-if=\"$ctrl.model.accountStatus !== 'Verified'\" class=\"italic bold\"><i class=\"icon-user-unfollow\"></i> {{ $ctrl.model.accountStatus }}</p>\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-md-12 mtop3\">\n                  <div class=\"alert alert-success custom-notif no-m\">\n                    <strong>Note:</strong> Make a deposit to increase your funds.\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <!-- My Products -->\n          <customer-product-widget on-customer-products-loaded=\"$ctrl.onCustomerProductsLoaded(customerProductsList)\"></customer-product-widget>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<request-product-modal></request-product-modal>\n<product-password-widget></product-password-widget>"

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _requests = __webpack_require__(1575);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _form = __webpack_require__(1576);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestsController = function () {
	  RequestsController.$inject = ["MemberRequestApiService", "AcrewardsStore", "$timeout", "$translate"];
	  function RequestsController(MemberRequestApiService, AcrewardsStore, $timeout, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, RequestsController);
	    this.$translate = $translate;
	    this.$timeout = $timeout;
	    this.MemberRequestApiService = MemberRequestApiService;
	    this.AcrewardsStore = AcrewardsStore;
	  }
	
	  (0, _createClass3.default)(RequestsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.model = new _requests2.default();
	      this.form = new _form2.default();
	      this.$timeout(function () {
	        $('#datatable-responsive').footable();
	      });
	
	      this.MemberRequestApiService.getMemberRequests().then(function (resp) {
	        _this.renderTable(resp);
	      });
	
	      this.AcrewardsStore.getDashboardDetails().then(function (details) {
	        _this.model.currency = details.others.currency;
	        _this.model.verifiedAt = details.others.verifiedAt;
	        _this.model.accountStatus = details.others.verifiedAt ? _this.$translate.instant('Verified') : _this.$translate.instant('Not Verified');
	      });
	    }
	  }, {
	    key: 'tableEventHandler',
	    value: function tableEventHandler() {
	      this.$timeout(function () {
	        $(window).resize(function () {
	          $('#requests-table').footable();
	          $('#requests-table').trigger('footable_redraw');
	        });
	        $(window).trigger('resize');
	
	        window.dispatchEvent(new Event('resize'));
	
	        var evt = window.document.createEvent('UIEvents');
	        evt.initUIEvent('resize', true, false, window, 0);
	        window.dispatchEvent(evt);
	      }, 0);
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable(data) {
	      $('.table-loading').hide();
	      this.model.pageParams.limit = data.limit;
	      this.model.pageParams.page = data.page;
	      this.model.requests = data.items;
	      this.model.recordsTotal = data.total;
	      this.model.recordsFiltered = data.total_filtered;
	
	      this.$timeout(function () {
	        $('.turnover-table').fadeIn(300);
	      }, 300);
	      this.tableEventHandler();
	    }
	  }, {
	    key: 'onFiltered',
	    value: function onFiltered(data, total, filter) {
	      this.model.total = data.total;
	      this.model.totalFiltered = data.total_filtered;
	      this.model.requests = data.requests;
	
	      this.form.requestFrom = filter.from;
	      this.form.requestTo = filter.to;
	      this.form.requestsType = filter.types;
	      this.form.requestsStatus = filter.status;
	
	      this.renderTable(data);
	    }
	  }, {
	    key: 'onPaginate',
	    value: function onPaginate(page, offset, limit, from, to, types, status) {
	      var _this2 = this;
	
	      this.model.pageParams.page = page;
	      this.model.pageParams.offset = offset;
	      this.form.limit = limit;
	      this.form.page = page;
	      this.form.requestFrom = from;
	      this.form.requestTo = to;
	      this.form.requestsType = types;
	      this.form.requestsStatus = status;
	
	      this.MemberRequestApiService.getMemberRequests(this.form.toPayload()).then(function (resp) {
	        _this2.renderTable(resp);
	      });
	    }
	  }, {
	    key: 'onCustomerProductsLoaded',
	    value: function onCustomerProductsLoaded(customerProductsList) {
	      this.model.availableBalance = customerProductsList.balance;
	    }
	  }, {
	    key: 'removeUnderscore',
	    value: function removeUnderscore(str) {
	      return str.replace(/_/g, " ");
	    }
	  }]);
	  return RequestsController;
	}();
	
	exports.default = RequestsController;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestsList = function RequestsList() {
	  (0, _classCallCheck3.default)(this, RequestsList);
	
	  this.transactionNumber = null;
	  this.status = null;
	  this.date = null;
	  this.type = null;
	  this.total = null;
	  this.verifiedAt = null;
	  this.totalFiltered = null;
	  this.availableBalance = null;
	  this.accountStatus = null;
	  this.currency = null;
	  this.requests = [];
	
	  this.pageParams = {
	    recordsTotal: null,
	    recordsFiltered: null,
	    limit: null,
	    page: null,
	    offset: null,
	    orderBy: null
	  };
	};
	
	exports.default = RequestsList;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MemberRequestForm = exports.REQUEST_STATUS = exports.REQUEST_TYPES = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _freeze = __webpack_require__(1252);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST_TYPES = exports.REQUEST_TYPES = (0, _freeze2.default)({
	  1: 'PRODUCT PASSWORD RESET',
	  2: 'KYC UPLOAD',
	  3: 'Google Authenticator'
	});
	
	var REQUEST_STATUS = exports.REQUEST_STATUS = (0, _freeze2.default)({
	  1: 'Requested',
	  2: 'Processed',
	  3: 'Declined',
	  4: 'Acknowledged'
	});
	
	var MemberRequestForm = exports.MemberRequestForm = function () {
	  function MemberRequestForm() {
	    (0, _classCallCheck3.default)(this, MemberRequestForm);
	
	    this.requestFrom = null;
	    this.requestTo = null;
	    this.requestTypes = null;
	    this.requestStatus = null;
	    this.limit = null;
	    this.page = null;
	    this.orderBy = null;
	    this.precision = null;
	    this.sort = null;
	
	    this.types = [];
	    this.setTypes();
	  }
	
	  (0, _createClass3.default)(MemberRequestForm, [{
	    key: 'toPayload',
	    value: function toPayload() {
	      return {
	        from: this.requestFrom,
	        to: this.requestTo,
	        types: this.requestTypes,
	        status: this.requestStatus,
	        limit: this.limit,
	        page: this.page
	      };
	    }
	  }, {
	    key: 'setTypes',
	    value: function setTypes() {
	      for (var key in REQUEST_TYPES) {
	        this.types.push({
	          value: key,
	          text: REQUEST_TYPES[key]
	        });
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.requestFrom = null;
	      this.requestTo = null;
	      this.requestTypes = null;
	      this.requestStatus = null;
	      this.limit = null;
	      this.page = null;
	      this.orderBy = null;
	      this.precision = null;
	      this.sort = null;
	    }
	  }]);
	  return MemberRequestForm;
	}();
	
	;
	
	exports.default = MemberRequestForm;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1578);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(500)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./requests.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./requests.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(499)();
	// imports
	
	
	// module
	exports.push([module.id, ".border-box{border:1px solid #dbddde;padding:15px 20px;border-radius:3px}.border-box ul{list-style:none;margin:0;padding:0}.pagination-b{margin:0}tr{text-transform:capitalize}.requests-table .custom_tooltip_mobile{display:inline}.details_tooltiptext{width:125px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1580);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1581);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    form: '<',
	    onFiltered: '&',
	    onReset: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form-horizontal\" action=\"\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"row\">\n          <div class=\"col-md-3 col-sm-6 col-xs-12\">\n            <div class=\"form-group mr-ml-0\">\n              <label>From</label>\n              <date-picker ng-model=\"$ctrl.form.requestFrom\"></date-picker>\n            </div>\n          </div>\n          <div class=\"col-md-3 col-sm-6 col-xs-12\">\n            <div class=\"form-group mr-ml-0\">\n              <label>To</label>\n              <date-picker ng-model=\"$ctrl.form.requestTo\"></date-picker>\n            </div>\n          </div>\n          <div class=\"col-md-3 col-sm-6 col-xs-12\">\n            <!-- <label>{{ 'Type' | translate }}</label> -->\n            <div class=\"tags-default\">\n              <label>{{ 'Type' | translate }}</label>\n              <div class=\"tags-default\">\n                <select2 ng-model=\"$ctrl.form.requestTypes\" options=\"$ctrl.form.types\" placeholder=\"All types\" multiple></select2>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-md-3 col-sm-6 col-xs-12\">\n            <label>{{ 'Status' | translate }}</label>\n            <select ng-model=\"$ctrl.form.requestStatus\" class=\"form-control\">\n              <option value=\"\">All Status</option>\n              <option ng-repeat=\"(key, status) in $ctrl.requestStatus\" value=\"{{ key }}\">{{ status }}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-12 text-right\">\n        <button ng-click=\"$ctrl.submit()\" type=\"button\" class=\"btn btn-inverse waves-effect waves-light ac-color\">{{ 'Search' | translate }}</button>\n        <button ng-click=\"$ctrl.reset()\" type=\"button\" class=\"btn btn-inverse waves-effect waves-light\">{{ 'Reset Filter' | translate }}</button>\n      </div>\n    </div>\n</form>\n"

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  FormController.$inject = ["MemberRequestApiService", "FormService", "$window", "$timeout"];
	  function FormController(MemberRequestApiService, FormService, $window, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.FormService = FormService;
	    this.MemberRequestApiService = MemberRequestApiService;
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form.MemberRequestForm();
	      this.requestsType = _form.REQUEST_TYPES;
	      this.requestStatus = _form.REQUEST_STATUS;
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      if (this.form.from && this.form.to) {
	        if (this.form.from) {
	          this.form.from = moment(this.form.from).format('YYYY-MM-DD');
	        }
	
	        if (this.form.to) {
	          this.form.to = moment(this.form.to).format('YYYY-MM-DD');
	        }
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.MemberRequestApiService.getMemberRequests(this.form.toPayload()).then(function (resp) {
	        _this.onFiltered({ data: resp, total: resp.total, filter: _this.form.toPayload() });
	      }).catch(function (error) {
	        console.log(error);
	      }).finally(function () {
	        return _this.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.form.reset();
	      this.submit();
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _dashboard = __webpack_require__(1583);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _deposit = __webpack_require__(1182);
	
	var _deposit2 = _interopRequireDefault(_deposit);
	
	var _deposit3 = __webpack_require__(1590);
	
	var _deposit4 = _interopRequireDefault(_deposit3);
	
	var _overview = __webpack_require__(1247);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _withdrawal = __webpack_require__(1398);
	
	var _withdrawal2 = _interopRequireDefault(_withdrawal);
	
	var _productwallet = __webpack_require__(1433);
	
	var _productwallet2 = _interopRequireDefault(_productwallet);
	
	var _peertopeer = __webpack_require__(1446);
	
	var _peertopeer2 = _interopRequireDefault(_peertopeer);
	
	var _outstandingbet = __webpack_require__(1463);
	
	var _outstandingbet2 = _interopRequireDefault(_outstandingbet);
	
	var _bethistory = __webpack_require__(1472);
	
	var _bethistory2 = _interopRequireDefault(_bethistory);
	
	var _betoverview = __webpack_require__(1599);
	
	var _betoverview2 = _interopRequireDefault(_betoverview);
	
	var _customer = __webpack_require__(1628);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerModule = _angular2.default.module('pages.customer', [_dashboard2.default, _deposit2.default, _deposit4.default, _overview2.default, _withdrawal2.default, _productwallet2.default, _peertopeer2.default, _outstandingbet2.default, _bethistory2.default, _betoverview2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('customer', {
	    parent: 'standardLayout',
	    url: '/customer',
	    component: 'customer'
	  });
	}]).component('customer', _customer2.default).name;
	
	exports.default = customerModule;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _dashboard = __webpack_require__(1584);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(1589);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardModule = _angular2.default.module('dashboard', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  //$urlRouterProvider.otherwise('dashboard');
	
	  $stateProvider.state('dashboard', {
	    parent: 'standardLayout',
	    url: '/dashboard',
	    component: 'dashboard',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('dashboard', _dashboard2.default).service('DashboardStore', _dashboard4.default).name;
	
	exports.default = dashboardModule;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dashboard = __webpack_require__(1585);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(1586);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardComponent = {
	  bindings: {
	    products: '<',
	    dashboard: '<'
	  },
	  template: _dashboard2.default,
	  controller: _dashboard4.default
	};
	
	exports.default = dashboardComponent;

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page gray\">\n    <!-- Start content -->\n    <div class=\"content\">\n        <div class=\"container\">\n            <!-- Page-Title -->\n            <div class=\"row mbot3\">\n                <div class=\"col-sm-12 col-md-12\">\n                    <h2 class=\"no-m\">{{ 'titles.dashboard' | translate }}</h2>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"row dashboard-main\">\n                        <!-- My Account -->\n                        <div class=\"col-lg-4 col-md-12\">\n                            <div class=\"portlet widget p-20\">\n                                <div class=\"portlet-heading no-p\">\n                                    <h3 class=\"portlet-title text-gray\">\n                                        <i class=\"far fa-credit-card\"></i> {{ 'titles.account' | translate }}\n                                    </h3>\n                                    <div class=\"clearfix\"></div>\n                                </div>\n                                <hr>\n                                <div class=\"portlet-body no-p\">\n                                    <div class=\"row\">\n                                        <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                                            <p>{{ 'Available Balance' | translate }}</p>\n                                            <span class=\"text-red italic bold\" loading=\"$ctrl.model.balance.available\">{{ $ctrl.model.balance.available }} {{ $ctrl.model.currency }}</span>\n                                        </div>\n                                        <div class=\"col-md-6 col-sm-6 col-xs-6\">\n                                            <p>{{ 'Account Status' | translate }}</p>\n                                            <span class=\"text-green\">\n                                                <p ng-if=\"$ctrl.model.status === 'Verified'\" class=\"italic bold\"><i class=\"icon-user-following\"></i> {{ $ctrl.model.status | translate }}</p>\n                                                <p ng-if=\"$ctrl.model.status !== 'Verified'\" class=\"italic bold\"><i class=\"icon-user-unfollow\"></i> {{ $ctrl.model.status | translate }}</p>\n                                            </span>\n                                        </div>\n                                    </div>\n                                    <div class=\"row\">\n                                        <div class=\"col-md-12 mtop3\">\n                                            <div class=\"alert alert-success custom-notif no-m\">\n                                                <strong>{{ 'Note:' | translate }}</strong> {{ 'makeDeposit' | translate }}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"row\">\n                                        <div class=\"col-md-12 mtop3\">\n                                            <account-reminder-widget></account-reminder-widget>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- Quicklinks -->\n                        <div class=\"col-lg-4 col-md-12\">\n                            <div class=\"portlet widget p-20\">\n                                <div class=\"portlet-heading no-p\">\n                                    <h3 class=\"portlet-title text-gray\">\n                                    <i class=\"fas fa-link\"></i>{{ 'Quick Links' | translate }}\n                                    </h3>\n                                    <div class=\"clearfix\"></div>\n                                </div>\n                                <hr>\n                                <div class=\"portlet-body no-p\">\n                                    <ul class=\"quicklinks text-center\">\n                                        <li>\n                                            <a ui-sref=\"deposit\">\n                                                <img src=\"assets/images/quicklinks/deposit.svg\" width=\"60\">\n                                                <h4>{{ 'titles.deposit' | translate }}</h4>\n                                            </a>\n                                        </li>\n                                        <li>\n                                            <a ui-sref=\"withdrawal\">\n                                                <img src=\"assets/images/quicklinks/withdraw.svg\" width=\"60\">\n                                                <h4>{{ 'titles.withdrawal' | translate }}</h4>\n                                            </a>\n                                        </li>\n                                        <li>\n                                            <a ui-sref=\"productwallet\">\n                                                <img src=\"assets/images/quicklinks/transfer.svg\" width=\"60\">\n                                                <h4>{{ 'titles.transfer' | translate }}</h4>\n                                            </a>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- My Products -->\n                        <div class=\"col-lg-4 col-md-12\">\n                            <customer-product-widget on-customer-products-loaded=\"$ctrl.onCustomerProductsLoaded(customerProductsList)\"></customer-product-widget>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div id=\"welcome-modal\" class=\"sweet-overlay\" tabindex=\"-1\">\n    <div class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"display: block; margin-top: -189px;\">\n        <div class=\"icon success animate\">\n            <span class=\"line tip animateSuccessTip\"></span>\n            <span class=\"line long animateSuccessLong\"></span>\n            <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n        </div>\n        <h3>{{ 'welcome' | translate }}</h3>\n        <p class=\"lead text-muted\">\n            {{ 'setup' | translate }}<br>\n            {{ 'to activate your account.' | translate }}<br>\n            <small>{{ 'setupNote' | translate }}</small>\n        </p>\n        <p>\n            <a ui-sref=\"activation\" class=\"confirm btn btn-sm btn-success\" tabindex=\"1\">{{ 'Proceed' | translate }}</a>\n            <a ui-sref=\"deposit\" class=\"confirm btn btn-sm btn-info\" tabindex=\"1\">{{ 'Deposit Now' | translate }}</a>\n        </p>\n    </div>\n</div>\n\n<request-product-modal></request-product-modal>\n<product-password-widget></product-password-widget>\n"

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dashboard = __webpack_require__(1587);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _bool = __webpack_require__(1588);
	
	var _basecontroller = __webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardController = function (_BaseController) {
	  DashboardController.$inject = ["AppService", "DashboardStore", "PageService", "StorageService", "EventDispatcherService"];
	  (0, _inherits3.default)(DashboardController, _BaseController);
	
	  function DashboardController(AppService, DashboardStore, PageService, StorageService, EventDispatcherService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DashboardController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardController.__proto__ || (0, _getPrototypeOf2.default)(DashboardController)).call(this, AppService));
	
	    _this.AppService = AppService;
	    _this.DashboardStore = DashboardStore;
	    _this.PageService = PageService;
	    _this.StorageService = StorageService;
	    _this.EventDispatcherService = EventDispatcherService;
	
	    // TODO: Should be in model.
	    _this.isEnabled = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(DashboardController, [{
	    key: '$doCheck',
	    value: function $doCheck() {
	      parent.postMessage('connected', '*');
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.model = new _dashboard2.default();
	      this.session = this.getSession();
	
	      this.updateModel();
	      this.checkStatus();
	
	      this.subscription = this.EventDispatcherService.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this2.updateModel();
	      });
	    }
	  }, {
	    key: 'doNotShowGoogleAuthenticatorPrompt',
	    value: function doNotShowGoogleAuthenticatorPrompt() {
	      this.StorageService.setItem('do-not-show-google-prompt', true);
	    }
	  }, {
	    key: 'goToGoogleAuthSettings',
	    value: function goToGoogleAuthSettings() {
	      this.goToState('settings', { '#': 'google-auth' });
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.subscription.remove();
	    }
	
	    // TODO: Create a separate component for balance.
	
	  }, {
	    key: 'updateModel',
	    value: function updateModel() {
	      var _this3 = this;
	
	      return this.DashboardStore.getDashboardDetails().then(function (details) {
	        _this3.model.balance.unallocated = details.balance.unallocated;
	        _this3.model.balance.acWalletWithdrawable = details.balance.acWalletWithdrawable;
	        //this.model.balance.totalRunningCommission = details.balance.totalRunningCommission;
	
	        _this3.model.currency = details.others.currency;
	        _this3.model.verifiedAt = details.others.verifiedAt;
	        _this3.model.activatedAt = details.others.activatedAt;
	        _this3.model.status = details.others.verifiedAt ? 'Verified' : 'Not Verified';
	
	        //For now affiliate stats is not yet part of this feature.
	        //We will uncomment this once they have decided to use the affiliate stats graph.
	        /*this.model.statistics.referralCount = details.statistics.referralCount;
	        this.model.statistics.newCustomers = details.statistics.newCustomers;
	        this.model.statistics.customersWithDeposit = details.statistics.customersWithDeposit;
	        this.model.statistics.activeCustomers = details.statistics.activeCustomers;*/
	      });
	    }
	  }, {
	    key: 'onCustomerProductsLoaded',
	    value: function onCustomerProductsLoaded(customerProductsList) {
	      this.model.balance.available = customerProductsList.balance;
	    }
	  }, {
	    key: 'refreshBalance',
	    value: function refreshBalance() {
	      var _this4 = this;
	
	      this.updateModel().then(function () {
	        return _this4.broadcast('reload.customer-products');
	      });
	    }
	  }, {
	    key: 'checkStatus',
	    value: function checkStatus() {
	      var _this5 = this;
	
	      this.DashboardStore.getCondition().then(function (response) {
	        var showModal = _this5.StorageService.getItem('show_activation_modal');
	        if ((0, _bool.parseBoolean)(showModal) && response.user.activation_code) {
	          if (response.user.activation_timestamp == response.user.activation_sent_timestamp) {
	            $('#welcome-modal').show();
	            _this5.isEnabled = false;
	          }
	        }
	      });
	    }
	  }]);
	  return DashboardController;
	}(_basecontroller.BaseController);
	
	exports.default = DashboardController;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardModel = function DashboardModel() {
	  (0, _classCallCheck3.default)(this, DashboardModel);
	
	  this.balance = {
	    unallocated: null,
	    available: null,
	    acWalletWithdrawable: 0,
	    totalRunningCommission: 0
	  };
	  this.currency = null;
	  this.verifiedAt = null;
	  this.activatedAt = null;
	  this.customerProducts = null;
	  this.modal = '';
	  this.status = null;
	
	  //For now affiliate stats is not yet part of this feature.
	  //We will uncomment this once they have decided to use the affiliate stats graph.
	  /*this.statistics = {
	    referralCount: 0,
	    newCustomers: 0,
	    customersWithDeposit: 0,
	    activeCustomers: 0,
	  };*/
	};
	
	exports.default = DashboardModel;

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseBoolean = parseBoolean;
	/**
	 * @returns true or false
	 */
	function parseBoolean(value) {
	  switch (value) {
	    case true:
	    case "true":
	    case 1:
	    case "1":
	    case "on":
	    case "yes":
	      return true;
	    default:
	      return false;
	  }
	}

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeBalance = makeBalance;
	exports.makeOtherDetails = makeOtherDetails;
	exports.makeStatistics = makeStatistics;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeBalance(details) {
	  return {
	    unallocated: details.unallocated
	    //For now affiliate stats is not yet part of this feature.
	    //We will uncomment this once they have decided to use the affiliate stats graph.
	    //acWalletWithdrawable: details.statistics.balances.withdrawable_balance,
	    //totalRunningCommission: details.statistics.balances.total_running_commission
	  };
	}
	
	function makeOtherDetails(details) {
	  return {
	    currency: details.currency === 'BTC' ? 'EUR' : details.currency,
	    verifiedAt: details.verified_at,
	    activatedAt: details.activated_at
	  };
	}
	
	function makeStatistics(details) {
	  return {
	    referralCount: details.statistics.statistics.referral_count,
	    newCustomers: details.statistics.statistics.current_period_new_customers,
	    customersWithDeposit: details.statistics.statistics.current_period_customers_with_deposit,
	    activeCustomers: details.statistics.statistics.current_period_active_customers
	  };
	}
	
	var DashboardStore = function () {
	  DashboardStore.$inject = ["DashboardApiService", "CustomerApiService"];
	  function DashboardStore(DashboardApiService, CustomerApiService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DashboardStore);
	    this.DashboardApiService = DashboardApiService;
	    this.CustomerApiService = CustomerApiService;
	  }
	
	  (0, _createClass3.default)(DashboardStore, [{
	    key: 'getDashboardDetails',
	    value: function getDashboardDetails() {
	      return this.DashboardApiService.dashboard().then(function (details) {
	        return {
	          balance: makeBalance(details),
	          others: makeOtherDetails(details)
	          //statistics: makeStatistics(details),
	        };
	      });
	    }
	  }, {
	    key: 'getCustomerProducts',
	    value: function getCustomerProducts() {
	      return this.CustomerApiService.getProducts();
	    }
	  }, {
	    key: 'getCondition',
	    value: function getCondition() {
	      return this.DashboardApiService.condition();
	    }
	  }]);
	  return DashboardStore;
	}();
	
	exports.default = DashboardStore;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _angularSanitize = __webpack_require__(1183);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _deposit = __webpack_require__(1591);
	
	var _deposit2 = _interopRequireDefault(_deposit);
	
	var _form = __webpack_require__(1595);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var depositModule = _angular2.default.module('deposit2', [_angularjs2.default, _angularSanitize2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('deposit2', {
	    parent: 'standardLayout',
	    url: '/transactions/deposit2',
	    component: 'deposit2',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('deposit2', _deposit2.default).component('depositForm2', _form2.default).name;
	
	exports.default = depositModule;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deposit = __webpack_require__(1592);
	
	var _deposit2 = _interopRequireDefault(_deposit);
	
	var _deposit3 = __webpack_require__(1593);
	
	var _deposit4 = _interopRequireDefault(_deposit3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var depositComponent = {
	  bindings: {
	    details: '<',
	    email: '<'
	  },
	  template: _deposit2.default,
	  controller: _deposit4.default
	};
	
	exports.default = depositComponent;

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper\">\n\t<div class=\"content\">\n\t\t<div class=\"container\">\n\t\t\t<div class=\"content-left col-sm-12 col-md-10 fadeIn animated\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-sm-12\">\n\t\t\t\t\t<div class=\"card-box\">\n\t\t\t\t\t\t<div class=\"portlet custom-accord\">\n\t\t\t\t\t\t\t<div class=\"portlet-heading portlet-default\">\n\t\t\t\t\t\t\t\t<h3 class=\"portlet-title\">\n\t\t\t\t\t\t\t\t\tDeposit\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<div class=\"portlet-widgets\">\n\t\t\t\t\t\t\t\t\t<a ng-click=\"$ctrl.refreshProducts()\" href=\"javascript:;\" data-toggle=\"reload\"><i class=\"ion-refresh\"></i></a>\n\t\t\t\t\t\t\t\t\t<a data-toggle=\"collapse\" data-parent=\"#accordion1\" href=\"#deposit\" class=\"\" aria-expanded=\"true\"><i class=\"ion-minus-round\"></i></a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"clearfix border-b\"></div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div id=\"deposit\" class=\"panel-collapse collapse in\" aria-expanded=\"true\" style=\"\">\n\t\t\t\t\t\t\t\t<div class=\"panel-body\">\n\t\t\t\t\t\t\t\t\t<div class=\"alert alert-success notif-success\">\n\t\t\t\t\t\t\t\t\t\t<strong>Note:</strong> Make sure you have sufficient funds in your account to bet on these bookies. If you'd like to make a deposit, see instruction below.\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div loading=\"$ctrl.customerProducts\"></div>\n\t\t\t\t\t\t\t\t\t<customer-products-list ng-if=\"$ctrl.customerProducts\" customer-products=\"$ctrl.customerProducts\"></customer-products-list>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"clearfix\"></div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-sm-12\">\n\t\t\t\t\t<div class=\"card-box\">\n\t\t\t\t\t\t  <div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t\t\t\t\t<ul class=\"nav nav-tabs navtab-bg nav-justified\">\n\t\t\t\t\t\t\t\t\t\t<li ng-click=\"$ctrl.onTabSelected(tabItem)\" ng-repeat=\"tabItem in $ctrl.tabsModel.tabItems\" ng-class=\"{'active': tabItem.isActive}\">\n\t\t\t\t\t\t\t\t\t\t\t<a data-toggle=\"tab\" aria-expanded=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t<span>{{ tabItem.paymentOption.type }}</span>\n\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-12 pull-left\">\n\t\t\t\t\t\t\t\t\t<div ng-show=\"$ctrl.selectedTabItem.paymentOption.type !== 'BANK'\">\n\t\t\t\t\t\t\t\t\t\t<p class=\"m-t-10\" ng-bind-html=\"$ctrl.selectedTabItem.paymentOption.display.selected\"></p>\n\t\t\t\t\t\t\t\t\t\t<img ng-src=\"{{ $ctrl.selectedTabItem.paymentOption.display.logo }}\" class=\"payment-option-logo\">\n\t\t\t\t\t\t\t\t\t\t<hr/>\n\t\t\t\t\t\t\t\t\t\t<p>{{ $ctrl.selectedTabItem.paymentOption.display.description }}</p>\n\n\t\t\t\t\t\t\t\t\t\t<p ng-repeat=\"field in $ctrl.selectedTabItem.paymentOption.display.fields\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"margin-right-50\"><b>{{ field.label }}:</b> {{ field.value }} </span>\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- We do not show this on bitcoin. -->\n\t\t\t\t\t\t\t\t\t\t<ul ng-show=\"$ctrl.selectedTabItem.paymentOption.type !== 'BITCOIN'\">\n\t\t\t\t\t\t\t\t\t\t\t<li><b>Processing time:</b> {{ $ctrl.selectedTabItem.paymentOption.display.paymentMethods.deposit.processingTime }}</li>\n\t\t\t\t\t\t\t\t\t\t\t<li class=\"m-t-5\"><b>Fee:</b> {{ $ctrl.selectedTabItem.feeDisplayFor('deposit') }}</li>\n\t\t\t\t\t\t\t\t\t\t\t<li class=\"m-t-5\"><b>Minimum Deposit Amount:</b> {{ $ctrl.selectedTabItem.paymentOption.display.paymentMethods.deposit.minimumDeposit }}</li>\n\t\t\t\t\t\t\t\t\t\t\t<li class=\"m-t-5\"><b>Maximum Deposit Amount:</b> {{ $ctrl.selectedTabItem.paymentOption.display.paymentMethods.deposit.maximumDeposit }}</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<div ng-show=\"$ctrl.selectedTabItem.paymentOption.type === 'BANK'\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"alert alert-warning\">\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Note: </strong> Bankwire transactions are temporarily unavailable. Please contact Customer Support for assistance.</p>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<!-- <p ng-repeat=\"field in $ctrl.PaymentOptionsViewDetails.activeDisplay.fields\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"margin-right-50\"><b>{{ field.label }}:</b> {{ field.value}} </span>\n\t\t\t\t\t\t\t\t\t</p> -->\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<deposit-form2 ng-if=\"$ctrl.customerProducts && $ctrl.selectedTabItem.paymentOption.type !== 'BANK'\" customer-products=\"$ctrl.customerProducts\" payment-option=\"$ctrl.selectedTabItem.paymentOption\"></deposit-form2>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _events = __webpack_require__(494);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _tabs = __webpack_require__(1594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DepositController = function (_BaseController) {
	  DepositController.$inject = ["CustomerApiService", "TransactionApiService", "EventDispatcherService", "SessionService"];
	  (0, _inherits3.default)(DepositController, _BaseController);
	
	  function DepositController(CustomerApiService, TransactionApiService, EventDispatcherService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DepositController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DepositController.__proto__ || (0, _getPrototypeOf2.default)(DepositController)).call(this));
	
	    _this.CustomerApiService = CustomerApiService;
	    _this.TransactionApiService = TransactionApiService;
	    _this.EventDispatcherService = EventDispatcherService;
	    _this.SessionService = SessionService;
	
	    _this.SessionService.session.map(function (session) {
	      if (session) {
	        _this.userCurrency = session.currency;
	      } else {
	        _this.userCurrency = null;
	      }
	    });
	
	    _this.customerProducts = null;
	    _this.paymentOptions = null;
	    _this.tabsModel = null;
	    _this.selectedTabItem = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(DepositController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.addSubscription(this.EventDispatcherService.addListener(_events2.default.BET_PROCESSED, function (event) {
	        return _this2.loadProducts();
	      }));
	      this.addSubscription(this.EventDispatcherService.addListener(_events2.default.BTC_EXCHANGE_RATE, function (event) {
	        var bitcoinRate = event.bitcoinRate;
	      }));
	
	      this.TransactionApiService.getPaymentOptions().then(function (paymentOptions) {
	        _this2.paymentOptions = paymentOptions;
	        _this2.tabsModel = _tabs.TabsModel.fromPaymentOptions(_this2.paymentOptions);
	        _this2.selectedTabItem = _this2.tabsModel.selectedTabItem;
	      });
	
	      this.loadProducts();
	    }
	  }, {
	    key: 'onTabSelected',
	    value: function onTabSelected(tabItem) {
	      this.tabsModel.selectTabItem(tabItem);
	      this.selectedTabItem = tabItem;
	    }
	  }, {
	    key: 'loadProducts',
	    value: function loadProducts() {
	      var _this3 = this;
	
	      this.CustomerApiService.getProducts().then(function (customerProducts) {
	        return _this3.customerProducts = customerProducts;
	      });
	    }
	  }]);
	  return DepositController;
	}(_basecontroller.BaseController);
	
	exports.default = DepositController;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabsModel = exports.TabItem = undefined;
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabItem = exports.TabItem = function () {
	  function TabItem() {
	    (0, _classCallCheck3.default)(this, TabItem);
	
	    this._paymentOption = null;
	    this._isActive = false;
	  }
	
	  (0, _createClass3.default)(TabItem, [{
	    key: "toggle",
	    value: function toggle() {
	      this._isActive = !this._isActive;
	    }
	  }, {
	    key: "paymentOption",
	    set: function set(paymentOption) {
	      this._paymentOption = paymentOption;
	    },
	    get: function get() {
	      return this._paymentOption;
	    }
	  }, {
	    key: "isActive",
	    set: function set(isActive) {
	      this._isActive = isActive;
	    },
	    get: function get() {
	      return this._isActive;
	    }
	  }], [{
	    key: "fromPaymentOption",
	    value: function fromPaymentOption(paymentOption) {
	      var tabItem = new TabItem();
	
	      tabItem.paymentOption = paymentOption;
	
	      return tabItem;
	    }
	  }]);
	  return TabItem;
	}();
	
	var TabsModel = exports.TabsModel = function () {
	  function TabsModel() {
	    (0, _classCallCheck3.default)(this, TabsModel);
	
	    this._paymentOptions = null;
	    this._tabItems = [];
	  }
	
	  (0, _createClass3.default)(TabsModel, [{
	    key: "selectTabItem",
	    value: function selectTabItem(selectedTabItem) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.tabItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var tabItem = _step.value;
	
	          if (selectedTabItem === tabItem) {
	            selectedTabItem.toggle();
	          } else {
	            tabItem.isActive = false;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: "paymentOptions",
	    set: function set(paymentOptions) {
	      this._paymentOptions = paymentOptions;
	    },
	    get: function get() {
	      return this._paymentOptions;
	    }
	  }, {
	    key: "tabItems",
	    set: function set(tabItems) {
	      this._tabItems = tabItems;
	    },
	    get: function get() {
	      return this._tabItems;
	    }
	  }, {
	    key: "selectedTabItem",
	    get: function get() {
	      var tabItem = this.tabItems.filter(function (tab) {
	        return tab.isActive;
	      })[0];
	
	      return tabItem;
	    }
	  }], [{
	    key: "fromPaymentOptions",
	    value: function fromPaymentOptions(paymentOptions) {
	      var tabsModel = new TabsModel();
	
	      tabsModel.paymentOptions = paymentOptions;
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(paymentOptions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var paymentOption = _step2.value;
	
	          tabsModel.tabItems.unshift(TabItem.fromPaymentOption(paymentOption));
	        }
	
	        // mark the first item as selected / active
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      tabsModel.tabItems[0].toggle();
	
	      return tabsModel;
	    }
	  }]);
	  return TabsModel;
	}();
	
	exports.default = TabsModel;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1596);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1597);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    customerProducts: '<',
	    paymentOption: '<',
	    onSuccessfulSubmission: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	module.exports = "<form>\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      <div ng-show=\"$ctrl.transactionForm.paymentOptionType !== 'ECOPAYZ'\" class=\"form-group\">\n          <label class=\"col-md-4 control-label\">Email</label>\n          <div class=\"col-md-8\">\n            <input ng-model=\"$ctrl.form.email\" ng-disabled=\"$ctrl.form.props.readOnly\" ng-class=\"{ 'parsley-error': $ctrl.form.error.email }\" type=\"text\" class=\"form-control\">\n            <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.error.email\">\n              <li ng-repeat=\"(key, error) in $ctrl.form.error.email\" class=\"parsley-required\">{{ error }}</li>\n            </ul>\n          </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\" ng-repeat=\"subtransaction in $ctrl.transactionForm.subtransactionsForm\">\n    <div class=\"col-md-6\">\n      <div class=\"form-group\">\n        <label class=\"col-md-4 control-label\">Product Name</label>\n        <div class=\"col-md-8\">\n          <select\n            ng-model=\"subtransaction.customerProduct\"\n            ng-init=\"oldValue=null\"\n            ng-change=\"$ctrl.transactionForm.onChangedCustomerProduct($index, subtransaction.customerProduct, oldValue)\"\n            ng-options=\"customerProduct.id as (customerProduct.productName + ' ( ' + customerProduct.username + ' ) ' ) for customerProduct in subtransaction.customerProducts\"\n            ng-click=\"oldValue=subtransaction.customerProduct\"\n            ng-disabled=\"$ctrl.form.props.readOnly\"\n            class=\"form-control\">\n            <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n            <!-- <option ng-repeat=\"customerProduct in $ctrl.form.customerProducts\" ng-value=\"{{ customerProduct.id }}\">{{ customerProduct.productName}} ({{ customerProduct.username }})</option> -->\n          </select>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-6\">\n      <div class=\"form-group\">\n        <label class=\"col-md-4 col-sm-12 col-xs-12 control-label text-left\">Amount:</label>\n        <div class=\"col-md-7 col-sm-11 col-xs-11\">\n          <input ng-model=\"subtransaction.amount\" ng-disabled=\"$ctrl.form.props.readOnly\" limit=\"6\" precision=\"2\" type=\"text\" class=\"form-control\">\n          <span class=\"currency-input\">{{ $ctrl.userCurrency$  | async }}</span>\n        </div>\n        <div class=\"col-md-1 col-sm-1 col-xs-1\">\n          <button ng-click=\"$ctrl.transactionForm.removeSubTransaction(subtransaction, $index)\" ng-if=\"$ctrl.transactionForm.canRemoveSubtransaction()\" class=\"btn btn-xs btn-danger pull-right\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row text-right\">\n      <div class=\"col-md-6\">\n        <div class=\"col-md-8\">\n          <div class=\"col-md-4\"></div>\n          <button ng-if=\"$ctrl.transactionForm.canAddCustomerProduct()\" ng-click=\"$ctrl.transactionForm.addSubtransaction()\" type=\"button\" class=\"add-pr\"><i class=\"fa fa-plus\"></i> Add another product</button>\n        </div>\n      </div><span class=\"text-red\"></span>\n    </div>\n  </div>\n\n  <div class=\"row total-amount\">\n    <div class=\"col-md-6 col-md-offset-6\">\n      <p class=\"text-right text-red\"><b>Total amount to be deposited on account:</b> {{ $ctrl.transactionForm.totalAmount }} {{ $ctrl.userCurrency }}</p>\n      <!-- <p class=\"text-right text-red\"><b>Fee:</b>\n        <span ng-if=\"$ctrl.PaymentOptionsViewDetails.feeDisplayFor('deposit') === 'FREE'\">Free</span>\n        <span ng-if=\"$ctrl.PaymentOptionsViewDetails.feeDisplayFor('deposit') !== 'FREE'\">{{ $ctrl.form.fee |number: 2}} {{ $ctrl.userCurrency$ |async }}</span>\n      </p> -->\n      <hr>\n      <h5 class=\"text-right\"><b>Total amount to be sent:</b> <span class=\"text-red\">{{ $ctrl.form.totalAmountToBeSent | number }} {{ $ctrl.userCurrency }}</span></h5>\n    </div>\n  </div>\n</form>"

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormController = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _transactionForm = __webpack_require__(1598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = exports.FormController = function () {
	  function FormController() {
	    (0, _classCallCheck3.default)(this, FormController);
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.transactionForm = new _transactionForm.TransactionForm(this.customerProducts);
	    }
	  }, {
	    key: "$doCheck",
	    value: function $doCheck() {
	      if (this.transactionForm && this.paymentOption) {
	        this.transactionForm.paymentOptionType = this.paymentOption.type;
	      }
	    }
	  }, {
	    key: "submit",
	    value: function submit() {}
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TransactionForm = exports.SubtransactionForm = undefined;
	
	var _slicedToArray2 = __webpack_require__(447);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubtransactionForm = exports.SubtransactionForm = function () {
	  function SubtransactionForm(key) {
	    (0, _classCallCheck3.default)(this, SubtransactionForm);
	
	    this._key = key;
	
	    this._customerProduct = null;
	    this._amount = 0;
	
	    // select model
	    this._customerProducts = [];
	  }
	
	  (0, _createClass3.default)(SubtransactionForm, [{
	    key: 'key',
	    get: function get() {
	      return this._key;
	    }
	  }, {
	    key: 'customerProduct',
	    set: function set(customerProduct) {
	      this._customerProduct = customerProduct;
	    },
	    get: function get() {
	      return this._customerProduct;
	    }
	  }, {
	    key: 'customerProducts',
	    set: function set(customerProducts) {
	      this._customerProducts = customerProducts;
	    },
	    get: function get() {
	      return this._customerProducts;
	    }
	  }, {
	    key: 'amount',
	    set: function set(amount) {
	      this._amount = amount;
	    },
	    get: function get() {
	      return this._amount;
	    }
	  }, {
	    key: 'customerProductSelect',
	    get: function get() {
	      return this._customerProducts;
	    }
	  }]);
	  return SubtransactionForm;
	}();
	
	var TransactionForm = exports.TransactionForm = function () {
	  function TransactionForm(customerProducts) {
	    (0, _classCallCheck3.default)(this, TransactionForm);
	
	    // form fields model
	    this._email = null;
	    this._paymentOptionType = null;
	    this._subTransactionsForm = [];
	    this._fee = 0;
	
	    // select model
	    this._customerProducts = customerProducts;
	    this._selectedCustomerProducts = [];
	
	    // misc
	    this.nextItemKey = 0;
	
	    this.addSubtransaction();
	  }
	
	  (0, _createClass3.default)(TransactionForm, [{
	    key: 'addSubtransaction',
	    value: function addSubtransaction() {
	      var _this = this;
	
	      var subtransactionForm = new SubtransactionForm(this.nextItemKey);
	
	      var copy = this.customerProducts.slice(0);
	      copy = copy.filter(function (item) {
	        return !_this.selectedCustomerProducts.includes(item.id);
	      });
	      subtransactionForm.customerProducts = copy;
	
	      if (this.customerProducts.length === 1) {
	        subTransaction.customerProduct = this.customerProducts[0].id;
	      }
	
	      this.subtransactionsForm.push(subtransactionForm);
	
	      this.nextItemKey++;
	    }
	  }, {
	    key: 'removeSubTransaction',
	    value: function removeSubTransaction(subtransactionForm, index) {
	      this.removeFromSelectedProducts(subtransactionForm.customerProduct);
	      this.reloadToAllCustomerProducts(subtransactionForm.customerProduct, index);
	
	      for (var i = 0; i < this.subtransactionsForm.length; i++) {
	        if (this.subtransactionsForm[i].key === subtransactionForm.key) {
	          this.subtransactionsForm.splice(i, 1);
	          break;
	        }
	      }
	    }
	  }, {
	    key: 'canAddCustomerProduct',
	    value: function canAddCustomerProduct() {
	      return this.customerProducts.length > 1;
	    }
	  }, {
	    key: 'canRemoveSubtransaction',
	    value: function canRemoveSubtransaction() {
	      return this.subtransactionsForm.length > 1;
	    }
	  }, {
	    key: 'toPayload',
	    value: function toPayload() {
	      var payload = {
	        transaction: {
	          email: this.email,
	          paymentOptionType: this.paymentOptionType
	        }
	      };
	
	      payload['transaction']['paymentOption'] = this.paymentOption;
	      payload['transaction']['customerFee'] = this.fee;
	
	      var subTransactions = {};
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.subTransactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _subTransaction = _step.value;
	
	          subTransactions[_subTransaction.key] = {
	            product: _subTransaction.product,
	            amount: _subTransaction.amount
	          };
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return payload;
	    }
	
	    //============================================================================
	    //  Code Below handles operations when a change in product selection occurs.
	    //============================================================================
	
	  }, {
	    key: 'onChangedCustomerProduct',
	    value: function onChangedCustomerProduct(index, newValue, oldValue) {
	      this.selectedCustomerProducts.push(newValue);
	      this.removeFromSelectedProducts(oldValue);
	      this.removeFromSelection(newValue, index);
	      this.reloadToAllCustomerProducts(oldValue, index);
	    }
	  }, {
	    key: 'removeFromSelection',
	    value: function removeFromSelection(newValue, index) {
	      // Remove CustomerProduct with id matching the newValue within each SubTransactions
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.subtransactionsForm.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
	              sIndex = _step2$value[0],
	              _subTransaction2 = _step2$value[1];
	
	          // This condition will not remove the CustomerProduct from the owning SubTransaction.
	          // The reason is that, when we tried to remove it, the ng-model will be affected does
	          // will unselect the selection. Apparently, this is the same implementation on OLD AMS.
	          if (index !== sIndex) {
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = (0, _getIterator3.default)(this.subtransactionsForm[sIndex].customerProducts.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
	                    cIndex = _step3$value[0],
	                    customerProduct = _step3$value[1];
	
	                if (customerProduct.id === newValue) {
	                  this.subtransactionsForm[sIndex].customerProducts.splice(cIndex, 1);
	                }
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'removeFromSelectedProducts',
	    value: function removeFromSelectedProducts(value) {
	      if (value) {
	        var oldValueIndex = this.selectedCustomerProducts.indexOf(value);
	        this.selectedCustomerProducts.splice(oldValueIndex, 1);
	      }
	    }
	
	    // Push CustomerProduct with id matching the oldValue (if oldValue is not null) within each SubTransactions
	
	  }, {
	    key: 'reloadToAllCustomerProducts',
	    value: function reloadToAllCustomerProducts(oldValue, index) {
	      if (oldValue) {
	        var oldCustomerProduct = this.getCustomerProductById(oldValue);
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(this.subtransactionsForm.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
	                sIndex = _step4$value[0],
	                _subTransaction3 = _step4$value[1];
	
	            if (index !== sIndex) {
	              _subTransaction3.customerProducts.push(oldCustomerProduct);
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getCustomerProductById',
	    value: function getCustomerProductById(id) {
	      return this.customerProducts.filter(function (customerProduct) {
	        return customerProduct.id === id;
	      })[0];
	    }
	  }, {
	    key: 'email',
	    set: function set(email) {
	      this._email = email;
	    },
	    get: function get() {
	      return this._email;
	    }
	  }, {
	    key: 'paymentOptionType',
	    set: function set(paymentOptionType) {
	      this._paymentOptionType = paymentOptionType;
	    },
	    get: function get() {
	      return this._paymentOptionType;
	    }
	  }, {
	    key: 'subtransactionsForm',
	    set: function set(subtransactionsForm) {
	      this.subtransactionsForm = subtransactionsForm;
	    },
	    get: function get() {
	      return this._subTransactionsForm;
	    }
	  }, {
	    key: 'fee',
	    set: function set(fee) {
	      this._fee = fee;
	    },
	    get: function get() {
	      return this._fee;
	    }
	  }, {
	    key: 'customerProducts',
	    get: function get() {
	      return this._customerProducts;
	    }
	  }, {
	    key: 'selectedCustomerProducts',
	    get: function get() {
	      return this._selectedCustomerProducts;
	    }
	  }, {
	    key: 'totalAmount',
	    get: function get() {
	      var totalAmount = (0, _numeral2.default)(0);
	
	      this.subtransactionsForm.forEach(function (subtransactionForm) {
	        totalAmount = totalAmount.add(subtransactionForm.amount);
	      });
	
	      return totalAmount.format('0.00');
	    }
	  }, {
	    key: 'totalAmountToBeSent',
	    get: function get() {
	      var totalAmount = (0, _numeral2.default)(this.totalAmount);
	      totalAmount = totalAmount.add(this.fee);
	
	      return totalAmount.format('0.00');
	    }
	  }]);
	  return TransactionForm;
	}();

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _betoverview = __webpack_require__(1600);
	
	var _betoverview2 = _interopRequireDefault(_betoverview);
	
	var _overview = __webpack_require__(1603);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _searchform = __webpack_require__(1606);
	
	var _searchform2 = _interopRequireDefault(_searchform);
	
	var _summarytable = __webpack_require__(1615);
	
	var _summarytable2 = _interopRequireDefault(_summarytable);
	
	var _bets = __webpack_require__(1618);
	
	var _bets2 = _interopRequireDefault(_bets);
	
	var _filterdetails = __webpack_require__(1622);
	
	var _filterdetails2 = _interopRequireDefault(_filterdetails);
	
	var _listing = __webpack_require__(1625);
	
	var _listing2 = _interopRequireDefault(_listing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components for overview
	var betoverviewModule = _angular2.default.module('betoverview', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('betoverview', {
	    parent: 'standardLayout',
	    redirectTo: 'betoverview.overview',
	    url: '/betoverview',
	    component: 'betoverview'
	  }).state('betoverview.overview', {
	    url: '',
	    component: 'betOverviewOverview',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  }).state('betoverview.bets', {
	    url: '/bets?from&to&league&betType&betTypeText&leagueText',
	    component: 'bets',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    },
	    reloadOnSearch: false
	  });
	}]).component('betoverview', _betoverview2.default)
	// Overview Components
	.component('betOverviewOverview', _overview2.default).component('overviewSearchForm', _searchform2.default).component('overviewSummaryTable', _summarytable2.default)
	// Bets Componnents
	.component('bets', _bets2.default).component('filterDetails', _filterdetails2.default).component('betListing', _listing2.default).name;
	
	// Components for bets
	exports.default = betoverviewModule;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _betoverview = __webpack_require__(1601);
	
	var _betoverview2 = _interopRequireDefault(_betoverview);
	
	var _betoverview3 = __webpack_require__(1602);
	
	var _betoverview4 = _interopRequireDefault(_betoverview3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var betoverviewComponent = {
	  bindings: {},
	  template: _betoverview2.default,
	  controller: _betoverview4.default
	};
	
	exports.default = betoverviewComponent;

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetOverviewController = function BetOverviewController() {
	  (0, _classCallCheck3.default)(this, BetOverviewController);
	};
	
	exports.default = BetOverviewController;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _overview = __webpack_require__(1604);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _overview3 = __webpack_require__(1605);
	
	var _overview4 = _interopRequireDefault(_overview3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var overviewComponent = {
	  bindings: {},
	  template: _overview2.default,
	  controller: _overview4.default
	};
	
	exports.default = overviewComponent;

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"col-md-12\">\n        <h2 class=\"text-dark\">Skype Betting</h2>\n      </div>\n      <div class=\"col-sm-9 fadeIn animated\">\n        <div class=\"card-box\">\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <h3 class=\"m-l-20 text-dark\"><i class=\"ti-stats-up\"></i> Bet Overview</h3>\n              <hr class=\"m-b-30\">\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <div class=\"card-box\">\n                <overview-search-form on-fetch-bet-overview=\"$ctrl.onFetchBetOverview(betoverview, payload)\"></overview-search-form>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-lg-12\">\n              <overview-summary-table bet-overview-details=\"$ctrl.betOverviewDetails\", payload=\"$ctrl.payload\"></overview-summary-table>\n            </div>\n          </div>\n          \n        </div>\n      </div>\n\n      <div class=\"col-lg-3\">\n          <img src=\"assets/images/ads-banner.jpg\" class=\"img-responsive\">\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OverviewController = function () {
	  function OverviewController() {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OverviewController);
	  }
	
	  (0, _createClass3.default)(OverviewController, [{
	    key: 'onFetchBetOverview',
	    value: function onFetchBetOverview(betoverview, payload) {
	      this.betOverviewDetails = betoverview;
	      this.payload = payload;
	    }
	  }]);
	  return OverviewController;
	}();
	
	exports.default = OverviewController;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _searchform = __webpack_require__(1607);
	
	var _searchform2 = _interopRequireDefault(_searchform);
	
	var _searchform3 = __webpack_require__(1608);
	
	var _searchform4 = _interopRequireDefault(_searchform3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    onFetchBetOverview: '&'
	  },
	  template: _searchform2.default,
	  controller: _searchform4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	module.exports = "<form name=\"searchform\" role=\"form\" ng-submit=\"$ctrl.submit()\" novalidate>\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <div class=\"row\">\n        <div class=\"col-md-3 form-group\">\n          <label>From</label>\n          <div class=\"input-group\">\n            <date-picker autoclose=\"true\" today-highlight=\"true\" name=\"from\" type=\"text\" ng-model=\"$ctrl.form.dateFrom\" placeholder=\"mm/dd/yyyy\"></date-picker>\n          </div>\n        </div>\n        <div class=\"col-md-3 form-group\">\n          <label>To</label>\n          <div class=\"input-group\">\n            <date-picker autoclose=\"true\" today-highlight=\"true\" type=\"text\" name=\"to\" ng-model=\"$ctrl.form.dateTo\" placeholder=\"mm/dd/yyyy\"></date-picker>\n          </div>\n        </div>\n        <div class=\"col-md-3 form-group\">\n          <label>League</label>\n          <select\n            ng-model=\"$ctrl.form.league\"\n            ng-options=\"item.value as item.text for item in $ctrl.form.leagueSelect.items\"\n            class=\"form-control\"\n            name=\"league\"\n            data-style=\"btn-white\">\n          </select>\n        </div>\n        <div class=\"col-md-3 form-group\">\n          <label>Bet Type</label>\n          <select \n            ng-model=\"$ctrl.form.betType\"\n            ng-readonly=\"$ctrl.form.props.betType.readOnly\"\n            ng-options=\"item.value as item.text disable when item.props.disabled for item in $ctrl.form.betTypeSelect.items\"\n            ng-change=\"$ctrl.onBetTypeChange()\"\n            class=\"form-control\"\n            name=\"betType\"\n            data-style=\"btn-white\">\n          </select>\n        </div>\n      </div>\n      <div class=\"row\">\n        <!-- <div class=\"col-md-6 form-group\">\n          <label>Bet Selection</label>\n          <select \n            ng-model=\"$ctrl.form.betSelection\"\n            ng-disabled=\"$ctrl.form.props.betSelection.readOnly\"\n            ng-options=\"item.value as item.text disable when item.props.disabled for item in $ctrl.form.betSelectionSelect.items\"\n            ng-change=\"$ctrl.onBetSelectionChange()\"\n            name=\"betSelection\"\n            class=\"form-control\" \n            data-style=\"btn-white\">\n          </select>\n        </div> -->\n        <!-- <div class=\"col-md-3 form-group\">\n          <label>Stake Range</label>\n          <select class=\"selectpicker\" data-style=\"btn-white\">\n            <option>All</option>\n            <option>Ketchup</option>\n            <option>Relish</option>\n          </select>\n        </div> -->\n      </div>\n    </div>\n    <div class=\"col-md-4\">\n      <div class=\"form-group m-t-5\">\n        <!-- <button ng-click=\"$ctrl.submit()\" type=\"button\" class=\"btn btn-default waves-effect waves-light m-t-20\" style=\"margin\">Search</button> -->\n        <ladda-button on-click=\"$ctrl.submit()\" type=\"submit\" text=\"'Search'\" class=\"'m-t-20'\"></ladda-button>\n        <button class=\"btn btn-inverse waves-effect waves-light m-t-20\" ng-click=\"$ctrl.reset()\">Reset</button>\n      </div>\n    </div>\n  </div>\n</form>"

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(1122);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _searchform = __webpack_require__(1609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchFormController = function (_BaseController) {
	  SearchFormController.$inject = ["BetOverviewApiService", "FormService"];
	  (0, _inherits3.default)(SearchFormController, _BaseController);
	
	  function SearchFormController(BetOverviewApiService, FormService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SearchFormController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchFormController.__proto__ || (0, _getPrototypeOf2.default)(SearchFormController)).call(this));
	
	    _this.BetOverviewApiService = BetOverviewApiService;
	    _this.FormService = FormService;
	    return _this;
	  }
	
	  (0, _createClass3.default)(SearchFormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.form = new _searchform.SearchFormModel();
	      var payload = this.form.toPayload();
	
	      this.BetOverviewApiService.getLeagues().then(function (leagues) {
	        return _this2.form.leagues = leagues;
	      });
	      this.BetOverviewApiService.getBetOverview(payload).then(function (betoverview) {
	        return _this2.onFetchBetOverview({ betoverview: betoverview, payload: payload });
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this3 = this;
	
	      this.FormService.isSubmitting.next(true);
	
	      var payload = this.form.toPayload();
	      var searchform = this.FormService.evaluateForms()['searchform'];
	
	      var mergedPayload = (0, _lodash.merge)(payload, {
	        betTypeText: searchform.betType.text,
	        leagueText: searchform.league.text
	      });
	
	      this.BetOverviewApiService.getBetOverview(payload).then(function (betoverview) {
	        _this3.onFetchBetOverview({ betoverview: betoverview, payload: mergedPayload });
	        _this3.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'onBetTypeChange',
	    value: function onBetTypeChange() {
	      var _this4 = this;
	
	      this.form.props.betSelection.readOnly = false;
	
	      this.form.betSelectionSelect.resetProperties();
	      this.form.betTypeSelect.resetProperties();
	
	      var betTypeSelectChangeBehavior = {
	        '1X2': function X2() {
	          _this4.form.betSelectionSelect.setProperty('Under', 'disabled', true);
	          _this4.form.betSelectionSelect.setProperty('Over', 'disabled', true);
	        },
	        'AHDP': function AHDP() {
	          _this4.form.betSelectionSelect.setProperty('Under', 'disabled', true);
	          _this4.form.betSelectionSelect.setProperty('Over', 'disabled', true);
	          _this4.form.betSelectionSelect.setProperty('Draw', 'disabled', true);
	        },
	        'O/U': function OU() {
	          _this4.form.betSelectionSelect.setProperty('Home', 'disabled', true);
	          _this4.form.betSelectionSelect.setProperty('Away', 'disabled', true);
	          _this4.form.betSelectionSelect.setProperty('Draw', 'disabled', true);
	        },
	        'Special/Multiple': function SpecialMultiple() {
	          _this4.form.props.betSelection.readOnly = true;
	        },
	        '': function _() {
	          _this4.form.betSelection = '';
	          _this4.form.props.betSelection.readOnly = true;
	        }
	      };
	
	      betTypeSelectChangeBehavior[this.form.betType]();
	    }
	  }, {
	    key: 'onBetSelectionChange',
	    value: function onBetSelectionChange() {
	      var _this5 = this;
	
	      this.form.betSelectionSelect.resetProperties();
	      this.form.betTypeSelect.resetProperties();
	
	      var betSelectionChangeBehavior = {
	        'Draw': function Draw() {
	          _this5.form.betTypeSelect.setProperty('AHDP', 'disabled', true);
	          _this5.form.betTypeSelect.setProperty('O/U', 'disabled', true);
	          _this5.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
	        },
	        'Home': function Home() {
	          _this5.form.betTypeSelect.setProperty('O/U', 'disabled', true);
	          _this5.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
	        },
	        'Away': function Away() {
	          _this5.form.betTypeSelect.setProperty('O/U', 'disabled', true);
	          _this5.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
	        },
	        'Under': function Under() {
	          _this5.form.betTypeSelect.setProperty('1X2', 'disabled', true);
	          _this5.form.betTypeSelect.setProperty('AHDP', 'disabled', true);
	          _this5.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
	        },
	        'Over': function Over() {
	          _this5.form.betTypeSelect.setProperty('1X2', 'disabled', true);
	          _this5.form.betTypeSelect.setProperty('AHDP', 'disabled', true);
	          _this5.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
	        }
	      };
	
	      betSelectionChangeBehavior[this.form.betSelection]();
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.form.reset();
	    }
	  }]);
	  return SearchFormController;
	}(_basecontroller.BaseController);
	
	exports.default = SearchFormController;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchFormModel = exports.BET_SELECTIONS = exports.BET_TYPES = undefined;
	
	var _assign = __webpack_require__(1610);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _freeze = __webpack_require__(1252);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _date = __webpack_require__(1490);
	
	var _select = __webpack_require__(1614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BET_TYPES = exports.BET_TYPES = (0, _freeze2.default)({
	  '1X2': '1X2',
	  'AHDP': 'AHDP',
	  'O/U': 'O/U',
	  'Special/Multiple': 'Special/Multiple'
	});
	
	var BET_SELECTIONS = exports.BET_SELECTIONS = (0, _freeze2.default)({
	  'Draw': 'Draw',
	  'Home': 'Home',
	  'Away': 'Away',
	  'Under': 'Under',
	  'Over': 'Over'
	});
	
	var SearchFormModel = exports.SearchFormModel = function () {
	  function SearchFormModel() {
	    (0, _classCallCheck3.default)(this, SearchFormModel);
	
	    this._dateFrom = (0, _date.currentDate)();
	    this._dateTo = (0, _date.currentDate)();
	    this._league = '';
	    this._betType = '';
	    this._betSelection = '';
	
	    this._betTypeSelect = new _select.SelectModel((0, _assign2.default)({ '': 'ALL' }, BET_TYPES));
	    this._betSelectionSelect = new _select.SelectModel((0, _assign2.default)({ '': 'ALL' }, BET_SELECTIONS));
	    this._leagueSelect = null;
	
	    this._leagues = [];
	
	    this.props = {
	      betType: {
	        readOnly: false
	      },
	      betSelection: {
	        readOnly: true
	      }
	    };
	  }
	
	  (0, _createClass3.default)(SearchFormModel, [{
	    key: 'toPayload',
	    value: function toPayload() {
	      return {
	        from: this.dateFrom,
	        to: this.dateTo,
	        league: this.league,
	        betType: this.betType,
	        bet: this.betSelection
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this._dateFrom = (0, _date.currentDate)();
	      this._dateTo = (0, _date.currentDate)();
	      this._league = '';
	      this._betType = '';
	      this._betSelection = '';
	    }
	  }, {
	    key: 'dateFrom',
	    set: function set(dateFrom) {
	      this._dateFrom = dateFrom;
	    },
	    get: function get() {
	      return this._dateFrom;
	    }
	  }, {
	    key: 'dateTo',
	    set: function set(dateTo) {
	      this._dateTo = dateTo;
	    },
	    get: function get() {
	      return this._dateTo;
	    }
	  }, {
	    key: 'league',
	    set: function set(league) {
	      this._league = league;
	    },
	    get: function get() {
	      return this._league;
	    }
	  }, {
	    key: 'betType',
	    set: function set(betType) {
	      this._betType = betType;
	    },
	    get: function get() {
	      return this._betType;
	    }
	  }, {
	    key: 'betSelection',
	    set: function set(betSelection) {
	      this._betSelection = betSelection;
	    },
	    get: function get() {
	      return this._betSelection;
	    }
	  }, {
	    key: 'stakeRange',
	    set: function set(stakeRange) {
	      this._stakeRange = stakeRange;
	    },
	    get: function get() {
	      return this._stakeRange;
	    }
	  }, {
	    key: 'betTypeSelect',
	    get: function get() {
	      return this._betTypeSelect;
	    }
	  }, {
	    key: 'betSelectionSelect',
	    get: function get() {
	      return this._betSelectionSelect;
	    }
	  }, {
	    key: 'leagueSelect',
	    get: function get() {
	      return this._leagueSelect;
	    }
	  }, {
	    key: 'leagues',
	    set: function set(leagues) {
	      this._leagueSelect = new _select.SelectModel((0, _assign2.default)({ '': 'ALL' }, leagues));
	    }
	  }]);
	  return SearchFormModel;
	}();

/***/ }),
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectModel = undefined;
	
	var _keys = __webpack_require__(1044);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(484);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A reasonable default model implementation
	// for select
	var SelectModel = exports.SelectModel = function () {
	  /**
	   * @param {object} items - Object of key value pairs containing the select values and display text 
	   */
	  function SelectModel(items) {
	    (0, _classCallCheck3.default)(this, SelectModel);
	
	    this._items = [];
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(items)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        this._items.push({
	          value: key,
	          text: items[key],
	          props: {
	            disabled: false
	          }
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	
	  (0, _createClass3.default)(SelectModel, [{
	    key: 'setProperty',
	    value: function setProperty(value, propkey, propValue) {
	      this.items.forEach(function (item) {
	        if (item['value'] === value) {
	          item['props'][propkey] = propValue;
	        }
	      });
	    }
	  }, {
	    key: 'resetProperties',
	    value: function resetProperties() {
	      this.items.forEach(function (item) {
	        item.props.disabled = false;
	      });
	    }
	  }, {
	    key: 'items',
	    get: function get() {
	      return this._items;
	    }
	  }]);
	  return SelectModel;
	}();

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _summarytable = __webpack_require__(1616);
	
	var _summarytable2 = _interopRequireDefault(_summarytable);
	
	var _summarytable3 = __webpack_require__(1617);
	
	var _summarytable4 = _interopRequireDefault(_summarytable3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var summaryTableComponent = {
	  bindings: {
	    betOverviewDetails: '<',
	    payload: '<'
	  },
	  template: _summarytable2.default,
	  controller: _summarytable4.default
	};
	
	exports.default = summaryTableComponent;

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	module.exports = "<h4 ng-if=\"!$ctrl.hasResult()\">No result found!</h4>\n<div ng-show=\"$ctrl.hasResult()\" class=\"table-summary\">\n  <div class=\"table-responsive\">\n    <table class=\"table m-0\">\n      <thead>\n        <tr>\n          <th>Bet Type</th>\n          <th>Profit</th>\n          <th>Turnover</th>\n          <th>Valid TO</th>\n          <th>Bet Count</th>\n          <th>Win</th>\n          <th>Loss</th>\n          <th>Push</th>\n          <th>Void</th>\n          <th>Ave. Odds</th>\n          <th>Yield %</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"(key, value) in $ctrl.betOverviewDetails.betOverview\" ng-if=\"value !== null\">\n          <td scope=\"row\">{{ key }}</td>\n          <td>{{ value.profit }}</td>\n          <td>{{ value.turnover }}</td>\n          <td>{{ value.validTurnover  }}</td>\n          <td>{{ value.numberOfBets }}</td>\n          <td>{{ value.winCount }}</td>\n          <td>{{ value.lossCount }}</td>\n          <td>{{ value.pushCount }}</td>\n          <td>{{ value.voidCount }}</td>\n          <td>{{ value.averageOdds }}</td>\n          <td>{{ value.yield }} %</td>\n        </tr>\n      </tbody>\n      <tfoot ng-if=\"$ctrl.betOverviewDetails.total && $ctrl.betOverviewDetails.total.profit\">\n          <tr>\n            <th scope=\"row\">Total</th>\n            <td>{{ $ctrl.betOverviewDetails.total.profit }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.turnover }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.validTurnover }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.numberOfBets }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.winCount }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.lossCount }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.pushCount }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.voidCount }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.averageOdds }}</td>\n            <td>{{ $ctrl.betOverviewDetails.total.yield }} %</td>\n          </tr>\n        </tfoot>\n    </table>\n  </div>\n</div>\n\n<!-- Export Buttons -->\n<div ng-show=\"$ctrl.hasResult()\" class=\"row\">\n  <div class=\"col-md-12\">\n    <a ui-sref=\"betoverview.bets($ctrl.payload)\" class=\"btn btn-primary waves-effect waves-light m-t-20\">View Bets</a>\n    <a ng-click=\"$ctrl.exportToCSV()\" class=\"btn btn-csv waves-effect waves-light pull-right m-t-20 m-l-10\">Export as CSV</a>\n    <!-- <a class=\"btn btn-pdf waves-effect waves-light pull-right m-t-20\">Export as PDF</a> -->\n  </div>\n</div>\n  "

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SummaryTableController = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(1122);
	
	var _export = __webpack_require__(1488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SummaryTableController = exports.SummaryTableController = function () {
	  function SummaryTableController() {
	    (0, _classCallCheck3.default)(this, SummaryTableController);
	  }
	
	  (0, _createClass3.default)(SummaryTableController, [{
	    key: 'exportToCSV',
	    value: function exportToCSV() {
	      var csvContent = 'Bet Type,Profit,Turnover,Valid TO,Bet Count,Win,Loss,Push,Void,Ave.Odds,Yield%\n';
	      var details = (0, _lodash.cloneDeep)(this.betOverviewDetails);
	
	      for (var key in details.betOverview) {
	        var row = details.betOverview[key];
	        csvContent += row.betType + ',"' + row.profit + '","' + row.turnover + '","' + row.validTurnover + '",' + row.numberOfBets + ',' + row.winCount + ',' + row.lossCount + ',' + row.pushCount + ',' + row.voidCount + ',"' + row.averageOdds + '","' + row.yield + '"\n';
	      }
	
	      var totals = details.total;
	      csvContent += 'Total,"' + totals.profit + '","' + totals.turnover + '","' + totals.validTurnover + '",' + totals.numberOfBets + ',' + totals.winCount + ',' + totals.lossCount + ',' + totals.pushCount + ',' + totals.voidCount + ',"' + totals.averageOdds + '","' + totals.yield + '"\n';
	
	      (0, _export.exportToCSV)(csvContent, 'betoverview.csv');
	    }
	  }, {
	    key: 'hasResult',
	    value: function hasResult() {
	      if (this.betOverviewDetails && !(0, _lodash.isEmpty)(this.betOverviewDetails.total)) {
	        return true;
	      }
	
	      return false;
	    }
	  }]);
	  return SummaryTableController;
	}();
	
	exports.default = SummaryTableController;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bets = __webpack_require__(1619);
	
	var _bets2 = _interopRequireDefault(_bets);
	
	var _bets3 = __webpack_require__(1620);
	
	var _bets4 = _interopRequireDefault(_bets3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var betsComponent = {
	  bindings: {},
	  template: _bets2.default,
	  controller: _bets4.default
	};
	
	exports.default = betsComponent;

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray\">\n  <div class=\"content\">\n    <div class=\"container\">\n      <div class=\"col-md-12\">\n        <h2 class=\"text-dark\">Skype Betting</h2>\n      </div>\n\n      <div class=\"col-sm-9 fadeIn animated\">\n        <div class=\"card-box\">\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <h3 class=\"m-l-20 text-dark\"><i class=\"ti-stats-up\"></i> View Bet </h3>\n              <hr class=\"m-b-30\">\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <div class=\"card-box\">\n                  <filter-details payload=\"$ctrl.payload\"></filter-details>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-md-10\">\n                <bet-listing on-paginate=\"$ctrl.onPaginate(offset)\" bet-listing=\"$ctrl.betListing\"></bet-listing>\n            </div>\n          </div>\n\n          <div class=\"row\">\n              <div class=\"col-md-2 col-md-offset-10\">\n                <button ng-click=\"$ctrl.exportToCSV()\" class=\"btn btn-md btn-info\">Export to CSV</button>\n              </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-lg-3\">\n        <img src=\"assets/images/ads-banner.jpg\" class=\"img-responsive\">\n      </div>\n    </div>\n  </div>\n</div>\n  "

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BetsController = undefined;
	
	var _getPrototypeOf = __webpack_require__(1051);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(1054);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(1073);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _basecontroller = __webpack_require__(1094);
	
	var _filter = __webpack_require__(1621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetsController = exports.BetsController = function (_BaseController) {
	  BetsController.$inject = ["BetOverviewApiService", "PageService"];
	  (0, _inherits3.default)(BetsController, _BaseController);
	
	  function BetsController(BetOverviewApiService, PageService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BetsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BetsController.__proto__ || (0, _getPrototypeOf2.default)(BetsController)).call(this));
	
	    _this.PageService = PageService;
	    _this.BetOverviewApiService = BetOverviewApiService;
	    return _this;
	  }
	
	  (0, _createClass3.default)(BetsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.payload = this.PageService.getQueryParameters();
	      this.filterModel = new _filter.FilterModel(this.payload);
	
	      this.BetOverviewApiService.getBets(this.filterModel.toPayload()).then(function (betListing) {
	        _this2.betListing = betListing;
	      });
	    }
	  }, {
	    key: "onPaginate",
	    value: function onPaginate(offset) {
	      var _this3 = this;
	
	      this.filterModel.offset = offset;
	      this.BetOverviewApiService.getBets(this.filterModel.toPayload()).then(function (betListing) {
	        _this3.betListing = betListing;
	      });
	    }
	  }, {
	    key: "exportToCSV",
	    value: function exportToCSV() {
	      this.BetOverviewApiService.exportToCSV(this.filterModel.toPayload());
	    }
	  }]);
	  return BetsController;
	}(_basecontroller.BaseController);
	
	exports.default = BetsController;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterModel = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterModel = exports.FilterModel = function () {
	  function FilterModel(payload) {
	    (0, _classCallCheck3.default)(this, FilterModel);
	
	    this._from = payload.from;
	    this._to = payload.to;
	    this._betType = payload.betType;
	    this._league = payload.league;
	    this._betSelection = payload.betSelection;
	
	    this._offset = 0;
	    this._limit = 10;
	  }
	
	  (0, _createClass3.default)(FilterModel, [{
	    key: "toPayload",
	    value: function toPayload() {
	      return {
	        offset: this.offset,
	        limit: this.limit,
	        from: this.from,
	        to: this.to,
	        league: this.league,
	        betType: this.betType,
	        bet: this.betSelection
	      };
	    }
	  }, {
	    key: "from",
	    get: function get() {
	      return this._from;
	    }
	  }, {
	    key: "to",
	    get: function get() {
	      return this._to;
	    }
	  }, {
	    key: "betType",
	    get: function get() {
	      return this._betType;
	    }
	  }, {
	    key: "betSelection",
	    get: function get() {
	      return this._betSelection;
	    }
	  }, {
	    key: "league",
	    get: function get() {
	      return this._league;
	    }
	  }, {
	    key: "offset",
	    set: function set(offset) {
	      this._offset = offset;
	    },
	    get: function get() {
	      return this._offset;
	    }
	  }, {
	    key: "limit",
	    get: function get() {
	      return this._limit;
	    }
	  }]);
	  return FilterModel;
	}();

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filterdetails = __webpack_require__(1623);
	
	var _filterdetails2 = _interopRequireDefault(_filterdetails);
	
	var _filterdetails3 = __webpack_require__(1624);
	
	var _filterdetails4 = _interopRequireDefault(_filterdetails3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterDetailsComponent = {
	  bindings: {
	    payload: '<'
	  },
	  template: _filterdetails2.default,
	  controller: _filterdetails4.default
	};
	
	exports.default = filterDetailsComponent;

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	module.exports = "<form role=\"form\">\n    <div class=\"row\">\n      <div class=\"col-md-2 form-group\">\n        <label>From</label>\n        <div class=\"input-group\">\n          <p>{{ $ctrl.payload.from }}</p>\n        </div>\n      </div>\n      <div class=\"col-md-2 form-group\">\n        <label>To</label>\n        <div class=\"input-group\">\n          <p>{{ $ctrl.payload.to }}</p>\n        </div>  \n      </div>\n      <div class=\"col-md-2 form-group\">\n        <label>League</label>\n        <p>{{ $ctrl.payload.leagueText }}</p>\n      </div>\n      <div class=\"col-md-2 form-group\">\n        <label>Bet Type</label>\n        <p>{{ $ctrl.payload.betTypeText }}</p>\n      </div>\n      <div ng-if=\"$ctrl.payload.betSelection\" class=\"col-md-2 form-group\">\n        <label>Bet Selection</label>\n        <p>{{ $ctrl.payload.betSelection }}</p>\n      </div>\n      <!-- <div class=\"col-md-2 form-group\">\n        <label>Stake Range</label>\n        <select class=\"selectpicker\" disabled data-style=\"btn-white\">\n          <option>All</option>\n          <option>Ketchup</option>\n          <option>Relish</option>\n        </select>\n      </div> -->\n  </div>\n</form>"

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterDetailsController = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterDetailsController = exports.FilterDetailsController = function FilterDetailsController() {
	  (0, _classCallCheck3.default)(this, FilterDetailsController);
	};
	
	exports.default = FilterDetailsController;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _listing = __webpack_require__(1626);
	
	var _listing2 = _interopRequireDefault(_listing);
	
	var _listing3 = __webpack_require__(1627);
	
	var _listing4 = _interopRequireDefault(_listing3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listingComponent = {
	  bindings: {
	    betListing: '<',
	    onPaginate: '&'
	  },
	  template: _listing2.default,
	  controller: _listing4.default
	};
	
	exports.default = listingComponent;

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"table-summary\">\n    <div class=\"table-responsive\">\n        <table class=\"table m-0\">\n            <thead>\n                <tr>\n                    <th>Event Date</th>\n                    <th>Bet ID</th>\n                    <th>Details</th>\n                    <th>Selection</th>\n                    <th>Odds</th>\n                    <th>Stake</th>\n                    <th>W\\L Amount</th>\n                    <th>Status</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat=\"(key, bet) in $ctrl.betListing.bets\">\n                    <td>{{ bet.eventDate }}</td>\n                    <td>{{ bet.id }}</td>\n                    <td>{{ bet.details }}</td>\n                    <td>{{ bet.selectionAsText }}</td>\n                    <td>{{ bet.odds }}</td>\n                    <td>{{ bet.stake }}</td>\n                    <td>{{ bet.winLoss }}</td>\n                    <td>{{ bet.statusAsText }}</td>\n                </tr>\n            </tbody>\n        </table>\n     </div>\n </div>\n <pagination2 on-page-clicked=\"$ctrl.onPageClicked(page, offset)\" max-page-count=\"5\" limit-per-page=\"10\" total=\"$ctrl.betListing.total\"></pagination2>\n            "

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListingController = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListingController = exports.ListingController = function () {
	  function ListingController() {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ListingController);
	  }
	
	  (0, _createClass3.default)(ListingController, [{
	    key: 'onPageClicked',
	    value: function onPageClicked(page, offset) {
	      this.onPaginate({ offset: offset });
	    }
	  }]);
	  return ListingController;
	}();
	
	exports.default = ListingController;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _customer = __webpack_require__(1629);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerComponent = {
	  bindings: {},
	  template: _customer2.default
	};
	
	exports.default = customerComponent;

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	module.exports = "<div ui-view></div>\n"

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(335);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _ngclipboard = __webpack_require__(1631);
	
	var _ngclipboard2 = _interopRequireDefault(_ngclipboard);
	
	var _marketing = __webpack_require__(1633);
	
	var _marketing2 = _interopRequireDefault(_marketing);
	
	var _form = __webpack_require__(1640);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _bannerimagepreview = __webpack_require__(1645);
	
	var _bannerimagepreview2 = _interopRequireDefault(_bannerimagepreview);
	
	var _downloadable = __webpack_require__(1646);
	
	var _downloadable2 = _interopRequireDefault(_downloadable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marketingModule = _angular2.default.module('marketing', [_angularjs2.default, _ngclipboard2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('marketing', {
	    url: '/marketing',
	    component: 'marketing',
	    resolve: {
	      authenticate: ["SecurityService", function authenticate(SecurityService) {
	        SecurityService.authenticate();
	      }]
	    }
	  });
	}]).component('marketing', _marketing2.default).component('marketingForm', _form2.default).service('BannerImagePreviewFactory', _bannerimagepreview2.default).directive('downloadable', _downloadable2.default).name;
	
	exports.default = marketingModule;

/***/ }),
/* 1631 */,
/* 1632 */,
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _marketing = __webpack_require__(1634);
	
	var _marketing2 = _interopRequireDefault(_marketing);
	
	var _marketing3 = __webpack_require__(1635);
	
	var _marketing4 = _interopRequireDefault(_marketing3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marketingComponent = {
	  bindings: {},
	  template: _marketing2.default,
	  controller: _marketing4.default
	};
	
	exports.default = marketingComponent;

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-page content-wrapper gray affilite-marketing\">\n  <div class=\"content\">\n    <div class=\"container\">\n\n      <div id=\"activation-modal\" class=\"sweet-overlay\" tabindex=\"-1\">\n        <div class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"display: block; margin-top: -189px;\">\n          <div class=\"icon success animate\">\n            <span class=\"line tip animateSuccessTip\"></span>\n            <span class=\"line long animateSuccessLong\"></span>\n            <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n          </div>\n          <h3>{{ 'Welcome to AC Affiliates!' | translate }}</h3>\n          <p class=\"lead text-muted\">\n            {{ 'setup' | translate }}<br>\n            {{ 'to activate your account.' | translate }}<br>\n            <small>{{ 'setupNote' | translate }}</small>\n          </p>\n          <p>\n            <a ui-sref=\"activation\" class=\"confirm btn btn-sm btn-success\" tabindex=\"1\">{{ 'Proceed' | translate }}</a>\n            <button ui-sref=\"marketing\" ng-click=\"$ctrl.activateLaterAction()\" class=\"confirm btn btn-sm btn-info\" tabindex=\"1\">{{ 'Activate Later' | translate }}</button>\n          </p>\n        </div>\n      </div>\n\n      <div id=\"welcome-affiliate-modal\" class=\"sweet-overlay\" tabindex=\"-1\">\n        <div class=\"sweet-alert showSweetAlert visible\" tabindex=\"-1\" data-has-cancel-button=\"false\" data-has-confirm-button=\"true\" data-allow-ouside-click=\"false\" data-has-done-function=\"false\" data-timer=\"null\" style=\"display: block; margin-top: -189px;\">\n          <div class=\"icon success animate\">\n            <span class=\"line tip animateSuccessTip\"></span>\n            <span class=\"line long animateSuccessLong\"></span>\n            <div class=\"placeholder\"></div> <div class=\"fix\"></div>\n          </div>\n          <br>\n          <h3>{{ 'Welcome to AC Affiliates!' | translate }}</h3>\n          <p class=\"lead text-muted\">\n            {{ \"You're on your way to earning a lifetime commission. Just follow 4 easy steps.\" | translate }}\n          </p>\n          <div class=\"text-center\">\n            <div class=\"checkbox\">\n              <input id=\"confirm-affiliate\" type=\"checkbox\" required ng-click=\"$ctrl.confirmModal()\">\n              <label for=\"confirm-affiliate\">\n                {{ 'I confirm that I have read and accepted' | translate }} <a href=\"https://www.asianconnect88.com/services/asianconnect-affiliate-program/\" target=\"_blank\">{{ 'Asianconnect Affiliates Terms and Conditions' | translate }}</a>.\n              </label>\n            </div>\n          </div>\n          <p>\n            <button type=\"button\" ng-click=\"$ctrl.onSubmitConfirmation()\" class=\"confirm btn btn-lg btn-success\" id=\"get-started\" tabindex=\"1\" disabled>{{ 'Get Started' | translate }}</button>\n          </p>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 fadeIn animated\">\n          <!-- Banners Tabbed Pane -->\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <div class=\"banner-tabs\">\n                <!-- Tabs -->\n                <ul class=\"nav nav-tabs nav-justified\">\n                  <li class=\"tab active\">\n                    <a data-target=\"#generate-tab\" data-toggle=\"tab\">\n                      <span>{{ 'Generate' | translate }}</span>\n                    </a>\n                  </li>\n                  <li class=\"tab\">\n                    <a data-target=\"#archive-tab\" data-toggle=\"tab\">\n                      <span>{{ 'Archive' | translate }}</span>\n                    </a>\n                  </li>\n                </ul>\n\n                <!-- Content -->\n                <div class=\"tab-content\">\n                  <!-- Generate Tab -->\n                  <div class=\"tab-pane active\" id=\"generate-tab\">\n                    <div class=\"row\">\n                      <div class=\"col-md-12 col-sm-12\">\n                        <p>{{ 'generateBannerNote' | translate }}</p>\n                      </div>\n                      <div class=\"col-lg-8 col-md-12 col-sm-12\">\n                        <marketing-form on-banner-preview=\"$ctrl.previewBanner(filename, allowDownload)\" on-successful-submission=\"$ctrl.onSuccessfulSubmission(response)\" on-form-reset=\"$ctrl.onFormReset()\"></marketing-form>\n                      </div>\n                      <div class=\"col-lg-4 col-md-12 col-sm-12\">\n                        <!-- HTML Referrer -->\n                        <div class=\"referral-code-wrap hidden\">\n                          <form class=\"form-group\">\n                            <div class=\"input-group m-t-10\">\n                                <input type=\"text\" class=\"form-control\" name=\"URL\" readonly style=\"width: 100% !important;\" id=\"referral-url\">\n                                <span class=\"input-group-btn\">\n                                    <button ngclipboard data-clipboard-target=\"#referral-url\" class=\"btn waves-effect waves-light btn-code-aff\">{{ 'Copy' | translate }}</button>\n                                </span>\n                            </div>\n                            <div class=\"note\"><small>{{ 'Note: Referral URL is your unique link where you can share to everyone' | translate }}</small></div>\n                          </form>\n                          <div class=\"clearfix\"></div>\n\n                          <!-- HTML Piwik Code -->\n                          <div class=\"piwik-wrap\">\n                            <h4 class=\"text-dark\">{{ 'Referral HTML Code' | translate }}</h4>\n                            <textarea class=\"code form-control\" style=\"font-size: 10px;\" rows=\"17\" id=\"referral-code\" name=\"referralCode\" readonly></textarea>\n                            <div class=\"note\"><small>{{ 'copyReferralCodeNote' | translate }}</small></div>\n                            <div class=\"m-b-30 p-t-10\">\n                              <a downloadable tracking-code=\"{{ $ctrl.trackingCode }}\" id=\"downloadLink\" class=\"btn btn-download pull-right\">{{ 'Download HTML' | translate }}</a>\n                              <a class=\"btn btn-clipboard-aff pull-right m-r-10\" id=\"copy-code\" ngclipboard data-clipboard-target=\"#referral-code\">{{ 'Copy' | translate }}</a>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"tc-applies\">\n                      <p>*<a class=\"ac-txtcolor\" href=\"https://www.asianconnect88.com/services/asianconnect-affiliate-program/\" target=\"_blank\">{{ 'Terms and Conditions' | translate }}</a> {{ 'and' | translate }} <a class=\"ac-txtcolor\" href=\"https://www.asianconnect88.com/services/asianconnect-affiliate-program/\" target=\"_blank\">{{ 'Commission Scheme' | translate }}</a> {{ 'apply' | translate }}.</p>\n                    </div>\n                  </div>\n\n                  <!-- Archive Tab -->\n                  <div class=\"tab-pane\" id=\"archive-tab\">\n                    <div class=\"row\">\n                      <div class=\"col-lg-2 col-md-2 col-sm-12\">\n                        <label for=\"banner-size\">{{ 'Referral URL' | translate }}</label>\n                      </div>\n                      <div class=\"col-lg-6 col-md-10 col-sm-12\">\n                        <form class=\"form-group\">\n                          <div class=\"input-group\">\n                            <select\n                                    ng-model=\"$ctrl.selectedReferralLink\"\n                                    ng-options=\"link for link in $ctrl.links\"\n                                    ng-change=\"$ctrl.onReferralLinkSelected($ctrl.selectedReferralLink, oldValue)\"\n                                    class=\"form-control\"\n                                    readonly>\n                              <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n                            </select>\n                            <input style=\"position:absolute; top:0; left:-500px;\" id=\"referralLink\"/>\n                            <span class=\"input-group-btn\">\n                              <button class=\"btn waves-effect waves-light btn-code-archive\" ngclipboard data-clipboard-target=\"#referralLink\">{{ 'Copy' | translate }}</button>\n                            </span>\n                          </div>\n                          <div class=\"note\"><small>{{ 'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.' | translate }}</small></div>\n                        </form>\n                        <div class=\"clearfix\"></div>\n                      </div>\n                      <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                        <div class=\"marketing-table\">\n                          <div class=\"inner-table\">\n                            <!-- Desktop -->\n                            <table id=\"datatable-responsive\" class=\"table m-0 dt-responsive nowrap affilite-table-desktop\" cellspacing=\"0\" width=\"100%\">\n                              <thead>\n                              <tr>\n                                <th data-toggle=\"true\">{{ 'form.type' | translate }}</th>\n                                <th data-hide=\"phone, tablet\">{{ 'form.language' | translate }}</th>\n                                <th data-hide=\"phone, tablet\">{{ 'form.size' | translate }}</th>\n                                <th>{{ 'form.campaign' | translate }}</th>\n                                <th data-hide=\"phone, tablet\">{{ 'form.website' | translate }}</th>\n                                <th data-hide=\"phone, tablet\">{{ 'form.referralCode' | translate }}</th>\n                                <th></th>\n                              </tr>\n                              </thead>\n\n                              <tbody>\n                                <tr ng-repeat=\"banner in $ctrl.list \">\n                                  <td>{{ banner.bannerImage.type }}</td>\n                                  <td>{{ banner.bannerImage.language }}</td>\n                                  <td>{{ banner.bannerImage.dimension }}</td>\n                                  <td>{{ banner.campaignName }}</td>\n                                  <td>{{ banner.website }}</td>\n                                  <td>{{ banner.referralCode }}</td>\n                                  <td>\n                                    <div class=\"button-list\">\n                                      <button ng-click=\"$ctrl.setState('banner', banner); $ctrl.previewBanner(banner.bannerImage.filename, true)\" class=\"btn btn-xs btn-preview\" data-toggle=\"modal\" data-target=\"#preview-archive\">{{ 'Preview' | translate }}</button>\n                                      <a downloadable tracking-code=\"{{  banner.trackingHTMLCode }}\" type=\"button\" class=\"btn btn-xs btn-dwl waves-effect waves-light\">{{ 'Download HTML' | translate }}</a>\n                                    </div>\n                                  </td>\n                                </tr>\n                              </tbody>\n                            </table>\n\n                            <!-- Mobile -->\n                            <table class=\"table m-0 dt-responsive nowrap affilite-table-mobile\" cellspacing=\"0\" width=\"100%\">\n                                <thead>\n                                <tr>\n                                  <th data-toggle=\"true\">{{ 'form.type' | translate }}</th>\n                                  <th data-hide=\"phone, tablet\">{{ 'form.language' | translate }}</th>\n                                  <th data-hide=\"phone, tablet\">{{ 'form.size' | translate }}</th>\n                                  <th>{{ 'form.campaign' | translate }}</th>\n                                  <th data-hide=\"phone, tablet\">{{ 'form.website' | translate }}</th>\n                                  <th data-hide=\"phone, tablet\">{{ 'form.referralCode' | translate }}</th>\n                                  <th></th>\n                                </tr>\n                                </thead>\n  \n                                <tbody>\n                                  <tr ng-repeat=\"banner in $ctrl.list \">\n                                    <td>{{ banner.bannerImage.type }}</td>\n                                    <td>{{ banner.bannerImage.language }}</td>\n                                    <td>{{ banner.bannerImage.dimension }}</td>\n                                    <td>{{ banner.campaignName }}</td>\n                                    <td>{{ banner.website }}</td>\n                                    <td>{{ banner.referralCode }}</td>\n                                    <td>\n                                      <div class=\"button-list\">\n                                        <button ng-click=\"$ctrl.setState('banner', banner); $ctrl.previewBanner(banner.bannerImage.filename, true)\" class=\"btn btn-xs btn-preview\" data-toggle=\"modal\" data-target=\"#preview-archive\">{{ 'Preview' | translate }}</button>\n                                        <a downloadable tracking-code=\"{{  banner.trackingHTMLCode }}\" type=\"button\" class=\"btn btn-xs btn-dwl waves-effect waves-light\">{{ 'Download HTML' | translate }}</a>\n                                      </div>\n                                    </td>\n                                  </tr>\n                                </tbody>\n                              </table>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- Banner Modal -->\n<div id=\"banner-info\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"bannerInfo\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">x</button>\n        <h4 class=\"modal-title\">{{ 'Information' | translate }}</h4>\n      </div>\n      <div class=\"modal-body\">\n        <p>{{ 'Get a unique tracking link for your campaign.' | translate }}</p>\n        <ol>\n          <li>{{ 'Website. Input your website URL.' | translate }}</li>\n          <li>{{ 'Banner type. Pick a banner type: (language/size/promo)' | translate }}</li>\n          <li>{{ 'Campaign. Name your campaign.' | translate }}</li>\n          <li>{{ 'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.' | translate }}</li>\n        </ol>\n        <p>{{ 'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.' | translate }}</p>\n\n        <pre>\n          &#x3C;script type=&#x22;text/javascript&#x22;&#x3E;\n              var _paq = _paq || [];\n              _paq.push([&#x27;trackPageView&#x27;]);\n              _paq.push([&#x27;enableLinkTracking&#x27;]);\n              _paq.push([&#x27;trackVisibleContentImpressions&#x27;]);\n              (function() {\n                  var u=&#x22;https://tracker.ac66.com/&#x22;;\n                  _paq.push([&#x27;setTrackerUrl&#x27;, u+&#x27;piwik.php&#x27;]);\n                  _paq.push([&#x27;setSiteId&#x27;, siteId]);\n                  var d=document, g=d.createElement(&#x27;script&#x27;), s=d.getElementsByTagName(&#x27;script&#x27;)[0];\n                  g.type=&#x27;text/javascript&#x27;; g.async=true; g.defer=true; g.src=u+&#x27;piwik.js&#x27;; s.parentNode.insertBefore(g,s);\n              })();\n          &#x3C;/script&#x3E;\n          &#x3C;noscript&#x3E;&#x3C;p&#x3E;&#x3C;img src=&#x22;https://tracker.ac66.com/piwik.php?idsite=siteId&#x22; style=&#x22;border:0;&#x22; alt=&#x22;&#x22; /&#x3E;&#x3C;/p&#x3E;&#x3C;/noscript&#x3E;\n\n          &#x3C;a href=&#x22;ReferralLink&#x22; onclick=&#x22;window.open(this.href); return false;&#x22; data-content-name=&#x22;TrackingCode&#x22; class=&#x22;piwikTrackContent&#x22; data-track-content&#x3E;\n              &#x3C;img src=&#x22;https://tracker.ac66.com/banners/filename&#x22; alt=&#x22;asianconnect88&#x22; class=&#x22;piwikContentPiece&#x22; data-content-piece=&#x22;trackingCode+dimension&#x22;&#x3E;\n          &#x3C;/a&#x3E;\n        </pre>\n\n        <p>{{ 'campaignNote' | translate }}</p>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- Preview Archive Modal -->\n<div id=\"preview-archive\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"previewArchive\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">x</button>\n        <h4 class=\"modal-title\">{{ 'Preview archived banner' | translate }}</h4>\n      </div>\n      <div class=\"modal-body text-center\">\n        <img class=\"img-responsive\" ng-src=\"data:image/JPEG;base64,{{$ctrl.banner}}\">\n        <div class=\"m-t-15\">\n          <a ng-show=\"$ctrl.state.allowDownload\" downloadable tracking-code=\"{{ $ctrl.state.banner.trackingHTMLCode }}\" type=\"button\" class=\"btn btn-download\">{{ 'Download HTML' | translate }}</a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- Preview Archive Modal -->\n<request-product-modal></request-product-modal>\n<product-password-widget></product-password-widget>\n"

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(1636);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(1639);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _bool = __webpack_require__(1588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Separate Archive and Generate tabs content into two components.
	var MarketingController = function () {
	  MarketingController.$inject = ["MarketingApiService", "DashboardApiService", "BannerImagePreviewFactory", "SessionService", "StorageService", "$timeout"];
	  function MarketingController(MarketingApiService, DashboardApiService, BannerImagePreviewFactory, SessionService, StorageService, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MarketingController);
	    this.MarketingApiService = MarketingApiService;
	    this.DashboardApiService = DashboardApiService;
	    this.BannerImagePreviewFactory = BannerImagePreviewFactory;
	    this.SessionService = SessionService;
	    this.StorageService = StorageService;
	    this.state = { banner: null, allowDownload: true };
	    this.activateLater = false;
	    this.$timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(MarketingController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.checkHasConfirmTermsAndCondition();
	      this.MarketingApiService.getBannerList().then(function (list) {
	        return _this.list = list;
	      });
	      this.MarketingApiService.getReferralLinks().then(function (links) {
	        return _this.links = links;
	      });
	      this.account = {
	        availableBalance: null
	      };
	      this.currency = this.SessionService.get('currency');
	      this.customerProducts = {
	        products: null,
	        availableBalance: null
	      };
	
	      this.renderTable();
	    }
	  }, {
	    key: 'checkHasConfirmTermsAndCondition',
	    value: function checkHasConfirmTermsAndCondition() {
	      var _this2 = this;
	
	      this.DashboardApiService.condition().then(function (resp) {
	        var showModal = _this2.StorageService.getItem('show_activation_modal');
	        if ((0, _bool.parseBoolean)(showModal) && !_this2.activateLater && resp.user.activation_code) {
	          if (resp.user.activation_timestamp == resp.user.activation_sent_timestamp) {
	            $('#activation-modal').show();
	            return false;
	          }
	        }
	
	        //Check if confirmed terms & condition
	        if (resp.has_confirm_terms_and_conditions == false) {
	          $('#welcome-affiliate-modal').show();
	          $('#get-started').click(function () {
	            $('#welcome-affiliate-modal').hide();
	          });
	        }
	      });
	    }
	  }, {
	    key: 'activateLaterAction',
	    value: function activateLaterAction() {
	      this.activateLater = true;
	      this.StorageService.setItem('show_activation_modal', false);
	      $('#activation-modal').hide();
	      this.checkHasConfirmTermsAndCondition();
	    }
	  }, {
	    key: 'confirmModal',
	    value: function confirmModal() {
	      $('#confirm-affiliate').attr('disabled', true);
	      $('#get-started').removeAttr('disabled');
	    }
	  }, {
	    key: 'onSubmitConfirmation',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.MarketingApiService.confirm();
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function onSubmitConfirmation() {
	        return _ref.apply(this, arguments);
	      }
	
	      return onSubmitConfirmation;
	    }()
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      this.$timeout(function () {
	        $(window).resize(function () {
	          $('#datatable-responsive').footable();
	          $('#datatable-responsive').trigger('footable_redraw');
	        });
	        $(window).trigger('resize');
	
	        window.dispatchEvent(new Event('resize'));
	
	        var evt = window.document.createEvent('UIEvents');
	        evt.initUIEvent('resize', true, false, window, 0);
	        window.dispatchEvent(evt);
	      }, 0);
	    }
	  }, {
	    key: 'onSuccessfulSubmission',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(response) {
	        var _this3 = this;
	
	        var detailsContainer;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                detailsContainer = document.getElementsByClassName('referral-code-wrap')[0];
	
	                detailsContainer.classList.remove('hidden');
	
	                // Display the generated tracking code.
	                document.getElementById('referral-url').value = response.referral_link;
	                document.getElementById('referral-code').value = response.tracking_html_code;
	                this.trackingCode = response.tracking_html_code;
	
	                // refresh the list.
	                this.MarketingApiService.getBannerList().then(function (list) {
	                  return _this3.list = list;
	                });
	                this.MarketingApiService.getReferralLinks().then(function (links) {
	                  return _this3.links = links;
	                });
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function onSuccessfulSubmission(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return onSuccessfulSubmission;
	    }()
	  }, {
	    key: 'onFormReset',
	    value: function onFormReset() {
	      var detailsContainer = document.getElementsByClassName('referral-code-wrap')[0];
	      detailsContainer.classList.add('hidden');
	    }
	  }, {
	    key: 'onReferralLinkSelected',
	    value: function onReferralLinkSelected(link) {
	      document.getElementById('referralLink').value = link;
	    }
	  }, {
	    key: 'previewBanner',
	    value: function previewBanner(filename, allowDownload) {
	      var _this4 = this;
	
	      this.setState('allowDownload', allowDownload);
	      this.BannerImagePreviewFactory.preview(filename).then(function (banner) {
	        return _this4.banner = banner;
	      });
	    }
	  }, {
	    key: 'setState',
	    value: function setState(key, value) {
	      this.state[key] = value;
	    }
	  }, {
	    key: 'onCustomerProductsLoaded',
	    value: function onCustomerProductsLoaded(customerProductsList) {
	      this.account.availableBalance = customerProductsList.balance;
	      this.renderTable();
	    }
	  }]);
	  return MarketingController;
	}();
	
	exports.default = MarketingController;

/***/ }),
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(1641);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(1642);
	
	var _form4 = _interopRequireDefault(_form3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formComponent = {
	  bindings: {
	    onSuccessfulSubmission: '&',
	    onBannerPreview: '&',
	    onFormReset: '&'
	  },
	  template: _form2.default,
	  controller: _form4.default
	};
	
	exports.default = formComponent;

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	module.exports = "<form role=\"form\" ng-submit=\"$ctrl.submit()\" novalidate>\n    <div class=\"col-md-6 col-sm-6\">\n      <div class=\"form-group\">\n          <label for=\"banner-website\">{{ 'form.website' | translate }}</label>\n          <div class=\"input-group aff-btn-group\">\n              <div class=\"input-group-btn aff-select\">\n                  <select\n                      ng-model=\"$ctrl.form.protocol\"\n                      ng-options=\"item.value as item.text for item in $ctrl.form.protocolSelect.items\"\n                      class=\"form-control website-url\"\n                      name=\"protocol\"\n                      data-style=\"btn-white\">\n                  </select>\n              </div>\n              <input\n                  ng-model=\"$ctrl.form.website\"\n                  ng-readonly=\"$ctrl.form.props.readOnly\"\n                  ng-class=\"{ 'parsley-error': $ctrl.form.errors.website }\"\n                  class=\"form-control\"\n                  placeholder=\"{{ 'Please enter your website URL' | translate }}\">\n          </div>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.errors.website\">\n              <li ng-repeat=\"(key, error) in $ctrl.form.errors.website.errors\" class=\"parsley-required\">{{ error }}</li>\n          </ul>\n      </div>\n\n      <div class=\"form-group\">\n          <label for=\"banner-website\">{{ 'form.type' | translate }}</label>\n          <div class=\"clearfix\"></div>\n          <div class=\"col-lg-6 col-md-12 col-sm-12\">\n          <div class=\"radio\">\n              <input ng-disabled=\"$ctrl.form.props.readOnly\" ng-model=\"$ctrl.form.type\" type=\"radio\" name=\"radio\" value=\"promotion\" checked>\n              <label class=\"aff-radio-label\" for=\"radio1\">\n                  {{ 'form.promotion' | translate }}\n              </label>\n          </div>\n          </div>\n          <div class=\"col-lg-6 col-md-12 col-sm-12\">\n          <div class=\"radio\">\n              <input ng-disabled=\"$ctrl.form.props.readOnly\" ng-model=\"$ctrl.form.type\" type=\"radio\" name=\"radio\" value=\"advertisement\">\n              <label class=\"aff-radio-label\" for=\"radio2\">\n                  {{ 'form.advertisement' | translate }}\n              </label>\n          </div>\n          </div>\n      </div>\n      <div class=\"clearfix\"></div>\n      <div class=\"form-group\" id=\"select-language\">\n          <label for=\"banner-lang\">{{ 'form.language' | translate }}</label>\n          <select\n              ng-model=\"$ctrl.form.language\"\n              ng-readonly=\"$ctrl.form.props.readOnly\"\n              ng-options=\"item.value as item.text | translate for item in $ctrl.form.languagesSelect.items\"\n              ng-class=\"{ 'parsley-error': $ctrl.form.errors.language }\"\n              class=\"form-control\">\n          </select>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.errors.language\">\n              <li ng-repeat=\"(key, error) in $ctrl.form.errors.language.errors\" class=\"parsley-required\">{{ error }}</li>\n          </ul>\n      </div>\n    </div>\n    <div class=\"col-md-6 col-sm-6\">\n      <div class=\"form-group\">\n          <label for=\"banner-size\">{{ 'form.size' | translate }}</label>\n          <select\n              ng-model=\"$ctrl.form.size\"\n              ng-readonly=\"$ctrl.form.props.readOnly\"\n              ng-options=\"item.value as item.text | translate for item in $ctrl.form.sizesSelect.items\"\n              ng-class=\"{ 'parsley-error': $ctrl.form.errors.size }\"\n              class=\"form-control\">\n              <option value=\"\" disabled selected>{{ 'Please Select' | translate }}</option>\n          </select>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.errors.size\">\n              <li ng-repeat=\"(key, error) in $ctrl.form.errors.size.errors\" class=\"parsley-required\">{{ error }}</li>\n          </ul>\n          <a ng-show=\"$ctrl.form.canPreviewBanner\" ng-click=\"$ctrl.previewBanner()\" class=\"pull-right waves-effect waves-light btn-preview-promo\" data-toggle=\"modal\" data-target=\"#preview-archive\"><small class=\"preview-aff\">{{ 'See Preview' | translate }}</small></a>\n      </div>\n      <div class=\"form-group\">\n          <label for=\"banner-campaign\">{{ 'form.campaign' | translate }}</label>\n          <input\n              ng-model=\"$ctrl.form.campaignName\"\n              ng-readonly=\"$ctrl.form.props.readOnly\"\n              ng-keydown=\"$ctrl.onPreventableKeydown($event)\"\n              ng-class=\"{ 'parsley-error': $ctrl.form.errors.campaignName }\"\n              type=\"text\" class=\"form-control\"\n              placeholder=\"{{ 'Please enter your Campaign Name' | translate }}\">\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.errors.campaignName\">\n              <li ng-repeat=\"(key, error) in $ctrl.form.errors.campaignName.errors\" class=\"parsley-required\">{{ error }}</li>\n          </ul>\n          <div class=\"note\"><small>{{ 'Special characters and spaces are not allowed.' | translate }}</small></div>\n      </div>\n      <div class=\"form-group\">\n          <label for=\"banner-referral-code\">{{ 'form.referralCode' | translate }}</label>\n          <div class=\"input-group m-t-10\">\n              <input\n                  ng-model=\"$ctrl.form.trackingCode\"\n                  ng-readonly=\"$ctrl.form.props.readOnly\"\n                  ng-keydown=\"$ctrl.onPreventableKeydown($event)\"\n                  ng-class=\"{ 'parsley-error': $ctrl.form.errors.trackingCode }\"\n                  type=\"text\" class=\"form-control\"\n                  placeholder=\"{{ 'Please enter your Referral Code' | translate }}\">\n              <span class=\"input-group-btn\">\n                  <button ng-hide=\"$ctrl.form.props.readOnly\" ng-click=\"$ctrl.createRandomTrackingCode()\" type=\"button\" class=\"btn waves-effect waves-light btn-code-aff\">{{ 'Get code' | translate }}</button>\n                  <button ng-hide=\"!$ctrl.form.props.readOnly\" type=\"button\" disabled class=\"btn waves-effect waves-light btn-code-aff\">{{ 'Get code' | translate }}</button>\n              </span>\n          </div>\n          <ul class=\"parsley-errors-list filled\" ng-if=\"$ctrl.form.errors.trackingCode\">\n              <li ng-repeat=\"(key, error) in $ctrl.form.errors.trackingCode.errors\" class=\"parsley-required\">{{ error }}</li>\n          </ul>\n          <div class=\"note\"><small>{{ 'referralCodeNote' | translate }}</small></div>\n      </div>\n      <div class=\"pull-right\">\n        <button ng-click=\"$ctrl.reset()\" type=\"button\" class=\"btn aff-reset-btn waves-effect waves-light\">{{ 'Reset' | translate }}</button>\n        <ladda-button class=\"btn-generate\" ladda-disable=\"$ctrl.form.props.readOnly\" on-click=\"$ctrl.submit()\" type=\"submit\" text=\"'Generate'\"></ladda-button>\n      </div>\n    </div>\n</form>\n"

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1643);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _randomTrackingCode = __webpack_require__(1644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormController = function () {
	  FormController.$inject = ["MarketingApiService", "FormService", "BannerImagePreviewFactory"];
	  function FormController(MarketingApiService, FormService, BannerImagePreviewFactory) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FormController);
	    this.MarketingApiService = MarketingApiService;
	    this.FormService = FormService;
	    this.BannerImagePreviewFactory = BannerImagePreviewFactory;
	  }
	
	  (0, _createClass3.default)(FormController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.form = new _form2.default();
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      this.FormService.isSubmitting.next(true);
	      this.MarketingApiService.generate(this.form.toPayload()).then(function (response) {
	        _this.onSuccessfulSubmission({ response: response });
	        _this.FormService.isSubmitting.next(false);
	        _this.form.props.readOnly = true;
	        _this.form.clearErrors();
	      }).catch(function (errors) {
	        _this.form.errors = errors;
	        _this.FormService.isSubmitting.next(false);
	      });
	    }
	  }, {
	    key: 'previewBanner',
	    value: function previewBanner() {
	      var filename = this.BannerImagePreviewFactory.getPreviewableBanner(this.form);
	      this.onBannerPreview({
	        filename: filename,
	        allowDownload: false
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.form.clear();
	      this.onFormReset();
	    }
	  }, {
	    key: 'createRandomTrackingCode',
	    value: function createRandomTrackingCode() {
	      this.form.trackingCode = (0, _randomTrackingCode.randomTrackingCode)();
	    }
	  }, {
	    key: 'onPreventableKeydown',
	    value: function onPreventableKeydown(event) {
	      if (event.which === 32) {
	        event.preventDefault();
	      }
	    }
	  }]);
	  return FormController;
	}();
	
	exports.default = FormController;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PROTOCOLS = exports.SIZES = exports.LANGUAGES = undefined;
	
	var _assign = __webpack_require__(1610);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _freeze = __webpack_require__(1252);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _select = __webpack_require__(1614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LANGUAGES = exports.LANGUAGES = (0, _freeze2.default)({
	  'EN': 'English',
	  'FR': 'French',
	  'DE': 'German',
	  'ES': 'Spanish',
	  'AO': 'AsianOdds | English',
	  'AO-FR': 'AsianOdds | French',
	  'AO-ES': 'AsianOdds | Spanish'
	});
	
	var SIZES = exports.SIZES = (0, _freeze2.default)({
	  '300x300': '300x300',
	  '300x250': '300x250',
	  '250x250': '250x250',
	  '468x60': '468x60',
	  '728x90': '728x90'
	});
	
	var PROTOCOLS = exports.PROTOCOLS = (0, _freeze2.default)({
	  http: 'http',
	  https: 'https'
	});
	
	var BannerForm = function () {
	  function BannerForm() {
	    (0, _classCallCheck3.default)(this, BannerForm);
	
	    this._website = null;
	    this._protocol = PROTOCOLS.http;
	    this._type = 'promotion';
	    this._language = '';
	    this._size = '';
	    this._campaignName = null;
	    this._trackingCode = null;
	
	    // Selects
	    this._protocolSelect = new _select.SelectModel(PROTOCOLS);
	    this._languagesSelect = new _select.SelectModel((0, _assign2.default)({ '': 'Please Select' }, LANGUAGES));
	    this._sizesSelect = new _select.SelectModel((0, _assign2.default)({ '': 'Please Select' }, SIZES));
	
	    this._errors = {};
	
	    this.props = { readOnly: false };
	  }
	
	  (0, _createClass3.default)(BannerForm, [{
	    key: 'toPayload',
	    value: function toPayload() {
	      return {
	        memberBanner: {
	          website: this.formatWebsite(this.protocol, this.website),
	          type: this.type,
	          language: this.toLanguageShortCode(this.language),
	          size: this.size,
	          campaignName: this.campaignName,
	          trackingCode: this.trackingCode
	        }
	      };
	    }
	  }, {
	    key: 'formatWebsite',
	    value: function formatWebsite(protocol, website) {
	      var protocolWebsite = '';
	
	      if (website !== null && website !== '') {
	        protocolWebsite = protocol + '://' + website;
	      }
	
	      return protocolWebsite;
	    }
	  }, {
	    key: 'toLanguageShortCode',
	    value: function toLanguageShortCode(language) {
	      for (var prop in LANGUAGES) {
	        if (prop === language) {
	          return prop;
	        }
	      }
	
	      return '';
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this._website = null;
	      this._type = 'promotion';
	      this._protocol = PROTOCOLS.http;
	      this._language = null;
	      this._size = null;
	      this._campaignName = null;
	      this._trackingCode = null;
	
	      this._errors = {};
	
	      this.props = { readOnly: false };
	    }
	  }, {
	    key: 'clearErrors',
	    value: function clearErrors() {
	      this._errors = {};
	    }
	  }, {
	    key: 'website',
	    set: function set(website) {
	      this._website = website;
	    },
	    get: function get() {
	      return this._website;
	    }
	  }, {
	    key: 'protocol',
	    set: function set(protocol) {
	      this._protocol = protocol;
	    },
	    get: function get() {
	      return this._protocol;
	    }
	  }, {
	    key: 'type',
	    set: function set(type) {
	      this._type = type;
	    },
	    get: function get() {
	      return this._type;
	    }
	  }, {
	    key: 'language',
	    set: function set(language) {
	      return this._language = language;
	    },
	    get: function get() {
	      return this._language;
	    }
	  }, {
	    key: 'size',
	    set: function set(size) {
	      this._size = size;
	    },
	    get: function get() {
	      return this._size;
	    }
	  }, {
	    key: 'campaignName',
	    set: function set(campaignName) {
	      this._campaignName = campaignName;
	    },
	    get: function get() {
	      return this._campaignName;
	    }
	  }, {
	    key: 'trackingCode',
	    set: function set(trackingCode) {
	      this._trackingCode = trackingCode;
	    },
	    get: function get() {
	      return this._trackingCode;
	    }
	  }, {
	    key: 'errors',
	    set: function set(errors) {
	      this._errors = errors.children;
	    },
	    get: function get() {
	      return this._errors;
	    }
	  }, {
	    key: 'canPreviewBanner',
	    get: function get() {
	      return this.language !== null && this.size !== null;
	    }
	  }, {
	    key: 'protocolSelect',
	    get: function get() {
	      return this._protocolSelect;
	    }
	  }, {
	    key: 'languagesSelect',
	    get: function get() {
	      return this._languagesSelect;
	    }
	  }, {
	    key: 'sizesSelect',
	    get: function get() {
	      return this._sizesSelect;
	    }
	  }]);
	  return BannerForm;
	}();
	
	exports.default = BannerForm;

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.randomTrackingCode = randomTrackingCode;
	function randomTrackingCode() {
	  var text = "";
	  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	
	  for (var i = 0; i < 10; i++) {
	    text += possible.charAt(Math.floor(Math.random() * possible.length));
	  }
	
	  return text;
	}

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _form = __webpack_require__(1643);
	
	var _lodash = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerImagePreviewFactory = function () {
	  BannerImagePreviewFactory.$inject = ["MarketingApiService"];
	  function BannerImagePreviewFactory(MarketingApiService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, BannerImagePreviewFactory);
	    this.MarketingApiService = MarketingApiService;
	
	    this.MarketingApiService.getImagesList().then(function (list) {
	      return _this.imagesList = list;
	    });
	  }
	
	  (0, _createClass3.default)(BannerImagePreviewFactory, [{
	    key: 'preview',
	    value: function preview(filename) {
	      return this.MarketingApiService.previewBanner(filename);
	    }
	  }, {
	    key: 'getPreviewableBanner',
	    value: function getPreviewableBanner(form) {
	      return this.inferFileName(form);
	    }
	  }, {
	    key: 'inferFileName',
	    value: function inferFileName(form) {
	      ;
	      var language = form.language;
	      var image = this.imagesList.filter(function (image) {
	        if (image.type_text === form.type && image.language === language && image.dimension === form.size) {
	          return image;
	        }
	      })[0];
	
	      return image.filename;
	    }
	  }]);
	  return BannerImagePreviewFactory;
	}();
	
	exports.default = BannerImagePreviewFactory;

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function DownloadableDirective() {
	  function supportIE(elem, trackingCode) {
	    var fileData = [trackingCode];
	    blobObject = new Blob(fileData);
	    elem.on('click', function () {
	      window.navigator.msSaveOrOpenBlob(blobObject, 'tracking.html');
	    });
	  }
	
	  return {
	    restrict: 'A',
	    scope: {
	      trackingCode: '@'
	    },
	    link: function link(scope, elem, attrs) {
	      attrs.$observe('trackingCode', function (trackingCode) {
	        // If we are on Chrome / Firefox / Safari
	        if (!window.navigator.msSaveOrOpenBlob) {
	          var url = "data:text/html;charset=utf-8," + encodeURIComponent(trackingCode);
	          elem.attr('download', 'tracking.html');
	          elem.attr('href', url);
	        } else {
	          supportIE(elem, trackingCode);
	        }
	      });
	    }
	  };
	}
	
	exports.default = DownloadableDirective;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _customerApi = __webpack_require__(1648);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	var _transactionApi = __webpack_require__(1650);
	
	var _transactionApi2 = _interopRequireDefault(_transactionApi);
	
	var _productApi = __webpack_require__(1652);
	
	var _productApi2 = _interopRequireDefault(_productApi);
	
	var _dashboardApi = __webpack_require__(1653);
	
	var _dashboardApi2 = _interopRequireDefault(_dashboardApi);
	
	var _profileApi = __webpack_require__(1654);
	
	var _profileApi2 = _interopRequireDefault(_profileApi);
	
	var _overviewApi = __webpack_require__(1655);
	
	var _overviewApi2 = _interopRequireDefault(_overviewApi);
	
	var _marketingApi = __webpack_require__(1656);
	
	var _marketingApi2 = _interopRequireDefault(_marketingApi);
	
	var _acrewardsApi = __webpack_require__(1658);
	
	var _acrewardsApi2 = _interopRequireDefault(_acrewardsApi);
	
	var _accountApi = __webpack_require__(1659);
	
	var _accountApi2 = _interopRequireDefault(_accountApi);
	
	var _betoverviewApi = __webpack_require__(1660);
	
	var _betoverviewApi2 = _interopRequireDefault(_betoverviewApi);
	
	var _paymentoptionApi = __webpack_require__(1663);
	
	var _paymentoptionApi2 = _interopRequireDefault(_paymentoptionApi);
	
	var _memberproductApi = __webpack_require__(1664);
	
	var _memberproductApi2 = _interopRequireDefault(_memberproductApi);
	
	var _ticketsApi = __webpack_require__(1665);
	
	var _ticketsApi2 = _interopRequireDefault(_ticketsApi);
	
	var _memberrequestApi = __webpack_require__(1666);
	
	var _memberrequestApi2 = _interopRequireDefault(_memberrequestApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiModule = _angular2.default.module('app.api', []).service('CustomerApiService', _customerApi2.default).service('TransactionApiService', _transactionApi2.default).service('ProductApiService', _productApi2.default).service('DashboardApiService', _dashboardApi2.default).service('ProfileApiService', _profileApi2.default).service('OverviewApiService', _overviewApi2.default).service('MarketingApiService', _marketingApi2.default).service('AcrewardsApiService', _acrewardsApi2.default).service('AccountApiService', _accountApi2.default).service('BetOverviewApiService', _betoverviewApi2.default).service('PaymentOptionApiService', _paymentoptionApi2.default).service('MemberProductApiService', _memberproductApi2.default).service('TicketsApiService', _ticketsApi2.default).service('MemberRequestApiService', _memberrequestApi2.default).name;
	
	exports.default = apiModule;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _account = __webpack_require__(1649);
	
	var _customerProduct = __webpack_require__(1460);
	
	var _paymentOption = __webpack_require__(1393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomerApiService = function () {
	  CustomerApiService.$inject = ["HttpService", "SessionService"];
	  function CustomerApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CustomerApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(CustomerApiService, [{
	    key: 'getProducts',
	    value: function getProducts() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/products').then(function (customerProductsPayload) {
	        return customerProductsPayload.map(function (payload) {
	          return (0, _customerProduct.makeCustomerProduct)(payload);
	        });
	      });
	    }
	  }, {
	    key: 'getCustomerProducts',
	    value: function getCustomerProducts() {
	      return this.getProducts();
	    }
	  }, {
	    key: 'getMemberProducts',
	    value: function getMemberProducts() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/products');
	    }
	
	    // TODO: We must not query all the products just to get the brokerageSyncId
	
	  }, {
	    key: 'getBrokerageSyncId',
	    value: function getBrokerageSyncId() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/products');
	    }
	  }, {
	    key: 'getPaymentOptions',
	    value: function getPaymentOptions() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/payment-options').then(function (paymentOptions) {
	        return paymentOptions.map(function (paymentOptionPayload) {
	          return (0, _paymentOption.makePaymentOption)(paymentOptionPayload);
	        });
	      });
	    }
	  }, {
	    key: 'getBalance',
	    value: function getBalance() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/balance');
	    }
	  }, {
	    key: 'getAccount',
	    value: function getAccount() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/balance').then(function (payload) {
	        return (0, _account.makeAccount)(payload);
	      });
	    }
	  }, {
	    key: 'getNotifications',
	    value: function getNotifications() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/notifications');
	    }
	  }, {
	    key: 'readNotifications',
	    value: function readNotifications() {
	      return this.HttpService.put('/' + this.SessionService.getLocale() + '/customer/read-notifications');
	    }
	  }, {
	    key: 'saveRestoreId',
	    value: function saveRestoreId(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/customer/restore-id/save', payload);
	    }
	  }, {
	    key: 'updateLanguage',
	    value: function updateLanguage(language) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/customer/language/update/' + language);
	    }
	  }, {
	    key: 'getGoogleAuthenticationCode',
	    value: function getGoogleAuthenticationCode() {
	      return this.HttpService.get('/auth/two-factor/qr-code');
	    }
	  }, {
	    key: 'activateGoogleTwoFactor',
	    value: function activateGoogleTwoFactor(payload) {
	      return this.HttpService.post('/customer/two-factor/activate', payload);
	    }
	  }, {
	    key: 'switchTwoFactor',
	    value: function switchTwoFactor() {
	      return this.HttpService.post('/customer/two-factor/switch', {});
	    }
	  }, {
	    key: 'setupTransactionPassword',
	    value: function setupTransactionPassword(payload) {
	      return this.HttpService.post('/customer/transaction-password/setup', payload);
	    }
	  }, {
	    key: 'updateAvatar',
	    value: function updateAvatar(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/customer/avatar/update', payload, 'json', { reportProgress: true, observe: 'events', 'Content-Type': undefined });
	    }
	  }, {
	    key: 'getAvatar',
	    value: function getAvatar(filename) {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/customer/avatar/get/' + filename);
	    }
	  }, {
	    key: 'resetGoogleAuthenticationCode',
	    value: function resetGoogleAuthenticationCode() {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/reset/google-auth');
	    }
	  }]);
	  return CustomerApiService;
	}();
	
	exports.default = CustomerApiService;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Account = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeAccount = makeAccount;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeAccount(payload) {
	  var account = new Account();
	  account.availableBalance = payload.available;
	  account.unallocatedBalance = payload.unallocated;
	
	  return account;
	}
	
	var Account = exports.Account = function () {
	  function Account() {
	    (0, _classCallCheck3.default)(this, Account);
	  }
	
	  (0, _createClass3.default)(Account, [{
	    key: "construct",
	    value: function construct() {
	      this._availableBalance = null;
	      this._unallocatedBalance = null;
	    }
	  }, {
	    key: "availableBalance",
	    set: function set(availableBalance) {
	      this._availableBalance = availableBalance;
	    },
	    get: function get() {
	      return this._availableBalance;
	    }
	  }, {
	    key: "unallocatedBalance",
	    set: function set(unallocatedBalance) {
	      this._unallocatedBalance = unallocatedBalance;
	    },
	    get: function get() {
	      return this._unallocatedBalance;
	    }
	  }]);
	  return Account;
	}();

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _customerProduct = __webpack_require__(1460);
	
	var _paymentOption = __webpack_require__(1393);
	
	var _bitcoinTransaction = __webpack_require__(1651);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionApiService = function () {
	  TransactionApiService.$inject = ["HttpService", "SessionService"];
	  function TransactionApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TransactionApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(TransactionApiService, [{
	    key: "depositDetails",
	    value: function depositDetails() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/deposit-details').then(function (details) {
	        details['customerProducts'] = details['customerProducts'].map(function (payload) {
	          return (0, _customerProduct.makeCustomerProduct)(payload);
	        });
	
	        details['paymentOptions'] = details['paymentOptions'].map(function (payload) {
	          return (0, _paymentOption.makePaymentOption)(payload);
	        });
	
	        return details;
	      });
	    }
	  }, {
	    key: "deposit",
	    value: function deposit(payload) {
	      var additionalHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/deposit', payload, 'json', additionalHeaders);
	    }
	  }, {
	    key: "withdrawDetails",
	    value: function withdrawDetails() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/withdraw-details').then(function (details) {
	        details['customerProducts'] = details['customerProducts'].map(function (payload) {
	          return (0, _customerProduct.makeCustomerProduct)(payload);
	        });
	
	        return details;
	      });
	    }
	  }, {
	    key: "withdraw",
	    value: function withdraw(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/withdraw', payload);
	    }
	  }, {
	    key: "transfer",
	    value: function transfer(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/transfer', payload);
	    }
	  }, {
	    key: "p2pTransfer",
	    value: function p2pTransfer(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/p2pTransfer', payload);
	    }
	  }, {
	    key: "p2pTransferDetails",
	    value: function p2pTransferDetails() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/p2pTransfer-details').then(function (details) {
	        details['customerProducts'] = details['customerProducts'].map(function (payload) {
	          return (0, _customerProduct.makeCustomerProduct)(payload);
	        });
	
	        return details;
	      });
	    }
	  }, {
	    key: "getPaymentOptions",
	    value: function getPaymentOptions() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/payment-options').then(function (paymentOptions) {
	        return paymentOptions.map(function (paymentOptionPayload) {
	          return (0, _paymentOption.makePaymentOption)(paymentOptionPayload);
	        });
	      });
	    }
	  }, {
	    key: "checkForActiveBitcoinTransaction",
	    value: function checkForActiveBitcoinTransaction() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/check-for-active-bitcoin-transaction').then(function (payload) {
	        if (payload.length === 0) {
	          return null;
	        }
	
	        return (0, _bitcoinTransaction.makeBitcoinTransaction)(payload);
	      });
	    }
	  }, {
	    key: "acknowledgeBitcoinTransaction",
	    value: function acknowledgeBitcoinTransaction() {
	      return this.HttpService.put('/' + this.SessionService.getLocale() + '/transactions/acknowledge-bitcoin-transaction');
	    }
	  }, {
	    key: "declineBitcoinTransaction",
	    value: function declineBitcoinTransaction() {
	      return this.HttpService.put('/' + this.SessionService.getLocale() + '/transactions/decline-bitcoin-transaction');
	    }
	  }, {
	    key: "lockRateBitcoinTransaction",
	    value: function lockRateBitcoinTransaction() {
	      return this.HttpService.put('/' + this.SessionService.getLocale() + '/transactions/lock-rate-bitcoin-transaction');
	    }
	
	    /**
	     * @deprecated use getHistory() of OverviewApiService instead.
	     */
	
	  }, {
	    key: "getHistory",
	    value: function getHistory(payload) {
	      var queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
	      return this.HttpService.get("/overview/transaction-history?" + queryParams);
	    }
	  }, {
	    key: "condition",
	    value: function condition() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/settings-condition');
	    }
	  }, {
	    key: "createProductPassword",
	    value: function createProductPassword(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/product-password/create', payload);
	    }
	  }, {
	    key: "viewProductPassword",
	    value: function viewProductPassword(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/product-password/view', payload);
	    }
	  }]);
	  return TransactionApiService;
	}();
	
	exports.default = TransactionApiService;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BitcoinTransaction = exports.BitcoinSubtransaction = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeBitcoinTransaction = makeBitcoinTransaction;
	
	var _customerProduct = __webpack_require__(1460);
	
	var _number = __webpack_require__(1203);
	
	var _moment = __webpack_require__(1256);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeBitcoinTransaction(payload) {
	  return BitcoinTransaction.fromPayload(payload);
	}
	
	var BitcoinSubtransaction = exports.BitcoinSubtransaction = function () {
	  function BitcoinSubtransaction() {
	    (0, _classCallCheck3.default)(this, BitcoinSubtransaction);
	
	    this._amount = null;
	    this._btc = null;
	    this._customerProduct = null;
	  }
	
	  (0, _createClass3.default)(BitcoinSubtransaction, [{
	    key: "amount",
	    set: function set(amount) {
	      this._amount = amount;
	    },
	    get: function get() {
	      return this._amount;
	    }
	  }, {
	    key: "btc",
	    set: function set(btc) {
	      btc = (0, _numeral2.default)(btc);
	      this._btc = btc;
	    },
	    get: function get() {
	      return this._btc;
	    }
	  }, {
	    key: "customerProduct",
	    set: function set(customerProduct) {
	      this._customerProduct = customerProduct;
	    },
	    get: function get() {
	      return this._customerProduct;
	    }
	  }], [{
	    key: "fromPayload",
	    value: function fromPayload(payload, bitcoinPayload) {
	      var subtransaction = new BitcoinSubtransaction();
	
	      subtransaction.amount = (0, _numeral2.default)(payload.amount);
	      subtransaction.customerProduct = (0, _customerProduct.makeCustomerProduct)(payload.customer_product);
	
	      var rate = (0, _numeral2.default)(bitcoinPayload.rate);
	      subtransaction.btc = (0, _numeral2.default)(subtransaction.amount.value() / rate.value()).format(_number.BITCOIN_DECIMAL_PLACES_FORMAT);
	
	      return subtransaction;
	    }
	  }]);
	  return BitcoinSubtransaction;
	}();
	
	var BitcoinTransaction = exports.BitcoinTransaction = function () {
	  function BitcoinTransaction() {
	    (0, _classCallCheck3.default)(this, BitcoinTransaction);
	
	    this._id = null;
	    this._timeRemaining = null;
	    this._receivingAddress = null;
	    this._senderAddress = null;
	    this._confirmationCount = null;
	    this._isDeclined = false;
	    this._isRateExpired = false;
	    this._lockDownRateTimeRemaining = null;
	    this._bitcoinSubtransactions = [];
	    this._adjustedRate = null;
	  }
	
	  (0, _createClass3.default)(BitcoinTransaction, [{
	    key: "id",
	    set: function set(id) {
	      this._id = id;
	    },
	    get: function get() {
	      return this._id;
	    }
	  }, {
	    key: "timeRemaining",
	    set: function set(timeRemaining) {
	      var parts = timeRemaining.split(':');
	      this._timeRemaining = (0, _moment2.default)({
	        hour: parts[0],
	        minute: parts[1],
	        second: parts[2]
	      });
	    },
	    get: function get() {
	      return this._timeRemaining;
	    }
	  }, {
	    key: "isTimeRemainingExpired",
	    get: function get() {
	      return this.timeRemaining.format('HH:mm:ss') === '00:00:00';
	    }
	  }, {
	    key: "receivingAddress",
	    get: function get() {
	      return this._receivingAddress;
	    },
	    set: function set(receivingAddress) {
	      this._receivingAddress = receivingAddress;
	    }
	  }, {
	    key: "senderAddress",
	    get: function get() {
	      return this._senderAddress;
	    },
	    set: function set(senderAddress) {
	      this._senderAddress = senderAddress;
	    }
	  }, {
	    key: "confirmationCount",
	    set: function set(confirmationCount) {
	      this._confirmationCount = confirmationCount;
	    },
	    get: function get() {
	      return this._confirmationCount;
	    }
	  }, {
	    key: "bitcoinSubtransactions",
	    set: function set(bitcoinSubtransactions) {
	      this._bitcoinSubtransactions = bitcoinSubtransactions;
	    },
	    get: function get() {
	      return this._bitcoinSubtransactions;
	    }
	  }, {
	    key: "hasConfirmation",
	    get: function get() {
	      return this.confirmationCount > 0;
	    }
	  }, {
	    key: "isRequested",
	    get: function get() {
	      if (this.isDeclined) {
	        return false;
	      }
	
	      return this.confirmationCount === null;
	    }
	  }, {
	    key: "isPending",
	    get: function get() {
	      if (this.isDeclined) {
	        return false;
	      }
	
	      return this.confirmationCount !== null && this.confirmationCount < 3;
	    }
	  }, {
	    key: "isConfirmed",
	    get: function get() {
	      return this.confirmationCount >= 3;
	    }
	  }, {
	    key: "isDeclined",
	    set: function set(isDeclined) {
	      this._isDeclined = isDeclined;
	    },
	    get: function get() {
	      return this._isDeclined;
	    }
	  }, {
	    key: "isRateExpired",
	    set: function set(isRateExpired) {
	      this._isRateExpired = isRateExpired;
	    },
	    get: function get() {
	      return this._isRateExpired;
	    }
	  }, {
	    key: "lockDownRateTimeRemaining",
	    set: function set(timeRemaining) {
	      var parts = timeRemaining.split(':');
	      this._lockDownRateTimeRemaining = (0, _moment2.default)({
	        hour: parts[0],
	        minute: parts[1],
	        second: parts[2]
	      });
	    },
	    get: function get() {
	      return this._lockDownRateTimeRemaining;
	    }
	  }, {
	    key: "isLockDownRateTimeExpired",
	    get: function get() {
	      return this._lockDownRateTimeRemaining.format('HH:mm:ss') === '00:00:00';
	    }
	  }, {
	    key: "adjustedRate",
	    set: function set(adjustedRate) {
	      this._adjustedRate = (0, _numeral2.default)(adjustedRate);
	    },
	    get: function get() {
	      return this._adjustedRate;
	    }
	  }, {
	    key: "formattedAdjustedRate",
	    get: function get() {
	      return BitcoinTransaction.formatDecimal(this.adjustedRate);
	    }
	  }], [{
	    key: "fromPayload",
	    value: function fromPayload(payload) {
	      var bitcoinTransaction = new BitcoinTransaction();
	
	      bitcoinTransaction.id = payload.id;
	      bitcoinTransaction.timeRemaining = payload.time_remaining;
	      bitcoinTransaction.adjustedRate = payload.bitcoin.rate;
	      bitcoinTransaction.receivingAddress = payload.bitcoin.receiver_unique_address;
	
	      if (payload.bitcoin.hasOwnProperty('transaction')) {
	        bitcoinTransaction.senderAddress = payload.bitcoin.transaction.sender_address;
	      }
	
	      if (payload.bitcoin.hasOwnProperty('confirmation_count')) {
	        bitcoinTransaction.confirmationCount = payload.bitcoin.confirmation_count;
	      }
	
	      bitcoinTransaction.isRateExpired = payload.bitcoin.rate_expired;
	      bitcoinTransaction.lockDownRateTimeRemaining = payload.lock_down_rate_time_remaining;
	      bitcoinTransaction.isDeclined = payload.isDeclined;
	
	      bitcoinTransaction.bitcoinSubtransactions = payload.subtransactions.map(function (subtransactionPayload) {
	        return BitcoinSubtransaction.fromPayload(subtransactionPayload, payload.bitcoin);
	      });
	
	      return bitcoinTransaction;
	    }
	  }, {
	    key: "formatDecimal",
	    value: function formatDecimal(numeral) {
	      return (0, _number.format)(numeral, _number.BITCOIN_DECIMAL_PLACES_FORMAT);
	    }
	  }]);
	  return BitcoinTransaction;
	}();

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductApiService = function () {
	  ProductApiService.$inject = ["HttpService", "SessionService"];
	  function ProductApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProductApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(ProductApiService, [{
	    key: 'getProducts',
	    value: function getProducts() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/products');
	    }
	  }]);
	  return ProductApiService;
	}();
	
	exports.default = ProductApiService;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardApiService = function () {
	  DashboardApiService.$inject = ["HttpService", "SessionService"];
	  function DashboardApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DashboardApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(DashboardApiService, [{
	    key: 'dashboard',
	    value: function dashboard() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/dashboard');
	    }
	  }, {
	    key: 'condition',
	    value: function condition() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/settings-condition');
	    }
	  }]);
	  return DashboardApiService;
	}();
	
	exports.default = DashboardApiService;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileApiService = function () {
	  ProfileApiService.$inject = ["HttpService", "SessionService"];
	  function ProfileApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ProfileApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(ProfileApiService, [{
	    key: 'profile',
	    value: function profile() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/profile');
	    }
	  }]);
	  return ProfileApiService;
	}();
	
	exports.default = ProfileApiService;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(1256);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OverviewApiService = function () {
	  OverviewApiService.$inject = ["HttpService", "SessionService"];
	  function OverviewApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OverviewApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(OverviewApiService, [{
	    key: 'getHistory',
	    value: function getHistory(payload) {
	      if (payload.from) {
	        payload.from = (0, _moment2.default)(payload.from, 'YYYY-MM-DD').format();
	      }
	
	      if (payload.to) {
	        payload.to = (0, _moment2.default)(payload.to, 'YYYY-MM-DD').format();
	      }
	
	      var queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
	      return this.HttpService.get('/' + this.SessionService.getLocale() + ('/overview/transaction-history?' + queryParams));
	    }
	  }]);
	  return OverviewApiService;
	}();
	
	exports.default = OverviewApiService;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _banner = __webpack_require__(1657);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketingApiService = function () {
	  MarketingApiService.$inject = ["HttpService", "SessionService"];
	  function MarketingApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MarketingApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(MarketingApiService, [{
	    key: 'generate',
	    value: function generate(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/marketing/generate-banner', payload);
	    }
	  }, {
	    key: 'getBannerList',
	    value: function getBannerList() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/marketing/list-banner').then(function (banners) {
	        return banners.map(function (banner) {
	          return (0, _banner.makeBanner)(banner);
	        });
	      });
	    }
	  }, {
	    key: 'getReferralLinks',
	    value: function getReferralLinks() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/marketing/referral-links');
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/marketing/confirm');
	    }
	  }, {
	    key: 'getImagesList',
	    value: function getImagesList() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/marketing/images-list');
	    }
	  }, {
	    key: 'previewBanner',
	    value: function previewBanner(fileName) {
	      var _this = this;
	
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/marketing/view-banner/' + fileName, 'arraybuffer').then(function (response) {
	        return _this.toBase64(response);
	      });
	    }
	  }, {
	    key: 'toBase64',
	    value: function toBase64(buffer) {
	      var binary = '';
	      var bytes = new Uint8Array(buffer);
	      var len = bytes.byteLength;
	      for (var i = 0; i < len; i++) {
	        binary += String.fromCharCode(bytes[i]);
	      }
	
	      return window.btoa(binary);
	    }
	  }]);
	  return MarketingApiService;
	}();
	
	exports.default = MarketingApiService;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Banner = exports.BannerImage = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeBanner = makeBanner;
	exports.makeBannerImage = makeBannerImage;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeBanner(bannerDetails) {
	  var bannerImage = makeBannerImage(bannerDetails.banner_image);
	  var banner = new Banner(bannerImage);
	  banner.id = bannerDetails.id;
	  banner.campaignName = bannerDetails.campaign_name;
	  banner.referralLink = bannerDetails.referral_link;
	  banner.trackingHTMLCode = bannerDetails.tracking_html_code;
	  banner.referralCode = bannerDetails.member_referral_name.name;
	  banner.website = bannerDetails.member_website !== null ? bannerDetails.member_website.website : '';
	
	  return banner;
	}
	
	function makeBannerImage(bannerImageDetails) {
	  var bannerImage = new BannerImage();
	  bannerImage.dimension = bannerImageDetails.dimension;
	  bannerImage.id = bannerImageDetails.id;
	  bannerImage.filename = bannerImageDetails.filename;
	  bannerImage.language = bannerImageDetails.language_text;
	  bannerImage.type = bannerImageDetails.type_title_text;
	
	  return bannerImage;
	}
	
	var BannerImage = exports.BannerImage = function () {
	  function BannerImage() {
	    (0, _classCallCheck3.default)(this, BannerImage);
	
	    this._id = null;
	    this._dimension = null;
	    this._filename = null;
	    this._language = null;
	    this._type = null;
	  }
	
	  (0, _createClass3.default)(BannerImage, [{
	    key: 'id',
	    set: function set(id) {
	      this._id = id;
	    },
	    get: function get() {
	      return this._id;
	    }
	  }, {
	    key: 'dimension',
	    set: function set(dimension) {
	      this._dimension = dimension;
	    },
	    get: function get() {
	      return this._dimension;
	    }
	  }, {
	    key: 'filename',
	    set: function set(filename) {
	      this._filename = filename;
	    },
	    get: function get() {
	      return this._filename;
	    }
	  }, {
	    key: 'language',
	    set: function set(language) {
	      this._language = language;
	    },
	    get: function get() {
	      return this._language;
	    }
	  }, {
	    key: 'type',
	    set: function set(type) {
	      this._type = type;
	    },
	    get: function get() {
	      return this._type;
	    }
	  }]);
	  return BannerImage;
	}();
	
	var Banner = exports.Banner = function () {
	  function Banner(bannerImage) {
	    (0, _classCallCheck3.default)(this, Banner);
	
	    this._bannerImage = bannerImage;
	    this._id = null;
	    this._campaignName = null;
	    this._referralLink = null;
	    this._trackingHTMLCode = null;
	
	    this.referralCode = null;
	    this.website = null;
	  }
	
	  (0, _createClass3.default)(Banner, [{
	    key: 'bannerImage',
	    set: function set(bannerImage) {
	      this._bannerImage = bannerImage;
	    },
	    get: function get() {
	      return this._bannerImage;
	    }
	  }, {
	    key: 'id',
	    set: function set(id) {
	      this._id = id;
	    },
	    get: function get() {
	      return this._id;
	    }
	  }, {
	    key: 'campaignName',
	    set: function set(campaignName) {
	      this._campaignName = campaignName;
	    },
	    get: function get() {
	      return this._campaignName;
	    }
	  }, {
	    key: 'referralLink',
	    set: function set(referralLink) {
	      this._referralLink = referralLink;
	    },
	    get: function get() {
	      return this._referralLink;
	    }
	  }, {
	    key: 'trackingHTMLCode',
	    set: function set(trackingHTMLCode) {
	      this._trackingHTMLCode = trackingHTMLCode;
	    },
	    get: function get() {
	      return this._trackingHTMLCode;
	    }
	  }, {
	    key: 'referralCode',
	    set: function set(referralCode) {
	      this._referralCode = referralCode;
	    },
	    get: function get() {
	      return this._referralCode;
	    }
	  }, {
	    key: 'website',
	    set: function set(website) {
	      this._website = website;
	    },
	    get: function get() {
	      return this._website;
	    }
	  }]);
	  return Banner;
	}();

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(1256);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcrewardsApiService = function () {
	  AcrewardsApiService.$inject = ["HttpService", "SessionService"];
	  function AcrewardsApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AcrewardsApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(AcrewardsApiService, [{
	    key: 'listTurnOverCommission',
	    value: function listTurnOverCommission(payload) {
	      var queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
	
	      return this.HttpService.get('/' + this.SessionService.getLocale() + ('/acrewards/turnover-commission-list?' + queryParams));
	    }
	  }, {
	    key: 'filterTurnOverCommission',
	    value: function filterTurnOverCommission(payload) {
	      if (payload.dwlDateFrom) {
	        payload.dwlDateFrom = (0, _moment2.default)(payload.dwlDateFrom, 'YYYY-MM-DD').format();
	      }
	
	      if (payload.dwlDateTo) {
	        payload.dwlDateTo = (0, _moment2.default)(payload.dwlDateTo, 'YYYY-MM-DD').format();
	      }
	
	      var queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
	      return this.HttpService.get('/' + this.SessionService.getLocale() + ('/acrewards/turnover-commission-list?' + queryParams));
	    }
	  }, {
	    key: 'getCurrentRunningCommission',
	    value: function getCurrentRunningCommission() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/acrewards/current-running-commission');
	    }
	  }, {
	    key: 'getPreviousRunningCommission',
	    value: function getPreviousRunningCommission() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/acrewards/previous-running-commission');
	    }
	  }]);
	  return AcrewardsApiService;
	}();
	
	exports.default = AcrewardsApiService;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountApiService = function () {
	  AccountApiService.$inject = ["HttpService"];
	  function AccountApiService(HttpService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AccountApiService);
	    this.HttpService = HttpService;
	  }
	
	  (0, _createClass3.default)(AccountApiService, [{
	    key: 'sendResetCode',
	    value: function sendResetCode(locale, payload) {
	      return this.HttpService.post('/' + locale + '/account/send/reset-code', payload);
	    }
	  }, {
	    key: 'validateResetCode',
	    value: function validateResetCode(locale, payload) {
	      return this.HttpService.post('/' + locale + '/account/check/reset-code', payload);
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(locale, payload) {
	      return this.HttpService.post('/' + locale + '/account/reset/password', payload);
	    }
	  }]);
	  return AccountApiService;
	}();
	
	exports.default = AccountApiService;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BetOverviewApiService = undefined;
	
	var _assign = __webpack_require__(1610);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _environment = __webpack_require__(504);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _bet = __webpack_require__(1661);
	
	var _overview = __webpack_require__(1662);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetOverviewApiService = exports.BetOverviewApiService = function () {
	  BetOverviewApiService.$inject = ["HttpService", "SessionService"];
	  function BetOverviewApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BetOverviewApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(BetOverviewApiService, [{
	    key: "getBetOverview",
	    value: function getBetOverview(payload) {
	      var mergedPayload = (0, _assign2.default)({ id: this.SessionService.get('brokerageSyncId') }, payload);
	      var queryParams = this.HttpService.buildQueryParamsFromPayload(mergedPayload);
	
	      return this.HttpService.getNonAsync("/brokerage/bet-overview?" + queryParams).then(function (payload) {
	        return (0, _overview.makeBetOverviewListing)(payload);
	      });
	    }
	  }, {
	    key: "getLeagues",
	    value: function getLeagues() {
	      return this.HttpService.get("/brokerage/get-leagues").then(function (payload) {
	        return payload.reduce(function (accumulator, league) {
	          return (0, _overview.makeLeagues)(accumulator, league);
	        }, {});
	      });
	    }
	  }, {
	    key: "getBets",
	    value: function getBets(payload) {
	      var mergedPayload = (0, _assign2.default)({ id: this.SessionService.get('brokerageSyncId') }, payload);
	      var queryParams = this.HttpService.buildQueryParamsFromPayload(mergedPayload);
	
	      return this.HttpService.getNonAsync("/brokerage/get-bets?" + queryParams).then(function (payload) {
	        return (0, _bet.makeBetListing)(payload);
	      });
	    }
	  }, {
	    key: "exportToCSV",
	    value: function exportToCSV(payload) {
	      var mergedPayload = (0, _assign2.default)({ id: this.SessionService.get('brokerageSyncId') }, payload);
	      var queryParams = this.HttpService.buildQueryParamsFromPayload(mergedPayload);
	      var url = _environment2.default.API_URL + ("/brokerage/export-bets?" + queryParams);
	      window.location.assign(url);
	    }
	  }]);
	  return BetOverviewApiService;
	}();
	
	exports.default = BetOverviewApiService;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Bet = exports.BetListing = exports.BET_STATUS_MAPPING = exports.BET_TYPE_MAPPING = exports.BET_SELECTION_MAPPING = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.makeBetListing = makeBetListing;
	exports.makeBet = makeBet;
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _date = __webpack_require__(1490);
	
	var _overview = __webpack_require__(1662);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BET_SELECTION_MAPPING = exports.BET_SELECTION_MAPPING = {
	  0: 'DRAW',
	  1: 'HOME',
	  2: 'AWAY',
	  3: 'UNDER',
	  4: 'OVER'
	};
	
	var BET_TYPE_MAPPING = exports.BET_TYPE_MAPPING = {
	  0: 'AHDP',
	  1: 'OU',
	  default: '1x2'
	};
	
	var BET_STATUS_MAPPING = exports.BET_STATUS_MAPPING = {
	  0: 'Voided',
	  1: 'Win',
	  2: 'Half Win',
	  3: 'Lose',
	  4: 'Half Lose',
	  5: 'Stake Returned'
	};
	
	function makeBetListing(payload) {
	  var bets = payload.data.map(function (bet) {
	    return makeBet(bet);
	  });
	  var total = payload.recordsTotal;
	
	  var betListing = new BetListing();
	  betListing.bets = bets;
	  betListing.total = payload.recordsTotal;
	
	  return betListing;
	}
	
	function makeBet(payload) {
	  var bet = new Bet();
	
	  bet.id = payload.id;
	  bet.eventDate = (0, _date.formatDate)(payload.event_date, 'MM/DD/YYYY');
	  bet.selection = +payload.betRequestType;
	  bet.handicap = +payload.handicap;
	  bet.bet = +payload.bet;
	  bet.betOption = payload.betOption;
	  bet.odds = (0, _overview.formatAmount)(payload.odds);
	  bet.stake = (0, _overview.formatAmount)(payload.stake);
	  bet.winLoss = (0, _overview.formatAmount)(payload.winLoss);
	  bet.home = payload.home;
	  bet.away = payload.away;
	  bet.halftimeBet = payload.halftimeBet;
	  bet.betType = +payload.betType;
	  bet.currentScore = payload.currentScore;
	  // Weird returns from api.
	  bet.status = +payload.result;
	
	  return bet;
	}
	
	var BetListing = exports.BetListing = function () {
	  function BetListing() {
	    (0, _classCallCheck3.default)(this, BetListing);
	
	    this._bets = [];
	    this._total = null;
	  }
	
	  (0, _createClass3.default)(BetListing, [{
	    key: 'bets',
	    set: function set(bets) {
	      this._bets = bets;
	    },
	    get: function get() {
	      return this._bets;
	    }
	  }, {
	    key: 'total',
	    set: function set(total) {
	      this._total = total;
	    },
	    get: function get() {
	      return this._total;
	    }
	  }]);
	  return BetListing;
	}();
	
	var Bet = exports.Bet = function () {
	  function Bet() {
	    (0, _classCallCheck3.default)(this, Bet);
	
	    this._id = null;
	    this._eventDate = null;
	    this._selection = null;
	    this._bet = null;
	    this._betOption = null;
	    this._odds = null;
	    this._stake = null;
	    this._winLoss = null;
	    this._status = null;
	    this._home = null;
	    this._away = null;
	    this._halftimeBet = null;
	    this._betType = null;
	    this._currentScore = null;
	    this._handicap = null;
	  }
	
	  (0, _createClass3.default)(Bet, [{
	    key: 'selectionHandicap',
	    value: function selectionHandicap() {
	      return 0 > this.betType ? '' : (0, _overview.formatAmount)(this.handicap);
	    }
	  }, {
	    key: 'id',
	    set: function set(id) {
	      this._id = id;
	    },
	    get: function get() {
	      return this._id;
	    }
	  }, {
	    key: 'eventDate',
	    set: function set(eventDate) {
	      this._eventDate = eventDate;
	    },
	    get: function get() {
	      return this._eventDate;
	    }
	  }, {
	    key: 'selection',
	    set: function set(selection) {
	      this._selection = selection;
	    },
	    get: function get() {
	      return this._selection;
	    }
	  }, {
	    key: 'bet',
	    set: function set(bet) {
	      this._bet = bet;
	    },
	    get: function get() {
	      return this._bet;
	    }
	  }, {
	    key: 'betOption',
	    set: function set(betOption) {
	      this._betOption = betOption;
	    },
	    get: function get() {
	      return this._betOption;
	    }
	  }, {
	    key: 'selectionAsText',
	    get: function get() {
	      var type = '';
	      if (this.selection === 0) {
	        switch (this.bet) {
	          case 0:
	            type = 'DRAW ';
	            break;
	          case 1:
	            type = 'HOME ';
	            break;
	          case 2:
	            type = 'AWAY ';
	            break;
	          case 3:
	            type = 'UNDER ';
	            break;
	          case 4:
	            type = 'OVER ';
	            break;
	        }
	
	        type = type + this.selectionHandicap();
	      };
	
	      var betOption = angular.fromJson(this.betOption);
	
	      if (this.selection === 1) {
	        type = betOption.special;
	      }
	
	      return type;
	    }
	  }, {
	    key: 'odds',
	    set: function set(odds) {
	      this._odds = odds;
	    },
	    get: function get() {
	      return this._odds;
	    }
	  }, {
	    key: 'stake',
	    set: function set(stake) {
	      this._stake = stake;
	    },
	    get: function get() {
	      return this._stake;
	    }
	  }, {
	    key: 'winLoss',
	    set: function set(winLoss) {
	      this._winLoss = winLoss;
	    },
	    get: function get() {
	      return this._winLoss;
	    }
	  }, {
	    key: 'status',
	    set: function set(status) {
	      this._status = status;
	    },
	    get: function get() {
	      return this._status;
	    }
	  }, {
	    key: 'statusAsText',
	    get: function get() {
	      return BET_STATUS_MAPPING[this.status];
	    }
	  }, {
	    key: 'home',
	    set: function set(home) {
	      this._home = home;
	    },
	    get: function get() {
	      return this._home;
	    }
	  }, {
	    key: 'away',
	    set: function set(away) {
	      this._away = away;
	    },
	    get: function get() {
	      return this._away;
	    }
	  }, {
	    key: 'halftimeBet',
	    set: function set(halftimeBet) {
	      this._halftimeBet = halftimeBet;
	    }
	  }, {
	    key: 'halfTimeBet',
	    get: function get() {
	      return this._halftimeBet;
	    }
	  }, {
	    key: 'halfFullTime',
	    get: function get() {
	      return !this._halftimeBet ? 'FT' : 'HT';
	    }
	  }, {
	    key: 'betType',
	    set: function set(betType) {
	      this._betType = betType;
	    },
	    get: function get() {
	      return this._betType;
	    }
	  }, {
	    key: 'betTypeAsText',
	    get: function get() {
	      return BET_TYPE_MAPPING[this._betType] || BET_TYPE_MAPPING['default'];
	    }
	  }, {
	    key: 'currentScore',
	    set: function set(currentScore) {
	      this._currentScore = currentScore;
	    },
	    get: function get() {
	      return this._currentScore;
	    }
	  }, {
	    key: 'handicap',
	    set: function set(handicap) {
	      this._handicap = handicap;
	    },
	    get: function get() {
	      return this._handicap;
	    }
	  }, {
	    key: 'details',
	    get: function get() {
	      switch (this.selection) {
	        case 0:
	          var texta = this.halfFullTime + '/' + this.betTypeAsText + ':';
	          var textb = ' ' + this.home + ' VS ' + this.away + ' ' + this.currentScore;
	
	          return '' + texta + textb;
	        case 1:
	          return this.home + ' VS ' + this.away;
	        default:
	          return this.away;
	      }
	    }
	  }]);
	  return Bet;
	}();

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BetOverviewListing = exports.BET_TYPES = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.formatAmount = formatAmount;
	exports.makeBetOverviewListing = makeBetOverviewListing;
	exports.makeLeagues = makeLeagues;
	
	var _numeral = __webpack_require__(1095);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BET_TYPES = exports.BET_TYPES = {
	  '-1': '1X2',
	  '0': 'AHDP',
	  '1': 'O/U',
	  '-2': 'Special Multiple'
	};
	
	function formatAmount(value) {
	  var sign = 0 > value ? '-' : '';
	  value = parseFloat(Math.abs(value).toFixed(4));
	  var count = value.toString().split('.')[1] ? value.toString().split('.')[1].length : 0;
	
	  switch (count) {
	    case 0:
	      value = sign + value + '.00';
	      break;
	    case 1:
	      value = sign + value + '0';
	      break;
	    default:
	      value = sign + value;
	      break;
	  }
	  var components = value.toString().split('.');
	  components[0] = components[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	
	  return components.join('.');
	}
	
	function makeBetOverviewListing(payload) {
	  var betOverviewListing = new BetOverviewListing();
	
	  var betOverview = {};
	  var total = {};
	
	  for (var key in payload.betOverview) {
	    var row = payload.betOverview[key];
	
	    if (row === null) {
	      continue;
	    }
	
	    betOverview[key] = {
	      averageOdds: formatAmount(row.averageOdds),
	      betType: BET_TYPES[row.betType + ""],
	      lossCount: row.lossCount,
	      numberOfBets: row.numberOfBets,
	      profit: formatAmount(row.profit),
	      pushCount: row.pushCount,
	      turnover: formatAmount(row.turnover),
	      validTurnover: formatAmount(row.validTurnover),
	      voidCount: row.voidCount,
	      winCount: row.winCount,
	      yield: formatAmount(row.profit / row.turnover * 100)
	    };
	  }
	
	  for (var _key in payload.total) {
	    var _row = payload.total;
	
	    total = {
	      averageOdds: formatAmount(_row.averageOdds),
	      betType: _row.betType,
	      lossCount: _row.lossCount,
	      numberOfBets: _row.numberOfBets,
	      profit: formatAmount(_row.profit),
	      pushCount: _row.pushCount,
	      turnover: formatAmount(_row.turnover),
	      validTurnover: formatAmount(_row.validTurnover),
	      voidCount: _row.voidCount,
	      winCount: _row.winCount,
	      yield: formatAmount(_row.profit / _row.turnover * 100)
	    };
	  }
	
	  betOverviewListing.betOverview = betOverview;
	  betOverviewListing.total = total;
	
	  return betOverviewListing;
	}
	
	// Just a reduce callback function
	function makeLeagues(accumulator, league) {
	  accumulator[league.id] = league.name;
	
	  return accumulator;
	}
	
	var BetOverviewListing = exports.BetOverviewListing = function () {
	  function BetOverviewListing() {
	    (0, _classCallCheck3.default)(this, BetOverviewListing);
	
	    this._betOverview = {};
	    this._total = {};
	  }
	
	  (0, _createClass3.default)(BetOverviewListing, [{
	    key: 'betOverview',
	    set: function set(betOverview) {
	      this._betOverview = betOverview;
	    },
	    get: function get() {
	      return this._betOverview;
	    }
	  }, {
	    key: 'total',
	    set: function set(total) {
	      this._total = total;
	    },
	    get: function get() {
	      return this._total;
	    }
	  }]);
	  return BetOverviewListing;
	}();

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentOptionApiService = undefined;
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _bitcoinRate = __webpack_require__(1220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentOptionApiService = exports.PaymentOptionApiService = function () {
	  PaymentOptionApiService.$inject = ["HttpService", "SessionService"];
	  function PaymentOptionApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PaymentOptionApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(PaymentOptionApiService, [{
	    key: 'getBitcoinAdjustment',
	    value: function getBitcoinAdjustment() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/payment-option/bitcoin-adjustment').then(function (payload) {
	        return _bitcoinRate.BitcoinRate.fromPayload(payload);
	      });
	    }
	  }, {
	    key: 'getBitcoinWithdrawalAdjustment',
	    value: function getBitcoinWithdrawalAdjustment() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/payment-option/bitcoin-withdrawal-adjustment').then(function (payload) {
	        return _bitcoinRate.BitcoinRate.fromWithdrawalAdjustmentPayload(payload);
	      });
	    }
	  }, {
	    key: 'getBankPaymentOption',
	    value: function getBankPaymentOption() {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/payment-option/bank');
	    }
	  }, {
	    key: 'getPaymentOptionById',
	    value: function getPaymentOptionById(id) {
	      return this.HttpService.get('/' + this.SessionService.getLocale() + '/payment-option/find/' + id);
	    }
	  }, {
	    key: 'linkBankAccountRequest',
	    value: function linkBankAccountRequest(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/payment-option/bank/create', payload);
	    }
	  }, {
	    key: 'updateBankAccountRequest',
	    value: function updateBankAccountRequest(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/payment-option/bank/update', payload);
	    }
	  }, {
	    key: 'deleteBankAccountRequest',
	    value: function deleteBankAccountRequest(payload) {
	      return this.HttpService.post('/' + this.SessionService.getLocale() + '/payment-option/bank/delete', payload);
	    }
	  }]);
	  return PaymentOptionApiService;
	}();
	
	exports.default = PaymentOptionApiService;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MemberProductApiService = function () {
	    MemberProductApiService.$inject = ["HttpService", "SessionService"];
	    function MemberProductApiService(HttpService, SessionService) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, MemberProductApiService);
	        this.HttpService = HttpService;
	        this.SessionService = SessionService;
	    }
	
	    (0, _createClass3.default)(MemberProductApiService, [{
	        key: 'request',
	        value: function request(payload) {
	            return this.HttpService.post('/' + this.SessionService.getLocale() + '/member/product/request', payload);
	        }
	    }]);
	    return MemberProductApiService;
	}();
	
	exports.default = MemberProductApiService;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TicketsApiService = function () {
	  TicketsApiService.$inject = ["HttpService"];
	  function TicketsApiService(HttpService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TicketsApiService);
	    this.HttpService = HttpService;
	  }
	
	  (0, _createClass3.default)(TicketsApiService, [{
	    key: 'tickets',
	    value: function tickets(payload) {
	      return this.HttpService.post('/customer/fetch/tickets', payload);
	    }
	  }, {
	    key: 'fetchTickets',
	    value: function fetchTickets() {
	      return this.HttpService.get('/zendesk/ticket');
	    }
	  }, {
	    key: 'fetchTicketDetails',
	    value: function fetchTicketDetails(payload) {
	      var queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
	      return this.HttpService.get('/zendesk/ticket-details?' + queryParams);
	    }
	  }, {
	    key: 'fetchTicketToken',
	    value: function fetchTicketToken() {
	      return this.HttpService.get('/zendesk/ticket-token');
	    }
	  }]);
	  return TicketsApiService;
	}();
	
	exports.default = TicketsApiService;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1044);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(419);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(420);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MemberRequestApiService = function () {
	  MemberRequestApiService.$inject = ["HttpService", "SessionService"];
	  function MemberRequestApiService(HttpService, SessionService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MemberRequestApiService);
	    this.HttpService = HttpService;
	    this.SessionService = SessionService;
	  }
	
	  (0, _createClass3.default)(MemberRequestApiService, [{
	    key: 'getMemberRequests',
	    value: function getMemberRequests() {
	      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var queryParams = '';
	      if ((0, _keys2.default)(payload).length > 0) {
	        queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
	      }
	
	      return this.HttpService.get('/' + this.SessionService.getLocale() + ('/member/request?' + queryParams));
	    }
	  }]);
	  return MemberRequestApiService;
	}();
	
	exports.default = MemberRequestApiService;

/***/ }),
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.en = en;
	function en() {
		return {
			'form': {
				'from': 'From',
				'to': 'To',
				'username': 'Username',
				'password': 'Password',
				'type': 'Type',
				'status': 'Status',
				'transactionPassword': 'Transaction Password',
				'confirmUsername': 'Confirm Username',
				'confirmPassword': 'Confirm Password',
				'confirmTransactionPassword': 'Confirm Transaction Password',
				'paymentOption': 'Payment Option',
				'fromProduct': 'From Product',
				'email': 'Email',
				'website': 'Website',
				'promotion': 'Promotion',
				'advertisement': 'Advertisement',
				'language': 'Language',
				'size': 'Size',
				'campaign': 'Campaign Name',
				'referralCode': 'Referral Code',
				'newPassword': 'New Password',
				'iban': 'Account Number/IBAN',
				'accountName': 'Account Name / Company Name',
				'birthDate': 'Date of Birth',
				'citizenship': 'Citizenship',
				'address': 'Address',
				'swift': 'Bank Code (BIC) / SWIFT',
				'bankName': 'Bank Name',
				'bankAddress': 'Bank Address',
				'isDefault': 'Use as default'
			},
			'titles': {
				'bankAccount': 'Bank Account',
				'dashboard': 'Dashboard',
				'account': 'My Account',
				'profile': 'My Profile',
				'transaction': 'Transactions',
				'transactionHistory': 'Transaction History',
				'overview': 'Overview',
				'deposit': 'Deposit',
				'withdrawal': 'Withdrawal',
				'transfer': 'Transfer',
				'productWallet': 'Transfer (Product Wallet)',
				'p2pTransfer': 'Transfer (Peer to Peer)',
				'skypeBetting': 'Skype Betting',
				'outstandingBets': 'Outstanding Bets',
				'betHistory': 'Bet History',
				'betOverview': 'Bet Overview',
				'affiliate': 'Affiliate',
				'affiliateDashboard': 'Affiliate Dashboard',
				'affiliateTools': 'Affiliate Tools',
				'supportTickets': 'Support Tickets',
				'settings': 'Settings',
				'mobileSite': 'AMS Mobite Site',
				'Valid Turnover/Commissions': 'Valid Turnover/Commissions',
				'products': 'Products',
				'size': 'Size',
				'campaign': 'Campaign Name',
				'referralCode': 'Referral Code',
				'website': 'Website',
				'tickets': 'Support Tickets'
			},
			'tables': {
				'product': 'Product',
				'memberId': 'Member ID',
				'totalTurnover': 'Total TO',
				'totalWinLoss': 'Total Customer W/L',
				'totalCommission': 'Affiliate Commission',
				'date': 'Date',
				'transactionNumber': 'Transaction #',
				'type': 'Type',
				'language': 'Language',
				'currency': 'Currency',
				'paymentOption': 'Payment Option',
				'amount': 'Amount',
				'status': 'Status',
				'Total Commission': 'Total Commission',
				'subject': 'Subject',
				'description': 'Description',
				'username': 'Username',
				'balance': 'Balance',
				'dateLastUpdated': 'Date Last Updated'
			},
			'Reset password': 'Reset password',
			'Activate Later': 'Activate Later',
			"You're on your way to earning a lifetime commission. Just follow 4 easy steps.": "You're on your way to earning a lifetime commission. Just follow 4 easy steps.",
			'I confirm that I have read and accepted': 'I confirm that I have read and accepted',
			'Asianconnect Affiliates Terms and Conditions': 'Asianconnect Affiliates Terms and Conditions',
			'Get Started': 'Get Started',
			'Banners and Referral Codes': 'Banners and Referral Codes',
			'Learn more': 'Learn more',
			'Archive': 'Archive',
			'generateBannerNote': 'Simply fill out the form with the details of your campaign and we\'ll generate a unique referral link and a downloadable banner for you.',
			'Setup your username and password now': 'Setup your username and password now',
			'Welcome to AC Affiliates!': 'Welcome to AC Affiliates!',
			'Please enter your Campaign Name': 'Please enter your Campaign Name',
			'Please enter your Referral Code': 'Please enter your Referral Code',
			'Get code': 'Get code',
			'Reset': 'Reset',
			'Generate': 'Generate',
			'referralCodeNote': 'You can reuse your existing Referral Code URL or create a new one. Special characters and spaces are not allowed.',
			'Special characters and spaces are not allowed.': 'Special characters and spaces are not allowed.',
			'See Preview': 'See Preview',
			'Preview': 'Preview',
			'Please enter your website URL': 'Please enter your website URL',
			'Please contact Customer Support.': 'Please contact Customer Support.',
			'Change email': 'Change email',
			'Transfer from': 'Transfer from',
			'Transfer to': 'Transfer to',
			'Product': 'Product',
			'Please Select': 'Please Select',
			'Commission Period': 'Commission Period',
			'Original Payout Date': 'Original Payout Date',
			'to': 'to',
			'Reason': 'Reason',
			'commission': 'commission',
			'Search': 'Search',
			'Reset Filter': 'Reset Filter',
			'All Status': 'All Status',
			'Product Username': 'Product Username',
			'All Payment Options': 'All Payment Options',
			'All types': 'All types',
			'Sign In': 'Sign In',
			'Sign in to start your session': 'Sign in to start your session',
			'Please wait, Logging in...': 'Please wait, Logging in...',
			'signOut': 'Sign out',
			'memberSince': 'Member Since',
			'Note:': 'Note:',
			'Note': 'Note',
			'makeDeposit': 'Make a deposit to increase your funds.',
			'welcome': 'Welcome to Asianconnect Member Site!',
			'setup': 'Setup your username and password now',
			'to activate your account.': 'to activate your account.',
			'setupNote': 'Note: Your temporary username and password was sent to your email.',
			'Proceed': 'Proceed',
			'Deposit Now': 'Deposit Now',
			'Available Balance': 'Available Balance',
			'Unallocated Balance': 'Unallocated Balance',
			'Account Status': 'Account Status',
			'Quick Links': 'Quick Links',
			'BETA': 'BETA',
			'Verified': 'Verified',
			'Not Verified': 'Not Verified',
			'Filter': 'Filter',
			'Request Transfer': 'Request Transfer',
			'loadingPageContent': 'Loading page content, please wait...',
			'Date Covered:': 'Date Covered:',
			'Total Turnover:': 'Total Turnover:',
			'Total Affiliate Commission:': 'Total Affiliate Commission:',
			'Total Customer W/L:': 'Total Customer W/L:',
			'exportCsv': 'Export as CSV',
			'noProduct': 'No Product',
			'somethingWentWrong': 'Something went wrong. Please check your details.',
			'activated': 'You have successfully activated your account.',
			'Account Activation': 'Account Activation',
			'activateAccountNote': 'Activate your account by filling out your credentials below.',
			'usernameValidation': 'Must contain letters, numbers and underscore only.',
			'passwordValidation': 'Must be least 8 characters, contain at least 2 letters, 2 digits and 2 symbols.',
			'transactionPasswordValidation': 'Must be alpha numeric, min 6 chars and should have at least 1 capital letter.',
			'Re-enter username': 'Re-enter username',
			'Re-enter password': 'Re-enter password',
			'Re-enter transaction password': 'Re-enter transaction password',
			'Activate account': 'Activate account',
			'Clear All': 'Clear All',
			'skrillContent': 'Please login to your SKRILL account and transfer the requested funds to ',
			'netellerContent': 'Please login to your NETELLER account and transfer the requested funds to ',
			'verifyDeposit': 'We are now verifying your deposit. Once we received your deposit, you will see the additional funds reflected in your account.',
			'netellerTransferNote': 'Please login to your NETELLER account and transfer the requested funds to ',
			'netellerTransferNote2': 'with transfer code of ',
			'you will see the additional funds reflected in your account.': 'you will see the additional funds reflected in your account.',
			'CONTINUE': 'CONTINUE',
			'cantProcessRequest': "Sorry We've not been able to process your request at this time",
			'Sorry': 'Sorry',
			'Thank you': 'Thank you',
			'OK': 'OK',
			'For making a deposit': 'For making a deposit',
			'We are now verifying your deposit. Once we have received your deposit,': 'We are now verifying your deposit. Once we have received your deposit,',
			'bankNotice': 'Bank transactions are not possible as of the moment. For inquiries, please contact customer support. Thank you.',
			'bankRestricted': 'Bank transaction is restricted in your country. Please use other payment methods.',
			'processingTime': 'Processing time',
			'fee': 'Fee',
			'minimumDeposit': 'Minimum Deposit Amount',
			'maximumDeposit': 'Maximum Deposit Amount',
			'chooseProductDeposit': 'Simply choose your preferred product (bookie), enter the amount then click the Request Deposit.',
			'Product Name': 'Product Name',
			'Amount': 'Amount',
			'fileValidation': 'Only jpg, jpeg and png file with maximum of 2 MB is allowed.',
			'Transaction Summary': 'Transaction Summary',
			'Total amount to be deposited in your account': 'Total amount to be deposited in your account',
			'Total amount to be sent in your account': 'Total amount to be sent in your account',
			'You have submitted the BTC deposit request form.': 'You have submitted the BTC deposit request form.',
			'Please send the BTC amount to the BTC address below. This address is unique to your account.': 'Please send the BTC amount to the BTC address below. This address is unique to your account.',
			'Tap or Scan to pay': 'Tap or Scan to pay',
			'Show QR': 'Show QR',
			'Total BTC to be sent': 'Total BTC to be sent',
			'Recipient BTC Address': 'Recipient BTC Address',
			'Please send total BTC to the recipient address.': 'Please send total BTC to the recipient address.',
			'Copy': 'Copy',
			'Rate Used per BTC': 'Rate Used per BTC',
			'Please send bitcoin in': 'Please send bitcoin in',
			'minutes.': 'minutes.',
			'This page will automatically refresh when Bitcoin has been sent.': 'This page will automatically refresh when Bitcoin has been sent.',
			'Thank you for sending the requested amount!': 'Thank you for sending the requested amount!',
			'We are now waiting for your Bitcoin confirmations.': 'We are now waiting for your Bitcoin confirmations.',
			'confirmation(s) received': 'confirmation(s) received',
			'Status': 'Status',
			'Thank you for making a deposit!': 'Thank you for making a deposit!',
			'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.': 'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.',
			'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.': 'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.',
			'Requested: waiting to receive bitcoin': 'Requested: waiting to receive bitcoin',
			'Note: Please contact Support if you made a request by mistake and would like to request again': 'Note: Please contact Support if you made a request by mistake and would like to request again',
			'bitcoinDeclined': "Sorry, your request was DECLINED probably because we did not receive the bitcoin. If this is a mistake, please contact Support and we'll assist you right away.",
			'Close': 'Close',
			'Exchange Rate': 'Exchange Rate',
			'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.': 'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.',
			'Total BTC amount to send:': 'Total BTC amount to send:',
			'Total EUR amount to receive:': 'Total EUR amount to receive:',
			'Transaction Status': 'Transaction Status',
			'Requested': 'Requested',
			'Pending Confirmation': 'Pending Confirmation',
			'Confirmed': 'Confirmed',
			'Declined': 'Declined',
			'Voided': 'Voided',
			'Account ID': 'Account ID',
			'Amount to deposit': 'Amount to deposit',
			'Total amount to deposit': 'Total amount to deposit',
			'Free': 'Free',
			'Add product': 'Add product',
			'Make new request': 'Make new request',
			'we will send you the username and password of your newly registered account.': 'we will send you the username and password of your newly registered account.',
			'Total amount to be deposited on account': 'Total amount to be deposited on account',
			'Total amount to be deducted from account': 'Total amount to be deducted from account',
			'Total amount to be sent': 'Total amount to be sent',
			'Total amount to be received': 'Total amount to be received',
			'Enter product username': 'Enter product username',
			'Total amount to send': 'Total amount to send',
			'Request is successfully created!': 'Request is successfully created!',
			'Please wait for customer service confirmation. You can view transaction status in Transactions overview.': 'Please wait for customer service confirmation. You can view transaction status in Transactions overview.',
			'Unable to Transfer': 'Unable to Transfer',
			'Please contact our customer service team to have your account verified. Thank you.': 'Please contact our customer service team to have your account verified. Thank you.',
			'No product(s) available for selection.': 'No product(s) available for selection.',
			'Opps, amount is not enough!': 'Opps, amount is not enough!',
			'Minimum amount that can be withdrawn is 100 EUR/GBP.': 'Minimum amount that can be withdrawn is 100 EUR/GBP.',
			'Do you want ': 'Do you want ',
			'to be your default bank for withdrawal?': 'to be your default bank for withdrawal?',
			'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.': 'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.',
			'Minimum Withdrawal Amount': 'Minimum Withdrawal Amount',
			'Maximum Withdrawal Amount': 'Maximum Withdrawal Amount',
			'Bank Account': 'Bank Account',
			'Link new bank account': 'Link new bank account',
			'transactionPasswordHint': 'Hint: If you have been an existing customer since March 2017 and haven\'t set your transaction password, this is your answer to the security question: What is your dream job?',
			'Beneficiary name': 'Beneficiary name',
			'Beneficiary address': 'Beneficiary address',
			'IBAN': 'IBAN',
			'Bank name': 'Bank name',
			'Bank address': 'Bank address',
			'SWIFT': 'SWIFT',
			'Total amount to be deducted from your account': 'Total amount to be deducted from your account',
			'Total amount to be received in your account': 'Total amount to be received in your account',
			'Confirmation Message': 'Confirmation Message',
			'Yes': 'Yes',
			'No': 'No',
			'confirmations': 'confirmations',
			'Please select product(s) where you want to withdraw, and input the amount in': 'Please select product(s) where you want to withdraw, and input the amount in',
			'or BTC': 'or BTC',
			'Total BTC': 'Total BTC',
			'SEND TO': 'SEND TO',
			'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.': 'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.',
			'Total BTC amount to receive': 'Total BTC amount to receive',
			'Total': 'Total',
			'amount to be deducted': 'amount to be deducted',
			'Amount to deduct': 'Amount to deduct',
			'Total amount to receive': 'Total amount to receive',
			'Opps, we need to know where to wire your funds.': 'Opps, we need to know where to wire your funds.',
			'Please fill in the required bank details. Thank you!': 'Please fill in the required bank details. Thank you!',
			'Unable to withdraw': 'Unable to withdraw',
			'Invalid Action!': 'Invalid Action!',
			'A product where the fee should be charged is required.': 'A product where the fee should be charged is required.',
			'Reset link was sent to your email.': 'Reset link was sent to your email.',
			'Success!': 'Success!',
			'Send reset password link': 'Send reset password link',
			"Enter the email you use for Asianconnect88, and we'll help you create a new password.": "Enter the email you use for Asianconnect88, and we'll help you create a new password.",
			'English': 'English',
			'French': 'French',
			'German': 'German',
			'Spanish': 'Spanish',
			'Asian Odds': 'Asian Odds',
			'Note: Referral URL is your unique link where you can share to everyone': 'Note: Referral URL is your unique link where you can share to everyone',
			'Referral HTML Code': 'Referral HTML Code',
			'copyReferralCodeNote': 'Simply copy, or download the HTML code of your campaign and paste in on the section where you wish the banner to be displayed on your website.',
			'Download HTML': 'Download HTML',
			'Terms and Conditions': 'Terms and Conditions',
			'and': 'and',
			'Commission Scheme': 'Commission Scheme',
			'apply': 'apply',
			'Referral URL': 'Referral URL',
			'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.': 'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.',
			'Information': 'Information',
			'Get a unique tracking link for your campaign.': 'Get a unique tracking link for your campaign.',
			'Website. Input your website URL.': 'Website. Input your website URL.',
			'Banner type. Pick a banner type: (language/size/promo)': 'Banner type. Pick a banner type: (language/size/promo)',
			'Campaign. Name your campaign.': 'Campaign. Name your campaign.',
			'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.': 'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.',
			'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.': 'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.',
			'campaignNote': 'Simply copy, or download the HTML code of your campaign and paste it on the section where you wish the banner to be displayed on your website.',
			'Preview archived banner': 'Preview archived banner',
			'Uploaded': 'Uploaded',
			'Drag and drop files here or': 'Drag and drop files here or',
			'Select file(s)': 'Select file(s)',
			'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.': 'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.',
			'file(s) selected. Click upload to proceed.': 'file(s) selected. Click upload to proceed.',
			'The file is too large (MB). Allowed maximum size is 2MB.': 'The file is too large (MB). Allowed maximum size is 2MB.',
			'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.': 'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.',
			'Successfully uploaded!': 'Successfully uploaded!',
			'Documents uploaded': 'Documents uploaded',
			'Delete Document': 'Delete Document',
			'Are you sure you want to delete this document?': 'Are you sure you want to delete this document?',
			'Cancel': 'Cancel',
			'Delete': 'Delete',
			'Account Information': 'Account Information',
			'Customer ID': 'Customer ID',
			'Full name': 'Full name',
			'Currency': 'Currency',
			'Country': 'Country',
			'Date of birth': 'Date of birth',
			'Join date': 'Join date',
			'Email Address': 'Email Address',
			'Phone number': 'Phone number',
			'Skype': 'Skype',
			'Username': 'Username',
			'K.Y.C documents': 'K.Y.C documents',
			'Password changed.': 'Password changed.',
			'I want to request a new reset code.': 'I want to request a new reset code.',
			'Loading, please wait...': 'Loading, please wait...',
			'Request new reset code?': 'Request new reset code?',
			'Enter your new account password below.': 'Enter your new account password below.',
			'Account password has been successfully updated!': 'Account password has been successfully updated!',
			'Update AMS account password': 'Update AMS account password',
			'Current AMS password': 'Current AMS password',
			'New AMS Password': 'New AMS Password',
			'Enter current password': 'Enter current password',
			'Enter new password': 'Enter new password',
			'Confirm new password': 'Confirm new password',
			'Update': 'Update',
			'Are you sure you want to delete this Bank Account?': 'Are you sure you want to delete this Bank Account?',
			'Add bank accounts for faster transaction.': 'Add bank accounts for faster transaction.',
			'Default': 'Default',
			'Link a new bank account': 'Link a new bank account',
			'Bank account successfully deleted.': 'Bank account successfully deleted.',
			'Success': 'Success',
			'Transaction password has been successfully updated!': 'Transaction password has been successfully updated!',
			'Update AMS transaction password': 'Update AMS transaction password',
			'Current AMS transaction password': 'Current AMS transaction password',
			'Enter current transaction password': 'Enter current transaction password',
			'New AMS transaction password': 'New AMS transaction password',
			'Enter new transaction password': 'Enter new transaction password',
			'Confirm new transaction password': 'Confirm new transaction password',
			'Account username has been successfully updated!': 'Account username has been successfully updated!',
			'Update AMS username': 'Update AMS username',
			'Current AMS username': 'Current AMS username',
			'New AMS username': 'New AMS username',
			'Enter new username': 'Enter new username',
			'Confirm new username': 'Confirm new username',
			'Enter password': 'Enter password',
			'Security': 'Security',
			'Update your Username, Account and Transaction Password': 'Update your Username, Account and Transaction Password',
			'Temporarily Unavailable': 'Temporarily Unavailable',
			'For inquiries, please contact Customer Support.': 'For inquiries, please contact Customer Support.',
			'Payment Option': 'Payment Option',
			'Manage your payment accounts': 'Manage your payment accounts',
			'Open': 'Open',
			'Pending': 'Pending',
			'Resolved': 'Resolved',
			'Closed': 'Closed',
			'Forbidden!': 'Forbidden!',
			'My Products': 'My Products',
			'Add Product': 'Add Product',
			'Reset Product Password': 'Reset Product Password',
			'New': 'New',
			'Bank account successfully created.': 'Bank account successfully created.',
			'Link a bank account': 'Link a bank account',
			'Enter Account Number': 'Enter Account Number',
			'Enter Account Name': 'Enter Account Name',
			'Enter Citizenship': 'Enter Citizenship',
			'Enter Address': 'Enter Address',
			'Enter Bank Code': 'Enter Bank Code',
			'Enter Bank Name': 'Enter Bank Name',
			'Enter Bank Address': 'Enter Bank Address',
			'Save bank account': 'Save bank account',
			'Save': 'Save',
			'Limit Reached!': 'Limit Reached!',
			'Go to Settings': 'Go to Settings',
			'Product password successfully requested.': 'Product password successfully requested.',
			'Warning': 'Warning',
			'Something went wrong. Please try again later.': 'Something went wrong. Please try again later.',
			'Request Product Password': 'Request Product Password',
			'Select one or more products to reset password': 'Select one or more products to reset password',
			'View Password': 'View Password',
			'Expires on': 'Expires on',
			'Expired Password': 'Expired Password',
			'No Password': 'No Password',
			'Enter Transaction Password': 'Enter Transaction Password',
			'Request': 'Request',
			'Product password will be available once password has been reset.': 'Product password will be available once password has been reset.',
			'Warning!': 'Warning!',
			'Warning! The following product/s has pending request': 'Warning! The following product/s has pending request',
			'Request Product': 'Request Product',
			'Please select at least one product below': 'Please select at least one product below',
			'No products available. You already have all the products Asianconnect offers.': 'No products available. You already have all the products Asianconnect offers.',
			'username': 'username',
			'SINGBET FORCED POSITION TAKING ON ASIANCONNECT': 'SINGBET FORCED POSITION TAKING ON ASIANCONNECT',
			'Profit and Loss (PnL)': 'Profit and Loss (PnL)',
			'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.': 'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.',
			'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).': 'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).',
			'Then if you lose, you only lose 400 EUR/GBP.': 'Then if you lose, you only lose 400 EUR/GBP.',
			'Deposits': 'Deposits',
			'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.': 'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.',
			'Withdrawals': 'Withdrawals',
			'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.': 'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.',
			'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.': 'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.',
			'I agree to the Terms and Conditions': 'I agree to the Terms and Conditions',
			'MAXBET FORCED POSITION TAKING ON ASIANCONNECT': 'MAXBET FORCED POSITION TAKING ON ASIANCONNECT',
			'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.': 'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.',
			'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).': 'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).',
			'Then if you lose, you only lose 500 EUR/GBP.': 'Then if you lose, you only lose 500 EUR/GBP.',
			'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.': 'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.',
			'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.': 'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.',
			'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.': 'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.',
			'SBOBET Forced Position Taking ON ASIANCONNECT': 'SBOBET Forced Position Taking ON ASIANCONNECT',
			'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.': 'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.',
			'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.',
			'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.',
			'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.': 'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.',
			'9WICKETS FORCED POSITION TAKING ON ASIANCONNECT': '9WICKETS FORCED POSITION TAKING ON ASIANCONNECT',
			'Please note that 9wickets have 3% commission rate applied to your winnings.': 'Please note that 9wickets have 3% commission rate applied to your winnings.',
			'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.': 'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.',
			'ORBITX FORCED POSITION TAKING ON ASIANCONNECT': 'ORBITX FORCED POSITION TAKING ON ASIANCONNECT',
			'Please note that OrbitX have 3% commission rate applied to your winnings.': 'Please note that OrbitX have 3% commission rate applied to your winnings.',
			'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.': 'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.',
			'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT': 'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT',
			'You can contact us via Skype at': 'You can contact us via Skype at',
			'NV for Skype betting Terms and Conditions.': 'NV for Skype betting Terms and Conditions.',
			'Successfully added!': 'Successfully added!',
			'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.': 'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.',
			'About Us': 'About Us',
			'Contact Us': 'Contact Us',
			'Legal Disclaimer': 'Legal Disclaimer',
			'Privacy Policy': 'Privacy Policy',
			'Go To Transaction Overview': 'Go To Transaction Overview',
			'Notification': 'Notification',
			'was deleted.': 'was deleted.',
			'Failed to delete': 'Failed to delete',
			'file has been uploaded.': 'file has been uploaded.',
			'Failed to upload': 'Failed to upload',
			'Paste an address where you want to receive BTC': 'Paste an address where you want to receive BTC',
			'New referral': 'New referral',
			'has been linked.': 'has been linked.',
			'Referral': 'Referral',
			'has been unlinked.': 'has been unlinked.',
			'Product/s': 'Product/s',
			'has been added.': 'has been added.',
			'Transaction': 'Transaction',
			'has been': 'has been',
			'Deposit': 'Deposit',
			'Withdraw': 'Withdraw',
			'Transfer': 'Transfer',
			'P2P Transfer': 'P2P Transfer',
			'Approved': 'Approved',
			'Acknowledged': 'Acknowledged',
			'Processed': 'Processed',
			'Saved': 'Saved',
			'Invalid Credentials!': 'Invalid Credentials!',
			'Email': 'Email',
			'Name': 'Name',
			'Request Deposit': 'Request Deposit',
			'Request Withdrawal': 'Request Withdrawal',
			'Upload': 'Upload',
			'W/L': 'W/L',
			'Bonus': 'Bonus',
			'Revenue Share': 'Revenue Share',
			'Total W/L:': 'Total W/L:',
			'Total Bonus:': 'Total Bonus:',
			'Total Revenue Share:': 'Total Revenue Share:',
			'Unlimited': 'Unlimited',
			'Instant': 'Instantané',
			'My Tickets': 'My Tickets',
			'Product is required': 'Product is required',
			'Transaction password invalid': 'Transaction password invalid',
			'Transaction deposit has been saved': 'Transaction deposit has been saved',
			'Product has been added': 'Product has been added',
			'Transaction withdrawal has been saved': 'Transaction withdrawal has been saved',
			'Transaction transfer has been saved': 'Transaction transfer has been saved',
			'Transaction deposit has been declined': 'Transaction deposit has been declined',
			'Transaction withdrawal has been declined': 'Transaction withdrawal has been declined',
			'Transaction transfer has been declined': 'Transaction transfer has been declined',
			'Transaction deposit has been voided': 'Transaction deposit has been voided',
			'Transaction withdrawal has been voided': 'Transaction withdrawal has been voided',
			'Transaction transfer has been voided': 'Transaction transfer has been voided',
			'Documents uploaded:': 'Documents uploaded:',
			'Warning! At least one product is required.': 'Warning! At least one product is required.',
			'paymentOptionsViewDetails': 'Important: After making a deposit, fill out this area. Failure to do so will make your deposit invalid. This is to alert us of your deposit transaction so we can verify if your deposit has already reflected on your account.',
			'File(s) still uploading, please wait.': 'File(s) still uploading, please wait.',
			'DEPOSIT': 'DEPOSIT',
			'WITHDRAWAL': 'WITHDRAWAL',
			'TRANSFER': 'TRANSFER',
			'BONUS': 'BONUS',
			'PSP TRANSFER': 'PSP TRANSFER',
			'COMMISSION': 'COMMISSION',
			'DEBIT': 'DEBIT',
			'CREDIT': 'CREDIT',
			'REVENUE SHARE': 'REVENUE SHARE',
			'RESET BOOKIE PASSWORD': 'RESET BOOKIE PASSWORD',
			'Ecopayz Merchant Account (EUR)': 'Ecopayz Merchant Account (EUR)'
	
		};
	}

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(1673);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.de = de;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function de() {
	  var _ref;
	
	  return _ref = {
	    'form': {
	      'from': 'Von',
	      'to': 'Zu',
	      'username': 'Nutzername',
	      'password': 'Passwort',
	      'type': 'Art',
	      'status': 'Status',
	      'transactionPassword': 'Transaktionspasswort',
	      'confirmUsername': 'Benutzername bestätigen',
	      'confirmPassword': 'Passwort bestätigen',
	      'confirmTransactionPassword': 'Transaktionspasswort bestätigen',
	      'paymentOption': 'Zahlungsoption',
	      'fromProduct': 'Von Produkt',
	      'email': 'E-Mail',
	      'website': 'Webseite',
	      'promotion': 'Promotion',
	      'advertisement': 'Werbeanzeige',
	      'language': 'Sprache',
	      'size': 'Größe',
	      'campaign': 'Name der Kampagne',
	      'referralCode': 'Referral Code',
	      'newPassword': 'Neues Passwort',
	      'iban': 'Kontonummer/IBAN',
	      'accountName': 'Name des Kontoinhabers / Firmenname',
	      'birthDate': 'Geburtstag',
	      'citizenship': 'Staatsangehörigkeit',
	      'address': 'Address',
	      'swift': 'Bankleitzahl (BIC) / SWIFT',
	      'bankName': 'Name der Bank',
	      'bankAddress': 'Adresse der Bank',
	      'isDefault': 'Als Standard benutzen'
	    },
	    'titles': {
	      'bankAccount': 'Bankkonto',
	      'dashboard': 'Dashboard',
	      'account': 'Mein Konto',
	      'profile': 'Mein Profil',
	      'transaction': 'Transaktionen',
	      'transactionHistory': 'Transaktionsverlauf',
	      'overview': 'Übersicht',
	      'deposit': 'Einzahlung',
	      'withdrawal': 'Auszahlung',
	      'transfer': 'Überweisung',
	      'productWallet': 'Überweisung (von/zu Produkt)',
	      'p2pTransfer': 'Überweisung (Peer to Peer)',
	      'skypeBetting': 'Skype Betting',
	      'outstandingBets': 'Offene Wetten',
	      'betHistory': 'Wettverlauf',
	      'betOverview': 'Wettübersicht',
	      'affiliate': 'Affiliate',
	      'affiliateDashboard': 'Affiliate Dashboard',
	      'affiliateTools': 'Affiliate Tools',
	      'supportTickets': 'Support Tickets',
	      'settings': 'Einstellungen',
	      'mobileSite': 'AMS Mobile Webseite',
	      'Valid Turnover/Commissions': 'Gültiger Umsatz/Kommission',
	      'products': 'Produkte',
	      'size': 'Größe',
	      'campaign': 'Name der Kampagne',
	      'referralCode': 'Referral Code',
	      'website': 'Webseite',
	      'tickets': 'Support Tickets'
	    },
	    'tables': {
	      'product': 'Produkt',
	      'memberId': 'Member ID',
	      'totalTurnover': 'Gesamtumsatz',
	      'totalWinLoss': 'Gesamt Profit/Verlust der Kunden',
	      'totalCommission': 'Affiliate Kommission',
	      'date': 'Datum',
	      'transactionNumber': 'Transaktionsnummer',
	      'type': 'Art',
	      'language': 'Sprache',
	      'currency': 'Währung',
	      'paymentOption': 'Zahlungsoption',
	      'amount': 'Betrag',
	      'status': 'Status',
	      'Total Commission': 'Gesamte Kommission',
	      'subject': 'Betreff',
	      'description': 'Beschreibung',
	      'username': 'Nutzername',
	      'balance': 'Kontostand',
	      'dateLastUpdated': 'Zuletzt aktualisiert am'
	    },
	    'Reset password': 'Passwort zurücksetzen',
	    'Activate Later': 'Später aktivieren',
	    "You're on your way to earning a lifetime commission. Just follow 4 easy steps.": "Du bist auf dem Weg eine lebenslange Kommission zu verdienen, folge einfach diesen 4 einfachen Schritten",
	    'I confirm that I have read and accepted': 'Ich bestätige, dass ich dies gelesen und akzeptiert habe',
	    'Asianconnect Affiliates Terms and Conditions': 'Asianconnect Affilliate Geschäftsbedingungen',
	    'Get Started': 'Lege los',
	    'Banners and Referral Codes': 'Banners and Referral Codes',
	    'Learn more': 'Erfahre mehr',
	    'Archive': 'Archiv',
	    'generateBannerNote': 'Fülle das Formular mit deinen Kampagnendetails aus und wir werden dir einen eigenen Referral Code und einen herunterladbaren Banner erstellen.',
	    'Setup your username and password now': 'Erstelle jetzt deinen Benutzernamen und dein Passwort',
	    'Welcome to AC Affiliates!': 'Herzlich Willkommen zu AC Affilliates!!',
	    'Please enter your Campaign Name': 'Bitte gebe den Namen deiner Kampagne ein',
	    'Please enter your Referral Code': 'Bitte gebe deinen Referral Code ein',
	    'Get code': 'Code abrufen',
	    'Reset': 'Zurücksetzen',
	    'Generate': 'Generieren',
	    'referralCodeNote': 'Du kannst deinen existierenden Referral Code benutzen oder einen neuen erstellen. Sonder und Leerzeichen sind nicht erlaubt.',
	    'Special characters and spaces are not allowed.': 'Sonder und Leerzeichen sind nicht erlaubt.',
	    'See Preview': 'Siehe Vorschau',
	    'Preview': 'Vorschau',
	    'Please enter your website URL': 'Bitte gebe die URL deiner Webseite ein',
	    'Please contact Customer Support.': 'Bitte kontaktiere den Kundensupport.',
	    'Change email': 'E-Mail ändern',
	    'Transfer from': 'Überweisung von',
	    'Transfer to': 'Überweisung zu',
	    'Product': 'Produkt',
	    'Please Select': 'Bitte auswählen',
	    'Commission Period': 'Kommission Zeitraum',
	    'Original Payout Date': 'Originaler Auszahlungstag',
	    'to': 'zu',
	    'Reason': 'Grund',
	    'commission': 'kommission',
	    'Search': 'Suche',
	    'Reset Filter': 'Filter zurücksetzen',
	    'All Status': 'Alle Statuse',
	    'Product Username': 'Produkt Benutzername',
	    'All Payment Options': 'Alle Zahlungsoptionen',
	    'All types': 'Alle Arten',
	    'Sign In': 'Anmelden',
	    'Sign in to start your session': 'Anmelden um die Session zu starten',
	    'Please wait, Logging in...': 'Bitte warten, Anmeldung erfolgt…',
	    'signOut': 'Abmelden',
	    'memberSince': 'Kunde seit',
	    'Note:': 'Anmerkung:',
	    'Note': 'Anmerkung',
	    'makeDeposit': 'Tätige eine Einzahlung um dein Guthaben zu erhöhen',
	    'welcome': 'Welcome to Asianconnect Member Site!',
	    'setup': 'Erstelle jetzt deinen Benutzernamen und dein Passwort',
	    'to activate your account.': 'um dein Konto zu aktivieren.',
	    'setupNote': 'Anmerkung: Dein temporärer Benutzername und Passwort wurden an deine E-Mail Adresse gesendet.',
	    'Proceed': 'Fortfahren',
	    'Deposit Now': 'Jetzt einzahlen',
	    'Available Balance': 'Verfügbares Guthaben',
	    'Unallocated Balance': 'Nicht zugewiesenes Guthaben',
	    'Account Status': 'Kontostatus',
	    'Quick Links': 'Quick Links',
	    'BETA': 'BETA',
	    'Verified': 'Verifiziert',
	    'Not Verified': 'Nicht verifiziert',
	    'Filter': 'Filter zurücksetzen',
	    'Request Transfer': 'Überweisung anfordern',
	    'loadingPageContent': 'Lade Seiteninhalt, bitte warten…',
	    'Date Covered:': 'Erfassungsdatum',
	    'Total Turnover:': 'Gesamtumsatz:',
	    'Total Affiliate Commission:': 'Gesamte Affilliate Kommission:',
	    'Total Customer W/L:': 'Gesamt Profit/Verlust der Kunden:',
	    'exportCsv': 'Als CSV exportieren',
	    'noProduct': 'Kein Produkt',
	    'somethingWentWrong': 'Es gab einen Fehler. Bitte überprüfe deine Angaben.',
	    'activated': 'Du hast dein Konto erfolgreich aktiviert.',
	    'Account Activation': 'Kontoaktivierung',
	    'activateAccountNote': 'Um dein Konto zu aktivieren fülle das unten stehende Formular aus.',
	    'usernameValidation': 'Darf nur Buchstaben, Nummern und Unterstrich enthalten.',
	    'passwordValidation': 'Mindestens 8 Zeichen, mit mindestens 2 Buchstaben, 2 Zahlen und 2 Symbolen.',
	    'transactionPasswordValidation': 'Muss alphanumerisch mindestens 6 Zeichen und einen Großbuchstaben enthalten.',
	    'Re-enter username': 'Benutzernamen erneut eingeben',
	    'Re-enter password': 'Passwort erneut eingeben',
	    'Re-enter transaction password': 'Transaktionspasswort erneut eingeben',
	    'Activate account': 'Konto aktivieren',
	    'Clear All': 'Alles löschen',
	    'skrillContent': 'Bitte melde dich bei Skrill an und überweise den Zahlungsbetrag an ',
	    'netellerContent': 'Bitte melde dich bei Neteller an und überweise den Zahlungsbetrag an ',
	    'verifyDeposit': 'Wir verifizieren nun die Einzahlung. Sobald wir diese erhalten haben wird die Einzahlung in deinem Konto angezeigt.',
	    'netellerTransferNote': 'Please login to your NETELLER account and transfer the requested funds to ',
	    'netellerTransferNote2': 'mit folgendem Transaktionscode',
	    'you will see the additional funds reflected in your account.': 'wirst du das hinzugefügte Guthaben in deinem Konto einsehen können',
	    'CONTINUE': 'Fortfahren',
	    'cantProcessRequest': "Entschuldigung, wir sind aktuell nicht in der Lage die Anfrage zu bearbeiten",
	    'Sorry': 'Entschuldigung',
	    'Thank you': 'Vielen Dank',
	    'OK': 'OK',
	    'For making a deposit': 'Für die Einzahlung',
	    'We are now verifying your deposit. Once we have received your deposit,': 'We are now verifying your deposit. Once we have received your deposit,',
	    'bankNotice': 'Banküberweisung ist aktuell nicht verfügbar. Bei Anfragen bitte den Kundendienst kontaktieren. Vielen Dank.',
	    'bankRestricted': 'Banküberweisung ist in deinem Land nicht verfügbar. Bitte nutze andere Zahlungsoptionen.',
	    'processingTime': 'Bearbeitungszeit',
	    'fee': 'Gebühr',
	    'minimumDeposit': 'Mindesteinzahlungsbetrag',
	    'maximumDeposit': 'Maximaleinzahlungsbetrag',
	    'chooseProductDeposit': 'Wähle dein bevorzugtes Produkt (Bookie) aus und gebe den gewünschten Einzahlungsbetrag ein.',
	    'Product Name': 'Produktname',
	    'Amount': 'Betrag',
	    'fileValidation': 'Nur jpg jpeg und png Dateien mit einer maximalen Größe von 2 MB erlaubt.',
	    'Transaction Summary': 'Transaktionsübersicht',
	    'Total amount to be deposited in your account': 'Betrag der auf das Konto eingezahlt werden soll',
	    'Total amount to be sent in your account': 'Betrag der auf dein Konto gesendet werden soll',
	    'You have submitted the BTC deposit request form.': 'Du hast das BTC Einzahlungsformular abgeschickt.',
	    'Please send the BTC amount to the BTC address below. This address is unique to your account.': 'Bitte sende den BTC Betrag zu der unten stehenden BTC Adresse. Diese Adresse ist nur für dein Kundenkonto erstellt worden.',
	    'Tap or Scan to pay': 'Antippen oder scannen um zu zahlen',
	    'Show QR': 'Zeige QR Code',
	    'Total BTC to be sent': 'Gesamt BTC Betrag der gesendet wird',
	    'Recipient BTC Address': 'Empfänger BTC Adresse',
	    'Please send total BTC to the recipient address.': 'Bitte sende den gesamten BTC Betrag an die Empfängeradresse.',
	    'Copy': 'Kopieren',
	    'Rate Used per BTC': 'Wechselkurs pro BTC',
	    'Please send bitcoin in': 'Bitte sende Bitcoin in',
	    'minutes.': 'minuten.',
	    'This page will automatically refresh when Bitcoin has been sent.': 'Diese Seite aktualisiert sich automatisch wenn Bitcoin versandt wurde.',
	    'Thank you for sending the requested amount!': 'Danke, dass du das angefragten Betrag gesendet hast!',
	    'We are now waiting for your Bitcoin confirmations.': 'Wir warten nun auf die Bitcoin Bestätigungen',
	    'confirmation(s) received': 'bestätigungen eingegangen',
	    'Status': 'Status',
	    'Thank you for making a deposit!': 'Vielen Dank für die Einzahlung!',
	    'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.': 'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.',
	    'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.': 'Wir warten nun auf den Erhalt deiner Bitcoin. Diese Seite aktualisiert sich automatisch sobald die Bitcoin empfangen wurden.',
	    'Requested: waiting to receive bitcoin': 'Angefordert: Warten auf den Erhalt der Bitcoin',
	    'Note: Please contact Support if you made a request by mistake and would like to request again': 'Anmerkung: Bitte kontaktiere den Kundendienst falls du eine Anfrage irrtürmlich aufgegeben hast und eine neue stellen möchtest',
	    'bitcoinDeclined': "Entschuldige, deine Anfrage wurde abgelehnt. Wahrscheinlich weil wir die Bitcoin nicht erhalten haben. Falls ein Fehler vorliegen sollte kontaktiere den Kundendienst.",
	    'Close': 'Schließen',
	    'Exchange Rate': 'Wechselkurs',
	    'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.': 'Anmerkung: Der Einzahlungskurs wird in Echtzeit aktualisiert und der Wechselkurs beim absenden der Einzahlungsanfrage gespeichert.',
	    'Total BTC amount to send:': 'Gesamt BTC Betrag der gesendet wird:',
	    'Total EUR amount to receive:': 'Gesamt EUR Betrag der empfangen wird:',
	    'Transaction Status': 'Transaktionsstatus',
	    'Requested': 'Angefragt',
	    'Pending Confirmation': 'Ausstehende Bestätigungen',
	    'Confirmed': 'Bestätigt',
	    'Declined': 'Abgelehnt',
	    'Voided': 'Ungültig',
	    'Account ID': 'Account ID',
	    'Amount to deposit': 'Einzahlungsbetrag',
	    'Total amount to deposit': 'Gesamtbetrag der eingezahlt wird',
	    'Free': 'Kostenlos',
	    'Add product': 'Produkt hinzufügen',
	    'Make new request': 'Neue Anfrage stellen',
	    'we will send you the username and password of your newly registered account.': 'wir werden dir den Nutzernamen und das Passwort deines neu erstellten Kontos zusenden.',
	    'Total amount to be deposited on account': 'Gesamtbetrag der auf das Konto eingezahlt wird',
	    'Total amount to be deducted from account': 'Gesamtbetrag der vom Konto abgebucht wird',
	    'Total amount to be sent': 'Gesamtbetrag der gesendet wird',
	    'Total amount to be received': 'Gesamtbetrag der erhalten wird',
	    'Enter product username': 'Gebe Nutzernamen des Produkts ein',
	    'Total amount to send': 'Gesamtbetrag der versendet werden muss',
	    'Request is successfully created!': 'Anfrage erfolgreich erstellt!',
	    'Please wait for customer service confirmation. You can view transaction status in Transactions overview.': 'Bitte warten sie auf die Bestätigung des Kundendienstes. Sie können den Transaktionsstatus in der Transaktionsübersicht einsehen.',
	    'Unable to Transfer': 'Transfer fehlgeschlagen',
	    'Please contact our customer service team to have your account verified. Thank you.': 'Bitte kontaktiere den Kundendienst um dein Konto zu verifizieren. Vielen Dank.',
	    'No product(s) available for selection.': 'Keine Produkte zur Auswahl verfügbar.',
	    'Opps, amount is not enough!': 'Opps Betrag ist nicht ausreichend!',
	    'Minimum amount that can be withdrawn is 100 EUR/GBP.': 'Der Mindestauszahlungsbetrag liegt bei 100 EUR/GBP',
	    'Do you want ': 'Möchtest du dass ',
	    'to be your default bank for withdrawal?': 'deine Standardbank für Auszahlungen ist?',
	    'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.': 'Du hast Überweisung als dein bevorzugtes Zahlungsmittel ausgewählt. Falls du ein anderes Zahlungsmittel auswählen möchtest klicke auf die nächsten Tabs.',
	    'Minimum Withdrawal Amount': 'Mindestauszahlungsbetrag',
	    'Maximum Withdrawal Amount': 'Maximalauszahlungsbetrag',
	    'Bank Account': 'Bankkonto',
	    'Link new bank account': 'Verlinke neues Bankkonto',
	    'transactionPasswordHint': 'Hinweis: Falls dein Benutzerkonto schon vor März 2017 existierte und du noch kein Transaktionspasswort festgelegt hast musst du die Sicherheitsfrage beantworten: Was ist dein Traumberuf?',
	    'Beneficiary name': 'Name des Zahlungsempfängers',
	    'Beneficiary address': 'Adresse des Zahlungsempfängers',
	    'IBAN': 'IBAN',
	    'Bank name': 'Name der Bank',
	    'Bank address': 'Adresse der Bank',
	    'SWIFT': 'SWIFT',
	    'Total amount to be deducted from your account': 'Gesamtbetrag der vom Konto abgebucht wird',
	    'Total amount to be received in your account': 'Gesamtbetrag der in deinem Konto empfangen wird',
	    'Confirmation Message': 'Bestätigungsnachricht',
	    'Yes': 'Ja',
	    'No': 'Nein',
	    'confirmations': 'bestätigungen eingegangen',
	    'Please select product(s) where you want to withdraw, and input the amount in': 'Bitte wähle die Produkte von denen du eine Auszahlung beantragen möchtest und gebe den Betrag ein',
	    'or BTC': 'oder BTC',
	    'Total BTC': 'Gesamt BTC',
	    'SEND TO': 'SENDE AN',
	    'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.': 'Bitte vergewissere dich dass deine Bitcoin Adresse korrekt ist. Wir werden deine BTC an diese Adresse senden.',
	    'Total BTC amount to receive': 'Gesamt BTC Betrag der empfangen wird',
	    'Total': 'Gesamt',
	    'amount to be deducted': 'betrag der abgebucht wird',
	    'Amount to deduct': 'betrag zum abbuchen',
	    'Total amount to receive': 'gesamtbetrag der empfangen wird',
	    'Opps, we need to know where to wire your funds.': 'Opps wir müssen wissen wohin dein Guthaben überwiesen werden soll.',
	    'Please fill in the required bank details. Thank you!': 'Bitte fülle die angeforderten Bankdetails aus. Vielen Dank!',
	    'Unable to withdraw': 'Auszahlung nicht möglich',
	    'Invalid Action!': 'Ungültige Aktion!',
	    'A product where the fee should be charged is required.': 'Ein Produkt wovon die Gebühr abebucht werden soll wird benötigt',
	    'Reset link was sent to your email.': 'Zurücksetzen Link wurde an deine E-Mail gesendet.',
	    'Success!': 'Erfolgreich!',
	    'Send reset password link': 'Sende Passwort Zurücksetzen Link',
	    "Enter the email you use for Asianconnect88, and we'll help you create a new password.": "Gebe die E-Mail ein welche du für Asianconnect88 benutzt und wir werden dir dabei helfen ein neues Passwort zu generieren.",
	    'English': 'Englisch',
	    'French': 'Französisch',
	    'German': 'Deutsch',
	    'Spanish': 'Spanisch',
	    'Asian Odds': 'AsianOdds',
	    'Note: Referral URL is your unique link where you can share to everyone': 'Anmerkung: Die Referral URL ist ein einmaliger Link welchen du versenden kannst',
	    'Referral HTML Code': 'Referral HTML Code',
	    'copyReferralCodeNote': 'Kopiere oder Downloade den HTML Code deiner Kampagne und füge ihn auf deiner Webseite ein.',
	    'Download HTML': 'Download HTML',
	    'Terms and Conditions': 'Allgemeine Geschäftsbedingungen',
	    'and': 'und',
	    'Commission Scheme': 'Kommissions Schema',
	    'apply': 'anfragen',
	    'Referral URL': 'Referral URL',
	    'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.': 'Anmerkung: Deine Referral URL ist ein einmaliger Link womit du Kunden zu Asianconnect referieren kannst.',
	    'Information': 'Information',
	    'Get a unique tracking link for your campaign.': 'Erstelle einen einzigarten tracking Link für deine Kampagne.',
	    'Website. Input your website URL.': 'Webseite. Füge die URL deiner Webseite ein.',
	    'Banner type. Pick a banner type: (language/size/promo)': 'Typ des Banners, wähle einen Banner Typen aus: (Sprache/Größe/Promo)',
	    'Campaign. Name your campaign.': 'Kampagne. Gib deiner Kampagne einen Namen',
	    'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.': 'Tracking code. Hast du einen bevorzugten tracking code? Gebe deinen bevorzugten tracking code ein. Klicke auf Generieren.',
	    'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.': 'Dein Referral Code URL/s sind bestimmte Links welche to benutzen kannst um Kunden zu Asianconnect zu referieren.',
	    'campaignNote': 'Kopiere den HTML Code deiner Kampagne und füge ihn im gewünschten Bereich deiner Webseite ein.',
	    'Preview archived banner': 'Vorschau archivierter Banner',
	    'Uploaded': 'Hochgeladen',
	    'Drag and drop files here or': 'Drag & Drop die Datei hier oder',
	    'Select file(s)': 'wähle Datei(en) aus',
	    'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.': 'Nur .jpg .jpeg docx doc pdf und .png mit einer maximalen Größe von 2MB erlaubt.',
	    'file(s) selected. Click upload to proceed.': 'Datei(en) ausgewählt. Klicke auf hochladen um fortzufahren.',
	    'The file is too large (MB). Allowed maximum size is 2MB.': 'Die Datei ist zu groß (MB). Die erlaubte maximale Größe ist 2MB.',
	    'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.': 'Nur .jpg .jpeg .png .pdf .doc und .docx sind erlaubt.',
	    'Successfully uploaded!': 'Erfolgreich hochgeladen!',
	    'Documents uploaded': 'Dokumente hochgeladen',
	    'Delete Document': 'Lösche Dokument',
	    'Are you sure you want to delete this document?': 'Bist du sicher, dass du dieses Dokument löschen willst?',
	    'Cancel': 'Abbrechen',
	    'Delete': 'Löschen',
	    'Account Information': 'Kontoinformation',
	    'Customer ID': 'Kundennummer',
	    'Full name': 'Vollständiger Name',
	    'Currency': 'Währung',
	    'Country': 'Land',
	    'Date of birth': 'Geburtstag',
	    'Join date': 'Datum der Anmeldung',
	    'Email Address': 'E-Mail Adresse',
	    'Phone number': 'Telefonnummer',
	    'Skype': 'Skype',
	    'Username': 'Benutzername',
	    'K.Y.C documents': 'K.Y.C Dokumente',
	    'Password changed.': 'Passwort geändert.',
	    'I want to request a new reset code.': 'Ich möchte einen neuen Reset code beantragen.',
	    'Loading, please wait...': 'Laden bitte warten…',
	    'Request new reset code?': 'Neuen Reset code beantragen??',
	    'Enter your new account password below.': 'Gebe dein neues Kontopasswort ein',
	    'Account password has been successfully updated!': 'Kontopasswort erfolgreich aktualisiert!',
	    'Update AMS account password': 'Aktualisiere AMS Kontopasswort',
	    'Current AMS password': 'Aktuelles AMS Kontopasswort',
	    'New AMS Password': 'Neues AMS-Passwort',
	    'Enter current password': 'Gebe aktuelles Passwort ein',
	    'Enter new password': 'Gebe neues Passwort ein',
	    'Confirm new password': 'Bestätige neues Passwort',
	    'Update': 'Aktualisieren',
	    'Are you sure you want to delete this Bank Account?': 'Bist du sicher, dass du dieses Bankkonto löschen möchtest?',
	    'Add bank accounts for faster transaction.': 'Füge Bankkonten für schnellere Transaktionen hinzu.',
	    'Default': 'Standard',
	    'Link a new bank account': 'Neues Bankkonto hinzufügen',
	    'Bank account successfully deleted.': 'Bankkonto erfolgreich gelöscht.',
	    'Success': 'Erfolg',
	    'Transaction password has been successfully updated!': 'Transaktionspasswort wurde erfolgreich aktualisiert!',
	    'Update AMS transaction password': 'AMS Transaktionspasswort aktualisieren',
	    'Current AMS transaction password': 'Aktuelles AMS Transaktionspasswort',
	    'Enter current transaction password': 'Aktuelles AMS Transaktionspasswort eingeben',
	    'New AMS transaction password': 'Neues AMS Transaktionspasswort',
	    'Enter new transaction password': 'Neues AMS Transaktionspasswort eingeben',
	    'Confirm new transaction password': 'Neues AMS Transaktionspasswort bestätigen',
	    'Account username has been successfully updated!': 'Benutzername wurde erfolgreich aktualisiert!',
	    'Update AMS username': 'AMS Benutzernamen aktualisieren',
	    'Current AMS username': 'Aktueller AMS Benutzername',
	    'New AMS username': 'Neuer AMS Benutzername',
	    'Enter new username': 'Neuen Nutzernamen eingeben',
	    'Confirm new username': 'Neuen Nutzernamen bestätigen',
	    'Enter password': 'Passwort eingeben',
	    'Security': 'Sicherheit',
	    'Update your Username, Account and Transaction Password': 'Aktualisiere deinen Benutzernamen und das Transaktionspasswort',
	    'Temporarily Unavailable': 'Temporär nicht verfügbar',
	    'For inquiries, please contact Customer Support.': 'Bei Anfragen bitte den Kundendienst kontaktieren.',
	    'Payment Option': 'Zahlungsoption',
	    'Manage your payment accounts': 'Verwalte deine Zahlungskonten',
	    'Open': 'Offen',
	    'Pending': 'Ausstehend',
	    'Resolved': 'Geklärt',
	    'Closed': 'Geschlossen',
	    'Forbidden!': 'Verboten!',
	    'My Products': 'Meine Produkte',
	    'Add Product': 'Produkt hinzufügen',
	    'Reset Product Password': 'Produktpasswort zurücksetzen',
	    'New': 'Neu',
	    'Bank account successfully created.': 'Bankkonto erfolgreich erstellt.',
	    'Link a bank account': 'Ein Bankkonto verlinken',
	    'Enter Account Number': 'Kontonummer eingeben',
	    'Enter Account Name': 'Kontoname eingeben',
	    'Enter Citizenship': 'Staatsangehörigkeit eingeben',
	    'Enter Address': 'Adresse eingeben',
	    'Enter Bank Code': 'Bankleitzahl eingeben',
	    'Enter Bank Name': 'Bankname eingeben',
	    'Enter Bank Address': 'Adresse der Bank eingeben',
	    'Save bank account': 'Bankkonto speichern',
	    'Save': 'Speichern',
	    'Limit Reached!': 'Limit erreicht!',
	    'Go to Settings': 'Gehe zu Einstellungen',
	    'Product password successfully requested.': 'Produktpasswort erfolgreich angefordert.',
	    'Warning': 'Warnung',
	    'Something went wrong. Please try again later.': 'Es ist etwas fehlgeschlagen. Bitte versuche es später erneut.',
	    'Request Product Password': 'Produktpasswort anfragen',
	    'Select one or more products to reset password': 'Wähle ein oder mehrere Produkte aus um das Passwort zurückzusetzen.',
	    'View Password': 'Passwort ansehen',
	    'Expires on': 'Läuft ab',
	    'Expired Password': 'Abgelaufenes Passwort',
	    'No Password': 'Kein Passwort',
	    'Enter Transaction Password': 'Transaktionspasswort eingeben',
	    'Request': 'Anfrage',
	    'Product password will be available once password has been reset.': 'Produktpasswort ist verfügbar sobald das Passwort zurückgesetzt wurde.',
	    'Warning!': 'Warnung!',
	    'Warning! The following product/s has pending request': 'Warnung! Das folgende Produkt hat eine ausstehende Anfrage',
	    'Request Product': 'Produktanfrage',
	    'Please select at least one product below': 'Bitte wähle mindestens ein unten aufgeführtes Produkt aus',
	    'No products available. You already have all the products Asianconnect offers.': 'Keine Produkte zur Auswahl verfügbar. Du verfügst schon über alle Produkte die Asianconnect anbietet.',
	    'username': 'Benutzername',
	    'SINGBET FORCED POSITION TAKING ON ASIANCONNECT': 'SINGBET FORCIERT ASIANCONNECT ZUM POSITION TAKING',
	    'Profit and Loss (PnL)': 'Gewinn und Verlust (GuV/PnL)',
	    'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.': 'Bitte beachte, dass dein Gewinn/Verlust bei Singbet immer GuV/PnL*0.40 beträgt.',
	    'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).': 'Wenn du z.B. 1000 setzt und gewinnst, gewinnst du im Endeffekt nur 400 EUR/GBP (1000*0.40).',
	    'Then if you lose, you only lose 400 EUR/GBP.': 'Wenn du verlierst, dann verlierst du nur 400 EUR/GBP',
	    'Deposits': 'Einzahlungen',
	    'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.': 'Deine Einzahlung bei SINGBET ist immer Betrag/0.40. Das bedeutet wenn du 1000 EUR/GBP einzahlst fügen wir 2500 (1000/0.40=2500) deinem SINGBET Konto hinzu.',
	    'Withdrawals': 'Auszahlungen',
	    'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.': 'Ebenso verhält es sich bei Auszahlungen. Betrag/0.40. Das bedeutet wenn du 1000 EUR/GBP auszahlen möchtest, dann buchen wir 2500 (1000/0.4) von deinem SINGBET Guthaben ab.',
	    'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.': 'In AMS Konto wird ein EUR/GBP Betrag angezeigt, allerdings ist das Guthaben in deinem SINGBET Konto sogenanntes „Singbet Guthaben“.',
	    'I agree to the Terms and Conditions': 'Ich akzeptiere die allgemeinen Geschäftsbedingungen',
	    'MAXBET FORCED POSITION TAKING ON ASIANCONNECT': 'MAXBET FORCIERT ASIANCONNECT ZUM POSITION TAKING',
	    'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.': 'Bitte beachte, dass dein Gewinn/Verlust bei MAXBET immer GuV/PnL*0.50 beträgt.',
	    'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).': 'Wenn du z.B. 1000 setzt und gewinnst, gewinnst du im Endeffekt nur 500 EUR/GBP (1000*0.50).',
	    'Then if you lose, you only lose 500 EUR/GBP.': 'Wenn du verlierst, dann verlierst du nur 500 EUR/GBP.',
	    'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.': 'Deine Einzahlung bei MAXBET ist immer Betrag/0.50. Das bedeutet wenn du 1000 EUR/GBP einzahlst fügen wir 2000 (1000/0.50=2000) deinem MAXBET Konto hinzu.',
	    'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.': 'Ebenso verhält es sich bei Auszahlungen. Betrag/0.50. Das bedeutet wenn du 1000 EUR/GBP auszahlen möchtest, dann buchen wir 2000 (1000/0.5) von deinem MAXBET Guthaben ab.',
	    'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.': 'In AMS Konto wird ein EUR/GBP Betrag angezeigt, allerdings ist das Guthaben in deinem MAXBET Konto sogenanntes „Maxbet Guthaben“.',
	    'SBOBET Forced Position Taking ON ASIANCONNECT': 'SBOBET FORCIERT ASIANCONNECT ZUM POSITION TAKING',
	    'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.': 'Bitte beachte, dass dein Gewinn/Verlust bei SBOBET immer GuV/PnL*0.30 beträgt. Wenn du z.B. 1000 setzt und gewinnst, gewinnst du im Endeffekt nur 300 EUR/GBP (1000*0.30). Wenn du verlierst, dann verlierst du nur 300 EUR/GBP',
	    'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Deine Einzahlung bei SBOBET ist immer Betrag/0.30. Das bedeutet wenn du 1000 EUR/GBP einzahlst fügen wir 3333.33 (1000/0.30=3333.33) deinem SBOBET Konto hinzu.',
	    'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Ebenso verhält es sich bei Auszahlungen. Betrag/0.30. Das bedeutet wenn du 1000 EUR/GBP auszahlen möchtest, dann buchen wir 3333.33 (1000/0.33) von deinem SBOBET Guthaben ab.',
	    'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.': 'In AMS Konto wird ein EUR/GBP Betrag angezeigt, allerdings ist das Guthaben in deinem SBOBET Konto sogenanntes „Sbobet Guthaben“.',
	    '9WICKETS FORCED POSITION TAKING ON ASIANCONNECT': '9WICKETS FORCIERT ASIANCONNECT ZUM POSITION TAKING',
	    'Please note that 9wickets have 3% commission rate applied to your winnings.': 'Bitte beachte, dass 9Wickets eine Kommission in Höhe von 3% von deinen Gewinnen abführt.',
	    'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.': 'Wir möchten dich darüber informieren, dass 9wickets täglich eine Überprüfung von allen Wetten durchführt die auf ihrer Plattform platziert wurden. Sollten betrügerische Aktivitäten oder auffällige Wettmuster auffallen, so hat 9wickets das Recht dein Konto zu schließen und das Guthaben einzuhalten.',
	    'ORBITX FORCED POSITION TAKING ON ASIANCONNECT': 'ORBITX FORCIERT ASIANCONNECT ZUM POSITION TAKING',
	    'Please note that OrbitX have 3% commission rate applied to your winnings.': 'Bitte beachte, dass ORBITX eine Kommission in Höhe von 3% von deinen Gewinnen abführt.',
	    'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.': 'Wir möchten dich darüber informieren, dass ORBITX täglich eine Überprüfung von allen Wetten durchführt die auf ihrer Plattform platziert wurden. Sollten betrügerische Aktivitäten oder auffällige Wettmuster auffallen, so hat ORBITX das Recht dein Konto zu schließen und das Guthaben einzuhalten.',
	    'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT': 'SKYPE BETTING ALLGEMEINE GESCHÄFTSBEDINGUNGEN BEI ASIANCONNECT',
	    'You can contact us via Skype at': 'Du kannst uns über Skype kontaktieren',
	    'NV for Skype betting Terms and Conditions.': 'NV für Skype betting Allgemeine Geschäftsbedingungen.',
	    'Successfully added!': 'Erfolgreich hinzugefügt!',
	    'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.': 'Die folgenden Produkte wurden hinzugefügt. Du kannst nun eine Einzahlung anfordern um dein Konto aufzuladen. Du erhältst den Benutzernamen und das Passwort für das Konto sobald wir die Einzahlung erhalten haben. Vielen Dank.',
	    'About Us': 'Über uns',
	    'Contact Us': 'Kontaktiere uns',
	    'Legal Disclaimer': 'Rechtlicher Hinweis',
	    'Privacy Policy': 'Datenschutzrichtlinie',
	    'Go To Transaction Overview': 'Gehe zur Transaktionsübersicht',
	    'Notification': 'Benachrichtigung',
	    'was deleted.': 'wurde gelöscht.',
	    'Failed to delete': 'Löschen fehlgeschlagen',
	    'file has been uploaded.': 'datei wurde hochgeladen',
	    'Failed to upload': 'Hochladen fehlgeschlagen',
	    'Paste an address where you want to receive BTC': 'Füge deine BTC Empfängeraddresse ein',
	    'New referral': 'Neue Überweisung',
	    'has been linked.': 'wurde verknüpft.',
	    'Referral': 'Überweisung',
	    'has been unlinked.': 'wurde nicht verbunden.',
	    'Product/s': 'Produkt',
	    'has been added.': 'wurde hinzugefügt.',
	    'Transaction': 'Transaktion',
	    'has been': 'ist gewesen',
	    'Deposit': 'Einzahlung',
	    'Withdraw': 'Auszahlung',
	    'Transfer': 'Überweisung',
	    'P2P Transfer': 'P2P Überweisung',
	    'Approved': 'Genehmigt',
	    'Acknowledged': 'Anerkannt',
	    'Processed': 'Verarbeitet',
	    'Saved': 'Gerettet',
	    'Invalid Credentials!': 'Ungültige Eingabe!',
	    'Email': 'E-Mail'
	  }, (0, _defineProperty3.default)(_ref, 'Account ID', 'Account ID'), (0, _defineProperty3.default)(_ref, 'Name', 'Name'), (0, _defineProperty3.default)(_ref, 'Request Deposit', 'Einzahlung anfordern'), (0, _defineProperty3.default)(_ref, 'Request Withdrawal', 'Auszahlung anfordern'), (0, _defineProperty3.default)(_ref, 'Upload', 'Upload'), (0, _defineProperty3.default)(_ref, 'W/L', 'W/L'), (0, _defineProperty3.default)(_ref, 'Bonus', 'Bonus'), (0, _defineProperty3.default)(_ref, 'Revenue Share', 'Umsatzbeteiligung'), (0, _defineProperty3.default)(_ref, 'Total W/L:', 'Gesamt W/L:'), (0, _defineProperty3.default)(_ref, 'Total Bonus:', 'Gesamtbonus:'), (0, _defineProperty3.default)(_ref, 'Total Revenue Share:', 'Gesamtumsatzanteil:'), (0, _defineProperty3.default)(_ref, 'Unlimited', 'Unbegrenzt'), (0, _defineProperty3.default)(_ref, 'Instant', 'Sofort'), (0, _defineProperty3.default)(_ref, 'My Tickets', 'Meine Tickets'), (0, _defineProperty3.default)(_ref, 'Product is required', 'Produkt wird benötigt'), (0, _defineProperty3.default)(_ref, 'Transaction password invalid', 'Transaktionspasswort_ungültig'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been saved', 'Transaktion Einzahlung wurde gespeichert'), (0, _defineProperty3.default)(_ref, 'Product has been added', 'Produkt wurde hinzugefügt'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been saved', 'Transaktion Auszahlung wurde gespeichert'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been saved', 'Transaktion Überweisung wurde gespeichert'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been declined', 'Transaktion Einzahlung wurde abgelehnt'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been declined', 'Transaktion Auszahlung wurde abgelehnt'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been declined', 'Transaktion Überweisung wurde abgelehnt'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been voided', 'Transaktion Einzahlung wurde storniert'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been voided', 'Transaktion Auszahlung wurde storniert'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been voided', 'Transaktion Überweisung wurde storniert'), (0, _defineProperty3.default)(_ref, 'Documents uploaded:', 'Dokumente hochgeladen:'), (0, _defineProperty3.default)(_ref, 'Warning! At least one product is required.', 'Warnung! Es ist mindestens ein Produkt erforderlich.'), (0, _defineProperty3.default)(_ref, 'paymentOptionsViewDetails', 'Wichtig: Nachdem du deine Einzahlung getätigt hast, fülle diesen Bereich aus. Falls dies nicht erfolgt wird deine Einzahlung ungültig. Wir benötigen diese Information um über die Transaktion in Kenntnis gesetzt zu werden und um zu überprüfen ob die Einzahlung bereits in deinem Konto vermerkt wurde.'), (0, _defineProperty3.default)(_ref, 'File(s) still uploading, please wait.', 'Datei (en) werden noch hochgeladen. Bitte warten Sie.'), (0, _defineProperty3.default)(_ref, 'DEPOSIT', 'EINZAHLUNG'), (0, _defineProperty3.default)(_ref, 'WITHDRAWAL', 'AUSZAHLUNG'), (0, _defineProperty3.default)(_ref, 'TRANSFER', 'ÜBERWEISUNG'), (0, _defineProperty3.default)(_ref, 'BONUS', 'BONUS'), (0, _defineProperty3.default)(_ref, 'PSP TRANSFER', 'PSP ÜBERWEISUNG'), (0, _defineProperty3.default)(_ref, 'COMMISSION', 'KOMMISSION'), (0, _defineProperty3.default)(_ref, 'DEBIT', 'DEBIT'), (0, _defineProperty3.default)(_ref, 'CREDIT', 'KREDIT'), (0, _defineProperty3.default)(_ref, 'REVENUE SHARE', 'UMSATZBETEILIGUNG'), (0, _defineProperty3.default)(_ref, 'RESET BOOKIE PASSWORD', 'RESET BOOKIE PASSWORT'), (0, _defineProperty3.default)(_ref, 'Ecopayz Merchant Account (EUR)', 'Ecopayz-Händlerkonto (EUR)'), _ref;
	}

/***/ }),
/* 1673 */,
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(1673);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.fr = fr;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fr() {
		var _ref;
	
		return _ref = {
			'form': {
				'from': 'De',
				'to': 'À',
				'username': 'Nom d’utilisateur',
				'password': 'Mot de passe',
				'type': 'Type',
				'status': 'Statut',
				'transactionPassword': 'Mot de passe de transaction',
				'confirmUsername': 'Confirmer nom d’utilisateur',
				'confirmPassword': 'Confirmer mot de passe',
				'confirmTransactionPassword': 'Confirmer le mot de passe de transaction',
				'paymentOption': 'Options de paiement',
				'fromProduct': 'Du produit',
				'email': 'E-mail',
				'website': 'Site internet',
				'promotion': 'Offre promotionnelle',
				'advertisement': 'Pub',
				'language': 'Langue',
				'size': 'Taille',
				'campaign': 'Nom de la campagne',
				'referralCode': 'Code de référencement',
				'newPassword': 'Nouveau mot de passe',
				'iban': 'Numéro de compte/IBAN',
				'accountName': 'Nom du compte / Nom de l’entreprise',
				'birthDate': 'Date de naissance',
				'citizenship': 'Nationalité',
				'address': 'Adresse',
				'swift': 'Code banque (BIC) / SWIFT',
				'bankName': 'Nom de la banque',
				'bankAddress': 'Adresse de la banque',
				'isDefault': 'Utilisé par défaut'
			},
			'titles': {
				'bankAccount': 'Compte bancaire',
				'dashboard': 'Tableau de bord',
				'account': 'Mon compte',
				'profile': 'Mon profil',
				'transaction': 'Transactions',
				'transactionHistory': 'Historique des transactions',
				'overview': 'Vue d’ensemble',
				'deposit': 'Dépôt',
				'withdrawal': 'Retrait',
				'transfer': 'Transfert',
				'productWallet': 'Transfert (à un autre bookmaker)',
				'p2pTransfer': 'Transfert (à une autre personne)',
				'skypeBetting': 'Skype Betting',
				'outstandingBets': 'Paris en cours',
				'betHistory': 'Historique de paris',
				'betOverview': 'Récapitulatif des paris',
				'affiliate': 'Affiliation',
				'affiliateDashboard': 'Tableau de bord affiliation',
				'affiliateTools': 'Outils d’affiliation',
				'supportTickets': 'Billets de soutien',
				'settings': 'Paramètres',
				'mobileSite': 'Site mobile AMS',
				'Valid Turnover/Commissions': 'Commissions / turnover validé',
				'products': 'Produits',
				'size': 'Taille',
				'campaign': 'Nom de la campagne',
				'referralCode': 'Code de référencement',
				'website': 'Site internet',
				'tickets': 'Billets de soutien'
			},
			'tables': {
				'product': 'Produit',
				'memberId': 'ID membre',
				'totalTurnover': 'Total turnover',
				'totalWinLoss': 'Total Customer W/L',
				'totalCommission': 'Commissions affilié',
				'date': 'Date',
				'transactionNumber': 'Transaction #',
				'type': 'Type',
				'language': 'Langue',
				'currency': 'Devise',
				'paymentOption': 'Option de paiement',
				'amount': 'Montant',
				'status': 'Statut',
				'Total Commission': 'Total commissions',
				'subject': 'Sujet',
				'description': 'La description',
				'username': 'Nom d’utilisateur',
				'balance': 'Balance',
				'dateLastUpdated': 'Date de dernière mise à jour'
			},
			'Reset password': 'Ré-initialiser mot de passe',
			'Activate Later': 'Activer plus tard',
			"You're on your way to earning a lifetime commission. Just follow 4 easy steps.": "Vous êtes sur le point de gagner une commission à vie. Suivez simplement ces 4 étapes",
			'I confirm that I have read and accepted': 'Je confirme avoir lu et accepté',
			'Asianconnect Affiliates Terms and Conditions': 'Les conditions générales d’Asianconnect affiliation',
			'Get Started': 'Commencer',
			'Banners and Referral Codes': 'Code de référencement et bannières',
			'Learn more': 'En savoir plus',
			'Archive': 'Archive',
			'generateBannerNote': 'Remplissez simplement le formulaire avec les détails de votre campagne et nous générerons pour vous un lien d’affiliation unique et une bannière téléchargeable',
			'Setup your username and password now': 'Choisissez votre nom d’utilisateur et votre mot de passe maintenant',
			'Welcome to AC Affiliates!': 'Bienvenue au sein du programme d’affiliation d’Asianconnect!',
			'Please enter your Campaign Name': 'Veuillez SVP entrer votre nom de campagne',
			'Please enter your Referral Code': 'Veuillez SVP entrer votre code de référencement souhaité',
			'Get code': 'Obtenez votre code',
			'Reset': 'Ré-initialisation',
			'Generate': 'Générer',
			'referralCodeNote': 'Vous pouvez ré-utiliser votre code URL existant or en créer un nouveau, les caractères spéciaux et les espaces ne sont pas autorisés.',
			'Special characters and spaces are not allowed.': 'Les caractères spéciaux et les espaces ne sont pas autorisés.',
			'See Preview': 'Voir Pré-visualisation',
			'Preview': 'Pré-visualisation',
			'Please enter your website URL': 'Veuillez SVP entrer l’URL de votre site internet',
			'Please contact Customer Support.': 'Veuillez SVP contacter le service client',
			'Change email': 'Changer email',
			'Transfer from': 'Transfert de',
			'Transfer to': 'Transfert à',
			'Product': 'Produit',
			'Please Select': 'Sélectionnez',
			'Commission Period': 'Période commissions',
			'Original Payout Date': 'Date de paiement',
			'to': 'à',
			'Reason': 'Raison',
			'commission': 'Commissions',
			'Search': 'Rechercher',
			'Reset Filter': 'Ré-initialiser filtre',
			'All Status': 'Tous les statuts',
			'Product Username': 'Nom d’utilisateur produit',
			'All Payment Options': 'Toutes les options de paiement',
			'All types': 'Tous types',
			'Sign In': 'Se connecter',
			'Sign in to start your session': 'Se connecter pour ouvrir une session',
			'Please wait, Logging in...': 'Attendez pendant la connexion SVP',
			'signOut': 'Se déconnecter',
			'memberSince': 'Membre depuis',
			'Note:': 'Note:',
			'Note': 'Note',
			'makeDeposit': 'Faîtes un dépôt pour augmenter vos fonds disponibles',
			'welcome': 'Bienvenue sur Asianconnect AMS!',
			'setup': 'Paramétrer votre nom d’utilisateur et votre mot de passe maintenant',
			'to activate your account.': 'Pour activer votre compte',
			'setupNote': 'Note : Votre nom d’utilisateur temporaire et votre mot de passe ont été envoyés sur votre adresse email',
			'Proceed': 'Proceed',
			'Deposit Now': 'Faîtes un dépôt maintenant',
			'Available Balance': 'Balance disponible',
			'Unallocated Balance': 'Balance non allouée',
			'Account Status': 'Statut du compte',
			'Quick Links': 'Liens rapides',
			'BETA': 'BETA',
			'Verified': 'Vérifié',
			'Not Verified': 'Non vérifié',
			'Filter': 'Filtre',
			'Request Transfer': 'Transfert requête',
			'loadingPageContent': 'Chargement de la page, merci de patienter',
			'Date Covered:': 'Date couverte:',
			'Total Turnover:': 'Total turnover:',
			'Total Affiliate Commission:': 'Total commissions affilié:',
			'Total Customer W/L:': 'Total client W/L:',
			'exportCsv': 'Exporter en format CSV',
			'noProduct': 'Pas de produit',
			'somethingWentWrong': 'Une erreur semble s’être produite. Veuillez SVP vérifier vos informations',
			'activated': 'Vous avez activé votre compte avec succès',
			'Account Activation': 'Activation de compte',
			'activateAccountNote': 'Activez votre compte en remplissant vos données ci-dessous',
			'usernameValidation': 'Doit contenir seulement des lettres, chiffres et underscore',
			'passwordValidation': 'Doit contenir au moins 8 caractères, dont 2 lettres, 2 chiffres et 2 symboles',
			'transactionPasswordValidation': 'Doit contenir au minimum 6 caractères alpha numériques, avec au moins une lettre majuscule',
			'Re-enter username': 'Entrez de nouveau votre nom d’utilisateur',
			'Re-enter password': 'Entrez de nouveau votre mot de passe',
			'Re-enter transaction password': 'Entrez de nouveau votre mot de passe de transaction',
			'Activate account': 'Activez votre compte',
			'Clear All': 'Tout supprimer',
			'skrillContent': 'Veuillez SVP vous connecter à votre compte SKRILL et transférer le montant souhaité à ',
			'netellerContent': 'Veuillez SVP vous connecter à votre compte NETELLER et transférer le montant souhaité à ',
			'verifyDeposit': 'Nous allons maintenant vérifier votre dépôt. Dès que nous aurons reçu votre dépôt, celui-ci apparaîtra sur votre compte ',
			'netellerTransferNote': 'Veuillez SVP vous connecter à votre compte NETELLER et transférer le montant souhaité à ',
			'netellerTransferNote2': 'Avec code de transfert de ',
			'you will see the additional funds reflected in your account.': 'Votre dépôt apparaîtra sur votre compte',
			'CONTINUE': 'Continuer',
			'cantProcessRequest': "Désolé, nous ne sommes pas en mesure de procéder à votre requête pour le moment",
			'Sorry': 'Désolé',
			'Thank you': 'Merci',
			'OK': 'OK',
			'For making a deposit': 'Pour effectuer un dépôt',
			'We are now verifying your deposit. Once we have received your deposit,': 'Nous allons maintenant vérifier votre dépôt. Dès que nous aurons reçu votre dépôt',
			'bankNotice': 'Les transactions bancaires ne sont pas possibles pour le moment. Pour toute demande, merci de contacter le service client. Merci',
			'bankRestricted': 'Les transactions bancaires sont restreintes pour votre pays. Veuillez SVP utiliser une autre méthode de paiement.',
			'processingTime': 'Temps de traitement',
			'fee': 'Frais',
			'minimumDeposit': 'Dépôt minimum',
			'maximumDeposit': 'Dépôt maximum',
			'chooseProductDeposit': 'Choisissez simplement votre bookmaker préféré, entrez le montant puis cliquez sur dépôt',
			'Product Name': 'Bookmaker',
			'Amount': 'Montant',
			'fileValidation': 'Seulement jpg jpeg et png avec un maximum de 2MB',
			'Transaction Summary': 'Résumé des transactions',
			'Total amount to be deposited in your account': 'Montant total à déposer sur votre compte',
			'Total amount to be sent in your account': 'Montant total à envoyer sur votre compte',
			'You have submitted the BTC deposit request form.': 'Vous avez rempli le formulaire de dépôt en bitcoin.',
			'Please send the BTC amount to the BTC address below. This address is unique to your account.': 'Veuillez SVP envoyer le montant en BTC à l’adresse ci-dessous. Cette adresse est uniquement utilisée pour votre compte.',
			'Tap or Scan to pay': 'Toucher ou scanner pour payer',
			'Show QR': 'Montrer QR',
			'Total BTC to be sent': 'Montant total BTC à envoyer',
			'Recipient BTC Address': 'Adresse BTC du bénéficiaire',
			'Please send total BTC to the recipient address.': 'Veuillez SVP envoyer le montant total en BTC à l’adresse bénéficiaire',
			'Copy': 'Copie',
			'Rate Used per BTC': 'Taux par BTC',
			'Please send bitcoin in': 'Veuillez SVP envoyer vos bitcoin en',
			'minutes.': 'minutes.',
			'This page will automatically refresh when Bitcoin has been sent.': 'Cette page s’actualisera automatiquement une fois que les bitcoins auront été envoyés',
			'Thank you for sending the requested amount!': 'Merci de nous avoir envoyer le montant souhaité!',
			'We are now waiting for your Bitcoin confirmations.': 'Nous attendons désormais la confirmation de vos bitcoins',
			'confirmation(s) received': 'confirmation(s) reçues',
			'Status': 'Statut',
			'Thank you for making a deposit!': 'Merci d’avoir effectuer un dépôt!',
			'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.': 'Nous allons maintenant vérifier votre dépôt. Dès que nous aurons reçu votre dépôt, celui-ci apparaîtra sur votre compte',
			'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.': 'Nous attendons désormais de recevoir vos bitcoins. Cette page s’actualisera automatiquement une fois que les bitcoins auront été reçus.',
			'Requested: waiting to receive bitcoin': 'En attente de réception des bitcoins.',
			'Note: Please contact Support if you made a request by mistake and would like to request again': 'Note : Veuillez svp contacter le support client si vous avez effectué une requête par erreur et que vous souhaitez en effectuer une autre.',
			'bitcoinDeclined': "Nous sommes désolés, votre requête a été ANNULEE probablement car nous n'avons pas reçu vos bitcoins. Si c'est une erreur, merci de contacter le support client afin que nous vérifions cela avec vous.",
			'Close': 'Fermer',
			'Exchange Rate': 'Taux de change',
			'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.': 'Note : Le taux de change est mis à jour en temps réel. Ce taux sera arrêté et bloqué une fois que vous aurez soumis votre requête',
			'Total BTC amount to send:': 'Montant total BTC à envoyer:',
			'Total EUR amount to receive:': 'Montant total EUR à recevoir:',
			'Transaction Status': 'Statut transaction',
			'Requested': 'Demande formulée',
			'Pending Confirmation': 'Confirmation en attente',
			'Confirmed': 'Confirmé',
			'Declined': 'Refusé',
			'Voided': 'Annulé',
			'Account ID': 'ID compte',
			'Amount to deposit': 'Montant à déposer',
			'Total amount to deposit': 'Montant total à déposer',
			'Free': 'Gratuit',
			'Add product': 'Ajouter produit',
			'Make new request': 'Nouvelle requête',
			'we will send you the username and password of your newly registered account.': 'Nous vous enverrons le nom d’utilisateur et le mot de passe de votre compte nouvellement créé',
			'Total amount to be deposited on account': 'Montant total à déposer sur votre compte',
			'Total amount to be deducted from account': 'Montant total à déduire de votre compte',
			'Total amount to be sent': 'Montant total à envoyer',
			'Total amount to be received': 'Montant total à recevoir',
			'Enter product username': 'Entrer le nom d’utilisateur pour ce produit',
			'Total amount to send': 'Montant total à envoyer',
			'Request is successfully created!': 'La requête a été créée avec succès!',
			'Please wait for customer service confirmation. You can view transaction status in Transactions overview.': 'Veuillez SVP attendre la confirmation du service client. Vous pouvez voir le statut de la transaction dans le résumé des transactions.',
			'Unable to Transfer': 'Impossible d’effectuer le transfer',
			'Please contact our customer service team to have your account verified. Thank you.': 'Veuillez svp contacter notre service client afin de valider votre compte. Merci',
			'No product(s) available for selection.': 'Aucun produit disponible',
			'Opps, amount is not enough!': 'Le montant est trop faible!',
			'Minimum amount that can be withdrawn is 100 EUR/GBP.': 'Le montant minimum pouvant être retiré est de 100 EUR/GBP',
			'Do you want ': 'Voulez-vous vous ',
			'to be your default bank for withdrawal?': 'que ce soit votre banque par défaut pour les retraits?',
			'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.': 'Vous avez sélectionné le virement bancaire comme votre méthode de paiement préférée. Si vous voulez le modifier, veuillez svp cliquer sur le prochain onglet.',
			'Minimum Withdrawal Amount': 'Montant minimum de retrait',
			'Maximum Withdrawal Amount': 'Montant maximum de retrait',
			'Bank Account': 'Compte bancaire',
			'Link new bank account': 'Lier nouveau compte bancaire',
			'transactionPasswordHint': 'Pour mémoire : si vous êtes déjà client depuis mars 2017 et n’avez toujours pas paramétré votre mot de passe de transaction, celui-ci est la réponse à votre question de sécurité : « Quel est votre métier rêvé? »',
			'Beneficiary name': 'Nom du bénéficiaire',
			'Beneficiary address': 'Adresse du bénéficiaire',
			'IBAN': 'IBAN',
			'Bank name': 'Nom de la banque',
			'Bank address': 'Adresse de la banque',
			'SWIFT': 'SWIFT',
			'Total amount to be deducted from your account': 'Montant total à déduire de votre compte',
			'Total amount to be received in your account': 'Montant total à recevoir sur votre compte',
			'Confirmation Message': 'Message de confirmation',
			'Yes': 'Oui',
			'No': 'Non',
			'confirmations': 'confirmations',
			'Please select product(s) where you want to withdraw, and input the amount in': 'Veuillez SVP sélectionner le produit pour lequel vous souhaitez effectuer le retrait, et indiquer le montant',
			'or BTC': 'ou BTC',
			'Total BTC': 'Total BTC',
			'SEND TO': 'A ENVOYER SUR',
			'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.': 'Veuillez SVP vous assurer que votre adresse bitcoin est correcte. Nous enverrons vos BTC à cette adresse.',
			'Total BTC amount to receive': 'Montant total BTC à recevoir',
			'Total': 'Total',
			'amount to be deducted': 'Montant à déduire',
			'Amount to deduct': 'Montant à déduire',
			'Total amount to receive': 'Montant total à recevoir',
			'Opps, we need to know where to wire your funds.': 'Nous avons besoin de savoir où transférer les fonds',
			'Please fill in the required bank details. Thank you!': 'Veuillez svp remplir les données bancaires. Merci!',
			'Unable to withdraw': 'Impossible de retirer',
			'Invalid Action!': 'Action invalide!',
			'A product where the fee should be charged is required.': 'Un produit où les frais seront déduits est requis',
			'Reset link was sent to your email.': 'Le lien de ré-initialisation vient d’être envoyé sur votre adresse email',
			'Success!': 'Success!',
			'Send reset password link': 'Envoyer le lien de ré-initialisation du mot de passe',
			"Enter the email you use for Asianconnect88, and we'll help you create a new password.": "Entrer l'adresse email utilisée sur asianconnect88 et nous vous aiderons à créer un nouveau mot de passe",
			'English': 'Anglais',
			'French': 'Français',
			'German': 'Allemand',
			'Spanish': 'Espagnol',
			'Asian Odds': 'Asian Odds',
			'Note: Referral URL is your unique link where you can share to everyone': 'Note : votre URL d’affiliation est votre unique lien que vous pouvez partager à tout le monde',
			'Referral HTML Code': 'Referral HTML Code',
			'copyReferralCodeNote': 'Copiez ou téléchargez simplement le code HTML de votre campagne, et collez-le dans la section de votre site internet où vous souhaitez le voir apparaître',
			'Download HTML': 'Télécharger HTML',
			'Terms and Conditions': 'Conditions générales',
			'and': 'et',
			'Commission Scheme': 'Structure de commissions',
			'apply': 'appliquer',
			'Referral URL': 'URL affilié',
			'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.': 'Note : votre URL d’affiliation est votre unique lien que vous pouvez utiliser pour rediriger vos clients sur Asianconnect',
			'Information': 'Information',
			'Get a unique tracking link for your campaign.': 'Obtenez un lien unique d’affiliation pour votre campagne',
			'Website. Input your website URL.': 'Site internet, Indiquez l’URL de votre site internet',
			'Banner type. Pick a banner type: (language/size/promo)': 'Type de bannière. Choisissez un type de bannière: (langue/taille/promo)',
			'Campaign. Name your campaign.': 'Campagne. Nommez votre campagne',
			'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.': 'Tracking code. Vous avez un tracking code préféré ? Indiquez le. Cliquez sur générer.',
			'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.': 'Votre URL d’affiliation est un lien unique que vous pouvez utiliser pour rediriger vos clients sur Asianconnect',
			'campaignNote': 'Copiez ou téléchargez simplement le code HTML de votre campagne, et collez-le dans la section de votre site internet où vous souhaitez le voir apparaître',
			'Preview archived banner': 'Pré-visualiser les bannières archivées',
			'Uploaded': 'Télécharger',
			'Drag and drop files here or': 'Glissez et déposez vos fichiers ici ou',
			'Select file(s)': 'Sélectionnez fichier(s)',
			'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.': 'Seulement jpg jpeg docx doc pdf et png avec un maximum de 2MB',
			'file(s) selected. Click upload to proceed.': 'Fichier(s) sélectionnés. Cliquez sur upload pour procéder au chargement',
			'The file is too large (MB). Allowed maximum size is 2MB.': 'Le fichier est trop gros (MB). La taille maximum autorisée est 2MB.',
			'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.': 'Seulement jpg jpeg docx doc pdf et png sont autorisés',
			'Successfully uploaded!': 'Téléchargé avec succès!',
			'Documents uploaded': 'Documents téléchargés',
			'Delete Document': 'Supprimer document',
			'Are you sure you want to delete this document?': 'Êtes-vous sur de vouloir supprimer ce document?',
			'Cancel': 'Annuler',
			'Delete': 'Supprimer',
			'Account Information': 'Information de compte',
			'Customer ID': 'ID Client',
			'Full name': 'Nom complet',
			'Currency': 'Devise',
			'Country': 'Pays',
			'Date of birth': 'Date de naissance',
			'Join date': 'Date d’inscription',
			'Email Address': 'Adresse e-mail',
			'Phone number': 'Numéro de téléphone',
			'Skype': 'Skype',
			'Username': 'Nom d’utilisateur',
			'K.Y.C documents': 'K.Y.C documents',
			'Password changed.': 'Mot de passe modifié',
			'I want to request a new reset code.': 'Je veux obtenir un nouveau code de ré-initialisation',
			'Loading, please wait...': 'Chargement, merci de patienter...',
			'Request new reset code?': 'Obtenir un nouveau code de ré-initialisation?',
			'Enter your new account password below.': 'Entrez votre nouveau mot de passe ci-dessous',
			'Account password has been successfully updated!': 'Votre mot de passe a été mis à jour avec succès!',
			'Update AMS account password': 'Mettre à jour votre mot de passe de votre compte AMS',
			'Current AMS password': 'Mot de passe actuel',
			'New AMS Password': 'Nouveau mot de passe AMS',
			'Enter current password': 'Entrez votre mot de passe actuel',
			'Enter new password': 'Entrez votre nouveau mot de passe',
			'Confirm new password': 'Confirmez votre nouveau mot de passe',
			'Update': 'Mis à jour',
			'Are you sure you want to delete this Bank Account?': 'Êtes-vous sur de vouloir supprimer ce compte bancaire ?',
			'Add bank accounts for faster transaction.': 'Ajouter un compte bancaire pour des transactions plus rapides',
			'Default': 'Défaut',
			'Link a new bank account': 'Lier un nouveau compte bancaire',
			'Bank account successfully deleted.': 'Compte bancaire supprimé avec succès',
			'Success': 'Succès',
			'Transaction password has been successfully updated!': 'Le mot de passe de transaction a été mis à jour avec succès',
			'Update AMS transaction password': 'Mettre à jour votre mot de passe de transaction AMS',
			'Current AMS transaction password': 'Mot de passe de transaction AMS actuel',
			'Enter current transaction password': 'Entrez votre mot de passe de transaction AMS actuel',
			'New AMS transaction password': 'Nouveau mot de passe de transaction AMS',
			'Enter new transaction password': 'Entrez votre nouveau mot de passe de transaction',
			'Confirm new transaction password': 'Confirmez le nouveau mot de passe de transaction',
			'Account username has been successfully updated!': 'Le nom d’utilisateur a été mis à jour avec succès',
			'Update AMS username': 'Mettre à jour votre nom d’utilisateur',
			'Current AMS username': 'Nom d’utilisateur actuel',
			'New AMS username': 'Nouveau nom d’utilisateur',
			'Enter new username': 'Entrez votre nouveau nom d’utilisateur',
			'Confirm new username': 'Confirmez votre nouveau nom d’utilisateur',
			'Enter password': 'Entrez mot de passe',
			'Security': 'Sécurité',
			'Update your Username, Account and Transaction Password': 'Mettre à jour votre nom d’utilisateur et votre mot de passe de transaction',
			'Temporarily Unavailable': 'Temporairement indisponibles',
			'For inquiries, please contact Customer Support.': 'Pour toute question, merci de contacter le service client',
			'Payment Option': 'Option de paiement',
			'Manage your payment accounts': 'Gérer vos comptes de paiement',
			'Open': 'Ouvert',
			'Pending': 'En cours',
			'Resolved': 'Résolu',
			'Closed': 'Clôturé',
			'Forbidden!': 'Interdit!',
			'My Products': 'Mes produits',
			'Add Product': 'Ajouter produits',
			'Reset Product Password': 'Ré-initialiser mot de passe du produit',
			'New': 'Nouveau',
			'Bank account successfully created.': 'Compte bancaire créé avec succès',
			'Link a bank account': 'Lier un compte bancaire',
			'Enter Account Number': 'Entrer le numéro de compte',
			'Enter Account Name': 'Entrer le nom du compte',
			'Enter Citizenship': 'Entrer nationalité',
			'Enter Address': 'Entrer adresse',
			'Enter Bank Code': 'Entrer code banque',
			'Enter Bank Name': 'Entrer nom de la banque',
			'Enter Bank Address': 'Entrer l’adresse de la banque',
			'Save bank account': 'Sauvegarder compte bancaire',
			'Save': 'Sauvegarder',
			'Limit Reached!': 'Limite atteinte!',
			'Go to Settings': 'Allez aux paramètres',
			'Product password successfully requested.': 'Mot de passe produit demandé avec succès',
			'Warning': 'Attention',
			'Something went wrong. Please try again later.': 'Une erreur s’est produite. Merci de ré-essayer plus tard',
			'Request Product Password': 'Demander mot de passe du produit',
			'Select one or more products to reset password': 'Sélectionnez un ou plusieurs produits à ré-initialiser le mot de passe',
			'View Password': 'Voir le mot de passe',
			'Expires on': 'Expire au',
			'Expired Password': 'Mot de passe expiré',
			'No Password': 'Pas de mot de passe',
			'Enter Transaction Password': 'Entrez mot de passe de transaction',
			'Request': 'Demande',
			'Product password will be available once password has been reset.': 'Le mot de passe du produit sera disponible une fois que le mot de passe aura été ré-initialisé',
			'Warning!': 'Attention!',
			'Warning! The following product/s has pending request': 'Attention! Le produit suivant a une demande en attente',
			'Request Product': 'Demander produit',
			'Please select at least one product below': 'Veuillez SVP choisir au moins un produit ci-dessous',
			'No products available. You already have all the products Asianconnect offers.': 'Aucun produit disponible, vous avez déjà tous les produits proposés par Asianconnect',
			'username': 'Nom d’utilisateur',
			'SINGBET FORCED POSITION TAKING ON ASIANCONNECT': 'SINGBET OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
			'Profit and Loss (PnL)': 'Gain et perte (GnP)',
			'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.': 'Veuillez SVP noter que votre gain/perte sur SINGBET est toujours GnP*0,40',
			'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).': 'Donc si votre mise est de 1000 et que vous gagnez, vous gagnez seulement 400 EUR/GBP (1000*0,40)',
			'Then if you lose, you only lose 400 EUR/GBP.': 'Et si vous perdez, vous perdez seulement 400 EUR/GBP',
			'Deposits': 'Dépôts',
			'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.': 'Votre dépôt sur SINGBET est toujours montant / 0,40. Cela signifie que si vous envoyez 1000 EUR/GBP, nous ajouterons 2500 (1000/0,40=2500) à votre balance SINGBET',
			'Withdrawals': 'Retraits',
			'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.': 'Également, votre retrait sera de /0,40. Cela signifie que si vous souhaitez retirer 1000 EUR/GBP, nous déduirons 2500 (1000/0,40) de votre balance SINGBET',
			'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.': 'Dans votre compte AMS apparaîtra votre solde réel en EUR/GBP, cependant dans votre compte SINGBET cela sera le solde SINGBET',
			'I agree to the Terms and Conditions': 'J’accepte les conditions générales',
			'MAXBET FORCED POSITION TAKING ON ASIANCONNECT': 'MAXBET OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
			'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.': 'Veuillez SVP noter que votre gain/perte sur MAXBET est toujours GnP*0,50.',
			'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).': 'Donc si votre mise est de 1000 et que vous gagnez, vous gagnez seulement 500 EUR/GBP (1000*0,50).',
			'Then if you lose, you only lose 500 EUR/GBP.': 'Et si vous perdez, vous perdez seulement 500 EUR/GBP.',
			'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.': 'Votre dépôt sur MAXBET est toujours montant / 0,50. Cela signifie que si vous envoyez 1000 EUR/GBP, nous ajouterons 2000 (1000/0,50=2000) à votre balance MAXBET',
			'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.': 'Également, votre retrait sera de /0,50. Cela signifie que si vous souhaitez retirer 1000 EUR/GBP, nous déduirons 2000 (1000/0,50) de votre balance MAXBET',
			'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.': 'Dans votre compte AMS apparaîtra votre solde réel en EUR/GBP, cependant dans votre compte MAXBET cela sera le solde MAXBET',
			'SBOBET Forced Position Taking ON ASIANCONNECT': 'SBOBET OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
			'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.': 'Veuillez SVP noter que votre gain/perte sur SBOBET est toujours GnP*0,30. Donc si votre mise est de 1000 et que vous gagnez, vous gagnez seulement 300 EUR/GBP (1000*0,30). Et si vous perdez, vous perdez seulement 300 EUR/GBP.',
			'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Votre dépôt sur SBOBET est toujours montant / 0,30. Cela signifie que si vous envoyez 1000 EUR/GBP, nous ajouterons 3333,33 (1000/0,30=3333,33) à votre balance SBOBET',
			'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Également, votre retrait sera de /0,30. Cela signifie que si vous souhaitez retirer 1000 EUR/GBP, nous déduirons 3333,33 (1000/0,30) de votre balance SBOBET',
			'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.': 'Dans votre compte AMS apparaîtra votre solde réel en EUR/GBP, cependant dans votre compte SBOBET cela sera le solde SBOBET',
			'9WICKETS FORCED POSITION TAKING ON ASIANCONNECT': '9WICKETS OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
			'Please note that 9wickets have 3% commission rate applied to your winnings.': 'Veuillez SVP noter que 9wickets applique une commission de 3% sur l’ensemble de vos gains',
			'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.': 'Veuillez également noter que 9Wickets effectue un contrôle quotidien de tous les paris placés sur leur plateforme. S’ils s’aperçoivent d’une quelconque irrégularité ou fraude, ils se réservent le droit de clôturer votre compte et de garder vos fonds.',
			'ORBITX FORCED POSITION TAKING ON ASIANCONNECT': 'ORBITX OBLIGE ASIANCONNECT A PRENDRE POSITION SUR LES PARIS',
			'Please note that OrbitX have 3% commission rate applied to your winnings.': 'Veuillez SVP noter que ORBITX applique une commission de 3% sur l’ensemble de vos gains',
			'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.': 'Veuillez également noter que ORBITX effectue un contrôle quotidien de tous les paris placés sur leur plateforme. S’ils s’aperçoivent d’une quelconque irrégularité ou fraude, ils se réservent le droit de clôturer votre compte et de garder vos fonds.',
			'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT': 'Conditions générales pour les paris via SKYPE',
			'You can contact us via Skype at': 'Vous pouvez nous contacter via skype à',
			'NV for Skype betting Terms and Conditions.': 'Conditions générales pour les paris via skype',
			'Successfully added!': 'Ajouté avec succès!',
			'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.': 'Le(s) produit(s) suivant(s) a été ajouté. Vous pouvez désormais effectuer un dépôt sur votre compte. Vous recevrez votre nom d’utilisateur et votre mot de passe aussitôt après que nous ayons reçu votre premier dépôt. Merci',
			'About Us': 'A propos de nous',
			'Contact Us': 'Contactez-nous',
			'Legal Disclaimer': 'Avertissement légal',
			'Privacy Policy': 'Politique de confidentialité',
			'Go To Transaction Overview': 'Allez au résumé des transactions',
			'Notification': 'Notification',
			'was deleted.': 'a été supprimé.',
			'Failed to delete': 'Impossible de supprimer',
			'file has been uploaded.': 'Le fichier a été téléchargé',
			'Failed to upload': 'Impossible de télécharger',
			'Paste an address where you want to receive BTC': 'Collez l’adresse sur laquelle vous souhaitez recevoir vos bitcoins',
			'New referral': 'Nouvel affilié',
			'has been linked.': 'a été lié.',
			'Referral': 'Affilié',
			'has been unlinked.': 'a été annulé.',
			'Product/s': 'Produit/s',
			'has been added.': 'a été ajouté.',
			'Transaction': 'Transaction',
			'has been': 'a été',
			'Deposit': 'Dépôt',
			'Withdraw': 'Retrait',
			'Transfer': 'Transfert',
			'P2P Transfer': 'Transfert P2P',
			'Approved': 'Approuvé',
			'Acknowledged': 'Pris en compte',
			'Processed': 'Effectué',
			'Saved': 'Sauvegardé',
			'Invalid Credentials!': 'Les informations d’identification invalides!',
			'Email': 'E-mail'
		}, (0, _defineProperty3.default)(_ref, 'Account ID', 'ID compte'), (0, _defineProperty3.default)(_ref, 'Name', 'Nom'), (0, _defineProperty3.default)(_ref, 'Request Deposit', 'Demande de dépôt'), (0, _defineProperty3.default)(_ref, 'Request Withdrawal', 'Demande de retrait'), (0, _defineProperty3.default)(_ref, 'Upload', 'Télécharger'), (0, _defineProperty3.default)(_ref, 'W/L', 'W/L'), (0, _defineProperty3.default)(_ref, 'Bonus', 'Prime'), (0, _defineProperty3.default)(_ref, 'Revenue Share', 'Partage des revenus'), (0, _defineProperty3.default)(_ref, 'Total W/L:', 'Total W/L:'), (0, _defineProperty3.default)(_ref, 'Total Bonus:', 'Bonus total:'), (0, _defineProperty3.default)(_ref, 'Total Revenue Share:', 'Partage total des revenus:'), (0, _defineProperty3.default)(_ref, 'Unlimited', 'Illimité'), (0, _defineProperty3.default)(_ref, 'Instant', 'Instantané'), (0, _defineProperty3.default)(_ref, 'My Tickets', 'Mes tickets'), (0, _defineProperty3.default)(_ref, 'Product is required', 'Un produit est requis'), (0, _defineProperty3.default)(_ref, 'Transaction password invalid', 'Mot de passe de transaction invalide'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been saved', 'La demande de dépôt a été sauvegardée'), (0, _defineProperty3.default)(_ref, 'Product has been added', 'Le produit a été ajouté'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been saved', 'La demande de retrait a été sauvegardée'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been saved', 'La demande de transfert a été sauvegardée'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been declined', 'La demande de dépôt a été refusée'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been declined', 'La demande de retrait a été refusée'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been declined', 'La demande de transfert a été refusée'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been voided', 'La demande de dépôt a été annulée'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been voided', 'La demande de retrait a été annulée'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been voided', 'La demande de transfert a été annulée'), (0, _defineProperty3.default)(_ref, 'Documents uploaded:', 'Documents téléchargés:'), (0, _defineProperty3.default)(_ref, 'Warning! At least one product is required.', 'Attention! Au moins un produit est requis'), (0, _defineProperty3.default)(_ref, 'paymentOptionsViewDetails', 'Important : Après avoir effectué un dépôt, veuillez svp remplir ce champ. Si cela n’est pas effectué, votre dépôt sera retardé. Cette procédure est nécessaire afin de nous informer de votre dépôt pour que nous puissions l’ajouter sur votre compte.'), (0, _defineProperty3.default)(_ref, 'File(s) still uploading, please wait.', 'Fichier (s) en cours de téléchargement, veuillez patienter.'), (0, _defineProperty3.default)(_ref, 'DEPOSIT', 'DÉPÔT'), (0, _defineProperty3.default)(_ref, 'WITHDRAWAL', 'RETRAIT'), (0, _defineProperty3.default)(_ref, 'TRANSFER', 'TRANSFERT'), (0, _defineProperty3.default)(_ref, 'BONUS', 'PRIME'), (0, _defineProperty3.default)(_ref, 'PSP TRANSFER', 'PART DES REVENUS'), (0, _defineProperty3.default)(_ref, 'COMMISSION', 'COMMISSIONS'), (0, _defineProperty3.default)(_ref, 'DEBIT', 'DÉBIT'), (0, _defineProperty3.default)(_ref, 'CREDIT', 'CRÉDIT'), (0, _defineProperty3.default)(_ref, 'REVENUE SHARE', 'PART DES REVENUS'), (0, _defineProperty3.default)(_ref, 'RESET BOOKIE PASSWORD', 'Réinitialiser mot de passe de bookmaker'), (0, _defineProperty3.default)(_ref, 'Ecopayz Merchant Account (EUR)', 'Compte marchand Ecopayz (EUR)'), _ref;
	}

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(1673);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.es = es;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function es() {
		var _ref;
	
		return _ref = {
			'form': {
				'from': 'Desde',
				'to': 'A',
				'username': 'Nombre Usuario',
				'password': 'Contraseña',
				'type': 'Tipo',
				'status': 'Estado',
				'transactionPassword': 'Contraseña de Transaccion',
				'confirmUsername': 'Confirmar Nombre Usuario',
				'confirmPassword': 'Confirmar Contraseña',
				'confirmTransactionPassword': 'Confirmar Contraseña de Transaccion',
				'paymentOption': 'Opción de Pago',
				'fromProduct': 'Desde Producto',
				'email': 'Corre electrónico',
				'website': 'Pagina Web',
				'promotion': 'Promoción',
				'advertisement': 'Anuncio',
				'language': 'Idioma',
				'size': 'Tamaño',
				'campaign': 'Nombre de la Campaña',
				'referralCode': 'Código de Referencia',
				'newPassword': 'Nueva contraseña',
				'iban': 'Numero de cuenta bancaria /IBAN',
				'accountName': 'Nombre cuenta / Nombre Compañía',
				'birthDate': 'Fecha de nacimiento',
				'citizenship': 'Ciudadania',
				'address': 'Direccion',
				'swift': 'Código Banco (BIC) /SWIFT',
				'bankName': 'Nombre Banco',
				'bankAddress': 'Dirección Banco',
				'isDefault': 'Usar como predeterminado'
			},
			'titles': {
				'bankAccount': 'Cuneta de Banco',
				'dashboard': 'Escritorio',
				'account': 'Mi Cuenta',
				'profile': 'Mi Perfil',
				'transaction': 'Transacciones',
				'transactionHistory': 'Historial de Transacciones',
				'overview': 'Vision General',
				'deposit': 'Depositos',
				'withdrawal': 'Retiradas',
				'transfer': 'Transferencias',
				'productWallet': 'Transferencias (Cartera de productos)',
				'p2pTransfer': 'Transferencias (Persona a persona)',
				'skypeBetting': 'Apuestas por Skype',
				'outstandingBets': 'Apuestas Abiertas',
				'betHistory': 'Historial de Apuestas',
				'betOverview': 'Resumen de apuestas',
				'affiliate': 'Afiliados',
				'affiliateDashboard': 'Escritorio de Afiliados',
				'affiliateTools': 'Herramientas de Afiliados',
				'supportTickets': 'Entradas de apoyo',
				'settings': 'Ajustes',
				'mobileSite': 'AMS Sitio Mobil',
				'Valid Turnover/Commissions': 'Rotación Válida/Comisiones',
				'products': 'Productos',
				'size': 'Tamaño',
				'campaign': 'Nombre Campaña',
				'referralCode': 'Código de referencia',
				'website': 'Pagina Web',
				'tickets': 'Entradas de apoyo'
			},
			'tables': {
				'product': 'Producto',
				'memberId': 'Identificación del usuario',
				'totalTurnover': 'Total TO',
				'totalWinLoss': 'Ganancia/Pérdida del cliente',
				'totalCommission': 'Comisión de Afiliados',
				'date': 'Fecha',
				'transactionNumber': 'Transacción #',
				'type': 'Tipo',
				'language': 'Idioma',
				'currency': 'Moneda',
				'paymentOption': 'Opción de Pago',
				'amount': 'Cantidad',
				'status': 'Estado',
				'Total Commission': 'Comisión Total',
				'subject': 'Tema',
				'description': 'Descripcion',
				'username': 'Nombre Usuario',
				'balance': 'Balance',
				'dateLastUpdated': 'Ultimo Dia Actualizado'
			},
			'Reset password': 'Restablecer contraseña',
			'Activate Later': 'Activar mas tarde',
			"You're on your way to earning a lifetime commission. Just follow 4 easy steps.": "Tienes la forma de ganar una comisión de por vida. Solo sigue estos 4 pasos sencillos",
			'I confirm that I have read and accepted': 'Confirmo que he leido y aceptado',
			'Asianconnect Affiliates Terms and Conditions': 'Términos y condiciones de Asianconnect Afiliados',
			'Get Started': 'Empezar',
			'Banners and Referral Codes': 'Banners y Codices de Referencia',
			'Learn more': 'Aprender Mas',
			'Archive': 'Archivo',
			'generateBannerNote': 'Simplemente complete el formulario con los detalles de su campaña y generaremos un enlace de referencia y un banner para usted',
			'Setup your username and password now': 'Configure ahora tu nombre de usuario y contraseña',
			'Welcome to AC Affiliates!': 'Bienvenido a AC Afiliados!',
			'Please enter your Campaign Name': 'Por favor introduzca el nombre de la campaña',
			'Please enter your Referral Code': 'Por favor introduzca su Codigo de Referencia',
			'Get code': 'Conseguir código',
			'Reset': 'Reiniciar',
			'Generate': 'Generar',
			'referralCodeNote': 'Puede reutilizar su Codigo de Referencia existente o crear uno nuevo.',
			'Special characters and spaces are not allowed.': 'Caracteres especiales y espacios no están permitidos',
			'See Preview': 'Ver vista previa',
			'Preview': 'Vista previa',
			'Please enter your website URL': 'Por favor introduzca el URL de su pagina web',
			'Please contact Customer Support.': 'Por favor contacte con el servicio al cliente',
			'Change email': 'Cambiar correo electronico',
			'Transfer from': 'Transferido de',
			'Transfer to': 'Transferido a',
			'Product': 'Producto',
			'Please Select': 'Por favor seleccione',
			'Commission Period': 'Periodo de Comision',
			'Original Payout Date': 'Fecha de pago inicial',
			'to': 'a',
			'Reason': 'Motivo',
			'commission': 'comision',
			'Search': 'Buscar',
			'Reset Filter': 'Reajustar Filtro',
			'All Status': 'Todos los estados',
			'Product Username': 'Nombre de usuario del Producto',
			'All Payment Options': 'Opciones de pago',
			'All types': 'Todos los tipos',
			'Sign In': 'Registrarse',
			'Sign in to start your session': 'Registre para iniciar su sesión',
			'Please wait, Logging in...': 'Por favor espere blogueando',
			'signOut': 'Desconecar',
			'memberSince': 'Miembro desde',
			'Note:': 'Notas:',
			'Note': 'Notas',
			'makeDeposit': 'Hacer deposito para incrementar fondos',
			'welcome': 'Bienvenido a la pagina de miembros de Asianconnect',
			'setup': 'Configura ahora tu nombre de usuario y contraseña',
			'to activate your account.': 'activar tu cuenta',
			'setupNote': 'Nota: Su nombre de usuario y contraseña temporales se enviaron a su correo electronico',
			'Proceed': 'Proceder',
			'Deposit Now': 'Depositar ahora',
			'Available Balance': 'Saldo disponible',
			'Unallocated Balance': 'Saldo no asignado',
			'Account Status': 'Estado de la cuenta',
			'Quick Links': 'Enlaces rapidos',
			'BETA': 'BETA',
			'Verified': 'Verificado',
			'Not Verified': 'No Verificado',
			'Filter': 'Filtrar',
			'Request Transfer': 'Solicitud de trasnferencia',
			'loadingPageContent': 'Cargando contenido de la pagina, por favor espere',
			'Date Covered:': 'Fecha Cubierta:',
			'Total Turnover:': 'Facturación Total:',
			'Total Affiliate Commission:': 'Comisión Total de Afiliados:',
			'Total Customer W/L:': 'Ganancia/Perdida Total del Ciente:',
			'exportCsv': 'Exportar a CSV',
			'noProduct': 'Sin producto',
			'somethingWentWrong': 'Algo salió mal. Por favor comprueba tus detalles.',
			'activated': 'Has activado exitosamente su cuenta.',
			'Account Activation': 'Activación de la cuenta',
			'activateAccountNote': 'Active a continuación su cuenta activado sus credenciales',
			'usernameValidation': 'Solo debe contener números, letras y guiones.',
			'passwordValidation': 'Debe tener al menos 8 caracteres que contentan al menos 2 letras, 2 números y 2 simbolos',
			'transactionPasswordValidation': 'Debe ser alfanumerico con un mínimo de 6 caracteres y tener al menos una letra mayuscula',
			'Re-enter username': 'Vuelva a ingresar nombre de usuario',
			'Re-enter password': 'Escriba otra vez la contraseña',
			'Re-enter transaction password': 'Vuelva a ingresar la contraseña de la transaccion',
			'Activate account': 'Activar la cuenta',
			'Clear All': 'Borrar todo',
			'skrillContent': 'Inicie sesión en su cuenta SKRILL y transfiera los fondos solicitados ',
			'netellerContent': 'Inicie sesión en su cuenta NETELLER y transfiera los fondos solicitados ',
			'verifyDeposit': 'Estamos verificando su deposito. Una vez que recibamos su depósito, vera los fondos adicionados.',
			'netellerTransferNote': 'Inicie sesión en su cuenta NETELLER y transfiera los fondos solicitados ',
			'netellerTransferNote2': 'con código de transferencia de ',
			'you will see the additional funds reflected in your account.': 'Vera los fondos adicionales reflejados en su cuenta',
			'CONTINUE': 'Continuar',
			'cantProcessRequest': "Lo sentimos, no hemos podido procesar su solicitud en este momenot",
			'Sorry': 'Lo siento',
			'Thank you': 'Gracias',
			'OK': 'Vale',
			'For making a deposit': 'Para hacer un depósito',
			'We are now verifying your deposit. Once we have received your deposit,': 'Estamos verificado su deposito. Una vez que hayamos recibido su deposito',
			'bankNotice': 'Las transferencias bancarias esta restringida en este momento. Para consolas por favor contacte con el servicio al cliente . Gracias',
			'bankRestricted': 'Transferencias bancas están restringidas en su pais. Por favor, utilice otros metodos de pago. Por favor utilice otro método de pago.',
			'processingTime': 'Tiempo de procesamietno',
			'fee': 'Tasas',
			'minimumDeposit': 'Mínima cantidad de depósito',
			'maximumDeposit': 'Máxima cantidad de depósito',
			'chooseProductDeposit': 'Simplemente elija su producto preferido (casa de apuestas), ingrese la cantidad y luego haga clic en Solicitar Depósito',
			'Product Name': 'Nombre del producto',
			'Amount': 'Cantidad',
			'fileValidation': 'Solo se permiten archivos jpg jeeps y png con un máximo de 2MB',
			'Transaction Summary': 'Resumen de transacciones',
			'Total amount to be deposited in your account': 'Importe total a depositar en su cuenta',
			'Total amount to be sent in your account': 'Importe total a enviar a su cuenta',
			'You have submitted the BTC deposit request form.': 'Usted ha enviado el formulario de solicitud de depósito de BTC',
			'Please send the BTC amount to the BTC address below. This address is unique to your account.': 'Por favor envíe el monto de BTC al a la siguiente dirección de BTC. Esta dirección es única para su cuenta.',
			'Tap or Scan to pay': 'Toque o escanee para pagar',
			'Show QR': 'Mostar QR',
			'Total BTC to be sent': 'BTC total a enviar',
			'Recipient BTC Address': 'Dirección BTC del destinatario',
			'Please send total BTC to the recipient address.': 'Por favor envíe el total de BTC a la dirección del destinatario.',
			'Copy': 'Copiar',
			'Rate Used per BTC': 'Tarifa utilizada por BTC',
			'Please send bitcoin in': 'Por favor envie bitcoin en',
			'minutes.': 'minutos.',
			'This page will automatically refresh when Bitcoin has been sent.': 'Esta página se actualizará automáticamente cuando se haya enviado los Bitcoins.',
			'Thank you for sending the requested amount!': 'Gracias por enviar la cantidad solicitada¡',
			'We are now waiting for your Bitcoin confirmations.': 'Estamos esperando la confirmación de sus Bitcoins.',
			'confirmation(s) received': 'confirmación recibida',
			'Status': 'Estado',
			'Thank you for making a deposit!': 'Gracias por hacer un depósito¡',
			'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.': 'Estamos verificado su depósito. Una vez que hayamos recibido su depósito, vera los fondos adicionales reflejados en su cuenta.',
			'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.': 'Estamos a la espera de recibir sus bitcoins. La pagina se actualizará automáticamente cuando se haya recibido los bitcoins.',
			'Requested: waiting to receive bitcoin': 'Solicitado: a la espera de recibir bitcoin',
			'Note: Please contact Support if you made a request by mistake and would like to request again': 'Nota: Póngase en contacto con el Servicio de asistencia técnica si realizó una solicitud por error y desea solicitarla de nuevo',
			'bitcoinDeclined': "Dispulce, su solicitud fue DECLINADA probablemente porque no recibimos sus bitcois. Si se trata de un error, póngase en contacto con nuestro servicio de asistencia y le atenderemos de inmediato",
			'Close': 'Cerrar',
			'Exchange Rate': 'Tipo de cambio',
			'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.': 'Nota: La tasa de depósito se actualiza en tiempo real, y se bloqueara una vez recibida su solicitud.',
			'Total BTC amount to send:': 'Cantidad total de BTC a enviar:',
			'Total EUR amount to receive:': 'Importe total de EUR a recibir:',
			'Transaction Status': 'Estado de la transacción',
			'Requested': 'Pedido',
			'Pending Confirmation': 'Pendiente de confirmación',
			'Confirmed': 'Confirmado',
			'Declined': 'Rechazad',
			'Voided': 'Anulado',
			'Account ID': 'ID de la cuenta',
			'Amount to deposit': 'Cantidad a depositar',
			'Total amount to deposit': 'Importe total a depositar',
			'Free': 'Gratis',
			'Add product': 'Añadir Producto',
			'Make new request': 'Hacer una nueva solicitud',
			'we will send you the username and password of your newly registered account.': 'le enviaremos el nombre de usuario y la contraseña de su cuenta recién registrada.',
			'Total amount to be deposited on account': 'Importe total a depositar en su cuenta',
			'Total amount to be deducted from account': 'Importe total a deducir de su cuenta',
			'Total amount to be sent': 'Importe total a enviar',
			'Total amount to be received': 'Importe total a recibir',
			'Enter product username': 'Introduzca el nombre de usuario del producto',
			'Total amount to send': 'Importe total a enviar',
			'Request is successfully created!': 'La solicitud se ha creado correctamente.',
			'Please wait for customer service confirmation. You can view transaction status in Transactions overview.': 'Por favor, espere la confirmación del servicio al cliente. Puede ver el estado de la transacción en el Resumen de Transacciones.',
			'Unable to Transfer': 'No se puede transfer',
			'Please contact our customer service team to have your account verified. Thank you.': 'Póngase en contacto con nuestro servicio de atención al cliente para verificar su cuenta. Gracias',
			'No product(s) available for selection.': 'No hay productos disponibles para la selección',
			'Opps, amount is not enough!': 'Apps la cantidad no es suficiente¡',
			'Minimum amount that can be withdrawn is 100 EUR/GBP.': 'La cantidad mínima que se puede retirar son 100 EUR/GBP',
			'Do you want ': 'Quieres ',
			'to be your default bank for withdrawal?': 'que sea tu banco por defecto para el retiro?',
			'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.': 'Ha seleccionado Transferencia bancaria como su método de pago preferido. Si desea elegir contro método de pago, haga clic en las siguientes pestañas.',
			'Minimum Withdrawal Amount': 'Cantidad mínima de retiro',
			'Maximum Withdrawal Amount': 'Cantidad máxima de retiro',
			'Bank Account': 'Cuenta bancaria',
			'Link new bank account': 'Vincular nueva cuenta bancaria',
			'transactionPasswordHint': 'Sugerencia: Si ha sido un cliente existente desde Marzo de 2017 y no ha configurado su contraseña de transacción, esta es su respuesta a la pregunta de seguridad: Cual es su trabajo soñado?',
			'Beneficiary name': 'Nombre del beneficiario',
			'Beneficiary address': 'Dirección del beneficiario',
			'IBAN': 'IBAN',
			'Bank name': 'Nombre del banco',
			'Bank address': 'Dirección del banco',
			'SWIFT': 'SWIFT',
			'Total amount to be deducted from your account': 'Importe total a deducir de su cuenta',
			'Total amount to be received in your account': 'Importe total a recibir en su cuenta',
			'Confirmation Message': 'Mensaje de confirmacion',
			'Yes': 'Sí',
			'No': 'No',
			'confirmations': 'Confirmación',
			'Please select product(s) where you want to withdraw, and input the amount in': 'Por favor seleccione los productos en los que desea retirar e ingrese la cantidad en',
			'or BTC': 'o BTC',
			'Total BTC': 'Total BTC',
			'SEND TO': 'Enviar a',
			'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.': 'Por favor, asegúrese de que su dirección de Bitcoin es correcta. Le enviaremos su BTC a esta dirección.',
			'Total BTC amount to receive': 'Total BTC a recibir',
			'Total': 'Total',
			'amount to be deducted': 'importe a ser deducido',
			'Amount to deduct': 'Importe a deducir',
			'Total amount to receive': 'Total importe a recibir',
			'Opps, we need to know where to wire your funds.': 'Oops necesitamos saber dónde transferir sus fondos',
			'Please fill in the required bank details. Thank you!': 'Por favor complete los datos bancarios requeridos. Gracias¡',
			'Unable to withdraw': 'No se puede retirar',
			'Invalid Action!': 'Acción no valida¡',
			'A product where the fee should be charged is required.': 'Se requiere producto donde se deba cobrar la tarifa.',
			'Reset link was sent to your email.': 'Restablecer enlace fue enviado a su correo electrónico',
			'Success!': 'Exito!',
			'Send reset password link': 'Enviar enlace restablecer contraseña',
			"Enter the email you use for Asianconnect88, and we'll help you create a new password.": "Ingrese el correo electrónico que usa para Asiancconnect88 y te ayudaremos con una nueva contraseña",
			'English': 'Inglés',
			'French': 'Francés',
			'German': 'Alemán',
			'Spanish': 'Español',
			'Asian Odds': 'Asian Odds',
			'Note: Referral URL is your unique link where you can share to everyone': 'Nota: La URL de referencia es su enlace único que puede compartirlo con todo el mundo',
			'Referral HTML Code': 'Código HTML de referencia',
			'copyReferralCodeNote': 'Simplemente copia o descarga el código HTML de su campana y péguelo en la sección de su página web donde desee mostrarlo',
			'Download HTML': 'Descargar HTML',
			'Terms and Conditions': 'Términos y condiciones',
			'and': 'y',
			'Commission Scheme': 'Esquema de comisiones',
			'apply': 'aplicar',
			'Referral URL': 'URL de referencia',
			'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.': 'Nota: Su URL es un único enlace que puede usar para recomendar nuevos miembros a Asianconnect',
			'Information': 'Información',
			'Get a unique tracking link for your campaign.': 'Obtenga un enlace de seguimiento único para su campaña.',
			'Website. Input your website URL.': 'Sitio web. Introduzca la URL de su sitio web',
			'Banner type. Pick a banner type: (language/size/promo)': 'Tipo de banner. Elija un tipo de banner (idioma/tamaño/promoción)',
			'Campaign. Name your campaign.': 'Campaña. Nombra tu campaña.',
			'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.': 'Código de localización. Tienes un código de seguimiento preferido?. Introduzca el código de seguimiento preferido. Haga clic Generar.',
			'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.': 'Su Codigo de Referencia URL es un enlace único que pude usar para recomendar a nuevos mientras a Asianconnect',
			'campaignNote': 'Simplemente copie o descargue el código HTML de su campaña y péguelo en la sección donde desea que e muestre el banner en su sitio web',
			'Preview archived banner': 'Vista previa del banner archivado',
			'Uploaded': 'Subido',
			'Drag and drop files here or': 'Arrastar y soltar archivos aquí',
			'Select file(s)': 'Selección archivos',
			'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.': 'Solo se permite .jp .jpeg .docx doc pdf -png con un máximo de 2MB',
			'file(s) selected. Click upload to proceed.': 'archivo(s) seleccionado(s). Haga click en subir para continuar',
			'The file is too large (MB). Allowed maximum size is 2MB.': 'El archivo es demasiado grande (MB). El tamaño máximo permitido es de 2MB.',
			'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.': 'Solo se permiten .jpeg .jpg .png .pdf .doc y .docx son permitidos',
			'Successfully uploaded!': 'Cargado con éxito!',
			'Documents uploaded': 'Documentos subidos',
			'Delete Document': 'Eliminar documento',
			'Are you sure you want to delete this document?': 'Estás seguro que quieres eliminar este documento?',
			'Cancel': 'Cancelar',
			'Delete': 'Borrar',
			'Account Information': 'Información de la cuenta',
			'Customer ID': 'Identificación de la cuenta',
			'Full name': 'Nombre completo',
			'Currency': 'Moneda',
			'Country': 'País',
			'Date of birth': 'Fecha de nacimienot',
			'Join date': 'Fecha de ingreso',
			'Email Address': 'Correo electrónico',
			'Phone number': 'Número de teléfono',
			'Skype': 'Skype',
			'Username': 'Nombre de usuario',
			'K.Y.C documents': 'Documentos de K.Y.C',
			'Password changed.': 'Contraseña cambiada',
			'I want to request a new reset code.': 'Quiero solicitar un nuevo código de reinicio',
			'Loading, please wait...': 'Cargando por favor espere…',
			'Request new reset code?': 'Solicitar nuevo código de reinicio?',
			'Enter your new account password below.': 'Introduzca su nueva contraseña a continuación',
			'Account password has been successfully updated!': 'La contraseña de la cuenta ha sido actualizada exitosamente!',
			'Update AMS account password': 'Actualizar la contraseña de la cuenta AMS',
			'Current AMS password': 'Contraseña actual de AMS',
			'New AMS Password': 'Nueva contraseña de AMS',
			'Enter current password': 'Introduzca la contraseña actual',
			'Enter new password': 'Introduzca la contraseña nueva',
			'Confirm new password': 'Confirma la nueva contraseña',
			'Update': 'Actualizar',
			'Are you sure you want to delete this Bank Account?': 'Esta seguro de que desea eliminar esta cuenta bancaria?',
			'Add bank accounts for faster transaction.': 'Añadir cuentas bancarias para una transacción mas rápida',
			'Default': 'Defecto',
			'Link a new bank account': 'Vincular una nueva cuenta bancaria',
			'Bank account successfully deleted.': 'Cuenta bancaria eliminada con éxito',
			'Success': 'Éxito',
			'Transaction password has been successfully updated!': 'Contraseña de transacción actualizada con éxito',
			'Update AMS transaction password': 'Actualizar la contraseña de transacción de AMS',
			'Current AMS transaction password': 'Contraseña de transacción actual de AMS',
			'Enter current transaction password': 'Ingrese la contraseña de transacción de AMS',
			'New AMS transaction password': 'Nueva contraseña de transacción de AMS',
			'Enter new transaction password': 'Introduzca una nueva contraseña de transacción',
			'Confirm new transaction password': 'Confirmar nueva contraseña de transacción',
			'Account username has been successfully updated!': 'El nombre de usuario de la cuenta se ha actualizado correctamente',
			'Update AMS username': 'Actualizar el nombre de usuario de AMS',
			'Current AMS username': 'Nombre usuario actual de AMS',
			'New AMS username': 'Introduce un nuevo nombre de usuario de AMS',
			'Enter new username': 'Introduce nuevo nombre de usuario',
			'Confirm new username': 'Confirmar nuevo nombre de usuario',
			'Enter password': 'Introducir contraseña',
			'Security': 'Seguridad',
			'Update your Username, Account and Transaction Password': 'Actualice su cuenta de usuario y contraseña de la transacción',
			'Temporarily Unavailable': 'Temporalmente no disponible',
			'For inquiries, please contact Customer Support.': 'Para consultas, póngase en contacto con Atención al cliente',
			'Payment Option': 'Opciones de pago',
			'Manage your payment accounts': 'Gestiona tus cuentas de pago',
			'Open': 'Abierto',
			'Pending': 'Pendiente',
			'Resolved': 'Resuelto',
			'Closed': 'Cerrado',
			'Forbidden!': 'Prohibido!',
			'My Products': 'Mis productos',
			'Add Product': 'Añadir producto',
			'Reset Product Password': 'Restablecer contraseña del producto',
			'New': 'New',
			'Bank account successfully created.': 'Cuenta bancaria creada con éxito.',
			'Link a bank account': 'Vincular una cuenta bancaria',
			'Enter Account Number': 'Ingrese numero de cuenta',
			'Enter Account Name': 'Ingrese nombre de la cuenta',
			'Enter Citizenship': 'Ingrese Ciudadanía',
			'Enter Address': 'Ingrese Dirección',
			'Enter Bank Code': 'Ingrese Código Bancario',
			'Enter Bank Name': 'Ingrese Nombre del Banco',
			'Enter Bank Address': 'Ingrese Dirección del Banco',
			'Save bank account': 'Guardar cuenta bancari',
			'Save': 'Guardar',
			'Limit Reached!': 'Limite alcanzado',
			'Go to Settings': 'Ir a la configuración',
			'Product password successfully requested.': 'Contraseña del producto solicitada con éxito',
			'Warning': 'Advertencia',
			'Something went wrong. Please try again later.': 'Algo salió mal. Por favor, intento de nuevo más tarde.',
			'Request Product Password': 'Solicitar contraseña del producto.',
			'Select one or more products to reset password': 'Seleccione uno o mas productos para restablecer la contrseña.',
			'View Password': 'Ver contraseña',
			'Expires on': 'Expira el',
			'Expired Password': 'Contraseña Caducada',
			'No Password': 'Sin Contraseña',
			'Enter Transaction Password': 'Introduzca la contraseña de la transaccion',
			'Request': 'Solicitud',
			'Product password will be available once password has been reset.': 'La contraseña del producto estará disponible una vez que la contraseña se haya restablecido',
			'Warning!': 'Advertencia!',
			'Warning! The following product/s has pending request': 'Advertencia!. El siguiente producto/s tiene una solicitud pendiente',
			'Request Product': 'Solicitar producto',
			'Please select at least one product below': 'Por favor seleccione al menos un producto a contiuacion',
			'No products available. You already have all the products Asianconnect offers.': 'No hay productos disponibles. Ya tienes todos los productos que ofrece Asianconnect',
			'username': 'Nombre de usuario',
			'SINGBET FORCED POSITION TAKING ON ASIANCONNECT': 'POSICIÓN FORZADA QUE TOMA ASIANCONNECT DE SINGBET',
			'Profit and Loss (PnL)': 'Pérdidas y Ganacias (PyG)',
			'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.': 'Tenga en cuenta que su ganancia/pérdida en SINGBET es siempre (PyG) *0,40',
			'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).': 'Entonces, si su apuesta es 1000 euros y gana, solo ganaría 400 EUR/GBP (1000*0,40)',
			'Then if you lose, you only lose 400 EUR/GBP.': 'Entonces, si pierdes, solo perderá 400 EUR/GBP',
			'Deposits': 'Depósitos',
			'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.': 'Su depósito en SINGBET es siempre de /0,40. Esto significa que si envía 1000 EUR/GBP agregaremos 2500 (1000/0.4=2500) a su cuenta de crédito de SINGBET.',
			'Withdrawals': 'Retiradas',
			'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.': 'Igualmente su cantidad de retiro es /0.40. Esto significa que si desea retirar 1000 EUR/GBP, deduciremos 2500 (1000/0,4) de su crédito de SINGBET.',
			'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.': 'En la cuenta AMS aparecerá el dinero EUR/GBP, sin embargo, en su cuenta de SINGBET aparecera el dinero de SINGBET.',
			'I agree to the Terms and Conditions': 'Estoy de acuerdo con los términos y condiciones.',
			'MAXBET FORCED POSITION TAKING ON ASIANCONNECT': 'POSICIÓN FORZADA QUE ASIANCONNECT TOMA DE MAXBET',
			'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.': 'Tenga en cuenta que su ganancia/pérdida en MAXBET es siempre (PyG)*0,50',
			'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).': 'Entonces, si su apuesta es 1000 y gana, solo gana 500 EUR/GBP (1000*0,50)',
			'Then if you lose, you only lose 500 EUR/GBP.': 'Entonces, si pierdes, solo perderá 500 EUR/GBP',
			'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.': 'Su depósito en MAXBET es siempre de /0,50. Esto significa que si envia 1000 EUR /GBP agregaremos 2000 (1000/0,50=2000) a su cuenta de crédito de MAXBET.',
			'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.': 'Igualmente su cantidad de retiro es /0.50. Esto significa que si desea retirar 1000 EUR/GBP, deduciremos 2000 (1000/0,5) de su crédito de MAXBET.',
			'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.': 'En la cuenta AMS aparecerá el dinero EUR/GBP, sin embargo, en su cuenta de MAXBET aparecera el dinero de MAXBET.',
			'SBOBET Forced Position Taking ON ASIANCONNECT': 'POSICION FORZADA QUE ASIANCONNECT TOMA DE SBOBET',
			'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.': 'Tenga en cuenta que su ganancia/pérdida en SBOBET es siempre (PyG)*0,30. Entonces, si su apuesta es 1000 y gana, solo gana 300 EUR/GBP (1000*0,30). Entonces, si pierdes, solo perderá 300 EUR/GBP.',
			'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Su depósito en SBOBET es siempre de /0,30. Esto significa que si envía 1000 EUR/GBP agregaremos 3333,33 (1000/0,30=3333,33) a su cuenta de crédito de SBOBET.',
			'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Igualmente su cantidad de retiro es /0,30. Esto significa que si desea retirar 1000 EUR/GBP, deduciremos 3333,33 (1000/0,30 = 3333,33) de su crédito de SBOBET.',
			'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.': 'En la cuenta AMS aparecerá el dinero EUR/GBP, sin embargo, en su cuenta de SBOBET aparecera el dinero de SBOBET.',
			'9WICKETS FORCED POSITION TAKING ON ASIANCONNECT': 'POSICION FORZADA QUE ASIANCONNECT TOMA DE 9WICKETS',
			'Please note that 9wickets have 3% commission rate applied to your winnings.': 'Tenga en cuenta que 9wickets tiene una tasa de comisión del 3% aplicada a sus ganancias',
			'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.': 'Tenga en cuenta también que 9wickets esta haciendo una revisión diaria de todas las apuestas realizadas en su plataforma. Si observan actividades fraudulentas o patrones de apuestas irregulares en su cuenta, 9wickets tiene el derecho de cerrar su cuenta y perder su saldo.',
			'ORBITX FORCED POSITION TAKING ON ASIANCONNECT': 'POSICION FORZADA QUE ASIANCONNECT TOMA DE ORBITX',
			'Please note that OrbitX have 3% commission rate applied to your winnings.': 'Tenga en cuenta que OrbitX tiene una tasa de comisión del 3% aplicada a sus ganancias.',
			'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.': 'Tenga en cuenta también que OrbitX esta haciendo una revisión diaria de todas las apuestas realizadas en su plataforma. Si observan actividades fraudulentas o patrones de apuestas irregulares en su cuenta, OrbitX tiene el derecho de cerrar su cuenta y perder su saldo.',
			'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT': 'SKYPE APUESTA TERMINOS Y CONDICIONES EN ASIANCONNECT',
			'You can contact us via Skype at': 'Puede contactarnos a través de Skype en',
			'NV for Skype betting Terms and Conditions.': 'NV para los términos y condiciones de las apuestas de Skype.',
			'Successfully added!': 'Añadido correctamente!',
			'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.': 'Se han añadido los siguientes productos. Ahora puede solicitar el depósito en su cuenta. Recibirá su nombre de usuario y contraseña una vez que hayamos recibido su depósito. Gracias',
			'About Us': 'Sobre Nosotros',
			'Contact Us': 'Contáctenos',
			'Legal Disclaimer': 'Nota Legal',
			'Privacy Policy': 'Política de Privacidad',
			'Go To Transaction Overview': 'Ir al Resumen de Transacciones',
			'Notification': 'Notificación',
			'was deleted.': 'qué borrado.',
			'Failed to delete': 'Error al eliminar',
			'file has been uploaded.': 'El archivo ha sido subido',
			'Failed to upload': 'Error al subir',
			'Paste an address where you want to receive BTC': 'Pegue la dirección donde quiere recibir sus BTC',
			'New referral': 'Nuevo referido',
			'has been linked.': 'ha sido vinculado.',
			'Referral': 'Referido',
			'has been unlinked.': 'ha sido desvinculado.',
			'Product/s': 'Producto/s',
			'has been added.': 'ha sido añadido.',
			'Transaction': 'Transacción',
			'has been': 'ha sido',
			'Deposit': 'Depositar',
			'Withdraw': 'Retirar',
			'Transfer': 'Transferir',
			'P2P Transfer': 'Transferencia Persona a Persona',
			'Approved': 'Aprobado',
			'Acknowledged': 'Admitido',
			'Processed': 'Procesado',
			'Saved': 'Salvado',
			'Invalid Credentials!': 'Credenciales no válidas!',
			'Email': 'Corre electrónico'
		}, (0, _defineProperty3.default)(_ref, 'Account ID', 'ID de la cuenta'), (0, _defineProperty3.default)(_ref, 'Name', 'Nombre'), (0, _defineProperty3.default)(_ref, 'Request Deposit', 'Realizar depósito'), (0, _defineProperty3.default)(_ref, 'Request Withdrawal', 'Realizar retirada'), (0, _defineProperty3.default)(_ref, 'Upload', 'Subir'), (0, _defineProperty3.default)(_ref, 'W/L', 'W/L'), (0, _defineProperty3.default)(_ref, 'Bonus', 'Primo'), (0, _defineProperty3.default)(_ref, 'Revenue Share', 'Participación en los ingresos'), (0, _defineProperty3.default)(_ref, 'Total W/L:', 'Total W/L:'), (0, _defineProperty3.default)(_ref, 'Total Bonus:', 'Bono Total:'), (0, _defineProperty3.default)(_ref, 'Total Revenue Share:', 'Ingresos totales compartidos:'), (0, _defineProperty3.default)(_ref, 'Unlimited', 'Ilimitado'), (0, _defineProperty3.default)(_ref, 'Instant', 'Inmediato'), (0, _defineProperty3.default)(_ref, 'My Tickets', 'Mis tickets'), (0, _defineProperty3.default)(_ref, 'Product is required', 'Se requiere producto'), (0, _defineProperty3.default)(_ref, 'Transaction password invalid', 'Contraseña de transacción inválida.'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been saved', 'La transacción de depósito se ha guardado'), (0, _defineProperty3.default)(_ref, 'Product has been added', 'El producto se ha añadido'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been saved', 'La transacción de retirada se ha guardado'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been saved', 'Trasferencia guardada'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been declined', 'La transacción de depósito ha sido rechazada'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been declined', 'La transacción de retirada ha sido rechazada'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been declined', 'La trasferencia ha sido rechazada'), (0, _defineProperty3.default)(_ref, 'Transaction deposit has been voided', 'La transacción de depósito ha sido anulada'), (0, _defineProperty3.default)(_ref, 'Transaction withdrawal has been voided', 'La transacción de retirada ha sido anulada'), (0, _defineProperty3.default)(_ref, 'Transaction transfer has been voided', 'Trasferencia anulada'), (0, _defineProperty3.default)(_ref, 'Documents uploaded:', 'Archivos subidos:'), (0, _defineProperty3.default)(_ref, 'Warning! At least one product is required.', 'Aviso! Al menos un producto es obligatorio.'), (0, _defineProperty3.default)(_ref, 'paymentOptionsViewDetails', 'Importante: Tras realizar el depósito, rellene este apartado. En caso de error, su depósito no podrá ser realizado. Este mensaje es para notificarnos de su transacción, y poder verificar que se ha reflejado en su cuenta.'), (0, _defineProperty3.default)(_ref, 'File(s) still uploading, please wait.', 'Los archivos aún se están cargando, por favor espere.'), (0, _defineProperty3.default)(_ref, 'DEPOSIT', 'DEPOSITOS'), (0, _defineProperty3.default)(_ref, 'WITHDRAWAL', 'RETIRADAS'), (0, _defineProperty3.default)(_ref, 'TRANSFER', 'TRANSFERENCIAS'), (0, _defineProperty3.default)(_ref, 'BONUS', 'PRIMO'), (0, _defineProperty3.default)(_ref, 'PSP TRANSFER', 'TRANSFERENCIA PERSONA A PERSONA'), (0, _defineProperty3.default)(_ref, 'COMMISSION', 'COMISION'), (0, _defineProperty3.default)(_ref, 'DEBIT', 'DÉBITO'), (0, _defineProperty3.default)(_ref, 'CREDIT', 'CRÉDITO'), (0, _defineProperty3.default)(_ref, 'REVENUE SHARE', 'PARTICIPACIÓN EN LOS INGRESOS'), (0, _defineProperty3.default)(_ref, 'RESET BOOKIE PASSWORD', 'RESET BOOKIE CONTRASEÑA'), (0, _defineProperty3.default)(_ref, 'Ecopayz Merchant Account (EUR)', 'Cuenta mercante Ecopayz (EUR)'), _ref;
	}

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js